webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/*!********************************!*\
  !*** ./src/config/env.conf.js ***!
  \********************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var apiHost = '//qa.lvyou.test.sankuai.com';
var embedHost = '//qa.lvyou.test.sankuai.com';
var loginHost = '//epassport.sjst.beta.sankuai.com';
var mscHost = '//tpt.dev.sankuai.com';
var assertUrl = '//awp-assets.sankuai.com';
var iHost = '//test.i.meituan.com';
var misSSOUrl = '//develop.sso.test.sankuai.info';
var misApiHost = '//qa.lvyou.test.sankuai.com';
var otpHost = '//qa.3f.meituan.com/old/index.html';
var awpHost = '//test01.awp.sankuai.com';
var falconHost = '//qa.lvyou.test.sankuai.com';
var directDealApiHost = '//zhilian-product.lvyou.test.sankuai.com';
var webSocketHost = '//notifywpush.trip.st.meituan.com';
switch ("production") {
    case 'production':
        // 接口地址
        exports.apiHost = apiHost = '//lvyou.meituan.com';
        exports.otpHost = otpHost = '//3f.meituan.com/new/index.html';
        exports.awpHost = awpHost = '//awp.meituan.com';
        // iframe 内嵌旧系统的地址
        exports.embedHost = embedHost = '//lvyou.meituan.com';
        // 登录登出接口地址
        exports.loginHost = loginHost = 'https://epassport.meituan.com';
        // iframe 结算的地址
        exports.mscHost = mscHost = '//tpt.meituan.com';
        // awp静态资源地址
        exports.assertUrl = assertUrl = '//awp-assets.meituan.net';
        // i版预览
        exports.iHost = iHost = '//i.meituan.com';
        // mis 登录页
        exports.misSSOUrl = misSSOUrl = '//sso.sankuai.com';
        exports.misApiHost = misApiHost = '//lvyou.meituan.com';
        exports.falconHost = falconHost = '//lvyou.meituan.com';
        exports.directDealApiHost = directDealApiHost = '//product-zhilian.meituan.com';
        exports.webSocketHost = webSocketHost = '//notifywpush-platform.meituan.com';
        break;
    case 'staging':
        exports.apiHost = apiHost = '//st.lvyou.meituan.com';
        exports.loginHost = loginHost = 'https://epassport.meituan.com';
        exports.awpHost = awpHost = '//st.awp.meituan.com';
        exports.embedHost = embedHost = '//st.lvyou.meituan.com';
        exports.mscHost = mscHost = '//tpt.st.sankuai.com';
        exports.assertUrl = assertUrl = '//awp-assets.sankuai.com';
        exports.iHost = iHost = '//test.i.meituan.com';
        exports.misSSOUrl = misSSOUrl = '//sso.sankuai.com';
        exports.misApiHost = misApiHost = '//st.lvyou.meituan.com';
        exports.otpHost = otpHost = '//st.3f.meituan.com/old/index.html';
        exports.falconHost = falconHost = '//st.lvyou.meituan.com';
        exports.directDealApiHost = directDealApiHost = '//zhilian-product.trip.st.sankuai.com';
        exports.webSocketHost = webSocketHost = '//notifywpush.trip.st.meituan.com';
        break;
    case 'offline':
        exports.otpHost = otpHost = '//test.3f.meituan.com';
        exports.apiHost = apiHost = '//lvyou.test.sankuai.info';
        exports.embedHost = embedHost = '//lvyou.test.sankuai.info';
        exports.mscHost = mscHost = '//tpt.dev.sankuai.com';
        exports.awpHost = awpHost = '//test02.awp.sankuai.com';
        break;
    case 'qa':
    default:
}
exports.falconHost = falconHost = falconHost + '/tbms/trip/report/otp';
exports.apiHost = apiHost;
exports.embedHost = embedHost;
exports.mscHost = mscHost;
exports.loginHost = loginHost;
exports.assertUrl = assertUrl;
exports.iHost = iHost;
exports.misSSOUrl = misSSOUrl;
exports.misApiHost = misApiHost;
exports.otpHost = otpHost;
exports.awpHost = awpHost;
exports.falconHost = falconHost;
exports.directDealApiHost = directDealApiHost;
exports.webSocketHost = webSocketHost;

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/*!*********************************************************!*\
  !*** ./src/views/dataPlatform/filters/moment-format.js ***!
  \*********************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _moment = __webpack_require__(/*! moment */ 32);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MomentFormat = {

    // 获取今天日期
    getToday: function getToday() {
        return (0, _moment2.default)().format('YYYY-MM-DD');
    },

    // 获取昨天日期
    getYestoday: function getYestoday() {
        return (0, _moment2.default)().subtract(_moment2.default.duration(1, 'd')).format('YYYY-MM-DD');
    },

    // 获取前第七天日期
    getSevenDate: function getSevenDate() {
        return (0, _moment2.default)().subtract(_moment2.default.duration(7, 'd')).format('YYYY-MM-DD');
    },

    // 获取前第三十天日期
    getThirtyDate: function getThirtyDate() {
        return (0, _moment2.default)().subtract(_moment2.default.duration(30, 'd')).format('YYYY-MM-DD');
    }

};

module.exports = MomentFormat;

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/*!********************************************************************!*\
  !*** ./src/views/dataPlatform/components/title-date/TitleDate.vue ***!
  \********************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-55ba80d0","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./TitleDate.vue */ 632)
}
var Component = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./TitleDate.vue */ 633),
  /* template */
  __webpack_require__(/*! !../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-55ba80d0","hasScoped":true}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./TitleDate.vue */ 634),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-55ba80d0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/*!******************************!*\
  !*** ./src/helpers/index.js ***!
  \******************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pick = exports.formatDate = exports.eventBus = exports.isRegex = exports.isUndefined = exports.isObject = exports.isArray = exports.clone = undefined;

var _slicedToArray2 = __webpack_require__(/*! babel-runtime/helpers/slicedToArray */ 234);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _vue = __webpack_require__(/*! vue */ 30);

var _vue2 = _interopRequireDefault(_vue);

var _formatDate = __webpack_require__(/*! ./formatDate */ 77);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var entries = Object.entries;
// clone

var clone = exports.clone = function clone(item) {
    if (!item) {
        return item;
    } // null, undefined values check
    return JSON.parse(JSON.stringify(item));
};

var isArray = exports.isArray = function isArray(arr) {
    return Object.prototype.toString.call(arr) === '[object Array]';
};

var isObject = exports.isObject = function isObject(arr) {
    return Object.prototype.toString.call(arr) === '[object Object]';
};

var isUndefined = exports.isUndefined = function isUndefined(arr) {
    return Object.prototype.toString.call(arr) === '[object Undefined]';
};

var isRegex = exports.isRegex = function isRegex(reg) {
    return Object.prototype.toString.call(reg) === '[object RegExp]';
};
var eventBus = exports.eventBus = new _vue2.default();

exports.formatDate = _formatDate.formatDate;
var pick = exports.pick = function pick() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var result = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = entries(obj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref = _step.value;

            var _ref2 = (0, _slicedToArray3.default)(_ref, 2);

            var key = _ref2[0];
            var value = _ref2[1];

            if (keys.indexOf(key) > -1) {
                result[key] = value;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return result;
};

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */
/*!*********************************!*\
  !*** ./src/api/dataPlatform.js ***!
  \*********************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(/*! axios */ 12);

var _axios2 = _interopRequireDefault(_axios);

var _env = __webpack_require__(/*! ../config/env.conf */ 2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

    /**
     * 获取经营数据
     * @param { int }    bizCode   业务线，11021 跟团 11022 酒景
     * @param { string } startDate 开始日期
     * @param { string } endDate   结束日期
     */
    getOperationData: function getOperationData(bizCode, startDate, endDate) {
        return _axios2.default.get('trip-package-auditapi/api/biz/data/operation/get', {
            params: {
                bizCode: bizCode,
                startDate: startDate,
                endDate: endDate
            }
        });
    },


    /**
     * 获取经营趋势数据
     * @param { int }    bizCode   业务线，11021 跟团 11022 酒景
     * @param { string } startDate 开始日期
     * @param { string } endDate   结束日期
     */
    getOperationTrendData: function getOperationTrendData(bizCode, startDate, endDate, moduleId) {
        return _axios2.default.get('trip-package-auditapi/api/biz/data/operation/trend', {
            params: {
                bizCode: bizCode,
                startDate: startDate,
                endDate: endDate,
                moduleId: moduleId
            }
        });
    },


    /**
     * 获取单品数据运营趋势
     * @param { int }    bizCode    业务线，11021 跟团 11022 酒景
     * @param { string } startDate  开始日期
     * @param { string } endDate    结束日期
     * @param { int }    productId  单品ID
     */
    getProductTrendData: function getProductTrendData(bizCode, startDate, endDate, productId) {
        return _axios2.default.get('trip-package-auditapi/api/biz/data/product/trend', {
            params: {
                bizCode: bizCode,
                startDate: startDate,
                endDate: endDate,
                productId: productId
            }
        });
    },


    /**
     * 获取单品数据
     * @param { int }    bizCode   业务线，11021 跟团 11022 酒景
     * @param { string } startDate 开始日期
     * @param { string } endDate   结束日期
     * @param { int }    rankType  类别
     */
    getRankTypeData: function getRankTypeData(bizCode, startDate, endDate, rankType) {
        return _axios2.default.get('trip-package-auditapi/api/biz/data/rank/get', {
            params: {
                bizCode: bizCode,
                startDate: startDate,
                endDate: endDate,
                rankType: rankType
            }
        });
    },


    /**
     * 获取商品分析数据
     * @param { int }    bizCode     业务线，11021 跟团 11022 酒景
     * @param { string } startDate   开始日期
     * @param { string } endDate     结束日期
     * @param { int }    productId   商品ID
     * @param { string } productName 商品名称
     * @param { int }    pageId      当前页码
     * @param { int }    pageSize    每页展示条数
     */
    getProductData: function getProductData(bizCode, startDate, endDate, productId, productName, pageId, pageSize) {
        return _axios2.default.get('trip-package-auditapi/api/biz/data/product/list', {
            params: {
                bizCode: bizCode,
                startDate: startDate,
                endDate: endDate,
                productId: productId,
                productName: productName,
                pageId: pageId,
                pageSize: pageSize
            }
        });
    },


    /**
     * 全品数据下载
     * @param { int }    bizCode   业务线，11021 跟团 11022 酒景
     * @param { string } startDate 开始日期
     * @param { string } endDate   结束日期
     * @param { int }    moduleId  模块
     */
    downloadData: function downloadData(bizCode, startDate, endDate, moduleId) {
        window.open(_env.apiHost + '/trip-package-auditapi/api/biz/data/operation/download?bizCode=' + bizCode + '&startDate=' + startDate + '&endDate=' + endDate + '&moduleId=' + moduleId);
    },


    /**
     * 单品数据下载
     * @param { int }    bizCode   业务线，11021 跟团 11022 酒景
     * @param { string } startDate 开始日期
     * @param { string } endDate   结束日期
     * @param { int }    moduleId  模块
     */
    downloadProductData: function downloadProductData(bizCode, startDate, endDate, moduleId, productId) {
        window.open(_env.apiHost + '/trip-package-auditapi/api/biz/data/product/download?bizCode=' + bizCode + '&startDate=' + startDate + '&endDate=' + endDate + '&moduleId=' + moduleId + '&productId=' + productId);
    }
};

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/*!**********************************************************!*\
  !*** ./src/views/dataPlatform/filters/percent-format.js ***!
  \**********************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (_value, _mark) {
    if (isNaN(_value) || _value === null || _value === '') {
        return '--';
    } else {
        return (parseFloat(_value) * 100).toFixed(2) + (_mark === true ? '%' : '');
    }
};

/***/ }),
/* 34 */
/*!****************************************!*\
  !*** ./src/api/menpiaoDataPlatform.js ***!
  \****************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(/*! axios */ 12);

var _axios2 = _interopRequireDefault(_axios);

var _env = __webpack_require__(/*! ../config/env.conf */ 2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

    /**
     * 获取首页数据
     * @param { int }    salePlatform  平台，0 全部 1 美团 2 点评
     * @param { string } startDate     开始日期
     * @param { string } endDate       结束日期
     * @param { boolean } hasDailyData 是否需要天级数据
     */
    getIndexData: function getIndexData(salePlatform, startDate, endDate, hasDailyData) {
        return _axios2.default.get('/rimet/fe/mtp/biz/operation/data/supplier', {
            params: {
                salePlatform: salePlatform,
                startDate: startDate,
                endDate: endDate,
                hasDailyData: hasDailyData
            }
        });
    },


    /**
     * 7天汇总数据
     * @param { int }    salePlatform  平台，0 全部 1 美团 2 点评
     * @param { string } date          日期
     * @param { int }    sortType      排序类型，1 增幅排序 2 跌幅排序
     * @param { string } sortKey       排序关键字
     * @param { int }    sortValueType 排序值类型，1 增长率 2 绝对值
     */
    getSevenData: function getSevenData(salePlatform, date, sortType, sortKey, sortValueType) {
        return _axios2.default.get('/rimet/fe/mtp/biz/operation/data/deal/week', {
            params: {
                salePlatform: salePlatform,
                date: date,
                sortType: sortType,
                sortKey: sortKey,
                sortValueType: sortValueType
            }
        });
    },


    /**
     * 商品分析
     * @param { int }    salePlatform 平台，0 全部 1 美团 2 点评
     * @param { string } startDate    开始日期
     * @param { string } endDate      结束日期
     * @param { int }    productStr   搜索商品名称、ID
     * @param { int }    pageNum      第几页
     * @param { int }    pageSize     每页多少条
     */
    getProductData: function getProductData(salePlatform, startDate, endDate, productStr, hasDailyData, pageNum, pageSize) {
        return _axios2.default.get('/rimet/fe/mtp/biz/operation/data/deal', {
            params: {
                salePlatform: salePlatform,
                startDate: startDate,
                endDate: endDate,
                searchStr: productStr,
                hasDailyData: hasDailyData,
                pageNum: pageNum || 1,
                pageSize: pageSize || 10
            }
        });
    },


    /**
     * 下载经营数据
     * @param { int }     salePlatform 平台，0 全部 1 美团 2 点评
     * @param { string }  startDate    开始日期
     * @param { string }  endDate      结束日期
     * @param { boolean } hasDailyData 是否需要天级数据
     */
    downloadOperateData: function downloadOperateData(salePlatform, startDate, endDate, hasDailyData) {
        window.open(_env.apiHost + '/rimet/fe/mtp/biz/operation/data/supplier/download?salePlatform=' + salePlatform + '&startDate=' + startDate + '&endDate=' + endDate + '&hasDailyData=' + hasDailyData);
    },


    /**
     * 下载商品数据
     * @param { int }     salePlatform 平台，0 全部 1 美团 2 点评
     * @param { string }  startDate    开始日期
     * @param { string }  endDate      结束日期
     * @param { boolean } searchStr    搜索内容
     */
    downloadProductData: function downloadProductData(salePlatform, startDate, endDate, searchStr, hasDailyData) {
        window.open(_env.apiHost + '/rimet/fe/mtp/biz/operation/data/deal/download?salePlatform=' + salePlatform + '&startDate=' + startDate + '&endDate=' + endDate + '&searchStr=' + searchStr + '&hasDailyData=' + hasDailyData);
    },


    /**
     * 下载交易数据
     * @param { int }     salePlatform 平台，0 全部 1 美团 2 点评
     * @param { string }  startDate    开始日期
     * @param { string }  endDate      结束日期
     * @param { boolean } hasDailyData 是否需要天级数据
     */
    downloadTransactionData: function downloadTransactionData(salePlatform, startDate, endDate, hasDailyData) {
        window.open(_env.apiHost + '/rimet/fe/mtp/biz/operation/data/order/download?salePlatform=' + salePlatform + '&startDate=' + startDate + '&endDate=' + endDate + '&hasDailyData=' + hasDailyData);
    }
};

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */
/*!*******************************************************!*\
  !*** ./src/views/dataPlatform/components/nav/Nav.vue ***!
  \*******************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-6d0ca32e","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Nav.vue */ 661)
}
var Component = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Nav.vue */ 662),
  /* template */
  __webpack_require__(/*! !../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6d0ca32e","hasScoped":true}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Nav.vue */ 663),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6d0ca32e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/*!****************************************************!*\
  !*** ./src/components/inner-frame/inner-frame.vue ***!
  \****************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-6cf793fa","scoped":true,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./inner-frame.vue */ 621)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./inner-frame.vue */ 622),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6cf793fa","hasScoped":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./inner-frame.vue */ 623),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6cf793fa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 43 */
/*!***********************************************************!*\
  !*** ./src/views/dataPlatform/components/table/Table.vue ***!
  \***********************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-72a35b02","scoped":false,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Table.vue */ 677)
}
var Component = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Table.vue */ 678),
  /* template */
  __webpack_require__(/*! !../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-72a35b02","hasScoped":false}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Table.vue */ 679),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/*!***************************!*\
  !*** ./src/api/ticket.js ***!
  \***************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.verify = exports.getMainOrderInfo = exports.codeDetail = exports.getBdsInfo = exports.getAnnounces = exports.getSignUpActivities = exports.asyncTicket = exports.queryCalendar = exports.getWhitelist = exports.getAllMappingExtType = exports.saveMappingSort = exports.getMappingSort = exports.getMappingExt = exports.saveMappingExt = exports.savePriceBase = exports.getPriceBase = exports.uploadImage = exports.getprotocol = exports.getTicketType = exports.getCrowdByPoi = exports.tehuiApply = exports.tehuiCheck = exports.getContractsDetail = exports.getContractsDetail4BD = exports.getContractsList = exports.getContractsList4BD = exports.getCommissionStatement = exports.getCertificateValidate = exports.getTicketParenthoodAdvice = exports.getSubAccounts = exports.getMsRatio = exports.checkRatio = exports.audit = exports.cancelAudit = exports.update = exports.create = exports.get = exports.searchTicket = exports.searchPoi = exports.getAllCitys = undefined;

var _axios = __webpack_require__(/*! axios */ 12);

var _axios2 = _interopRequireDefault(_axios);

var _store = __webpack_require__(/*! store */ 107);

var _store2 = _interopRequireDefault(_store);

var _notices = __webpack_require__(/*! utils/notices */ 51);

var _env = __webpack_require__(/*! config/env.conf */ 2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
var bizName = 'TICKET_INNER';
var apiRole = { apiRole: 'auto' };
var feClient = { feclient: 'lvyou_web' };
var bizType = { bizTypes: bizName };
var clinetWithApiRole = Object.assign({}, feClient, apiRole);
var clientWithApiRoleBizType = Object.assign({}, bizType, clinetWithApiRole);
// import qs from 'qs'

var getAllCitys = exports.getAllCitys = function getAllCitys() {
    return _axios2.default.get('/midas/api/v1/agent/prefecture/city/query', {
        params: clinetWithApiRole
    });
};

var searchPoi = exports.searchPoi = function searchPoi(params) {
    return _axios2.default.get('/midas/api/v1/agent/poi/es/query', {
        params: Object.assign(params, apiRole)
    });
};

var searchTicket = exports.searchTicket = function searchTicket(params) {
    return _axios2.default.get('/midas/api/v1/agent/tickets/ipoi/query', {
        params: Object.assign(params, apiRole)
    });
};

var get = exports.get = function get(id) {
    var path = _store2.default.state.pageAccountType === 'mis' ? '/midas/mis/tickets/' + id : '/midas/scs/account/op/tickets/' + id;
    return _axios2.default.get(path, {
        params: clinetWithApiRole
    });
};

var create = exports.create = function create(data) {
    console.log(data);
    var path = _store2.default.state.pageAccountType === 'mis' ? '/midas/mis/tickets/' : '/midas/scs/account/op/tickets';

    return _axios2.default.post(path, data, {
        params: clinetWithApiRole
    });
};

var update = exports.update = function update(id, data) {
    var path = _store2.default.state.pageAccountType === 'mis' ? '/midas/mis/tickets/' + id : '/midas/scs/account/op/tickets/' + id;
    return _axios2.default.put(path, data, {
        params: clinetWithApiRole
    });
};

var cancelAudit = exports.cancelAudit = function cancelAudit(id) {
    var path = _store2.default.state.pageAccountType === 'mis' ? '/midas/mis/tickets/cancel/audit' : '/midas/scs/account/op/tickets/cancel/audit';
    return _axios2.default.get(path, {
        params: Object.assign({ id: id }, clinetWithApiRole)
    });
};

var audit = exports.audit = function audit(id, params) {
    if (_store2.default.state.pageAccountType === 'mis') {
        return _axios2.default.post('/midas/mis/tickets/' + id + '/auditsubmit', null, {
            params: Object.assign({
                opRole: 2
            }, clinetWithApiRole, params)
        });
    } else {
        return _axios2.default.post('/midas/scs/account/op/tickets/' + id + '/auditsubmit', null, {
            params: Object.assign({
                opRole: 3
            }, clinetWithApiRole, params)
        });
    }
};

var checkRatio = exports.checkRatio = function checkRatio(id) {
    return _axios2.default.get('/midas/mis/tickets/' + id + '/priceinfos', {
        params: clinetWithApiRole
    });
};

var getMsRatio = exports.getMsRatio = function getMsRatio(poiIds, category, supplierId) {
    var path = _store2.default.state.pageAccountType === 'mis' ? '/midas/mis/msratio/mtcategories/' + category : '/midas/scs/account/op/msratio/mtcategories/' + category;
    return _axios2.default.get(path, {
        params: Object.assign({
            mtCategoryId: category,
            mdcPoiIds: poiIds,
            partnerSupplierId: supplierId
        }, clinetWithApiRole)
    });
};

var getSubAccounts = exports.getSubAccounts = function getSubAccounts(supplierId) {
    var path = _store2.default.state.pageAccountType === 'mis' ? '/rimet/api/accounts/info' : '/rimet/account/allsubaccounts';
    return _axios2.default.get(path, {
        params: Object.assign({
            type: 1,
            businessType: 'TICKET',
            supplierId: supplierId
        }, clinetWithApiRole)
    });
};

var getTicketParenthoodAdvice = exports.getTicketParenthoodAdvice = function getTicketParenthoodAdvice(mdcPoiIds) {
    return _axios2.default.get('/midas/api/v1/agent/get/poi/advice/ticket', {
        params: Object.assign({
            mdcPoiIds: mdcPoiIds
        }, clinetWithApiRole)
    });
};

/* old one
 export const getCertificateValidate = (mdcPoiIds) => {
 return axios.post('/midas/scs/account/v1/proxy/op/certificate/poi/validate', qs.stringify({
 mdcPoiIds,
 apiRole: 'auto',
 feclient: 'lvyou_web'
 }), {
 headers: {
 'Content-Type': 'application/x-www-form-urlencoded'
 }
 })
 }
 */

var getCertificateValidate = exports.getCertificateValidate = function getCertificateValidate(mdcPoiIds, supplierId) {
    var path = _store2.default.state.pageAccountType === 'mis' ? '/midas/mis/poi/validate' : '/midas/scs/account/v1/proxy/op/certificate/poi/validate';
    return _axios2.default.post(path, null, {
        params: Object.assign({
            mdcPoiIds: mdcPoiIds,
            partnerSupplierId: supplierId
        }, clinetWithApiRole)
    });
};

// 查询返佣协议接口
var getCommissionStatement = exports.getCommissionStatement = function getCommissionStatement(partnerId) {
    return _axios2.default.get('/midas/msc/v1/agent/get/commission/statement', {
        params: Object.assign({
            partnerId: partnerId
        }, feClient)
    });
};

// BD
var getContractsList4BD = exports.getContractsList4BD = function getContractsList4BD(supplierId) {
    return _axios2.default.get('/virgo/supplier/contract/list/v2/' + supplierId, {
        params: clientWithApiRoleBizType
    });
};

var getContractsList = exports.getContractsList = function getContractsList(supplierId) {
    return _axios2.default.get('/virgo/fe/3f/supplier/contract/list/v2/' + supplierId, {
        params: clientWithApiRoleBizType
    });
};

// BD
var getContractsDetail4BD = exports.getContractsDetail4BD = function getContractsDetail4BD(contractId) {
    return _axios2.default.get('/virgo/supplier/contract/v2/simple/info/' + contractId, {
        params: clientWithApiRoleBizType
    });
};

var getContractsDetail = exports.getContractsDetail = function getContractsDetail(contractId) {
    return _axios2.default.get('/virgo/fe/3f/supplier/contract/v2/simple/info/' + contractId, {
        params: clientWithApiRoleBizType
    });
};

var tehuiCheck = exports.tehuiCheck = function tehuiCheck(dealId) {
    return _axios2.default.get('/midas/mis/specialticket/specialInfo', {
        params: Object.assign({
            dealId: dealId
        }, clinetWithApiRole)
    });
};

var tehuiApply = exports.tehuiApply = function tehuiApply(data) {
    return _axios2.default.post('/midas/mis/specialticket/apply', data, {
        params: clinetWithApiRole
    });
};

var getCrowdByPoi = exports.getCrowdByPoi = function getCrowdByPoi(poiIds) {
    return _axios2.default.get('/midas/api/v1/agent/mtp/poi/fitpeople', {
        params: Object.assign({
            mdcPoiIds: poiIds.join(',')
        }, clinetWithApiRole)
    });
};

var getTicketType = exports.getTicketType = function getTicketType(ticketId) {
    return _axios2.default.get('/midas/api/v1/agent/mtp/ticketcategoryid/fitpeople', {
        params: Object.assign({
            ticketCategoryId: '' + ticketId
        }, feClient)
    });
};

var getprotocol = exports.getprotocol = function getprotocol(supplierId, contractNum) {
    return _axios2.default.get('/midas/mis/supplier/' + supplierId + '/protocol?feclient=lvyou_web&contractNum=' + encodeURIComponent(contractNum));
};

// 图片上传
var uploadImage = exports.uploadImage = '/midas/common/v1/upload';

/***
 * 查询产品价格基础数据
 * @param partnerId 合作方ID
 * @param partnerDealId 合作方产品ID
 * @returns {*}
 */
var getPriceBase = exports.getPriceBase = function getPriceBase(partnerId, partnerDealId) {
    return _axios2.default.get(_env.directDealApiHost + '/product/mtp/inner/price/levelPriceBase', {
        params: Object.assign({
            partnerId: partnerId,
            partnerDealId: partnerDealId
        }, feClient)
    });
};

/***
 * 保存价格基础信息
 * @param partnerId
 * @param partnerDealId
 * @param data
 * @returns {*}
 */
var savePriceBase = exports.savePriceBase = function savePriceBase(partnerId, partnerDealId, data) {
    return _axios2.default.put(_env.directDealApiHost + '/product/mtp/inner/price/levelPriceBase', {
        partnerId: partnerId,
        partnerDealId: partnerDealId,
        data: data
    }, {
        params: clinetWithApiRole
    });
};
/***
 * 保存层级映射表
 * @param partnerId
 * @param partnerDealId
 * @param data
 * @returns {*}
 */
var saveMappingExt = exports.saveMappingExt = function saveMappingExt(partnerId, partnerDealId) {
    var levelNo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var data = arguments[3];

    return _axios2.default.put(_env.directDealApiHost + '/product/mtp/inner/price/levelMappingExt', {
        partnerId: partnerId,
        partnerDealId: partnerDealId,
        levelNo: levelNo,
        data: data
    }, {
        params: clinetWithApiRole
    });
};
/***
 * 查询层级映射信息
 * @param partnerId 合作方ID
 * @param partnerDealId 合作方产品ID
 * @param levelNo 场次:1 席位:2 场馆:3
 * @returns {*}
 */
var getMappingExt = exports.getMappingExt = function getMappingExt(partnerId, partnerDealId) {
    var levelNo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

    return _axios2.default.get(_env.directDealApiHost + '/product/mtp/inner/price/levelMappingExt', {
        params: Object.assign({
            partnerId: partnerId,
            partnerDealId: partnerDealId,
            levelNo: levelNo
        }, feClient)
    });
};
/***
 * 查询全局层级映射表顺序
 * @param partnerId 合作方ID
 * @param partnerDealId 合作方产品ID
 * @param levelNo 场次:1 席位:2 场馆:3
 * @returns {*}
 */
var getMappingSort = exports.getMappingSort = function getMappingSort(partnerId, partnerDealId) {
    var levelNo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

    return _axios2.default.get(_env.directDealApiHost + '/product/mtp/inner/price/levelMapping', {
        params: Object.assign({
            partnerId: partnerId,
            partnerDealId: partnerDealId,
            levelNo: levelNo
        }, feClient)
    });
};
/***
 * 保存全局层级映射表顺序
 * @param partnerId
 * @param partnerDealId
 * @param data
 * @returns {*}
 */
var saveMappingSort = exports.saveMappingSort = function saveMappingSort(partnerId, partnerDealId) {
    var levelNo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var data = arguments[3];

    return _axios2.default.put(_env.directDealApiHost + '/product/mtp/inner/price/levelMapping', {
        partnerId: partnerId,
        partnerDealId: partnerDealId,
        levelNo: levelNo,
        data: data
    }, {
        params: clinetWithApiRole
    });
};
/***
 * 查询全部层级映射信息
 * @param partnerId 合作方ID
 * @param partnerDealId 合作方产品ID
 * @param levelNo 场次:1 席位:2 场馆:3
 * @returns {*}
 */
var getAllMappingExtType = exports.getAllMappingExtType = function getAllMappingExtType(partnerId, partnerDealId) {
    return _axios2.default.get(_env.directDealApiHost + '/product/mtp/inner/price/levelMappingExt/allType', {
        params: Object.assign({
            partnerId: partnerId,
            partnerDealId: partnerDealId
        }, feClient)
    });
};

/***
 * BA鉴权 获取POI白名单列表（鲁班）
 * @returns {*}
 */
var getWhitelist = exports.getWhitelist = function getWhitelist() {
    return _axios2.default.get('/midas/mis/lion/poi/whitelist', {
        params: feClient
    });
};

// 直连判断有误价格日历
var queryCalendar = exports.queryCalendar = function queryCalendar(supplierId) {
    return _axios2.default.get('/rhone/mtp/partner/tech/fe/get?partnerId=' + supplierId);
};

// 拉取价格日历
var asyncTicket = exports.asyncTicket = function asyncTicket(supplierId, partnerDealId) {
    var path = _store2.default.state.pageAccountType === 'mis' ? '/midas/mis/sync/api/daypricestock' : '/midas/scs/account/op/sync/api/daypricestock';
    return _axios2.default.get(path, {
        params: Object.assign({
            partnerId: supplierId,
            partnerDealId: partnerDealId
        }, feClient)
    });
};

var getSignUpActivities = exports.getSignUpActivities = function getSignUpActivities(count, sortType) {
    return _axios2.default.get('/rimet/activity/v2/slot/list', {
        params: {
            count: count,
            page: 1,
            slotStatus: 0,
            sortType: sortType || 2
        }
    }).then(function (response) {
        var activities = response && response.data || [];
        if (activities && activities.length) {
            var now = new Date().valueOf();
            activities = activities.filter(function (activity) {
                var applyStartTime = activity.applyStartTime;
                var applyEndTime = activity.applyEndTime;
                if (applyStartTime && applyEndTime) {
                    var start = new Date(applyStartTime).valueOf();
                    var end = new Date(applyEndTime).valueOf();
                    return now > start && now < end;
                }
                return false;
            });
        }
        return activities;
    });
};

var getAnnounces = exports.getAnnounces = function getAnnounces(bizLineId) {
    return _axios2.default.get('/trip-notify/acc/announces/special', {
        params: {
            bizLineId: bizLineId,
            servicePlatform: 1
        }
    }).then(function (respone) {
        var data = respone && respone.data;
        if (data.noticeAnnPublishList) {
            data.notices = data.noticeAnnPublishList.map(function (noticeItem) {
                return (0, _notices.mapNoticeItem)(noticeItem);
            });
        }
        if (data.ruleAnnPublishList) {
            data.rules = data.ruleAnnPublishList.map(function (ruleItem) {
                return (0, _notices.mapNoticeItem)(ruleItem);
            });
        }
        if (data.meidaAnnPublishList) {
            data.courses = data.meidaAnnPublishList.map(function (courseItem) {
                return (0, _notices.mapCourseItem)(courseItem);
            });
        }
        if (data.stripeDecorateList) {
            data.bannerTexts = data.stripeDecorateList.map(function (stripItem) {
                return {
                    id: stripItem.announceId,
                    text: stripItem.decorateContent
                };
            });
        }
        if (data.bannerDecorateList) {
            data.bannerImages = data.bannerDecorateList.map(function (imgItem) {
                return {
                    id: imgItem.announceId,
                    src: imgItem.decorateContent
                };
            });
        }
        if (data.rightDialogDecorateList) {
            data.topNotices = data.rightDialogDecorateList.map(function (dialogItem) {
                return {
                    title: dialogItem.decorateTitle,
                    content: dialogItem.decorateContent,
                    id: dialogItem.announceId
                };
            });
        }
        return data;
    });
};

var getBdsInfo = exports.getBdsInfo = function getBdsInfo(supplierId) {
    return _axios2.default.get('/virgo/fe/3f/bsnsfe/base/bdInfo/' + supplierId + '?feclient=lvyou_web').then(function (response) {
        return response.data;
    });
};

var codeDetail = exports.codeDetail = function codeDetail(code) {
    return _axios2.default.get('/meilv/trade/ticket/merchant/v2/voucher/show/' + code, {
        params: feClient
    });
};

var getMainOrderInfo = exports.getMainOrderInfo = function getMainOrderInfo(params) {
    return _axios2.default.get('/dpack-trade/dpack/merchant/query/orderRelation', { params: params });
};

var verify = exports.verify = function verify(data) {
    return _axios2.default.post('/meilv/scs/account/v1/voucher/verify', data);
};

/***/ }),
/* 51 */
/*!******************************!*\
  !*** ./src/utils/notices.js ***!
  \******************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formatPhone = exports.mapCourseItem = exports.mapNoticeItem = exports.getNoticeDetailUrl = undefined;

var _moment = __webpack_require__(/*! moment */ 32);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pathName = window.location.pathname;

var getNoticeDetailUrl = exports.getNoticeDetailUrl = function getNoticeDetailUrl(id) {
    return pathName + ('#/announce/' + id);
};

var mapNoticeItem = exports.mapNoticeItem = function mapNoticeItem(noticeItem) {
    return {
        id: noticeItem.id,
        name: noticeItem.title,
        isNew: Boolean(noticeItem.isNew),
        date: (0, _moment2.default)(noticeItem.publishTime).format('YYYY-MM-DD')
    };
};

var mapCourseItem = exports.mapCourseItem = function mapCourseItem(courseItem) {
    var coverPicSrc = null;
    if (courseItem.coverPic) {
        coverPicSrc = courseItem.coverPic.replace('http://', 'https://');
    }
    return {
        id: courseItem.id,
        title: courseItem.title,
        subTitle: courseItem.subTitle,
        src: coverPicSrc
    };
};
var phoneSplit = '-';
var formatPhone = exports.formatPhone = function formatPhone(phoneStr) {
    if (phoneStr && typeof phoneStr === 'string') {
        var formatPhoneReg = /^(\d{3})(\d{4})(\d{4})$/;
        var matches = formatPhoneReg.exec(phoneStr);
        if (matches && matches.length) {
            return matches.filter(function (mtach, index) {
                return index > 0;
            }).join(phoneSplit);
        }
        return phoneStr;
    }
};

/***/ }),
/* 52 */
/*!******************************************************!*\
  !*** ./src/components/view-wrapper/view-wrapper.vue ***!
  \******************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-b7711928","scoped":true,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./view-wrapper.vue */ 617)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./view-wrapper.vue */ 618),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-b7711928","hasScoped":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./view-wrapper.vue */ 619),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b7711928",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/*!*********************************************************!*\
  !*** ./src/views/dataPlatform/components/tips/Tips.vue ***!
  \*********************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-1278c5a1","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Tips.vue */ 638)
}
var Component = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Tips.vue */ 639),
  /* template */
  __webpack_require__(/*! !../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1278c5a1","hasScoped":true}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Tips.vue */ 640),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1278c5a1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/*!************************************!*\
  !*** ./src/router/routeBuilder.ts ***!
  \************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var env_conf_1 = __webpack_require__(/*! ./../config/env.conf */ 2);
var baseUrl = env_conf_1.otpHost + '/#/';
var routerHelper_1 = __webpack_require__(/*! ./routerHelper */ 246);
var FinanceBizMap = {
    'dzd': {
        'jiujing': 'zeus/mtp',
        'chepiao': 'travel/car',
        'gty': 'travel/group',
        'jijiu': 'travel/planehotel'
    },
    'fp': {
        'jiujing': 'zeus',
        'chepiao': 'car',
        'gty': 'group',
        'jijiu': 'planehotel'
    },
    'QaA': ['jiujing', 'gty'],
    'paymentRecords': ['chepiao', 'gty']
};
var DataBizMap = {
    fwsj: ['gty']
};
var bizLineIdMap = {
    'ticket': 2,
    'jiujing': 4,
    'jijiu': 6,
    'chepiao': 7,
    'gty': 3,
    'wenchuang': 1
};
var bizLineNameMap = {
    'ticket': 'ticket',
    'jiujing': 'sceneHotel',
    'jijiu': 'airlineTicket',
    'chepiao': 'carTicket',
    'gty': 'packageTour',
    'wenchuang': 'wenchuang'
};
var RouteBuilder = (function () {
    function RouteBuilder(bizLineName, viewWrapper, innerFrame) {
        this.bizLineName = bizLineName;
        this.viewWrapper = viewWrapper;
        this.innerFrame = innerFrame;
    }
    RouteBuilder.prototype.createRoute = function (name, path, component, meta) {
        var routeMeta = Object.assign({ type: this.bizLineName }, meta || {});
        return {
            name: this.bizLineName + name,
            path: path,
            component: component,
            meta: routeMeta
        };
    };
    RouteBuilder.prototype.createRouteFromItem = function (routeItem) {
        var _this = this;
        var route = null;
        var component = routeItem.component;
        if (!component) {
            if (routeItem.children && routeItem.children.length) {
                component = this.viewWrapper;
            }
            else if (routeItem.meta && routeItem.meta.src) {
                component = this.innerFrame;
            }
            else {
                component = this.viewWrapper;
            }
        }
        route = this.createRoute(routeItem.name, routeItem.path, component, routeItem.meta);
        if (routeItem.children && routeItem.children.length) {
            route.children = [];
            routeItem.children.forEach(function (childRouteItem) {
                route.children.push(_this.createRouteFromItem(childRouteItem));
            });
        }
        return route;
    };
    RouteBuilder.prototype.createRouteItem = function (name, path, title, src, fulPath, component, meta) {
        return this.createRouteFromItem({
            name: name,
            path: path,
            component: component,
            meta: Object.assign({
                title: title,
                src: src ? fulPath ? src : "" + (baseUrl + this.bizLineName + src) : null
            }, meta || {})
        });
    };
    RouteBuilder.prototype.createNativeRouteItem = function (name, path, title, component, meta) {
        return this.createRouteItem(name, path, title, null, false, component, meta);
    };
    RouteBuilder.buildBasicInfo = function (builer, orderPrefix, homeapgeCompoent, hasConfirmOrder) {
        var productPreFix = '/product/';
        var orderPreFix = orderPrefix || '/order/';
        var home = builer.createRouteItem('home', '', '首页', '/', false, builer.innerFrame, { icon: 'turbo-ui-home' });
        if (homeapgeCompoent) {
            home = builer.createNativeRouteItem('home', '', '首页', homeapgeCompoent, { icon: 'turbo-ui-home', bizLineId: bizLineIdMap[builer.bizLineName] });
        }
        var product = builer.createRouteItem('product', 'product', '产品管理', null, false, builer.viewWrapper, { icon: 'turbo-ui-setting' });
        var productNew = builer.createRouteItem('productNew', 'new', '新建产品', productPreFix + 'new');
        var productList = builer.createRouteItem('productList', 'list', '产品列表', productPreFix + 'list');
        product.children = [productNew, productList];
        var order = builer.createRouteItem('order', 'gtyOrder', '订单管理', null, false, builer.viewWrapper, { icon: 'assignment' });
        var orderList = builer.createRouteItem('orderlist', 'list', '管理订单', orderPreFix + 'list-order');
        var confirmOrderList = null;
        if (hasConfirmOrder) {
            confirmOrderList = builer.createRouteItem('confirmOrderlist', 'confirmOrderList', '待确认订单', orderPrefix + 'confirmOrderList');
        }
        var noPayList = builer.createRouteItem('nopayList', 'nopaylist', '追单列表', orderPreFix + 'list-workorder');
        order.children = [orderList, noPayList];
        if (confirmOrderList) {
            order.children.push(confirmOrderList);
        }
        return [home, product, order];
    };
    RouteBuilder.buildMyInfo = function (builer, noBizMenu) {
        var preFix = '/info/';
        var result = null;
        if (!noBizMenu) {
            result = builer.createRouteItem('myinfo', 'info', '我的信息', null, false, builer.viewWrapper, { icon: 'ios-person' });
        }
        var authInfo = builer.createRouteItem('authInfo', 'authInfo', '认证信息', preFix + 'auth-info');
        var suppilerInfo = builer.createRouteItem('suppilerInfo', 'suppilerInfo', '供应商信息', preFix + 'supplier');
        var contractInfo = builer.createRouteItem('contractInfo', 'contractInfo', '合同信息', preFix + 'contract-list');
        var menuAry = [authInfo, suppilerInfo, contractInfo];
        if (!noBizMenu) {
            result.children = menuAry;
        }
        else {
            result = menuAry;
        }
        return result;
    };
    RouteBuilder.buildTicketMyInfo = function (builer) {
        var preFix = '/info/';
        var myInfo = builer.createRouteItem('myinfo', 'info', '我的信息', null, false, builer.viewWrapper, { icon: 'ios-person' });
        var authInfo = builer.createRouteItem('authInfo', 'auth-info', '认证信息', preFix + 'auth-info');
        var suppilerInfo = builer.createRouteItem('suppilerInfo', 'supplier', '供应商信息', preFix + 'supplier');
        var contractInfo = builer.createRouteItem('contractInfo', 'contract-list', '合同信息', preFix + 'contract-list');
        myInfo.children = [authInfo, suppilerInfo, contractInfo];
        return myInfo;
    };
    RouteBuilder.buildPromotionInfo = function (builer) {
        var preFix = '/promotion/';
        var promotionInfo = builer.createRouteItem('promotionInfo', 'promotion', '营销中心', null, false, builer.viewWrapper, { icon: 'turbo-ui-fire' });
        var createSelfPromotion = builer.createRouteItem('createSelfPromotion', 'createSelfPromotion', '自助活动创建', preFix + 'deal-list');
        var selfPromotionList = builer.createRouteItem('selfPromotionList', 'list', '自助活动查询', preFix + 'self-promotion-list');
        promotionInfo.children = [createSelfPromotion, selfPromotionList];
        return promotionInfo;
    };
    RouteBuilder.buildFinanceInfo = function (builder) {
        var isFulPath = true;
        var preFix = '/msc/fe/index.html#/';
        var meta = { withPadding: true };
        var financeInfo = builder.createRouteItem('financeInfo', 'finance', '财务管理', null, false, builder.viewWrapper, { icon: 'turbo-ui-money' });
        var settlement = builder.createRouteItem('settlement', 'settlement', '结算对账单', routerHelper_1.getMscSrc(env_conf_1.mscHost + preFix + "statement/" + FinanceBizMap.dzd[builder.bizLineName]), isFulPath, null, meta);
        var invoiceList = builder.createRouteItem('invoicelist', 'invoicelist', '发票管理', routerHelper_1.getMscSrc(env_conf_1.mscHost + "/msc/biz/travel/invoice/queryPartnerInvoiceModel?buzParty=TRAVEL&bizline=" + FinanceBizMap.fp[builder.bizLineName] + "&sellType=mtp"), isFulPath, null, meta);
        financeInfo.children = [settlement, invoiceList];
        if (FinanceBizMap.QaA.includes(builder.bizLineName)) {
            financeInfo.children.push(builder.createRouteItem('financeQAA', 'qaa', '财务问答', routerHelper_1.getMscSrc(env_conf_1.mscHost + preFix + "question/travel/"), isFulPath, null, meta));
        }
        if (FinanceBizMap.paymentRecords.includes(builder.bizLineName)) {
            financeInfo.children.push(builder.createRouteItem('paymentRecords', 'records', '付款记录', routerHelper_1.getMscSrc(env_conf_1.mscHost + preFix + "paytrace/" + FinanceBizMap.dzd[builder.bizLineName]), isFulPath, null, meta));
        }
        return financeInfo;
    };
    RouteBuilder.buildDataSummary = function (builer, operatingDataCompoent, productDataComponent, ServeData) {
        var dataSummaryInfo = builer.createRouteItem('dataSummaryInfo', 'reporter', '数据分析', null, false, builer.viewWrapper, { icon: 'turbo-ui-bargraph' });
        var operatingData = builer.createNativeRouteItem('operatingData', 'operating', '经营数据', operatingDataCompoent);
        var productData = builer.createNativeRouteItem('productData', 'product', '商品数据', productDataComponent);
        dataSummaryInfo.children = [operatingData, productData];
        if (DataBizMap.fwsj.includes(builer.bizLineName)) {
            dataSummaryInfo.children.push(builer.createNativeRouteItem('serveData', 'srver', '服务数据', ServeData));
        }
        return dataSummaryInfo;
    };
    RouteBuilder.buildReviewList = function (builer, commentComponet) {
        var reviewList = builer.createNativeRouteItem('reviewlist', 'reviews', '评价管理', commentComponet, { icon: 'turbo-ui-recommend' });
        return reviewList;
    };
    RouteBuilder.buildReviewDetail = function (builer, commentComponet) {
        return builer.createNativeRouteItem('reviewDetail', 'review/:id?/:name?', '评价详情', commentComponet, { notMenu: true, noAuth: true, activeName: builer.bizLineName + 'reviewlist' });
    };
    RouteBuilder.buildQaA = function (builer) {
        var preFix = '/qa/';
        var qaqManage = builer.createRouteItem('qaq', 'qa', '问答管理', null, false, builer.viewWrapper, { icon: 'turbo-ui-comment' });
        var qaqSummary = builer.createRouteItem('summary', 'qa-collect', '问答汇总', preFix + 'qa-collect');
        var qaqList = builer.createRouteItem('list', 'qa-query', '问答查询', preFix + 'qa-query');
        qaqManage.children = [qaqSummary, qaqList];
        return qaqManage;
    };
    RouteBuilder.buildXAXY = function (builder, component) {
        var xgxy = builder.createNativeRouteItem('academy', 'academy', '西瓜学院', component, { bizLineId: bizLineIdMap[builder.bizLineName], icon: 'turbo-ui-college' });
        return xgxy;
    };
    RouteBuilder.buildGZZX = function (builder) {
        var gzzx = builder.createRouteItem('policyrule', 'policyrule', '规则中心', baseUrl + "notification/policyrule/" + bizLineNameMap[builder.bizLineName], true, null, { icon: 'turbo-ui-hammer' });
        return gzzx;
    };
    return RouteBuilder;
}());
exports.default = RouteBuilder;


/***/ }),
/* 67 */
/*!****************************************!*\
  !*** ./src/views/academy/HomePage.vue ***!
  \****************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-75887188","scoped":true,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./HomePage.vue */ 775)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./HomePage.vue */ 776),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-75887188","hasScoped":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./HomePage.vue */ 785),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-75887188",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/*!*******************************!*\
  !*** ./src/api/tripNotify.js ***!
  \*******************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.insertCookie = exports.getLastestMsg = exports.noticeList = exports.pageList = exports.getType = exports.update = exports.handleMsg = exports.readAllMessage = exports.getList = exports.getCategoryList = exports.getNotifyCount = undefined;

var _axios = __webpack_require__(/*! axios */ 12);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getNotifyCount = exports.getNotifyCount = function getNotifyCount() {
  return _axios2.default.get('/trip-notify/msg/v2/count');
};

var getCategoryList = exports.getCategoryList = function getCategoryList(type) {
  return _axios2.default.get('/trip-notify/msg/list/category?typeId=' + (type || 0));
};

var getList = exports.getList = function getList(params) {
  return _axios2.default.get('/trip-notify/msg/condition/list', { params: params });
};

var readAllMessage = exports.readAllMessage = function readAllMessage(types) {
  return _axios2.default.put('/trip-notify/msg/types/read', { typeIds: types.join(',') });
};

var handleMsg = exports.handleMsg = function handleMsg(msgId) {
  return _axios2.default.put('/trip-notify/msg/ids/handled', { broadCastIds: msgId });
};

var update = exports.update = function update(msg) {
  return _axios2.default.post('/trip-notify/msg/status/update', msg);
};

var getType = exports.getType = function getType() {
  return _axios2.default.get('/trip-notify/msg/type');
};

var pageList = exports.pageList = function pageList(params) {
  return _axios2.default.get('/trip-notify/msg/condition/page', { params: params });
};

var noticeList = exports.noticeList = function noticeList(params) {
  return _axios2.default.get('/trip-notify/acc/announces', { params: params });
};

var getLastestMsg = exports.getLastestMsg = function getLastestMsg(typeWeight) {
  return _axios2.default.get('/trip-notify/msg/latest', { params: { typeWeight: typeWeight } });
};

var insertCookie = exports.insertCookie = function insertCookie() {
  return _axios2.default.get('/trip-notify/acc/cookie');
};

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */
/*!************************************************!*\
  !*** ./src/components/content-block/index.vue ***!
  \************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-7175face","scoped":true,"hasInlineConfig":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./index.vue */ 496)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./index.vue */ 497),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7175face","hasScoped":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./index.vue */ 498),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7175face",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/*!***********************************!*\
  !*** ./src/helpers/formatDate.js ***!
  \***********************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var formatDate = exports.formatDate = function formatDate(dateInput) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd';

    var date = dateInput instanceof Date ? dateInput : new Date(dateInput);
    var fmt = format;
    var o = {
        'M+': date.getMonth() + 1, //月份
        'd+': date.getDate(), //日
        'h+': date.getHours(), //小时
        'm+': date.getMinutes(), //分
        's+': date.getSeconds(), //秒
        'q+': Math.floor((date.getMonth() + 3) / 3), //季度
        'S': date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, String(date.getFullYear()).substr(4 - RegExp.$1.length));
    for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(String(o[k]).length));
    }
    return fmt;
};

/***/ }),
/* 78 */
/*!************************************************************!*\
  !*** ./src/views/dataPlatform/components/echarts/Line.vue ***!
  \************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-423e4527","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Line.vue */ 664)
}
var Component = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Line.vue */ 665),
  /* template */
  __webpack_require__(/*! !../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-423e4527","hasScoped":true}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Line.vue */ 666),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-423e4527",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 79 */
/*!**********************************!*\
  !*** ./src/data/notification.js ***!
  \**********************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.businessLines = exports.LandingPageMap = exports.TICKETORDERTYPE = exports.TICKETORDERCODE = exports.OtherMsgTypesMap = exports.MsgCategories = undefined;

var _env = __webpack_require__(/*! config/env.conf */ 2);

var MsgCategories = exports.MsgCategories = [{
    id: 1,
    name: '编审'
}, {
    id: 2,
    name: '促销'
}, {
    id: 3,
    name: '其它'
}];
var shenSuRefundList = { stateName: 'ticketOrderRefund' };

var OtherMsgTypesMap = exports.OtherMsgTypesMap = {
    18: { stateName: 'ticketselfPromotionList', paramName: 'activityId', params: { status: 0 } },
    34: { stateName: 'gtyselfPromotionList', paramName: 'activityId', params: { status: 0 } },
    35: { stateName: 'jiujingselfPromotionList', paramName: 'activityId', params: { status: 0 } },
    39: { stateName: 'gtysummary', paramName: 'id', params: {} },
    40: { stateName: 'jiujingsummary', paramName: 'id', params: {} },
    41: { stateName: 'ticketflowInvestList', paramName: 'id', params: { status: 0, slotStatus: 0 } },
    42: { stateName: 'ticketflowInvestList', paramName: 'id', params: { status: 0, slotStatus: 2 } },
    43: { stateName: 'ticketflowInvestList', paramName: 'id', params: { status: 0, slotStatus: 5 } },
    888: { stateName: 'ticketselfPromotionList', paramName: 'id', params: {} },
    50: shenSuRefundList
};

var TICKETORDERCODE = exports.TICKETORDERCODE = 1;

var TICKETORDERTYPE = exports.TICKETORDERTYPE = 888;
var hasHtmlExt = _env.otpHost.includes('.html');

var editCertificate = { stateName: 'ticketeditCertificate', paramName: 'id', urlPattern: '' + _env.otpHost + (hasHtmlExt ? '' : '/') + '#/ticket/product/edit-certificate/$bizKey' };
var tickerList = { stateName: 'ticketlistProduct', paramName: 'dealId' };
var jiujingEditProduct = { stateName: 'jiujing-editProduct', paramName: 'id', paramsExt: { tab: 4 }, noblank: true, urlPattern: '' + _env.otpHost + (hasHtmlExt ? '' : '/') + '#/jiujing/product/edit/$bizKey?tab=4' };
var verifyList = { stateName: 'verify', urlPattern: '#/notification/verify?categoryId=65' };
var LandingPageMap = exports.LandingPageMap = { 50: shenSuRefundList, 2: editCertificate, 5: editCertificate, 7: tickerList, 10: tickerList, 11: tickerList, 65: jiujingEditProduct, '65taa': verifyList };

var businessLines = exports.businessLines = [{
    name: '门票',
    value: 'ticket',
    bizLineId: 2
}, {
    name: '跟团游',
    value: 'packageTour',
    bizLineId: 3
}, {
    name: '景酒',
    value: 'sceneHotel',
    bizLineId: 4
}, {
    name: '机酒',
    value: 'airlineTicket',
    bizLineId: 6
}, {
    name: '旅游用车',
    value: 'carTicket',
    bizLineId: 7
}];

/***/ }),
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/*!******************************************************************************!*\
  !*** ./src/views/dataPlatform/components/indicators-data/IndicatorsData.vue ***!
  \******************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-644b3f48","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./IndicatorsData.vue */ 635)
}
var Component = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./IndicatorsData.vue */ 636),
  /* template */
  __webpack_require__(/*! !../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-644b3f48","hasScoped":true}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./IndicatorsData.vue */ 637),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-644b3f48",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 94 */
/*!******************************************************************************!*\
  !*** ./src/views/dataPlatform/operateData/components/line-tips/LineTips.vue ***!
  \******************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-63a31332","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./LineTips.vue */ 647)
}
var Component = __webpack_require__(/*! ../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./LineTips.vue */ 648),
  /* template */
  __webpack_require__(/*! !../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-63a31332","hasScoped":true}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./LineTips.vue */ 649),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-63a31332",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/*!****************************!*\
  !*** ./src/api/comment.js ***!
  \****************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(/*! axios */ 12);

var _axios2 = _interopRequireDefault(_axios);

var _env = __webpack_require__(/*! ../config/env.conf */ 2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

    /**
     * 获取云标签
     * @param { int } did     产品ID
     * @param { int } channel 来源，1 美团 2 点评
     */
    getTags: function getTags(did, channel) {
        return _axios2.default.get('/rimet/fe/mtp/comment/api/travel/deal/tag', {
            params: {
                did: did,
                channel: channel
            }
        });
    },


    /**
     * 根据标签获取评价
     * @param { int }    did     产品ID
     * @param { int }    channel 来源，1 美团 2 点评
     * @param { string } tag     标签名
     * @param { int }    page    第几页
     * @param { int }    count   一页展示几条
     */
    getCommentsForTag: function getCommentsForTag(did, channel, tag) {
        var page = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
        var count = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 20;

        return _axios2.default.get('/rimet/fe/mtp/comment/api/travel/deal/tag/comments', {
            params: {
                did: did,
                channel: channel,
                tag: tag,
                page: page,
                count: count
            }
        });
    },


    /**
     * 根据回复情况获取评价
     * @param { int } did       产品ID
     * @param { int } channel   来源，1 美团 2 点评
     * @param { int } replyType 回复类型，1 全部 2 未回复
     * @param { int } page      第几页
     * @param { int } count     一页展示几条
     */
    getCommentsForReply: function getCommentsForReply(did, channel, replyType) {
        var page = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
        var count = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 20;

        return _axios2.default.get('/rimet/fe/mtp/comment/api/travel/deal/reply/comments', {
            params: {
                did: did,
                channel: channel,
                replyType: replyType,
                page: page,
                count: count
            }
        });
    },


    /**
     * 根据日期、星级获取评价
     * @param { int }    did       产品ID
     * @param { int }    channel   来源，1 美团 2 点评
     * @param { string } startDate 开始时间
     * @param { string } endDate   结束时间
     * @param { list }   starLevel 星级
     * @param { int }    page      第几页
     * @param { int }    count     一页展示几条
     */
    getCommentsForOthers: function getCommentsForOthers(did, channel, startDate, endDate, starLevels) {
        var page = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
        var count = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 20;

        return _axios2.default.get('/rimet/fe/mtp/comment/api/travel/deal/v2/comments', {
            params: {
                did: did,
                channel: channel,
                startDate: startDate,
                endDate: endDate,
                starLevels: starLevels,
                page: page,
                count: count
            }
        });
    },


    /**
     * 根据有无内容获取评价
     * @param { int } did         产品ID
     * @param { int } contentType 有无内容，0 全部 1 有内容 2 无内容
     * @param { int } page        第几页
     * @param { int } count       一页展示几条
     */
    getCommentsForContent: function getCommentsForContent(did, contentType) {
        var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var count = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 20;

        return _axios2.default.get('/rimet/fe/mtp/comment/api/travel/deal/content/comments', {
            params: {
                did: did,
                contentType: contentType,
                page: page,
                count: count
            }
        });
    },


    /**
     * 获取产品列表及筛选
     * @param { int }    businessType 业务线
     * @param { string } searchStr    搜索内容
     * @param { int }    page         第几页
     * @param { int }    count        一页展示几条
     */
    getProductList: function getProductList(businessType, searchStr) {
        var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var count = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10;

        return _axios2.default.get('/rimet/fe/mtp/comment/api/travel/deal/list', {
            params: {
                businessType: businessType,
                searchStr: searchStr || null,
                page: page,
                count: count
            }
        });
    },


    /**
     * 获取默认产品
     * @param { int } businessType 业务线
     */
    getDefaultProduct: function getDefaultProduct(businessType) {
        return _axios2.default.get('/rimet/fe/mtp/comment/api/travel/deal/default', {
            params: {
                businessType: businessType
            }
        });
    },


    /**
     * 提交商家回复
     * @param { int }    did       项目ID
     * @param { string } reply     回复内容
     * @param { int }    commentId 评价ID
     * @param { int }    poiId     该评价所属的景点ID
     */
    postCommentReply: function postCommentReply(did, reply, commentId, poiId) {
        var params = {
            did: did,
            reply: reply,
            commentId: commentId,
            poiId: poiId
        };
        return _axios2.default.post('/rimet/fe/mtp/comment/api/travel/comments/' + commentId + '/reply', params);
    },


    /**
     * 评价下载
     * @param { int } did     产品ID
     * @param { int } channel 来源，1 美团 2 点评
     */
    uploadComment: function uploadComment(did, channel) {
        window.open(_env.apiHost + '/rimet/fe/mtp/comment/api/travel/download?dealId=' + did + '&channel=' + channel);
    }
};

/***/ }),
/* 96 */,
/* 97 */
/*!************************************************!*\
  !*** ./src/components/nhomepage/nhomepage.vue ***!
  \************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-7be59d06","scoped":false,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./nhomepage.vue */ 731)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./nhomepage.vue */ 732),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7be59d06","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./nhomepage.vue */ 774),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */
/*!****************************!*\
  !*** ./src/store/index.js ***!
  \****************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(/*! vue */ 30);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(/*! vuex */ 14);

var _vuex2 = _interopRequireDefault(_vuex);

var _actions = __webpack_require__(/*! ./actions */ 455);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(/*! ./getters */ 224);

var getters = _interopRequireWildcard(_getters);

var _mutations = __webpack_require__(/*! ./mutations */ 483);

var _mutations2 = _interopRequireDefault(_mutations);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var state = {
    version: "0.13.5",
    isLogin: false,
    isMisLogin: false,
    pageAccountType: '', // 当前页面是mis账号类型还是商家账号类型， 值为 'mis' 'biz'
    bizUser: {}, // 商家账号信息
    misUser: {}, // 商家账号
    bizAuthInfo: {}, // 商家账号权限信息
    fromPage: '',
    sfCustoms: null,
    unreadMap: {},
    jiuJingConfirmOrders: 0
};

var store = new _vuex2.default.Store({
    state: state,
    getters: getters,
    actions: actions,
    mutations: _mutations2.default,
    strict: false
});

exports.default = store;

/***/ }),
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */
/*!******************************************************!*\
  !*** ./src/components/input-number-custom/index.vue ***!
  \******************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-055a5f12","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./index.vue */ 493)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./index.vue */ 494),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-055a5f12","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./index.vue */ 495),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */,
/* 117 */
/*!*******************************************************!*\
  !*** ./src/views/dataPlatform/filters/data-format.js ***!
  \*******************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (_value) {
    if (isNaN(_value) || _value === null || _value === '') {
        return '--';
    }
    if (String(_value).indexOf('.') !== -1) {
        return _value;
    }
    var arr = String(_value).split('').reverse();
    var new_arr = [];
    for (var i = 0, len = arr.length; i < len; i++) {
        if (i === 0 || i % 3 !== 0) {
            new_arr.push(arr[i]);
        } else {
            new_arr.push(',');
            new_arr.push(arr[i]);
        }
    }
    return new_arr.reverse().join('');
};

/***/ }),
/* 118 */
/*!*****************************************!*\
  !*** ./src/views/comment/list/Main.vue ***!
  \*****************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-cbeb821a","scoped":true,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Main.vue */ 698)
}
var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Main.vue */ 699),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-cbeb821a","hasScoped":true}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Main.vue */ 730),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cbeb821a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/*!****************************************************************!*\
  !*** ./src/views/dataPlatform/menpiao/components/PlatForm.vue ***!
  \****************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-67620d02","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PlatForm.vue */ 821)
}
var Component = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PlatForm.vue */ 822),
  /* template */
  __webpack_require__(/*! !../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-67620d02","hasScoped":true}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PlatForm.vue */ 823),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-67620d02",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 120 */
/*!******************************!*\
  !*** ./src/api/wenchuang.js ***!
  \******************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(/*! axios */ 12);

var _axios2 = _interopRequireDefault(_axios);

var _env = __webpack_require__(/*! ../config/env.conf */ 2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

    /**
     * 获取订单列表数据
     * @param { int } orderState -1 全部，0 新单，1 待发货，2 已发货
     * 3 发货失败，4 已签收，5 申请退款，6 退款成功
     */
    getOrderListData: function getOrderListData(orderState, form, currentPage) {
        var params = {};
        params.orderState = orderState;
        if (form) {
            for (var key in form) {
                if (form[key].trim() !== '') {
                    params[key] = form[key].trim();
                }
            }
        }
        if (currentPage) {
            params.offset = (currentPage - 1) * 20;
        }
        return _axios2.default.get('cci/core/v1/order/list', {
            params: params
        });
    },


    /**
     * 获取订单详情
     * @param { int } orderId 订单ID
     */
    getOrderDetails: function getOrderDetails(orderId) {
        return _axios2.default.get('cci/core/v1/order/detail', {
            params: {
                orderId: orderId
            }
        });
    },


    /**
     * 发货
     * @param { int }    orderId     订单ID
     * @param { string } deliverCode 快递公司编号
     * @param { string } deliverNo   快递单号
     */
    sendProduct: function sendProduct(orderId, deliverCode, deliverNo) {
        var params = {
            orderId: orderId,
            deliverCode: deliverCode,
            deliverNo: deliverNo
        };
        var q = new URLSearchParams();
        for (var i in params) {
            q.append(i, params[i]);
        }
        return _axios2.default.post('cci/core/v1/order/deliver', q.toString(), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
    },


    /**
     * 放弃
     * @param { int }    orderId  订单ID
     * @param { int }    reason   放弃理由
     * @param { string } describe 描述
     */
    reject: function reject(orderId, reason, describe) {
        var params = {
            orderId: orderId,
            reason: reason,
            describe: describe
        };
        var q = new URLSearchParams();
        for (var i in params) {
            q.append(i, params[i]);
        }
        return _axios2.default.post('cci/core/v1/order/reject', q.toString(), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
    },


    /**
     * 退款
     * @param { int }    orderId 订单ID
     * @param { int }    status  1 同意，2 拒绝
     * @param { string } message 原因
     */
    handleRefund: function handleRefund(orderId, status, message) {
        var params = {
            orderId: orderId,
            status: status,
            message: message
        };
        var q = new URLSearchParams();
        for (var i in params) {
            q.append(i, params[i]);
        }
        return _axios2.default.post('/cci/core/v1/order/handleRefund', q.toString(), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
    },


    /**
     * 获取快递列表
     */
    getExpressInfo: function getExpressInfo() {
        return _axios2.default.get('cci/core/v1/deliver/company/list');
    },


    /**
     * 下载
     */
    downloadOrder: function downloadOrder(params) {
        var str = '';
        for (var k in params) {
            if (params[k] !== '') {
                str += k + '=' + params[k] + '&';
            }
        }
        window.open(_env.apiHost + '/cci/core/v1/order/export?' + str);
    }
};

/***/ }),
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */
/*!****************************!*\
  !*** ./src/data/ticket.js ***!
  \****************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var categories = exports.categories = [{ label: '单景区', value: 61 }, { label: '水上乐园', value: 62 }, { label: '动物园', value: 272 }, { label: '植物园', value: 273 }, { label: '温泉', value: 276 }, { label: '游乐场/主题乐园', value: 59 }, { label: '海洋馆', value: 271 }, { label: '博物馆/美术馆/科技馆', value: 64 }, { label: '游船', value: 270 }, { label: '高空观景', value: 67 }, { label: '漂流', value: 278 }, { label: '巴士观光', value: 269 }, { label: '滑雪', value: 283 }, { label: '演出票', value: 760 }, { label: '餐/票+餐', value: 776 }, { label: '物流商品', value: 779 },
// {label: '骑马', value: 88},
// {label: '滑冰', value: 284},
{ label: '其他', value: 274 }];

var usePeopleTypes = exports.usePeopleTypes = [{ label: '成人票', value: 1 }, { label: '儿童票', value: 2 }, { label: '老人票', value: 3 }, { label: '双人票', value: 4 }, { label: '不限人群票', value: 5 }, { label: '亲子票', value: 6 }, { label: '学生票', value: 7 }, { label: '优待票', value: 8 }, { label: '团体票', value: 9 }, { label: '三人票', value: 10 }, { label: '其他', value: 0 }];

var timeLimitedRangeTypes = exports.timeLimitedRangeTypes = [{ label: '平日', value: 1 }, { label: '周末', value: 2 }, { label: '不限时间', value: 3 }, { label: '其他', value: 0 }];

var uploadMaterialTypes = exports.uploadMaterialTypes = [{ label: '无需上传物料类型', value: 0 }, { label: '文本', value: 1 }, { label: '图片', value: 2 }, { label: '文本+图片', value: 3 }];

var buyCountLimitTypes = exports.buyCountLimitTypes = [{ label: '张', value: 0 }, { label: '单', value: 1 }];

var textareaForbiddenWords = exports.textareaForbiddenWords = ['营业时间', '入园时间', '预约', '预定', '预订', '电话', '有效期'];

var ticketName2PersonType = exports.ticketName2PersonType = {
    '儿童票': ['儿童'],
    '老人票': ['老年人'],
    '亲子票': ['儿童'],
    '学生票': ['全日制大中小学生(不含成人教育、研究生)', '全日制大中小学生'],
    '优待票': ['残疾人', '现役军人', '离休干部', '教师']
};

/***/ }),
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */
/*!*********************************************************!*\
  !*** ./src/views/ticket/product/common/defaultModel.js ***!
  \*********************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _helpers = __webpack_require__(/*! helpers */ 16);

var modelData = __webpack_require__(/*! ./modelSchema */ 582).default;


var copyKeys = ['contractId', 'contractNum', 'mtCategory', 'title', 'servicePhones', 'contractInfoType', 'contractInfoRule', 'visitorInfoType', 'visitorInfoRule', 'minBuyCount', 'maxBuyCount', 'orderCancelTime', 'generateTicketMethod', 'generateTicketWorkTime', 'needTicket', 'getTicketRule', 'ticketGetAddress', 'getVoucherRule', 'getInAddresses', 'useDateMode', 'useDateDays', 'unavailableDates', 'voucherDateEnd', 'voucherDateBegin', 'validWeekRule', 'dayPriceStockRules', 'refundType', 'refundTimeType', 'refundLimitDays', 'refundLimitHours', 'refundLimitMinutes', 'refundFeeMode', 'refundFee', 'partlyRefund', 'scheduleOnlineType', 'scheduleOnlineTime', 'scheduleOfflineType', 'scheduleOfflineTime', 'ticketCategory'];

function removeJsonNullKey(obj) {
    var value = void 0;
    var key = void 0;
    if ((0, _helpers.isArray)(obj)) {
        obj.forEach(function (item, index) {
            removeJsonNullKey(item);
        });
    } else if ((0, _helpers.isObject)(obj)) {
        for (key in obj) {
            if (obj.hasOwnProperty(key)) {
                value = obj[key];
                if (value === null) {
                    delete obj[key];
                }
                if ((0, _helpers.isObject)(value) || (0, _helpers.isArray)(value)) {
                    removeJsonNullKey(value);
                }
            }
        }
    }
}

function getDefaultModel() {
    var isDirectDeal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var isCopy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var data = arguments[2];


    modelData.sourceType = isDirectDeal ? 5 : 1;
    modelData.generateTicketMethod = modelData.sourceType === 1 ? 1 : 3;
    if (modelData.generateTicketMethod === 3) {
        modelData.getVoucherRule.voucherLoaders = [4];
        modelData.getTicketRule.voucherLoaders = [4];
    }
    if (data) {
        removeJsonNullKey(data);
        if (isCopy) {
            data = (0, _helpers.pick)(data, copyKeys);
            // 复制的时候只复制ticketCategory的poi信息，其他初始化
            var poiInfo = data.ticketCategory.poi;
            data.ticketCategory = {
                ticket: {},
                subTicket: {},
                poi: poiInfo,
                createTicketCategoryInfo: {
                    ticketCategoryName: '',
                    usePeople: 1,
                    timeLimitedRange: 3,
                    timeLimitedRangeText: '',
                    ticketCategoryPrice: '',
                    uploadMaterialType: 2,
                    uploadMaterialText: '',
                    uploadMaterialImage: []
                }
            };
        }
        if (!data.dealImageInfos) {
            data.dealImageInfos = [];
        }
        if (data.maxBuyCount === -1) {
            delete data.maxBuyCount;
        }
        // data.scheduleOfflineType = Boolean(data.scheduleOfflineTime);
        // 如果接口返回的数据值不符合初始值得要求则在此格式化;
        if (!Array.isArray(data.includeItems)) {
            data.includeItems = [{
                count: 1
            }];
        }

        if ((0, _helpers.isUndefined)(data.containInsurance) || data.containInsurance === null) {
            data.containInsurance = false;
        }

        if (!Number.isInteger(data.hours)) {
            data.hours = 0;
        }

        if (!Number.isInteger(data.minutes)) {
            data.minutes = 0;
        }
        if (data.scrAttrs) {
            if (!data.scrAttrs.offlineBookRule) {
                data.scrAttrs.offlineBookRule = {
                    bookTypes: []
                };
            } else if (!data.scrAttrs.offlineBookRule.bookTypes) {
                data.scrAttrs.offlineBookRule.bookTypes = [];
            }
        }
        if (!Array.isArray(data.servicePhones) || data.servicePhones && data.servicePhones.length === 0) {
            data.servicePhones = [{
                phone: '',
                startHour: 0,
                startMin: 0,
                endHour: 0,
                endMin: 0
            }];
        }

        if (!data.generateTicketWorkTime) {
            data.generateTicketWorkTime = {
                startWorkHour: 8,
                startWorkMinute: 0,
                endWorkHour: 20,
                endWorkMinute: 0
            };
        }
        // 需求：若上传过特批附件则默认显示需要特批附件
        if (data.specialAuthPics && data.specialAuthPics.length) {
            data.needSpecialAuthFile = true;
        }
        modelData = Object.assign(modelData, data);
        // todo：暂时解决，其他值也有类似问题
        if (!modelData.ticketCategory.poi) {
            modelData.ticketCategory.poi = [];
        }
        if (modelData.freeTicketAssociatedAccount) {
            modelData.statementId = modelData.freeTicketAssociatedAccount;
        }
    }
    return modelData;
}

exports.default = getDefaultModel;

/***/ }),
/* 160 */
/*!**********************************!*\
  !*** ./src/api/verifyHistory.js ***!
  \**********************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _axios = __webpack_require__(/*! axios */ 12);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    getConsumptionList: function getConsumptionList(queryParams) {
        return _axios2.default.get('/meilv/scs/account/v1/voucher/statistics', {
            params: queryParams
        });
    },
    getDeals: function getDeals(queryParams) {
        return _axios2.default.get('/meilv/scs/account/v1/voucher/deallist', {
            params: queryParams
        });
    },
    getAllConsumptionList: function getAllConsumptionList(queryParams) {
        return _axios2.default.get('/meilv/scs/account/v1/voucher/log', {
            params: queryParams
        });
    }
};

/***/ }),
/* 161 */
/*!*******************************!*\
  !*** ./src/api/dataCenter.js ***!
  \*******************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getHistoryData = exports.getReserveData = exports.getDataTable = undefined;

var _axios = __webpack_require__(/*! axios */ 12);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDataTable = exports.getDataTable = function getDataTable(queryParms) {
    return _axios2.default.get('/meilv/trade/ticket/merchant/api/data/detail/v1', {
        params: queryParms
    });
};

var getReserveData = exports.getReserveData = function getReserveData(queryParms) {
    return _axios2.default.get('/meilv/trade/ticket/merchant/api/data/reserve_count/v1');
};

var getHistoryData = exports.getHistoryData = function getHistoryData(queryParms) {
    return _axios2.default.get('/meilv/trade/ticket/merchant/api/data/history/v1', {
        params: queryParms
    });
};

/***/ }),
/* 162 */
/*!*****************************************************!*\
  !*** ./src/views/dataPlatform/operateData/Main.vue ***!
  \*****************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-1e1a4df6","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Main.vue */ 624)
}
var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Main.vue */ 625),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1e1a4df6","hasScoped":true}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Main.vue */ 668),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1e1a4df6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 163 */
/*!***********************************************************!*\
  !*** ./src/views/dataPlatform/components/title/Title.vue ***!
  \***********************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-dbe6b3da","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Title.vue */ 626)
}
var Component = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Title.vue */ 627),
  /* template */
  __webpack_require__(/*! !../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-dbe6b3da","hasScoped":true}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Title.vue */ 628),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-dbe6b3da",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/*!*****************************************************!*\
  !*** ./src/views/dataPlatform/productData/Main.vue ***!
  \*****************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-c7b7890c","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Main.vue */ 669)
}
var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Main.vue */ 670),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-c7b7890c","hasScoped":true}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Main.vue */ 697),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c7b7890c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 165 */
/*!**************************************!*\
  !*** ./src/config/packageProduct.js ***!
  \**************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Package_Order_Interval = exports.Package_Order_Interval = 5 * 1000 * 60;
var Max_Order_Show_Num = exports.Max_Order_Show_Num = 10;
var Lazy_Img_Src = exports.Lazy_Img_Src = 'https://mcombo.meituan.net/test/hotel/ebooking/images/003.gif';
var Lazy_Load_Attr = exports.Lazy_Load_Attr = 'data-src';

/***/ }),
/* 166 */
/*!******************************************!*\
  !*** ./src/components/homepage/Card.vue ***!
  \******************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-b0b021e4","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Card.vue */ 733)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Card.vue */ 734),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-b0b021e4","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Card.vue */ 735),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/*!******************************!*\
  !*** ./src/config/common.js ***!
  \******************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var bizLines = exports.bizLines = [{
    name: '门票',
    value: 'ticket',
    bizLineId: 2
}, {
    name: '跟团游',
    value: 'gty',
    bizLineId: 3
}, {
    name: '景酒套餐',
    value: 'jiujing',
    bizLineId: 4
}, {
    name: '机酒套餐',
    value: 'jijiu',
    bizLineId: 6
}, {
    name: '旅游用车',
    value: 'chepiao',
    bizLineId: 7
}, {
    name: '实物电商',
    value: 'wenchuang',
    bizLineId: 1
}];

var dxEnvUrlMap = exports.dxEnvUrlMap = {
    'qa': 'api.xm.test.sankuai.com',
    'production': 'api.neixin.cn',
    'staging': 'api.st.neixin.cn'
};

/***/ }),
/* 168 */
/*!***************************************!*\
  !*** ./src/filters/toFixedPercent.js ***!
  \***************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (rate) {
    return rate + '%';
};

/***/ }),
/* 169 */
/*!*********************************!*\
  !*** ./static/img/group-26.png ***!
  \*********************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 170 */
/*!***************************!*\
  !*** ./src/utils/menu.js ***!
  \***************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getAuthBizLines = exports.getRootRoute = exports.getMenus = exports.getActiveMenuInfo = undefined;

var _menuConfig = __webpack_require__(/*! config/menuConfig */ 263);

var cache = {};
var getAuthBizLineKey = 'getAuthBizLineKey';
var RootStateKey = "RootState";
var menusKeyPrefix = "menus";

function filterMenus(route, sfCustoms) {
    var rootPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '/';

    var path = rootPath + route.path;
    if (!sfCustoms.check(path)) {
        route.meta = route.meta || {};
        Object.assign(route.meta, { notMenu: true });
    } else {
        if (route.children && route.children.length) {
            route.children.forEach(function (routeItem) {
                filterMenus(routeItem, sfCustoms, path + '/');
            });
        }
    }
}

var getActiveMenuInfo = exports.getActiveMenuInfo = function getActiveMenuInfo(currentRoute) {
    var info = {};
    if (currentRoute.meta && currentRoute.meta.activeName) {
        info.activeName = currentRoute.meta.activeName;
    } else if (!currentRoute.meta || !currentRoute.meta.notMenu) {
        info.activeName = currentRoute.name;
    }
    var matches = currentRoute.matched;
    if (matches && matches[0] && matches[0].name === _menuConfig.rootRouteName) {
        if (matches[2] && matches[2].name) {
            info.openNames = [matches[2].name];
        }
    }
    return info;
};

var getMenus = exports.getMenus = function getMenus(routes, currentRoute, sfCustoms, bizUser) {
    var matches = currentRoute.matched;
    if (matches && matches[0] && matches[0].name === _menuConfig.rootRouteName && matches[1] && matches[1].meta && matches[1].meta.name) {
        var bizLineDefaultRouteName = matches[1].meta.name;
        var key = menusKeyPrefix + bizLineDefaultRouteName;
        key += bizUser && bizUser.id || 'nokey';
        if (cache && cache[key]) {
            return cache[key];
        }
        var menus = [];
        var rootRoute = getRootRoute(routes);
        var bizLineHomeRoute = rootRoute.children.find(function (route) {
            if (route && route.meta && route.meta.name) {
                return route.meta.name === bizLineDefaultRouteName;
            }
        });
        if (bizLineHomeRoute && bizLineHomeRoute.children && bizLineHomeRoute.children.length) {
            filterMenus(bizLineHomeRoute, sfCustoms);
            menus = bizLineHomeRoute.children;
        }
        cache[key] = menus;
        return cache[key];
    }
    return [];
};

var getRootRoute = exports.getRootRoute = function getRootRoute(routes) {
    if (cache && cache[RootStateKey]) {
        return cache[RootStateKey];
    } else {
        var rootRoute = routes.find(function (routeItem) {
            return routeItem.name === _menuConfig.rootRouteName;
        });
        cache[RootStateKey] = rootRoute;
        return rootRoute;
    }
};

var getAuthBizLines = exports.getAuthBizLines = function getAuthBizLines(routes, bizUser) {
    var key = (bizUser && bizUser.id || 'nokey') + getAuthBizLineKey;
    if (cache && cache[key]) {
        return cache[key];
    } else {
        var result = [];
        if (bizUser && routes && routes.length) {
            var authBizLines = bizUser.authBizlineInfos;
            if (authBizLines && authBizLines.length) {
                var rootRoute = getRootRoute(routes);
                if (rootRoute.children && rootRoute.children.length) {
                    result = rootRoute.children.filter(function (childRoute) {
                        return authBizLines.find(function (authBizLine) {
                            return authBizLine.bizline === childRoute.meta.bizLineValue;
                        });
                    }).map(function (childRoute) {
                        return {
                            name: childRoute.meta.bizName,
                            value: childRoute.meta.name
                        };
                    });
                }
            }
        }
        cache[getAuthBizLineKey] = result;
        return result;
    }
};

/***/ }),
/* 171 */
/*!*****************************************!*\
  !*** ./src/views/wenchuang/constant.js ***!
  \*****************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// 放弃理由
var REJECT_REASON = exports.REJECT_REASON = {
    1: '地址信息不全',
    2: '商品库存不足',
    3: '其它'

    // 拒绝退款原因
};var REFUSE_REASON = exports.REFUSE_REASON = {
    1: '产品不支持退款',
    2: '其它'

    // 订单状态
};var ORDER_STATE_LIST = exports.ORDER_STATE_LIST = [{
    name: '全部',
    value: -1
}, {
    name: '待发货',
    value: 1
}, {
    name: '已发货',
    value: 2
}, {
    name: '发货失败',
    value: 3
}, {
    name: '已签收',
    value: 4
}, {
    name: '申请退款',
    value: 5
}, {
    name: '退款成功',
    value: 6
}];

/***/ }),
/* 172 */
/*!****************************************!*\
  !*** ./src/components/layout/index.js ***!
  \****************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FooterBar = exports.NavBar = undefined;

var _NavBar = __webpack_require__(/*! ./NavBar.vue */ 952);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _FooterBar = __webpack_require__(/*! ./FooterBar.vue */ 956);

var _FooterBar2 = _interopRequireDefault(_FooterBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Sidebar from './Sidebar.vue'
exports.NavBar = _NavBar2.default;
exports.FooterBar = _FooterBar2.default;

/***/ }),
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */
/*!*************************************!*\
  !*** ./src/store/mutation-types.js ***!
  \*************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_BIZ_USER_INFO = exports.SET_BIZ_USER_INFO = 'SET_USER_INFO';
var SET_MIS_USER_INFO = exports.SET_MIS_USER_INFO = 'SET_MIS_USER_INFO';
var CLEAR_USER_INFO = exports.CLEAR_USER_INFO = 'CLEAR_USER_INFO';
var SET_FROM_PAGE = exports.SET_FROM_PAGE = 'SET_FROM_PAGE';
var SET_COUNTRIES = exports.SET_COUNTRIES = 'SET_COUNTRIES';
var SET_PAGE_ACCOUNT_TYPE = exports.SET_PAGE_ACCOUNT_TYPE = 'SET_PAGE_ACCOUNT_TYPE';
var SET_CUSTOMS = exports.SET_CUSTOMS = 'SET_CUSTOMS';
var SET_TRIP_NOTIFY = exports.SET_TRIP_NOTIFY = 'SET_TRIP_NOTIFY';

/***/ }),
/* 223 */
/*!***************************!*\
  !*** ./src/api/common.js ***!
  \***************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getAccountPermission = exports.getMisUserInfo = exports.getUserInfo = exports.logout = undefined;

var _axios = __webpack_require__(/*! axios */ 12);

var _axios2 = _interopRequireDefault(_axios);

var _jsonp = __webpack_require__(/*! jsonp */ 478);

var _jsonp2 = _interopRequireDefault(_jsonp);

var _env = __webpack_require__(/*! ../config/env.conf */ 2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rimetBaseUrl = '/rimet/out/'; // 存放所有通用接口

var clientName = 'lvyou_web';

var logout = exports.logout = function logout() {
    return _axios2.default.get('/rimet/out/auth/logout', {
        params: {
            feclient: 'lvyou_web'
        }
    });
};

var getUserInfo = exports.getUserInfo = function getUserInfo() {
    return _axios2.default.get('/rimet/out/auth/user/menu', {
        params: {
            feclient: 'lvyou_web',
            domainList: 'lvyou-ticket,open-jingjiu,open-gentuanyou,open-jijiu,open-frame,open-cheliang,open-wenchuang'
        }
    });
};

var getMisUserInfo = exports.getMisUserInfo = function getMisUserInfo() {
    return new Promise(function (resolve, reject) {
        (0, _jsonp2.default)(_env.misApiHost + '/tbms/api/getUserInfo/unops', {
            prefix: 'callback'
        }, function (err, _data) {
            if (err) {
                console.log('登陆出错，请重试');
                reject(err);
            }
            var data = _data.data;

            if (_data.status === 1 && !err) {
                reject({
                    status: 1,
                    message: '登录失败'
                });
            } else if (_data.ops === false) {
                console.log('====>login.error');
                reject(false);
            }
            resolve(data);
        });
    });
};

var getAccountPermission = exports.getAccountPermission = function getAccountPermission(entrances) {
    return _axios2.default.get(rimetBaseUrl + 'auth/user/menu/grant', {
        params: {
            feclient: clientName,
            entrances: entrances
        }
    });
};

/***/ }),
/* 224 */
/*!******************************!*\
  !*** ./src/store/getters.js ***!
  \******************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// 获取基础的信息
var env = exports.env = function env(state) {
    return {
        from: state.from,
        user: state.bizUser
    };
};

// 获取是否登录
var isLogin = exports.isLogin = function isLogin(state) {
    var user = account(state);
    return Boolean(user && user.id);
};

// 获取用户信息
var account = exports.account = function account(state) {
    if (state.pageAccountType === 'biz') {
        return state.bizUser;
    } else if (state.pageAccountType === 'mis') {
        return state.misUser;
    }
    return {};
};

/***/ }),
/* 225 */,
/* 226 */
/*!*************************************!*\
  !*** ./src/router/router.config.js ***!
  \*************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _router = __webpack_require__(/*! ./router.ticket */ 486);

var _router2 = _interopRequireDefault(_router);

var _viewWrapper = __webpack_require__(/*! components/view-wrapper/view-wrapper.vue */ 52);

var _viewWrapper2 = _interopRequireDefault(_viewWrapper);

var _router3 = __webpack_require__(/*! ./router.jiujing */ 620);

var _router4 = _interopRequireDefault(_router3);

var _router5 = __webpack_require__(/*! ./router.jijiu */ 786);

var _router6 = _interopRequireDefault(_router5);

var _router7 = __webpack_require__(/*! ./router.chepiao */ 787);

var _router8 = _interopRequireDefault(_router7);

var _router9 = __webpack_require__(/*! ./router.gty */ 788);

var _router10 = _interopRequireDefault(_router9);

var _router11 = __webpack_require__(/*! ./router.ticketng */ 800);

var _router12 = _interopRequireDefault(_router11);

var _router13 = __webpack_require__(/*! ./router.account */ 890);

var _router14 = _interopRequireDefault(_router13);

var _router15 = __webpack_require__(/*! ./router.purse */ 891);

var _router16 = _interopRequireDefault(_router15);

var _router17 = __webpack_require__(/*! ./router.notification */ 892);

var _router18 = _interopRequireDefault(_router17);

var _router19 = __webpack_require__(/*! ./router.wenchuang */ 931);

var _router20 = _interopRequireDefault(_router19);

var _router21 = __webpack_require__(/*! ./router.info */ 948);

var _router22 = _interopRequireDefault(_router21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by xuxin06@meituan.com on 2017/7/24.
 */
// import LoadingComp from 'components/loading.vue'
exports.default = [{
    name: 'login',
    path: '/login',
    component: __webpack_require__(/*! views/login/Main.vue */ 949),
    meta: {
        noAuth: true,
        noUser: true
    }
}, {
    path: '/ticketold',
    component: __webpack_require__(/*! views/ticket/Main.vue */ 962),
    children: _router2.default
}, {
    name: 'comment',
    path: '/:type/comment/:id?/:name?',
    component: __webpack_require__(/*! views/comment/list/Main.vue */ 118),
    meta: {
        noAuth: true
    }
}, {
    name: 'operateData',
    path: '/:type/dataPlatform/operateData',
    component: __webpack_require__(/*! views/dataPlatform/operateData/Main.vue */ 162)
}, {
    name: 'productData',
    path: '/:type/dataPlatform/productData',
    component: __webpack_require__(/*! views/dataPlatform/productData/Main.vue */ 164)
}, {
    name: 'serviceData',
    path: '/:type/dataPlatform/serviceData',
    component: __webpack_require__(/*! views/dataPlatform/serviceData/Main.vue */ 260)
}, {
    name: 'newHome',
    path: '',
    component: __webpack_require__(/*! views/layout/Main.vue */ 262),
    children: [{
        path: 'ticket',
        component: _viewWrapper2.default,
        children: _router12.default,
        meta: {
            name: 'tickethome',
            bizName: '门票',
            bizLineValue: 'lvyou-ticket'
        }
    }, {
        path: 'jiujing',
        component: _viewWrapper2.default,
        children: _router4.default,
        meta: {
            name: 'jiujinghome',
            bizName: '景酒套餐',
            bizLineValue: 'open-jingjiu'
        }
    }, {
        path: 'gty',
        component: _viewWrapper2.default,
        children: _router10.default,
        meta: {
            name: 'gtyhome',
            bizName: '跟团游',
            bizLineValue: 'open-gentuanyou'
        }
    }, {
        path: 'jijiu',
        component: _viewWrapper2.default,
        children: _router6.default,
        meta: {
            name: 'jijiuhome',
            bizName: '机酒套餐',
            bizLineValue: 'open-jijiu'
        }
    }, {
        path: 'chepiao',
        component: _viewWrapper2.default,
        children: _router8.default,
        meta: {
            name: 'chepiaohome',
            bizName: '旅游用车',
            bizLineValue: 'open-cheliang'
        }
    }, {
        path: 'wenchuang',
        component: _viewWrapper2.default,
        children: _router20.default,
        meta: {
            name: 'wenchuanghome',
            bizName: '实物电商',
            bizLineValue: 'open-wenchuang'
        }
    }, {
        path: 'account',
        component: _viewWrapper2.default,
        children: _router14.default,
        meta: {
            notBizMenu: true,
            name: 'adminAccount'
        }
    }, {
        path: 'purse',
        component: _viewWrapper2.default,
        children: _router16.default,
        meta: {
            notBizMenu: true,
            name: 'purseList'
        }
    }, {
        path: 'notification',
        component: _viewWrapper2.default,
        children: _router18.default,
        meta: {
            notBizMenu: true,
            name: 'notificationList'
        }
    }, {
        path: 'info',
        component: _viewWrapper2.default,
        children: _router22.default,
        meta: {
            notBizMenu: true,
            name: 'jiujingauthInfo'
        }
    }, {
        name: 'systemSetting',
        path: 'setting',
        component: __webpack_require__(/*! views/setting/setting.vue */ 966),
        meta: {
            noAuth: true,
            notBizMenu: true
        }
    }]
}, {
    path: '/403',
    component: __webpack_require__(/*! components/403.vue */ 975)
}, {
    path: '/home',
    component: __webpack_require__(/*! components/Home.vue */ 979)
}, {
    name: 'merchnatAcademy',
    path: '/merchnat/academy/:bizLineId',
    component: __webpack_require__(/*! views/academy/HomePage.vue */ 67)
}, {
    name: 'announceDetail',
    path: '/announce/:id',
    component: __webpack_require__(/*! views/academy/AnnounceDetail.vue */ 983),
    meta: {
        noAuth: true
    }
}, {
    name: 'unauthorized',
    path: '/unauthorized',
    component: __webpack_require__(/*! views/unauthorized/Main.vue */ 989),
    meta: {
        noAuth: true
    }
}, {
    path: '*',
    component: __webpack_require__(/*! components/404.vue */ 993),
    meta: {
        noAuth: true
    }
}, {
    name: 'gtyProgramData',
    path: '/gtyDataCenter/programData',
    component: __webpack_require__(/*! views/gtyDataCenter/programData.vue */ 997)
}, {
    name: 'gtyOperationData',
    path: '/gtyDataCenter/operationData',
    component: __webpack_require__(/*! views/gtyDataCenter/operationData.vue */ 1001)
}, {
    name: 'customerSourceAnalyse',
    path: '/newGtyDataCenter/customerSourceAnalyse',
    component: __webpack_require__(/*! views/newGtyDataCenter/customerSourceAnalyse.vue */ 261)
}];

/***/ }),
/* 227 */
/*!************************************************!*\
  !*** ./src/views/ticket/product/item/Main.vue ***!
  \************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-750bbfee","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Main.vue */ 487)
  __webpack_require__(/*! !../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-750bbfee","scoped":true,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=1!./Main.vue */ 488)
}
var Component = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Main.vue */ 489),
  /* template */
  __webpack_require__(/*! !../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-750bbfee","hasScoped":true}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Main.vue */ 583),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-750bbfee",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 228 */
/*!*******************************************************!*\
  !*** ./src/views/ticket/product/item/Instruction.vue ***!
  \*******************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-11bf0cee","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Instruction.vue */ 491)
}
var Component = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Instruction.vue */ 492),
  /* template */
  __webpack_require__(/*! !../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-11bf0cee","hasScoped":false}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Instruction.vue */ 499),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 229 */
/*!************************************************!*\
  !*** ./src/views/ticket/product/item/Info.vue ***!
  \************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-5ed40704","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Info.vue */ 500)
  __webpack_require__(/*! !../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-5ed40704","scoped":true,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=1!./Info.vue */ 501)
}
var Component = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Info.vue */ 502),
  /* template */
  __webpack_require__(/*! !../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-5ed40704","hasScoped":true}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Info.vue */ 545),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5ed40704",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */
/*!*************************************************!*\
  !*** ./src/components/custom-upload/upload.vue ***!
  \*************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./upload.vue */ 518),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1864fcb4","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./upload.vue */ 526),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 234 */,
/* 235 */
/*!*************************************************!*\
  !*** ./src/views/ticket/product/item/Price.vue ***!
  \*************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-7cac3229","scoped":false,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Price.vue */ 546)
}
var Component = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Price.vue */ 547),
  /* template */
  __webpack_require__(/*! !../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7cac3229","hasScoped":false}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Price.vue */ 568),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 236 */
/*!********************************************!*\
  !*** ./src/components/datepicker/index.js ***!
  \********************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datepicker = __webpack_require__(/*! ./datepicker.vue */ 553);

var _datepicker2 = _interopRequireDefault(_datepicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datepicker2.default.install = function (Vue) {
    Vue.component(_datepicker2.default.name, _datepicker2.default);
};

module.exports = _datepicker2.default;

/***/ }),
/* 237 */
/*!*******************************!*\
  !*** ./src/api/tuanTicket.js ***!
  \*******************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.update = exports.create = exports.get = exports.pullData = exports.online = undefined;

var _axios = __webpack_require__(/*! axios */ 12);

var _axios2 = _interopRequireDefault(_axios);

var _store = __webpack_require__(/*! store */ 107);

var _store2 = _interopRequireDefault(_store);

var _notices = __webpack_require__(/*! utils/notices */ 51);

var _env = __webpack_require__(/*! config/env.conf */ 2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import qs from 'qs'

// 上线
var online = exports.online = function online(id) {
  return _axios2.default.put('/midas/mis/msc/deal/preprod/online?mtpDealId=' + id);
};

// 从哥伦布拉取数据
var pullData = exports.pullData = function pullData(id, contractNum) {
  return _axios2.default.get('/midas/mis/msc/deal/preprod/resource/info?relationMtDealId=' + id + '&contractNum=' + contractNum);
};

// 获取数据接口
var get = exports.get = function get(id) {
  return _axios2.default.get('/midas/mis/msc/deal/preprod/info?preProdId=' + id);
};

// 新建
var create = exports.create = function create(data) {
  return _axios2.default.post('/midas/mis/preprod/tickets', data);
};

// 更新
var update = exports.update = function update(data, id) {
  return _axios2.default.put('/midas/mis/preprod/tickets/' + id, data);
};

/***/ }),
/* 238 */
/*!************************************************!*\
  !*** ./src/views/ticket/verify/phone/Main.vue ***!
  \************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-4794acf8","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Main.vue */ 592)
}
var Component = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Main.vue */ 593),
  /* template */
  __webpack_require__(/*! !../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-4794acf8","hasScoped":true}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Main.vue */ 594),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4794acf8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 239 */
/*!*************************************************************!*\
  !*** ./src/views/ticket/verify/phone/pages/phoneVerify.vue ***!
  \*************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-3a06f7a1","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./phoneVerify.vue */ 595)
}
var Component = __webpack_require__(/*! ../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./phoneVerify.vue */ 596),
  /* template */
  __webpack_require__(/*! !../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3a06f7a1","hasScoped":false}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./phoneVerify.vue */ 598),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 240 */
/*!***********************************************************!*\
  !*** ./src/views/ticket/verify/phone/pages/appVerify.vue ***!
  \***********************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-50898914","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./appVerify.vue */ 599)
}
var Component = __webpack_require__(/*! ../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  null,
  /* template */
  __webpack_require__(/*! !../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-50898914","hasScoped":false}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./appVerify.vue */ 600),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 241 */
/*!**************************************************!*\
  !*** ./src/views/ticket/verify/history/Main.vue ***!
  \**************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-95c11ec4","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Main.vue */ 601)
}
var Component = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Main.vue */ 602),
  /* template */
  __webpack_require__(/*! !../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-95c11ec4","hasScoped":true}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Main.vue */ 603),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-95c11ec4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */
/*!****************************************************************************!*\
  !*** ./src/views/ticket/verify/history/pages/singleProgramConsumption.vue ***!
  \****************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-0414e0cf","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./singleProgramConsumption.vue */ 604)
}
var Component = __webpack_require__(/*! ../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./singleProgramConsumption.vue */ 605),
  /* template */
  __webpack_require__(/*! !../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-0414e0cf","hasScoped":true}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./singleProgramConsumption.vue */ 606),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0414e0cf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 243 */
/*!*************************************************************************!*\
  !*** ./src/views/ticket/verify/history/pages/allProgramConsumption.vue ***!
  \*************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-3ccb3a90","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./allProgramConsumption.vue */ 607)
}
var Component = __webpack_require__(/*! ../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./allProgramConsumption.vue */ 608),
  /* template */
  __webpack_require__(/*! !../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3ccb3a90","hasScoped":true}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./allProgramConsumption.vue */ 609),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3ccb3a90",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 244 */
/*!************************************************!*\
  !*** ./src/views/dataCenter/operationData.vue ***!
  \************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-6cd5d6d8","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./operationData.vue */ 614)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./operationData.vue */ 615),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6cd5d6d8","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./operationData.vue */ 616),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 245 */
/*!**********************************!*\
  !*** ./src/filters/toPercent.js ***!
  \**********************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (rate) {
    return (rate * 100).toFixed(1);
};

/***/ }),
/* 246 */
/*!************************************!*\
  !*** ./src/router/routerHelper.js ***!
  \************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getMscSrc = undefined;

var _env = __webpack_require__(/*! config/env.conf */ 2);

var protocol = window.location.protocol;
var getMscSrc = exports.getMscSrc = function getMscSrc(src) {
    return _env.mscHost + '/msc/biz/login?continue=' + encodeURIComponent(src.includes('://') ? src : protocol + src);
};

/***/ }),
/* 247 */
/*!****************************************************************!*\
  !*** ./src/views/dataPlatform/components/echarts/Columnar.vue ***!
  \****************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-1d6ff03a","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Columnar.vue */ 654)
}
var Component = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Columnar.vue */ 655),
  /* template */
  __webpack_require__(/*! !../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1d6ff03a","hasScoped":true}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Columnar.vue */ 656),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1d6ff03a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 248 */
/*!************************************************************!*\
  !*** ./src/views/dataPlatform/components/echarts/Rose.vue ***!
  \************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-111a1dfc","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Rose.vue */ 674)
}
var Component = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Rose.vue */ 675),
  /* template */
  __webpack_require__(/*! !../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-111a1dfc","hasScoped":true}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Rose.vue */ 676),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-111a1dfc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 249 */
/*!*************************************************!*\
  !*** ./src/components/homepage/serviceItem.vue ***!
  \*************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-6c395c0c","scoped":false,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./serviceItem.vue */ 736)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./serviceItem.vue */ 737),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6c395c0c","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./serviceItem.vue */ 738),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 250 */
/*!************************************************!*\
  !*** ./src/components/homepage/ActiveItem.vue ***!
  \************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-7a68e392","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ActiveItem.vue */ 739)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ActiveItem.vue */ 740),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7a68e392","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ActiveItem.vue */ 741),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/*!*********************************************!*\
  !*** ./src/components/homepage/notices.vue ***!
  \*********************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-971502a6","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./notices.vue */ 742)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./notices.vue */ 743),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-971502a6","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./notices.vue */ 747),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 252 */
/*!************************************************!*\
  !*** ./src/components/homepage/noticeItem.vue ***!
  \************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-f90e302e","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./noticeItem.vue */ 744)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./noticeItem.vue */ 745),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-f90e302e","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./noticeItem.vue */ 746),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 253 */
/*!************************************************!*\
  !*** ./src/components/homepage/CourseItem.vue ***!
  \************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-1b8b0a4c","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CourseItem.vue */ 748)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CourseItem.vue */ 749),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1b8b0a4c","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CourseItem.vue */ 750),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 254 */
/*!********************************************!*\
  !*** ./src/components/homepage/Footer.vue ***!
  \********************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-6b75aace","scoped":true,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Footer.vue */ 751)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Footer.vue */ 752),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6b75aace","hasScoped":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Footer.vue */ 753),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6b75aace",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 255 */
/*!*************************************************!*\
  !*** ./src/components/homepage/BannerTexts.vue ***!
  \*************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-f3abcae8","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BannerTexts.vue */ 754)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BannerTexts.vue */ 755),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-f3abcae8","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BannerTexts.vue */ 756),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 256 */
/*!**************************************************!*\
  !*** ./src/components/homepage/BannerImages.vue ***!
  \**************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-48f090c2","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BannerImages.vue */ 757)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BannerImages.vue */ 758),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-48f090c2","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BannerImages.vue */ 759),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 257 */
/*!***********************************************!*\
  !*** ./src/components/homepage/TopNotice.vue ***!
  \***********************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-6e39faff","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./TopNotice.vue */ 760)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./TopNotice.vue */ 761),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6e39faff","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./TopNotice.vue */ 767),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 258 */
/*!************************************************!*\
  !*** ./src/components/homepage/MidNotices.vue ***!
  \************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-3c3a9b31","scoped":false,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MidNotices.vue */ 768)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MidNotices.vue */ 769),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3c3a9b31","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MidNotices.vue */ 770),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 259 */
/*!****************************!*\
  !*** ./src/api/academy.js ***!
  \****************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getGoodCoursesList = exports.readAnnounnce = exports.getAnnounceDetail = exports.getTags = exports.getAnnounces = exports.getBannerImgs = undefined;

var _axios = __webpack_require__(/*! axios */ 12);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getBannerImgs = exports.getBannerImgs = function getBannerImgs(params) {
    return _axios2.default.get('/trip-notify/acc/decorate/special', { params: Object.assign({ servicePlatform: 1, placements: 7 }, params) }).then(function (response) {
        var data = response.data;
        if (data) {
            data.forEach(function (item) {
                item.decorateContent = item.decorateContent.replace('http://', 'https://');
            });
        }
        return response;
    });
};

var getAnnounces = exports.getAnnounces = function getAnnounces(params) {
    return _axios2.default.get('/trip-notify/acc/announces', { params: Object.assign({ servicePlatform: 1, publishType: 5, page: 1, pageCount: 100 }, params) }).then(function (response) {
        var data = response.data;
        if (data) {
            data.forEach(function (item) {
                if (item.coverPic) {
                    item.coverPic = item.coverPic.replace('http://', 'https://');
                }
            });
        }
        return response;
    });
};

var getTags = exports.getTags = function getTags(params) {
    return _axios2.default.get('/trip-notify/acc/announce/contentTag', { params: Object.assign({ publishType: 5 }, params) });
};

var getAnnounceDetail = exports.getAnnounceDetail = function getAnnounceDetail(id) {
    return _axios2.default.get('/trip-notify/acc/announces/' + id).then(function (response) {
        var data = response.data;
        if (data.contentText) {
            data.contentText = data.contentText.replace(/http:\/\//g, 'https://');
        }
        if (data.coverPic) {
            data.coverPic = data.coverPic.replace('http://', 'https://');
        }
        return response;
    });
};

var readAnnounnce = exports.readAnnounnce = function readAnnounnce(id) {
    return _axios2.default.post('/trip-notify/acc/stcs', { contentId: id, opType: 1 });
};

var getGoodCoursesList = exports.getGoodCoursesList = function getGoodCoursesList(params) {
    return _axios2.default.get('/trip-notify/acc/announces/courses', { params: Object.assign({ servicePlatform: 1, page: 1, pageCount: 5 }, params) });
};

/***/ }),
/* 260 */
/*!*****************************************************!*\
  !*** ./src/views/dataPlatform/serviceData/Main.vue ***!
  \*****************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-0c34d374","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Main.vue */ 789)
}
var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Main.vue */ 790),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-0c34d374","hasScoped":true}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Main.vue */ 799),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0c34d374",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 261 */
/*!**************************************************************!*\
  !*** ./src/views/newGtyDataCenter/customerSourceAnalyse.vue ***!
  \**************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-24189c8d","scoped":true,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./customerSourceAnalyse.vue */ 873)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./customerSourceAnalyse.vue */ 874),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-24189c8d","hasScoped":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./customerSourceAnalyse.vue */ 889),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-24189c8d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 262 */
/*!***********************************!*\
  !*** ./src/views/layout/Main.vue ***!
  \***********************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-cae76352","scoped":false,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Main.vue */ 906)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Main.vue */ 907),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-cae76352","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Main.vue */ 930),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 263 */
/*!**********************************!*\
  !*** ./src/config/menuConfig.js ***!
  \**********************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var rootRouteName = exports.rootRouteName = 'newHome';
var accountTypeMap = exports.accountTypeMap = {
    1: '主账号',
    2: '子账号'
};

/***/ }),
/* 264 */
/*!*******************************!*\
  !*** ./src/utils/lazyLoad.js ***!
  \*******************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function addStyle(url) {
    var doc = document;
    var link = doc.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('type', 'text/css');
    link.setAttribute('href', url);
    return addHtmlElement(link);
}

function addScript(url) {
    var doc = document;
    var script = doc.createElement('script');
    script.setAttribute('src', url);
    return addHtmlElement(script);
}

function addHtmlElement(ele) {
    return new Promise(function (resolve, reject) {
        if (ele) {
            var heads = document.getElementsByTagName('head');
            if (heads.length) {
                heads[0].appendChild(ele);
                ele.onload = function () {
                    setTimeout(function () {
                        resolve('loaded');
                    }, 10);
                };
                ele.onerror = function (err) {
                    reject(err);
                };
            }
        } else {
            reject('Parameters ele is illegal');
        }
    });
};

var loaded = [];

var addSources = exports.addSources = function addSources(sources) {
    return new Promise(function (resolve, reject) {
        if (sources && sources.length) {
            var promises = sources.map(function (sourceSrc) {
                if (loaded.includes(sourceSrc)) {
                    return Promise.resolve('loaded already');
                }
                if (/\.css$/.test(sourceSrc)) {
                    return addStyle(sourceSrc);
                } else if (/\.js$/.test(sourceSrc)) {
                    return addScript(sourceSrc);
                } else {
                    return Promise.reject('not supported extension');
                }
            });
            Promise.all(promises).then(function () {
                loaded = loaded.concat(sources);
                resolve(sources.join('\n') + ' loaded!');
            }).catch(function (err) {
                Owl.addError('lazyLoadError', {
                    level: 'info',
                    combo: false,
                    tags: err
                });
                reject(err);
                window.alert('加载资源失败，请刷新网页');
            });
        } else {
            reject('Paramters sources is illegal');
        }
    });
};

/***/ }),
/* 265 */
/*!**********************************!*\
  !*** ./src/api/gtyDataCenter.js ***!
  \**********************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getGtyData = exports.getHistoryData = exports.getReserveData = exports.getDataTable = undefined;

var _axios = __webpack_require__(/*! axios */ 12);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDataTable = exports.getDataTable = function getDataTable(queryParms) {
    return _axios2.default.get('/meilv-group-travel/scs/account/data-analysis/deal-overview', {
        params: queryParms
    });
};

var getReserveData = exports.getReserveData = function getReserveData(queryParms) {
    return _axios2.default.get('/meilv/trade/ticket/merchant/api/data/reserve_count/v1');
};

var getHistoryData = exports.getHistoryData = function getHistoryData(queryParms) {
    return _axios2.default.get('/meilv/trade/ticket/merchant/api/data/history/v1', {
        params: queryParms
    });
};

var getGtyData = exports.getGtyData = function getGtyData(queryParms) {
    return _axios2.default.get('/meilv-group-travel/scs/account/data-analysis/operation-overview', {
        params: queryParms
    });
};

/***/ }),
/* 266 */
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(/*! ./promise-polyfill */ 267);

__webpack_require__(/*! ./polyfills */ 271);

var _vue = __webpack_require__(/*! vue */ 30);

var _vue2 = _interopRequireDefault(_vue);

__webpack_require__(/*! config/api.conf */ 426);

var _turboUi = __webpack_require__(/*! @hfe/turbo-ui */ 446);

var _turboUi2 = _interopRequireDefault(_turboUi);

__webpack_require__(/*! @hfe/turbo-ui/dist/turbo.min.css */ 447);

__webpack_require__(/*! styles/base.pcss */ 448);

var _app = __webpack_require__(/*! ./app */ 449);

var _vueClipboard = __webpack_require__(/*! vue-clipboard2 */ 1011);

var _vueClipboard2 = _interopRequireDefault(_vueClipboard);

var _player = __webpack_require__(/*! components/Player/player */ 1020);

var _player2 = _interopRequireDefault(_player);

var _orders = __webpack_require__(/*! components/ConfirmOrders/orders */ 1022);

var _orders2 = _interopRequireDefault(_orders);

var _TitleMessager = __webpack_require__(/*! components/TitleMessager/TitleMessager */ 1026);

var _TitleMessager2 = _interopRequireDefault(_TitleMessager);

__webpack_require__(/*! @hfe/paprika */ 1027);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_player2.default.install(_vue2.default);
_TitleMessager2.default.install(_vue2.default);
_vue2.default.use(_turboUi2.default);
window.Vue = _vue2.default;
_vue2.default.use(_vueClipboard2.default);
_vue2.default.component('OrdersInDialog', _orders2.default);

_app.app.$mount('#app');

/***/ }),
/* 267 */
/*!*********************************!*\
  !*** ./src/promise-polyfill.js ***!
  \*********************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _promisePolyfill = __webpack_require__(/*! promise-polyfill */ 268);

var _promisePolyfill2 = _interopRequireDefault(_promisePolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.Promise = window.Promise || _promisePolyfill2.default;

/***/ }),
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */
/*!**************************!*\
  !*** ./src/polyfills.js ***!
  \**************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(/*! core-js/es6/symbol */ 272);

__webpack_require__(/*! core-js/es6/object */ 276);

__webpack_require__(/*! core-js/es6/function */ 293);

__webpack_require__(/*! core-js/es6/parse-int */ 298);

__webpack_require__(/*! core-js/es6/parse-float */ 300);

__webpack_require__(/*! core-js/es6/number */ 302);

__webpack_require__(/*! core-js/es6/math */ 315);

__webpack_require__(/*! core-js/es6/string */ 333);

__webpack_require__(/*! core-js/es6/date */ 355);

__webpack_require__(/*! core-js/es6/array */ 362);

__webpack_require__(/*! core-js/es6/regexp */ 385);

__webpack_require__(/*! core-js/es6/map */ 388);

__webpack_require__(/*! core-js/es6/set */ 390);

__webpack_require__(/*! core-js/es6/weak-map */ 392);

__webpack_require__(/*! core-js/es6/weak-set */ 394);

__webpack_require__(/*! core-js/es6/typed */ 396);

__webpack_require__(/*! core-js/es6/reflect */ 408);

__webpack_require__(/*! core-js/es7/array */ 424);

/***/ }),
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */
/*!********************************!*\
  !*** ./src/config/api.conf.js ***!
  \********************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _env = __webpack_require__(/*! ./env.conf */ 2);

var _vue = __webpack_require__(/*! vue */ 30);

var _vue2 = _interopRequireDefault(_vue);

var _axios = __webpack_require__(/*! axios */ 12);

var _axios2 = _interopRequireDefault(_axios);

var _vueAxios = __webpack_require__(/*! vue-axios */ 445);

var _vueAxios2 = _interopRequireDefault(_vueAxios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// if (process.env.NODE_ENV !== 'production') {
//     axios.defaults.baseURL = '/'
// }
// 默认接口前缀
_axios2.default.defaults.baseURL = _env.apiHost + '/';

_axios2.default.defaults.withCredentials = true;
_axios2.default.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
_axios2.default.interceptors.response.use(function (response) {
    // Do something before request is sent
    if (response.data && Number(response.data.status) === 0) {
        return response.data;
    } else {
        return Promise.reject(response.data, response);
    }
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});
_vue2.default.use(_vueAxios2.default, _axios2.default);

/***/ }),
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */
/*!******************************!*\
  !*** ./src/styles/base.pcss ***!
  \******************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 449 */
/*!********************!*\
  !*** ./src/app.js ***!
  \********************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.store = exports.router = exports.app = undefined;

var _vue = __webpack_require__(/*! vue */ 30);

var _vue2 = _interopRequireDefault(_vue);

var _vuexRouterSync = __webpack_require__(/*! vuex-router-sync */ 450);

var _App = __webpack_require__(/*! ./components/App */ 451);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(/*! ./router */ 453);

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__(/*! ./store */ 107);

var _store2 = _interopRequireDefault(_store);

__webpack_require__(/*! filters */ 1007);

var _myValidate = __webpack_require__(/*! components/validate/myValidate */ 1010);

var _myValidate2 = _interopRequireDefault(_myValidate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_myValidate2.default);

/*
Validator.addLocale(zh);
const config = {
    locale: 'zh_CN'
};
Vue.use(VeeValidate, config)
*/

// import VeeValidate, {Validator} from 'vee-validate'
// import zh from 'vee-validate/dist/locale/zh_CN'
(0, _vuexRouterSync.sync)(_store2.default, _router2.default);

var app = new _vue2.default(Object.assign({
    router: _router2.default,
    store: _store2.default
}, _App2.default));

exports.app = app;
exports.router = _router2.default;
exports.store = _store2.default;

/***/ }),
/* 450 */,
/* 451 */
/*!*************************************!*\
  !*** ./src/components/App/index.js ***!
  \*************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(/*! ./style.css */ 452);

exports.default = {
    data: function data() {
        return {};
    },
    render: function render(h) {
        return h(
            'div',
            {
                attrs: { id: 'app' }
            },
            [h(
                'router-view',
                null,
                []
            )]
        );
    }
};

/***/ }),
/* 452 */
/*!**************************************!*\
  !*** ./src/components/App/style.css ***!
  \**************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 453 */
/*!*****************************!*\
  !*** ./src/router/index.js ***!
  \*****************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(/*! vue */ 30);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(/*! vue-router */ 454);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _axios = __webpack_require__(/*! axios */ 12);

var _axios2 = _interopRequireDefault(_axios);

var _store = __webpack_require__(/*! ../store */ 107);

var _store2 = _interopRequireDefault(_store);

var _router = __webpack_require__(/*! ./router.config */ 226);

var _router2 = _interopRequireDefault(_router);

var _env = __webpack_require__(/*! ../config/env.conf */ 2);

var _lazyLoad = __webpack_require__(/*! utils/lazyLoad */ 264);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var router = new _vueRouter2.default({
    mode: 'hash',
    routes: _router2.default
});
var isMisPage = false;

var lazyLoadUrls = ['//awp-assets.meituan.net/hfe/fep/6b4b3a87958e7f26a37bfa9206f0cac1/notpxigua.min.js', '//awp-assets.meituan.net/hfe/fep/9d93eed949585a53c7c19106e292e800/xiguaStyle.52e08ec97b8608c6c8861175e2cf58da.css', '//awp-assets.meituan.net/hfe/fep/ee42594ba27c859a9d2ef2b44be15fc3/notpecharts.min.js'];

function routeBeforeHooks(to, from, next) {
    isMisPage = to.meta.isMis;
    baiduAnalytics(to);
    _store2.default.dispatch('updatePageAccountType', isMisPage ? 'mis' : 'biz');
    // 如果是mis账号操作
    if (isMisPage) {
        if (to.meta.noAuth) {
            next();
            return;
        }
        _store2.default.dispatch('getMisUser').then(function (data) {
            next();
        }).catch(function () {
            // 未登录
            var url = encodeURIComponent(window.location.href);
            var settoken = '' + location.protocol + _env.misApiHost + '/tbms/api/v1/settoken?continue=' + url;
            var service = encodeURIComponent(settoken);
            window.location.href = _env.misSSOUrl + '/auth?service=' + service;
        });
    } else {
        //
        if (to.meta.noUser) {
            next();
            return;
        }
        //
        _store2.default.dispatch('getUser').then(function (data) {
            if (to.meta.noAuth) {
                next();
                return;
            }
            if (to.path === '/' || _store2.default.state.sfCustoms.check(to.path)) {
                next();
            } else {
                next({ name: 'unauthorized' });
            }
        }).catch(function () {
            _store2.default.dispatch('updateBeforeLogin', to);
            next({ path: '/login' });
        });
    }
}
//
router.beforeEach(function (to, from, next) {
    // ...
    if (!window.extraResourcesLoaded) {
        if (to.name && /home$/i.test(to.name) || to.meta && to.meta.src && to.meta.src.includes(_env.otpHost)) {
            routeBeforeHooks(to, from, next);
        } else {
            (0, _lazyLoad.addSources)(lazyLoadUrls).then(function () {
                window.xigua.install(window.Vue);
                routeBeforeHooks(to, from, next);
                window.extraResourcesLoaded = true;
            }).catch(function (err) {
                console.error(err);
            });
        }
    } else {
        routeBeforeHooks(to, from, next);
    }
});

_axios2.default.interceptors.request.use(function (config) {
    // Do something before request is sent
    // if role is bd, then switch api to sankuai domain
    if (config.params && config.params.apiRole === 'auto' && isMisPage) {
        config.url = config.url.replace(_env.apiHost, _env.misApiHost);
    }
    if (config.params && config.params.apiRole) {
        delete config.params.apiRole;
    }
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

window.router = router;
exports.default = router;


function baiduAnalytics(to) {
    if (window._hmt) {
        window._hmt.push(['_trackPageview', '/notp' + to.fullPath]);
    }
}

/***/ }),
/* 454 */,
/* 455 */
/*!******************************!*\
  !*** ./src/store/actions.js ***!
  \******************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setCount = exports.getCount = exports.incrementAsync = exports.updateBeforeLogin = exports.updatePageAccountType = exports.doLogout = exports.getMisUser = exports.getUser = undefined;

var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ 22);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(/*! babel-runtime/helpers/asyncToGenerator */ 23);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _mutationTypes = __webpack_require__(/*! ./mutation-types */ 222);

var types = _interopRequireWildcard(_mutationTypes);

var _common = __webpack_require__(/*! api/common */ 223);

var _tripNotify = __webpack_require__(/*! api/tripNotify.js */ 73);

var _getters = __webpack_require__(/*! ./getters */ 224);

var getters = _interopRequireWildcard(_getters);

var _SimplePermissions = __webpack_require__(/*! Auth/SimplePermissions */ 482);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// for count api
var ls = null;
var LSKey = 'NOTP-AJAX-COUNT';
try {
    var test = '__localstorage-test__';
    window.localStorage.setItem(test, test);
    window.localStorage.removeItem(test);
    ls = window.localStorage;
} catch (e) {
    if (Owl) {
        Owl.addError('Local storage is not supported', {
            level: 'info',
            combo: false
        });
    }
}

var getUser = exports.getUser = function getUser(_ref, force) {
    var commit = _ref.commit,
        state = _ref.state,
        dispatch = _ref.dispatch;

    var user = getters.account(state);
    if (!force && user.id) {
        return user;
    }
    return (0, _common.getUserInfo)().then(function (result) {
        commit(types.SET_BIZ_USER_INFO, result.data);
        var customs = _SimplePermissions.CustomsBuilder.buildCustoms(result.data.authBizlineInfos);
        commit(types.SET_CUSTOMS, customs);
        return result.data;
    });
};

var getMisUser = exports.getMisUser = function getMisUser(_ref2, force) {
    var commit = _ref2.commit,
        state = _ref2.state,
        dispatch = _ref2.dispatch;

    if (!force && state.misUser.id) {
        return state.misUser;
    }
    return (0, _common.getMisUserInfo)().then(function (data) {
        commit(types.SET_MIS_USER_INFO, data);
        return data;
    });
};

var doLogout = exports.doLogout = function doLogout(_ref3) {
    var commit = _ref3.commit,
        state = _ref3.state,
        dispatch = _ref3.dispatch;

    return (0, _common.logout)().then(function (data) {
        commit(types.CLEAR_USER_INFO);
    });
};

var updatePageAccountType = exports.updatePageAccountType = function updatePageAccountType(_ref4, type) {
    var commit = _ref4.commit,
        state = _ref4.state,
        dispatch = _ref4.dispatch;

    commit(types.SET_PAGE_ACCOUNT_TYPE, type);
};

var updateBeforeLogin = exports.updateBeforeLogin = function updateBeforeLogin(_ref5, target) {
    var commit = _ref5.commit,
        state = _ref5.state,
        dispatch = _ref5.dispatch;

    commit(types.SET_FROM_PAGE, target);
};

// for counter demo
var incrementAsync = exports.incrementAsync = function incrementAsync(_ref6) {
    var commit = _ref6.commit;

    setTimeout(function () {
        commit('INCREMENT');
    }, 200);
};

// 消息系统
var getCount = exports.getCount = function () {
    var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(_ref7) {
        var commit = _ref7.commit;
        var now, time, response;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        if (!(navigator && navigator.onLine === false)) {
                            _context.next = 2;
                            break;
                        }

                        return _context.abrupt('return', true);

                    case 2:
                        if (!ls) {
                            _context.next = 9;
                            break;
                        }

                        now = new Date().getTime();

                        if (!ls[LSKey]) {
                            _context.next = 8;
                            break;
                        }

                        time = ls[LSKey];

                        if (!(now - time < 25 * 1000)) {
                            _context.next = 8;
                            break;
                        }

                        return _context.abrupt('return', true);

                    case 8:
                        ls.setItem(LSKey, now);

                    case 9:
                        _context.prev = 9;
                        _context.next = 12;
                        return (0, _tripNotify.getNotifyCount)();

                    case 12:
                        response = _context.sent;

                        commit(types.SET_TRIP_NOTIFY, response.data);
                        _context.next = 21;
                        break;

                    case 16:
                        _context.prev = 16;
                        _context.t0 = _context['catch'](9);

                        if (Owl) {
                            Owl.addError('Message Count Error ' + (_context.t0.status === 1 ? '- not login' : '- other'), {
                                level: 'info',
                                combo: false,
                                tags: { message: _context.t0.message }
                            });
                        }

                        if (!(_context.t0.status === 1)) {
                            _context.next = 21;
                            break;
                        }

                        return _context.abrupt('return', false);

                    case 21:
                        return _context.abrupt('return', true);

                    case 22:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined, [[9, 16]]);
    }));

    return function getCount(_x) {
        return _ref8.apply(this, arguments);
    };
}();

// webSocket 消息系统
var setCount = exports.setCount = function setCount(_ref9, data) {
    var commit = _ref9.commit;

    commit(types.SET_TRIP_NOTIFY, data);
    if (ls) {
        var now = new Date().getTime();
        ls.setItem(LSKey, now);
    }
};

/***/ }),
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */
/*!***************************************!*\
  !*** ./src/Auth/SimplePermissions.ts ***!
  \***************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var commonBizLines = [
    {
        name: 'open-frame',
        SimplePermissions: ['/fe/purse/*']
    }, {
        name: 'open-presalechat',
        SimplePermissions: ['/fe/preSaleService/*']
    }, {
        name: 'open-info',
        SimplePermissions: ['/fe/info/*']
    }
];
var BizLineMap = { 'open-jingjiu': 'jiujing', 'open-jijiu': 'jijiu', 'open-cheliang': 'chepiao', 'open-gentuanyou': 'gty', 'lvyou-ticket': 'ticket', 'open-wenchuang': 'wenchuang' };
var bizLineCommonMenus = ['academy', 'policyrule'];
var bizLinePrivateMenus = { 'lvyou-ticket': ['ticketold/*'] };
var permissionPreFix = '/fe/';
var fePermissionReg = /^\/fe\/.*/;
var SimplePermissions = (function () {
    function SimplePermissions(bizLineAuthInfos) {
        this.bizLineAuthInfos = bizLineAuthInfos;
        this.addCommonLines();
    }
    SimplePermissions.prototype.addCommonLines = function () {
        var _this = this;
        if (this.bizLineAuthInfos && this.bizLineAuthInfos.length) {
            this.bizLineAuthInfos.forEach(function (line) {
                var bizLineName = line.bizline;
                var linePath = BizLineMap[bizLineName];
                if (linePath && line.simplePermissions && line.simplePermissions.length) {
                    var preFix_1 = permissionPreFix + linePath + '/';
                    bizLineCommonMenus.forEach(function (menuPath) {
                        line.simplePermissions.push(preFix_1 + menuPath);
                    });
                    var privateMenus = bizLinePrivateMenus[bizLineName];
                    if (privateMenus && privateMenus.length) {
                        privateMenus.forEach(function (menuPath) {
                            line.simplePermissions.push(permissionPreFix + menuPath);
                        });
                    }
                }
            });
            commonBizLines.forEach(function (line) {
                _this.bizLineAuthInfos.push({
                    bizline: line.name,
                    simplePermissions: line.SimplePermissions
                });
            });
        }
    };
    SimplePermissions.prototype.getPermissions = function () {
        var result = [];
        this.bizLineAuthInfos.forEach(function (bizLineInfo) {
            var simplePermissions = bizLineInfo.simplePermissions || [];
            simplePermissions.filter(function (permission) {
                if (fePermissionReg.test(permission)) {
                    if (!result.includes(permission)) {
                        result.push(permission);
                    }
                }
            });
        });
        return result;
    };
    return SimplePermissions;
}());
var WILD_CARD = '*';
var PathNode = (function () {
    function PathNode(name) {
        if (name !== WILD_CARD) {
            this.children = {};
        }
        else {
            this.children = null;
        }
    }
    return PathNode;
}());
var PermissionTree = (function () {
    function PermissionTree(permissions) {
        var _this = this;
        this.permissions = permissions;
        this.rootNode = new PathNode('');
        permissions.forEach(function (urlPattern) {
            var pathSegments = urlPattern.substring(3, urlPattern.length).split('/');
            var currentNode = _this.rootNode;
            for (var depth = 1; depth < pathSegments.length; ++depth) {
                if (!currentNode.children) {
                    break;
                }
                var pathName = pathSegments[depth];
                if (!currentNode.children[pathName]) {
                    currentNode.children[pathName] = new PathNode(pathName);
                }
                currentNode = currentNode.children[pathName];
            }
        });
    }
    return PermissionTree;
}());
var Customs = (function () {
    function Customs(permissionTree) {
        this.permissionTree = permissionTree;
    }
    Customs.prototype.check = function (path) {
        var paths = path.split('/');
        var currentNode = this.permissionTree.rootNode;
        for (var i = 1; i < paths.length; ++i) {
            var currentPath = paths[i];
            if (!currentNode.children) {
                return false;
            }
            if (currentNode.children[WILD_CARD]) {
                return true;
            }
            if (!currentNode.children[currentPath]) {
                return false;
            }
            currentNode = currentNode.children[currentPath];
        }
        return true;
    };
    return Customs;
}());
var CustomsBuilder = (function () {
    function CustomsBuilder() {
    }
    CustomsBuilder.buildCustoms = function (bizLineAuthInfos) {
        var sPermission = new SimplePermissions(bizLineAuthInfos);
        var permissionTree = new PermissionTree(sPermission.getPermissions());
        return new Customs(permissionTree);
    };
    return CustomsBuilder;
}());
exports.CustomsBuilder = CustomsBuilder;


/***/ }),
/* 483 */
/*!********************************!*\
  !*** ./src/store/mutations.js ***!
  \********************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(/*! babel-runtime/helpers/defineProperty */ 114);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _types$SET_BIZ_USER_I;

var _mutationTypes = __webpack_require__(/*! ./mutation-types */ 222);

var types = _interopRequireWildcard(_mutationTypes);

var _router = __webpack_require__(/*! router/router.config */ 226);

var _router2 = _interopRequireDefault(_router);

var _menu = __webpack_require__(/*! utils/menu */ 170);

var _message = __webpack_require__(/*! ./modules/message */ 1005);

var _message2 = _interopRequireDefault(_message);

var _neixin = __webpack_require__(/*! utils/neixin */ 1006);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 在此维护消息系统的单例
var messsage = new _message2.default();

exports.default = (_types$SET_BIZ_USER_I = {}, (0, _defineProperty3.default)(_types$SET_BIZ_USER_I, types.SET_BIZ_USER_INFO, function (state, payload) {
    var authBizlineInfos = payload.authBizlineInfos;

    state.bizAuthInfo = authBizlineInfos;
    var rootRoute = (0, _menu.getRootRoute)(_router2.default);
    (0, _neixin.redirectToNeiXin)(payload);
    if (rootRoute && rootRoute.children && rootRoute.children.length) {
        var accountRoute = rootRoute.children.find(function (childRoute) {
            return childRoute.path === 'account';
        });
        var routeName = 'subAccount';
        if (payload.accountType === 1) {
            routeName = 'adminAccount';
        }
        if (accountRoute && accountRoute.children) {
            var accountMenuRoute = accountRoute.children.find(function (childRoute) {
                return childRoute.name === routeName;
            });
            accountMenuRoute.meta.notMenu = false;
        }
    }
    if (payload) {
        payload.id = payload.userId;
        payload.name = payload.userName;
        state.bizUser = payload;
    }
}), (0, _defineProperty3.default)(_types$SET_BIZ_USER_I, types.SET_MIS_USER_INFO, function (state, payload) {
    state.misUser = Object.assign(state.misUser, payload);
}), (0, _defineProperty3.default)(_types$SET_BIZ_USER_I, types.SET_PAGE_ACCOUNT_TYPE, function (state, payload) {
    state.pageAccountType = payload || 'biz';
}), (0, _defineProperty3.default)(_types$SET_BIZ_USER_I, types.CLEAR_USER_INFO, function (state) {
    // clear cart
    state.bizUser = {};
    state.bizAuthInfo = {};
    state.sfCustoms = null;
}), (0, _defineProperty3.default)(_types$SET_BIZ_USER_I, types.SET_FROM_PAGE, function (state, payload) {
    // clear cart
    if (payload) {
        state.fromPage = payload;
    }
}), (0, _defineProperty3.default)(_types$SET_BIZ_USER_I, types.SET_CUSTOMS, function (state, payload) {
    if (payload) {
        state.sfCustoms = payload;
    }
}), (0, _defineProperty3.default)(_types$SET_BIZ_USER_I, types.SET_TRIP_NOTIFY, function (state, data) {
    // 3f的系统，只有商家登录
    var userId = state.bizUser.id;
    var res = messsage.updateUnread(userId, data);
    if (res) {
        state.unreadMap = res;
    }
}), _types$SET_BIZ_USER_I);

/***/ }),
/* 484 */,
/* 485 */,
/* 486 */
/*!*************************************!*\
  !*** ./src/router/router.ticket.js ***!
  \*************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Created by xuxin06@meituan.com on 2017/7/24.
 */
var notMenu = true;
exports.default = [{
    name: 'misCreateTicket',
    path: '/mis/ticket/product/item/:id?',
    component: __webpack_require__(/*! views/ticket/product/item/Main.vue */ 227),
    meta: {
        isMis: true,
        notMenu: notMenu
    }
}, {
    name: 'bizCreateTicket',
    path: 'product/item/:id?',
    component: __webpack_require__(/*! views/ticket/product/item/Main.vue */ 227),
    meta: {
        notMenu: notMenu
    }
}, {
    name: 'misCreateTuanTicket',
    path: '/mis/ticket/tuan/item/:id?',
    component: __webpack_require__(/*! views/ticket/product/tuan/Main.vue */ 584),
    meta: {
        isMis: true,
        notMenu: notMenu
    }
}, {
    name: 'phoneVerify',
    path: 'phoneVerify',
    redirect: { name: 'app' },
    meta: {
        title: '手机验证',
        notMenu: notMenu
    },
    component: __webpack_require__(/*! views/ticket/verify/phone/Main.vue */ 238),
    children: [{
        name: 'phone',
        path: 'phone',
        component: __webpack_require__(/*! views/ticket/verify/phone/pages/phoneVerify.vue */ 239)
    }, {
        name: 'app',
        path: 'app',
        component: __webpack_require__(/*! views/ticket/verify/phone/pages/appVerify.vue */ 240)
    }]
}, {
    name: 'verifyHistory',
    path: 'verifyHistory',
    redirect: { name: 'singleProgram' },
    component: __webpack_require__(/*! views/ticket/verify/history/Main.vue */ 241),
    meta: {
        title: '验证历史',
        requiresAuth: true,
        isOpened: null,
        notMenu: notMenu
    },
    children: [{
        name: 'singleProgram',
        path: 'singleProgram',
        component: __webpack_require__(/*! views/ticket/verify/history/pages/singleProgramConsumption.vue */ 242)
    }, {
        name: 'allProgram',
        path: 'allProgram',
        component: __webpack_require__(/*! views/ticket/verify/history/pages/allProgramConsumption.vue */ 243)
    }]
}, {
    name: 'programData',
    path: 'views/dataCenter/programData',
    component: __webpack_require__(/*! views/dataCenter/programData.vue */ 610),
    meta: {
        notMenu: notMenu
    }
}, {
    name: 'operationData',
    path: 'views/dataCenter/operationData',
    component: __webpack_require__(/*! views/dataCenter/operationData.vue */ 244),
    meta: {
        notMenu: notMenu
    }
}];

/***/ }),
/* 487 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-750bbfee","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/ticket/product/item/Main.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 488 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-750bbfee","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/ticket/product/item/Main.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 489 */
/*!*******************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/ticket/product/item/Main.vue ***!
  \*******************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(/*! vue */ 30);

var _vue2 = _interopRequireDefault(_vue);

var _ticketDraft = __webpack_require__(/*! helpers/ticketDraft */ 490);

var _ticketDraft2 = _interopRequireDefault(_ticketDraft);

var _vuex = __webpack_require__(/*! vuex */ 14);

var _Instruction = __webpack_require__(/*! ./Instruction.vue */ 228);

var _Instruction2 = _interopRequireDefault(_Instruction);

var _Info = __webpack_require__(/*! ./Info.vue */ 229);

var _Info2 = _interopRequireDefault(_Info);

var _Price = __webpack_require__(/*! ./Price.vue */ 235);

var _Price2 = _interopRequireDefault(_Price);

var _preview = __webpack_require__(/*! components/product/preview.vue */ 569);

var _preview2 = _interopRequireDefault(_preview);

var _teHuiApply = __webpack_require__(/*! components/product/teHuiApply.vue */ 573);

var _teHuiApply2 = _interopRequireDefault(_teHuiApply);

var _ticket = __webpack_require__(/*! api/ticket */ 50);

var _messageBox = __webpack_require__(/*! components/messagebox-custom/message.box.js */ 577);

var _messageBox2 = _interopRequireDefault(_messageBox);

var _defaultModel = __webpack_require__(/*! ../common/defaultModel */ 159);

var _defaultModel2 = _interopRequireDefault(_defaultModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _messageBox2.default)(_vue2.default); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var history = window.history;

exports.default = {
    components: {
        Instruction: _Instruction2.default,
        Info: _Info2.default,
        Price: _Price2.default,
        Preview: _preview2.default,
        TeHuiApply: _teHuiApply2.default
    },
    data: function data() {
        return {
            entryTime: '',
            teHuiOption: null,
            teHuiShow: false,
            previewShowTrigger: '',
            loading: false,
            id: '',
            errors: [],
            model: {},
            activeIndex: '1',
            tabs: [{
                name: 'basicInfoForm',
                status: false
            }, {
                name: 'orderInfoForm',
                status: false
            }, {
                name: 'priceStockForm',
                status: false
            }],
            mode: 'edit',
            showErrorOnTabs: false,
            userinfo: false,
            ls: false, //localstorage
            modelLoaded: false
        };
    },

    computed: Object.assign({}, (0, _vuex.mapGetters)(['account']), {
        // 获取其他非deal的信息
        extra: function extra() {
            var DirectDealIDs = [2, // 直连V2
            4, // 直连V1
            5];
            return {
                partnerDealId: this.model.partnerDealId,
                // 是否是直签商家， true是，false为三方
                isDirect: this.account.directSign > 0,
                // 是否直连产品
                isDirectDeal: this.model.sourceType && DirectDealIDs.indexOf(this.model.sourceType) !== -1 || this.$route.query.isDirectDeal === 'true',
                // 是否是bd上单模板
                isBD: this.$route.meta.isMis,
                contractNum: this.$route.query.contractNum || this.model.contractNum,
                contractId: this.$route.query.contractId || this.model.contractId,
                supplierId: this.$route.query.supplierId || this.account.supplierId,
                isNew: (!this.id || this.mode === 'copy') && !this.model.mtDealId
            };
        },
        previewUrl: function previewUrl() {
            if (this.mode === 'edit' && this.previewShowTrigger) {
                return 'https://i.meituan.com/awp/h5/lvyou/deal/ticket/detail/index.html?dealId=' + this.id + '&type=offline&time=' + this.previewShowTrigger;
            } else {
                return '';
            }
        }
    }),
    watch: {
        '$route': 'initProduct',
        activeIndex: function activeIndex() {
            window.scrollTo && window.scrollTo(0, 0);
        },

        model: {
            handler: function handler(val, oldVal) {},
            deep: true
        }
    },
    methods: Object.assign({}, (0, _vuex.mapActions)(['login', 'getUser']), {
        initProduct: function initProduct() {
            var _this = this;

            var id = this.$route.params.id;
            this.id = id;
            var isMis = this.$route.meta.isMis;
            var supportModes = ['new', 'edit', 'copy', 'readonly'];
            if (supportModes.indexOf(this.$route.query.mode) > -1) {
                this.mode = this.$route.query.mode;
            } else {
                this.mode = id ? 'edit' : 'new';
            }

            if (id) {
                this.loading = true;
                (0, _ticket.get)(id).then(function (json) {
                    _this.loading = false;
                    _this.model = (0, _defaultModel2.default)(_this.extra.isDirectDeal, _this.mode === 'copy', json.data);
                    _this.checkDataStatus(_this.model);
                    _this.updateMsRatio();
                    if (_this.mode !== 'new') {
                        _this.checkDraft();
                    }
                    // 出现垃圾数据，直连出票方式写死成3
                    if (_this.extra.isDirectDeal) {
                        _this.model.generateTicketMethod = 3;
                    }
                }).catch(function (response) {
                    _this.loading = false;
                    _this.$message.error(response && response.message);
                    _this.model = (0, _defaultModel2.default)(_this.extra.isDirectDeal, _this.mode === 'copy');
                });
                if (!isMis) {
                    var supplierId = this.$route.query.supplierId;
                    if (supplierId) {}
                }
            } else {
                this.mode = 'new';
                this.model = (0, _defaultModel2.default)(this.extra.isDirectDeal, this.mode === 'copy');
            }
        },
        updateMsRatio: function updateMsRatio() {
            var _this2 = this;

            if (this.model.ticketCategory.poi) {
                var mdcPoiIds = [];
                this.model.ticketCategory.poi.map(function (item, index) {
                    mdcPoiIds.push(item.mdcPoiId);
                    return item;
                });
                this.model.mdcPoiIds = mdcPoiIds.join(',');
            } else {
                this.model.ticketCategory.poi = [];
            }
            if (this.model.mdcPoiIds && this.model.mtCategory) {
                (0, _ticket.getMsRatio)(this.model.mdcPoiIds, this.model.mtCategory, this.extra.supplierId).then(function (result) {
                    if (result && result.data) {
                        var data = result.data;
                        _this2.model.baseMsRatioSnapshot = data.maxMsRatio;
                        _this2.model.maxMsRatioProvinceName = data.maxMsRatioProvinceName;
                        _this2.model.provinceLocationIdsSnapshot = data.provinceLocationIdsSnapshot;
                    }
                });
            } else {
                this.model.baseMsRatioSnapshot = 0;
                this.model.maxMsRatioProvinceName = '';
                this.model.provinceLocationIdsSnapshot = [];
            }
        },
        tabChange: function tabChange(tab) {
            var _this3 = this;

            var lastActiveIndex = this.activeIndex;
            this.activeIndex = tab.key;
            // 剧场票只能BD查看
            if (!this.extra.isBD && tab.key === '3' && this.model.IAmTheatre) {
                this.$message.info('剧场票场次及席位信息，请联系您的BD进行查看和修改；');
                this.$nextTick(function () {
                    _this3.activeIndex = lastActiveIndex;
                });
                return;
            }
        },
        prevStep: function prevStep() {
            var current = parseInt(this.activeIndex);
            if (current === 1) {
                return;
            }
            var index = current - 1;
            this.activeIndex = index.toString();
        },
        nextStep: function nextStep() {
            var current = parseInt(this.activeIndex);
            console.log(this.errors[0]);
            if (this.errors[0].items && this.errors[0].items['tab' + current] && this.errors[0].items['tab' + current].length > 0) {
                this.errors[0].showAllError('tab' + current);
                return;
            }

            if (this.tabs && current === this.tabs.length) {
                return;
            }
            var index = current + 1;
            // 剧场票只能BD查看
            if (!this.extra.isBD && index === 3 && this.model.IAmTheatre) {
                this.$message.info('剧场票场次及席位信息，请联系您的BD进行查看和修改；');
                return;
            }
            this.activeIndex = index.toString();
        },
        checkDataStatus: function checkDataStatus(data) {
            var _this4 = this;

            if (data.checkStatus === 0 || data.msRatioCheckStatus === 0) {
                this.mode = 'readonly';
                this.$msgbox({
                    title: '撤销审核提示',
                    message: '您的deal正在审核，确认要撤销审核吗？撤销审核后您可以编辑您的产品，否则您只能查看产品',
                    confirmButtonText: '撤销',
                    cancelButtonText: '取消'
                }).then(function () {
                    (0, _ticket.cancelAudit)(_this4.id).then(function () {
                        _this4.$message.success('撤销审核成功');
                        _this4.mode = 'edit';
                    }).catch(function (response) {
                        _this4.$message.error(response.message || '撤销审核失败');
                    });
                }).catch(function () {
                    // window.close();
                });
            } else if (data.checkStatus === 4) {
                this.mode = 'readonly';
                this.$message.error('您的deal已被设为黑名单，无法编辑和提交审核。');
            }
        },
        prepareData: function prepareData(model) {
            var data = JSON.parse(JSON.stringify(model));
            if (parseInt(data.scheduleOfflineType, 10) === 1) {
                data.scheduleOfflineTime = null;
            }
            if (!data.includeItems || data.includeItems && data.includeItems.length <= 1) {
                data.isAllAvailable = undefined;
                data.availableCount = undefined;
            }
            if (data.useDateMode == 1 && data.stockType === 1) {
                data.dayPriceStockRules.forEach(function (item) {
                    item.stock = -1;
                });
            }
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = data.ticketPoiDiscounts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var crowd = _step.value;

                    if (!crowd.ticketDiscountList || crowd.ticketDiscountList.length === 1 && crowd.ticketDiscountList[0].crowd === null) {
                        crowd.ticketDiscountList = null;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (parseInt(data.useDateMode, 10) == 1 && this.extra.isDirectDeal && parseInt(data.refundType, 10) === 4 && !this.model.IAmTheatre) {
                data.stairsRefund = true;
                // 当阶梯退款只有一条，且退款为无限制的时候，使用外面的退款规则
                // 阶梯退款不应该存在无限制，以防万一还是遍历所有数据
                var foundTimeTypeZero = false;
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = data.refundStairsRules[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var rule = _step2.value;

                        if (parseInt(rule.refundTimeType, 10) === 0) {
                            foundTimeTypeZero = true;
                            break;
                        }
                    }
                    // 有0 或者只有一条，不使用阶梯数据
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                if (foundTimeTypeZero || data.refundStairsRules.length === 1) {
                    var firstStair = data.refundStairsRules[0];
                    data.refundFee = firstStair.refundFee;
                    data.refundFeeMode = firstStair.refundFeeMode;
                    data.refundTimeType = firstStair.refundTimeType;
                    if (data.refundTimeType > 0) {
                        data.refundLimitDays = firstStair.aheadDays;
                        data.refundLimitHours = firstStair.hours;
                        data.refundLimitMinutes = firstStair.minutes;
                    }

                    data.stairsRefund = false;
                }
            } else {
                data.stairsRefund = false;
            }
            // 退款数据清洗，先放在这，之后移到组件中
            if (this.extra.isDirectDeal) {
                if (data.refundType === 1) {
                    if (data.useDateMode >= 3 && !data.canRefundCurrentDate) {
                        data.canRefundCurrentDate = true;
                    }
                } else {
                    var refundAfterCount = 0;
                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                        for (var _iterator3 = data.refundStairsRules[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var _rule = _step3.value;

                            if (_rule.refundTimeType === 3) {
                                // eslint-disable-line
                                refundAfterCount++;
                            }
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }
                        } finally {
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }

                    if (refundAfterCount) {
                        if (data.useDateMode >= 3 && !data.canRefundCurrentDate) {
                            data.canRefundCurrentDate = true;
                        }
                    } else {
                        data.canRefundCurrentDate = true;
                    }
                }
                data.canRefundCurrentDate = data.canRefundCurrentDate.toString();
            }
            // 所有直连，sourcetype改成5
            if (this.extra.isDirectDeal) {
                data.sourceType = 5;
                if (this.model.IAmTheatre) {
                    data.needSpecialAuthFile = false;
                }
            }
            // 保存的时候以防万一，再处理一次垃圾数据
            if (this.extra.isDirectDeal) {
                data.generateTicketMethod = 3;
            }
            return data;
        },
        doSave: function doSave() {
            var _this5 = this;

            var data = this.prepareData(this.model);
            if (this.mode === 'edit') {
                var id = this.model.id || this.id;
                return (0, _ticket.update)(id, data).then(function () {
                    return id;
                }, function (result) {
                    if (result.status === 9) {
                        result.message = '保存失败';
                    }
                    throw result;
                });
            }
            return (0, _ticket.create)(data).then(function (response) {
                var dealId = response.data && response.data.dealId || response.data;
                _this5.id = dealId;
                return dealId;
            }, function (result) {
                if (result.status === 9) {
                    _this5.mode = 'edit';
                    _this5.id = result.data;
                    _this5.model.id = _this5.id;
                    result.message = '保存失败';
                }
                throw result;
            });
        },
        saveModel: function saveModel() {
            var _this6 = this;

            var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            if (this.doHaveErrors()) {
                return;
            }

            // 暂时先复制一份，之后优化
            if (this.hasProtocolButNotUsed()) {
                var that = this;
                this.$confirm({
                    title: '提示',
                    message: '该供应商有签订返佣/包票补充协议，但是该deal并没有关联其补充协议，确定不关联吗？',
                    confirmButtonText: '去关联',
                    cancelButtonText: '不关联，继续保存'
                }).then(function (data) {
                    that.$refs.info.$refs.supplierProtocol.connectProtocol = true;
                    that.$refs.info.$refs.supplierProtocol.changeConnect();
                    that.activeIndex = '1';
                }, function (err) {
                    return that.doSave().then(function (id) {
                        if (history && history.pushState) {
                            if (that.extra.isBD) {
                                var state = that.$router.resolve({ name: that.$route.name, query: { mode: 'edit', supplierId: that.extra.supplierId }, params: { id: id } });
                                history.pushState(null, 'notp', state.href);
                            } else {
                                var _state = that.$router.resolve({ name: that.$route.name, query: { mode: 'edit' }, params: { id: id } });
                                history.pushState(null, 'notp', _state.href);
                            }
                        }
                        // 清空草稿
                        var ls = that.getTicketDraftInstance();
                        if (ls) {
                            ls.clearDraft();
                        }
                        if (from !== 'preview') {
                            that.toListOrNot();
                        }
                        that.mode = 'edit';
                        return true;
                    }, function (result) {
                        var message = void 0;
                        if (result && result.message) {
                            message = result.message || '保存失败, 网络错误';
                        } else {
                            message = '保存失败, 网络错误';
                        }
                        that.$notify({
                            title: '提示',
                            message: message,
                            type: 'error'
                        });
                        // 协议绑定失败
                        if (result.status === 10) {
                            that.protocolFailed(result);
                        }
                        return false;
                    });
                });
            } else {
                return this.doSave().then(function (id) {
                    // this.$notify({
                    //    title: '提示',
                    //    message: '保存成功',
                    //    type: 'success'
                    // })
                    // console.log(id);
                    if (_this6.mode !== 'edit') {
                        var isCopy = _this6.mode === 'copy';
                        var endTime = new Date().getTime();
                        var actString = '\u4E0A\u62A5\u521B\u5EFA\u6E90' + (isCopy ? 'copydeal' : 'newcreate');
                        if (window.Analytics) {
                            window.Analytics('event', { // eslint-disable-line
                                nm: 'mge',
                                val: {
                                    cid: 'MTP上单成功页',
                                    act: actString,
                                    lab: {
                                        'start': _this6.entryTime,
                                        'end': endTime
                                    },
                                    val: id
                                } });
                        }
                    }
                    if (history && history.pushState) {
                        if (_this6.extra.isBD) {
                            var state = _this6.$router.resolve({ name: _this6.$route.name, query: { mode: 'edit', supplierId: _this6.extra.supplierId }, params: { id: id } });
                            history.pushState(null, 'notp', state.href);
                        } else {
                            var _state2 = _this6.$router.resolve({ name: _this6.$route.name, query: { mode: 'edit' }, params: { id: id } });
                            history.pushState(null, 'notp', _state2.href);
                        }
                    }
                    // 清空草稿
                    var ls = _this6.getTicketDraftInstance();
                    if (ls) {
                        ls.clearDraft();
                    }
                    if (from !== 'preview') {
                        _this6.toListOrNot();
                    }
                    _this6.mode = 'edit';
                    return true;
                }, function (result) {
                    var message = void 0;
                    if (result && result.message) {
                        message = result.message || '保存失败, 网络错误';
                    } else {
                        message = '保存失败, 网络错误';
                    }
                    // 协议绑定失败
                    if (result.status === 10) {
                        _this6.protocolFailed(result);
                    } else {
                        _this6.$notify({
                            title: '提示',
                            message: message,
                            type: 'error'
                        });
                    }
                    return false;
                });
            }
        },

        // 保存协议是在上单成功之后，为了防止过多的脏数据，如果是协议保存失败，则是变成编辑状态
        protocolFailed: function protocolFailed(result) {
            try {

                var message = result && result.message ? result.message : '关联失败';

                message = message.replace(/\n/g, '<br>');

                this.$alert_html({
                    title: '提示',
                    message: message,
                    showCancelButton: false,
                    closeOnClickModal: false,
                    confirmButtonText: '关闭'
                });
                this.activeIndex = '1';
                this.mode = 'edit';
                this.model.id = this.id = result.data.dealId;
                if (history && history.pushState) {
                    var state = this.$router.resolve({ name: this.$route.name, query: { mode: 'edit', supplierId: this.extra.supplierId }, params: { id: result.data.dealId } });
                    history.pushState(null, 'notp', state.href);
                }
                // 清空草稿
                var ls = this.getTicketDraftInstance();
                if (ls) {
                    ls.clearDraft();
                }
                if (from !== 'preview') {
                    this.toListOrNot();
                }
                this.mode = 'edit';
            } catch (e) {
                console.log(e.message);
            }
        },
        saveAndPreview: function saveAndPreview() {
            var _this7 = this;

            var savePromise = this.saveModel('preview');
            if (savePromise && savePromise.then) {
                savePromise.then(function (success) {
                    if (success) {
                        _this7.$message({
                            showClose: true,
                            message: '保存成功',
                            type: 'success',
                            duration: 2000
                        });
                        _this7.previewShowTrigger = new Date().getTime();
                    }
                });
            }
        },
        saveAndCheck: function saveAndCheck() {
            var _this8 = this;

            if (this.doHaveErrors()) {
                return;
            }
            this.tabs.forEach(function (tab) {
                tab.status = true;
            });
            if (this.hasProtocolButNotUsed()) {
                var that = this;
                this.$confirm({
                    title: '提示',
                    message: '该供应商有签订返佣/包票补充协议，但是该deal并没有关联其补充协议，确定不关联吗？',
                    confirmButtonText: '去关联',
                    cancelButtonText: '不关联，继续保存'
                }).then(function (data) {
                    that.$refs.info.$refs.supplierProtocol.connectProtocol = true;
                    that.$refs.info.$refs.supplierProtocol.changeConnect();
                    that.activeIndex = '1';
                }, function (err) {
                    that.doSave().then(function (id) {
                        if (parseInt(id) > 0) {
                            (0, _ticket.audit)(id).then(function () {
                                // 清空草稿
                                var ls = that.getTicketDraftInstance();
                                if (ls) {
                                    ls.clearDraft();
                                }
                                that.$msgbox({
                                    title: '提示',
                                    message: '提交审核成功',
                                    type: 'success',
                                    confirmButtonText: '返回产品列表',
                                    cancelButtonText: '确定'
                                }).then(function () {
                                    window.close();
                                });
                                if (that.extra.isBD) {
                                    (0, _ticket.tehuiCheck)(id).then(function (json) {
                                        if (json.data.isAllowApply) {
                                            var data = json.data;
                                            data.dealId = id;
                                            that.teHuiShow = true;
                                            that.teHuiOption = data;
                                        }
                                    }).catch(function (resp) {
                                        // 特惠票检查失败
                                    });
                                }
                                if (history && history.pushState) {
                                    if (that.extra.isBD) {
                                        var state = that.$router.resolve({ name: that.$route.name, query: { mode: 'edit', supplierId: that.extra.supplierId }, params: { id: id } });
                                        history.pushState(null, 'notp', state.href);
                                    } else {
                                        var _state3 = that.$router.resolve({ name: that.$route.name, query: { mode: 'edit' }, params: { id: id } });
                                        history.pushState(null, 'notp', _state3.href);
                                    }
                                }
                                that.mode = 'edit';
                            }, function (response) {
                                that.$notify({
                                    title: '提示',
                                    message: response && response.message,
                                    type: 'error'
                                });
                            });
                        }
                    }, function (response) {
                        that.$notify({
                            title: '提示',
                            message: response && response.message,
                            type: 'error'
                        });
                    });
                });
            } else {
                this.doSave().then(function (id) {
                    if (parseInt(id) > 0) {
                        (0, _ticket.audit)(id).then(function () {
                            // 清空草稿
                            var ls = _this8.getTicketDraftInstance();
                            if (ls) {
                                ls.clearDraft();
                            }
                            _this8.$msgbox({
                                title: '提示',
                                message: '提交审核成功',
                                type: 'success',
                                confirmButtonText: '返回产品列表',
                                cancelButtonText: '确定'
                            }).then(function () {
                                window.close();
                            });
                            if (_this8.extra.isBD) {
                                (0, _ticket.tehuiCheck)(id).then(function (json) {
                                    if (json.data.isAllowApply) {
                                        var data = json.data;
                                        data.dealId = id;
                                        _this8.teHuiShow = true;
                                        _this8.teHuiOption = data;
                                    }
                                }).catch(function (resp) {
                                    // 特惠票检查失败
                                });
                            }
                            if (history && history.pushState) {
                                if (_this8.extra.isBD) {
                                    var state = _this8.$router.resolve({ name: _this8.$route.name, query: { mode: 'edit', supplierId: _this8.extra.supplierId }, params: { id: id } });
                                    history.pushState(null, 'notp', state.href);
                                } else {
                                    var _state4 = _this8.$router.resolve({ name: _this8.$route.name, query: { mode: 'edit' }, params: { id: id } });
                                    history.pushState(null, 'notp', _state4.href);
                                }
                            }
                            _this8.mode = 'edit';
                        }, function (response) {
                            _this8.$notify({
                                title: '提示',
                                message: response && response.message || '提交审核失败!',
                                type: 'error'
                            });
                        });
                    }
                }, function (response) {
                    // 协议绑定失败
                    if (response.status === 10) {
                        _this8.protocolFailed(response);
                    } else {
                        _this8.$notify({
                            title: '提示',
                            message: response && response.message,
                            type: 'error'
                        });
                    }
                });
            }
        },
        getTicketDraftInstance: function getTicketDraftInstance() {
            // 获取票对象的单例
            // ls没有初始化 且 （（是BD 且 有合同id） 或 不是BD）则开始初始化ls
            if (!this.ls && (this.extra.isBD && this.extra.contractId || !this.extra.isBD)) {
                this.ls = new _ticketDraft2.default(this.extra.isBD ? this.extra.contractId : null);
            }
            return this.ls;
        },
        saveDraft: function saveDraft() {
            if (this.model.mtDealId || !this.modelLoaded && this.model !== 'new') return;
            var ls = this.getTicketDraftInstance();
            if (ls) {
                this.ls.draft(this.model);
            }
        },
        toListOrNot: function toListOrNot() {
            this.$msgbox({
                title: '提示',
                message: '保存成功',
                confirmButtonText: '返回产品列表',
                cancelButtonText: '取消'
            }).then(function () {
                window.close();
            });
        },
        doHaveErrors: function doHaveErrors() {
            var findError = false;
            for (var i = 1; i < 4; i++) {
                if (this.errors[0].items && this.errors[0].items['tab' + i] && this.errors[0].items['tab' + i].length > 0) {
                    this.errors[0].showAllError('tab' + i);
                    findError = true;
                }
            }

            if (findError) {
                this.showErrorOnTabs = true;
                this.$notify({
                    title: '提示',
                    message: this.extra.isDirectDeal ? '请您检查下橙色报警框，当前还有未填写的内容' : '填写内容校验不通过，请详细检查每一项字段的输入值。',
                    type: 'error'
                });
                return true;
            }
            if (!this.model.IAmTheatre) {
                if (this.model.useDateMode === 0 && this.model.limitDayType === 1) {
                    this.$msgbox({
                        title: '提示',
                        message: '有效期模式的产品只可勾选“下单日限购”，请更改后再进行提交。',
                        type: 'error',
                        confirmButtonText: '确定',
                        showCancelButton: false
                    });
                    return true;
                }
            }

            return false;
        },
        checkDraft: function checkDraft() {
            var ls = this.getTicketDraftInstance();
            if (this.extra.isNew && ls && ls.hasDraft()) {
                var that = this;
                that.$confirm({
                    title: '草稿',
                    message: '您当前有草稿未保存，是否要继续编辑？',
                    confirmButtonText: ' 继续编辑',
                    cancelButtonText: '放弃草稿并重新创建'
                }).then(function (data) {
                    //console.log(ls.useDraft())
                    that.model = ls.useDraft();
                    // 即使读取草稿，依然使用当前的一些数据
                    // 老直连的逻辑，只要是直连，全改成5。。。。。。
                    if (that.extra.isDirectDeal) {
                        that.model.sourceType = 5;
                    }
                    //supplierId与get参数中不符的，恢复成get中的id
                    if (that.model.supplierId !== that.extra.supplierId) {
                        that.model.supplierId = that.extra.supplierId;
                    }

                    that.$message({
                        message: '加载成功',
                        type: 'success'
                    });
                    that.modelLoaded = true;
                }, function (err) {
                    ls.clearDraft();
                    that.modelLoaded = true;
                });
            } else {
                this.modelLoaded = true;
            }
        },

        // 跨组件获取是否有协议
        hasProtocolButNotUsed: function hasProtocolButNotUsed() {
            // 跨组件获取是否有协议
            var yes = false;
            try {
                if (this.$refs.info.$refs.supplierProtocol.protocolTypeList.length > 0) {
                    yes = true;
                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                        for (var _iterator4 = Object.keys(this.model.supplierProtocolRule)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                            var key = _step4.value;

                            if (this.model.supplierProtocolRule[key].length > 0) {
                                yes = false;
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                _iterator4.return();
                            }
                        } finally {
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }
                }
            } catch (e) {}
            return yes;
        }
    }),
    created: function created() {
        // 组件创建完后获取数据，
        // 此时 data 已经被 observed 了
        window.router = this.$route;
        this.initProduct();
    },
    mounted: function mounted() {
        var _this9 = this;

        // 如果是新建，监控model并存入草稿
        this.$watch(function () {
            return !_this9.model.mtDealId ? _this9.model : null;
        }, this.saveDraft, { deep: true });
        if (this.mode === 'new') {
            this.checkDraft();
        }
        this.entryTime = new Date().getTime();
    }
};

/***/ }),
/* 490 */
/*!************************************!*\
  !*** ./src/helpers/ticketDraft.js ***!
  \************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ 74);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ 75);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TicketDraft = function () {
    function TicketDraft(contractId) {
        (0, _classCallCheck3.default)(this, TicketDraft);

        if (!contractId) {
            contractId = 'noContractId';
        }
        this.lsswitch = true;
        this.lsKey = 'notp-ticket-draft-' + contractId;
        if (typeof process !== 'undefined' && (process.server || process.SERVER_BUILD || Object({"ENV":"production","NODE_ENV":"production"}) && Object({"ENV":"production","NODE_ENV":"production"}).VUE_ENV === 'server')) {
            this.lsswitch = false;
            return;
        }
        try {
            var test = '__localstorage-test__';
            window.localStorage.setItem(test, test);
            window.localStorage.removeItem(test);
        } catch (e) {
            this.lsswitch = false;
            console.error('Local storage is not supported');
        }
        this.ls = window.localStorage;
    }

    (0, _createClass3.default)(TicketDraft, [{
        key: 'draft',
        value: function draft(data) {
            if (!this.lsswitch) return;
            this.ls.setItem(this.lsKey, JSON.stringify(data));
        }
    }, {
        key: 'hasDraft',
        value: function hasDraft() {
            return this.lsswitch ? !!this.ls[this.lsKey] : false;
        }
    }, {
        key: 'clearDraft',
        value: function clearDraft() {
            if (this.lsswitch) {
                this.ls.removeItem(this.lsKey);
            }
        }
    }, {
        key: 'useDraft',
        value: function useDraft() {
            return this.lsswitch ? JSON.parse(this.ls[this.lsKey]) : false;
        }
    }]);
    return TicketDraft;
}();

exports.default = TicketDraft;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./../../node_modules/process/browser.js */ 80)))

/***/ }),
/* 491 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-11bf0cee","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/ticket/product/item/Instruction.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 492 */
/*!**************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/ticket/product/item/Instruction.vue ***!
  \**************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _index2 = __webpack_require__(/*! components/input-number-custom/index.vue */ 115);

var _index3 = _interopRequireDefault(_index2);

var _index4 = __webpack_require__(/*! components/content-block/index.vue */ 76);

var _index5 = _interopRequireDefault(_index4);

var _ticket = __webpack_require__(/*! data/ticket */ 155);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        CustomInputNumber: _index3.default,
        ContentBlock: _index5.default
    },
    data: function data() {
        return {
            PAGE: 'tab2',
            buyCountLimitTypes: _ticket.buyCountLimitTypes,
            contractInfoType: '1',
            contractInfoRule: {
                mobile: false,
                name: false
            },
            visitorInfoGroupSize: 1,
            visitorInfoRule: {
                name: false,
                mobile: false,
                credentials: false,
                passport: false,
                mtp: false,
                hkmlp: false,
                tlp: false
            },
            aheadHoursType: '1',
            aheadHours: 0,
            hours: 0,
            minutes: 0,
            aheadDays: 0,
            minBuyCount: 1,
            maxBuyCount: '',
            phoneLimitDays: '',
            phoneLimitCount: '',
            phoneLimitUnitType: 0,
            idLimitDays: '',
            idLimitCount: '',
            idLimitUnitType: 0,
            CANCEL_MINUTE: [10, 15, 20, 30, 40, 50, 60, 90, 120],
            SEPARATED_MINUTE: [0, 15, 30, 45, 59],
            orderCancelTime: 30,
            generateTicketMethod: 2,
            voucherTimes: [{
                voucherStartTimeHour: 8,
                voucherStartTimeMinute: 0,
                voucherEndTimeHour: 18,
                voucherEndTimeMinute: 0
            }],
            ticketGetAddress: [''],
            getInAddresses: [''],
            onlineBefore: false,
            buyLimitShow: false
        };
    },

    props: {
        model: {
            type: Object,
            required: true
        },
        extra: {
            type: Object,
            required: true
        },
        errors: {
            type: Array,
            required: true
        },
        // 编辑方式
        mode: {
            type: String,
            required: false
        },
        isTuan: {
            type: Boolean,
            default: false
        },
        readonly: Boolean
    },
    methods: {
        deleteOneVoucherTime: function deleteOneVoucherTime(index) {
            this.model.voucherTimes.splice(index, 1);
            this.voucherTimes.splice(index, 1);
        },
        addOneVoucherTime: function addOneVoucherTime() {
            if (this.model.voucherTimes.length < 3) {
                this.model.voucherTimes.push({
                    voucherStartTime: 480,
                    voucherEndTime: 1080,
                    needVoucherOrGetInTimeSupplement: false,
                    voucherOrGetInTimeSupplement: ''
                });
                this.voucherTimes.push({
                    voucherStartTimeHour: 8,
                    voucherStartTimeMinute: 0,
                    voucherEndTimeHour: 18,
                    voucherEndTimeMinute: 0
                });
            }
        },
        newTicketGetAddress: function newTicketGetAddress() {
            this.model.ticketGetAddress.push('');
            this.validateErrors.add(this.PAGE, {
                key: this.model.ticketGetAddress.length - 1,
                modelName: 'model.ticketGetAddress[index]',
                showError: false,
                rule: 'required'
            });
        },
        deleteTicketGetAddress: function deleteTicketGetAddress(index) {
            this.model.ticketGetAddress.splice(index, 1);
            /*
            const position = this.validateErrors.search(this.PAGE, 'model.ticketGetAddress[index]', 'required', index)
            if (position >= 0) {
                this.validateErrors.remove(this.PAGE, position)
            }
            */
        },
        newGetInAddresses: function newGetInAddresses() {
            this.model.getInAddresses.push('');
        },
        deleteGetInAddresses: function deleteGetInAddresses(index) {
            this.model.getInAddresses.splice(index, 1);
        },
        changeTime: function changeTime(index) {
            this.model.voucherTimes[index].voucherStartTime = this.voucherTimes[index].voucherStartTimeHour * 60 + this.voucherTimes[index].voucherStartTimeMinute;
            this.model.voucherTimes[index].voucherEndTime = this.voucherTimes[index].voucherEndTimeHour * 60 + this.voucherTimes[index].voucherEndTimeMinute;
        },
        changeGenerateTicketMethod: function changeGenerateTicketMethod() {
            if (this.model.generateTicketMethod === 1) {
                this.model.getTicketRule.voucherLoaders = [1];
                this.model.getVoucherRule.voucherLoaders = [1];
            } else {
                this.model.getTicketRule.voucherLoaders = [4];
                this.model.getVoucherRule.voucherLoaders = [4];
            }
            this.model.getTicketRule.needCertificateSupplement = false;
            this.model.getVoucherRule.needCertificateSupplement = false;
            this.checkVoucherLoaderErrors();
        },
        checkContractInfoRule: function checkContractInfoRule(e) {
            var current = e.srcElement.type;
            var index = this.validateErrors.search(this.PAGE, 'contractInfoRule', 'required', 0);
            if (!this.model.contractInfoRule.mobile && !this.model.contractInfoRule.name && this.model.contractInfoType === 2) {
                if (index >= 0 && currnet === 'checkbox') {
                    this.validateErrors.items[this.PAGE][index].showError = true;
                } else {
                    this.validateErrors.add(this.PAGE, {
                        key: 0,
                        modelName: 'contractInfoRule',
                        showError: current === 'radio' ? false : true,
                        rule: 'required'
                    });
                }
            } else {
                if (index >= 0) {
                    this.validateErrors.remove(this.PAGE, index);
                }
            }
        },
        checkVisitorInfoRule: function checkVisitorInfoRule(e) {
            var current = e.srcElement.type;
            var index = this.validateErrors.search(this.PAGE, 'visitorInfoRule', 'required', 0);
            if (!this.model.visitorInfoRule.name && !this.model.visitorInfoRule.mobile && this.model.visitorInfoType !== 1) {
                if (index >= 0 && current === 'checkbox') {
                    this.validateErrors.items[this.PAGE][index].showError = true;
                } else {
                    this.validateErrors.add(this.PAGE, {
                        key: 0,
                        modelName: 'visitorInfoRule',
                        showError: current === 'radio' ? false : true,
                        rule: 'required'
                    });
                }
            } else {
                if (index >= 0) {
                    this.validateErrors.removeAll(this.PAGE, 'visitorInfoRule', 'required');
                }
            }
        },
        needTicketChanged: function needTicketChanged() {
            if (this.model.needTicket) {
                if (this.model.generateTicketMethod === 1) {
                    this.model.getVoucherRule.voucherLoaders = [1];
                } else {
                    this.model.getVoucherRule.voucherLoaders = [4];
                }
                for (var i = 0; i < this.model.ticketGetAddress.length; i++) {
                    var index = this.validateErrors.search(this.PAGE, 'model.ticketGetAddress[index]', 'required', i);
                    if (this.model.ticketGetAddress[i].length <= 0) {
                        if (index === -1) {
                            this.validateErrors.add(this.PAGE, {
                                key: i,
                                modelName: 'model.ticketGetAddress[index]',
                                showError: false,
                                rule: 'required'
                            });
                        }
                    } else {
                        if (index >= 0) {
                            this.validateErrors.remove(this.PAGE, index);
                        }
                    }
                }
            } else {
                if (this.model.generateTicketMethod === 1) {
                    this.model.getTicketRule.voucherLoaders = [1];
                } else {
                    this.model.getTicketRule.voucherLoaders = [4];
                }
                for (var _i = 0; _i < this.model.ticketGetAddress.length; _i++) {
                    var _index = this.validateErrors.search(this.PAGE, 'model.ticketGetAddress[index]', 'required', _i);
                    if (_index >= 0) {
                        this.validateErrors.remove(this.PAGE, _index);
                    }
                }
            }
            this.model.ticketGetAddress = [''];
            this.model.getInAddresses = [''];
            this.validateErrors.removeAll(this.PAGE, 'model.getInAddresses[index]');
            this.validateErrors.removeAll(this.PAGE, 'model.ticketGetAddress[index]');
            if (this.model.needTicket) {
                this.validateErrors.add(this.PAGE, {
                    key: 0,
                    modelName: 'model.ticketGetAddress[index]',
                    showError: false,
                    rule: 'required'
                });
            } else {
                this.validateErrors.add(this.PAGE, {
                    key: 0,
                    modelName: 'model.getInAddresses[index]',
                    showError: false,
                    rule: 'required'
                });
            }
            this.model.getTicketRule.needCertificateSupplement = false;
            this.model.getVoucherRule.needCertificateSupplement = false;
            this.checkVoucherLoaderErrors();
        },
        ticketGetAddressChanged: function ticketGetAddressChanged(index) {
            var position = this.validateErrors.search(this.PAGE, 'model.ticketGetAddress[index]', 'required', index);
            if (this.model.ticketGetAddress[index].length > 0) {
                if (position >= 0) {
                    this.validateErrors.remove(this.PAGE, position);
                }
            } else {
                if (position >= 0) {
                    this.validateErrors.items[this.PAGE][position].showError = true;
                } else {
                    this.validateErrors.add(this.PAGE, {
                        key: index,
                        modelName: 'model.ticketGetAddress[index]',
                        showError: true,
                        rule: 'required'
                    });
                }
            }
        },
        voucherLoaderChanged: function voucherLoaderChanged() {
            this.checkVoucherLoaderErrors();
        },

        checkVoucherLoaderErrors: function checkVoucherLoaderErrors() {
            if (this.model.needTicket) {
                if (this.model.getTicketRule.voucherLoaders.length <= 0) {
                    this.validateErrors.add(this.PAGE, {
                        key: 0,
                        modelName: 'model.getTicketRule.voucherLoaders',
                        showError: true,
                        rule: 'required'
                    });
                } else {
                    this.validateErrors.removeAll(this.PAGE, 'model.getTicketRule.voucherLoaders');
                }
                this.validateErrors.removeAll(this.PAGE, 'model.getVoucherRule.voucherLoaders');
            } else {
                if (this.model.getVoucherRule.voucherLoaders.length <= 0) {
                    this.validateErrors.add(this.PAGE, {
                        key: 0,
                        modelName: 'model.getVoucherRule.voucherLoaders',
                        showError: true,
                        rule: 'required'
                    });
                } else {
                    this.validateErrors.removeAll(this.PAGE, 'model.getVoucherRule.voucherLoaders');
                }
                this.validateErrors.removeAll(this.PAGE, 'model.getTicketRule.voucherLoaders');
            }
        },
        integerHandle: function integerHandle(e) {
            if (e.target.value === '') {
                e.target.value = '';
            }
        },
        limitCheck: function limitCheck(type, value) {
            this.doBuyLimitShow();
        },
        doBuyLimitShow: function doBuyLimitShow() {
            var model = this.model;
            if (!model) return;
            this.buyLimitShow = false;
            var phoneShow = void 0,
                idShow = void 0;
            if (model.contractInfoType === 2 && model.contractInfoRule && model.contractInfoRule.mobile || model.visitorInfoRule && model.visitorInfoRule.mobile && model.visitorInfoType !== 1) {
                // console.log('model.phoneLimitCount', model.phoneLimitCount)
                if (model.phoneLimitCount > 0) this.buyLimitShow = true;
                phoneShow = true;
            }
            if (model.visitorInfoType !== 1 && model.visitorInfoRule && model.visitorInfoRule.credentials) {
                // console.log('model.id', model.idLimitCount)
                idShow = true;
                if (model.idLimitCount > 0) this.buyLimitShow = true;
            }
            // if (!this.buyLimitShow && (phoneShow || idShow)) {
            //     this.model.limitDayType = 0;
            // }
        },
        updateModel: function updateModel() {
            if (this.model.voucherTimes.length > 0) {
                this.voucherTimes = [];
                for (var i = 0; i < this.model.voucherTimes.length; i++) {
                    this.voucherTimes.push({
                        voucherStartTimeHour: Math.floor(this.model.voucherTimes[i].voucherStartTime / 60),
                        voucherStartTimeMinute: this.model.voucherTimes[i].voucherStartTime % 60,
                        voucherEndTimeHour: Math.floor(this.model.voucherTimes[i].voucherEndTime / 60),
                        voucherEndTimeMinute: this.model.voucherTimes[i].voucherEndTime % 60
                    });
                    if (!this.model.voucherTimes[i].voucherOrGetInTimeSupplement) {
                        this.model.voucherTimes[i].voucherOrGetInTimeSupplement = '';
                    }
                }
            }
            if (this.model.mtDealId) {
                this.onlineBefore = true;
            } else {
                this.onlineBefore = false;
            }
            this.doBuyLimitShow();
        }
    },
    directives: {
        'textarea-check': function textareaCheck(el) {
            var text = el.getElementsByTagName('textarea')[0].value;
            var errorNotice = el.parentNode.getElementsByClassName('is-danger')[0];
            if (errorNotice) {
                errorNotice.style.display = 'none';
                for (var i = 0; i < _ticket.textareaForbiddenWords.length; i++) {
                    if (text.indexOf(_ticket.textareaForbiddenWords[i]) !== -1) {
                        errorNotice.style.display = 'block';
                        errorNotice.innerText = '请勿在此处填写' + _ticket.textareaForbiddenWords[i] + '信息';
                    }
                }
            }
        }
    },
    watch: {
        model: function model() {
            this.updateModel();
        }
    },
    mounted: function mounted() {
        this.$watch(function () {
            var model = this.model;
            if (!model || !Object.keys(model).length) return false;
            if (model.contractInfoType === 2 && model.contractInfoRule.mobile || model.visitorInfoRule.mobile && model.visitorInfoType !== 1) {
                console.log('model.phoneLimitCount', model.phoneLimitCount);
                if (model.phoneLimitCount > 0) return true;
            }
            if (model.visitorInfoType !== 1 && model.visitorInfoRule.credentials) {
                console.log('model.id', model.idLimitCount);
                if (model.idLimitCount > 0) return true;
            }
            return false;
        }, function (val) {
            this.buyLimitShow = val;
        }, {
            immediate: true
        });
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { mapActions, mapGetters } from 'vuex'

/***/ }),
/* 493 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-055a5f12","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/input-number-custom/index.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */
/*!*************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/input-number-custom/index.vue ***!
  \*************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var on = function () {
    if (document.addEventListener) {
        return function (element, event, handler) {
            if (element && event && handler) {
                element.addEventListener(event, handler, false);
            }
        };
    }
    return function (element, event, handler) {
        if (element && event && handler) {
            element.attachEvent('on' + event, handler);
        }
    };
}();

var off = function () {
    if (document.removeEventListener) {
        return function (element, event, handler) {
            if (element && event) {
                element.removeEventListener(event, handler, false);
            }
        };
    }
    return function (element, event, handler) {
        if (element && event) {
            element.detachEvent('on' + event, handler);
        }
    };
}();

var once = function once(el, event, fn) {
    var listener = function listener() {
        if (fn) {
            fn.apply(this, arguments);
        }
        off(el, event, listener);
    };
    on(el, event, listener);
};

exports.default = {
    name: 'custom-input-number',
    props: {
        step: {
            type: Number,
            default: 1
        },
        max: {
            type: Number,
            default: Infinity
        },
        min: {
            type: Number,
            default: -Infinity
        },
        value: {
            default: 0
        },
        placeholder: {
            type: String,
            default: ''
        },
        disabled: Boolean,
        size: String,
        controls: {
            type: Boolean,
            default: true
        },
        // 保持初始化null
        initAsNull: {
            type: Boolean,
            default: false
        },
        // 只能输入整数
        isInt: {
            type: Boolean,
            default: false
        }
    },
    directives: {
        repeatClick: {
            bind: function bind(el, binding, vnode) {
                var interval = null;
                var startTime = void 0;
                var handler = function handler() {
                    return vnode.context[binding.expression].apply();
                };
                var clear = function clear() {
                    if (new Date() - startTime < 100) {
                        handler();
                    }
                    clearInterval(interval);
                    interval = null;
                };
                on(el, 'mousedown', function () {
                    startTime = new Date();
                    once(document, 'mouseup', clear);
                    clearInterval(interval);
                    interval = setInterval(handler, 100);
                });
            }
        }
    },
    data: function data() {
        return {
            currentValue: 0,
            isInit: true
        };
    },

    watch: {
        value: {
            immediate: true,
            handler: function handler(value) {
                var newVal = Number(value);
                if (isNaN(newVal)) return;
                newVal = this.isInt ? Math.round(newVal) : newVal;
                if (newVal >= this.max) newVal = this.max;
                if (newVal <= this.min) newVal = this.min;
                this.currentValue = value === null && this.initAsNull && this.isInit ? value : newVal;
                this.$emit('input', this.currentValue);
            }
        },
        max: {
            immediate: true,
            handler: function handler(value) {
                var newVal = Number(value);
                if (isNaN(value)) return;
                if (newVal <= this.currentValue) {
                    this.currentValue = newVal;
                }
            }
        },
        min: {
            immediate: true,
            handler: function handler(value) {
                var newVal = Number(value);
                if (isNaN(value)) return;
                if (newVal >= this.currentValue) {
                    this.currentValue = this.currentValue === null && this.initAsNull && this.isInit ? this.currentValue : newVal;
                }
            }
        },
        currentValue: {
            immediate: true,
            handler: function handler(value) {
                // 解决小数点后不能输入0的问题: 只有一个.，并且0结尾的时候，不进行处理
                if (value === '' || typeof value === 'string' && /[0]+$/.test(value) && value.indexOf('.') === value.lastIndexOf('.') && value.indexOf('.') !== -1) return;
                var newVal = Number(value);
                if (isNaN(newVal)) return;
                this.setCurrentValue(value === null && this.initAsNull && this.initAsNull ? value : newVal);
            }
        }
    },
    computed: {
        minDisabled: function minDisabled() {
            return this._decrease(this.value, this.step) < this.min;
        },
        maxDisabled: function maxDisabled() {
            return this._increase(this.value, this.step) > this.max;
        },
        precision: function precision() {
            var value = this.value,
                step = this.step,
                _getPrecision = this._getPrecision;

            return Math.max(_getPrecision(value), _getPrecision(step));
        }
    },
    methods: {
        // 按照精度 返回
        _toPrecision: function _toPrecision(num, _precision) {
            var precision = _precision;
            if (typeof precision === 'undefined') precision = this.precision;
            return parseFloat(parseFloat(Number(num).toFixed(precision)));
        },

        // 获取精度
        _getPrecision: function _getPrecision(value) {
            var valueString = value.toString();
            var dotPosition = valueString.indexOf('.');
            var precision = 0;
            if (dotPosition !== -1) {
                precision = valueString.length - dotPosition - 1;
            }
            return precision;
        },
        _increase: function _increase(val, step) {
            if (typeof val !== 'number') return this.currentValue;
            var precisionFactor = Math.pow(10, this.precision);
            return this._toPrecision((precisionFactor * val + precisionFactor * step) / precisionFactor);
        },
        _decrease: function _decrease(val, step) {
            if (typeof val !== 'number') return this.currentValue;
            var precisionFactor = Math.pow(10, this.precision);
            return this._toPrecision((precisionFactor * val - precisionFactor * step) / precisionFactor);
        },
        increase: function increase() {
            if (this.disabled || this.maxDisabled) return;
            var value = this.value || 0;
            var newVal = this._increase(value, this.step);
            if (newVal > this.max) return;
            this.setCurrentValue(newVal);
        },
        decrease: function decrease() {
            if (this.disabled || this.minDisabled) return;
            var value = this.value || 0;
            var newVal = this._decrease(value, this.step);
            if (newVal < this.min) return;
            this.setCurrentValue(newVal);
        },
        handleBlur: function handleBlur() {
            this.setCurrentValue(this.currentValue);
        },
        setCurrentValue: function setCurrentValue(_newVal) {
            if (this.isInit && this.currentValue === null && this.initAsNull) {
                return;
            }
            // 不是初始化，
            var oldVal = this.currentValue;
            var newVal = _newVal;
            if (newVal >= this.max) newVal = this.max;
            if (newVal <= this.min) newVal = this.min;
            if (oldVal === newVal) return;
            this.currentValue = newVal;
            this.$emit('change', newVal, oldVal);
            this.$emit('input', newVal);
            this.currentValue = newVal;
            this.isInit = false;
        }
    }
};

/***/ }),
/* 495 */
/*!*****************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-055a5f12","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/input-number-custom/index.vue ***!
  \*****************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group xigua-input-number custom-input-group-width",
    class: [
      _vm.size ? 'input-' + _vm.size : '',
      {
        'disabled': _vm.disabled
      }
    ]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    staticClass: "form-control",
    class: _vm.size ? 'input-' + _vm.size : '',
    attrs: {
      "type": "number",
      "disabled": _vm.disabled,
      "max": _vm.max,
      "min": _vm.min,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "blur": _vm.handleBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    },
    nativeOn: {
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        $event.preventDefault();
        _vm.increase($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        $event.preventDefault();
        _vm.decrease($event)
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon custom-input-group-addon"
  }, [_c('div', {
    directives: [{
      name: "repeat-click",
      rawName: "v-repeat-click",
      value: (_vm.increase),
      expression: "increase"
    }],
    class: {
      'disabled': _vm.maxDisabled
    }
  }, [_c('i', {
    staticClass: "icon-angle-up"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "repeat-click",
      rawName: "v-repeat-click",
      value: (_vm.decrease),
      expression: "decrease"
    }],
    class: {
      'disabled': _vm.minDisabled
    }
  }, [_c('i', {
    staticClass: "icon-angle-down"
  })])])])
},staticRenderFns: []}

/***/ }),
/* 496 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7175face","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/content-block/index.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 497 */
/*!*******************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/content-block/index.vue ***!
  \*******************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { mapState } from 'vuex'
exports.default = {
    name: 'content-block',
    props: {
        title: String,
        isRequired: {
            type: Boolean,
            default: false
        },
        type: {
            Object: Object,
            default: function _default() {
                return {
                    left: 2,
                    right: 9
                };
            }
        }
    },
    methods: {}
};

/***/ }),
/* 498 */
/*!**********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7175face","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content-block/index.vue ***!
  \**********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row form-item"
  }, [_c('div', {
    class: ("col-sm-" + (_vm.type.left) + " rowTitle")
  }, [(_vm.isRequired) ? _c('span', {
    staticClass: "required-content"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    class: ("col-sm-" + (_vm.type.right))
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 499 */
/*!******************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11bf0cee","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ticket/product/item/Instruction.vue ***!
  \******************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.model.modelReady) ? _c('div', [_c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly' && !_vm.isTuan
    }
  }, [_c('h2', [_vm._v("预订限制设置")]), _vm._v(" "), _c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "提前购买时间"
    }
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "aheadHoursType1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.aheadHoursType),
      expression: "model.aheadHoursType"
    }],
    attrs: {
      "id": "aheadHoursType1",
      "type": "radio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.model.aheadHoursType, 1)
    },
    on: {
      "__c": function($event) {
        _vm.model.aheadHoursType = 1
      }
    }
  }), _vm._v(" 用户任意时间购买均可使用")])]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "aheadHoursType2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.aheadHoursType),
      expression: "model.aheadHoursType"
    }],
    attrs: {
      "id": "aheadHoursType2",
      "type": "radio"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.model.aheadHoursType, 2)
    },
    on: {
      "__c": function($event) {
        _vm.model.aheadHoursType = 2
      }
    }
  }), _vm._v("用户需提前")]), _vm._v(" "), _c('v-select', {
    staticClass: "nano-select inline-input",
    attrs: {
      "disabled": _vm.model.aheadHoursType != 2,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.aheadHours),
      callback: function($$v) {
        _vm.model.aheadHours = $$v
      },
      expression: "model.aheadHours"
    }
  }, _vm._l((24), function(n) {
    return _c('v-option', {
      key: n,
      attrs: {
        "label": n - 1,
        "value": n - 1
      }
    })
  })), _vm._v(" "), _c('label', {
    attrs: {
      "for": "aheadHoursType2"
    }
  }, [_vm._v("小时")]), _vm._v(" "), _c('v-select', {
    staticClass: "nano-select inline-input",
    attrs: {
      "disabled": _vm.model.aheadHoursType != 2,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.minutes),
      callback: function($$v) {
        _vm.model.minutes = $$v
      },
      expression: "model.minutes"
    }
  }, _vm._l((60), function(n) {
    return _c('v-option', {
      key: n,
      attrs: {
        "label": n - 1,
        "value": n - 1
      }
    })
  })), _vm._v(" "), _c('label', {
    attrs: {
      "for": "aheadHoursType2"
    }
  }, [_vm._v("\n                    分钟购买，方可使用\n                ")]), _vm._v(" "), (_vm.model.aheadHoursType === 2) ? _c('span', [_c('span', {
    staticClass: "orange-warning"
  }, [_vm._v("若选择用户可随时购买使用，订单量可增加15%")])]) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "aheadHoursType3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.aheadHoursType),
      expression: "model.aheadHoursType"
    }],
    attrs: {
      "id": "aheadHoursType3",
      "type": "radio"
    },
    domProps: {
      "value": 3,
      "checked": _vm._q(_vm.model.aheadHoursType, 3)
    },
    on: {
      "__c": function($event) {
        _vm.model.aheadHoursType = 3
      }
    }
  }), _vm._v(" 用户需在游玩")]), _vm._v(" "), _c('v-select', {
    staticClass: "mini-select inline-input",
    attrs: {
      "disabled": _vm.model.aheadHoursType != 3,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.aheadDays),
      callback: function($$v) {
        _vm.model.aheadDays = $$v
      },
      expression: "model.aheadDays"
    }
  }, _vm._l((8), function(n) {
    return _c('v-option', {
      key: n,
      attrs: {
        "label": n - 1 == 0 ? '当天' : '前' + (n - 1) + '天',
        "value": n - 1
      }
    })
  })), _vm._v(" "), _c('label', {
    attrs: {
      "for": "aheadHoursType3"
    }
  }, [_vm._v("的")]), _vm._v(" "), _c('v-select', {
    staticClass: "nano-select inline-input",
    attrs: {
      "disabled": _vm.model.aheadHoursType != 3,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.hours),
      callback: function($$v) {
        _vm.model.hours = $$v
      },
      expression: "model.hours"
    }
  }, _vm._l((24), function(n) {
    return _c('v-option', {
      key: n,
      attrs: {
        "label": n - 1,
        "value": n - 1
      }
    })
  })), _vm._v(" "), _c('label', {
    attrs: {
      "for": "aheadHoursType3"
    }
  }, [_vm._v("点")]), _vm._v(" "), _c('v-select', {
    staticClass: "nano-select inline-input",
    attrs: {
      "disabled": _vm.model.aheadHoursType != 3,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.minutes),
      callback: function($$v) {
        _vm.model.minutes = $$v
      },
      expression: "model.minutes"
    }
  }, _vm._l((60), function(n) {
    return _c('v-option', {
      key: n,
      attrs: {
        "label": n - 1,
        "value": n - 1
      }
    })
  })), _vm._v(" "), _c('label', {
    attrs: {
      "for": "aheadHoursType2"
    }
  }, [_vm._v("\n                    分前购买，方可使用\n                ")]), _vm._v(" "), (_vm.model.aheadHoursType === 3) ? _c('span', [_c('span', {
    staticClass: "orange-warning"
  }, [_vm._v("若选择用户可随时购买使用，订单量可增加约30%")])]) : _vm._e()], 1), _vm._v(" "), (_vm.model.aheadHoursType === 3 && _vm.extra.isDirectDeal) ? _c('div', {
    style: ({
      color: _vm.model.needAheadSupplement ? 'inherit' : '#999'
    })
  }, [_c('label', {
    attrs: {
      "for": "aheadSupplement"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.needAheadSupplement),
      expression: "model.needAheadSupplement"
    }],
    attrs: {
      "id": "aheadSupplement",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.needAheadSupplement) ? _vm._i(_vm.model.needAheadSupplement, null) > -1 : (_vm.model.needAheadSupplement)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.needAheadSupplement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.needAheadSupplement = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.needAheadSupplement = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.needAheadSupplement = $$c
        }
      }
    }
  }), _vm._v(" 补充规则：用户购买后需等待")]), _vm._v(" "), _c('v-select', {
    staticClass: "nano-select inline-input",
    attrs: {
      "disabled": !_vm.model.needAheadSupplement,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.aheadHoursBeforeUse),
      callback: function($$v) {
        _vm.model.aheadHoursBeforeUse = $$v
      },
      expression: "model.aheadHoursBeforeUse"
    }
  }, _vm._l((24), function(n) {
    return _c('v-option', {
      key: n,
      attrs: {
        "label": n - 1,
        "value": n - 1
      }
    })
  })), _vm._v(" "), _c('label', {
    attrs: {
      "for": "aheadSupplement"
    }
  }, [_vm._v("小时")]), _vm._v(" "), _c('v-select', {
    staticClass: "nano-select inline-input",
    attrs: {
      "disabled": !_vm.model.needAheadSupplement,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.aheadMinutesBeforeUse),
      callback: function($$v) {
        _vm.model.aheadMinutesBeforeUse = $$v
      },
      expression: "model.aheadMinutesBeforeUse"
    }
  }, _vm._l((60), function(n) {
    return _c('v-option', {
      key: n,
      attrs: {
        "label": n - 1,
        "value": n - 1
      }
    })
  })), _vm._v(" "), _c('label', {
    attrs: {
      "for": "aheadSupplement"
    }
  }, [_vm._v("\n                    分钟方可使用\n                ")])], 1) : _vm._e()])], 1), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [_c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "联系人信息"
    }
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "contractInfoType1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.contractInfoType),
      expression: "model.contractInfoType"
    }],
    attrs: {
      "id": "contractInfoType1",
      "type": "radio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.model.contractInfoType, 1)
    },
    on: {
      "change": _vm.checkContractInfoRule,
      "__c": function($event) {
        _vm.model.contractInfoType = 1
      }
    }
  }), _vm._v(" 不需要")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "contractInfoType2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.contractInfoType),
      expression: "model.contractInfoType"
    }],
    attrs: {
      "id": "contractInfoType2",
      "type": "radio"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.model.contractInfoType, 2)
    },
    on: {
      "change": _vm.checkContractInfoRule,
      "__c": function($event) {
        _vm.model.contractInfoType = 2
      }
    }
  }), _vm._v(" 需要")])]), _vm._v(" "), (_vm.model.contractInfoType === 2) ? _c('div', {
    staticClass: "extra-content-block",
    class: {
      'error-block-local': _vm.validateErrors.has('tab2', 'contractInfoRule')
    }
  }, [_c('div', {
    staticClass: "orange-warning"
  }, [_vm._v("若不需要联系人信息，订单量可增加约20%，用户填写的信息越少，下单转化越高")]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "CTMobile"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.contractInfoRule.mobile),
      expression: "model.contractInfoRule.mobile"
    }],
    attrs: {
      "id": "CTMobile",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.contractInfoRule.mobile) ? _vm._i(_vm.model.contractInfoRule.mobile, null) > -1 : (_vm.model.contractInfoRule.mobile)
    },
    on: {
      "change": _vm.checkContractInfoRule,
      "__c": function($event) {
        var $$a = _vm.model.contractInfoRule.mobile,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.contractInfoRule.mobile = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.contractInfoRule.mobile = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.contractInfoRule.mobile = $$c
        }
      }
    }
  }), _vm._v(" 手机号")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "CTName"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.contractInfoRule.name),
      expression: "model.contractInfoRule.name"
    }],
    attrs: {
      "id": "CTName",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.contractInfoRule.name) ? _vm._i(_vm.model.contractInfoRule.name, null) > -1 : (_vm.model.contractInfoRule.name)
    },
    on: {
      "change": _vm.checkContractInfoRule,
      "__c": function($event) {
        var $$a = _vm.model.contractInfoRule.name,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.contractInfoRule.name = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.contractInfoRule.name = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.contractInfoRule.name = $$c
        }
      }
    }
  }), _vm._v(" 姓名")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab2', 'contractInfoRule')),
      expression: "validateErrors.has('tab2','contractInfoRule')"
    }],
    staticClass: "notice",
    class: {
      'error-text-local': _vm.validateErrors.has('tab2', 'contractInfoRule')
    }
  }, [_vm._v("\n                    （至少选择一项）\n                ")])]) : _vm._e()]), _vm._v(" "), _c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "游玩人信息"
    }
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "visitorInfoType1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.visitorInfoType),
      expression: "model.visitorInfoType"
    }],
    attrs: {
      "id": "visitorInfoType1",
      "type": "radio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.model.visitorInfoType, 1)
    },
    on: {
      "change": _vm.checkVisitorInfoRule,
      "__c": function($event) {
        _vm.model.visitorInfoType = 1
      }
    }
  }), _vm._v(" 不需要")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "visitorInfoType2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.visitorInfoType),
      expression: "model.visitorInfoType"
    }],
    attrs: {
      "id": "visitorInfoType2",
      "type": "radio"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.model.visitorInfoType, 2)
    },
    on: {
      "change": _vm.checkVisitorInfoRule,
      "__c": function($event) {
        _vm.model.visitorInfoType = 2
      }
    }
  }), _vm._v(" 只需要1位游玩人信息")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "visitorInfoType3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.visitorInfoType),
      expression: "model.visitorInfoType"
    }],
    attrs: {
      "id": "visitorInfoType3",
      "type": "radio"
    },
    domProps: {
      "value": 3,
      "checked": _vm._q(_vm.model.visitorInfoType, 3)
    },
    on: {
      "change": _vm.checkVisitorInfoRule,
      "__c": function($event) {
        _vm.model.visitorInfoType = 3
      }
    }
  }), _vm._v(" 需要全部游玩人信息")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "visitorInfoType4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.visitorInfoType),
      expression: "model.visitorInfoType"
    }],
    attrs: {
      "id": "visitorInfoType4",
      "type": "radio"
    },
    domProps: {
      "value": 4,
      "checked": _vm._q(_vm.model.visitorInfoType, 4)
    },
    on: {
      "change": _vm.checkVisitorInfoRule,
      "__c": function($event) {
        _vm.model.visitorInfoType = 4
      }
    }
  }), _vm._v(" 每"), _c('div', {
    staticClass: "nano-select inline-input",
    staticStyle: {
      "vertical-align": "bottom"
    }
  }, [_c('custom-input-number', {
    attrs: {
      "min": 2,
      "disabled": _vm.model.visitorInfoType != 4
    },
    model: {
      value: (_vm.model.visitorInfoGroupSize),
      callback: function($$v) {
        _vm.model.visitorInfoGroupSize = $$v
      },
      expression: "model.visitorInfoGroupSize"
    }
  })], 1), _vm._v("位游玩人共用1个信息")])]), _vm._v(" "), (_vm.model.visitorInfoType !== 1) ? _c('div', {
    staticClass: "extra-content-block",
    class: {
      'error-block-local': _vm.validateErrors.has('tab2', 'visitorInfoRule')
    }
  }, [(_vm.model.visitorInfoType === 2) ? _c('div', {
    staticClass: "orange-warning"
  }, [_vm._v("若不需要游玩人信息，订单量可增加约20%，用户填写的信息越少，下单转化越高")]) : _vm._e(), _vm._v(" "), (_vm.model.visitorInfoType === 3) ? _c('div', {
    staticClass: "orange-warning"
  }, [_vm._v("若不需要游玩人信息，订单量可增加约30%，用户填写的信息越少，下单转化越高")]) : _vm._e(), _vm._v(" "), (_vm.model.visitorInfoType === 4) ? _c('div', {
    staticClass: "orange-warning"
  }, [_vm._v("若不需要游玩人信息，订单量可增加约35%，用户填写的信息越少，下单转化越高")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_vm._v("身份信息")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "VIRName"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.visitorInfoRule.name),
      expression: "model.visitorInfoRule.name"
    }],
    attrs: {
      "id": "VIRName",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.visitorInfoRule.name) ? _vm._i(_vm.model.visitorInfoRule.name, null) > -1 : (_vm.model.visitorInfoRule.name)
    },
    on: {
      "change": _vm.checkVisitorInfoRule,
      "__c": function($event) {
        var $$a = _vm.model.visitorInfoRule.name,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.visitorInfoRule.name = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.visitorInfoRule.name = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.visitorInfoRule.name = $$c
        }
      }
    }
  }), _vm._v(" 姓名")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "VIRMobile"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.visitorInfoRule.mobile),
      expression: "model.visitorInfoRule.mobile"
    }],
    attrs: {
      "id": "VIRMobile",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.visitorInfoRule.mobile) ? _vm._i(_vm.model.visitorInfoRule.mobile, null) > -1 : (_vm.model.visitorInfoRule.mobile)
    },
    on: {
      "change": _vm.checkVisitorInfoRule,
      "__c": function($event) {
        var $$a = _vm.model.visitorInfoRule.mobile,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.visitorInfoRule.mobile = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.visitorInfoRule.mobile = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.visitorInfoRule.mobile = $$c
        }
      }
    }
  }), _vm._v(" 手机号")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab2', 'visitorInfoRule')),
      expression: "validateErrors.has('tab2','visitorInfoRule')"
    }],
    staticClass: "notice",
    class: {
      'error-text-local': _vm.validateErrors.has('tab2', 'visitorInfoRule')
    }
  }, [_vm._v("\n                            （至少选择一项）\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_vm._v("证件信息")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "VIRredentials"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.visitorInfoRule.credentials),
      expression: "model.visitorInfoRule.credentials"
    }],
    attrs: {
      "id": "VIRredentials",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.visitorInfoRule.credentials) ? _vm._i(_vm.model.visitorInfoRule.credentials, null) > -1 : (_vm.model.visitorInfoRule.credentials)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.visitorInfoRule.credentials,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.visitorInfoRule.credentials = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.visitorInfoRule.credentials = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.visitorInfoRule.credentials = $$c
        }
      }
    }
  }), _vm._v(" 身份证")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "VIRPassport"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.visitorInfoRule.passport),
      expression: "model.visitorInfoRule.passport"
    }],
    attrs: {
      "id": "VIRPassport",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.visitorInfoRule.passport) ? _vm._i(_vm.model.visitorInfoRule.passport, null) > -1 : (_vm.model.visitorInfoRule.passport)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.visitorInfoRule.passport,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.visitorInfoRule.passport = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.visitorInfoRule.passport = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.visitorInfoRule.passport = $$c
        }
      }
    }
  }), _vm._v(" 护照")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "VIRMtp"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.visitorInfoRule.mtp),
      expression: "model.visitorInfoRule.mtp"
    }],
    attrs: {
      "id": "VIRMtp",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.visitorInfoRule.mtp) ? _vm._i(_vm.model.visitorInfoRule.mtp, null) > -1 : (_vm.model.visitorInfoRule.mtp)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.visitorInfoRule.mtp,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.visitorInfoRule.mtp = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.visitorInfoRule.mtp = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.visitorInfoRule.mtp = $$c
        }
      }
    }
  }), _vm._v(" 台胞证")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "VIRHkmlp"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.visitorInfoRule.hkmlp),
      expression: "model.visitorInfoRule.hkmlp"
    }],
    attrs: {
      "id": "VIRHkmlp",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.visitorInfoRule.hkmlp) ? _vm._i(_vm.model.visitorInfoRule.hkmlp, null) > -1 : (_vm.model.visitorInfoRule.hkmlp)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.visitorInfoRule.hkmlp,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.visitorInfoRule.hkmlp = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.visitorInfoRule.hkmlp = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.visitorInfoRule.hkmlp = $$c
        }
      }
    }
  }), _vm._v(" 港澳通行证")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "VIRTlp"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.visitorInfoRule.tlp),
      expression: "model.visitorInfoRule.tlp"
    }],
    attrs: {
      "id": "VIRTlp",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.visitorInfoRule.tlp) ? _vm._i(_vm.model.visitorInfoRule.tlp, null) > -1 : (_vm.model.visitorInfoRule.tlp)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.visitorInfoRule.tlp,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.visitorInfoRule.tlp = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.visitorInfoRule.tlp = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.visitorInfoRule.tlp = $$c
        }
      }
    }
  }), _vm._v(" 大陆居民往来台湾通行证")])]), _vm._v(" "), _c('div', {
    staticClass: "notice"
  }, [_vm._v("\n                            （若勾选多个证件，用户在购买时只需任选一个证件填写）\n                        ")])])])]) : _vm._e()]), _vm._v(" "), (_vm.model.sourceType === 3 && _vm.model.scrAttrs) ? _c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "需要线下预约"
    }
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "needBookOffline1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.scrAttrs.needBookOffline),
      expression: "model.scrAttrs.needBookOffline"
    }],
    attrs: {
      "id": "needBookOffline1",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.model.scrAttrs.needBookOffline, false)
    },
    on: {
      "__c": function($event) {
        _vm.model.scrAttrs.needBookOffline = false
      }
    }
  }), _vm._v(" 不需要")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "needBookOffline2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.scrAttrs.needBookOffline),
      expression: "model.scrAttrs.needBookOffline"
    }],
    attrs: {
      "id": "needBookOffline2",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.model.scrAttrs.needBookOffline, true)
    },
    on: {
      "__c": function($event) {
        _vm.model.scrAttrs.needBookOffline = true
      }
    }
  }), _vm._v(" 需要")])]), _vm._v(" "), (_vm.model.scrAttrs.needBookOffline) ? _c('div', {
    staticClass: "extra-content-block"
  }, [_c('div', {
    staticClass: "extra-info-input"
  }, [_c('label', {
    attrs: {
      "for": "bookTypes1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.scrAttrs.offlineBookRule.bookTypes),
      expression: "model.scrAttrs.offlineBookRule.bookTypes"
    }],
    attrs: {
      "id": "bookTypes1",
      "type": "checkbox"
    },
    domProps: {
      "value": 1,
      "checked": Array.isArray(_vm.model.scrAttrs.offlineBookRule.bookTypes) ? _vm._i(_vm.model.scrAttrs.offlineBookRule.bookTypes, 1) > -1 : (_vm.model.scrAttrs.offlineBookRule.bookTypes)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.scrAttrs.offlineBookRule.bookTypes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 1,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.scrAttrs.offlineBookRule.bookTypes = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.scrAttrs.offlineBookRule.bookTypes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.scrAttrs.offlineBookRule.bookTypes = $$c
        }
      }
    }
  }), _vm._v(" 需要短信预约\n                        ，请至少提前"), _c('v-input', {
    staticClass: "mini-select inline-input",
    model: {
      value: (_vm.model.scrAttrs.offlineBookRule.smsAheadTime),
      callback: function($$v) {
        _vm.model.scrAttrs.offlineBookRule.smsAheadTime = $$v
      },
      expression: "model.scrAttrs.offlineBookRule.smsAheadTime"
    }
  }), _vm._v("将出行人"), _c('v-input', {
    staticClass: "mini-select inline-input",
    model: {
      value: (_vm.model.scrAttrs.offlineBookRule.smsUserInfo),
      callback: function($$v) {
        _vm.model.scrAttrs.offlineBookRule.smsUserInfo = $$v
      },
      expression: "model.scrAttrs.offlineBookRule.smsUserInfo"
    }
  }), _vm._v("发送至"), _c('v-input', {
    staticClass: "middle-select inline-input",
    model: {
      value: (_vm.model.scrAttrs.offlineBookRule.smsPhone),
      callback: function($$v) {
        _vm.model.scrAttrs.offlineBookRule.smsPhone = $$v
      },
      expression: "model.scrAttrs.offlineBookRule.smsPhone"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "extra-info-input"
  }, [_c('label', {
    attrs: {
      "for": "bookTypes2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.scrAttrs.offlineBookRule.bookTypes),
      expression: "model.scrAttrs.offlineBookRule.bookTypes"
    }],
    attrs: {
      "id": "bookTypes2",
      "type": "checkbox"
    },
    domProps: {
      "value": 2,
      "checked": Array.isArray(_vm.model.scrAttrs.offlineBookRule.bookTypes) ? _vm._i(_vm.model.scrAttrs.offlineBookRule.bookTypes, 2) > -1 : (_vm.model.scrAttrs.offlineBookRule.bookTypes)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.scrAttrs.offlineBookRule.bookTypes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 2,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.scrAttrs.offlineBookRule.bookTypes = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.scrAttrs.offlineBookRule.bookTypes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.scrAttrs.offlineBookRule.bookTypes = $$c
        }
      }
    }
  }), _vm._v(" 需要电话预约\n                        ，请至少提前"), _c('v-input', {
    staticClass: "mini-select inline-input",
    model: {
      value: (_vm.model.scrAttrs.offlineBookRule.telAheadTime),
      callback: function($$v) {
        _vm.model.scrAttrs.offlineBookRule.telAheadTime = $$v
      },
      expression: "model.scrAttrs.offlineBookRule.telAheadTime"
    }
  }), _vm._v("拨打"), _c('v-input', {
    staticClass: "middle-select inline-input",
    model: {
      value: (_vm.model.scrAttrs.offlineBookRule.telPhone),
      callback: function($$v) {
        _vm.model.scrAttrs.offlineBookRule.telPhone = $$v
      },
      expression: "model.scrAttrs.offlineBookRule.telPhone"
    }
  }), _vm._v("进行预约")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "extra-info-input"
  }, [_c('label', {
    attrs: {
      "for": "bookTypes3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.scrAttrs.offlineBookRule.bookTypes),
      expression: "model.scrAttrs.offlineBookRule.bookTypes"
    }],
    attrs: {
      "id": "bookTypes3",
      "type": "checkbox"
    },
    domProps: {
      "value": 4,
      "checked": Array.isArray(_vm.model.scrAttrs.offlineBookRule.bookTypes) ? _vm._i(_vm.model.scrAttrs.offlineBookRule.bookTypes, 4) > -1 : (_vm.model.scrAttrs.offlineBookRule.bookTypes)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.scrAttrs.offlineBookRule.bookTypes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 4,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.scrAttrs.offlineBookRule.bookTypes = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.scrAttrs.offlineBookRule.bookTypes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.scrAttrs.offlineBookRule.bookTypes = $$c
        }
      }
    }
  }), _vm._v(" 其他\n                        "), _c('v-input', {
    staticClass: "large-select inline-input",
    model: {
      value: (_vm.model.scrAttrs.offlineBookRule.other),
      callback: function($$v) {
        _vm.model.scrAttrs.offlineBookRule.other = $$v
      },
      expression: "model.scrAttrs.offlineBookRule.other"
    }
  })], 1)])]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly' && !_vm.isTuan
    }
  }, [_c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "预订数量限制"
    }
  }, [_c('span', [_vm._v("每笔订单最少购买")]), _vm._v(" "), _c('div', {
    staticClass: "nano-select inline-input",
    staticStyle: {
      "vertical-align": "bottom"
    }
  }, [_c('custom-input-number', {
    attrs: {
      "min": 1
    },
    model: {
      value: (_vm.model.minBuyCount),
      callback: function($$v) {
        _vm.model.minBuyCount = $$v
      },
      expression: "model.minBuyCount"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("张，最多购买")]), _vm._v(" "), _c('div', {
    staticClass: "nano-select inline-input"
  }, [_c('v-input', {
    directives: [{
      name: "va",
      rawName: "v-va.tab2",
      value: ('integer'),
      expression: "'integer'",
      modifiers: {
        "tab2": true
      }
    }],
    class: {
      'input': true, 'is-danger': _vm.validateErrors.has('tab2', 'model.maxBuyCount')
    },
    attrs: {
      "type": "number",
      "placeholder": "不限"
    },
    on: {
      "blur": _vm.integerHandle
    },
    model: {
      value: (_vm.model.maxBuyCount),
      callback: function($$v) {
        _vm.model.maxBuyCount = $$v
      },
      expression: "model.maxBuyCount"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("张")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab2', 'model.maxBuyCount')),
      expression: "validateErrors.has('tab2', 'model.maxBuyCount')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("最多预订数量需为正整数，不填为不限")])]), _vm._v(" "), ((_vm.model.contractInfoType === 2 && _vm.model.contractInfoRule.mobile) || (_vm.model.visitorInfoRule.mobile && _vm.model.visitorInfoType != 1)) ? _c('content-block', {
    attrs: {
      "title": "手机号限制"
    }
  }, [_c('span', [_vm._v("同一手机号在")]), _vm._v(" "), _c('div', {
    staticClass: "nano-select inline-input",
    staticStyle: {
      "vertical-align": "bottom"
    }
  }, [_c('custom-input-number', {
    attrs: {
      "disabled": _vm.isTuan,
      "min": 1
    },
    model: {
      value: (_vm.model.phoneLimitDays),
      callback: function($$v) {
        _vm.model.phoneLimitDays = $$v
      },
      expression: "model.phoneLimitDays"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("天内最多购买")]), _vm._v(" "), _c('div', {
    staticClass: "nano-select inline-input"
  }, [_c('v-input', {
    directives: [{
      name: "va",
      rawName: "v-va.tab2",
      value: ('integer'),
      expression: "'integer'",
      modifiers: {
        "tab2": true
      }
    }],
    class: {
      'input': true, 'is-danger': _vm.validateErrors.has('tab2', 'model.phoneLimitCount')
    },
    attrs: {
      "type": "number",
      "placeholder": "不限"
    },
    on: {
      "blur": _vm.integerHandle,
      "change": _vm.limitCheck
    },
    model: {
      value: (_vm.model.phoneLimitCount),
      callback: function($$v) {
        _vm.model.phoneLimitCount = $$v
      },
      expression: "model.phoneLimitCount"
    }
  })], 1), _vm._v(" "), _c('v-select', {
    staticClass: "nano-select inline-input",
    attrs: {
      "disabled": _vm.isTuan,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.phoneLimitUnitType),
      callback: function($$v) {
        _vm.model.phoneLimitUnitType = $$v
      },
      expression: "model.phoneLimitUnitType"
    }
  }, _vm._l((_vm.buyCountLimitTypes), function(item, index) {
    return _c('v-option', {
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab2', 'model.phoneLimitCount')),
      expression: "validateErrors.has('tab2', 'model.phoneLimitCount')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("请输入正确的张数")])], 1) : _vm._e(), _vm._v(" "), (_vm.model.visitorInfoType !== 1 && _vm.model.visitorInfoRule.credentials) ? _c('content-block', {
    attrs: {
      "title": "身份证限制"
    }
  }, [_c('span', [_vm._v("同一身份证在")]), _vm._v(" "), _c('div', {
    staticClass: "nano-select inline-input",
    staticStyle: {
      "vertical-align": "bottom"
    }
  }, [_c('custom-input-number', {
    attrs: {
      "disabled": _vm.isTuan,
      "min": 1
    },
    model: {
      value: (_vm.model.idLimitDays),
      callback: function($$v) {
        _vm.model.idLimitDays = $$v
      },
      expression: "model.idLimitDays"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("天内最多购买")]), _vm._v(" "), _c('div', {
    staticClass: "nano-select inline-input"
  }, [_c('v-input', {
    directives: [{
      name: "va",
      rawName: "v-va.tab2",
      value: ('integer'),
      expression: "'integer'",
      modifiers: {
        "tab2": true
      }
    }],
    class: {
      'input': true, 'is-danger': _vm.validateErrors.has('tab2', 'model.idLimitCount')
    },
    attrs: {
      "type": "number",
      "placeholder": "不限"
    },
    on: {
      "blur": _vm.integerHandle,
      "change": _vm.limitCheck
    },
    model: {
      value: (_vm.model.idLimitCount),
      callback: function($$v) {
        _vm.model.idLimitCount = $$v
      },
      expression: "model.idLimitCount"
    }
  })], 1), _vm._v(" "), _c('v-select', {
    staticClass: "nano-select inline-input",
    attrs: {
      "disabled": _vm.isTuan,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.idLimitUnitType),
      callback: function($$v) {
        _vm.model.idLimitUnitType = $$v
      },
      expression: "model.idLimitUnitType"
    }
  }, _vm._l((_vm.buyCountLimitTypes), function(item, index) {
    return _c('v-option', {
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab2', 'model.idLimitCount')),
      expression: "validateErrors.has('tab2', 'model.idLimitCount')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("请输入正确的张数")])], 1) : _vm._e(), _vm._v(" "), (_vm.buyLimitShow) ? _c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "限购方式"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.limitDayType),
      expression: "model.limitDayType"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.model.limitDayType, 0)
    },
    on: {
      "__c": function($event) {
        _vm.model.limitDayType = 0
      }
    }
  }), _vm._v(" 下单日限购")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.limitDayType),
      expression: "model.limitDayType"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.model.limitDayType, 1)
    },
    on: {
      "__c": function($event) {
        _vm.model.limitDayType = 1
      }
    }
  }), _vm._v(" 游玩日限购")]), _vm._v(" "), _c('span', {
    staticClass: "orange-warning"
  }, [_vm._v("有效期模式的产品不能选择游玩日限购")])]) : _vm._e(), _vm._v(" "), _c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "订单取消时间"
    }
  }, [_c('span', [_vm._v("下单成功后")]), _vm._v(" "), _c('v-select', {
    staticClass: "mini-select inline-input",
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.orderCancelTime),
      callback: function($$v) {
        _vm.model.orderCancelTime = $$v
      },
      expression: "model.orderCancelTime"
    }
  }, _vm._l((_vm.CANCEL_MINUTE), function(n) {
    return _c('v-option', {
      key: n,
      attrs: {
        "label": n,
        "value": n
      }
    })
  })), _vm._v(" "), _c('span', [_vm._v("分钟内如未付款，系统将自动取消订单")])], 1)], 1), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [_c('h2', [_vm._v("入园方式")]), _vm._v(" "), _c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "出票方式"
    }
  }, [(!_vm.extra.isDirectDeal) ? _c('label', {
    attrs: {
      "for": "GTM1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.generateTicketMethod),
      expression: "model.generateTicketMethod"
    }],
    attrs: {
      "id": "GTM1",
      "disabled": _vm.onlineBefore,
      "type": "radio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.model.generateTicketMethod, 1)
    },
    on: {
      "change": _vm.changeGenerateTicketMethod,
      "__c": function($event) {
        _vm.model.generateTicketMethod = 1
      }
    }
  }), _vm._v(" 美团出票")]) : _vm._e(), _vm._v(" "), (!_vm.extra.isDirectDeal) ? _c('label', {
    attrs: {
      "for": "GTM2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.generateTicketMethod),
      expression: "model.generateTicketMethod"
    }],
    attrs: {
      "id": "GTM2",
      "disabled": _vm.onlineBefore,
      "type": "radio"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.model.generateTicketMethod, 2)
    },
    on: {
      "change": _vm.changeGenerateTicketMethod,
      "__c": function($event) {
        _vm.model.generateTicketMethod = 2
      }
    }
  }), _vm._v(" 商家手工出票")]) : _vm._e(), _vm._v(" "), (_vm.extra.isDirectDeal) ? _c('label', {
    attrs: {
      "for": "GTM3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.generateTicketMethod),
      expression: "model.generateTicketMethod"
    }],
    attrs: {
      "id": "GTM3",
      "disabled": _vm.onlineBefore,
      "type": "radio"
    },
    domProps: {
      "value": 3,
      "checked": _vm._q(_vm.model.generateTicketMethod, 3)
    },
    on: {
      "__c": function($event) {
        _vm.model.generateTicketMethod = 3
      }
    }
  }), _vm._v(" 商家对接出票")]) : _vm._e(), _vm._v(" "), (_vm.model.generateTicketMethod == 2 && _vm.extra.isBD) ? _c('div', {
    staticClass: "block-waring"
  }, [_vm._v("\n                此流程是新方案，未解决需换票的二次预约的产品，请确保已经过培训并培训商家后再选择此项。直签BD咨询刘策（liuce），三方BD咨询刘策（liuce），"), _c('a', {
    attrs: {
      "href": "https://wiki.sankuai.com/pages/viewpage.action?pageId=569306927"
    }
  }, [_vm._v("使用说明")])]) : _vm._e(), _vm._v(" "), (_vm.model.generateTicketMethod == 2 && !_vm.extra.isBD) ? _c('div', {
    staticClass: "block-waring"
  }, [_vm._v("\n                此流程是新方案，为解决需换票的二次预约产品，请确保您已经过培训，点击下载"), _c('a', {
    attrs: {
      "href": "https://awp-assets.meituan.net/HFE/hotel-fe-notp/assets/files/%E3%80%90%E8%BF%90%E8%90%A5%E6%96%87%E6%A1%A3%E3%80%91%E6%89%8B%E5%B7%A5%E5%87%BA%E7%A5%A8%E4%BD%BF%E7%94%A8%E8%AF%B4%E6%98%8E%EF%BC%88%E5%95%86%E5%AE%B6%E7%89%88%EF%BC%89V1-20170823.docx"
    }
  }, [_vm._v("使用说明")])]) : _vm._e()]), _vm._v(" "), (_vm.model.generateTicketMethod == 2) ? _c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "出票时间"
    }
  }, [_vm._v("\n            从\n            "), _c('v-select', {
    staticClass: "nano-select inline-input",
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.generateTicketWorkTime.startWorkHour),
      callback: function($$v) {
        _vm.model.generateTicketWorkTime.startWorkHour = $$v
      },
      expression: "model.generateTicketWorkTime.startWorkHour"
    }
  }, _vm._l((10), function(n) {
    return _c('v-option', {
      key: n,
      attrs: {
        "label": n - 1,
        "value": n - 1
      }
    })
  })), _vm._v("\n            点\n            "), _c('v-select', {
    staticClass: "nano-select inline-input",
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.generateTicketWorkTime.startWorkMinute),
      callback: function($$v) {
        _vm.model.generateTicketWorkTime.startWorkMinute = $$v
      },
      expression: "model.generateTicketWorkTime.startWorkMinute"
    }
  }, _vm._l((4), function(n) {
    return _c('v-option', {
      key: n,
      attrs: {
        "label": (n - 1) * 15,
        "value": (n - 1) * 15
      }
    })
  })), _vm._v("\n            分到\n            "), _c('v-select', {
    staticClass: "nano-select inline-input",
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.generateTicketWorkTime.endWorkHour),
      callback: function($$v) {
        _vm.model.generateTicketWorkTime.endWorkHour = $$v
      },
      expression: "model.generateTicketWorkTime.endWorkHour"
    }
  }, _vm._l((6), function(n) {
    return _c('v-option', {
      key: n,
      attrs: {
        "label": n + 17,
        "value": n + 17
      }
    })
  })), _vm._v("\n            点\n            "), _c('v-select', {
    staticClass: "nano-select inline-input",
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.generateTicketWorkTime.endWorkMinute),
      callback: function($$v) {
        _vm.model.generateTicketWorkTime.endWorkMinute = $$v
      },
      expression: "model.generateTicketWorkTime.endWorkMinute"
    }
  }, _vm._l((4), function(n) {
    return _c('v-option', {
      key: n,
      attrs: {
        "label": (n - 1) * 15,
        "value": (n - 1) * 15
      }
    })
  })), _vm._v("\n            分产生的订单，"), _c('span', {
    staticClass: "red-span"
  }, [_vm._v("30分钟")]), _vm._v("内出票，其他时间的订单，次日\n            "), _c('span', {
    staticClass: "red-span"
  }, [_vm._v("\n                " + _vm._s(_vm.model.generateTicketWorkTime.startWorkMinute + 30 >= 60 ? ((_vm.model.generateTicketWorkTime.startWorkHour+1) + "点" + (_vm.model.generateTicketWorkTime.startWorkMinute-30) + "分") : ((_vm.model.generateTicketWorkTime.startWorkHour) + "点" + (_vm.model.generateTicketWorkTime.startWorkMinute+30) + "分")) + "\n                ")]), _vm._v("出票\n        ")], 1) : _vm._e(), _vm._v(" "), (_vm.model.generateTicketMethod == 3) ? _c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "下单时是否回传凭证"
    }
  }, [_c('label', {
    attrs: {
      "for": "RV1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.returnVoucher),
      expression: "model.returnVoucher"
    }],
    attrs: {
      "id": "RV1",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.model.returnVoucher, true)
    },
    on: {
      "__c": function($event) {
        _vm.model.returnVoucher = true
      }
    }
  }), _vm._v(" 是")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "RV2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.returnVoucher),
      expression: "model.returnVoucher"
    }],
    attrs: {
      "id": "RV2",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.model.returnVoucher, false)
    },
    on: {
      "__c": function($event) {
        _vm.model.returnVoucher = false
      }
    }
  }), _vm._v(" 否")])]) : _vm._e(), _vm._v(" "), (_vm.model.generateTicketMethod == 3 && !_vm.model.returnVoucher) ? _c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "用户获取凭证方式说明"
    }
  }, [_c('div', [_c('v-input', {
    directives: [{
      name: "va",
      rawName: "v-va.tab2",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "tab2": true
      }
    }],
    class: {
      'input': true, 'is-danger': _vm.validateErrors.has('tab2', 'model.voucherText')
    },
    attrs: {
      "type": "text",
      "maxlength": 50,
      "name": "voucherText",
      "placeholder": "建议填写内容：“凭商家短信入园”、“凭商家二维码验证”"
    },
    model: {
      value: (_vm.model.voucherText),
      callback: function($$v) {
        _vm.model.voucherText = $$v
      },
      expression: "model.voucherText"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "help-block input-counter"
  }, [_vm._v(_vm._s(_vm.model.voucherText.length) + "/50字")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab2', 'model.voucherText')),
      expression: "validateErrors.has('tab2', 'model.voucherText')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("请填写用户获取凭证方式说明")])], 1), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "icon-error help-icon"
  }), _vm._v(" 此处内容用于在订单详情页告知用户凭证信息，请根据商家实际情况谨慎填写\n            ")])]) : _vm._e()], 1), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly && !isTuan'
    }
  }, [_c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "入园方式"
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [_c('label', {
    attrs: {
      "for": "needTicket1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.needTicket),
      expression: "model.needTicket"
    }],
    attrs: {
      "id": "needTicket1",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.model.needTicket, false)
    },
    on: {
      "change": _vm.needTicketChanged,
      "__c": function($event) {
        _vm.model.needTicket = false
      }
    }
  }), _vm._v(" 无需换票，直接验证入园")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "needTicket2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.needTicket),
      expression: "model.needTicket"
    }],
    attrs: {
      "id": "needTicket2",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.model.needTicket, true)
    },
    on: {
      "change": _vm.needTicketChanged,
      "__c": function($event) {
        _vm.model.needTicket = true
      }
    }
  }), _vm._v(" 换票入园")]), (_vm.model.needTicket) ? _c('span', {
    staticClass: "orange-warning"
  }, [_vm._v("若选“无需换票，直接验证入园”模式，订单量可增加约20%")]) : _vm._e()]), _vm._v(" "), (_vm.model.needTicket) ? _c('div', {
    staticClass: "extra-content-block"
  }, [_c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "换票凭证"
    }
  }, [(_vm.model.generateTicketMethod == 3) ? _c('div', [_c('label', {
    attrs: {
      "for": "GTR1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.voucherLoaders),
      expression: "model.getTicketRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR1",
      "type": "checkbox"
    },
    domProps: {
      "value": 4,
      "checked": Array.isArray(_vm.model.getTicketRule.voucherLoaders) ? _vm._i(_vm.model.getTicketRule.voucherLoaders, 4) > -1 : (_vm.model.getTicketRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 4,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 商家电子码")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.voucherLoaders),
      expression: "model.getTicketRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR2",
      "type": "checkbox"
    },
    domProps: {
      "value": 2,
      "checked": Array.isArray(_vm.model.getTicketRule.voucherLoaders) ? _vm._i(_vm.model.getTicketRule.voucherLoaders, 2) > -1 : (_vm.model.getTicketRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 2,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 商家短信")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.voucherLoaders),
      expression: "model.getTicketRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR3",
      "type": "checkbox"
    },
    domProps: {
      "value": 5,
      "checked": Array.isArray(_vm.model.getTicketRule.voucherLoaders) ? _vm._i(_vm.model.getTicketRule.voucherLoaders, 5) > -1 : (_vm.model.getTicketRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 5,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 二维码")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.voucherLoaders),
      expression: "model.getTicketRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR4",
      "type": "checkbox"
    },
    domProps: {
      "value": 6,
      "checked": Array.isArray(_vm.model.getTicketRule.voucherLoaders) ? _vm._i(_vm.model.getTicketRule.voucherLoaders, 6) > -1 : (_vm.model.getTicketRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 6,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 身份证")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR5"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.voucherLoaders),
      expression: "model.getTicketRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR5",
      "type": "checkbox"
    },
    domProps: {
      "value": 7,
      "checked": Array.isArray(_vm.model.getTicketRule.voucherLoaders) ? _vm._i(_vm.model.getTicketRule.voucherLoaders, 7) > -1 : (_vm.model.getTicketRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 7,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 商家订单号")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR6"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.voucherLoaders),
      expression: "model.getTicketRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR6",
      "type": "checkbox"
    },
    domProps: {
      "value": 3,
      "checked": Array.isArray(_vm.model.getTicketRule.voucherLoaders) ? _vm._i(_vm.model.getTicketRule.voucherLoaders, 3) > -1 : (_vm.model.getTicketRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 3,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 商家邮件")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR7"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.voucherLoaders),
      expression: "model.getTicketRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR7",
      "type": "checkbox"
    },
    domProps: {
      "value": 8,
      "checked": Array.isArray(_vm.model.getTicketRule.voucherLoaders) ? _vm._i(_vm.model.getTicketRule.voucherLoaders, 8) > -1 : (_vm.model.getTicketRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 8,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 手机号")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR8"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.needCertificateSupplement),
      expression: "model.getTicketRule.needCertificateSupplement"
    }],
    attrs: {
      "id": "GTR8",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.getTicketRule.needCertificateSupplement) ? _vm._i(_vm.model.getTicketRule.needCertificateSupplement, null) > -1 : (_vm.model.getTicketRule.needCertificateSupplement)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.needCertificateSupplement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.needCertificateSupplement = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.needCertificateSupplement = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.needCertificateSupplement = $$c
        }
      }
    }
  }), _vm._v(" 凭证补充信息")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab2', 'model.getTicketRule.voucherLoaders')),
      expression: "validateErrors.has('tab2', 'model.getTicketRule.voucherLoaders')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("除了补充信息，至少再选一项")])]) : _vm._e(), _vm._v(" "), (_vm.model.generateTicketMethod == 2) ? _c('div', [_c('label', {
    attrs: {
      "for": "GTR1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.voucherLoaders),
      expression: "model.getTicketRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR1",
      "type": "checkbox"
    },
    domProps: {
      "value": 4,
      "checked": Array.isArray(_vm.model.getTicketRule.voucherLoaders) ? _vm._i(_vm.model.getTicketRule.voucherLoaders, 4) > -1 : (_vm.model.getTicketRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 4,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 商家电子码")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.voucherLoaders),
      expression: "model.getTicketRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR2",
      "type": "checkbox"
    },
    domProps: {
      "value": 2,
      "checked": Array.isArray(_vm.model.getTicketRule.voucherLoaders) ? _vm._i(_vm.model.getTicketRule.voucherLoaders, 2) > -1 : (_vm.model.getTicketRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 2,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 商家短信")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.voucherLoaders),
      expression: "model.getTicketRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR3",
      "type": "checkbox"
    },
    domProps: {
      "value": 6,
      "checked": Array.isArray(_vm.model.getTicketRule.voucherLoaders) ? _vm._i(_vm.model.getTicketRule.voucherLoaders, 6) > -1 : (_vm.model.getTicketRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 6,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 身份证原件")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.needCertificateSupplement),
      expression: "model.getTicketRule.needCertificateSupplement"
    }],
    attrs: {
      "id": "GTR4",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.getTicketRule.needCertificateSupplement) ? _vm._i(_vm.model.getTicketRule.needCertificateSupplement, null) > -1 : (_vm.model.getTicketRule.needCertificateSupplement)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.needCertificateSupplement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.needCertificateSupplement = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.needCertificateSupplement = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.needCertificateSupplement = $$c
        }
      }
    }
  }), _vm._v(" 凭证补充信息")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab2', 'model.getTicketRule.voucherLoaders')),
      expression: "validateErrors.has('tab2', 'model.getTicketRule.voucherLoaders')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("除了补充信息，至少再选一项")])]) : _vm._e(), _vm._v(" "), (_vm.model.generateTicketMethod == 1) ? _c('div', [_c('label', {
    attrs: {
      "for": "GTRMT"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.voucherLoaders),
      expression: "model.getTicketRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTRMT",
      "type": "checkbox"
    },
    domProps: {
      "value": 1,
      "checked": Array.isArray(_vm.model.getTicketRule.voucherLoaders) ? _vm._i(_vm.model.getTicketRule.voucherLoaders, 1) > -1 : (_vm.model.getTicketRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 1,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 美团电子码")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.voucherLoaders),
      expression: "model.getTicketRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR3",
      "type": "checkbox"
    },
    domProps: {
      "value": 6,
      "checked": Array.isArray(_vm.model.getTicketRule.voucherLoaders) ? _vm._i(_vm.model.getTicketRule.voucherLoaders, 6) > -1 : (_vm.model.getTicketRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 6,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 身份证")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getTicketRule.needCertificateSupplement),
      expression: "model.getTicketRule.needCertificateSupplement"
    }],
    attrs: {
      "id": "GTR4",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.getTicketRule.needCertificateSupplement) ? _vm._i(_vm.model.getTicketRule.needCertificateSupplement, null) > -1 : (_vm.model.getTicketRule.needCertificateSupplement)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.getTicketRule.needCertificateSupplement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getTicketRule.needCertificateSupplement = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getTicketRule.needCertificateSupplement = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getTicketRule.needCertificateSupplement = $$c
        }
      }
    }
  }), _vm._v(" 凭证补充信息")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab2', 'model.getTicketRule.voucherLoaders')),
      expression: "validateErrors.has('tab2', 'model.getTicketRule.voucherLoaders')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("除了补充信息，至少再选一项")])]) : _vm._e(), _vm._v(" "), (_vm.model.getTicketRule.needCertificateSupplement) ? _c('div', {
    staticClass: "extra-info-input"
  }, [_c('v-input', {
    directives: [{
      name: "va",
      rawName: "v-va.tab2",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "tab2": true
      }
    }],
    class: {
      'input': true, 'is-danger': _vm.validateErrors.has('tab2', 'model.getTicketRule.certificateSupplement')
    },
    attrs: {
      "placeholder": "如学生证信息",
      "maxlength": 30
    },
    model: {
      value: (_vm.model.getTicketRule.certificateSupplement),
      callback: function($$v) {
        _vm.model.getTicketRule.certificateSupplement = $$v
      },
      expression: "model.getTicketRule.certificateSupplement"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "help-block input-counter"
  }, [_vm._v(_vm._s(_vm.model.getTicketRule.certificateSupplement ? _vm.model.getTicketRule.certificateSupplement.length : 0) + "/30字")])], 1) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab2', 'model.getTicketRule.certificateSupplement')),
      expression: "validateErrors.has('tab2', 'model.getTicketRule.certificateSupplement')"
    }],
    staticClass: "help float-help is-danger"
  }, [_vm._v("补充信息不能为空")])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [_c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "换票时间"
    }
  }, [_vm._l((_vm.model.voucherTimes), function(vTime, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "margin-bottom": "10px",
        "position": "relative"
      }
    }, [(_vm.model.voucherTimes.length > 1) ? _c('span', {
      staticClass: "ticket-step ticket-step-active",
      staticStyle: {
        "margin-top": "4px"
      }
    }, [_vm._v(_vm._s(index + 1))]) : _vm._e(), _vm._v("\n                         从\n                        "), _c('v-select', {
      staticClass: "nano-select inline-input",
      attrs: {
        "placeholder": "请选择"
      },
      on: {
        "change": function($event) {
          _vm.changeTime(index)
        }
      },
      model: {
        value: (_vm.voucherTimes[index].voucherStartTimeHour),
        callback: function($$v) {
          _vm.voucherTimes[index].voucherStartTimeHour = $$v
        },
        expression: "voucherTimes[index].voucherStartTimeHour"
      }
    }, _vm._l((24), function(n) {
      return _c('v-option', {
        key: n,
        attrs: {
          "label": n - 1,
          "value": n - 1
        }
      })
    })), _vm._v("\n                        点\n                        "), _c('v-select', {
      staticClass: "nano-select inline-input",
      attrs: {
        "placeholder": "请选择"
      },
      on: {
        "change": function($event) {
          _vm.changeTime(index)
        }
      },
      model: {
        value: (_vm.voucherTimes[index].voucherStartTimeMinute),
        callback: function($$v) {
          _vm.voucherTimes[index].voucherStartTimeMinute = $$v
        },
        expression: "voucherTimes[index].voucherStartTimeMinute"
      }
    }, _vm._l((_vm.SEPARATED_MINUTE), function(n) {
      return _c('v-option', {
        key: n,
        attrs: {
          "label": (n == 0) ? '00' : n,
          "value": n
        }
      })
    })), _vm._v("\n                        分到\n                        "), _c('v-select', {
      staticClass: "nano-select inline-input",
      attrs: {
        "placeholder": "请选择"
      },
      on: {
        "change": function($event) {
          _vm.changeTime(index)
        }
      },
      model: {
        value: (_vm.voucherTimes[index].voucherEndTimeHour),
        callback: function($$v) {
          _vm.voucherTimes[index].voucherEndTimeHour = $$v
        },
        expression: "voucherTimes[index].voucherEndTimeHour"
      }
    }, _vm._l((24), function(n) {
      return _c('v-option', {
        key: n,
        attrs: {
          "label": n - 1,
          "value": n - 1
        }
      })
    })), _vm._v("\n                        点\n                        "), _c('v-select', {
      staticClass: "nano-select inline-input",
      attrs: {
        "placeholder": "请选择"
      },
      on: {
        "change": function($event) {
          _vm.changeTime(index)
        }
      },
      model: {
        value: (_vm.voucherTimes[index].voucherEndTimeMinute),
        callback: function($$v) {
          _vm.voucherTimes[index].voucherEndTimeMinute = $$v
        },
        expression: "voucherTimes[index].voucherEndTimeMinute"
      }
    }, _vm._l((_vm.SEPARATED_MINUTE), function(n) {
      return _c('v-option', {
        key: n,
        attrs: {
          "label": (n == 0) ? '00' : n,
          "value": n
        }
      })
    })), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'VTNV' + index
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (vTime.needVoucherOrGetInTimeSupplement),
        expression: "vTime.needVoucherOrGetInTimeSupplement"
      }],
      attrs: {
        "id": 'VTNV' + index,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(vTime.needVoucherOrGetInTimeSupplement) ? _vm._i(vTime.needVoucherOrGetInTimeSupplement, null) > -1 : (vTime.needVoucherOrGetInTimeSupplement)
      },
      on: {
        "__c": function($event) {
          var $$a = vTime.needVoucherOrGetInTimeSupplement,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (vTime.needVoucherOrGetInTimeSupplement = $$a.concat($$v))
            } else {
              $$i > -1 && (vTime.needVoucherOrGetInTimeSupplement = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            vTime.needVoucherOrGetInTimeSupplement = $$c
          }
        }
      }
    }), _vm._v(" 补充信息")]), _vm._v(" "), (_vm.mode != 'readonly' && _vm.model.voucherTimes.length > 1) ? _c('div', {
      staticClass: "icon-button delete icon-cancel",
      on: {
        "click": function($event) {
          _vm.deleteOneVoucherTime(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.mode !== 'readonly' && _vm.model.voucherTimes.length < 3 && index === _vm.model.voucherTimes.length - 1) ? _c('div', {
      staticClass: "icon-button icon-plus-circle",
      on: {
        "click": _vm.addOneVoucherTime
      }
    }) : _vm._e(), _vm._v(" "), (vTime.needVoucherOrGetInTimeSupplement) ? _c('div', {
      staticClass: "extra-info-input"
    }, [_c('v-input', {
      directives: [{
        name: "va",
        rawName: "v-va.tab2",
        value: ('required'),
        expression: "'required'",
        modifiers: {
          "tab2": true
        }
      }],
      class: {
        'input': true, 'is-danger': _vm.validateErrors.has('tab2', 'vTime.voucherOrGetInTimeSupplement', null, index)
      },
      staticStyle: {
        "margin-top": "10px"
      },
      attrs: {
        "data-key": index,
        "placeholder": "淡旺季信息，淡旺季时间等",
        "maxlength": 30
      },
      model: {
        value: (vTime.voucherOrGetInTimeSupplement),
        callback: function($$v) {
          vTime.voucherOrGetInTimeSupplement = $$v
        },
        expression: "vTime.voucherOrGetInTimeSupplement"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "help-block input-counter"
    }, [_vm._v(_vm._s(vTime.voucherOrGetInTimeSupplement.length) + "/30字")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.validateErrors.has('tab2', 'vTime.voucherOrGetInTimeSupplement', null, index)),
        expression: "validateErrors.has('tab2', 'vTime.voucherOrGetInTimeSupplement', null, index)"
      }],
      staticClass: "help is-danger",
      staticStyle: {
        "margin-top": "-10px"
      }
    }, [_vm._v("勾选后，补充信息必填")])], 1) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.model.voucherTimes.length > 1) ? _c('div', [_c('span', {
    staticClass: "icon-error orange-notice"
  }), _vm._v(" 设置的换票时间要覆盖该产品所有的可用日期")]) : _vm._e()], 2), _vm._v(" "), (_vm.model.needTicket) ? _c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "换票地址"
    }
  }, [_vm._l((_vm.model.ticketGetAddress), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "row extra-info-input"
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('v-input', {
      directives: [{
        name: "va",
        rawName: "v-va.tab2",
        value: ('required'),
        expression: "'required'",
        modifiers: {
          "tab2": true
        }
      }],
      class: {
        'input': true, 'is-danger': _vm.validateErrors.has('tab2', 'model.ticketGetAddress[index]', null, index)
      },
      attrs: {
        "data-key": index,
        "id": "ticketGetAddress",
        "placeholder": "具体到景区大门，无需重复填写景区地址，可附加该地点明显参照物",
        "maxlength": 50
      },
      on: {
        "change": function($event) {
          _vm.ticketGetAddressChanged(index)
        }
      },
      model: {
        value: (_vm.model.ticketGetAddress[index]),
        callback: function($$v) {
          _vm.$set(_vm.model.ticketGetAddress, index, $$v)
        },
        expression: "model.ticketGetAddress[index]"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "help-block input-counter"
    }, [_vm._v(_vm._s(_vm.model.ticketGetAddress[index].length) + "/50字")])], 1), _vm._v(" "), (_vm.model.ticketGetAddress.length > 1) ? _c('div', {
      staticClass: "icon-button delete icon-cancel",
      staticStyle: {
        "margin-left": "0"
      },
      on: {
        "click": function($event) {
          _vm.deleteTicketGetAddress(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.validateErrors.has('tab2', 'model.ticketGetAddress[index]', null, index)),
        expression: "validateErrors.has('tab2','model.ticketGetAddress[index]', null,index)"
      }],
      staticClass: "help float-help is-danger",
      staticStyle: {
        "padding-left": "15px"
      }
    }, [_vm._v("换票地址不能为空")])])
  }), _vm._v(" "), (_vm.mode !== 'readonly') ? _c('div', {
    staticClass: "icon-link-revise",
    on: {
      "click": _vm.newTicketGetAddress
    }
  }, [_c('span', {
    staticClass: "icon-plus-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "mls"
  }, [_vm._v(" 新增换票地址")])]) : _vm._e()], 2) : _vm._e()], 1)], 1) : _c('div', {
    staticClass: "extra-content-block"
  }, [_c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "入园凭证"
    }
  }, [(_vm.model.generateTicketMethod == 3) ? _c('div', [_c('label', {
    attrs: {
      "for": "GTR1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.voucherLoaders),
      expression: "model.getVoucherRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR1",
      "type": "checkbox"
    },
    domProps: {
      "value": 4,
      "checked": Array.isArray(_vm.model.getVoucherRule.voucherLoaders) ? _vm._i(_vm.model.getVoucherRule.voucherLoaders, 4) > -1 : (_vm.model.getVoucherRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 4,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 商家电子码")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.voucherLoaders),
      expression: "model.getVoucherRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR2",
      "type": "checkbox"
    },
    domProps: {
      "value": 2,
      "checked": Array.isArray(_vm.model.getVoucherRule.voucherLoaders) ? _vm._i(_vm.model.getVoucherRule.voucherLoaders, 2) > -1 : (_vm.model.getVoucherRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 2,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 商家短信")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.voucherLoaders),
      expression: "model.getVoucherRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR3",
      "type": "checkbox"
    },
    domProps: {
      "value": 5,
      "checked": Array.isArray(_vm.model.getVoucherRule.voucherLoaders) ? _vm._i(_vm.model.getVoucherRule.voucherLoaders, 5) > -1 : (_vm.model.getVoucherRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 5,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 二维码")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.voucherLoaders),
      expression: "model.getVoucherRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR4",
      "type": "checkbox"
    },
    domProps: {
      "value": 6,
      "checked": Array.isArray(_vm.model.getVoucherRule.voucherLoaders) ? _vm._i(_vm.model.getVoucherRule.voucherLoaders, 6) > -1 : (_vm.model.getVoucherRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 6,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 身份证")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR5"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.voucherLoaders),
      expression: "model.getVoucherRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR5",
      "type": "checkbox"
    },
    domProps: {
      "value": 7,
      "checked": Array.isArray(_vm.model.getVoucherRule.voucherLoaders) ? _vm._i(_vm.model.getVoucherRule.voucherLoaders, 7) > -1 : (_vm.model.getVoucherRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 7,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 商家订单号")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR6"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.voucherLoaders),
      expression: "model.getVoucherRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR6",
      "type": "checkbox"
    },
    domProps: {
      "value": 3,
      "checked": Array.isArray(_vm.model.getVoucherRule.voucherLoaders) ? _vm._i(_vm.model.getVoucherRule.voucherLoaders, 3) > -1 : (_vm.model.getVoucherRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 3,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 商家邮件")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR7"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.voucherLoaders),
      expression: "model.getVoucherRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR7",
      "type": "checkbox"
    },
    domProps: {
      "value": 8,
      "checked": Array.isArray(_vm.model.getVoucherRule.voucherLoaders) ? _vm._i(_vm.model.getVoucherRule.voucherLoaders, 8) > -1 : (_vm.model.getVoucherRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 8,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 手机号")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR8"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.needCertificateSupplement),
      expression: "model.getVoucherRule.needCertificateSupplement"
    }],
    attrs: {
      "id": "GTR8",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.getVoucherRule.needCertificateSupplement) ? _vm._i(_vm.model.getVoucherRule.needCertificateSupplement, null) > -1 : (_vm.model.getVoucherRule.needCertificateSupplement)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.needCertificateSupplement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.needCertificateSupplement = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.needCertificateSupplement = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.needCertificateSupplement = $$c
        }
      }
    }
  }), _vm._v(" 凭证补充信息")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab2', 'model.getVoucherRule.voucherLoaders')),
      expression: "validateErrors.has('tab2', 'model.getVoucherRule.voucherLoaders')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("除了补充信息，至少再选一项")])]) : _vm._e(), _vm._v(" "), (_vm.model.generateTicketMethod == 2) ? _c('div', [_c('label', {
    attrs: {
      "for": "GTR1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.voucherLoaders),
      expression: "model.getVoucherRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR1",
      "type": "checkbox"
    },
    domProps: {
      "value": 4,
      "checked": Array.isArray(_vm.model.getVoucherRule.voucherLoaders) ? _vm._i(_vm.model.getVoucherRule.voucherLoaders, 4) > -1 : (_vm.model.getVoucherRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 4,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 商家电子码")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.voucherLoaders),
      expression: "model.getVoucherRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR2",
      "type": "checkbox"
    },
    domProps: {
      "value": 2,
      "checked": Array.isArray(_vm.model.getVoucherRule.voucherLoaders) ? _vm._i(_vm.model.getVoucherRule.voucherLoaders, 2) > -1 : (_vm.model.getVoucherRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 2,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 商家短信")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.voucherLoaders),
      expression: "model.getVoucherRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR3",
      "type": "checkbox"
    },
    domProps: {
      "value": 6,
      "checked": Array.isArray(_vm.model.getVoucherRule.voucherLoaders) ? _vm._i(_vm.model.getVoucherRule.voucherLoaders, 6) > -1 : (_vm.model.getVoucherRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 6,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 身份证原件")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.needCertificateSupplement),
      expression: "model.getVoucherRule.needCertificateSupplement"
    }],
    attrs: {
      "id": "GTR4",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.getVoucherRule.needCertificateSupplement) ? _vm._i(_vm.model.getVoucherRule.needCertificateSupplement, null) > -1 : (_vm.model.getVoucherRule.needCertificateSupplement)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.needCertificateSupplement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.needCertificateSupplement = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.needCertificateSupplement = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.needCertificateSupplement = $$c
        }
      }
    }
  }), _vm._v(" 凭证补充信息")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab2', 'model.getVoucherRule.voucherLoaders')),
      expression: "validateErrors.has('tab2', 'model.getVoucherRule.voucherLoaders')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("除了补充信息，至少再选一项")])]) : _vm._e(), _vm._v(" "), (_vm.model.generateTicketMethod == 1) ? _c('div', [_c('label', {
    attrs: {
      "for": "GTRMT"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.voucherLoaders),
      expression: "model.getVoucherRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTRMT",
      "type": "checkbox"
    },
    domProps: {
      "value": 1,
      "checked": Array.isArray(_vm.model.getVoucherRule.voucherLoaders) ? _vm._i(_vm.model.getVoucherRule.voucherLoaders, 1) > -1 : (_vm.model.getVoucherRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 1,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 美团电子码")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.voucherLoaders),
      expression: "model.getVoucherRule.voucherLoaders"
    }],
    attrs: {
      "id": "GTR3",
      "type": "checkbox"
    },
    domProps: {
      "value": 6,
      "checked": Array.isArray(_vm.model.getVoucherRule.voucherLoaders) ? _vm._i(_vm.model.getVoucherRule.voucherLoaders, 6) > -1 : (_vm.model.getVoucherRule.voucherLoaders)
    },
    on: {
      "change": _vm.voucherLoaderChanged,
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.voucherLoaders,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 6,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.voucherLoaders = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.voucherLoaders = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.voucherLoaders = $$c
        }
      }
    }
  }), _vm._v(" 身份证原件")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "GTR4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.getVoucherRule.needCertificateSupplement),
      expression: "model.getVoucherRule.needCertificateSupplement"
    }],
    attrs: {
      "id": "GTR4",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.getVoucherRule.needCertificateSupplement) ? _vm._i(_vm.model.getVoucherRule.needCertificateSupplement, null) > -1 : (_vm.model.getVoucherRule.needCertificateSupplement)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.getVoucherRule.needCertificateSupplement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.getVoucherRule.needCertificateSupplement = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.getVoucherRule.needCertificateSupplement = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.getVoucherRule.needCertificateSupplement = $$c
        }
      }
    }
  }), _vm._v(" 凭证补充信息")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab2', 'model.getVoucherRule.voucherLoaders')),
      expression: "validateErrors.has('tab2', 'model.getVoucherRule.voucherLoaders')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("除了补充信息，至少再选一项")])]) : _vm._e(), _vm._v(" "), (_vm.model.getVoucherRule.needCertificateSupplement) ? _c('div', {
    staticClass: "extra-info-input"
  }, [_c('v-input', {
    directives: [{
      name: "va",
      rawName: "v-va.tab2",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "tab2": true
      }
    }],
    class: {
      'input': true, 'is-danger': _vm.validateErrors.has('tab2', 'model.getVoucherRule.certificateSupplement')
    },
    attrs: {
      "placeholder": "如学生证信息",
      "maxlength": 30
    },
    model: {
      value: (_vm.model.getVoucherRule.certificateSupplement),
      callback: function($$v) {
        _vm.model.getVoucherRule.certificateSupplement = $$v
      },
      expression: "model.getVoucherRule.certificateSupplement"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "help-block input-counter"
  }, [_vm._v(_vm._s(_vm.model.getVoucherRule.certificateSupplement ? _vm.model.getVoucherRule.certificateSupplement.length : 0) + "/30字")])], 1) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab2', 'model.getVoucherRule.certificateSupplement')),
      expression: "validateErrors.has('tab2', 'model.getVoucherRule.certificateSupplement')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("补充信息不能为空")])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [_c('content-block', {
    attrs: {
      "isRequired": "",
      "title": "入园时间"
    }
  }, [_vm._l((_vm.model.voucherTimes), function(vTime, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "margin-bottom": "10px",
        "position": "relative"
      }
    }, [(_vm.model.voucherTimes.length > 1) ? _c('span', {
      staticClass: "ticket-step ticket-step-active",
      staticStyle: {
        "margin-top": "4px"
      }
    }, [_vm._v(_vm._s(index + 1))]) : _vm._e(), _vm._v("\n                         从\n                        "), _c('v-select', {
      staticClass: "nano-select inline-input",
      attrs: {
        "placeholder": "请选择"
      },
      on: {
        "change": function($event) {
          _vm.changeTime(index)
        }
      },
      model: {
        value: (_vm.voucherTimes[index].voucherStartTimeHour),
        callback: function($$v) {
          _vm.voucherTimes[index].voucherStartTimeHour = $$v
        },
        expression: "voucherTimes[index].voucherStartTimeHour"
      }
    }, _vm._l((24), function(n) {
      return _c('v-option', {
        key: n,
        attrs: {
          "label": n - 1,
          "value": n - 1
        }
      })
    })), _vm._v("\n                        点\n                        "), _c('v-select', {
      staticClass: "nano-select inline-input",
      attrs: {
        "placeholder": "请选择"
      },
      on: {
        "change": function($event) {
          _vm.changeTime(index)
        }
      },
      model: {
        value: (_vm.voucherTimes[index].voucherStartTimeMinute),
        callback: function($$v) {
          _vm.voucherTimes[index].voucherStartTimeMinute = $$v
        },
        expression: "voucherTimes[index].voucherStartTimeMinute"
      }
    }, _vm._l((_vm.SEPARATED_MINUTE), function(n) {
      return _c('v-option', {
        key: n,
        attrs: {
          "label": (n == 0) ? '00' : n,
          "value": n
        }
      })
    })), _vm._v("\n                        分到\n                        "), _c('v-select', {
      staticClass: "nano-select inline-input",
      attrs: {
        "placeholder": "请选择"
      },
      on: {
        "change": function($event) {
          _vm.changeTime(index)
        }
      },
      model: {
        value: (_vm.voucherTimes[index].voucherEndTimeHour),
        callback: function($$v) {
          _vm.voucherTimes[index].voucherEndTimeHour = $$v
        },
        expression: "voucherTimes[index].voucherEndTimeHour"
      }
    }, _vm._l((24), function(n) {
      return _c('v-option', {
        key: n,
        attrs: {
          "label": n - 1,
          "value": n - 1
        }
      })
    })), _vm._v("\n                        点\n                        "), _c('v-select', {
      staticClass: "nano-select inline-input",
      attrs: {
        "placeholder": "请选择"
      },
      on: {
        "change": function($event) {
          _vm.changeTime(index)
        }
      },
      model: {
        value: (_vm.voucherTimes[index].voucherEndTimeMinute),
        callback: function($$v) {
          _vm.voucherTimes[index].voucherEndTimeMinute = $$v
        },
        expression: "voucherTimes[index].voucherEndTimeMinute"
      }
    }, _vm._l((_vm.SEPARATED_MINUTE), function(n) {
      return _c('v-option', {
        key: n,
        attrs: {
          "label": (n == 0) ? '00' : n,
          "value": n
        }
      })
    })), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'VTNV' + index
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (vTime.needVoucherOrGetInTimeSupplement),
        expression: "vTime.needVoucherOrGetInTimeSupplement"
      }],
      attrs: {
        "id": 'VTNV' + index,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(vTime.needVoucherOrGetInTimeSupplement) ? _vm._i(vTime.needVoucherOrGetInTimeSupplement, null) > -1 : (vTime.needVoucherOrGetInTimeSupplement)
      },
      on: {
        "__c": function($event) {
          var $$a = vTime.needVoucherOrGetInTimeSupplement,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (vTime.needVoucherOrGetInTimeSupplement = $$a.concat($$v))
            } else {
              $$i > -1 && (vTime.needVoucherOrGetInTimeSupplement = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            vTime.needVoucherOrGetInTimeSupplement = $$c
          }
        }
      }
    }), _vm._v(" 补充信息")]), _vm._v(" "), (_vm.model.voucherTimes.length > 1) ? _c('div', {
      staticClass: "icon-button delete icon-cancel",
      on: {
        "click": function($event) {
          _vm.deleteOneVoucherTime(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.mode !== 'readonly' && _vm.model.voucherTimes.length < 3 && index === _vm.model.voucherTimes.length - 1) ? _c('div', {
      staticClass: "icon-button icon-plus-circle",
      on: {
        "click": _vm.addOneVoucherTime
      }
    }) : _vm._e(), _vm._v(" "), (vTime.needVoucherOrGetInTimeSupplement) ? _c('div', {
      staticClass: "extra-info-input"
    }, [_c('v-input', {
      directives: [{
        name: "va",
        rawName: "v-va.tab2",
        value: ('required'),
        expression: "'required'",
        modifiers: {
          "tab2": true
        }
      }],
      class: {
        'input': true, 'is-danger': _vm.validateErrors.has('tab2', 'vTime.voucherOrGetInTimeSupplement', null, index)
      },
      staticStyle: {
        "margin-top": "10px"
      },
      attrs: {
        "data-key": index,
        "placeholder": "淡旺季信息，淡旺季时间等",
        "maxlength": 30
      },
      model: {
        value: (vTime.voucherOrGetInTimeSupplement),
        callback: function($$v) {
          vTime.voucherOrGetInTimeSupplement = $$v
        },
        expression: "vTime.voucherOrGetInTimeSupplement"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "help-block input-counter"
    }, [_vm._v(_vm._s(vTime.voucherOrGetInTimeSupplement.length) + "/30字")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.validateErrors.has('tab2', 'vTime.voucherOrGetInTimeSupplement', null, index)),
        expression: "validateErrors.has('tab2', 'vTime.voucherOrGetInTimeSupplement', null, index)"
      }],
      staticClass: "help is-danger",
      staticStyle: {
        "margin-top": "-10px"
      }
    }, [_vm._v("勾选后，补充信息必填")])], 1) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.model.voucherTimes.length > 1) ? _c('div', [_c('span', {
    staticClass: "icon-error orange-notice"
  }), _vm._v(" 设置的入园时间要覆盖该产品所有的可用日期")]) : _vm._e()], 2), _vm._v(" "), _c('content-block', {
    attrs: {
      "title": "入园地址",
      "isRequired": ""
    }
  }, [_vm._l((_vm.model.getInAddresses), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "row",
      staticStyle: {
        "position": "relative",
        "margin-bottom": "10px"
      }
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('v-input', {
      directives: [{
        name: "va",
        rawName: "v-va.tab2",
        value: ('required'),
        expression: "'required'",
        modifiers: {
          "tab2": true
        }
      }],
      class: {
        'input': true, 'is-danger': _vm.validateErrors.has('tab2', 'model.getInAddresses[index]', null, index)
      },
      attrs: {
        "data-key": index,
        "placeholder": "具体到景区大门，无需重复填写景区地址，可附加该地点明显参照物",
        "maxlength": 50
      },
      model: {
        value: (_vm.model.getInAddresses[index]),
        callback: function($$v) {
          _vm.$set(_vm.model.getInAddresses, index, $$v)
        },
        expression: "model.getInAddresses[index]"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "help-block input-counter"
    }, [_vm._v(_vm._s(_vm.model.getInAddresses[index].length) + "/50字")])], 1), _vm._v(" "), (_vm.mode !== 'readonly' && _vm.model.getInAddresses.length > 1) ? _c('div', {
      staticClass: "icon-button delete icon-cancel",
      staticStyle: {
        "margin-left": "0"
      },
      on: {
        "click": function($event) {
          _vm.deleteGetInAddresses(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.validateErrors.has('tab2', 'model.getInAddresses[index]', null, index)),
        expression: "validateErrors.has('tab2','model.getInAddresses[index]', null,index)"
      }],
      staticClass: "help float-help is-danger",
      staticStyle: {
        "padding-left": "15px"
      }
    }, [_vm._v("入园地址不能为空")])])
  }), _vm._v(" "), (_vm.mode !== 'readonly') ? _c('div', {
    staticClass: "icon-link-revise",
    on: {
      "click": _vm.newGetInAddresses
    }
  }, [_c('span', {
    staticClass: "icon-plus-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "mls"
  }, [_vm._v(" 新增入园地址")])]) : _vm._e()], 2)], 1)], 1)]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [(_vm.model.needTicket) ? _c('content-block', {
    attrs: {
      "title": "入园地址"
    }
  }, [_vm._l((_vm.model.getInAddresses), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "row",
      staticStyle: {
        "position": "relative",
        "margin-bottom": "10px"
      }
    }, [_c('div', {
      staticClass: "col-sm-11"
    }, [_c('v-input', {
      staticStyle: {
        "padding-right": "55px"
      },
      attrs: {
        "placeholder": "具体到景区大门，无需重复填写景区地址，可附加该地点明显参照物",
        "maxlength": 80
      },
      model: {
        value: (_vm.model.getInAddresses[index]),
        callback: function($$v) {
          _vm.$set(_vm.model.getInAddresses, index, $$v)
        },
        expression: "model.getInAddresses[index]"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "help-block input-counter"
    }, [_vm._v(_vm._s(_vm.model.getInAddresses[index].length) + "/80字")])], 1), _vm._v(" "), (_vm.mode !== 'readonly' && _vm.model.getInAddresses.length > 1) ? _c('div', {
      staticClass: "icon-button delete icon-cancel",
      staticStyle: {
        "margin-left": "0"
      },
      on: {
        "click": function($event) {
          _vm.deleteGetInAddresses(index)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.mode !== 'readonly') ? _c('div', {
    staticClass: "icon-link-revise",
    on: {
      "click": _vm.newGetInAddresses
    }
  }, [_c('span', {
    staticClass: "icon-plus-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "mls"
  }, [_vm._v(" 新增入园地址")])]) : _vm._e()], 2) : _vm._e()], 1)], 1), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly' && !_vm.isTuan
    }
  }, [_c('content-block', {
    attrs: {
      "title": "其他说明"
    }
  }, [_c('v-input', {
    directives: [{
      name: "textarea-check",
      rawName: "v-textarea-check"
    }],
    staticClass: "custom-textarea",
    attrs: {
      "type": "textarea",
      "rows": 5,
      "maxlength": 1000,
      "placeholder": "选填，已在其他栏填写过的信息请勿重复填写，否则产品可能被审核人员驳回"
    },
    model: {
      value: (_vm.model.otherNote),
      callback: function($$v) {
        _vm.model.otherNote = $$v
      },
      expression: "model.otherNote"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "help-block textarea-counter",
    class: {
      'textarea-counter-red': _vm.model.otherNote.length > 1000 ? true : false
    }
  }, [_vm._v(_vm._s(_vm.model.otherNote.length) + "/1000字")]), _vm._v(" "), _c('span', {
    staticClass: "help is-danger",
    staticStyle: {
      "display": "none"
    }
  })], 1)], 1)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 500 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ed40704","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/ticket/product/item/Info.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 501 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ed40704","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/ticket/product/item/Info.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 502 */
/*!*******************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/ticket/product/item/Info.vue ***!
  \*******************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = __webpack_require__(/*! babel-runtime/helpers/typeof */ 116);

var _typeof3 = _interopRequireDefault(_typeof2);

var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ 22);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(/*! babel-runtime/helpers/asyncToGenerator */ 23);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _ticket = __webpack_require__(/*! api/ticket */ 50);

var _ticket2 = __webpack_require__(/*! data/ticket */ 155);

var _index = __webpack_require__(/*! components/input-number-custom/index.vue */ 115);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(/*! components/content-block/index.vue */ 76);

var _index4 = _interopRequireDefault(_index3);

var _upload = __webpack_require__(/*! components/custom-upload/upload.vue */ 233);

var _upload2 = _interopRequireDefault(_upload);

var _discountDes = __webpack_require__(/*! components/product/discountDes.vue */ 527);

var _discountDes2 = _interopRequireDefault(_discountDes);

var _dealAndContract = __webpack_require__(/*! components/product/dealAndContract.vue */ 531);

var _dealAndContract2 = _interopRequireDefault(_dealAndContract);

var _supplierProtocol = __webpack_require__(/*! components/product/supplierProtocol.vue */ 535);

var _supplierProtocol2 = _interopRequireDefault(_supplierProtocol);

var _env = __webpack_require__(/*! config/env.conf */ 2);

var _vuex = __webpack_require__(/*! vuex */ 14);

var _helpers = __webpack_require__(/*! helpers */ 16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        CustomInputNumber: _index2.default,
        CustomUpload: _upload2.default,
        ContentBlock: _index4.default,
        DiscountDes: _discountDes2.default,
        DealAndContract: _dealAndContract2.default,
        SupplierProtocol: _supplierProtocol2.default
    },
    data: function data() {
        return {
            apiHost: _env.apiHost,
            crowdOptionsMap: {},
            mtCategories: _ticket2.categories,
            usePeopleTypes: _ticket2.usePeopleTypes,
            timeLimitedRangeTypes: _ticket2.timeLimitedRangeTypes,
            uploadMaterialTypes: _ticket2.uploadMaterialTypes,
            cities: [],
            poi: [],
            selectedCity: '',
            msg: '',
            poiname: '',
            lastTime: 0,
            ticketTypeList: [],
            ticketType: '',
            timeStr1: '',
            timeSelectVisible: false,
            dialogVisible: false,
            phoneDialogVisible: false,
            ticketAdvices: [],
            ticketTypeStatusInfo: null,
            servicePhone: [],
            selectedPhone: [],
            originImgList: [],
            originTicketImgList: [],
            onlineBefore: false,
            PAGE: 'tab1',
            poiInfo: {}
        };
    },

    props: {
        model: {
            type: Object,
            required: true
        },
        mode: {
            type: String,
            required: true
        },
        extra: {
            type: Object,
            required: true
        },
        validate: {
            type: Boolean,
            required: true
        },
        errors: {
            type: Array,
            required: true
        },
        isTuan: {
            type: Boolean,
            default: false
        },
        readonly: Boolean,
        loaded: Boolean
    },
    methods: Object.assign({}, (0, _vuex.mapActions)(['login', 'getUser']), (0, _vuex.mapGetters)(['user']), {
        getPoiList: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(keyWord) {
                var startTime, res;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                startTime = new Date().getMilliseconds();

                                this.lastTime = startTime;
                                _context.next = 4;
                                return (0, _ticket.searchPoi)({
                                    cityLocationId: this.selectedCity,
                                    feclient: 'lvyou_web',
                                    keyword: keyWord,
                                    count: 20,
                                    page: 1
                                });

                            case 4:
                                res = _context.sent;

                                if (startTime === this.lastTime) {
                                    if (res && res.data && res.data.length && startTime === this.lastTime) {
                                        this.poi = res.data;
                                    } else {
                                        this.poi = [];
                                    }
                                }

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function getPoiList(_x) {
                return _ref.apply(this, arguments);
            }

            return getPoiList;
        }(),
        clicked: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(poi) {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!poi) {
                                    _context2.next = 6;
                                    break;
                                }

                                this.model.ticketCategory.poi.push(poi);
                                this.msg = '';
                                // 清空已选票种
                                this.ticketType = '';
                                _context2.next = 6;
                                return this.searchForTicketType();

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function clicked(_x2) {
                return _ref2.apply(this, arguments);
            }

            return clicked;
        }(),
        handleTagClose: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(index) {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                this.model.ticketCategory.poi.splice(index, 1);
                                // 清空选项
                                this.ticketType = '';
                                _context3.next = 4;
                                return this.searchForTicketType();

                            case 4:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function handleTagClose(_x3) {
                return _ref3.apply(this, arguments);
            }

            return handleTagClose;
        }(),
        searchForTicketType: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
                var searchPois, i, mdcPoiIds, poiNotice, alertErrorMsg, _i, certificateInfo, poi, res, _i2, subTicketList, ticketId, ticketName, j;

                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                if (!(this.model.ticketCategory && this.model.ticketCategory.poi.length > 0)) {
                                    _context4.next = 28;
                                    break;
                                }

                                // 准备poi字符串
                                searchPois = [];

                                for (i = 0; i < this.model.ticketCategory.poi.length; i++) {
                                    searchPois.push(this.model.ticketCategory.poi[i].mdcPoiId);
                                }
                                mdcPoiIds = searchPois.join(',');
                                // 父子门票接口

                                _context4.next = 6;
                                return (0, _ticket.getTicketParenthoodAdvice)(mdcPoiIds);

                            case 6:
                                poiNotice = _context4.sent;

                                this.ticketAdvices = [];
                                if (poiNotice && poiNotice.data && poiNotice.data.length > 0) {
                                    alertErrorMsg = '';

                                    for (_i = 0; _i < poiNotice.data.length; _i++) {
                                        this.ticketAdvices.push({
                                            type: poiNotice.data[_i].parentChildRelation,
                                            message: poiNotice.data[_i].advice
                                        });
                                        if (poiNotice.data[_i].parentChildRelation === 3) {
                                            alertErrorMsg += poiNotice.data[_i].advice + "\n";
                                        }
                                    }
                                    console.log('poiNotice error', alertErrorMsg);
                                    /*
                                    if (alertErrorMsg.length > 0) {
                                        this.$notify.error({
                                            title: '错误',
                                            message: alertErrorMsg
                                        });
                                    }
                                    */
                                }
                                // 授权书接口
                                _context4.next = 11;
                                return (0, _ticket.getCertificateValidate)(mdcPoiIds, this.extra.supplierId);

                            case 11:
                                certificateInfo = _context4.sent;

                                this.ticketTypeStatusInfo = certificateInfo.data;
                                if (this.ticketTypeStatusInfo.isNeed && this.ticketTypeStatusInfo.certificateInfos && this.ticketTypeStatusInfo.certificateInfos.length > 0) {
                                    poi = this.ticketTypeStatusInfo.certificateInfos[0];

                                    this.certificateCreateUrl = '/#/ticket/product/list-certificate?poiId=' + poi.poiId + '&poiName=' + encodeURIComponent(poi.poiName);
                                } else {
                                    this.certificateCreateUrl = null;
                                }
                                // 门票票种接口
                                res = {};
                                _context4.prev = 15;
                                _context4.next = 18;
                                return (0, _ticket.searchTicket)({
                                    feclient: 'lvyou_web',
                                    keyword: '',
                                    mdcPoiIds: mdcPoiIds
                                });

                            case 18:
                                res = _context4.sent;
                                _context4.next = 24;
                                break;

                            case 21:
                                _context4.prev = 21;
                                _context4.t0 = _context4['catch'](15);

                                if (_context4.t0.message) {
                                    this.$alert({
                                        title: '错误',
                                        message: _context4.t0.message,
                                        showCancelButton: false,
                                        closeOnClickModal: false
                                    });
                                }

                            case 24:

                                this.ticketTypeList = [];
                                if (res && res.status === 0 && res.data && res.data.length > 0) {
                                    for (_i2 = 0; _i2 < res.data.length; _i2++) {
                                        this.ticketTypeList.push({
                                            disabled: true,
                                            label: res.data[_i2].name,
                                            value: res.data[_i2].ticketId
                                        });
                                        if (res.data[_i2].subTicketCategoryInfoList && res.data[_i2].subTicketCategoryInfoList.length > 0) {
                                            subTicketList = res.data[_i2].subTicketCategoryInfoList;
                                            ticketId = res.data[_i2].ticketId;
                                            ticketName = res.data[_i2].name;

                                            for (j = 0; j < subTicketList.length; j++) {
                                                this.ticketTypeList.push({
                                                    label: subTicketList[j].name,
                                                    value: {
                                                        ticketId: ticketId,
                                                        ticketName: ticketName,
                                                        subTicketId: subTicketList[j].ticketId,
                                                        subTicketName: subTicketList[j].name
                                                    }
                                                });
                                            }
                                        }
                                    }
                                }
                                _context4.next = 29;
                                break;

                            case 28:
                                this.ticketAdvices = [];

                            case 29:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this, [[15, 21]]);
            }));

            function searchForTicketType() {
                return _ref4.apply(this, arguments);
            }

            return searchForTicketType;
        }(),
        onError: function onError(e) {
            this.$notify.error({
                title: '错误',
                message: '上传失败，请稍后重试'
            });
        },
        onSuccess: function onSuccess(e) {
            this.model.dealImageInfos.push({
                imageName: e.file.name,
                imageUrl: e.data.data.url,
                frontImage: false
            });
            for (var i = 0; i < this.model.dealImageInfos.length; i++) {
                if (i === 0) {
                    this.model.dealImageInfos[i].frontImage = true;
                } else {
                    this.model.dealImageInfos[i].frontImage = false;
                }
            }
        },
        onTicketUploadSuccess: function onTicketUploadSuccess(e) {
            this.model.ticketCategory.createTicketCategoryInfo.uploadMaterialImage.push({
                imageName: e.file.name,
                imageUrl: e.data.data.url
            });
        },
        onDelete: function onDelete(e) {
            var url = '';
            if (e.file) {
                url = e.file.url;
            } else {
                url = e.url;
            }
            for (var i = 0; i < this.model.dealImageInfos.length; i++) {
                if (url === this.model.dealImageInfos[i].imageUrl) {
                    this.model.dealImageInfos.splice(i, 1);
                }
            }
        },
        onTicketUploadDelete: function onTicketUploadDelete(e) {
            var url = '';
            if (e.file) {
                url = e.file.url;
            } else {
                url = e.url;
            }
            for (var i = 0; i < this.model.ticketCategory.createTicketCategoryInfo.uploadMaterialImage.length; i++) {
                if (url === this.model.ticketCategory.createTicketCategoryInfo.uploadMaterialImage[i].imageUrl) {
                    this.model.ticketCategory.createTicketCategoryInfo.uploadMaterialImage.splice(i, 1);
                }
            }
        },
        onMaxLimit: function onMaxLimit(e) {
            this.$notify.error({
                title: '错误',
                message: '最多只能上传5张物料'
            });
        },
        onSizeLimited: function onSizeLimited(e) {
            this.$message({
                showClose: true,
                message: '最多只能上传2M的物料',
                type: 'error',
                duration: 10000
            });
        },
        askForNewTicketType: function askForNewTicketType() {
            if (this.model.ticketCategory.poi.length > 0) {
                this.dialogVisible = true;
            }
        },
        saveNewTicketType: function saveNewTicketType() {
            // 临时的数据判断
            var createInfo = this.model.ticketCategory.createTicketCategoryInfo;
            if (createInfo.ticketCategoryName.trim() === '' || createInfo.ticketCategoryPrice === '' || createInfo.ticketCategoryPrice <= 0 || createInfo.timeLimitedRange === 0 && createInfo.timeLimitedRangeText.trim() === '' || (createInfo.uploadMaterialType === 1 || createInfo.uploadMaterialType === 3) && createInfo.uploadMaterialText.trim() === '' || (createInfo.uploadMaterialType === 2 || createInfo.uploadMaterialType === 3) && createInfo.uploadMaterialImage.length <= 0) {
                var message = '请将信息填写完整';
                if (createInfo.ticketCategoryPrice <= 0 || createInfo.ticketCategoryPrice === '') {
                    message = '请输入正确的市场价';
                }
                this.$message({
                    showClose: true,
                    message: message,
                    type: 'error',
                    duration: 10000
                });
            } else {
                var decimal = createInfo.ticketCategoryPrice.toString().split('.')[1];
                if (decimal && decimal.length > 2) {
                    this.$message({
                        showClose: true,
                        message: '请输入正确的市场价',
                        type: 'error',
                        duration: 10000
                    });
                } else {
                    this.ticketType = createInfo.ticketCategoryName;
                    var ticketName = '';
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = _ticket2.usePeopleTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var type = _step.value;

                            if (type.value === this.model.ticketCategory.createTicketCategoryInfo.usePeople) {
                                ticketName = type.label;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    if (!this.extra.isDirectDeal) {
                        this.initCrowdOptionsByTicketName(ticketName);
                    }
                    this.model.ticketCategory.subTicket = {};
                    this.model.ticketCategory.ticket = {};
                    this.dialogVisible = false;
                    if (!this.model.marketPrice) {
                        this.model.marketPrice = createInfo.ticketCategoryPrice;
                    }
                }
            }
        },
        newIncludeItems: function newIncludeItems(index) {
            this.model.includeItems.splice(index + 1, 0, {
                name: '',
                count: 1,
                unit: '',
                timeLength: null
            });
            this.model.availableCount = 1;
            this.includeErrorCheck();
        },
        deleteIncludeItems: function deleteIncludeItems(index) {
            this.model.includeItems.splice(index, 1);
            if (this.model.includeItems.length <= 1) {
                this.model.isAllAvailable = true;
            }
            this.model.availableCount = 1;
            this.includeErrorCheck();
        },
        upIncludeItems: function upIncludeItems(index) {
            var temp = Object.assign(this.model.includeItems[index], {});
            this.$set(this.model.includeItems, index, Object.assign(this.model.includeItems[index - 1], {}));
            this.$set(this.model.includeItems, index - 1, Object.assign(temp, {}));
        },
        downIncludeItems: function downIncludeItems(index) {
            var temp = Object.assign(this.model.includeItems[index], {});
            this.$set(this.model.includeItems, index, Object.assign(this.model.includeItems[index + 1], {}));
            this.$set(this.model.includeItems, index + 1, Object.assign(temp, {}));
        },
        newServicePhone: function newServicePhone() {
            if (this.model.servicePhones.length < 3) {
                this.model.servicePhones.push({
                    phone: '',
                    startHour: '9',
                    startMin: '0',
                    endHour: '18',
                    endMin: '0'
                });
            }
        },
        newServicePhoneFromContract: function newServicePhoneFromContract() {
            this.phoneDialogVisible = true;
        },
        saveServicePhoneFromContract: function saveServicePhoneFromContract() {
            if (this.selectedPhone.length + this.model.servicePhones.length > 3) {
                alert('\u6700\u591A\u8FD8\u53EF\u9009' + (3 - this.model.servicePhones.length) + '\u4E2A\u7535\u8BDD');
            } else {
                for (var i = 0; i < this.selectedPhone.length; i++) {
                    var phone = Object.assign({}, this.selectedPhone[i]);
                    this.model.servicePhones.push(phone);
                }
                this.phoneDialogVisible = false;
            }
        },
        deleteOneServicePhone: function deleteOneServicePhone(index) {
            this.model.servicePhones.splice(index, 1);
        },
        onSetHeadImage: function onSetHeadImage(file) {
            var index = 0;
            var url = '';
            if (file.file) {
                url = file.file.url;
            } else {
                url = file.url;
            }

            for (var i = 0; i < this.model.dealImageInfos.length; i++) {
                if (url === this.model.dealImageInfos[i].imageUrl) {
                    index = i;
                }
                this.model.dealImageInfos[i].frontImage = false;
            }
            var temp = this.model.dealImageInfos[index];
            this.model.dealImageInfos.splice(index, 1);

            this.model.dealImageInfos.unshift(temp);
            this.model.dealImageInfos[0].frontImage = true;
        },
        // 更新优惠人群选项
        updateCrowdOptions: function () {
            var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
                var pois = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

                var poiInfo, poiIds, _ref6, data;

                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                poiInfo = {};
                                poiIds = pois.map(function (poi) {
                                    poiInfo[poi.mdcPoiId] = poi;
                                    return poi.mdcPoiId;
                                });

                                poiInfo.poiIds = poiIds;
                                this.poiInfo = poiInfo;

                                if (!pois.length) {
                                    _context5.next = 19;
                                    break;
                                }

                                _context5.prev = 5;
                                _context5.next = 8;
                                return (0, _ticket.getCrowdByPoi)(poiIds);

                            case 8:
                                _ref6 = _context5.sent;
                                data = _ref6.data;

                                this.crowdOptions = data || [];
                                // 初始化优惠人群数据
                                this.initTicketPoiDiscount(this.crowdOptions, poiInfo);
                                _context5.next = 17;
                                break;

                            case 14:
                                _context5.prev = 14;
                                _context5.t0 = _context5['catch'](5);

                                this.crowdOptions = [];

                            case 17:
                                _context5.next = 20;
                                break;

                            case 19:
                                this.crowdOptions = [];

                            case 20:
                                this.model.crowdOptions = this.crowdOptions;

                            case 21:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this, [[5, 14]]);
            }));

            function updateCrowdOptions() {
                return _ref5.apply(this, arguments);
            }

            return updateCrowdOptions;
        }(),
        initTicketPoiDiscount: function initTicketPoiDiscount() {
            var poiCrowdOption = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var poiInfo = arguments[1];
            var poiIds = arguments[2];

            var ticketPoiDiscountMap = {};
            this.model.ticketPoiDiscounts = this.model.ticketPoiDiscounts.forEach(function (item) {
                ticketPoiDiscountMap[item.mdcPoiId] = item.ticketDiscountList;
            });
            this.model.ticketPoiDiscounts = poiCrowdOption.map(function (item) {
                var model = {
                    mdcPoiId: item.mdcPoiId,
                    poiName: poiInfo[item.mdcPoiId].mdcPoiName,
                    options: item.ticketDiscountList
                };
                if (ticketPoiDiscountMap[item.mdcPoiId] && ticketPoiDiscountMap[item.mdcPoiId].length > 0) {
                    model.ticketDiscountList = ticketPoiDiscountMap[item.mdcPoiId];
                } else {
                    model.ticketDiscountList = [{
                        crowd: null,
                        crowdString: '',
                        otherCrowd: null,
                        discountInfo: {
                            policyType: null,
                            preventCondition: null
                        },
                        freeInfo: {
                            policyType: 0,
                            preventCondition: null
                        }
                    }];
                }
                return model;
            });
        },
        initCrowdOptionsByTicketName: function initCrowdOptionsByTicketName(ticketName) {
            var personTypes = _ticket2.ticketName2PersonType[ticketName];
            var pois = [];
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = this.crowdOptions[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var crowd = _step2.value;

                    pois.push(crowd.mdcPoiId);
                    var temp = {
                        mdcPoiId: crowd.mdcPoiId,
                        ticketDiscountList: []
                    };
                    var found = false;
                    if (personTypes && personTypes.length > 0) {
                        var _iteratorNormalCompletion3 = true;
                        var _didIteratorError3 = false;
                        var _iteratorError3 = undefined;

                        try {
                            for (var _iterator3 = personTypes[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                var personType = _step3.value;
                                var _iteratorNormalCompletion4 = true;
                                var _didIteratorError4 = false;
                                var _iteratorError4 = undefined;

                                try {
                                    for (var _iterator4 = crowd.ticketDiscountList[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                        var option = _step4.value;

                                        if (option.crowdString === personType && option.discountInfo.policyType !== 1) {
                                            found = true;
                                            temp.ticketDiscountList.push((0, _helpers.clone)(option));
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError4 = true;
                                    _iteratorError4 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                            _iterator4.return();
                                        }
                                    } finally {
                                        if (_didIteratorError4) {
                                            throw _iteratorError4;
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                    _iterator3.return();
                                }
                            } finally {
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }
                    }
                    if (!found) {
                        temp.ticketDiscountList.push({
                            crowd: null,
                            crowdString: '',
                            otherCrowd: null,
                            discountInfo: {
                                policyType: null,
                                preventCondition: null
                            },
                            freeInfo: {
                                policyType: 0,
                                preventCondition: null
                            }
                        });
                    }
                    this.model.ticketPoiDiscounts.push(temp);
                }
                // 准备pois数据
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            this.initTicketPoiDiscount(this.crowdOptions, this.poiInfo);
        },
        includeErrorCheck: function includeErrorCheck() {
            var _this = this;

            // 此函数用于判断，在直连情况下，费用包含与费用包含补充说明二选其一填写
            if (this.extra.isDirectDeal) {
                setTimeout(function () {
                    // 首先判断是否两个都是空
                    if (_this.model.include.length <= 0 && _this.model.includeItems.length === 1 && !_this.model.includeItems[0].name && !_this.model.includeItems[0].unit) {
                        _this.validateErrors.add('tab1', {
                            key: 0,
                            modelName: 'model.includeItems~model.include',
                            showError: false,
                            rule: 'required'
                        });
                    } else {
                        _this.validateErrors.removeAll('tab1', 'model.includeItems~model.include');
                        _this.validateErrors.removeAll('tab1', 'data.name');
                        // 如果不是两者为空，在费用包含补充说明为空的时候，判断费用包含是否合法
                        if (_this.model.include.length <= 0 || _this.model.includeItems.length > 1) {
                            var foundErr = false;
                            var _iteratorNormalCompletion5 = true;
                            var _didIteratorError5 = false;
                            var _iteratorError5 = undefined;

                            try {
                                for (var _iterator5 = _this.model.includeItems[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                    var item = _step5.value;

                                    if (!item.name || !item.unit) {
                                        foundErr = true;
                                        break;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError5 = true;
                                _iteratorError5 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                        _iterator5.return();
                                    }
                                } finally {
                                    if (_didIteratorError5) {
                                        throw _iteratorError5;
                                    }
                                }
                            }

                            if (foundErr) {
                                _this.validateErrors.add('tab1', {
                                    key: 0,
                                    modelName: 'data.name',
                                    showError: false,
                                    rule: 'required'
                                });
                            } else {
                                _this.validateErrors.removeAll('tab1', 'data.name');
                            }
                        }
                    }
                }, 0);
            }
        },
        updateServicePhone: function updateServicePhone(servicePhone) {
            this.servicePhone = servicePhone;
        },
        updateModel: function () {
            var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
                var i, res, _i3;

                return _regenerator2.default.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                // 直连初始化费用包含报错状态
                                if (this.model && this.model.includeItems && this.model.includeItems.length === 0) {
                                    this.model.includeItems.push({
                                        name: '',
                                        count: 1,
                                        unit: '',
                                        timeLength: null
                                    });
                                }

                                if (this.extra.isDirectDeal) {
                                    this.includeErrorCheck();
                                }
                                // 获取到model以后初始化
                                // 初始化门票票种
                                if (this.model.ticketCategory.ticket && this.model.ticketCategory.ticket.name) {
                                    this.ticketType = this.model.ticketCategory.ticket.name + ' - ' + this.model.ticketCategory.subTicket.name;
                                } else if (this.model.ticketCategory.createTicketCategoryInfo && this.model.ticketCategory.createTicketCategoryInfo.ticketCategoryName) {
                                    this.ticketType = this.model.ticketCategory.createTicketCategoryInfo.ticketCategoryName;
                                }

                                this.searchForTicketType();

                                if (this.model.mtDealId) {
                                    this.onlineBefore = true;
                                } else {
                                    this.onlineBefore = false;
                                }

                                // 初始化imglist
                                this.originImgList = [];
                                if (this.model.dealImageInfos.length > 0) {
                                    for (i = 0; i < this.model.dealImageInfos.length; i++) {
                                        this.originImgList.push({
                                            name: this.model.dealImageInfos[i].imageName,
                                            url: this.model.dealImageInfos[i].imageUrl
                                        });
                                    }
                                }

                                // BD

                                if (!(this.extra.isBD && this.extra.contractNum)) {
                                    _context6.next = 18;
                                    break;
                                }

                                _context6.prev = 8;
                                _context6.next = 11;
                                return (0, _ticket.getContractsDetail4BD)(this.extra.contractNum);

                            case 11:
                                res = _context6.sent;

                                if (res && res.data && res.data.servicePhone) {
                                    this.servicePhone = JSON.parse(res.data.servicePhone);
                                }
                                _context6.next = 18;
                                break;

                            case 15:
                                _context6.prev = 15;
                                _context6.t0 = _context6['catch'](8);

                                this.$Message.error({
                                    content: _context6.t0.message || '获取合同信息失败',
                                    duration: 5
                                });

                            case 18:
                                if (!this.model.ticketCategory.createTicketCategoryInfo) {
                                    this.$set(this.model.ticketCategory, 'createTicketCategoryInfo', {
                                        ticketCategoryName: '',
                                        usePeople: 1,
                                        timeLimitedRange: 3,
                                        timeLimitedRangeText: '',
                                        ticketCategoryPrice: '',
                                        uploadMaterialType: 0,
                                        uploadMaterialText: '',
                                        uploadMaterialImage: []
                                    });
                                } else if (this.model.ticketCategory.createTicketCategoryInfo.uploadMaterialImage.length > 0) {
                                    for (_i3 = 0; _i3 < this.model.ticketCategory.createTicketCategoryInfo.uploadMaterialImage.length; _i3++) {
                                        this.originTicketImgList.push({
                                            name: this.model.ticketCategory.createTicketCategoryInfo.uploadMaterialImage[_i3].imageName,
                                            url: this.model.ticketCategory.createTicketCategoryInfo.uploadMaterialImage[_i3].imageUrl
                                        });
                                    }
                                }

                            case 19:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this, [[8, 15]]);
            }));

            function updateModel() {
                return _ref7.apply(this, arguments);
            }

            return updateModel;
        }()
    }),
    directives: {
        'textarea-check': function textareaCheck(el, binding, vnode) {
            var text = el.getElementsByTagName('textarea')[0].value;
            var errorNotice = el.parentNode.getElementsByClassName('is-danger')[0];
            var findError = false;
            if (errorNotice) {
                errorNotice.style.display = 'none';
                for (var i = 0; i < _ticket2.textareaForbiddenWords.length; i++) {
                    if (text.indexOf(_ticket2.textareaForbiddenWords[i]) !== -1) {
                        errorNotice.style.display = 'block';
                        errorNotice.innerText = '请勿在此处填写' + _ticket2.textareaForbiddenWords[i] + '信息';
                        findError = true;
                        break;
                    }
                }
            }
            var position = vnode.context.validateErrors.search('tab1', vnode.data.model.expression, 'required');
            if (findError) {

                if (position === -1) {
                    vnode.context.validateErrors.add('tab1', {
                        key: 0,
                        modelName: vnode.data.model.expression,
                        showError: true,
                        rule: 'required'
                    });
                }
            } else {
                if (position >= 0) {
                    vnode.context.validateErrors.remove('tab1', position);
                }
            }
        }
    },
    watch: {
        selectedCity: function () {
            var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
                return _regenerator2.default.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.getPoiList('');

                            case 2:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function selectedCity() {
                return _ref8.apply(this, arguments);
            }

            return selectedCity;
        }(),

        ticketType: function () {
            var _ref9 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8() {
                var ticketTypeName, _ref10, data;

                return _regenerator2.default.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                if (!((0, _typeof3.default)(this.ticketType) === 'object')) {
                                    _context8.next = 18;
                                    break;
                                }

                                ticketTypeName = '';

                                if (!(!this.model.ticketCategory.subTicketId || !this.model.ticketCategory.ticket.subTicketId || this.ticketType.subTicketId !== this.model.ticketCategory.ticket.subTicketId)) {
                                    _context8.next = 14;
                                    break;
                                }

                                _context8.prev = 3;
                                _context8.next = 6;
                                return (0, _ticket.getTicketType)(this.ticketType.subTicketId);

                            case 6:
                                _ref10 = _context8.sent;
                                data = _ref10.data;

                                ticketTypeName = data || '';
                                _context8.next = 14;
                                break;

                            case 11:
                                _context8.prev = 11;
                                _context8.t0 = _context8['catch'](3);

                                ticketTypeName = '';

                            case 14:
                                this.model.ticketCategory.ticket = {
                                    ticketId: this.ticketType.ticketId,
                                    name: this.ticketType.ticketName
                                };
                                this.model.ticketCategory.subTicket = {
                                    ticketId: this.ticketType.subTicketId,
                                    name: this.ticketType.subTicketName
                                };
                                this.ticketType = this.model.ticketCategory.ticket.name + ' - ' + this.model.ticketCategory.subTicket.name;

                                if (ticketTypeName !== '') {
                                    // 放在直连判断外面，方便清洗数据
                                    this.model.ticketPoiDiscounts = [];
                                    if (!this.extra.isDirectDeal) {
                                        this.initCrowdOptionsByTicketName(ticketTypeName);
                                    }
                                }
                                /*
                                if (this.$refs['crowdOption'] && this.$refs['crowdOption'].autoSelectByTicketName && ticketTypeName !== '') {
                                    this.$refs['crowdOption'].autoSelectByTicketName(ticketTypeName)
                                }
                                */

                            case 18:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this, [[3, 11]]);
            }));

            function ticketType() {
                return _ref9.apply(this, arguments);
            }

            return ticketType;
        }(),
        'model.ticketCategory.poi': function () {
            var _ref11 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9(poi) {
                var result, flag;
                return _regenerator2.default.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                if (!this.extra.isDirectDeal) {
                                    this.updateCrowdOptions(poi);
                                }

                                if (this.model.ticketCategory.poi.length > 0) {
                                    this.validateErrors.removeAll('tab1', 'model.ticketCategory.poi');
                                } else {
                                    this.validateErrors.add('tab1', {
                                        key: 0,
                                        modelName: 'model.ticketCategory.poi',
                                        showError: true,
                                        rule: 'required'
                                    });
                                }

                                if (!this.extra.isBD) {
                                    _context9.next = 16;
                                    break;
                                }

                                _context9.prev = 3;
                                _context9.next = 6;
                                return (0, _ticket.getWhitelist)();

                            case 6:
                                result = _context9.sent;
                                flag = false;

                                if (Array.isArray(result.data) && this.model.ticketCategory && this.model.ticketCategory.poi && this.model.ticketCategory.poi.length) {
                                    this.model.ticketCategory.poi.forEach(function (i) {
                                        if (result.data.includes(i.mdcPoiId)) {
                                            flag = true;
                                        }
                                    });
                                }
                                // poi命中演出票白名单时，展示“产品类型设置模块”
                                this.model.theatreWhiteList = flag;
                                if (!flag) {
                                    this.model.ticketPriceType = 0;
                                }
                                _context9.next = 16;
                                break;

                            case 13:
                                _context9.prev = 13;
                                _context9.t0 = _context9['catch'](3);

                                this.$alert({
                                    title: '错误',
                                    message: _context9.t0.message || '白名单获取失败',
                                    showCancelButton: false,
                                    closeOnClickModal: false
                                });

                            case 16:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this, [[3, 13]]);
            }));

            function modelTicketCategoryPoi(_x6) {
                return _ref11.apply(this, arguments);
            }

            return modelTicketCategoryPoi;
        }(),
        model: function () {
            var _ref12 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10() {
                return _regenerator2.default.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.updateModel();

                            case 2:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function model() {
                return _ref12.apply(this, arguments);
            }

            return model;
        }()
    },
    mounted: function () {
        var _ref13 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee11() {
            var _this2 = this;

            var res, cities, _res;

            return _regenerator2.default.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            this.errors[0] = this.validateErrors;
                            _context11.next = 3;
                            return (0, _ticket.getAllCitys)();

                        case 3:
                            res = _context11.sent;
                            cities = res && res.data && res.data.length > 0 ? res.data : [];

                            this.cities = cities;
                            if (this.model && this.model.includeItems && this.model.includeItems.length === 0) {
                                this.model.includeItems.push({
                                    name: '',
                                    count: 1,
                                    unit: '',
                                    timeLength: null
                                });
                            }

                            if (!(this.extra.isBD && this.extra.contractNum)) {
                                _context11.next = 14;
                                break;
                            }

                            _context11.next = 10;
                            return (0, _ticket.getContractsDetail4BD)(this.extra.contractNum);

                        case 10:
                            _res = _context11.sent;

                            if (_res && _res.data && _res.data.servicePhone) {
                                this.servicePhone = JSON.parse(_res.data.servicePhone);
                                if (this.servicePhone && this.servicePhone.length > 0 && this.model.servicePhones[0].phone === '') {
                                    this.$set(this.model.servicePhones, 0, Object.assign({}, this.servicePhone[0]));
                                }
                            }
                            this.model.contractNum = this.extra.contractNum;
                            this.model.contractId = this.extra.contractId;

                        case 14:
                            if (!this.model.ticketCategory || !this.model.ticketCategory.poi || this.model.ticketCategory.poi.length <= 0) {
                                this.validateErrors.add('tab1', {
                                    key: 0,
                                    modelName: 'model.ticketCategory.poi',
                                    showError: false,
                                    rule: 'required'
                                });
                            }
                            this.$watch(function () {
                                if (_this2.model && _this2.model.ticketCategory && _this2.model.ticketCategory.poi && _this2.model.mtCategory) {
                                    var mdcPoiIds = [];
                                    _this2.model.ticketCategory.poi.map(function (item, index) {
                                        mdcPoiIds.push(item.mdcPoiId);
                                        return item;
                                    });
                                    return _this2.model.mtCategory + mdcPoiIds.join(',');
                                } else {
                                    return null;
                                }
                            }, function (newVal, oldVal) {
                                if (newVal !== oldVal) {
                                    _this2.$emit('updateMsRatio');
                                }
                            });

                        case 16:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, this);
        }));

        function mounted() {
            return _ref13.apply(this, arguments);
        }

        return mounted;
    }()
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */
/*!******************************************!*\
  !*** ./node_modules/moment/locale zh-cn ***!
  \******************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./zh-cn": 232,
	"./zh-cn.js": 232
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 517;

/***/ }),
/* 518 */
/*!********************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/custom-upload/upload.vue ***!
  \********************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _uploadList = __webpack_require__(/*! ./upload-list */ 519);

var _uploadList2 = _interopRequireDefault(_uploadList);

var _uploadSelect = __webpack_require__(/*! ./upload-select */ 522);

var _uploadSelect2 = _interopRequireDefault(_uploadSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'custom-upload',
    components: {
        uploadSelect: _uploadSelect2.default,
        uploadList: _uploadList2.default
    },
    props: {
        type: {
            type: String,
            default: 'fileList' // fileList or drag or imageList
        },
        disabled: {
            type: Boolean,
            default: false
        },
        url: {
            type: String,
            require: true
        },
        accept: {
            type: String
        },
        isAuto: {
            type: Boolean,
            default: true
        },
        isMultiple: {
            type: Boolean,
            default: false
        },
        maxLimit: {
            type: Number
        },
        thumbnailMode: {
            type: Boolean,
            default: false
        },
        showFileList: {
            type: Boolean,
            default: true
        },
        showProgress: {
            type: Boolean,
            default: true
        },
        defaultFileList: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        fileName: {
            type: String,
            default: 'file'
        },
        params: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        withCredentials: {
            type: Boolean,
            default: true
        },
        headers: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        fileLimitSize: {
            type: Number
        },
        enableHeadImage: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            fileList: [],
            lastestFile: {}
        };
    },

    computed: {
        autoUpload: function autoUpload() {
            return !(!this.isAuto && this.type === 'fileList');
        },
        acceptType: function acceptType() {
            return this.thumbnailMode ? 'image/gif, image/png, image/jpeg, image/bmp, image/webp' : this.accept;
        }
    },
    watch: {
        defaultFileList: {
            immediate: true,
            handler: function handler(fileList) {
                var _fileList = this.fileList = [];
                fileList.forEach(function (file) {
                    file.id = Math.random().toString(36).substr(2);
                    file.percentage = 100;
                    _fileList.push(file);
                });
                this.lastestFile = _fileList[_fileList.length - 1];
            }
        }
    },
    methods: {
        initFile: function initFile(file) {
            file.id = Math.random().toString(36).substr(2);
            try {
                file.url = URL.createObjectURL(file);
            } catch (err) {
                console.error(err);
                return;
            }
            var _file = {
                name: file.name,
                size: file.size,
                percentage: 0,
                id: file.id,
                showProgress: false,
                url: file.url,
                file: file
            };
            return _file;
        },
        uploadFile: function uploadFile(files) {
            var _this = this;

            var uploadFiles = this.autoUpload ? files : this.fileList;
            if (uploadFiles.length === 0) {
                return;
            } else {
                if (!this.isMultiple) {
                    uploadFiles = uploadFiles.slice(0, 1);
                }
                if (this.autoUpload) {
                    uploadFiles.forEach(function (file) {
                        _this.upload(file);
                    });
                } else {
                    uploadFiles.filter(function (file) {
                        return file.percentage < 100;
                    }).forEach(function (item) {
                        _this.upload(item.file);
                    });
                }
            }
        },
        onFileChange: function onFileChange(files) {
            var _this2 = this;

            var _fileList = this.fileList;
            files = Array.from(files);
            if (files.length > this.maxLimit || _fileList.length >= this.maxLimit) {
                this.$emit('on-max-limit');
                return;
            }
            if (this.fileLimitSize) {
                for (var i = 0; i < files.length; i++) {
                    if (files[i].size > this.fileLimitSize) {
                        this.$emit('on-file-size-max-limit');
                        return;
                    }
                }
            }
            files.forEach(function (file) {
                var _file = _this2.initFile(file);
                _fileList.push(_file);
            });
            this.lastestFile = _fileList[_fileList.length - 1];
            if (this.autoUpload || this.type === 'drag' || this.type === 'imageList') {
                this.uploadFile(files);
            }
        },
        getFile: function getFile(file) {
            var fileList = this.fileList;
            var target = void 0;
            fileList.every(function (item) {
                target = file.id === item.id ? item : null;
                return !target;
            });
            return target;
        },
        upload: function upload(file) {
            var _this3 = this;

            var _file = this.getFile(file);
            _file.showProgress = true;
            this.$emit('on-before-upload', file);
            var formData = new FormData();
            formData.append(this.fileName, file);
            if (this.params) {
                for (var key in this.params) {
                    formData.append(key, this.params[key]);
                }
            }
            var xhr = new XMLHttpRequest();
            xhr.open('post', this.url, true);
            if (xhr.upload) {
                xhr.upload.onprogress = function (e) {
                    if (e.total > 0) {
                        e.percent = e.loaded / e.total * 100;
                    }
                    _file.percentage = e.percent || 0;
                    _this3.$emit('on-progress', {
                        file: file,
                        data: e
                    });
                };
            }
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (parseInt(xhr.status, 10) === 200) {
                        var data = JSON.parse(xhr.responseText);
                        setTimeout(function () {
                            _file.showProgress = false;
                        }, 1000);
                        if (data && data.data && data.data.url) {
                            file.url = data.data.url;
                            _this3.$emit('on-success', {
                                file: file,
                                data: data
                            });
                        }
                    } else {
                        var msg = xhr.responseText;
                        var err = new Error(msg);
                        err.status = xhr.status;
                        err.statusText = xhr.statusText;
                        _file.showProgress = false;
                        _this3.fileList.splice(_this3.fileList.indexOf(_file), 1);
                        _this3.lastestFile = _this3.fileList[_this3.fileList.length - 1];
                        _this3.$emit('on-error', {
                            file: file,
                            error: err
                        });
                        return;
                    }
                }
            };
            xhr.onerror = function (e) {
                _file.showProgress = false;
                _this3.fileList.splice(_this3.fileList.indexOf(_file), 1);
                _this3.lastestFile = _this3.fileList[_this3.fileList.length - 1];
                _this3.$emit('on-error', {
                    file: file,
                    error: e
                });
            };
            if (this.withCredentials && 'withCredentials' in xhr) {
                xhr.withCredentials = true;
            }
            if (this.headers) {
                for (var header in this.headers) {
                    xhr.setRequestHeader(header, this.headers[header]);
                }
            }
            xhr.send(formData);
        },
        onDeleteFile: function onDeleteFile(file) {
            if (!this.disabled) {
                var fileList = this.fileList;
                fileList.splice(fileList.indexOf(file), 1);
                this.lastestFile = fileList[fileList.length - 1];
                this.$emit('on-delete', file);
            }
        },
        onSetHeadImage: function onSetHeadImage(file) {
            if (!this.disabled) {
                var fileList = this.fileList;
                fileList.splice(fileList.indexOf(file), 1);
                fileList.unshift(file);
                this.lastestFile = fileList[fileList.length - 1];
                this.$emit('on-set-head', file);
            }
        },
        clearFileList: function clearFileList() {
            this.fileList = [];
        }
    }

};

/***/ }),
/* 519 */
/*!******************************************************!*\
  !*** ./src/components/custom-upload/upload-list.vue ***!
  \******************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./upload-list.vue */ 520),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-bd7c5dd6","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./upload-list.vue */ 521),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 520 */
/*!*************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/custom-upload/upload-list.vue ***!
  \*************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    props: {
        fileList: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        disabled: {
            type: Boolean,
            default: false
        },
        showFileList: {
            type: Boolean,
            default: true
        },
        showProgress: {
            type: Boolean,
            default: true
        }

    },
    methods: {
        deleteFile: function deleteFile(file) {
            this.$emit('on-delete-file', file);
        }
    }
};

/***/ }),
/* 521 */
/*!*****************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd7c5dd6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom-upload/upload-list.vue ***!
  \*****************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showFileList) ? _c('ul', {
    staticClass: "v-upload-list"
  }, _vm._l((_vm.fileList), function(file) {
    return _c('li', {
      staticClass: "v-upload-file"
    }, [_c('a', {
      staticClass: "v-upload-filename"
    }, [_vm._m(0, true), _vm._v(_vm._s(file.name) + "\n            ")]), _vm._v(" "), _c('span', {
      staticClass: "v-upload-btn-delete",
      class: {
        'v-upload-disable': _vm.disabled === true
      },
      on: {
        "click": function($event) {
          _vm.deleteFile(file)
        }
      }
    }, [_vm._v("删除")]), _vm._v(" "), (file.showProgress && _vm.showProgress) ? _c('v-progress', {
      attrs: {
        "type": "line",
        "stroke-width": 2,
        "percentage": file.percentage,
        "status": file.percentage === 100 ? 'success' : ''
      }
    }) : _vm._e()], 1)
  })) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "v-icon-document"
  }, [_c('img', {
    attrs: {
      "src": "//awp-assets.meituan.net/hfe/fep/1a41c4c7bf7f017fe4885c4565e73894/uploadlist.svg"
    }
  })])
}]}

/***/ }),
/* 522 */
/*!********************************************************!*\
  !*** ./src/components/custom-upload/upload-select.vue ***!
  \********************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-1e913ab3","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./upload-select.vue */ 523)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./upload-select.vue */ 524),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1e913ab3","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./upload-select.vue */ 525),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 523 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1e913ab3","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/custom-upload/upload-select.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 524 */
/*!***************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/custom-upload/upload-select.vue ***!
  \***************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    type: {
      type: String,
      default: "fileList" // fileList or drag or imageList
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fileList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isAuto: {
      type: Boolean,
      default: true
    },
    accept: {
      type: String
    },
    isMultiple: {
      type: Boolean,
      default: true
    },
    maxLimit: {
      type: Number
    },
    lastestFile: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showProgress: {
      type: Boolean,
      default: true
    },
    enableHeadImage: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      dragover: false
    };
  },

  computed: {},
  watch: {},
  methods: {
    selectItem: function selectItem(e) {
      this.$refs.input.click();
    },
    fileChange: function fileChange(e) {
      if (!this.disabled) {
        var files = e.target.files || e.dataTransfer.files;
        if (!files) {
          return;
        }
        this.dragover = false;
        this.$emit("on-file-change", files);
        this.$refs.input.value = null;
      }
    },
    confirmUpload: function confirmUpload() {
      this.$emit("on-confirm-upload");
    },
    deleteFile: function deleteFile(file) {
      event.preventDefault();
      // 因为popover有个消失延迟动画，所以这里先隐藏
      var popovers = document.getElementsByClassName("el-popover");
      for (var inx = 0; inx < popovers.length; ++inx) {
        popovers[inx].style.display = "none";
      }
      if (this.$refs.popover) {
        if (this.$refs.popover.length > 0) {
          for (var _inx = 0; _inx < this.$refs.popover.length; ++_inx) {
            this.$refs.popover[_inx].showPopper = false;
          }
        } else {
          this.$refs.popover.showPopper = false;
        }
      }
      this.$emit("on-delete-file", file);
    },
    setHeadImage: function setHeadImage(file) {
      event.preventDefault();
      // 因为popover有个消失延迟动画，所以这里先隐藏
      var popovers = document.getElementsByClassName("el-popover");
      for (var inx = 0; inx < popovers.length; ++inx) {
        popovers[inx].style.display = "none";
      }
      if (this.$refs.popover) {
        if (this.$refs.popover.length > 0) {
          for (var _inx2 = 0; _inx2 < this.$refs.popover.length; ++_inx2) {
            this.$refs.popover[_inx2].showPopper = false;
          }
        } else {
          this.$refs.popover.showPopper = false;
        }
      }
      this.$emit("on-set-head-image", file);
    }
  },
  created: function created() {}
};

/***/ }),
/* 525 */
/*!*******************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e913ab3","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom-upload/upload-select.vue ***!
  \*******************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-upload-select",
    class: {
      'v-upload-dragger': _vm.type === 'drag', 'is-dragOver': _vm.dragover && !_vm.disabled, 'v-upload-image-list': _vm.type === 'imageList'
    },
    on: {
      "drop": function($event) {
        $event.preventDefault();
        _vm.fileChange($event)
      },
      "dragover": function($event) {
        $event.preventDefault();
        _vm.dragover = true
      },
      "dragleave": function($event) {
        $event.preventDefault();
        _vm.dragover = false
      }
    }
  }, [(_vm.type === 'fileList') ? _c('div', [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    class: {
      'v-select-btn': !_vm.isAuto
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.selectItem($event)
      }
    }
  }, [_vm._v("选择文件\n        ")]), _vm._v(" "), (!_vm.isAuto) ? _c('button', {
    staticClass: "btn btn-sm btn-primary",
    class: {
      'v-upload-btn': !_vm.isAuto
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.confirmUpload($event)
      }
    }
  }, [_vm._v("确定上传\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.type === 'drag') ? _c('div', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.selectItem($event)
      }
    }
  }, [_c('div', {
    staticClass: "v-icon-cloud-upload",
    class: {
      'v-upload-disable': _vm.disabled === true
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "512",
      "height": "512",
      "viewBox": "0 0 512 512"
    }
  }, [_c('g', {
    attrs: {
      "id": "icomoon-ignore"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M446.134 193.245c1.222-5.555 1.866-11.324 1.866-17.245 0-44.183-35.817-80-80-80-7.111 0-14.007 0.934-20.566 2.676-12.399-38.676-48.645-66.676-91.434-66.676-43.674 0-80.527 29.168-92.163 69.085-11.371-3.311-23.396-5.085-35.837-5.085-70.692 0-128 57.308-128 128 0 70.694 57.308 128 128 128h64v96h128v-96h112c44.183 0 80-35.816 80-80 0-39.36-28.427-72.081-65.866-78.755zM288 320v96h-64v-96h-80l112-112 112 112h-80z",
      "fill": "#99a9bf"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "v-upload-text"
  }, [_vm._v("将文件拖拽到此处或者点击上传")]), _vm._v(" "), (_vm.lastestFile.percentage === 100) ? _c('img', {
    attrs: {
      "src": _vm.lastestFile.url
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.lastestFile.percentage === 100),
      expression: "lastestFile.percentage === 100"
    }],
    staticClass: "v-upload-modal"
  }, [_c('span', {
    staticClass: "btn",
    class: {
      'v-upload-disable': _vm.disabled === true
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.deleteFile($event)
      }
    }
  }, [_c('i', [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "512",
      "height": "512",
      "viewBox": "0 0 512 512"
    }
  }, [_c('g', {
    attrs: {
      "id": "icomoon-ignore"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M64 160v320c0 17.6 14.4 32 32 32h288c17.6 0 32-14.4 32-32v-320h-352zM160 448h-32v-224h32v224zM224 448h-32v-224h32v224zM288 448h-32v-224h32v224zM352 448h-32v-224h32v224z",
      "fill": "#fff"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M424 64h-104v-40c0-13.2-10.8-24-24-24h-112c-13.2 0-24 10.8-24 24v40h-104c-13.2 0-24 10.8-24 24v40h416v-40c0-13.2-10.8-24-24-24zM288 64h-96v-31.599h96v31.599z",
      "fill": "#fff"
    }
  })])])]), _vm._v(" "), _c('span', {
    staticClass: "btn",
    class: {
      'v-upload-disable': _vm.disabled === true
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.selectItem($event)
      }
    }
  }, [_c('i', {
    staticClass: "v-icon-upload-continue"
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "512",
      "height": "512",
      "viewBox": "0 0 512 512"
    }
  }, [_c('g', {
    attrs: {
      "id": "icomoon-ignore"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 448h512v32h-512zM512 384v32h-512v-32l64-128h128v64h128v-64h128zM112 160l144-144 144 144h-112v128h-64v-128z",
      "fill": "#fff"
    }
  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.type === 'imageList') ? _c('div', [_c('ul', _vm._l((_vm.fileList), function(file, index) {
    return _c('li', {
      staticClass: "v-upload-img"
    }, [_c('v-popover', {
      ref: "popover",
      refInFor: true,
      attrs: {
        "placement": "top"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "440px"
      },
      attrs: {
        "src": file.url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "v-upload-img",
      slot: "reference"
    }, [(file.percentage === 100) ? _c('img', {
      attrs: {
        "src": file.url
      }
    }) : _vm._e(), _vm._v(" "), (file.showProgress && _vm.showProgress) ? _c('v-progress', {
      staticClass: "circle-progress",
      attrs: {
        "width": 100,
        "type": "circle",
        "stroke-width": 4.8,
        "percentage": file.percentage,
        "status": file.percentage === 100 ? 'success' : ''
      }
    }) : _vm._e(), _vm._v(" "), (_vm.enableHeadImage && index === 0) ? _c('div', {
      staticClass: "headImageTag"
    }, [_vm._v("首图")]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (file.percentage === 100),
        expression: "file.percentage === 100"
      }],
      staticClass: "v-upload-modal"
    }, [_c('div', {
      staticStyle: {
        "width": "100%",
        "bottom": "0",
        "height": "30px",
        "background-color": "#06c1ae",
        "position": "absolute"
      }
    }, [_c('a', {
      staticClass: "imageOperator",
      class: {
        'v-upload-disable': _vm.disabled === true
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteFile(file)
        }
      }
    }, [_vm._v("删除")]), _vm._v(" "), (_vm.enableHeadImage && index !== 0) ? _c('a', {
      staticClass: "imageOperator",
      class: {
        'v-upload-disable': _vm.disabled === true
      },
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.setHeadImage(file)
        }
      }
    }, [_vm._v("设为首图")]) : _vm._e()])])], 1)])], 1)
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fileList.length < _vm.maxLimit),
      expression: "fileList.length < maxLimit"
    }],
    staticClass: "v-upload-add plus",
    class: {
      'v-upload-disable': _vm.disabled === true
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.selectItem($event)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "input",
    staticClass: "v-upload-input",
    attrs: {
      "type": "file",
      "multiple": _vm.isMultiple,
      "accept": _vm.accept,
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.fileChange
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 526 */
/*!************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1864fcb4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom-upload/upload.vue ***!
  \************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-upload"
  }, [_c('uploadSelect', {
    attrs: {
      "type": _vm.type,
      "disabled": _vm.disabled,
      "max-limit": _vm.maxLimit,
      "is-auto": _vm.autoUpload,
      "accept": _vm.acceptType,
      "is-multiple": _vm.isMultiple,
      "file-list": _vm.fileList,
      "lastest-file": _vm.lastestFile,
      "show-progress": _vm.showProgress,
      "enable-head-image": _vm.enableHeadImage
    },
    on: {
      "on-file-change": _vm.onFileChange,
      "on-confirm-upload": _vm.uploadFile,
      "on-delete-file": _vm.onDeleteFile,
      "on-set-head-image": _vm.onSetHeadImage
    }
  }), _vm._v(" "), _vm._t("tips"), _vm._v(" "), _c('uploadList', {
    attrs: {
      "file-list": _vm.fileList,
      "disabled": _vm.disabled,
      "show-file-list": _vm.showFileList,
      "show-progress": _vm.showProgress
    },
    on: {
      "on-delete-file": _vm.onDeleteFile
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 527 */
/*!************************************************!*\
  !*** ./src/components/product/discountDes.vue ***!
  \************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-7cbc508e","scoped":true,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./discountDes.vue */ 528)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./discountDes.vue */ 529),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7cbc508e","hasScoped":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./discountDes.vue */ 530),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7cbc508e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 528 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7cbc508e","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/product/discountDes.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 529 */
/*!*******************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/product/discountDes.vue ***!
  \*******************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    data: function data() {
        return {
            optIndex: -1
        };
    },

    props: {
        crowds: {
            type: Array,
            required: true
        },
        extra: {
            type: Object,
            required: true
        },
        mode: {
            type: String,
            required: true
        }
    },
    methods: {
        autoSelectByTicketName: function autoSelectByTicketName() {
            var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        },
        getOnSelect: function getOnSelect(model, options) {
            var opt = options[model.optIndex];
            model.crowd = opt.crowd;
            model.crowdString = opt.crowdString;
            model.otherCrowd = opt.otherCrowd;
            model.discountInfo.policyType = opt.discountInfo.policyType;
            model.discountInfo.preventCondition = opt.discountInfo.preventCondition;
            model.freeInfo.policyType = opt.freeInfo.policyType;
            model.freeInfo.preventCondition = opt.freeInfo.preventCondition;
        },
        addItem: function addItem(ticketDiscountList) {
            ticketDiscountList.push({
                crowd: null,
                crowdString: '',
                optIndex: '',
                otherCrowd: null,
                discountInfo: {
                    policyType: null,
                    preventCondition: null
                },
                freeInfo: {
                    policyType: 0,
                    preventCondition: null
                }
            });
        },
        removeItem: function removeItem(model, index, ticketDiscountList) {
            if (ticketDiscountList.length === 1) {
                model.crowd = null;
                model.optIndex = '';
                model.crowdString = '';
                model.otherCrowd = null;
                model.discountInfo = {};
                model.freeInfo = {};
                model.discountInfo.policyType = null;
                model.discountInfo.preventCondition = null;
                model.freeInfo.policyType = 0;
                model.freeInfo.preventCondition = null;
            } else {
                ticketDiscountList.splice(index, 1);
            }
        }
    },
    mounted: function mounted() {},
    watch: {
        crowds: function crowds() {
            if (this.crowds[0].options) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = this.crowds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var crowd = _step.value;

                        var crowdString2Index = {};
                        crowd.forbiddenList = [];
                        for (var i = 0; i < crowd.options.length; i++) {
                            crowdString2Index[crowd.options[i].crowdString] = i;
                            crowd.forbiddenList.push(crowd.options[i].crowdString);
                        }
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = crowd.ticketDiscountList[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var ticketDiscount = _step2.value;

                                var index = crowd.forbiddenList.indexOf(ticketDiscount.crowdString);
                                if (index === -1) {
                                    index = '';
                                }
                                ticketDiscount.optIndex = index;
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    }
};

/***/ }),
/* 530 */
/*!**********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cbc508e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/discountDes.vue ***!
  \**********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.crowds.length) ? _c('div', [_c('strong', [_vm._v("适用人群限制：")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("只需添加当前票种可以使用的特殊人群使用限制")]), _vm._v(" "), _vm._l((_vm.crowds), function(crowd) {
    return _c('div', [(_vm.crowds.length !== 1) ? _c('div', [_c('b', [_vm._v(_vm._s(crowd.poiName))])]) : _vm._e(), _vm._v(" "), _vm._l((crowd.ticketDiscountList), function(model, index) {
      return _c('div', {
        staticClass: "crowd-item"
      }, [_c('div', [_c('v-select', {
        staticClass: "middle-select inline-input",
        attrs: {
          "placeholder": "请选择",
          "remote": false
        },
        on: {
          "input": function($event) {
            _vm.getOnSelect(model, crowd.options)
          }
        },
        model: {
          value: (model.optIndex),
          callback: function($$v) {
            model.optIndex = $$v
          },
          expression: "model.optIndex"
        }
      }, _vm._l((crowd.options), function(opt, index) {
        return (opt.discountInfo.policyType !== 1) ? _c('v-option', {
          key: index,
          attrs: {
            "label": opt.crowdString,
            "value": index
          }
        }) : _vm._e()
      })), _vm._v(" "), (model.crowd == 1000 && model.crowdString === '其他') ? _c('span', [_c('v-input', {
        directives: [{
          name: "va",
          rawName: "v-va.tab1",
          value: ('required|forbidden'),
          expression: "'required|forbidden'",
          modifiers: {
            "tab1": true
          }
        }],
        staticClass: "inline-input",
        class: {
          'input': true, 'is-danger': _vm.validateErrors.has('tab1', 'model.otherCrowd', null, index)
        },
        attrs: {
          "data-key": index,
          "forbiddenList": crowd.forbiddenList
        },
        model: {
          value: (model.otherCrowd),
          callback: function($$v) {
            model.otherCrowd = $$v
          },
          expression: "model.otherCrowd"
        }
      })], 1) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("\n                     限制为\n                     "), _c('v-input', {
        staticClass: "inline-input large-select",
        attrs: {
          "maxlength": 60
        },
        model: {
          value: (model.discountInfo.preventCondition),
          callback: function($$v) {
            model.discountInfo.preventCondition = $$v
          },
          expression: "model.discountInfo.preventCondition"
        }
      })], 1), _vm._v(" "), (_vm.mode !== 'readonly') ? _c('span', [_c('button', {
        staticClass: "btn btn-link btn-xs",
        on: {
          "click": function($event) {
            _vm.addItem(crowd.ticketDiscountList)
          }
        }
      }, [_c('i', {
        staticClass: "icon-button icon-plus"
      })]), _vm._v(" "), (model.crowd !== null || model.discountInfo.preventCondition !== null || crowd.ticketDiscountList.length > 1) ? _c('button', {
        staticClass: "btn btn-link btn-xs",
        on: {
          "click": function($event) {
            _vm.removeItem(model, index, crowd.ticketDiscountList)
          }
        }
      }, [_c('i', {
        staticClass: "icon-button delete icon-cancel"
      })]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), (model.freeInfo.policyType === 1) ? _c('div', [_vm._v("\n                " + _vm._s(model.crowdString) + _vm._s(model.freeInfo.preventCondition) + "免费\n                "), (_vm.extra.isBD) ? _c('span', {
        staticClass: "text-warning",
        staticStyle: {
          "margin-left": "5px"
        }
      }, [_vm._v("请仔细核对免票信息，如有误，请前往CRM系统中报错")]) : _c('span', {
        staticClass: "text-warning",
        staticStyle: {
          "margin-left": "5px"
        }
      }, [_vm._v("请仔细核对免票信息，若有误请向您的BD报错")])]) : _vm._e(), _vm._v(" "), (_vm.validateErrors.has('tab1', 'model.otherCrowd', 'required', index)) ? _c('div', {
        staticStyle: {
          "color": "red"
        }
      }, [_vm._v("\n                适用人群不能为空\n            ")]) : (_vm.validateErrors.has('tab1', 'model.otherCrowd', 'forbidden', index)) ? _c('div', {
        staticStyle: {
          "color": "red"
        }
      }, [_vm._v("\n                该人群已存在，请勿重复填写，若有人群限制不同，可修改人群限制内容\n            ")]) : _vm._e()])
    })], 2)
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 531 */
/*!****************************************************!*\
  !*** ./src/components/product/dealAndContract.vue ***!
  \****************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-dcd8560c","scoped":false,"hasInlineConfig":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./dealAndContract.vue */ 532)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./dealAndContract.vue */ 533),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-dcd8560c","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./dealAndContract.vue */ 534),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 532 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dcd8560c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/product/dealAndContract.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 533 */
/*!***********************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/product/dealAndContract.vue ***!
  \***********************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ 22);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(/*! babel-runtime/helpers/asyncToGenerator */ 23);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _ticket = __webpack_require__(/*! api/ticket */ 50);

var _index = __webpack_require__(/*! components/content-block/index.vue */ 76);

var _index2 = _interopRequireDefault(_index);

var _vuex = __webpack_require__(/*! vuex */ 14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        ContentBlock: _index2.default
    },
    data: function data() {
        return {
            bankInfo: '',
            contractsList: []
        };
    },

    methods: Object.assign({}, (0, _vuex.mapActions)(['login', 'getUser']), (0, _vuex.mapGetters)(['user'])),
    props: {
        model: {
            type: Object,
            required: true
        },
        extra: {
            type: Object,
            required: true
        },
        updateServicePhone: {
            type: Function
        },
        mode: {
            type: String,
            required: true
        },
        errors: {
            type: Array,
            required: true
        }
    },
    computed: {
        id: function id() {
            return this.$route.params.id || null;
        }
    },
    watch: {
        'model.contractId': function modelContractId() {
            for (var i = 0; i < this.contractsList.length; i++) {
                if (this.contractsList[i].id === this.model.contractId) {
                    this.bankInfo = '\u6B3E\u9879\u5C06\u6253\u5165\u6B64\u5E10\u53F7\uFF1A' + this.contractsList[i].contractBank.otherBranchName + ' ' + this.contractsList[i].contractBank.accountNum;
                    if (this.contractsList[i].servicePhone.length > 0) {
                        this.servicePhone = JSON.parse(this.contractsList[i].servicePhone);
                        this.updateServicePhone(this.servicePhone);
                        if (this.servicePhone && this.servicePhone.length > 0 && (!this.extra.isBD || this.model.servicePhones[0].phone === '')) {
                            this.$set(this.model.servicePhones, 0, Object.assign({}, this.servicePhone[0]));
                        }
                    }
                    this.model.contractNum = this.contractsList[i].contractNum;
                }
            }
        }
    },
    mounted: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            var supplierId, userinfo, res, contractList, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, contract;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            // 获取合同列表
                            supplierId = this.extra.supplierId;

                            if (supplierId) {
                                _context.next = 6;
                                break;
                            }

                            _context.next = 4;
                            return this.getUser();

                        case 4:
                            userinfo = _context.sent;

                            supplierId = userinfo.supplierId;

                        case 6:
                            _context.prev = 6;
                            res = void 0;

                            if (!this.extra.isBD) {
                                _context.next = 14;
                                break;
                            }

                            _context.next = 11;
                            return (0, _ticket.getContractsList4BD)(supplierId);

                        case 11:
                            res = _context.sent;
                            _context.next = 17;
                            break;

                        case 14:
                            _context.next = 16;
                            return (0, _ticket.getContractsList)(supplierId);

                        case 16:
                            res = _context.sent;

                        case 17:
                            if (!res.data) {
                                _context.next = 41;
                                break;
                            }

                            contractList = res.data;

                            this.contractsList = contractList.map(function (contractItem) {
                                var obj = {};
                                Object.assign(obj, contractItem.contractDO, { contractBank: contractItem.contractBank });
                                return obj;
                            });
                            // 直连有些老的单子，contractid是0

                            if (!this.extra.isDirectDeal) {
                                _context.next = 41;
                                break;
                            }

                            if (!((this.model.contractId === 0 || this.model.contractId === null) && this.model.contractNum !== '')) {
                                _context.next = 41;
                                break;
                            }

                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context.prev = 25;

                            for (_iterator = this.contractsList[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                contract = _step.value;

                                if (this.model.contractNum === contract.contractNum) {
                                    this.model.contractId = contract.id;
                                }
                            }
                            _context.next = 33;
                            break;

                        case 29:
                            _context.prev = 29;
                            _context.t0 = _context['catch'](25);
                            _didIteratorError = true;
                            _iteratorError = _context.t0;

                        case 33:
                            _context.prev = 33;
                            _context.prev = 34;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }

                        case 36:
                            _context.prev = 36;

                            if (!_didIteratorError) {
                                _context.next = 39;
                                break;
                            }

                            throw _iteratorError;

                        case 39:
                            return _context.finish(36);

                        case 40:
                            return _context.finish(33);

                        case 41:
                            _context.next = 46;
                            break;

                        case 43:
                            _context.prev = 43;
                            _context.t1 = _context['catch'](6);

                            this.$message({
                                showClose: true,
                                message: _context.t1.message || '获取合同列表失败',
                                type: 'error',
                                duration: 10000
                            });

                        case 46:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[6, 43], [25, 29, 33, 41], [34,, 36, 40]]);
        }));

        function mounted() {
            return _ref.apply(this, arguments);
        }

        return mounted;
    }()
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 534 */
/*!***************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dcd8560c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/dealAndContract.vue ***!
  \***************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.extra.isDirectDeal && this.id) ? _c('content-block', {
    attrs: {
      "title": "产品编号"
    }
  }, [_vm._v("\n        " + _vm._s(this.id) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.extra.isDirectDeal) ? _c('content-block', {
    attrs: {
      "title": "商家产品编号",
      "isRequired": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-8",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('v-input', {
    directives: [{
      name: "va",
      rawName: "v-va.tab1",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "tab1": true
      }
    }],
    class: {
      'input': true, 'is-danger': _vm.validateErrors.has('tab1', 'model.partnerDealId')
    },
    attrs: {
      "type": "text",
      "name": "partnerDealId",
      "placeholder": "请填写商家产品编号",
      "disabled": !_vm.extra.isNew
    },
    model: {
      value: (_vm.model.partnerDealId),
      callback: function($$v) {
        _vm.model.partnerDealId = $$v
      },
      expression: "model.partnerDealId"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab1', 'model.partnerDealId')),
      expression: "validateErrors.has('tab1', 'model.partnerDealId')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("请填写商家产品编号")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.extra.isNew) ? _c('span', [_c('span', {
    staticClass: "icon-error help-icon"
  }), _vm._v(" 产品保存后无法修改，请在上单前与商家确认")]) : _c('span', [_c('span', {
    staticClass: "icon-error help-icon"
  }), _vm._v(" 商家产品编号在产品保存后不可更改")])])]) : _vm._e(), _vm._v(" "), (_vm.extra.isBD) ? _c('content-block', {
    attrs: {
      "title": "对应合同"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.extra.contractNum) + "\n    ")]) : _c('content-block', {
    attrs: {
      "title": "对应合同",
      "isRequired": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('v-select', {
    directives: [{
      name: "va",
      rawName: "v-va.tab1",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "tab1": true
      }
    }],
    staticClass: "col-sm-4",
    class: {
      'input': true, 'is-danger': _vm.validateErrors.has('tab1', 'model.contractId')
    },
    attrs: {
      "placeholder": "请选择合同"
    },
    model: {
      value: (_vm.model.contractId),
      callback: function($$v) {
        _vm.model.contractId = $$v
      },
      expression: "model.contractId"
    }
  }, _vm._l((_vm.contractsList), function(item) {
    return _c('v-option', {
      key: item.id,
      attrs: {
        "label": item.contractName,
        "value": item.id
      }
    })
  })), _vm._v(" "), (_vm.bankInfo && _vm.bankInfo.length > 0) ? _c('div', {
    staticClass: "col-sm-7"
  }, [_vm._v(_vm._s(_vm.bankInfo))]) : _vm._e()], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab1', 'model.contractId')),
      expression: "validateErrors.has('tab1','model.contractId')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("请选择合同")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 535 */
/*!*****************************************************!*\
  !*** ./src/components/product/supplierProtocol.vue ***!
  \*****************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-1499fcd7","scoped":true,"hasInlineConfig":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./supplierProtocol.vue */ 536)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./supplierProtocol.vue */ 537),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1499fcd7","hasScoped":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./supplierProtocol.vue */ 544),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1499fcd7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 536 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1499fcd7","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/product/supplierProtocol.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 537 */
/*!************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/product/supplierProtocol.vue ***!
  \************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ 22);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(/*! babel-runtime/helpers/asyncToGenerator */ 23);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _slicedToArray2 = __webpack_require__(/*! babel-runtime/helpers/slicedToArray */ 234);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _index = __webpack_require__(/*! components/content-block/index.vue */ 76);

var _index2 = _interopRequireDefault(_index);

var _ticket = __webpack_require__(/*! api/ticket */ 50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//todo: 确定禁止修改的情况，并添加
exports.default = {
    components: {
        ContentBlock: _index2.default
    },
    data: function data() {
        return {
            tempMsg: '',
            protocolInfo: null,
            connectProtocol: false,
            protocolTypeList: [],
            selectProtocolTypeList: ['']
        };
    },

    props: {
        extra: {
            type: Object,
            required: true
        },
        supplierProtocolRule: {
            type: Object,
            required: true
        },
        loaded: Boolean
    },
    methods: {
        resetDisable: function resetDisable() {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Object.keys(this.protocolInfo)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var key = _step.value;
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = this.protocolInfo[key][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var proto = _step2.value;

                            proto.disabled = false;
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        addProtocol: function addProtocol(protocolInfo) {
            var _protocolInfo$split = protocolInfo.split('~||~'),
                _protocolInfo$split2 = (0, _slicedToArray3.default)(_protocolInfo$split, 2),
                key = _protocolInfo$split2[0],
                protocolStr = _protocolInfo$split2[1];

            if (key && this.supplierProtocolRule[key]) {
                var protocol = JSON.parse(protocolStr);
                this.supplierProtocolRule[key].push(protocol);
                this.tempMsg = '';
                // disable掉已经选中项
                for (var i = 0; i < this.protocolInfo[key].length; i++) {
                    if (this.protocolInfo[key][i].ruleId === protocol.ruleId) {
                        this.protocolInfo[key][i].disabled = true;
                    }
                }
            }
        },
        handleTagClose: function handleTagClose(index, key) {
            var protocol = this.supplierProtocolRule[key][index];
            this.supplierProtocolRule[key].splice(index, 1);
            // 去掉禁用
            for (var i = 0; i < this.protocolInfo[key].length; i++) {
                if (this.protocolInfo[key][i].ruleId === protocol.ruleId) {
                    delete this.protocolInfo[key][i].disabled;
                }
            }
        },
        addProtocolType: function addProtocolType() {
            this.selectProtocolTypeList.push('');
        },
        removeProtocolType: function removeProtocolType(index) {
            var protocol = this.selectProtocolTypeList.splice(index, 1).pop();
            // 同时要清空相应的协议列表
            this.$set(this.supplierProtocolRule, protocol, []);
        },
        initData: function initData() {
            if (this.loaded) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = Object.keys(this.supplierProtocolRule)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var key = _step3.value;

                        if (this.supplierProtocolRule[key].length > 0) {
                            this.connectProtocol = true;
                            if (this.selectProtocolTypeList.length === 1 && this.selectProtocolTypeList[0] === '') {
                                this.selectProtocolTypeList = [];
                            }
                            if (this.selectProtocolTypeList.indexOf(key) === -1) {
                                this.selectProtocolTypeList.push(key);
                            }
                            // 将已经被选择的协议在列表中disable掉
                            var _iteratorNormalCompletion4 = true;
                            var _didIteratorError4 = false;
                            var _iteratorError4 = undefined;

                            try {
                                for (var _iterator4 = this.supplierProtocolRule[key][Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                    var obj = _step4.value;
                                    var _iteratorNormalCompletion5 = true;
                                    var _didIteratorError5 = false;
                                    var _iteratorError5 = undefined;

                                    try {
                                        for (var _iterator5 = this.protocolInfo[key][Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                            var item = _step5.value;

                                            if (obj.ruleId === item.ruleId) {
                                                item.disabled = true;
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError5 = true;
                                        _iteratorError5 = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                                _iterator5.return();
                                            }
                                        } finally {
                                            if (_didIteratorError5) {
                                                throw _iteratorError5;
                                            }
                                        }
                                    }
                                }
                            } catch (err) {
                                _didIteratorError4 = true;
                                _iteratorError4 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                        _iterator4.return();
                                    }
                                } finally {
                                    if (_didIteratorError4) {
                                        throw _iteratorError4;
                                    }
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
        },
        changeConnect: function changeConnect() {
            // 选择否以后清空所有数据
            if (!this.connectProtocol) {
                //清空diabled
                this.resetDisable();
                this.selectProtocolTypeList = [''];
                var _iteratorNormalCompletion6 = true;
                var _didIteratorError6 = false;
                var _iteratorError6 = undefined;

                try {
                    for (var _iterator6 = Object.keys(this.supplierProtocolRule)[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                        var key = _step6.value;

                        this.supplierProtocolRule[key] = [];
                    }
                } catch (err) {
                    _didIteratorError6 = true;
                    _iteratorError6 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion6 && _iterator6.return) {
                            _iterator6.return();
                        }
                    } finally {
                        if (_didIteratorError6) {
                            throw _iteratorError6;
                        }
                    }
                }
            } else {
                // 选择是的时候，如果只有一种协议，且该种协议下只有一个协议，在此手动添加
                if (this.protocolTypeList.length === 1) {
                    this.selectProtocolTypeList = [this.protocolTypeList[0].key];
                }
            }
            //当选择是否关联的时候，相应处理报错状态
            this.checkEmpty();
        },
        checkEmpty: function checkEmpty() {
            // 手动控制报错
            if (!this.connectProtocol) {
                this.validateErrors.removeAll('tab1', 'model.supplierProtocolRule');
            } else {
                var empty = true;
                if (this.selectProtocolTypeList.length > 0) {
                    var allDone = true;
                    var _iteratorNormalCompletion7 = true;
                    var _didIteratorError7 = false;
                    var _iteratorError7 = undefined;

                    try {
                        for (var _iterator7 = this.selectProtocolTypeList[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                            var type = _step7.value;

                            if (type === '') {
                                allDone = false;
                                break;
                            }
                            if (this.supplierProtocolRule[type].length <= 0) {
                                allDone = false;
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError7 = true;
                        _iteratorError7 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                _iterator7.return();
                            }
                        } finally {
                            if (_didIteratorError7) {
                                throw _iteratorError7;
                            }
                        }
                    }

                    if (allDone) {
                        empty = false;
                    }
                }
                if (empty) {
                    this.validateErrors.add('tab1', {
                        key: 0,
                        modelName: 'model.supplierProtocolRule',
                        showError: false,
                        rule: 'required'
                    });
                } else {
                    this.validateErrors.removeAll('tab1', 'model.supplierProtocolRule');
                }
            }
        }
    },
    watch: {
        loaded: function loaded() {
            this.initData();
        },
        selectProtocolTypeList: function selectProtocolTypeList() {
            // 处理当某个协议类型下只有一个协议且关联协议选是的时候，自动选中那一个协议
            if (this.selectProtocolTypeList.length > 0) {
                var _iteratorNormalCompletion8 = true;
                var _didIteratorError8 = false;
                var _iteratorError8 = undefined;

                try {
                    for (var _iterator8 = this.selectProtocolTypeList[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                        var type = _step8.value;

                        if (type !== '' && this.protocolInfo[type].length === 1 && this.connectProtocol) {
                            this.$set(this.supplierProtocolRule, type, [this.protocolInfo[type][0]]);
                        }
                    }
                } catch (err) {
                    _didIteratorError8 = true;
                    _iteratorError8 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion8 && _iterator8.return) {
                            _iterator8.return();
                        }
                    } finally {
                        if (_didIteratorError8) {
                            throw _iteratorError8;
                        }
                    }
                }
            }
        },
        // 直接watch supplierProtocolRule watch不到。。。。。
        'supplierProtocolRule.rebateProtocols': function supplierProtocolRuleRebateProtocols() {
            this.checkEmpty();
        },
        'supplierProtocolRule.packageProtocols': function supplierProtocolRulePackageProtocols() {
            this.checkEmpty();
        }
    },
    beforeMount: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            var res;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!this.extra.supplierId) {
                                _context.next = 11;
                                break;
                            }

                            _context.prev = 1;
                            _context.next = 4;
                            return (0, _ticket.getprotocol)(this.extra.supplierId, this.extra.contractNum);

                        case 4:
                            res = _context.sent;

                            if (res && res.data && res.data.supplierProtocolRule) {
                                this.protocolInfo = res.data.supplierProtocolRule;
                                //这里写死两种协议，以后增加新协议需与后端协调整体修改
                                //这里重新整理后端数据，方便前端展示
                                //因为有try catch，直接判断length
                                if (this.protocolInfo.rebateProtocols.length > 0) {
                                    this.protocolTypeList.push({
                                        key: 'rebateProtocols',
                                        name: '返佣协议'
                                    });
                                }
                                if (this.protocolInfo.packageProtocols.length > 0) {
                                    this.protocolTypeList.push({
                                        key: 'packageProtocols',
                                        name: '包票协议'
                                    });
                                }
                                if (this.protocolTypeList.length === 1) {
                                    this.selectProtocolTypeList = [this.protocolTypeList[0].key];
                                }
                                this.initData();
                            }
                            _context.next = 11;
                            break;

                        case 8:
                            _context.prev = 8;
                            _context.t0 = _context['catch'](1);

                            console.log(_context.t0);

                        case 11:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[1, 8]]);
        }));

        function beforeMount() {
            return _ref.apply(this, arguments);
        }

        return beforeMount;
    }()
};

/***/ }),
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */
/*!***************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1499fcd7","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/supplierProtocol.vue ***!
  \***************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.protocolTypeList.length > 0) ? _c('div', [_c('content-block', {
    attrs: {
      "title": "是否关联补充协议",
      "isRequired": ""
    }
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "connectProtocol1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.connectProtocol),
      expression: "connectProtocol"
    }],
    attrs: {
      "id": "connectProtocol1",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.connectProtocol, true)
    },
    on: {
      "change": function($event) {
        _vm.changeConnect()
      },
      "__c": function($event) {
        _vm.connectProtocol = true
      }
    }
  }), _vm._v(" 是")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "connectProtocol2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.connectProtocol),
      expression: "connectProtocol"
    }],
    attrs: {
      "id": "connectProtocol2",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.connectProtocol, false)
    },
    on: {
      "change": function($event) {
        _vm.changeConnect()
      },
      "__c": function($event) {
        _vm.connectProtocol = false
      }
    }
  }), _vm._v(" 否")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab1', 'model.supplierProtocolRule')),
      expression: "validateErrors.has('tab1','model.supplierProtocolRule')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("请补充完整下方所需关联协议")])]), _vm._v(" "), (_vm.connectProtocol) ? _c('content-block', {
    attrs: {
      "title": "关联协议",
      "isRequired": ""
    }
  }, _vm._l((_vm.selectProtocolTypeList), function(block, index) {
    return _c('div', [_c('div', {
      staticStyle: {
        "position": "relative"
      }
    }, [_c('div', {
      staticClass: "step-line"
    }), _vm._v(" "), _c('div', {
      staticClass: "row step-content"
    }, [_c('div', {
      staticClass: "ticket-step ticket-step-active col-sm-1"
    }, [_vm._v("1")]), _vm._v(" "), _c('span', {
      staticClass: "col-sm-1 no-padding-right"
    }, [_vm._v("协议类型")]), _vm._v(" "), (_vm.protocolTypeList.length > 1) ? _c('v-select', {
      staticClass: "col-sm-6",
      attrs: {
        "placeholder": "请选择协议类型"
      },
      model: {
        value: (_vm.selectProtocolTypeList[index]),
        callback: function($$v) {
          _vm.$set(_vm.selectProtocolTypeList, index, $$v)
        },
        expression: "selectProtocolTypeList[index]"
      }
    }, _vm._l((_vm.protocolTypeList), function(item) {
      return _c('v-option', {
        key: item.key,
        attrs: {
          "label": item.name,
          "value": item.key,
          "disabled": _vm.selectProtocolTypeList.indexOf(item.key) !== -1
        }
      })
    })) : (_vm.protocolTypeList.length === 1) ? _c('span', {
      staticClass: "col-sm-6"
    }, [_vm._v(_vm._s(_vm.protocolTypeList[0].name))]) : _vm._e(), _vm._v(" "), _c('span', [(_vm.selectProtocolTypeList.length < _vm.protocolTypeList.length) ? _c('button', {
      staticClass: "btn btn-link btn-xs",
      on: {
        "click": function($event) {
          _vm.addProtocolType()
        }
      }
    }, [_c('i', {
      staticClass: "icon-button icon-plus"
    })]) : _vm._e(), _vm._v(" "), (_vm.selectProtocolTypeList.length > 1) ? _c('button', {
      staticClass: "btn btn-link btn-xs",
      on: {
        "click": function($event) {
          _vm.removeProtocolType(index)
        }
      }
    }, [_c('i', {
      staticClass: "icon-button delete icon-cancel"
    })]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
      staticClass: "row step-content"
    }, [_c('div', {
      staticClass: "ticket-step ticket-step-active col-sm-1"
    }, [_vm._v("2")]), _vm._v(" "), _c('span', {
      staticClass: "col-sm-1 no-padding-right"
    }, [_vm._v("协议名称")]), _vm._v(" "), (_vm.selectProtocolTypeList[index] === '') ? _c('v-input', {
      staticClass: "col-sm-6",
      attrs: {
        "disabled": true
      }
    }) : (_vm.protocolInfo[_vm.selectProtocolTypeList[index]].length === 1) ? _c('span', {
      staticClass: "col-sm-6"
    }, [_vm._v(_vm._s(_vm.protocolInfo[_vm.selectProtocolTypeList[index]][0].ruleName))]) : (_vm.protocolInfo[_vm.selectProtocolTypeList[index]].length > 1) ? _c('v-select', {
      staticClass: "col-sm-6",
      attrs: {
        "placeholder": "请选择协议名称"
      },
      on: {
        "change": _vm.addProtocol
      },
      model: {
        value: (_vm.tempMsg),
        callback: function($$v) {
          _vm.tempMsg = $$v
        },
        expression: "tempMsg"
      }
    }, _vm._l((_vm.protocolInfo[_vm.selectProtocolTypeList[index]]), function(item) {
      return _c('v-option', {
        key: item.ruleId,
        attrs: {
          "label": item.ruleName,
          "value": ((_vm.selectProtocolTypeList[index]) + "~||~" + (JSON.stringify(item))),
          "disabled": typeof item.disabled !== 'undefined' && item.disabled
        }
      })
    })) : _vm._e()], 1)]), _vm._v(" "), (_vm.selectProtocolTypeList[index] !== '' &&
      _vm.supplierProtocolRule[_vm.selectProtocolTypeList[index]].length > 0 &&
      _vm.protocolInfo[_vm.selectProtocolTypeList[index]].length > 1) ? _c('div', {
      staticClass: "row step-content tags"
    }, [_c('div', {
      staticClass: "col-sm-10 col-md-offset-1"
    }, _vm._l((_vm.supplierProtocolRule[_vm.selectProtocolTypeList[index]]), function(tag, tagIndex) {
      return _c('v-tag', {
        key: tag.ruleName,
        staticClass: "tag",
        attrs: {
          "type": 'success',
          "close-transition": false,
          "closable": true
        },
        on: {
          "close": function($event) {
            _vm.handleTagClose(tagIndex, _vm.selectProtocolTypeList[index])
          }
        }
      }, [_vm._v("\n                        " + _vm._s(tag.ruleName) + "\n                    ")])
    }))]) : _vm._e()])
  })) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 545 */
/*!**********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ed40704","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ticket/product/item/Info.vue ***!
  \**********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.model.modelReady) ? _c('div', [_c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [_c('h2', [_vm._v("基本信息")]), _vm._v(" "), _c('deal-and-contract', {
    attrs: {
      "model": _vm.model,
      "extra": _vm.extra,
      "mode": _vm.mode,
      "updateServicePhone": _vm.updateServicePhone,
      "errors": _vm.errors
    },
    on: {
      "update:model": function($event) {
        _vm.model = $event
      },
      "update:errors": function($event) {
        _vm.errors = $event
      }
    }
  }), _vm._v(" "), (_vm.extra.isBD && !_vm.isTuan) ? _c('supplierProtocol', {
    ref: "supplierProtocol",
    attrs: {
      "extra": _vm.extra,
      "supplierProtocolRule": _vm.model.supplierProtocolRule,
      "loaded": _vm.loaded
    },
    on: {
      "update:supplierProtocolRule": function($event) {
        _vm.model.supplierProtocolRule = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('content-block', {
    attrs: {
      "type": {
        left: 2,
        right: 6
      },
      "title": "商品品类",
      "isRequired": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "va",
      rawName: "v-va.tab1",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "tab1": true
      }
    }],
    class: {
      'input': true, 'is-danger': _vm.validateErrors.has('tab1', 'model.mtCategory')
    },
    attrs: {
      "placeholder": "请选择品类"
    },
    model: {
      value: (_vm.model.mtCategory),
      callback: function($$v) {
        _vm.model.mtCategory = $$v
      },
      expression: "model.mtCategory"
    }
  }, _vm._l((_vm.mtCategories), function(item) {
    return (!(_vm.extra.isDirectDeal && item.value === 779)) ? _c('v-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    }) : _vm._e()
  })), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab1', 'model.mtCategory')),
      expression: "validateErrors.has('tab1', 'model.mtCategory')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("请选择商品品类")])], 1), _vm._v(" "), _c('content-block', {
    attrs: {
      "title": "景点与票种",
      "isRequired": ""
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "step-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "row step-content"
  }, [_c('div', {
    staticClass: "ticket-step ticket-step-active col-sm-1"
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "col-sm-1 no-padding-right"
  }, [_vm._v("选择城市")]), _vm._v(" "), _c('v-select', {
    staticClass: "col-sm-6",
    attrs: {
      "filterable": "",
      "placeholder": "请先选择景点所在城市"
    },
    model: {
      value: (_vm.selectedCity),
      callback: function($$v) {
        _vm.selectedCity = $$v
      },
      expression: "selectedCity"
    }
  }, _vm._l((_vm.cities), function(item) {
    return _c('v-option', {
      key: item.locationId,
      attrs: {
        "label": item.name,
        "value": item.locationId
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "row step-content"
  }, [_c('div', {
    staticClass: "ticket-step ticket-step-active col-sm-1"
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "col-sm-1 no-padding-right"
  }, [_vm._v("选择景点")]), _vm._v(" "), _c('v-select', {
    staticClass: "col-sm-6",
    class: {
      'input': true, 'is-danger': _vm.validateErrors.has('tab1', 'model.ticketCategory.poi')
    },
    attrs: {
      "filterable": "",
      "remote": "",
      "remote-method": _vm.getPoiList,
      "disabled": _vm.selectedCity === '' || (_vm.onlineBefore && !_vm.extra.isBD),
      "placeholder": _vm.selectedCity === '' ? '请选择景点' : '请输入景点名称或poi编号'
    },
    on: {
      "change": _vm.clicked
    },
    model: {
      value: (_vm.msg),
      callback: function($$v) {
        _vm.msg = $$v
      },
      expression: "msg"
    }
  }, _vm._l((_vm.poi), function(item) {
    return _c('v-option', {
      key: item.mdcPoiId,
      attrs: {
        "label": item.placeName,
        "value": item,
        "disabled": item.accurateResult === 0
      }
    }, [(_vm.extra.isBD) ? _c('span', {
      staticClass: "local-gray-color"
    }, [_vm._v(_vm._s(item.mdcPoiId))]) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(_vm._s(item.mdcPoiName))]), _vm._v(" "), (_vm.extra.isBD) ? _c('span', {
      staticClass: "local-gray-color"
    }, [_vm._v("在售" + _vm._s(item.dealCount))]) : _vm._e()])
  })), _vm._v(" "), (_vm.extra.isBD) ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "icon-error help-icon"
  }), _vm._v(" 如若没有景点，请在CRM中先创建新景点\n                    ")]) : _c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "icon-error help-icon"
  }), _vm._v(" 如若没有景点，请联系你的BD\n                    ")])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab1', 'model.ticketCategory.poi')),
      expression: "validateErrors.has('tab1', 'model.ticketCategory.poi')"
    }],
    staticClass: "help is-danger",
    staticStyle: {
      "padding-left": "11%",
      "margin-top": "-20px"
    }
  }, [_vm._v("请选择景点")]), _vm._v(" "), (_vm.model.ticketCategory && _vm.model.ticketCategory.poi.length > 0) ? _c('div', {
    staticClass: "row step-content tags"
  }, [_c('div', {
    staticClass: "col-sm-10 col-md-offset-1"
  }, _vm._l((_vm.model.ticketCategory.poi), function(tag, index) {
    return _c('v-tag', {
      key: tag.mdcPoiId,
      staticClass: "tag",
      attrs: {
        "closable": _vm.mode !== 'readonly' && !(_vm.onlineBefore && !_vm.extra.isBD),
        "type": 'success',
        "close-transition": false
      },
      on: {
        "close": function($event) {
          _vm.handleTagClose(index)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(tag.mdcPoiName) + "\n                        ")])
  }))]) : _vm._e(), _vm._v(" "), (_vm.ticketAdvices && _vm.ticketAdvices.length > 0) ? _c('div', {
    staticClass: "row step-content tags"
  }, [_c('div', {
    staticClass: "col-sm-10 col-md-offset-1"
  }, _vm._l((_vm.ticketAdvices), function(advice, index) {
    return _c('v-alert', {
      key: index,
      staticClass: "content-gap-10mg",
      attrs: {
        "title": " ",
        "type": advice.type == 3 ? 'error' : 'warning'
      },
      domProps: {
        "innerHTML": _vm._s(advice.message)
      }
    })
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row step-content"
  }, [_c('div', {
    staticClass: "ticket-step ticket-step-active col-sm-1"
  }, [_vm._v("3")]), _vm._v(" "), _c('span', {
    staticClass: "col-sm-1 no-padding-right"
  }, [_vm._v("门票票种")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "va",
      rawName: "v-va.tab1",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "tab1": true
      }
    }],
    staticClass: "col-sm-6",
    class: {
      'input': true, 'is-danger': _vm.validateErrors.has('tab1', 'ticketType')
    },
    attrs: {
      "placeholder": "请选择票种",
      "no-match-text": "1",
      "filterable": "",
      "disabled": _vm.model.ticketCategory && _vm.model.ticketCategory.poi && _vm.model.ticketCategory.poi.length <= 0 || (_vm.onlineBefore && !_vm.extra.isBD)
    },
    model: {
      value: (_vm.ticketType),
      callback: function($$v) {
        _vm.ticketType = $$v
      },
      expression: "ticketType"
    }
  }, _vm._l((_vm.ticketTypeList), function(item) {
    return _c('v-option', {
      key: item.value.subTicketId || item.value,
      staticClass: "custom-dropdown-with-title",
      attrs: {
        "label": item.label,
        "value": item.value,
        "disabled": item.disabled
      }
    })
  })), _vm._v(" "), (_vm.ticketType && _vm.ticketType.length > 0 && (!_vm.model.ticketCategory || !_vm.model.ticketCategory.subTicket || !_vm.model.ticketCategory.subTicket.ticketId)) ? _c('div', {
    staticClass: "pending-approval"
  }, [_vm._v("待审核")]) : _vm._e(), _vm._v(" "), (_vm.mode !== 'readonly') ? _c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "icon-error help-icon"
  }), _vm._v(" 没有合适的票种？"), _c('a', {
    on: {
      "click": _vm.askForNewTicketType
    }
  }, [_vm._v("申请新票种")])]) : _vm._e()], 1)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab1', 'ticketType')),
      expression: "validateErrors.has('tab1', 'ticketType')"
    }],
    staticClass: "help is-danger",
    staticStyle: {
      "padding-left": "11%",
      "margin-top": "-20px"
    }
  }, [_vm._v("请选择票种")])])], 1), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly' && !_vm.isTuan
    }
  }, [_c('content-block', {
    attrs: {
      "title": "产品名称",
      "isRequired": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-8",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('v-input', {
    directives: [{
      name: "va",
      rawName: "v-va.tab1",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "tab1": true
      }
    }],
    class: {
      'input': true, 'is-danger': _vm.validateErrors.has('tab1', 'model.title')
    },
    attrs: {
      "type": "text",
      "name": "title",
      "placeholder": "请填写产品名称"
    },
    model: {
      value: (_vm.model.title),
      callback: function($$v) {
        _vm.model.title = $$v
      },
      expression: "model.title"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab1', 'model.title')),
      expression: "validateErrors.has('tab1', 'model.title')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("请填写产品名称")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "icon-error help-icon"
  }), _vm._v(" 格式要求：景点名称+消费项目+适用人群 例：故宫平日门票成人票\n            ")])])], 1), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [(_vm.ticketTypeStatusInfo && (_vm.ticketTypeStatusInfo.isNeed || _vm.ticketTypeStatusInfo.message)) ? _c('content-block', {
    attrs: {
      "title": "授权书"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ticketTypeStatusInfo.message))]), _vm._v(" "), (!_vm.extra.isBD && !_vm.extra.isDirect && _vm.certificateCreateUrl) ? _c('a', {
    attrs: {
      "href": _vm.certificateCreateUrl
    }
  }, [_vm._v("点此上传授权书")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('content-block', {
    attrs: {
      "title": "费用包含",
      "isRequired": !_vm.extra.isDirectDeal
    }
  }, [_c('table', {
    staticClass: "table table-hover table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_c('span', {
    staticClass: "required-content"
  }, [_vm._v("*")]), _vm._v("费用项目包含")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_c('span', {
    staticClass: "required-content"
  }, [_vm._v("*")]), _vm._v("数量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_c('span', {
    staticClass: "required-content"
  }, [_vm._v("*")]), _vm._v("单位")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("单次时长")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("操作")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.model.includeItems), function(data, index) {
    return _c('tr', {
      key: index,
      staticStyle: {
        "cursor": "default !important"
      }
    }, [_c('td', [(!_vm.extra.isDirectDeal) ? _c('v-input', {
      directives: [{
        name: "va",
        rawName: "v-va.tab1",
        value: ('required'),
        expression: "'required'",
        modifiers: {
          "tab1": true
        }
      }],
      attrs: {
        "data-key": index,
        "placeholder": "填写项目名称"
      },
      model: {
        value: (data.name),
        callback: function($$v) {
          data.name = $$v
        },
        expression: "data.name"
      }
    }) : _c('v-input', {
      attrs: {
        "data-key": index,
        "placeholder": "填写项目名称"
      },
      on: {
        "change": function($event) {
          _vm.includeErrorCheck()
        }
      },
      model: {
        value: (data.name),
        callback: function($$v) {
          data.name = $$v
        },
        expression: "data.name"
      }
    })], 1), _vm._v(" "), _c('td', [_c('custom-input-number', {
      attrs: {
        "min": 1
      },
      model: {
        value: (data.count),
        callback: function($$v) {
          data.count = $$v
        },
        expression: "data.count"
      }
    })], 1), _vm._v(" "), _c('td', [(!_vm.extra.isDirectDeal) ? _c('v-input', {
      directives: [{
        name: "va",
        rawName: "v-va.tab1",
        value: ('required'),
        expression: "'required'",
        modifiers: {
          "tab1": true
        }
      }],
      attrs: {
        "data-key": index
      },
      model: {
        value: (data.unit),
        callback: function($$v) {
          data.unit = $$v
        },
        expression: "data.unit"
      }
    }) : _c('v-input', {
      attrs: {
        "data-key": index
      },
      on: {
        "change": function($event) {
          _vm.includeErrorCheck()
        }
      },
      model: {
        value: (data.unit),
        callback: function($$v) {
          data.unit = $$v
        },
        expression: "data.unit"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-input', {
      staticStyle: {
        "display": "inline-block"
      },
      style: ({
        'width': _vm.extra.isDirectDeal ? '60%' : '100%',
        'float': _vm.extra.isDirectDeal ? 'left' : 'none'
      }),
      model: {
        value: (data.timeLength),
        callback: function($$v) {
          data.timeLength = $$v
        },
        expression: "data.timeLength"
      }
    }), _vm._v(" "), (_vm.extra.isDirectDeal) ? _c('div', {
      staticStyle: {
        "float": "right",
        "width": "40%",
        "line-height": "35px"
      }
    }, [_vm._v("小时")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "row"
    }, [(_vm.model.includeItems.length > 1) ? _c('div', {
      staticClass: "col-sm-3",
      staticStyle: {
        "float": "right"
      }
    }, [_c('span', {
      staticClass: "icon-times-circle control-icon delete click-able",
      on: {
        "click": function($event) {
          _vm.mode !== 'readonly' && _vm.deleteIncludeItems(index)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3",
      staticStyle: {
        "float": "right"
      }
    }, [_c('span', {
      staticClass: "icon-plus-circle control-icon click-able",
      on: {
        "click": function($event) {
          _vm.mode !== 'readonly' && _vm.newIncludeItems(index)
        }
      }
    })]), _vm._v(" "), (index !== _vm.model.includeItems.length - 1) ? _c('div', {
      staticClass: "col-sm-3",
      staticStyle: {
        "float": "right"
      }
    }, [_c('span', {
      staticClass: "icon-arrow-down control-icon click-able",
      on: {
        "click": function($event) {
          _vm.mode !== 'readonly' && _vm.downIncludeItems(index)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (index !== 0) ? _c('div', {
      staticClass: "col-sm-3",
      staticStyle: {
        "float": "right"
      }
    }, [_c('span', {
      staticClass: "icon-arrow-up control-icon click-able",
      on: {
        "click": function($event) {
          _vm.mode !== 'readonly' && _vm.upIncludeItems(index)
        }
      }
    })]) : _vm._e()])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "table-bottom"
  }, [_c('span', [_vm._v("项目可用数量：")]), _vm._v(" "), _c('span', [_c('label', {
    staticClass: "label-inline",
    attrs: {
      "for": "r21"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.isAllAvailable),
      expression: "model.isAllAvailable"
    }],
    staticClass: "v-radio",
    attrs: {
      "id": "r21",
      "name": "r2",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.model.isAllAvailable, true)
    },
    on: {
      "__c": function($event) {
        _vm.model.isAllAvailable = true
      }
    }
  }), _vm._v("\n                        全部可用")])]), _vm._v(" "), (_vm.model.includeItems && _vm.model.includeItems.length > 1) ? _c('span', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.isAllAvailable),
      expression: "model.isAllAvailable"
    }],
    staticClass: "v-radio",
    attrs: {
      "id": "r22",
      "name": "r2",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.model.isAllAvailable, false)
    },
    on: {
      "__c": function($event) {
        _vm.model.isAllAvailable = false
      }
    }
  }), _vm._v("\n                        " + _vm._s(_vm.model.includeItems.length) + "选\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "nano-select inline-input",
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_c('custom-input-number', {
    attrs: {
      "disabled": _vm.model.isAllAvailable,
      "max": _vm.model.includeItems.length - 1,
      "min": 1
    },
    model: {
      value: (_vm.model.availableCount),
      callback: function($$v) {
        _vm.model.availableCount = $$v
      },
      expression: "model.availableCount"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v(" 项可用")])]) : _vm._e()]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab1', 'data.name') || _vm.validateErrors.has('tab1', 'data.unit')),
      expression: "validateErrors.has('tab1', 'data.name') || validateErrors.has('tab1', 'data.unit')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("表格包含错误")])]), _vm._v(" "), _c('content-block', {
    attrs: {
      "title": "费用包含补充说明"
    }
  }, [_c('v-input', {
    directives: [{
      name: "textarea-check",
      rawName: "v-textarea-check"
    }],
    staticClass: "custom-textarea",
    attrs: {
      "type": "textarea",
      "rows": 5,
      "maxlength": 200,
      "placeholder": "选填，已写在费用包含中的项目请勿重复写至本栏，否则产品可能被审核人员驳回"
    },
    on: {
      "change": function($event) {
        _vm.includeErrorCheck()
      }
    },
    model: {
      value: (_vm.model.include),
      callback: function($$v) {
        _vm.model.include = $$v
      },
      expression: "model.include"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "help-block textarea-counter",
    class: {
      'textarea-counter-red': _vm.model.include.length > 200 ? true : false
    }
  }, [_vm._v(_vm._s(_vm.model.include.length) + "/200字")]), _vm._v(" "), _c('span', {
    staticClass: "help is-danger",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab1', 'model.includeItems~model.include')),
      expression: "validateErrors.has('tab1', 'model.includeItems~model.include')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("费用包含与补充说明二者至少填其一")])], 1), _vm._v(" "), (!_vm.extra.isDirectDeal && _vm.model.ticketCategory.poi && _vm.model.ticketCategory.poi.length) ? _c('content-block', {
    attrs: {
      "title": "适用人群限制"
    }
  }, [_c('discount-des', {
    ref: "crowdOption",
    attrs: {
      "options": _vm.crowdOptionsMap,
      "extra": _vm.extra,
      "crowds": _vm.model.ticketPoiDiscounts,
      "mode": _vm.mode
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('content-block', {
    attrs: {
      "title": "费用不包含"
    }
  }, [_c('v-input', {
    directives: [{
      name: "textarea-check",
      rawName: "v-textarea-check"
    }],
    staticClass: "custom-textarea",
    attrs: {
      "type": "textarea",
      "rows": 5,
      "maxlength": 150,
      "placeholder": "选填，需要额外花费才能享受的项目"
    },
    model: {
      value: (_vm.model.exclude),
      callback: function($$v) {
        _vm.model.exclude = $$v
      },
      expression: "model.exclude"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "help-block textarea-counter",
    class: {
      'textarea-counter-red': _vm.model.exclude.length > 150 ? true : false
    }
  }, [_vm._v(_vm._s(_vm.model.exclude.length) + "/150字")]), _vm._v(" "), _c('span', {
    staticClass: "help is-danger",
    staticStyle: {
      "display": "none"
    }
  })], 1), _vm._v(" "), _c('content-block', {
    attrs: {
      "title": "是否含保险",
      "isRequired": ""
    }
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "CI1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.containInsurance),
      expression: "model.containInsurance"
    }],
    attrs: {
      "id": "CI1",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.model.containInsurance, false)
    },
    on: {
      "__c": function($event) {
        _vm.model.containInsurance = false
      }
    }
  }), _vm._v("\n                    不包含")]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "CI2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.containInsurance),
      expression: "model.containInsurance"
    }],
    attrs: {
      "id": "CI2",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.model.containInsurance, true)
    },
    on: {
      "__c": function($event) {
        _vm.model.containInsurance = true
      }
    }
  }), _vm._v(" 包含")])]), _vm._v(" "), _c('div', [(_vm.model.containInsurance) ? _c('v-input', {
    directives: [{
      name: "va",
      rawName: "v-va.tab1",
      value: ('required'),
      expression: "'required'",
      modifiers: {
        "tab1": true
      }
    }],
    class: {
      'input': true, 'is-danger': _vm.validateErrors.has('tab1', 'model.insuranceNote')
    },
    attrs: {
      "maxlength": 30,
      "placeholder": "请填写保险的险种以及保险公司的名称"
    },
    model: {
      value: (_vm.model.insuranceNote),
      callback: function($$v) {
        _vm.model.insuranceNote = $$v
      },
      expression: "model.insuranceNote"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.model.containInsurance) ? _c('p', {
    staticClass: "help-block input-counter"
  }, [_vm._v(_vm._s(_vm.model.insuranceNote.length) + "/30字")]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab1', 'model.insuranceNote', 'required')),
      expression: "validateErrors.has('tab1', 'model.insuranceNote', 'required')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("请填写保险的险种以及保险公司的名称")])], 1)])], 1), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly' && !_vm.isTuan
    }
  }, [_c('content-block', {
    attrs: {
      "title": "客服电话",
      "isRequired": ""
    }
  }, [_vm._l((_vm.model.servicePhones), function(phone, index) {
    return _c('div', {
      key: index,
      staticClass: "row content-gap-10mg"
    }, [_c('div', {
      staticClass: "col-sm-3"
    }, [_c('v-input', {
      directives: [{
        name: "va",
        rawName: "v-va.tab1",
        value: ('required|tel'),
        expression: "'required|tel'",
        modifiers: {
          "tab1": true
        }
      }],
      staticClass: "form-control",
      class: {
        'input': true, 'is-danger': _vm.validateErrors.has('tab1', 'phone.phone', null, index)
      },
      attrs: {
        "type": "text",
        "data-key": index
      },
      model: {
        value: (phone.phone),
        callback: function($$v) {
          phone.phone = $$v
        },
        expression: "phone.phone"
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.validateErrors.has('tab1', 'phone.phone', 'required', index)),
        expression: "validateErrors.has('tab1', 'phone.phone', 'required', index)"
      }],
      staticClass: "help is-danger"
    }, [_vm._v("请输入客服电话")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.validateErrors.has('tab1', 'phone.phone', 'tel', index) && !_vm.validateErrors.has('tab1', 'phone.phone', 'required', index)),
        expression: "validateErrors.has('tab1', 'phone.phone', 'tel', index) && !validateErrors.has('tab1', 'phone.phone', 'required', index)"
      }],
      staticClass: "help is-danger"
    }, [_vm._v("电话号码格式不正确")])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-8"
    }, [_vm._v("\n                    客服工作时间\n                    "), _c('v-select', {
      staticClass: "nano-select inline-input",
      attrs: {
        "placeholder": "请选择"
      },
      model: {
        value: (phone.startHour),
        callback: function($$v) {
          phone.startHour = $$v
        },
        expression: "phone.startHour"
      }
    }, _vm._l((24), function(n) {
      return _c('v-option', {
        key: n,
        attrs: {
          "label": n - 1,
          "value": n - 1
        }
      })
    })), _vm._v("\n                    点\n                    "), _c('v-select', {
      staticClass: "nano-select inline-input",
      attrs: {
        "placeholder": "请选择"
      },
      model: {
        value: (phone.startMin),
        callback: function($$v) {
          phone.startMin = $$v
        },
        expression: "phone.startMin"
      }
    }, _vm._l((60), function(n) {
      return _c('v-option', {
        key: n,
        attrs: {
          "label": n - 1,
          "value": n - 1
        }
      })
    })), _vm._v("\n                    至\n                    "), _c('v-select', {
      staticClass: "nano-select inline-input",
      attrs: {
        "placeholder": "请选择"
      },
      model: {
        value: (phone.endHour),
        callback: function($$v) {
          phone.endHour = $$v
        },
        expression: "phone.endHour"
      }
    }, _vm._l((24), function(n) {
      return _c('v-option', {
        key: n,
        attrs: {
          "label": n - 1,
          "value": n - 1
        }
      })
    })), _vm._v("\n                    点\n                    "), _c('v-select', {
      staticClass: "nano-select inline-input",
      attrs: {
        "placeholder": "请选择"
      },
      model: {
        value: (phone.endMin),
        callback: function($$v) {
          phone.endMin = $$v
        },
        expression: "phone.endMin"
      }
    }, _vm._l((60), function(n) {
      return _c('v-option', {
        key: n,
        attrs: {
          "label": n - 1,
          "value": n - 1
        }
      })
    })), _vm._v(" "), ((_vm.mode !== 'readonly' || _vm.isTuan) && _vm.model.servicePhones && _vm.model.servicePhones.length > 1) ? _c('div', {
      staticClass: "icon-button delete icon-cancel",
      on: {
        "click": function($event) {
          _vm.deleteOneServicePhone(index)
        }
      }
    }) : _vm._e()], 1)])
  }), _vm._v(" "), ((_vm.mode !== 'readonly' || _vm.isTuan) && _vm.model.servicePhones && _vm.model.servicePhones.length < 3) ? _c('div', {
    staticClass: "row"
  }, [(_vm.servicePhone.length > 0) ? _c('div', {
    staticClass: "icon-link-revise col-sm-3",
    on: {
      "click": _vm.newServicePhoneFromContract
    }
  }, [_c('span', {
    staticClass: "icon-plus-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "mls"
  }, [_vm._v(" 从合同电话中选择")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "icon-link-revise col-sm-3",
    on: {
      "click": _vm.newServicePhone
    }
  }, [_c('span', {
    staticClass: "icon-plus-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "mls"
  }, [_vm._v(" 新增客服电话")])])]) : _vm._e()], 2)], 1), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [_c('h2', [_vm._v("产品图片")]), _vm._v(" "), _c('div', {
    staticClass: "row form-item"
  }, [_c('div', {
    staticClass: "col-sm-2 rowTitle"
  }, [_vm._v("产品图片")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', [_c('custom-upload', {
    attrs: {
      "url": _vm.apiHost + '/midas/common/v1/upload',
      "is-multiple": false,
      "max-limit": 5,
      "disabled": _vm.mode == 'readonly',
      "thumbnail-mode": true,
      "show-file-list": false,
      "type": "imageList",
      "default-file-list": _vm.originImgList,
      "fileLimitSize": 2097152,
      "enable-head-image": true
    },
    on: {
      "on-max-limit": _vm.onMaxLimit,
      "on-error": _vm.onError,
      "on-success": _vm.onSuccess,
      "on-delete": _vm.onDelete,
      "on-file-size-max-limit": _vm.onSizeLimited,
      "on-set-head": _vm.onSetHeadImage
    }
  })], 1), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), (_vm.model.ticketCategory.createTicketCategoryInfo) ? _c('v-dialog', {
    attrs: {
      "title": "申请新票种",
      "size": "lg",
      "show-close": true
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('content-block', {
    attrs: {
      "type": {
        left: 3,
        right: 8
      },
      "title": "票种名称",
      "isRequired": ""
    }
  }, [_c('v-input', {
    model: {
      value: (_vm.model.ticketCategory.createTicketCategoryInfo.ticketCategoryName),
      callback: function($$v) {
        _vm.model.ticketCategory.createTicketCategoryInfo.ticketCategoryName = $$v
      },
      expression: "model.ticketCategory.createTicketCategoryInfo.ticketCategoryName"
    }
  })], 1), _vm._v(" "), _c('content-block', {
    attrs: {
      "type": {
        left: 3,
        right: 8
      },
      "title": "使用人群",
      "isRequired": ""
    }
  }, [_c('v-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.ticketCategory.createTicketCategoryInfo.usePeople),
      callback: function($$v) {
        _vm.model.ticketCategory.createTicketCategoryInfo.usePeople = $$v
      },
      expression: "model.ticketCategory.createTicketCategoryInfo.usePeople"
    }
  }, _vm._l((_vm.usePeopleTypes), function(item) {
    return _c('v-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('content-block', {
    attrs: {
      "type": {
        left: 3,
        right: 8
      },
      "title": "时间限制范围",
      "isRequired": ""
    }
  }, [_c('v-select', {
    staticClass: "col-sm-6",
    staticStyle: {
      "padding-left": "0"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.ticketCategory.createTicketCategoryInfo.timeLimitedRange),
      callback: function($$v) {
        _vm.model.ticketCategory.createTicketCategoryInfo.timeLimitedRange = $$v
      },
      expression: "model.ticketCategory.createTicketCategoryInfo.timeLimitedRange"
    }
  }, _vm._l((_vm.timeLimitedRangeTypes), function(item) {
    return _c('v-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })), _vm._v(" "), _c('v-input', {
    staticClass: "col-sm-6",
    staticStyle: {
      "padding-right": "0"
    },
    attrs: {
      "disabled": _vm.model.ticketCategory.createTicketCategoryInfo.timeLimitedRange !== 0
    },
    model: {
      value: (_vm.model.ticketCategory.createTicketCategoryInfo.timeLimitedRangeText),
      callback: function($$v) {
        _vm.model.ticketCategory.createTicketCategoryInfo.timeLimitedRangeText = $$v
      },
      expression: "model.ticketCategory.createTicketCategoryInfo.timeLimitedRangeText"
    }
  })], 1), _vm._v(" "), _c('content-block', {
    attrs: {
      "type": {
        left: 3,
        right: 8
      },
      "title": "票种门市价",
      "isRequired": ""
    }
  }, [_c('v-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.model.ticketCategory.createTicketCategoryInfo.ticketCategoryPrice),
      callback: function($$v) {
        _vm.model.ticketCategory.createTicketCategoryInfo.ticketCategoryPrice = $$v
      },
      expression: "model.ticketCategory.createTicketCategoryInfo.ticketCategoryPrice"
    }
  })], 1), _vm._v(" "), _c('content-block', {
    attrs: {
      "type": {
        left: 3,
        right: 8
      },
      "title": "上传物料类型",
      "isRequired": ""
    }
  }, [_c('v-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.ticketCategory.createTicketCategoryInfo.uploadMaterialType),
      callback: function($$v) {
        _vm.model.ticketCategory.createTicketCategoryInfo.uploadMaterialType = $$v
      },
      expression: "model.ticketCategory.createTicketCategoryInfo.uploadMaterialType"
    }
  }, _vm._l((_vm.uploadMaterialTypes), function(item) {
    return _c('v-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), (_vm.model.ticketCategory.createTicketCategoryInfo.uploadMaterialType !== 0) ? _c('content-block', {
    attrs: {
      "type": {
        left: 3,
        right: 8
      },
      "title": "上传物料",
      "isRequired": ""
    }
  }, [(_vm.model.ticketCategory.createTicketCategoryInfo.uploadMaterialType !== 2) ? _c('v-input', {
    staticClass: "content-gap-10mg",
    attrs: {
      "type": "textarea",
      "rows": 2
    },
    model: {
      value: (_vm.model.ticketCategory.createTicketCategoryInfo.uploadMaterialText),
      callback: function($$v) {
        _vm.model.ticketCategory.createTicketCategoryInfo.uploadMaterialText = $$v
      },
      expression: "model.ticketCategory.createTicketCategoryInfo.uploadMaterialText"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.model.ticketCategory.createTicketCategoryInfo.uploadMaterialType !== 1) ? _c('custom-upload', {
    attrs: {
      "url": _vm.apiHost + '/midas/common/v1/upload',
      "is-multiple": false,
      "max-limit": 5,
      "disabled": _vm.mode == 'readonly',
      "thumbnail-mode": true,
      "show-file-list": false,
      "type": "imageList",
      "fileLimitSize": 2097152,
      "default-file-list": _vm.originTicketImgList
    },
    on: {
      "on-max-limit": _vm.onMaxLimit,
      "on-error": _vm.onError,
      "on-success": _vm.onTicketUploadSuccess,
      "on-delete": _vm.onTicketUploadDelete,
      "on-file-size-max-limit": _vm.onSizeLimited
    }
  }, [_c('div', {
    staticClass: "v-upload-tips",
    slot: "tips"
  }, [_vm._v("注：高度和宽度不低于440px，图片大小不超过2M，支持格式有jpg、png、jpeg")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.model.ticketCategory.createTicketCategoryInfo.uploadMaterialType == 0) ? _c('div', {
    staticClass: "noUploadNotice"
  }, [_vm._v("免物料类型：在已有的票种基础上进行使用人数变更、使用时限变更、人群组合票种变更、消费项目组合票种变更")]) : _vm._e(), _vm._v(" "), _c('content-block', {
    attrs: {
      "type": {
        left: 3,
        right: 8
      },
      "title": " "
    }
  }, [_c('v-button', {
    staticClass: "btn-default",
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("关闭\n            ")]), _vm._v(" "), _c('v-button', {
    staticClass: "btn-primary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.saveNewTicketType
    }
  }, [_vm._v("申请创建票种")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "title": "选择电话",
      "size": "lg",
      "show-close": true
    },
    model: {
      value: (_vm.phoneDialogVisible),
      callback: function($$v) {
        _vm.phoneDialogVisible = $$v
      },
      expression: "phoneDialogVisible"
    }
  }, [_vm._l((_vm.servicePhone), function(phone, index) {
    return _c('div', {
      key: index,
      staticClass: "content-gap-10mg"
    }, [_c('label', {
      attrs: {
        "for": ("selectPhone" + index)
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedPhone),
        expression: "selectedPhone"
      }],
      attrs: {
        "id": ("selectPhone" + index),
        "type": "checkbox"
      },
      domProps: {
        "value": phone,
        "checked": Array.isArray(_vm.selectedPhone) ? _vm._i(_vm.selectedPhone, phone) > -1 : (_vm.selectedPhone)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.selectedPhone,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = phone,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedPhone = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selectedPhone = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedPhone = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(phone.phone))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(phone.startHour) + "点" + _vm._s(phone.startMin) + "分 至 " + _vm._s(phone.endHour) + "点" + _vm._s(phone.endMin) + "分")])])])
  }), _vm._v(" "), _c('content-block', {
    attrs: {
      "type": {
        left: 3,
        right: 8
      },
      "title": " "
    }
  }, [_c('v-button', {
    staticClass: "btn-default",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.phoneDialogVisible = false
      }
    }
  }, [_vm._v("关闭\n            ")]), _vm._v(" "), _c('v-button', {
    staticClass: "btn-primary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.saveServicePhoneFromContract
    }
  }, [_vm._v("保存")])], 1)], 2)], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b', [_vm._v("注意事项：")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("1. 高度和宽度不低于440px，图片大小不超过2M，支持格式有jpg、png、jpeg")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("2. 重要提示：图片不可有字、不可使用拼图、不可有重复图片、不可有除美团水印外的其他水印、不能有人物特写、明星宣传画等涉及人物肖像权的图片")])])
}]}

/***/ }),
/* 546 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7cac3229","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/ticket/product/item/Price.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 547 */
/*!********************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/ticket/product/item/Price.vue ***!
  \********************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ 22);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(/*! babel-runtime/helpers/asyncToGenerator */ 23);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _helpers = __webpack_require__(/*! helpers */ 16);

var _big = __webpack_require__(/*! big.js */ 548);

var _big2 = _interopRequireDefault(_big);

var _index2 = __webpack_require__(/*! components/input-number-custom/index.vue */ 115);

var _index3 = _interopRequireDefault(_index2);

var _Calendar = __webpack_require__(/*! components/calendar/Calendar.vue */ 549);

var _Calendar2 = _interopRequireDefault(_Calendar);

var _vuex = __webpack_require__(/*! vuex */ 14);

var _env = __webpack_require__(/*! config/env.conf */ 2);

var _ticket = __webpack_require__(/*! api/ticket */ 50);

var _upload = __webpack_require__(/*! components/custom-upload/upload.vue */ 233);

var _upload2 = _interopRequireDefault(_upload);

var _index4 = __webpack_require__(/*! components/datepicker/index */ 236);

var _index5 = _interopRequireDefault(_index4);

var _sortDialog = __webpack_require__(/*! components/product/sortDialog.vue */ 557);

var _sortDialog2 = _interopRequireDefault(_sortDialog);

var _refund = __webpack_require__(/*! components/product/refund.vue */ 561);

var _refund2 = _interopRequireDefault(_refund);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        Calendar: _Calendar2.default,
        CustomUpload: _upload2.default,
        CustomInputNumber: _index3.default,
        customDatepicker: _index5.default,
        SortDialog: _sortDialog2.default,
        Refund: _refund2.default
    },
    directives: {},
    data: function data() {
        var _this = this;

        var that = this;
        return {
            // 是否有价格日历
            canPullPrice: false,
            // 是否需要校验
            needValidation: true,
            // 可用日期选择，是否至少有一个选择了
            hasWeekOne: true,
            // 特殊费率
            ratioInvalid: false,
            modelLocal: { mtPrice: null, marketPrice: null, settlementPrice: null, stock: null },
            // 子账户
            subAccounts: [],
            // 全选子账户
            subAccountAll: false,
            // 有效期时间段日期组件配置
            inDateOption: {
                allowInput: false,
                mode: 'range',
                minDate: (0, _helpers.formatDate)(new Date(), 'yyyy-MM-dd'),
                onChange: function onChange(dates) {
                    var beginDate = null;
                    var endDate = null;
                    dates = dates.length ? dates : _this.voucherDateBeginEnd.split(' ~ ');
                    if (dates && dates.length > 1) {
                        _this.model.voucherDateBegin = (0, _helpers.formatDate)(dates[0], 'yyyy-MM-dd');
                        _this.model.voucherDateEnd = (0, _helpers.formatDate)(dates[1], 'yyyy-MM-dd');
                        beginDate = _this.model.voucherDateBegin;
                        endDate = _this.model.voucherDateEnd;
                        // 删除已选择的不在时间段内的日期
                        if (_this.model.unavailableDates && _this.model.unavailableDates.length) {
                            _this.model.unavailableDates = _this.model.unavailableDates.filter(function (item) {
                                return item >= beginDate && item <= endDate;
                            });
                        }
                    }
                    _this.model.voucherDateBegin = beginDate;
                    _this.model.voucherDateEnd = endDate;
                    // 更新日历配置
                    _this.inDateOptionOpen.minDate = beginDate || (0, _helpers.formatDate)(new Date(), 'yyyy-MM-dd');
                    _this.inDateOptionOpen.maxDate = endDate;
                }
            },
            // 不可用日期
            unavailableDates: '',
            inDateOptionOpen: {
                allowInput: false,
                minDate: that.model.voucherDateBegin || (0, _helpers.formatDate)(new Date(), 'yyyy-MM-dd'),
                maxDate: that.model.voucherDateEnd,
                dateFormat: 'yyyy-MM-dd',
                mode: 'multiple',
                inline: true,
                onChange: function onChange(dates) {
                    if (Array.isArray(dates)) {
                        _this.model.unavailableDates = dates.map(function (i) {
                            return (0, _helpers.formatDate)(i, 'yyyy-MM-dd');
                        });
                    } else {
                        _this.model.unavailableDates = [];
                    }
                },
                clickOpens: true
            },
            // 可用日期是否全选
            validWeekCheckedAll: false,
            validWeekRuleIds: [],
            foundFreeTicket: false,
            weeks: [{
                text: '周一',
                val: 'monday'
            }, {
                text: '周二',
                val: 'tuesday'
            }, {
                text: '周三',
                val: 'wednesday'
            }, {
                text: '周四',
                val: 'thursday'
            }, {
                text: '周五',
                val: 'friday'
            }, {
                text: '周六',
                val: 'saturday'
            }, {
                text: '周日',
                val: 'sunday'
            }],
            // 免票类型
            freeTicketTypes: [{
                name: '返佣免票',
                id: 0
            }, {
                name: '广告位置换免票',
                id: 1
            }, {
                name: '商家赠与免票',
                id: 2
            }, {
                name: '商家参与活动免票',
                id: 3
            }, {
                name: '其他',
                id: 4
            }],
            today: (0, _helpers.formatDate)(new Date(), 'yyyy-MM-dd'),
            // 图片上传
            upload: {
                maxImgLength: 5,
                url: '' + _env.apiHost + _ticket.uploadImage,
                maxSize: 1024 * 1024 * 2,
                onBeforeUpload: function onBeforeUpload(file) {
                    var error = '';
                    if (file.size > that.upload.maxSize) {
                        error = '您选择了超过2M的图片，请上传小于2M的图片';
                    }
                    if (error) {
                        that.$message({
                            showClose: false,
                            message: error,
                            type: 'warning',
                            duration: 1000
                        });
                    }
                },

                onMaxLimit: function onMaxLimit(e) {
                    that.$notify.error({
                        title: '错误',
                        message: '最多只能上传5张图片'
                    });
                },
                onSizeLimited: function onSizeLimited(e) {
                    that.$message({
                        showClose: true,
                        message: '最多只能上传2M的图片',
                        type: 'error',
                        duration: 10000
                    });
                },
                onProgress: function onProgress(value) {
                    console.log('onProgress...');
                },
                onError: function onError(value) {
                    console.log('onError...');
                },
                onSuccess: function onSuccess(value) {
                    if (value && value.file && value.file.url) {
                        var img = { imageName: value.file.name, imageUrl: value.file.url };
                        that.model.specialAuthPics.push(img);
                    }
                },
                onDelete: function onDelete(value) {
                    var url = '';
                    if (value.file) {
                        url = value.file.url;
                    } else {
                        url = value.url;
                    }
                    var _index = -1;
                    that.model.specialAuthPics.filter(function (item, index) {
                        if (url === item.imageUrl) {
                            _index = index;
                        }
                    });
                    if (_index > -1) {
                        that.model.specialAuthPics.splice(_index, 1);
                    }
                }
            },
            // 价格日历已经选择日期
            dateSelected: [],
            voucherDateBeginEnd: '',
            // 特殊费率列表
            invalidRatioList: {},
            // 价格日历模式下是否费率下降
            hasDeclined: false,
            // 价格日历模式下是否低于基准费率
            belowBase: false,
            // 座位图片
            seatUpload: {
                maxImgLength: 1,
                url: '' + _env.apiHost + _ticket.uploadImage,
                maxSize: 1024 * 1024 * 2,
                onBeforeUpload: function onBeforeUpload(file) {
                    var error = '';
                    if (file.size > that.upload.maxSize) {
                        error = '您选择了超过2M的图片，请上传小于2M的图片';
                    }
                    if (error) {
                        that.$message({
                            showClose: false,
                            message: error,
                            type: 'warning',
                            duration: 1000
                        });
                    }
                },

                onMaxLimit: function onMaxLimit() {
                    that.$notify.error({
                        title: '错误',
                        message: '最多只能上传1张图片'
                    });
                },
                onSizeLimited: function onSizeLimited() {
                    that.$message({
                        showClose: true,
                        message: '最多只能上传2M的图片',
                        type: 'error',
                        duration: 10000
                    });
                },
                onSuccess: function onSuccess(value) {
                    if (value && value.file && value.file.url) {
                        that.model.seatImage = value.file.url;
                    }
                },
                onDelete: function onDelete() {
                    that.model.seatImage = '';
                }
            },
            theatreTab: { changci: false, xiwei: false, changguan: false },
            // 剧场票价格日历配置
            price: {
                // 是否可以编辑剧场票价格
                canEditPrice: that.mode === 'new',
                dateSelected: [],
                // 合并成表格结构
                priceTable: [],
                priceSet: {},
                single: false,
                getInfoFun: function getInfoFun(day) {
                    var date = day.date;
                    var priceSet = that.price.priceSet;
                    var info = { texts: [], otherColor: true };
                    var item = priceSet[date];
                    if (item && item.length && item[0].mtPrice) {
                        info.texts.push('<span>已设置价格</span>');
                    }
                    return info;
                },
                onDaySelect: function onDaySelect(day) {
                    // 假如10号和11号有相同的价格说明，但是录入的价格不同时提示
                    var needUpdate = day && !that.price.canEditPrice;
                    if (needUpdate) {
                        that.price.dateSelected = [day.$day.date];
                    }
                    var needMerge = that.mergeTheatrePrice(null, true);
                    if (needMerge) {
                        that.$message.info(needMerge + '相同的价格说明，设置的价格不同，需要分开录入！');
                        that.price.dateSelected.splice(that.price.dateSelected.length - 1, 1);
                    }
                    if (needMerge || needUpdate) {
                        that.$nextTick(function () {
                            that.updateCalendar();
                        });
                    }
                },
                cancelCanEdit: function cancelCanEdit() {
                    that.price.canEditPrice = false;
                    that.price.dateSelected.length = 0;
                    that.price.priceTable = [];
                    that.$nextTick(function () {
                        that.updateCalendar();
                    });
                },
                // 设置价格日历
                savePrice: function savePrice() {
                    var priceTable = that.price.priceTable;
                    var hasNull = !priceTable || priceTable.length < 1 || priceTable.filter(function (i) {
                        return !i.marketPrice || !i.mtPrice || !i.settlementPrice;
                    }).length;
                    if (hasNull) {
                        that.$message.info('请选择日期并填写完整价格再保存！');
                        return;
                    }
                    that.saveTheatreIno('price', true);
                }
            },
            changci: {
                // 是否可以编辑剧场票价
                canEditPrice: that.mode === 'new',
                dateSelected: [],
                // 合并成表格结构
                priceTable: [],
                priceSet: {},
                single: false,
                getInfoFun: function getInfoFun(day) {
                    var date = day.date;
                    var priceSet = that.changci.priceSet;
                    var info = { texts: [] };
                    var item = priceSet[date];
                    if (item && item.length) {
                        item.forEach(function (i) {
                            info.texts.push('<span>\u573A\u6B21 ' + i.levelName + '</span>');
                        });
                    }
                    return info;
                },
                onDaySelect: function onDaySelect(day) {
                    // 重复场次开始时间则提示
                    var needUpdate = day && !that.changci.canEditPrice;
                    if (needUpdate) {
                        that.changci.dateSelected = [day.$day.date];
                    }
                    var needMerge = that.mergeTheatrePrice(that.changci.dateSelected, true, that.changci.priceSet, that.changci.priceTable, 'mappingRel');
                    if (needMerge) {
                        that.$message.info(needMerge + '相同的场次开始时间，需要分开录入！');
                        that.changci.dateSelected.splice(that.changci.dateSelected.length - 1, 1);
                    }
                    if (needMerge || needUpdate) {
                        that.$nextTick(function () {
                            that.updateCalendar();
                        });
                    }
                },
                cancelCanEdit: function cancelCanEdit() {
                    that.changci.canEditPrice = false;
                    that.changci.dateSelected.length = 0;
                    that.changci.priceTable = [];
                    that.$nextTick(function () {
                        that.updateCalendar();
                    });
                },
                // 设置价格日历
                savePrice: function savePrice() {
                    var priceTable = that.changci.priceTable;
                    var hasNull = !priceTable || priceTable.length < 1 || priceTable.filter(function (i) {
                        return !i.levelName || !i.mappingRel;
                    }).length;
                    if (hasNull) {
                        that.$message.info('请选择日期并填写完整信息再保存！');
                        return;
                    }
                    that.saveTheatreIno('changci');
                }
            },
            // 剧场票价格日历配置
            xiwei: {
                canEditPrice: that.mode === 'new',
                dateSelected: [],
                // 合并成表格结构
                priceTable: [],
                priceSet: [],
                single: false,
                getInfoFun: function getInfoFun(day) {
                    var date = day.date;
                    var priceSet = that.xiwei.priceSet;
                    var info = { texts: [] };
                    var item = priceSet[date];
                    if (item && item.length) {
                        item.forEach(function (i) {
                            info.texts.push('<span>' + i.levelName + '</span>');
                        });
                    }
                    return info;
                },
                onDaySelect: function onDaySelect(day) {
                    // 重复坐席位置则提示
                    var needUpdate = day && !that.xiwei.canEditPrice;
                    if (needUpdate) {
                        that.xiwei.dateSelected = [day.$day.date];
                    }
                    var needMerge = that.mergeTheatrePrice(that.xiwei.dateSelected, true, that.xiwei.priceSet, that.xiwei.priceTable, 'mappingRel');
                    if (needMerge) {
                        that.$message.info(needMerge + '相同的坐席位置，需要分开录入！');
                        that.xiwei.dateSelected.splice(that.xiwei.dateSelected.length - 1, 1);
                    }
                    if (needMerge || needUpdate) {
                        that.$nextTick(function () {
                            that.updateCalendar();
                        });
                    }
                },
                cancelCanEdit: function cancelCanEdit() {
                    that.xiwei.canEditPrice = false;
                    that.xiwei.dateSelected.length = 0;
                    that.xiwei.priceTable = [];
                    that.$nextTick(function () {
                        that.updateCalendar();
                    });
                },
                // 设置价格日历
                savePrice: function savePrice() {
                    var priceTable = that.xiwei.priceTable;
                    var hasNull = !priceTable || priceTable.length < 1 || priceTable.filter(function (i) {
                        return !i.levelName || !i.mappingRel;
                    }).length;
                    if (hasNull) {
                        that.$message.info('请选择日期并填写完整信息再保存！');
                        return;
                    }
                    that.saveTheatreIno('xiwei');
                }
            },
            // 剧场票场馆区域tab
            changguan: {
                canEditPrice: that.mode === 'new',
                dateSelected: [],
                // 合并成表格结构
                priceTable: [],
                priceSet: [],
                single: false,
                getInfoFun: function getInfoFun(day) {
                    var date = day.date;
                    var priceSet = that.changguan.priceSet;
                    var info = { texts: [] };
                    var item = priceSet[date];
                    if (item && item.length) {
                        item.forEach(function (i) {
                            info.texts.push('<span>' + i.levelName + '</span>');
                        });
                    }
                    return info;
                },
                onDaySelect: function onDaySelect(day) {
                    // 重复坐席位置则提示
                    var needUpdate = day && !that.changguan.canEditPrice;
                    if (needUpdate) {
                        that.changguan.dateSelected = [day.$day.date];
                    }
                    var needMerge = that.mergeTheatrePrice(that.changguan.dateSelected, true, that.changguan.priceSet, that.changguan.priceTable, 'mappingRel');
                    if (needMerge) {
                        that.$message.info(needMerge + '相同的场馆位置，需要分开录入！');
                        that.changguan.dateSelected.splice(that.changguan.dateSelected.length - 1, 1);
                    }
                    if (needMerge || needUpdate) {
                        that.$nextTick(function () {
                            that.updateCalendar();
                        });
                    }
                },
                cancelCanEdit: function cancelCanEdit() {
                    that.changguan.canEditPrice = false;
                    that.changguan.dateSelected.length = 0;
                    that.changguan.priceTable = [];
                    that.$nextTick(function () {
                        that.updateCalendar();
                    });
                },
                // 设置价格日历
                savePrice: function savePrice() {
                    var priceTable = that.changguan.priceTable;
                    var hasNull = !priceTable || priceTable.length < 1 || priceTable.filter(function (i) {
                        return !i.levelName || !i.mappingRel;
                    }).length;
                    if (hasNull) {
                        that.$message.info('请选择日期并填写完整信息再保存！');
                        return;
                    }
                    that.saveTheatreIno('changguan');
                }
            },
            sortDialog: {
                model: [],
                show: false,
                modelKey: '',
                no: { changci: 1, xiwei: 2, changguan: 3 },
                sort: function sort(key) {
                    if (that.mode === 'readonly') {
                        return;
                    }
                    that.sortDialog.modelKey = key;
                    (0, _ticket.getMappingSort)(that.extra.supplierId, that.extra.partnerDealId, that.sortDialog.no[key]).then(function (result) {
                        if (result && result.data.length > 1) {
                            that.sortDialog.show = false;
                            that.sortDialog.model = result.data;
                            that.$nextTick(function () {
                                that.sortDialog.show = true;
                            });
                        } else {
                            that.$message.info('没有要调整排序的内容！');
                        }
                    }, function (err) {
                        that.$message.info('\u83B7\u53D6\u6392\u5E8F\u4FE1\u606F\u51FA\u9519\uFF1A ' + err.message);
                    });
                },
                save: function save(model) {
                    that.sortDialog.show = false;
                    (0, _ticket.saveMappingSort)(that.extra.supplierId, that.extra.partnerDealId, that.sortDialog.no[that.sortDialog.modelKey], model).then(function (result) {
                        if (result && result.data.length > 1) {
                            that.$message.success('调整排序成功！');
                            that.fetchTheatreInfo(false, that.sortDialog.modelKey);
                        }
                    }, function (err) {
                        that.$message.info('\u8C03\u6574\u6392\u5E8F\u51FA\u9519\uFF1A ' + err.message);
                    });
                }
            }
        };
    },

    watch: {
        // 费率变化
        'model.baseMsRatioSnapshot': function modelBaseMsRatioSnapshot() {
            if (this.model) {
                if (!this.model.useDateMode || this.model.useDateMode === '0') {
                    this.ratioCheck();
                } else {
                    this.calendarRadioCheck();
                }
            }
        },
        // 监听是否剧场票
        'model.ticketPriceType': function modelTicketPriceType(value) {
            this.model.IAmTheatre = value === 1 || value === '1';
            if (this.model.IAmTheatre) {
                this.model.useDateMode = '1';
                // 退款规则不支持部分退，只能一次退完
                if (this.model.refundType !== 4 && this.model.refundType !== 3) {
                    this.model.refundType = 4;
                }
                this.model.stockType = 2;
            }
        },
        // 剧场票的价格日历tab
        'price.dateSelected': function priceDateSelected(newVal) {
            this.mergeTheatrePrice(newVal);
        },
        // 剧场票的场次tab
        'changci.dateSelected': function changciDateSelected() {
            this.mergeTheatrePrice(this.changci.dateSelected, false, this.changci.priceSet, this.changci.priceTable, 'mappingRel');
        },
        // 剧场票的席位tab
        'xiwei.dateSelected': function xiweiDateSelected() {
            this.mergeTheatrePrice(this.xiwei.dateSelected, false, this.xiwei.priceSet, this.xiwei.priceTable, 'mappingRel');
        },
        // 剧场票的场馆区域tab
        'changguan.dateSelected': function changguanDateSelected() {
            this.mergeTheatrePrice(this.changguan.dateSelected, false, this.changguan.priceSet, this.changguan.priceTable, 'mappingRel');
        },
        // 监听若产品id和供应商id同时有则初始化剧场票信息
        'extra.partnerDealId': function extraPartnerDealId() {
            this.fetchTheatreInfo();
        },
        // 监听若产品id和供应商id同时有则初始化剧场票信息
        'extra.supplierId': function extraSupplierId() {
            this.fetchTheatreInfo();
        },
        // 免票类型
        'model.freeTicketType': function modelFreeTicketType() {
            this.updateFreeType();
        },
        model: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var _this2 = this;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                // 初始化特批文件
                                if (this.model.specialAuthPics && this.model.specialAuthPics.length > 0) {
                                    this.model.specialAuthPics.forEach(function (item) {
                                        _this2.model.specialAuthPicsShow.push({
                                            name: item.imageName,
                                            url: item.imageUrl
                                        });
                                    });
                                }
                                // 初始化坐席图片
                                if (this.model.seatImage) {
                                    this.model.seatImageShow.push({
                                        name: '座位图片',
                                        url: this.model.seatImage
                                    });
                                }

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function model() {
                return _ref.apply(this, arguments);
            }

            return model;
        }()
    },
    computed: Object.assign({}, (0, _vuex.mapGetters)(['account']), {
        ratioShow: function ratioShow() {
            this.ratioCheck();
            var _ratio = this.ratio > 0 ? this.ratio : 0;
            // 需求：若没上传过特批附件才进行设置
            if (!this.model.specialAuthPics || !this.model.specialAuthPics.length) {
                this.model.needSpecialAuthFile = Math.floor(this.ratio) === 0;
            }
            return _ratio;
        },
        ratio: function ratio() {
            var _ratio = this.correctRatio(this.model.mtPrice, this.model.settlementPrice, true);
            return _ratio;
        },
        ratioShowLocal: function ratioShowLocal() {
            this.ratioCheck();
            return this.ratioLocal > 0 ? this.ratioLocal : 0;
        },
        ratioLocal: function ratioLocal() {
            var _ratio = this.correctRatio(this.modelLocal.mtPrice, this.modelLocal.settlementPrice, true);
            return _ratio;
        }
    }),
    props: {
        // 数据模型
        model: {
            type: Object,
            required: true
        },
        // 供应商信息
        extra: {
            type: Object,
            required: true
        },
        // 编辑方式
        mode: {
            type: String,
            required: false
        },
        isTuan: {
            type: Boolean,
            default: false
        },
        readonly: Boolean
    },
    methods: {
        // 拉取价格日历
        pullPrice: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                var res;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.prev = 0;
                                _context2.next = 3;
                                return (0, _ticket.asyncTicket)(this.extra.supplierId, this.model.partnerDealId);

                            case 3:
                                res = _context2.sent;

                                if (!(res.status === 0)) {
                                    _context2.next = 14;
                                    break;
                                }

                                if (!(res.data && res.data.length && res.data.length > 0)) {
                                    _context2.next = 11;
                                    break;
                                }

                                this.model.dayPriceStockRules = res.data;
                                // 重新计算费率
                                this.calendarRadioCheck();
                                this.updateCalendar();
                                _context2.next = 12;
                                break;

                            case 11:
                                throw new Error("拉取价格日历失败");

                            case 12:
                                _context2.next = 15;
                                break;

                            case 14:
                                throw new Error("拉取价格日历失败");

                            case 15:
                                _context2.next = 20;
                                break;

                            case 17:
                                _context2.prev = 17;
                                _context2.t0 = _context2['catch'](0);

                                this.$alert({
                                    title: '错误',
                                    message: '拉取价格日历数据失败',
                                    showCancelButton: false,
                                    closeOnClickModal: false
                                });

                            case 20:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[0, 17]]);
            }));

            function pullPrice() {
                return _ref2.apply(this, arguments);
            }

            return pullPrice;
        }(),

        // 模式改变时改为不限库存
        dateModeChange: function dateModeChange() {
            this.model.stockType = 1;
            if (this.model.useDateMode === '0') {
                this.ratioCheck();
            } else {
                this.calendarRadioCheck();
            }
            if (this.mode === 'new' && this.model.useDateMode === '1' && !this.model.ticketCategory.ticket.ticketId && this.model.ticketCategory.createTicketCategoryInfo.ticketCategoryPrice && !this.modelLocal.marketPrice) {
                this.modelLocal.marketPrice = this.model.ticketCategory.createTicketCategoryInfo.ticketCategoryPrice;
            }
            // 直连价格日历模式，使用日库存默认
            if (this.mode === 'new' && this.extra.isDirectDeal && !this.model.IAmTheatre && this.model.useDateMode === '1') {
                this.model.stockType = 2;
            }
        },

        // 全选可用日期
        selectAllWeek: function selectAllWeek() {
            var checked = Boolean(this.validWeekCheckedAll);
            var week = this.model.validWeekRule;
            Object.keys(week).forEach(function (key) {
                week[key] = checked;
            });
        },

        // 不存在没选择的
        isAllWeekSelected: function isAllWeekSelected() {
            var _this3 = this;

            var keysArr = Object.keys(this.model.validWeekRule);
            var out = keysArr.filter(function (item) {
                return !_this3.model.validWeekRule[item];
            }).length < 1;
            this.validWeekCheckedAll = out;
        },

        //  删除一个不可用日期
        deleteUnavailableDates: function deleteUnavailableDates(i) {
            var index = this.model.unavailableDates.indexOf(i);
            if (index > -1) {
                this.model.unavailableDates.splice(index, 1);
            }
        },

        // 重置不可用日期
        resetUnavailableDates: function resetUnavailableDates() {
            this.model.unavailableDates = [];
        },

        // 全选子账户
        selectAllAccounts: function selectAllAccounts(select) {
            var _this4 = this;

            this.subAccountAll = !select;
            if (!this.subAccountAll) {
                this.model && (this.model.bindedBizAccountId = []); // eslint-disable-line
            } else {
                this.model && (this.model.bindedBizAccountId = []); // eslint-disable-line
                this.subAccounts.forEach(function (item) {
                    if (_this4.ticketSubAccount(item)) {
                        _this4.model && _this4.model.bindedBizAccountId.push(item.accountId); // eslint-disable-line
                    }
                });
            }
        },

        // 是否显示
        ticketSubAccount: function ticketSubAccount(account, type) {
            var productType = account && account.authInfo && account.authInfo.ticketAuth && account.authInfo.ticketAuth.productType || [];
            if (type === 'all') {
                return productType.indexOf(1) > -1;
            }
            return productType.indexOf(2) > -1;
        },

        // 获取子账户
        getSubAccounts: function getSubAccounts() {
            var _this5 = this;

            // 超级账户才有子账户
            if (this.extra.isBD || this.account.accountType === 1) {
                (0, _ticket.getSubAccounts)(this.extra.supplierId).then(function (result) {
                    if (result.data && result.data.accountInfoList) {
                        _this5.subAccounts = result.data.accountInfoList || [];
                        _this5.subAccounts = _this5.subAccounts.filter(function (item) {
                            return item && item.businessType && item.businessType.ticket;
                        });
                    }
                }, function (err) {
                    _this5.$message.error('\u83B7\u53D6\u5B50\u8D26\u6237\u5931\u8D25 ' + err.message);
                });
            } else if (!this.extra.isBD && this.model) {
                this.model.bindedBizAccountId = [this.account.userId];
            }
        },

        // 免票类型切换
        updateFreeType: function updateFreeType() {
            var _this6 = this;

            if (this.model.freeTicketType === 0) {
                this.model.associatedContractList = this.model.associatedContractList || [];
                if (this.extra.supplierId) {
                    (0, _ticket.getCommissionStatement)(this.extra.supplierId).then(function (json) {
                        if (json.status === 0) {
                            var data = json.data;
                            _this6.model.associatedContractList = data.map(function (item, index) {
                                item.showName = item.ruleName + '(' + item.statementPeriodStart + '至' + item.statementPeriodEnd + ')';
                                return item;
                            });
                        } else {
                            _this6.$message.error(json.message || '获取信息出错');
                        }
                    }, function (err) {
                        _this6.$message.error('\u83B7\u53D6\u514D\u7968\u7C7B\u578B\u5931\u8D25 ' + err.message);
                    });
                }
            } else if (this.model.freeTicketType === 2 || this.model.freeTicketType === 3 || this.model.freeTicketType === 4) {
                this.model.freeTicketAssociatedAccount = '';
            }
        },
        updateStatements: function updateStatements() {
            var _this7 = this;

            if (this.model.freeTicketType === 0) {
                var statement = {};
                this.model.associatedContractList.forEach(function (item, index) {
                    if (!statement.statementId && item.statementId + '' === _this7.model.statementId + '') {
                        statement = item;
                    }
                });
                this.model.freeTicketAssociatedAccount = statement.statementId;
                this.model.freeTicketAssociatedDetail = statement.showName;
            }
        },

        // 查询基础费率
        getMsRatio: function getMsRatio() {
            if (this.model.ticketCategory) {
                this.$emit('updateMsRatio');
            }
        },

        // 计算费率: notCode，true表示用户输入，否则为代码调用
        correctRatio: function correctRatio(mtPrice, settlementPrice, notCode) {
            if (mtPrice === null || mtPrice === undefined) return null;
            try {
                var price = new _big2.default(mtPrice);
                var commission = price.minus(settlementPrice);
                var ratio = commission.div(mtPrice).mul(100);
                ratio = this.toFixedFloor(ratio);
                if (notCode) {
                    // 需求：若没上传过特批附件才进行设置
                    if (!this.model.specialAuthPics || !this.model.specialAuthPics.length) {
                        this.model.needSpecialAuthFile = ratio === 0;
                    }
                }
                // 解决：如mtPrice为33，settlementPrice为17应该得0.4848，*100 却出现48.480000000000004
                // 解决：如mtPrice为33，settlementPrice为20应该得0.3939，*10000/100 出现39.38999999999999
                // (117-101)/117 = 0.1367 *100还是*10000/100 都有问题
                // let _ratio100 = ratio * 100;
                // let _ratio1000 = ratio * 10000 / 100;
                // ratio = _ratio100.toString().length > _ratio1000.toString().length ? _ratio1000: _ratio100;
                return ratio;
            } catch (e) {
                return 0;
            }
        },
        addDayPrice: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                var _this8 = this;

                var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                var priceInfo, dayStock, msg, submitInfo;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (!(this.ratioLocal > 50 || this.modelLocal.settlementPrice && this.hasDeclined || this.modelLocal.settlementPrice && this.ratioLocal < this.model.baseMsRatioSnapshot * 100)) {
                                    _context3.next = 4;
                                    break;
                                }

                                if (this.isTuan) {
                                    _context3.next = 4;
                                    break;
                                }

                                _context3.next = 4;
                                return this.$alert_html({
                                    title: '重要提示',
                                    message: '提交价格的费率存在降低/没有达到普通费率底线，更新提交后，<b>会进入人工费率审核（预计24小时内，审核完毕），审核通过后才可以上线</b>',
                                    showCancelButton: false,
                                    closeOnClickModal: false
                                });

                            case 4:
                                priceInfo = this.model.dayPriceStockRules;

                                if (!priceInfo) {
                                    priceInfo = this.model.dayPriceStockRules = [];
                                }

                                if (selected.length) {
                                    _context3.next = 9;
                                    break;
                                }

                                this.$message({
                                    showClose: true,
                                    message: '请先选择日期',
                                    type: 'error',
                                    duration: 1400
                                });
                                return _context3.abrupt('return');

                            case 9:
                                if (!(this.model.stockType === 2 && !this.modelLocal.stock)) {
                                    _context3.next = 12;
                                    break;
                                }

                                this.$message({
                                    showClose: true,
                                    message: '请设置日库存',
                                    type: 'error',
                                    duration: 1400
                                });
                                return _context3.abrupt('return');

                            case 12:

                                // 日库存模式需要存储已售，拆开存储
                                dayStock = [];

                                selected.forEach(function (date) {
                                    priceInfo.every(function (item) {
                                        var dates = item.dates || [];
                                        var pos = dates.indexOf(date);
                                        if (pos > -1) {
                                            // 如果日库存模式，将已售保留下来
                                            if (parseInt(_this8.model.stockType, 10) === 2) {
                                                var oneStack = JSON.parse(JSON.stringify(query));
                                                oneStack.dates = [date];
                                                oneStack.sold = item.sold;
                                                dayStock.push(oneStack);
                                            }
                                            dates.splice(pos, 1);
                                        }
                                        return pos === -1;
                                    });
                                });

                                // 日库存模式，剔除已经处理过的日期
                                if (parseInt(this.model.stockType, 10) === 2) {
                                    selected = selected.filter(function (date) {
                                        var _iteratorNormalCompletion = true;
                                        var _didIteratorError = false;
                                        var _iteratorError = undefined;

                                        try {
                                            for (var _iterator = dayStock[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                                var item = _step.value;

                                                var dates = item.dates || [];
                                                var pos = dates.indexOf(date);
                                                if (pos !== -1) return false;
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally {
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator.return) {
                                                    _iterator.return();
                                                }
                                            } finally {
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }

                                        return true;
                                    });
                                }

                                msg = '';

                                priceInfo.forEach(function (item1) {
                                    item1.dates.every(function (date2) {
                                        var isWrong = date2 >= _this8.today;
                                        if (query.settlementPrice === 0) {
                                            isWrong = isWrong && item1.settlementPrice !== 0;
                                        } else {
                                            isWrong = isWrong && item1.settlementPrice === 0;
                                        }

                                        if (isWrong) {
                                            msg = date2;
                                        }
                                        return !isWrong;
                                    });
                                });

                                if (!msg.length) {
                                    _context3.next = 20;
                                    break;
                                }

                                this.$message({
                                    showClose: true,
                                    message: '不允许非0结算价与0结算价的录入在一个deal上',
                                    type: 'error',
                                    duration: 1400
                                });
                                return _context3.abrupt('return');

                            case 20:

                                if (parseInt(this.model.stockType, 10) === 2) {
                                    priceInfo = priceInfo.concat(dayStock);
                                }

                                submitInfo = Object.assign({
                                    dates: selected.concat()
                                }, query);

                                priceInfo.push(submitInfo);

                                // 删除没有出发日期的
                                this.model.dayPriceStockRules = priceInfo.filter(function (item) {
                                    return item.dates && item.dates.length;
                                });
                                selected.length = 0;
                                this.calendarRadioCheck();
                                this.updateCalendar();

                            case 27:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function addDayPrice() {
                return _ref3.apply(this, arguments);
            }

            return addDayPrice;
        }(),
        updateCalendar: function updateCalendar() {
            _helpers.eventBus.$emit('calendar-update');
        },


        // 有效期模式
        ratioCheck: function ratioCheck() {
            this.ratioInvalid = false;
            if (this.model) {
                var msRatio = this.model.baseMsRatioSnapshot;
                var ratioInvalid = false;
                if (!this.model.useDateMode || this.model.useDateMode === '0') {
                    // ratioInvalid：1： 费率大于50；2： 美团价大于了门市价；3：低于基准 4：费率下降
                    if (this.ratio > 50) {
                        ratioInvalid = 1;
                    } else if (this.model.mtPrice > this.model.marketPrice) {
                        ratioInvalid = 2;
                    }
                    // 低于基准
                    if (msRatio && this.ratio && this.ratio < msRatio * 100) {
                        ratioInvalid = 3;
                    }
                    // 费率下降
                    if (this.model.onlineMsRatioPriceInfo && this.model.onlineMsRatioPriceInfo.oldMsRatio && this.ratio && this.model.onlineMsRatioPriceInfo.oldMsRatio * 100 > this.ratio) {
                        ratioInvalid = 4;
                    }
                } else {
                    if (this.ratioLocal > 50) {
                        ratioInvalid = 1;
                    } else if (this.modelLocal.mtPrice > this.modelLocal.marketPrice) {
                        ratioInvalid = 2;
                    }
                    // 低于基准
                    if (msRatio && this.ratioLocal && this.ratioLocal < msRatio * 100) {
                        ratioInvalid = 3;
                    }
                }
                this.ratioInvalid = ratioInvalid;
            }
        },
        calendarRadioCheck: function calendarRadioCheck() {
            var _this9 = this;

            // 价格日历模式
            if (this.model.useDateMode) {
                this.belowBase = false;
                this.hasDeclined = false;
                // 需求：若没上传过特批附件才进行设置
                if (!this.model.specialAuthPics || !this.model.specialAuthPics.length) {
                    this.model.needSpecialAuthFile = false;
                }
                if (this.model.dayPriceStockRules && this.model.dayPriceStockRules.length) {
                    var msRatio = this.model.baseMsRatioSnapshot;
                    // 整理价格 费率 为 特殊费率展示格式
                    var result = {};
                    this.foundFreeTicket = false;
                    this.model.dayPriceStockRules.forEach(function (item) {
                        var hasAfter = false;
                        item.dates.forEach(function (date) {
                            if (date > _this9.today) {
                                hasAfter = true;
                                // 检查费率下降
                                if (_this9.checkHistoryRatio(item, date, true)) {
                                    _this9.hasDeclined = true;
                                }
                            }
                        });
                        if (!hasAfter) return;
                        // 判断免票(适配拉取价格日历规则）
                        if (parseInt(item.settlementPrice, 10) === 0) {
                            _this9.foundFreeTicket = true;
                        }
                        // 小于底线费率才进行展示
                        var ratio = _this9.correctRatio(item.mtPrice, item.settlementPrice);
                        if (ratio === 0) {
                            // 需求：若没上传过特批附件才进行设置
                            if (!_this9.model.specialAuthPics || !_this9.model.specialAuthPics.length) {
                                // 价格日历模式中如果存在0费率则需要上传特批附件
                                _this9.model.needSpecialAuthFile = true;
                            }
                        }
                        // 如果是直连，并且新增不等于old，onlineMsRatioPriceInfo[date] || onlineMsRatioPriceInfo.oldMsRatio
                        // 获取old费率
                        if (ratio < msRatio * 100 && !(_this9.isDirectDeal && ratio === _this9.model.onlineMsRatioPriceInfo.oldMsRatio)) {
                            _this9.belowBase = true;
                            var tempKey = 'ratio_' + item.mtPrice + '_' + item.settlementPrice;
                            if (!result[tempKey]) {
                                result[tempKey] = Object.assign({}, item);
                                result[tempKey].ratio = ratio;
                            } else {
                                result[tempKey].dates = result[tempKey].dates.concat(item.dates);
                            }
                        }
                    });
                    this.invalidRatioList = result;
                }
            }
        },
        dayLock: function dayLock(day) {
            return Boolean(day.isBefore || day.isAfter || this.readonly);
        },
        onRemoveDate: function onRemoveDate(selected) {
            var priceInfo = this.model.dayPriceStockRules;
            if (!priceInfo) {
                priceInfo = this.model.dayPriceStockRules = [];
            }
            selected.forEach(function (date) {
                priceInfo.every(function (item) {
                    var dates = item.dates || [];
                    var pos = dates.indexOf(date);
                    if (pos > -1) {
                        dates.splice(pos, 1);
                    }
                    return pos === -1;
                });
            });

            this.model.dayPriceStockRules = priceInfo.filter(function (item) {
                return item.dates && item.dates.length;
            });
            this.calendarRadioCheck();
        },
        getTitle: function getTitle(date, item) {
            var title = [];
            var ratio = this.correctRatio(item.mtPrice, item.settlementPrice);

            title.push('日期' + date + '&nbsp;' + (item.subText ? '库存' + item.subText : ''));
            title.push('门市价' + item.marketPrice + '&nbsp;美团价' + item.mtPrice);
            title.push('结算价' + item.settlementPrice + '&nbsp;费率' + ratio + '%');
            return title.join('<br>');
        },
        getInfoFun: function getInfoFun(day) {
            var date = day.date;
            var priceInfo = this.model.dayPriceStockRules || [];
            var info = {};
            for (var i = 0, len = priceInfo.length; i < len; i++) {
                var item = priceInfo[i];
                var dates = item.dates;
                if (date === dates || dates.indexOf(date) > -1) {
                    info = Object.assign({
                        texts: []
                    }, item);
                    delete info.dates;
                    break;
                }
            }

            if (info.mtPrice) {
                var items = info.texts;
                info.title = this.getTitle(date, info);
                items.push('\u95E8\u5E02\u4EF7:\uFFE5' + info.marketPrice + '  \u7F8E\u56E2\u4EF7:\uFFE5' + info.mtPrice);
                items.push('\u7ED3\u7B97\u4EF7:\uFFE5' + info.settlementPrice);
                var ratio = this.correctRatio(info.mtPrice, info.settlementPrice);
                // 检查费率是否下降
                this.checkHistoryRatio(info, date);
                // 费率下降
                if (info.isDecline) {
                    items.push('<span style="color:#ff4f28">\u8D39\u7387:' + (ratio + '%⬇&nbsp;') + '</span>(' + (info.previousRate * 100).toFixed(2) + '%)');
                } else if (this.model.baseMsRatioSnapshot && ratio < this.model.baseMsRatioSnapshot * 100) {
                    // 特殊费率
                    items.push('<span style="color:#ff4f28">\u8D39\u7387:' + (ratio + '%') + '(\u7279\u6B8A\u8D39\u7387)</span>');
                } else {
                    items.push('\u8D39\u7387:' + (ratio + '%'));
                }

                var sold = parseInt(info.sold || '0');
                var stockType = parseInt(this.model.stockType);
                var stockText = '不限';
                if (stockType === 2) {
                    if (info.stock > -1) {
                        stockText = info.stock.toString();
                    } else if (info.stock === -1) {
                        stockText = '不限';
                    } else {
                        stockText = '未设置';
                    }
                } else if (stockType === 3) {
                    stockText = this.model.stock;
                }
                if (stockText) {
                    items.push('\u5DF2\u552E/\u5E93\u5B58: ' + sold + '/' + stockText);
                }
            }
            return info;
        },

        // 检查历史费率，费率是否下降
        checkHistoryRatio: function checkHistoryRatio(day, date, notSetResult) {
            if (this.model.onlineMsRatioPriceInfo && this.model.onlineMsRatioPriceInfo.dayPriceStockRules) {
                if (day && date && (this.model.onlineMsRatioPriceInfo.dayPriceStockRules[date] || this.model.onlineMsRatioPriceInfo.oldMsRatio)) {
                    if (((this.model.onlineMsRatioPriceInfo.dayPriceStockRules[date] || this.model.onlineMsRatioPriceInfo.oldMsRatio) * 100).toFixed(4) > this.correctRatio(day.mtPrice, day.settlementPrice)) {
                        if (!notSetResult) {
                            day.isDecline = true;
                            day.previousRate = this.model.onlineMsRatioPriceInfo.dayPriceStockRules[date] ? this.model.onlineMsRatioPriceInfo.dayPriceStockRules[date].toFixed(4) : this.model.onlineMsRatioPriceInfo.oldMsRatio.toFixed(4);
                        }
                        return true;
                    }
                }
            }
            return false;
        },

        // 根据获取数组中某个属性的集合
        getTheListAttrs: function getTheListAttrs(list, attr) {
            var result = [];
            if (Array.isArray(list)) {
                list.forEach(function (item) {
                    result.push(item[attr]);
                });
            }
            return result;
        },

        // 保存价格日历
        save: function save() {
            var _this10 = this;

            var data = void 0;
            // if (!validate()) return;

            this.priceInfo = this.priceInfo || [];
            // 遍历每个日期
            this.dateSelected.forEach(function (date, index) {
                _this10.priceInfo.forEach(function (item) {
                    var pos = item.dates.indexOf(date);
                    if (pos > -1) {
                        item.dates.splice(pos, 1);
                    }
                });
            });
            data = Object.assign({}, this.modelLocal);
            data.dates = this.dateSelected.concat([]);
            this.priceInfo.push(data);
            // 删除没有出发日期的
            this.priceInfo = this.priceInfo.filter(function (item) {
                return item.dates && item.dates.length;
            });
            this.model.dayPriceStockRules = this.priceInfo;
            this.dateSelected.length = 0;
            _helpers.eventBus.$emit('calendar-reset');
        },
        toFixedFloor: function toFixedFloor(num) {
            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

            var rate = Math.pow(10, length);
            var val = Number(num) * rate;
            val = Math.floor(val);
            return val / rate;
        },

        // 查询剧场票显示什么tab
        getAllMappingExt: function getAllMappingExt() {
            return (0, _ticket.getAllMappingExtType)(this.extra.supplierId, this.extra.partnerDealId).then(function (result) {
                return result.data;
            });
        },

        // 获取演出信息
        fetchTheatreInfo: function fetchTheatreInfo(isClick, tabKey) {
            var _this11 = this;

            if (!this.model.IAmTheatre || !this.extra.isBD) {
                return;
            }
            if (this.extra.partnerDealId && this.extra.supplierId) {
                this.getAllMappingExt().then(function (response) {
                    if (!tabKey) {
                        (0, _ticket.getPriceBase)(_this11.extra.supplierId, _this11.extra.partnerDealId).then(function (result) {
                            if (result.data) {
                                _this11.price.priceSet = result.data;
                                _this11.mergeTheatrePrice();
                                _this11.updateCalendar();
                            }
                        }, function (err) {
                            _this11.$message.info('\u83B7\u53D6\u5267\u573A\u7968\u4EF7\u683C\u57FA\u672C\u4FE1\u606F\u51FA\u9519\uFF1A ' + err.message);
                        });
                    }
                    // 解决ui不更新问题
                    _this11.$nextTick(function () {
                        if (Array.isArray(response)) {
                            _this11.theatreTab.changci = response.includes(1);
                            _this11.theatreTab.xiwei = response.includes(2);
                            _this11.theatreTab.changguan = response.includes(3);
                        } else {
                            _this11.theatreTab.changci = false;
                            _this11.theatreTab.xiwei = false;
                            _this11.theatreTab.changguan = false;
                        }
                    });
                    var mappingObj = [{ no: 1, label: '场次', prop: 'changci' }, { no: 2, label: '席位', prop: 'xiwei' }, { no: 3, label: '场馆', prop: 'changguan' }];
                    mappingObj.forEach(function (i) {
                        if (response && response.length && response.includes(i.no)) {
                            var need = !tabKey || i.prop === tabKey;
                            need && (0, _ticket.getMappingExt)(_this11.extra.supplierId, _this11.extra.partnerDealId, i.no).then(function (result) {
                                if (result.data) {
                                    _this11[i.prop].priceSet = result.data;
                                }
                                _this11.mergeTheatrePrice(_this11[i.prop].dateSelected, false, _this11[i.prop].priceSet, _this11[i.prop].priceTable, 'mappingRel');
                                _this11.updateCalendar();
                            }, function (err) {
                                _this11.$message.info('\u83B7\u53D6\u5267\u573A\u7968' + i.label + '\u51FA\u9519\uFF1A ' + err.message);
                            });
                        }
                    });
                });
            } else {
                if (isClick) {
                    this.$message.info('缺少供应商或产品信息');
                }
            }
        },

        /***
         * 合并原始数据进行展示
         * @param dates 日历控件选中的日期
         * @param isMsg  是否只验证重复信息
         * @param priceSetParam 传入的原始数据
         * @param tableData 整理完数据需要放的变量
         * @param priceSet 接口返回的原始数据
         * @returns {string}
         */
        mergeTheatrePrice: function mergeTheatrePrice(dates, isMsg, priceSetParam, tableData) {
            var repeatProp = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'priceDesc';

            var tool = {};
            var msg = {};
            tableData = tableData || this.price.priceTable;
            priceSetParam = priceSetParam || this.price.priceSet;
            dates = dates || this.price.dateSelected;
            if (!isMsg) {
                tableData.length = 0;
            }
            var priceSet = Object.assign({}, priceSetParam);
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = dates[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var date = _step2.value;

                    var price = priceSet[date];
                    if (price && price.length) {
                        var _iteratorNormalCompletion3 = true;
                        var _didIteratorError3 = false;
                        var _iteratorError3 = undefined;

                        try {
                            for (var _iterator3 = price[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                var pp = _step3.value;

                                var p = Object.assign({}, pp);
                                // 相同价格，不同价格说明也可以一次录入
                                var samePrice = tool[p[repeatProp]] && (repeatProp === 'priceDesc' && tool[p[repeatProp]].marketPrice === p.marketPrice && tool[p[repeatProp]].mtPrice === p.mtPrice && tool[p[repeatProp]].settlementPrice === p.settlementPrice || repeatProp === 'mappingRel' && tool[p[repeatProp]].levelName === p.levelName);
                                // 重复则把重复日期放入指定价格说明行
                                if (tool[p[repeatProp]] || samePrice) {
                                    if (!isMsg) {
                                        tool[p[repeatProp]].dates.push({ date: date, id: p.id });
                                    }
                                    if (!samePrice) {
                                        msg[tool[p[repeatProp]].dates[0].date + '\u3001' + date] = 1;
                                    }
                                } else {
                                    p.dates = [{ date: date, id: p.id }];
                                    if (p[repeatProp]) {
                                        tool[p[repeatProp]] = p;
                                    }
                                    if (!isMsg) {
                                        tableData.push(p);
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                    _iterator3.return();
                                }
                            } finally {
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            var result = Object.keys(msg).join('，');
            if (result) {
                if (!isMsg) {
                    dates.length = 0;
                    this.updateCalendar();
                    this.$message.info(result + '\u76F8\u540C\u4FE1\u606F\uFF0C\u9700\u8981\u5206\u5F00\u5F55\u5165\uFF01');
                }
                return result;
            }
        },

        // 前台刷新剧场票priceSet
        refreshPriceSet: function refreshPriceSet() {
            var _this12 = this;

            this.$nextTick(function () {
                _this12.updateCalendar();
            });
        },

        // 保存剧场票相关信息
        saveTheatreIno: function saveTheatreIno(priceSet, isPrice) {
            var _this13 = this;

            if (this.model.IAmTheatre) {
                var price = this.prepareTheatreInfo(priceSet, isPrice);
                if (isPrice) {
                    (0, _ticket.savePriceBase)(this.extra.supplierId, this.extra.partnerDealId, price).then(function (result) {
                        if (result && result.data) {
                            Object.keys(result.data).forEach(function (i) {
                                _this13[priceSet].priceSet[i] = result.data[i];
                            });
                            _this13[priceSet].dateSelected = [];
                            _this13.refreshPriceSet();
                            _this13.$message.success('保存成功!');
                        }
                    }, function (err) {
                        _this13.$message.error('\u4FDD\u5B58\u5267\u573A\u7968\u4EF7\u683C\u57FA\u672C\u4FE1\u606F\u51FA\u9519\uFF1A ' + err.message);
                    });
                } else {
                    var mappingObj = { changci: { no: 1, label: '场次', prop: 'changci' },
                        xiwei: { no: 2, label: '席位', prop: 'xiwei' },
                        changguan: { no: 3, label: '场馆', prop: 'changguan' } };
                    (0, _ticket.saveMappingExt)(this.extra.supplierId, this.extra.partnerDealId, mappingObj[priceSet].no, price).then(function (result) {
                        if (result && result.data) {
                            Object.keys(result.data).forEach(function (i) {
                                _this13[priceSet].priceSet[i] = result.data[i];
                            });
                            _this13[priceSet].dateSelected = [];
                            _this13.refreshPriceSet();
                            _this13.$message.success('保存成功!');
                        }
                    }, function (err) {
                        _this13.$message.error('\u4FDD\u5B58\u5267\u573A\u7968' + mappingObj[priceSet].label + '\u51FA\u9519\uFF1A ' + err.message);
                    });
                }
            }
        },

        // 整理原始剧场票信息
        prepareTheatreInfo: function prepareTheatreInfo(priceSet, isPrice) {
            var result = [];
            var priceTable = this[priceSet].priceTable;
            var dateSelected = this[priceSet].dateSelected;
            if (priceTable && priceTable.length) {
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                    for (var _iterator4 = priceTable[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var price = _step4.value;

                        if (price && price.dates && price.dates.length) {
                            var _iteratorNormalCompletion5 = true;
                            var _didIteratorError5 = false;
                            var _iteratorError5 = undefined;

                            try {
                                for (var _iterator5 = price.dates[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                    var ids = _step5.value;

                                    if (dateSelected.indexOf(ids.date) > -1) {
                                        if (isPrice) {
                                            result.push({
                                                id: ids.id,
                                                marketPrice: price.marketPrice,
                                                mtPrice: price.mtPrice,
                                                settlementPrice: price.settlementPrice
                                            });
                                        } else {
                                            result.push({
                                                id: ids.id,
                                                levelSeq: price.levelSeq,
                                                levelName: price.levelName,
                                                mappingRel: price.mappingRel
                                            });
                                        }
                                    }
                                }
                            } catch (err) {
                                _didIteratorError5 = true;
                                _iteratorError5 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                        _iterator5.return();
                                    }
                                } finally {
                                    if (_didIteratorError5) {
                                        throw _iteratorError5;
                                    }
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }
            }
            return result;
        },

        // 整理原始剧场票信息
        prepareTheatreInfo1: function prepareTheatreInfo1(priceSet, isPrice) {
            var result = [];
            var price_Set = this[priceSet].priceSet;
            var dateSelected = this[priceSet].dateSelected;
            Object.keys(price_Set).forEach(function (i) {
                var item = price_Set[i];
                if (dateSelected.indexOf(i) > -1 && item && item.length) {
                    var _iteratorNormalCompletion6 = true;
                    var _didIteratorError6 = false;
                    var _iteratorError6 = undefined;

                    try {
                        for (var _iterator6 = item[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                            var price = _step6.value;

                            var modelItem = isPrice ? { id: price.id, marketPrice: price.marketPrice, mtPrice: price.mtPrice, priceDesc: price.priceDesc, settlementPrice: price.settlementPrice } : { id: price.id, levelSeq: price.levelSeq, levelName: price.levelName, mappingRel: price.mappingRel };
                            result.push(modelItem);
                        }
                    } catch (err) {
                        _didIteratorError6 = true;
                        _iteratorError6 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                _iterator6.return();
                            }
                        } finally {
                            if (_didIteratorError6) {
                                throw _iteratorError6;
                            }
                        }
                    }
                }
            });
            return result;
        }
    },
    mounted: function () {
        var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
            var res;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            // 团购没有子账号信息
                            if (!this.isTuan) {
                                this.getSubAccounts();
                            }
                            this.getMsRatio();
                            this.fetchTheatreInfo();
                            // 直连检查

                            if (!this.extra.isDirectDeal) {
                                _context4.next = 14;
                                break;
                            }

                            _context4.prev = 4;
                            _context4.next = 7;
                            return (0, _ticket.queryCalendar)(this.extra.supplierId);

                        case 7:
                            res = _context4.sent;

                            if (res.status === 0) {
                                this.canPullPrice = Boolean(res.data.priceUrl);
                            }
                            _context4.next = 14;
                            break;

                        case 11:
                            _context4.prev = 11;
                            _context4.t0 = _context4['catch'](4);

                            console.log(_context4.t0);

                        case 14:

                            // 可用日期星期全选
                            // 不存在没选择的
                            this.$watch(function () {
                                var _this14 = this;

                                var out = false;
                                if (this.model.validWeekRule) {
                                    var keysArr = Object.keys(this.model.validWeekRule);
                                    out = keysArr.filter(function (item) {
                                        return !_this14.model.validWeekRule[item];
                                    }).length < 1;
                                    this.hasWeekOne = keysArr.filter(function (item) {
                                        return _this14.model.validWeekRule[item];
                                    }).length > 0;
                                }
                                this.validWeekCheckedAll = out;
                                return out;
                            }, function (newVal, oldVal) {
                                this.validWeekCheckedAll = newVal;
                            });

                            // 监听有效期时间段
                            this.$watch(function () {
                                var out = this.model.voucherDateBegin && this.model.voucherDateEnd ? this.model.voucherDateBegin + ' ~ ' + this.model.voucherDateEnd : '';
                                return out;
                            }, function (newVal, oldVal) {
                                this.voucherDateBeginEnd = newVal;
                                this.inDateOptionOpen.minDate = this.model.voucherDateBegin;
                                this.inDateOptionOpen.maxDate = this.model.voucherDateEnd;
                            });
                            // 监听不可用日期
                            this.$watch('model.unavailableDates', function (val) {
                                if (val && val.length) {
                                    this.unavailableDates = val.join(' ~ ');
                                } else {
                                    this.unavailableDates = '';
                                }
                            });
                            // 监听价格日历选中日期
                            this.$watch('dateSelected', function (newVal, oldVal) {
                                var date = newVal[newVal.length - 1];
                                var _iteratorNormalCompletion7 = true;
                                var _didIteratorError7 = false;
                                var _iteratorError7 = undefined;

                                try {
                                    for (var _iterator7 = this.model.dayPriceStockRules[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                                        var rule = _step7.value;

                                        if (rule.dates.indexOf(date) !== -1) {
                                            this.modelLocal.mtPrice = rule.mtPrice;
                                            this.modelLocal.marketPrice = rule.marketPrice;
                                            this.modelLocal.settlementPrice = rule.settlementPrice;
                                            this.modelLocal.stock = rule.stock;
                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError7 = true;
                                    _iteratorError7 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                            _iterator7.return();
                                        }
                                    } finally {
                                        if (_didIteratorError7) {
                                            throw _iteratorError7;
                                        }
                                    }
                                }
                            });

                        case 18:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this, [[4, 11]]);
        }));

        function mounted() {
            return _ref4.apply(this, arguments);
        }

        return mounted;
    }()
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 548 */,
/* 549 */
/*!**********************************************!*\
  !*** ./src/components/calendar/Calendar.vue ***!
  \**********************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-47313bec","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Calendar.vue */ 550)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Calendar.vue */ 551),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-47313bec","hasScoped":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Calendar.vue */ 552),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-47313bec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 550 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-47313bec","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/calendar/Calendar.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 551 */
/*!*****************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/calendar/Calendar.vue ***!
  \*****************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _helpers = __webpack_require__(/*! helpers */ 16);

// import Day from './Day.vue'

exports.default = {
    components: {
        // Day
    },
    data: function data() {
        return {
            monthInfo: {},
            today: new Date(),
            weekMap: {
                '6': '日',
                '0': '一',
                '1': '二',
                '2': '三',
                '3': '四',
                '4': '五',
                '5': '六'
            },
            weekdays: [],
            weeks: [],
            month: null,
            allChecked: false
        };
    },

    props: {
        getDayInfo: {
            type: Function
        },
        lockCheck: {
            type: Function
        },
        onSingleSelect: {
            type: Function
        },
        selected: {
            type: Array,
            required: true
        },
        beforeTime: {
            'default': function _default() {
                return new Date();
            }
        },
        afterTime: {
            'default': function _default() {
                return new Date('2100-01-01');
            }
        },
        tagDay: {
            'default': function _default() {
                return new Date();
            }
        },
        readonly: {
            type: Boolean,
            'default': false
        },
        single: {
            type: Boolean,
            'default': false
        },
        removeDisabled: {
            type: Boolean,
            'default': false
        },
        isTuan: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        buildDay: function buildDay(date) {
            var day = {};
            var time = day.time = new Date(date);
            day.text = time.getDate();
            day.isBefore = this.isBefore(time);
            day.isAfter = this.isAfter(time);
            day.isToday = this.isToday(time);
            day.otherMon = time.getMonth() !== this.tagDay.getMonth();
            day.checked = false;
            day.date = (0, _helpers.formatDate)(day.time);
            if (this.getDayInfo) {
                day.info = this.getDayInfo(day);
            }
            if (this.lockCheck) {
                day.locked = this.lockCheck(day);
            }
            day.checked = this.isChecked(day);
            return day;
        },
        buildColWeek: function buildColWeek() {
            var weekdays = this.weekdays;
            this.weeks.forEach(function (week) {
                week.forEach(function (day, index) {
                    var col = weekdays[index];
                    if (!col.days) {
                        col.days = [];
                    }
                    if (!day.locked) {
                        col.days.push(day);
                    }
                });
            });
        },
        removeSelect: function removeSelect() {
            if (this.selected && this.selected.length) {
                this.$emit('calendar-remove-selected', this.selected);
                this.selected.splice(0, this.selected.length);
                this.updateMonth();
            }
        },
        selectAll: function selectAll() {
            var _this = this;

            var checked = this.allChecked = !this.allChecked;
            if (this.weekdays && this.weekdays.length) {
                this.weekdays.forEach(function (weekday) {
                    var index = weekday.index;
                    _this.selectWeek(index, checked);
                });
            }
        },
        isAllChecked: function isAllChecked() {
            var checked = false;
            var allLocked = true;
            if (this.weekdays && this.weekdays.length) {
                checked = true;
                this.weekdays.forEach(function (weekday) {
                    if (!weekday.locked && !weekday.checked) {
                        checked = false;
                    }
                    if (!weekday.locked) {
                        allLocked = false;
                    }
                });
                if (allLocked) {
                    checked = false;
                }
                this.allChecked = checked;
            }
            return checked;
        },
        selectWeek: function selectWeek(num, isChecked) {
            var _this2 = this;

            var checked = Boolean(isChecked);
            var col = this.weekdays[num];
            if (col && col.days && col.days.length) {
                if (checked) {
                    col.days.forEach(function (day) {
                        if (!day.locked) {
                            _this2.select(day);
                        }
                    });
                } else {
                    col.days.forEach(function (day) {
                        if (!day.locked) {
                            _this2.unSelect(day);
                        }
                    });
                }
            }
        },
        isWeekAllSelected: function isWeekAllSelected(weekDay) {
            var checked = false;
            var allLocked = true;
            if (weekDay && weekDay.days) {
                checked = true;
                weekDay.days.forEach(function (day) {
                    if (!day.locked && !day.checked) {
                        checked = false;
                    }
                    if (!day.locked) {
                        allLocked = false;
                    }
                });
                if (allLocked) {
                    checked = false;
                    weekDay.locked = true;
                }
                weekDay.checked = checked;
            }
            return checked;
        },
        toggle: function toggle(day) {
            var checked = this.isChecked(day);
            this.$emit('calendar-day-click', day, checked);
            if (this.readonly && !this.isTuan) return;
            if (!day.locked) {
                if (checked) {
                    this.unSelect(day);
                } else {
                    this.select(day);
                    if (this.onSingleSelect) {
                        this.onSingleSelect({
                            $day: day
                        });
                    }
                }
            }
        },
        unSelect: function unSelect(day) {
            day.checked = false;
            if (this.isChecked(day)) {
                var index = this.selected.indexOf(day.date);
                this.selected.splice(index, 1);
            }
        },
        select: function select(day) {
            day.checked = true;
            if (!this.isChecked(day)) {
                var date = day.date;
                this.selected.push(date);
            }
        },
        isChecked: function isChecked(day) {
            return Array.isArray(this.selected) && day && this.selected.indexOf(day.date) > -1;
        },
        resetMonth: function resetMonth(date) {
            this.allChecked = false;
            this.tagDay = date || new Date();
            this.month = null;
            this.updateMonth();
        },


        // 获取一个月的信息
        updateMonth: function updateMonth() {
            var month = (0, _helpers.formatDate)(this.tagDay, 'yyyy-MM');
            if (month !== this.month) {
                this.$emit('calendar-month-change', month);
            }
            this.month = month;
            this.weeks = this.getVisibleWeeks(this.tagDay);
            this.updateMonthInfo();
            this.weekdays = this.getWeekDays();
            this.buildColWeek();
        },
        getFirstDate: function getFirstDate(date) {
            var day = new Date(date);
            day.setDate(1);
            day.setHours(0);
            day.setMinutes(0);
            day.setSeconds(0);
            day.setMilliseconds(0);
            return day;
        },
        getWeekDays: function getWeekDays() {
            var days = [];
            for (var i = 0; i < 7; i++) {
                days.push({
                    name: this.weekMap[i],
                    index: i
                });
            }
            return days;
        },
        getVisibleWeeks: function getVisibleWeeks(day) {
            var date = this.getFirstDate(day);
            var weeks = [];
            if (date.getDay() === 0) {
                date.setDate(-5);
            } else {
                date.setDate(date.getDate() - (date.getDay() - 1));
            }
            if (date.getDate() === 1) {
                date.setDate(-6);
            }
            var weekNum = 0;
            while (weekNum < 6) {
                weekNum = weekNum + 1;
                var week = [];
                var inMonth = false;
                for (var i = 0; i < 7; i++) {
                    var item = this.buildDay(date);
                    if (!inMonth && !item.otherMon) {
                        inMonth = true;
                    }
                    week.push(item);
                    date.setDate(date.getDate() + 1);
                }
                if (inMonth) {
                    weeks.push(week);
                }
            }
            return weeks;
        },
        updateMonthInfo: function updateMonthInfo() {
            var day = new Date(this.tagDay);
            var info = {
                month: day.getMonth() + 1,
                year: day.getFullYear()
            };
            day.setDate(1);
            day.setMonth(day.getMonth() - 1);
            info.prevMonth = day.getMonth() + 1;
            day.setMonth(day.getMonth() + 2);
            info.nextMonth = day.getMonth() + 1;
            this.monthInfo = info;
        },
        next: function next(_delta) {
            var delta = _delta;
            var date = this.tagDay;
            date.setDate(1);
            delta = delta || 1;
            date.setMonth(date.getMonth() + delta);
            this.updateMonth();
        },
        prev: function prev(delta) {
            return this.next(-delta || -1);
        },
        isToday: function isToday(date) {
            return this.dateCompare(date, this.today) === 0;
        },
        isAfter: function isAfter(date) {
            var after = new Date(this.afterTime);
            if (isNaN(after)) return false;
            return this.dateCompare(date, after) > 0;
        },
        isBefore: function isBefore(date) {
            var before = new Date(this.beforeTime);
            if (isNaN(before)) return false;
            return this.dateCompare(date, before) < 0;
        },
        dateCompare: function dateCompare(_date1, _date2) {
            var date1 = (0, _helpers.formatDate)(_date1);
            var date2 = (0, _helpers.formatDate)(_date2);
            if (date1 > date2) {
                return 1;
            } else if (date1 < date2) {
                return -1;
            } else if (date1 === date2) {
                return 0;
            }
            return NaN;
        }
    },
    destroyed: function destroyed() {
        _helpers.eventBus.$off('calendar-update', this.updateFn);
        _helpers.eventBus.$off('calendar-reset', this.resetFn);
    },
    mounted: function mounted() {
        var _this3 = this;

        this.updateFn = function () {
            _this3.updateMonth();
        };
        this.resetFn = function ($event, date) {
            _this3.resetMonth(date);
        };
        this.updateMonth();
        _helpers.eventBus.$on('calendar-update', this.updateFn);
        _helpers.eventBus.$on('calendar-reset', this.resetFn);
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 552 */
/*!********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47313bec","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/Calendar.vue ***!
  \********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "date-calendar"
  }, [_c('header', [_c('div', {
    staticClass: "date-calendar-header flex"
  }, [_c('div', {
    staticClass: "date-calendar-header-month",
    on: {
      "click": function($event) {
        _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "icon-angle-left"
  }), _vm._v(" " + _vm._s(_vm.monthInfo.prevMonth) + "月\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "date-calendar-header-title"
  }, [_vm._v("\n                " + _vm._s(_vm._f("date")(_vm.tagDay, 'yyyy年MM月')) + "\n                "), ((!_vm.readonly || _vm.isTuan) && !_vm.single) ? _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allChecked),
      expression: "allChecked"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.isAllChecked(),
      "checked": Array.isArray(_vm.allChecked) ? _vm._i(_vm.allChecked, null) > -1 : (_vm.allChecked)
    },
    on: {
      "change": function($event) {
        _vm.selectAll()
      },
      "__c": function($event) {
        var $$a = _vm.allChecked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allChecked = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.allChecked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allChecked = $$c
        }
      }
    }
  }), _vm._v("\n                    全选\n                ")]) : _vm._e(), _vm._v(" "), (!_vm.readonly && !_vm.removeDisabled) ? _c('button', {
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.removeSelect()
      }
    }
  }, [_vm._v("\n                    删除选中日期\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "date-calendar-header-month",
    on: {
      "click": function($event) {
        _vm.next()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.monthInfo.nextMonth) + "月 "), _c('i', {
    staticClass: "icon-angle-right"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "date-calendar-week-line flex"
  }, _vm._l((_vm.weekdays), function(item) {
    return _c('div', {
      key: item.index,
      staticClass: "date-calendar-week-title"
    }, [_c('label', [((!_vm.readonly || _vm.isTuan) && !_vm.single) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.checked),
        expression: "item.checked"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.isWeekAllSelected(item),
        "checked": Array.isArray(item.checked) ? _vm._i(item.checked, null) > -1 : (item.checked)
      },
      on: {
        "change": function($event) {
          _vm.selectWeek(item.index, item.checked)
        },
        "__c": function($event) {
          var $$a = item.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (item.checked = $$a.concat($$v))
            } else {
              $$i > -1 && (item.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            item.checked = $$c
          }
        }
      }
    }) : _vm._e(), _vm._v("\n                    周" + _vm._s(item.name) + "\n                ")])])
  }))]), _vm._v(" "), _c('section', {
    staticClass: "date-calendar-body"
  }, _vm._l((_vm.weeks), function(week) {
    return _c('div', {
      staticClass: "date-calendar-line flex"
    }, _vm._l((week), function(day) {
      return _c('div', {
        staticClass: "date-calendar-day",
        class: {
          selected: day.checked, other: day.otherMon, locked: day.locked, today: day.isToday, info: day.info, 'out-range': day.isBefore || day.isAfter
        },
        on: {
          "click": function($event) {
            _vm.toggle(day)
          }
        }
      }, [_c('div', {
        staticClass: "day-text"
      }, [(!day.isToday) ? _c('span', [_vm._v(_vm._s(day.text) + "日")]) : _vm._e(), _vm._v(" "), (day.isToday) ? _c('span', [_vm._v("今日")]) : _vm._e(), _vm._v(" "), (day.info && day.info.desc) ? _c('span', {
        staticClass: "day-desc"
      }, [_vm._v(_vm._s(day.info.desc))]) : _vm._e()]), _vm._v(" "), (day.info && day.info.texts && day.info.texts.length) ? _c('div', {
        class: {
          'day-info': true, 'other-color': day.info.otherColor
        }
      }, [_c('ul', {
        staticClass: "list-unstyled"
      }, _vm._l((day.info.texts), function(text) {
        return _c('li', {
          staticClass: "day-info-item",
          domProps: {
            "innerHTML": _vm._s(text)
          }
        })
      }))]) : _vm._e()])
    }))
  }))])
},staticRenderFns: []}

/***/ }),
/* 553 */
/*!**************************************************!*\
  !*** ./src/components/datepicker/datepicker.vue ***!
  \**************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./datepicker.vue */ 554),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-597efa4c","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./datepicker.vue */ 556),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 554 */
/*!*********************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/datepicker/datepicker.vue ***!
  \*********************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flatpickr = __webpack_require__(/*! ./flatpickr */ 555);

var _flatpickr2 = _interopRequireDefault(_flatpickr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'v-datepicker',
    data: function data() {
        return {
            fp: null
        };
    },

    props: {
        options: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        message: {
            type: String,
            default: function _default() {
                return '';
            }
        },
        color: {
            type: String,
            required: false
        },
        bgColor: {
            type: String,
            required: false
        },
        disableColor: {
            type: String,
            required: false
        }
    },
    watch: {
        options: {
            handler: function handler(opt) {
                for (var o in opt) {
                    this.fp.set(o, opt[o]);
                }
            },
            deep: true
        },
        message: function message(val) {
            try {
                val = val.split(this.fp.l10n.rangeSeparator);
                this.fp.setDate(val, false);
            } catch (e) {}
        }
    },
    methods: {
        inputting: function inputting(e) {
            this.$emit('input', e.target.value);
        }
    },
    mounted: function mounted() {
        _flatpickr2.default.l10ns.zh = {
            rangeSeparator: ' ~ ',
            weekdays: {
                shorthand: ['日', '一', '二', '三', '四', '五', '六'],
                longhand: ['日', '一', '二', '三', '四', '五', '六']
            },
            months: {
                shorthand: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                longhand: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
            }
        };

        this.options.locale = 'zh';
        this.options.prevArrow = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 -1 20 20"><g></g><path d="M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z"></path></svg>';
        this.options.nextArrow = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 -1 20 20"><g></g><path d="M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z"></path></svg>';

        this.fp = new _flatpickr2.default(this.$el, this.options);
        if (this.bgColor) {
            this.fp.changeMonthNavBackColor(this.bgColor);
        }
        if (this.color && this.bgColor && this.disableColor) {
            this.fp.changeDayStyle(this.color, this.bgColor, this.disableColor);
        }
        this.$emit('flatpickr-ref', this.fp);
    },
    destroyed: function destroyed() {
        this.fp.destroy();
    }
}; //
//
//
//

/***/ }),
/* 555 */
/*!************************************************!*\
  !*** ./src/components/datepicker/flatpickr.js ***!
  \************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = __webpack_require__(/*! babel-runtime/helpers/typeof */ 116);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*! flatpickr v2.2.5, @license MIT */
/* eslint-disable */
function Flatpickr(element, config) {
    var self = this;

    function init() {
        if (element._flatpickr) {
            destroy(element._flatpickr);
        }

        element._flatpickr = self;

        self.element = element;
        self.instanceConfig = config || {};

        setupFormats();

        parseConfig();
        setupLocale();
        setupInputs();
        setupDates();

        setupHelperFunctions();

        self.isOpen = self.config.inline;
        self.changeMonth = changeMonth;
        self.clear = clear;
        self.close = close;
        self.destroy = destroy;
        self.formatDate = formatDate;
        self.jumpToDate = jumpToDate;
        self.open = open;
        self.parseDate = parseDate;
        self.redraw = redraw;
        self.set = set;
        self.setDate = setDate;
        self.toggle = toggle;
        self.changeMonthNavBackColor = changeMonthNavBackColor;
        self.changeDayStyle = changeDayStyle;
        self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === 'single' && !self.config.disable.length && !self.config.enable.length && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

        if (!self.isMobile) {
            build();
        }

        bind();

        self.minDateHasTime = self.config.minDate && (self.config.minDate.getHours() || self.config.minDate.getMinutes() || self.config.minDate.getSeconds());

        self.maxDateHasTime = self.config.maxDate && (self.config.maxDate.getHours() || self.config.maxDate.getMinutes() || self.config.maxDate.getSeconds());

        if (!self.isMobile) {
            Object.defineProperty(self, 'dateIsPicked', {
                set: function set(bool) {
                    if (bool) {
                        return self.calendarContainer.classList.add('dateIsPicked');
                    }
                    self.calendarContainer.classList.remove('dateIsPicked');
                }
            });
        }

        self.dateIsPicked = self.selectedDates.length > 0 || self.config.noCalendar;

        if (self.selectedDates.length) {
            if (self.config.enableTime) {
                setHoursFromDate();
            }
            updateValue();
        }

        if (self.config.weekNumbers) {
            self.calendarContainer.style.width = self.days.offsetWidth + self.weekWrapper.offsetWidth + 'px';
        }

        triggerEvent('Ready');
    }

    function updateTime(e) {
        if (self.config.noCalendar && !self.selectedDates.length)
            // picking time only
            {
                self.selectedDates = [self.now];
            }

        timeWrapper(e);

        if (!self.selectedDates.length) {
            return;
        }

        setHoursFromInputs();
        updateValue();
    }

    function setHoursFromInputs() {
        if (!self.config.enableTime) {
            return;
        }

        var hours = parseInt(self.hourElement.value, 10) || 0,
            minutes = parseInt(self.minuteElement.value, 10) || 0,
            seconds = self.config.enableSeconds ? parseInt(self.secondElement.value, 10) || 0 : 0;

        if (self.amPM) {
            hours = hours % 12 + 12 * (self.amPM.innerHTML === 'PM');
        }

        if (self.minDateHasTime && compareDates(latestSelectedDateObj(), self.config.minDate) === 0) {
            hours = Math.max(hours, self.config.minDate.getHours());
            if (hours === self.config.minDate.getHours()) {
                minutes = Math.max(minutes, self.config.minDate.getMinutes());
            }
        } else if (self.maxDateHasTime && compareDates(latestSelectedDateObj(), self.config.maxDate) === 0) {
            hours = Math.min(hours, self.config.maxDate.getHours());
            if (hours === self.config.maxDate.getHours()) {
                minutes = Math.min(minutes, self.config.maxDate.getMinutes());
            }
        }

        setHours(hours, minutes, seconds);
    }

    function setHoursFromDate(dateObj) {
        var date = dateObj || latestSelectedDateObj();

        if (date) {
            setHours(date.getHours(), date.getMinutes(), date.getSeconds());
        }
    }

    function setHours(hours, minutes, seconds) {
        if (self.selectedDates.length) {
            self.selectedDates[self.selectedDates.length - 1].setHours(hours % 24, minutes, seconds || 0, 0);
        }

        if (!self.config.enableTime || self.isMobile) {
            return;
        }

        self.hourElement.value = self.pad(!self.config.time_24hr ? (12 + hours) % 12 + 12 * (hours % 12 === 0) : hours);

        self.minuteElement.value = self.pad(minutes);

        if (!self.config.time_24hr && self.selectedDates.length) {
            self.amPM.textContent = latestSelectedDateObj().getHours() >= 12 ? 'PM' : 'AM';
        }

        if (self.config.enableSeconds) {
            self.secondElement.value = self.pad(seconds);
        }
    }

    function bind() {
        if (self.config.wrap) {
            ['open', 'close', 'toggle', 'clear'].forEach(function (el) {
                try {
                    self.element.querySelector('[data-' + el + ']').addEventListener('click', self[el]);
                } catch (e) {
                    //
                }
            });
        }

        if ('createEvent' in document) {
            self.changeEvent = document.createEvent('HTMLEvents');
            self.changeEvent.initEvent('change', false, true);
        }

        if (self.isMobile) {
            return setupMobile();
        }

        self.debouncedResize = debounce(onResize, 50);
        self.triggerChange = function () {
            return triggerEvent('Change');
        };
        self.debouncedChange = debounce(self.triggerChange, 1000);

        if (self.config.mode === 'range') {
            self.days.addEventListener('mouseover', onMouseOver);
            if (self.bgColor) {
                self.changeDayStyle('#fff', '#1da1ff', '#ccc');
            }
        }

        document.addEventListener('keydown', onKeyDown);
        window.addEventListener('resize', self.debouncedResize);

        var clickEvent = typeof window.ontouchstart !== 'undefined' ? 'touchstart' : 'click';

        document.addEventListener(clickEvent, documentClick);
        document.addEventListener('blur', documentClick);

        if (self.config.clickOpens) {
            (self.altInput || self.input).addEventListener('focus', open);
        }

        if (!self.config.noCalendar) {
            self.prevMonthNav.addEventListener('click', function () {
                return changeMonth(-1);
            });
            self.nextMonthNav.addEventListener('click', function () {
                return changeMonth(1);
            });

            self.currentYearElement.addEventListener('wheel', function (e) {
                return debounce(yearScroll(e), 50);
            });
            self.currentYearElement.addEventListener('focus', function () {
                self.currentYearElement.select();
            });

            self.currentYearElement.addEventListener('input', function (event) {
                if (event.target.value.length === 4) {
                    self.currentYearElement.blur();
                    handleYearChange(event.target.value);
                    event.target.value = self.currentYear;
                }
            });

            self.days.addEventListener('click', selectDate);
        }

        if (self.config.enableTime) {
            self.timeContainer.addEventListener('wheel', function (e) {
                return debounce(updateTime(e), 5);
            });
            self.timeContainer.addEventListener('input', updateTime);

            self.timeContainer.addEventListener('wheel', self.debouncedChange);
            self.timeContainer.addEventListener('input', self.triggerChange);

            self.hourElement.addEventListener('focus', function () {
                self.hourElement.select();
            });
            self.minuteElement.addEventListener('focus', function () {
                self.minuteElement.select();
            });

            if (self.secondElement) {
                self.secondElement.addEventListener('focus', function () {
                    self.secondElement.select();
                });
            }

            if (self.amPM) {
                self.amPM.addEventListener('click', function (e) {
                    updateTime(e);
                    self.triggerChange(e);
                });
            }
        }
    }

    function jumpToDate(jumpDate) {
        jumpDate = jumpDate ? parseDate(jumpDate) : latestSelectedDateObj() || (self.config.minDate > self.now ? self.config.minDate : self.now);

        try {
            self.currentYear = jumpDate.getFullYear();
            self.currentMonth = jumpDate.getMonth();
        } catch (e) {
            console.error(e.stack);
            console.warn('Invalid date supplied: ' + jumpDate);
        }

        self.redraw();
    }

    function incrementNumInput(e, delta) {
        var input = e.target.parentNode.childNodes[0];
        input.value = parseInt(input.value, 10) + delta * (input.step || 1);

        try {
            input.dispatchEvent(new Event('input', { 'bubbles': true }));
        } catch (e) {
            var ev = document.createEvent('CustomEvent');
            ev.initCustomEvent('input', true, true, {});
            input.dispatchEvent(ev);
        }
    }

    function createNumberInput(inputClassName) {
        var wrapper = createElement('div', 'numInputWrapper'),
            numInput = createElement('input', 'numInput ' + inputClassName),
            arrowUp = createElement('span', 'arrowUp'),
            arrowDown = createElement('span', 'arrowDown');

        numInput.type = 'text';
        wrapper.appendChild(numInput);
        wrapper.appendChild(arrowUp);
        wrapper.appendChild(arrowDown);

        arrowUp.addEventListener('click', function (e) {
            return incrementNumInput(e, 1);
        });
        arrowDown.addEventListener('click', function (e) {
            return incrementNumInput(e, -1);
        });
        return wrapper;
    }

    function build() {
        var fragment = document.createDocumentFragment();
        self.calendarContainer = createElement('div', 'flatpickr-calendar');
        self.numInputType = navigator.userAgent.indexOf('MSIE 9.0') > 0 ? 'text' : 'number';

        if (!self.config.noCalendar) {
            fragment.appendChild(buildMonthNav());
            self.innerContainer = createElement('div', 'flatpickr-innerContainer');

            if (self.config.weekNumbers) {
                self.innerContainer.appendChild(buildWeeks());
            }

            self.rContainer = createElement('div', 'flatpickr-rContainer');
            self.rContainer.appendChild(buildWeekdays());
            self.rContainer.appendChild(buildDays());
            self.innerContainer.appendChild(self.rContainer);
            fragment.appendChild(self.innerContainer);
        }

        if (self.config.enableTime) {
            fragment.appendChild(buildTime());
        }

        if (self.config.mode === 'range') {
            self.calendarContainer.classList.add('rangeMode');
        }

        self.calendarContainer.appendChild(fragment);

        if (self.config.inline || self.config.static) {
            self.calendarContainer.classList.add(self.config.inline ? 'inline' : 'static');
            positionCalendar();

            if (self.config.appendTo && self.config.appendTo.nodeType) {
                self.config.appendTo.appendChild(self.calendarContainer);
            } else {
                self.element.parentNode.insertBefore(self.calendarContainer, (self.altInput || self.input).nextSibling);
            }
        } else {
            document.body.appendChild(self.calendarContainer);
        }
    }

    function createDay(className, date, dayNumber) {
        var dateIsEnabled = isEnabled(date);
        self.dayElement = createElement('span', 'flatpickr-day ' + className, date.getDate());

        self.dayElement.dateObj = date;

        if (compareDates(date, self.now) === 0) {
            self.dayElement.classList.add('today');
        }

        if (dateIsEnabled) {
            self.dayElement.tabIndex = 0;

            if (isDateSelected(date)) {
                self.dayElement.classList.add('selected');
                if (self.bgColor) {
                    self.dayElement.style.backgroundColor = "#1da1ff";
                }
                if (self.config.mode === 'range') {
                    self.dayElement.classList.add(compareDates(date, self.selectedDates[0]) === 0 ? 'startRange' : 'endRange');
                } else {
                    self.selectedDateElem = self.dayElement;
                }
            }
        } else {
            self.dayElement.classList.add('disabled');
            if (self.selectedDates[0] && date > self.minRangeDate && date < self.selectedDates[0]) {
                self.minRangeDate = date;
            } else if (self.selectedDates[0] && date < self.maxRangeDate && date > self.selectedDates[0]) {
                self.maxRangeDate = date;
            }
        }

        if (self.config.mode === 'range') {
            if (isDateInRange(date) && !isDateSelected(date)) {
                self.dayElement.classList.add('inRange');
            }

            if (self.selectedDates.length === 1 && (date < self.minRangeDate || date > self.maxRangeDate)) {
                self.dayElement.classList.add('notAllowed');
            }
        }

        if (self.config.weekNumbers && className !== 'prevMonthDay' && dayNumber % 7 === 1) {
            self.weekNumbers.insertAdjacentHTML('beforeend', "<span class='disabled flatpickr-day'>" + self.config.getWeek(date) + '</span>');
        }

        triggerEvent('DayCreate', self.dayElement);

        return self.dayElement;
    }

    function changeDayStyle(color, bgColor, disableColor) {
        self.bgColor = bgColor;
        var obj = self.days.getElementsByClassName('flatpickr-day');

        var _loop = function _loop(i) {
            obj[i].addEventListener('click', function () {
                obj[i].classList.remove('selected');
                obj[i].style.backgroundColor = bgColor;
            }, false);
            obj[i].addEventListener('mouseover', function () {
                if (obj[i].className.indexOf('disabled') !== -1) {
                    obj[i].style.backgroundColor = disableColor;
                    obj[i].style.color = bgColor;
                } else {
                    if (color) {
                        obj[i].style.color = color;
                    }
                    if (bgColor) {
                        obj[i].style.backgroundColor = bgColor;
                    }
                }
            }, false);
            obj[i].addEventListener('mouseout', function () {
                if (obj[i].className.indexOf('disabled') !== -1) {
                    obj[i].style.backgroundColor = '#fff';
                    obj[i].style.color = 'black';
                } else {
                    obj[i].style.color = 'black';
                    obj[i].style.backgroundColor = '#fff';
                }
            }, false);
        };

        for (var i = 0; i < obj.length; i++) {
            _loop(i);
        }
    }

    function buildDays() {
        if (!self.days) {
            self.days = createElement('div', 'flatpickr-days');
            self.days.tabIndex = -1;
        }

        self.firstOfMonth = (new Date(self.currentYear, self.currentMonth, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;

        self.prevMonthDays = self.utils.getDaysinMonth((self.currentMonth - 1 + 12) % 12);

        var daysInMonth = self.utils.getDaysinMonth(),
            days = document.createDocumentFragment();

        var dayNumber = self.prevMonthDays + 1 - self.firstOfMonth;

        if (self.config.weekNumbers) {
            self.weekNumbers.innerHTML = '';
        }

        if (self.config.mode === 'range') {
            // const dateLimits = self.config.enable.length || self.config.disable.length || self.config.mixDate || self.config.maxDate;
            self.minRangeDate = new Date(self.currentYear, self.currentMonth - 1, dayNumber);
            self.maxRangeDate = new Date(self.currentYear, self.currentMonth + 1, (42 - self.firstOfMonth) % daysInMonth);
        }

        self.days.innerHTML = '';

        // prepend days from the ending of previous month
        for (var i = 0; dayNumber <= self.prevMonthDays; i++, dayNumber++) {
            days.appendChild(createDay('prevMonthDay', new Date(self.currentYear, self.currentMonth - 1, dayNumber), dayNumber));
        }

        // Start at 1 since there is no 0th day
        for (dayNumber = 1; dayNumber <= daysInMonth; dayNumber++) {
            days.appendChild(createDay('', new Date(self.currentYear, self.currentMonth, dayNumber), dayNumber));
        }

        // append days from the next month
        for (var dayNum = daysInMonth + 1; dayNum <= 42 - self.firstOfMonth; dayNum++) {
            days.appendChild(createDay('nextMonthDay', new Date(self.currentYear, self.currentMonth + 1, dayNum % daysInMonth), dayNum));
        }

        self.days.appendChild(days);
        return self.days;
    }

    function changeMonthNavBackColor(color) {
        if (color) {
            self.monthNav.style.backgroundColor = color;
        }
    }

    function buildMonthNav() {
        var monthNavFragment = document.createDocumentFragment();
        self.monthNav = createElement('div', 'flatpickr-month');

        self.prevMonthNav = createElement('span', 'flatpickr-prev-month');
        self.prevMonthNav.innerHTML = self.config.prevArrow;

        self.currentMonthElement = createElement('span', 'cur-month');

        var yearInput = createNumberInput('cur-year');
        self.currentYearElement = yearInput.childNodes[0];
        self.currentYearElement.title = self.l10n.scrollTitle;

        if (self.config.minDate) {
            self.currentYearElement.min = self.config.minDate.getFullYear();
        }

        if (self.config.maxDate) {
            self.currentYearElement.max = self.config.maxDate.getFullYear();

            self.currentYearElement.disabled = self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
        }

        self.nextMonthNav = createElement('span', 'flatpickr-next-month');
        self.nextMonthNav.innerHTML = self.config.nextArrow;

        self.navigationCurrentMonth = createElement('span', 'flatpickr-current-month');
        self.navigationCurrentMonth.appendChild(yearInput);
        self.navigationCurrentMonth.appendChild(self.currentMonthElement);

        monthNavFragment.appendChild(self.prevMonthNav);
        monthNavFragment.appendChild(self.navigationCurrentMonth);
        monthNavFragment.appendChild(self.nextMonthNav);
        self.monthNav.appendChild(monthNavFragment);

        updateNavigationCurrentMonth();

        return self.monthNav;
    }

    function buildTime() {
        self.calendarContainer.classList.add('hasTime');
        self.timeContainer = createElement('div', 'flatpickr-time');
        self.timeContainer.tabIndex = -1;
        var separator = createElement('span', 'flatpickr-time-separator', ':');

        var hourInput = createNumberInput('flatpickr-hour');
        self.hourElement = hourInput.childNodes[0];

        var minuteInput = createNumberInput('flatpickr-minute');
        self.minuteElement = minuteInput.childNodes[0];

        self.hourElement.tabIndex = self.minuteElement.tabIndex = 0;
        self.hourElement.pattern = self.minuteElement.pattern = '\d*';

        self.hourElement.value = self.pad(latestSelectedDateObj() ? latestSelectedDateObj().getHours() : self.config.defaultHour);

        self.minuteElement.value = self.pad(latestSelectedDateObj() ? latestSelectedDateObj().getMinutes() : self.config.defaultMinute);

        self.hourElement.step = self.config.hourIncrement;
        self.minuteElement.step = self.config.minuteIncrement;

        self.hourElement.min = self.config.time_24hr ? 0 : 1;
        self.hourElement.max = self.config.time_24hr ? 23 : 12;

        self.minuteElement.min = 0;
        self.minuteElement.max = 59;

        self.hourElement.title = self.minuteElement.title = self.l10n.scrollTitle;

        self.timeContainer.appendChild(hourInput);
        self.timeContainer.appendChild(separator);
        self.timeContainer.appendChild(minuteInput);

        if (self.config.time_24hr) {
            self.timeContainer.classList.add('time24hr');
        }

        if (self.config.enableSeconds) {
            self.timeContainer.classList.add('hasSeconds');

            var secondInput = createNumberInput('flatpickr-second');
            self.secondElement = secondInput.childNodes[0];

            self.secondElement.pattern = self.hourElement.pattern;
            self.secondElement.value = latestSelectedDateObj() ? self.pad(latestSelectedDateObj().getSeconds()) : '00';

            self.secondElement.step = self.minuteElement.step;
            self.secondElement.min = self.minuteElement.min;
            self.secondElement.max = self.minuteElement.max;

            self.timeContainer.appendChild(createElement('span', 'flatpickr-time-separator', ':'));
            self.timeContainer.appendChild(secondInput);
        }

        if (!self.config.time_24hr) {
            // add self.amPM if appropriate
            self.amPM = createElement('span', 'flatpickr-am-pm', ['AM', 'PM'][self.hourElement.value > 11 | 0]);
            self.amPM.title = self.l10n.toggleTitle;
            self.amPM.tabIndex = 0;
            self.timeContainer.appendChild(self.amPM);
        }

        return self.timeContainer;
    }

    function buildWeekdays() {
        if (!self.weekdayContainer) {
            self.weekdayContainer = createElement('div', 'flatpickr-weekdays');
        }

        var firstDayOfWeek = self.l10n.firstDayOfWeek;
        var weekdays = self.l10n.weekdays.shorthand.slice();

        if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) {
            weekdays = [].concat(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
        }

        self.weekdayContainer.innerHTML = '\n\t\t<span class=flatpickr-weekday>\n\t\t\t' + weekdays.join('</span><span class=flatpickr-weekday>') + '\n\t\t</span>\n\t\t';

        return self.weekdayContainer;
    }

    function buildWeeks() {
        self.calendarContainer.classList.add('hasWeeks');
        self.weekWrapper = createElement('div', 'flatpickr-weekwrapper');
        self.weekWrapper.appendChild(createElement('span', 'flatpickr-weekday', self.l10n.weekAbbreviation));
        self.weekNumbers = createElement('div', 'flatpickr-weeks');
        self.weekWrapper.appendChild(self.weekNumbers);
        return self.weekWrapper;
    }

    function changeMonth(value, is_offset) {
        self.currentMonth = typeof is_offset === 'undefined' || is_offset ? self.currentMonth + value : value;

        handleYearChange();
        updateNavigationCurrentMonth();
        buildDays();

        if (!self.config.noCalendar) {
            self.days.focus();
        }

        triggerEvent('MonthChange');
    }

    function clear() {
        var triggerChangeEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        self.input.value = '';

        if (self.altInput) {
            self.altInput.value = '';
        }

        if (self.mobileInput) {
            self.mobileInput.value = '';
        }

        self.selectedDates = [];
        self.dateIsPicked = false;

        self.redraw();

        if (triggerChangeEvent !== false)
            // triggerChangeEvent is true (default) or an Event
            {
                triggerEvent('Change');
            }
    }

    function close() {
        self.isOpen = false;

        if (!self.isMobile) {
            self.calendarContainer.classList.remove('open');
            (self.altInput || self.input).classList.remove('active');
        }

        triggerEvent('Close');
    }

    function destroy(instance) {
        instance = instance || self;
        instance.clear(false);

        document.removeEventListener('keydown', onKeyDown);
        window.removeEventListener('resize', instance.debouncedResize);

        document.removeEventListener('click', documentClick);
        document.removeEventListener('blur', documentClick);

        if (instance.mobileInput && instance.mobileInput.parentNode) {
            instance.mobileInput.parentNode.removeChild(instance.mobileInput);
        } else if (instance.calendarContainer && instance.calendarContainer.parentNode) {
            instance.calendarContainer.parentNode.removeChild(instance.calendarContainer);
        }

        if (instance.altInput) {
            instance.input.type = 'text';
            if (instance.altInput.parentNode) {
                instance.altInput.parentNode.removeChild(instance.altInput);
            }
        }

        instance.input.classList.remove('flatpickr-input');
        instance.input.removeEventListener('focus', open);
        instance.input.removeAttribute('readonly');

        delete instance.input._flatpickr;
    }

    function isCalendarElem(elem) {
        var e = elem;
        while (e) {
            if (/flatpickr-day|flatpickr-calendar/.test(e.className)) {
                return true;
            }
            e = e.parentNode;
        }

        return false;
    }

    function documentClick(e) {
        var isInput = self.element.contains(e.target) || e.target === self.input || e.target === self.altInput;

        if (self.isOpen && !isCalendarElem(e.target) && !isInput) {
            self.close();

            if (self.config.mode === 'range' && self.selectedDates.length === 1) {
                self.clear();
                self.redraw();
            }
        }
    }

    function formatDate(frmt, dateObj) {
        if (self.config.formatDate) {
            return self.config.formatDate(frmt, dateObj);
        }

        var chars = frmt.split('');
        return chars.map(function (c, i) {
            return self.formats[c] && chars[i - 1] !== '\\' ? self.formats[c](dateObj) : c !== '\\' ? c : '';
        }).join('');
    }

    function handleYearChange(newYear) {
        if (self.currentMonth < 0 || self.currentMonth > 11) {
            self.currentYear += self.currentMonth % 11;
            self.currentMonth = (self.currentMonth + 12) % 12;
            triggerEvent('YearChange');
        } else if (newYear && (!self.currentYearElement.min || newYear >= self.currentYearElement.min) && (!self.currentYearElement.max || newYear <= self.currentYearElement.max)) {
            self.currentYear = parseInt(newYear, 10) || self.currentYear;

            if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) {
                self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
            } else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) {
                self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
            }

            self.redraw();
            triggerEvent('YearChange');
        }
    }

    function isEnabled(date) {
        if (self.config.minDate && compareDates(date, self.config.minDate) < 0 || self.config.maxDate && compareDates(date, self.config.maxDate) > 0) {
            return false;
        }

        if (!self.config.enable.length && !self.config.disable.length) {
            return true;
        }

        var dateToCheck = parseDate(date, true); // timeless

        var bool = self.config.enable.length > 0,
            array = bool ? self.config.enable : self.config.disable;

        for (var i = 0, d; i < array.length; i++) {
            d = array[i];

            if (d instanceof Function && d(dateToCheck)) // disabled by function
                {
                    return bool;
                } else if ((d instanceof Date || typeof d === 'string') && parseDate(d, true).getTime() === dateToCheck.getTime())
                // disabled by date string
                {
                    return bool;
                } else if ( // disabled by range
            (typeof d === 'undefined' ? 'undefined' : (0, _typeof3.default)(d)) === 'object' && d.from && d.to && dateToCheck >= parseDate(d.from) && dateToCheck <= parseDate(d.to)) {
                return bool;
            }
        }

        return !bool;
    }

    function onKeyDown(e) {
        if (self.isOpen) {
            switch (e.which) {
                case 13:
                    if (self.timeContainer && self.timeContainer.contains(e.target)) {
                        updateValue();
                    } else {
                        selectDate(e);
                    }

                    break;

                case 27:
                    // escape
                    self.clear();
                    self.redraw();
                    self.close();
                    break;

                case 37:
                    if (e.target !== self.input & e.target !== self.altInput) {
                        changeMonth(-1);
                    }
                    break;

                case 38:
                    e.preventDefault();

                    if (self.timeContainer && self.timeContainer.contains(e.target)) {
                        updateTime(e);
                    } else {
                        self.currentYear++;
                        self.redraw();
                    }

                    break;

                case 39:
                    if (e.target !== self.input & e.target !== self.altInput) {
                        changeMonth(1);
                    }
                    break;

                case 40:
                    e.preventDefault();
                    if (self.timeContainer && self.timeContainer.contains(e.target)) {
                        updateTime(e);
                    } else {
                        self.currentYear--;
                        self.redraw();
                    }

                    break;

                default:
                    break;
            }
        }
    }

    function onMouseOver(e) {
        if (self.selectedDates.length !== 1 || !e.target.classList.contains('flatpickr-day')) {
            return;
        }

        var hoverDate = e.target.dateObj,
            initialDate = parseDate(self.selectedDates[0], true),
            rangeStartDate = Math.min(hoverDate.getTime(), self.selectedDates[0].getTime()),
            rangeEndDate = Math.max(hoverDate.getTime(), self.selectedDates[0].getTime()),
            containsDisabled = false;

        for (var t = rangeStartDate; t < rangeEndDate; t += self.utils.duration.DAY) {
            if (!isEnabled(new Date(t))) {
                containsDisabled = true;
                break;
            }
        }

        for (var timestamp = self.days.childNodes[0].dateObj.getTime(), i = 0; i < 42; i++, timestamp += self.utils.duration.DAY) {
            var outOfRange = timestamp < self.minRangeDate.getTime() || timestamp > self.maxRangeDate.getTime();

            if (outOfRange) {
                self.days.childNodes[i].classList.add('notAllowed');
                self.days.childNodes[i].classList.remove('inRange', 'startRange', 'endRange');
                continue;
            } else if (containsDisabled && !outOfRange) {
                continue;
            }

            self.days.childNodes[i].classList.remove('startRange', 'inRange', 'endRange', 'notAllowed');

            var minRangeDate = Math.max(self.minRangeDate.getTime(), rangeStartDate),
                maxRangeDate = Math.min(self.maxRangeDate.getTime(), rangeEndDate);

            e.target.classList.add(hoverDate < self.selectedDates[0] ? 'startRange' : 'endRange');

            if (initialDate > hoverDate && timestamp === initialDate.getTime()) {
                self.days.childNodes[i].classList.add('endRange');
            } else if (initialDate < hoverDate && timestamp === initialDate.getTime()) {
                self.days.childNodes[i].classList.add('startRange');
            } else if (timestamp > minRangeDate && timestamp < maxRangeDate) {
                self.days.childNodes[i].classList.add('inRange');
            }
        }
    }

    function onResize() {
        if (self.isOpen && !self.config.static && !self.config.inline) {
            positionCalendar();
        }
    }

    function open(e) {
        if (self.isMobile) {
            if (e) {
                e.preventDefault();
                e.target.blur();
            }

            setTimeout(function () {
                self.mobileInput.click();
            }, 0);

            triggerEvent('Open');
            return;
        } else if (self.isOpen || (self.altInput || self.input).disabled || self.config.inline) {
            return;
        }

        self.calendarContainer.classList.add('open');

        if (!self.config.static && !self.config.inline) {
            positionCalendar();
        }

        self.isOpen = true;

        if (!self.config.allowInput) {
            (self.altInput || self.input).blur();
            (self.config.noCalendar ? self.timeContainer : self.selectedDateElem ? self.selectedDateElem : self.days).focus();
        }

        (self.altInput || self.input).classList.add('active');
        triggerEvent('Open');
    }

    function parseConfig() {
        var boolOpts = ['utc', 'wrap', 'weekNumbers', 'allowInput', 'clickOpens', 'time_24hr', 'enableTime', 'noCalendar', 'altInput', 'shorthandCurrentMonth', 'inline', 'static', 'enableSeconds', 'disableMobile'];
        self.config = Object.create(Flatpickr.defaultConfig);
        var userConfig = Object.assign({}, self.instanceConfig, self.element.dataset || {});

        Object.defineProperty(self.config, 'minDate', {
            get: function get() {
                return this._minDate;
            },
            set: function set(date) {
                this._minDate = parseDate(date);

                if (self.days) {
                    redraw();
                }

                if (!self.currentYearElement) {
                    return;
                }

                if (date && this._minDate instanceof Date) {
                    self.minDateHasTime = this._minDate.getHours() || this._minDate.getMinutes() || this._minDate.getSeconds();

                    self.currentYearElement.min = this._minDate.getFullYear();
                } else {
                    self.currentYearElement.removeAttribute('min');
                }

                self.currentYearElement.disabled = this._maxDate && this._minDate && this._maxDate.getFullYear() === this._minDate.getFullYear();
            }
        });

        Object.defineProperty(self.config, 'maxDate', {
            get: function get() {
                return this._maxDate;
            },
            set: function set(date) {
                this._maxDate = parseDate(date);
                if (self.days) {
                    redraw();
                }

                if (!self.currentYearElement) {
                    return;
                }

                if (date && this._maxDate instanceof Date) {
                    self.currentYearElement.max = this._maxDate.getFullYear();
                    self.maxDateHasTime = this._maxDate.getHours() || this._maxDate.getMinutes() || this._maxDate.getSeconds();
                } else {
                    self.currentYearElement.removeAttribute('max');
                }

                self.currentYearElement.disabled = this._maxDate && this._minDate && this._maxDate.getFullYear() === this._minDate.getFullYear();
            }
        });

        Object.assign(self.config, userConfig);

        for (var i = 0; i < boolOpts.length; i++) {
            self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === 'true';
        }

        if (!userConfig.dateFormat && userConfig.enableTime) {
            self.config.dateFormat = self.config.noCalendar ? 'H:i' + (self.config.enableSeconds ? ':S' : '') : Flatpickr.defaultConfig.dateFormat + ' H:i' + (self.config.enableSeconds ? ':S' : '');
        }

        if (userConfig.altInput && userConfig.enableTime && !userConfig.altFormat) {
            self.config.altFormat = self.config.noCalendar ? 'h:i' + (self.config.enableSeconds ? ':S K' : ' K') : Flatpickr.defaultConfig.altFormat + (' h:i' + (self.config.enableSeconds ? ':S' : '') + ' K');
        }
    }

    function setupLocale() {
        if ((0, _typeof3.default)(self.config.locale) !== 'object' && typeof Flatpickr.l10ns[self.config.locale] === 'undefined') {
            console.warn('flatpickr: invalid locale ' + self.config.locale);
        }

        self.l10n = Object.assign(Object.create(Flatpickr.l10ns.default), (0, _typeof3.default)(self.config.locale) === 'object' ? self.config.locale : self.config.locale !== 'default' ? Flatpickr.l10ns[self.config.locale] || {} : {});
    }

    function parseDate(date) {
        var timeless = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        if (!date) {
            return null;
        }

        var dateTimeRegex = /(\d+)/g,
            timeRegex = /^(\d{1,2})[:\s](\d\d)?[:\s]?(\d\d)?\s?(a|p)?/i,
            timestamp = /^(\d+){13}$/g,
            date_cn = /^(\d{4})(\d{2})(\d{2})$/,
            date_orig = date;

        if (date.toFixed || timestamp.test(date)) // timestamp
            {
                date = new Date(date);
            } else if (date_cn.test(date)) {
            var d = date.match(date_cn);
            date = new Date(d[1], Number(d[2]) - 1, d[3]);
        } else if (typeof date === 'string') {
            date = date.trim();

            if (date === 'today') {
                date = new Date();
                timeless = true;
            } else if (self.config.parseDate) {
                date = self.config.parseDate(date);
            } else if (timeRegex.test(date)) {
                // time picker
                var m = date.match(timeRegex),
                    hours = !m[4] ? m[1] // military time, no conversion needed
                : m[1] % 12 + (m[4].toLowerCase() === 'p' ? 12 : 0); // am/pm

                date = new Date();
                date.setHours(hours, m[2] || 0, m[3] || 0);
            } else if (/Z$/.test(date) || /GMT$/.test(date)) // datestrings w/ timezone
                {
                    date = new Date(date);
                } else if (dateTimeRegex.test(date) && /^[0-9]/.test(date)) {
                var _d = date.match(dateTimeRegex);
                date = new Date(_d[0] + '/' + (_d[1] || 1) + '/' + (_d[2] || 1) + ' ' + (_d[3] || 0) + ':' + (_d[4] || 0) + ':' + (_d[5] || 0));
            } else // fallback
                {
                    date = new Date(date);
                }
        } else if (date instanceof Date) {
            date = new Date(date.getTime());
        } // create a copy

        if (!(date instanceof Date)) {
            console.warn('flatpickr: invalid date ' + date_orig);
            console.info(self.element);
            return null;
        }

        if (self.config.utc && !date.fp_isUTC) {
            date = date.fp_toUTC();
        }

        if (timeless === true) {
            date.setHours(0, 0, 0, 0);
        }

        return date;
    }

    function positionCalendar() {
        var calendarHeight = self.calendarContainer.offsetHeight,
            input = self.altInput || self.input,
            inputBounds = input.getBoundingClientRect(),
            distanceFromBottom = window.innerHeight - inputBounds.bottom + input.offsetHeight;

        var top = void 0,
            left = window.pageXOffset + inputBounds.left;

        if (distanceFromBottom < calendarHeight) {
            top = window.pageYOffset - calendarHeight + inputBounds.top - 2;
            self.calendarContainer.classList.remove('arrowTop');
            self.calendarContainer.classList.add('arrowBottom');
        } else {
            top = window.pageYOffset + input.offsetHeight + inputBounds.top + 2;
            self.calendarContainer.classList.remove('arrowBottom');
            self.calendarContainer.classList.add('arrowTop');
        }

        if (!self.config.static && !self.config.inline) {
            self.calendarContainer.style.top = top + 'px';
            self.calendarContainer.style.left = left + 'px';
        }
    }

    function redraw() {
        if (self.config.noCalendar || self.isMobile) {
            return;
        }

        buildWeekdays();
        updateNavigationCurrentMonth();
        buildDays();
    }

    function selectDate(e) {
        if (self.config.allowInput && e.which === 13 && e.target === (self.altInput || self.input)) {
            return self.setDate((self.altInput || self.input).value), e.target.blur();
        }

        if (!e.target.classList.contains('flatpickr-day') || e.target.classList.contains('disabled') || e.target.classList.contains('notAllowed')) {
            return;
        }

        var selectedDate = e.target.dateObj;
        self.selectedDateElem = e.target;

        if (self.config.mode === 'single') {
            self.selectedDates = [selectedDate];

            if (!self.config.enableTime) {
                self.close();
            }
        } else if (self.config.mode === 'multiple') {
            var selectedIndex = isDateSelected(selectedDate);
            if (selectedIndex) {
                self.selectedDates.splice(selectedIndex, 1);
            } else {
                self.selectedDates.push(selectedDate);
            }
        } else if (self.config.mode === 'range') {
            if (self.selectedDates.length === 2) {
                self.clear();
            }

            self.selectedDates.push(selectedDate);
            self.selectedDates.sort(function (a, b) {
                return a.getTime() - b.getTime();
            });
        }

        setHoursFromInputs();

        if (selectedDate.getMonth() !== self.currentMonth && self.config.mode !== 'range') {
            self.currentYear = selectedDate.getFullYear();
            self.currentMonth = selectedDate.getMonth();
            updateNavigationCurrentMonth();
        }

        buildDays();

        if (self.minDateHasTime && self.config.enableTime && compareDates(selectedDate, self.config.minDate) === 0) {
            setHoursFromDate(self.config.minDate);
        }

        updateValue();

        setTimeout(function () {
            return self.dateIsPicked = true;
        }, 50);

        if (self.config.mode === 'range' && self.selectedDates.length === 1) {
            onMouseOver(e);
            if (self.bgColor) {
                self.changeDayStyle('#fff', '#1da1ff', '#ccc');
            }
        }

        triggerEvent('Change');
    }

    function set(option, value) {
        self.config[option] = value;
        self.redraw();
        jumpToDate();
    }

    function setDate(date, triggerChange) {
        if (!date) {
            return self.clear();
        }

        self.selectedDates = (Array.isArray(date) ? date.map(parseDate) : [parseDate(date)]).filter(function (d) {
            return d instanceof Date && isEnabled(d);
        });
        self.redraw();
        jumpToDate();

        setHoursFromDate();
        updateValue();

        self.dateIsPicked = self.selectedDates.length > 0;

        if (triggerChange) {
            triggerEvent('Change');
        }
    }

    function setupDates() {
        self.selectedDates = [];
        self.now = new Date();
        var inputDate = self.config.defaultDate || self.input.value;

        if (Array.isArray(inputDate)) {
            self.selectedDates = inputDate.map(parseDate);
        } else if (inputDate) {
            switch (self.config.mode) {
                case 'single':
                    self.selectedDates = [parseDate(inputDate)];
                    break;

                case 'multiple':
                    self.selectedDates = inputDate.split('; ').map(parseDate);
                    break;

                case 'range':
                    self.selectedDates = inputDate.split(self.l10n.rangeSeparator).map(parseDate);
                    break;

                default:
                    break;
            }
        }

        self.selectedDates = self.selectedDates.filter(function (d) {
            return d instanceof Date && d.getTime() && isEnabled(d);
        });

        var initialDate = self.selectedDates.length ? self.selectedDates[0] : self.config.minDate > self.now ? self.config.minDate : self.now;

        self.currentYear = initialDate.getFullYear();
        self.currentMonth = initialDate.getMonth();
    }

    function setupHelperFunctions() {
        self.utils = {
            duration: {
                DAY: 86400000
            },
            getDaysinMonth: function getDaysinMonth() {
                var month = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.currentMonth;
                var yr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : self.currentYear;

                if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) {
                    return 29;
                }
                return self.l10n.daysInMonth[month];
            },

            monthToStr: function monthToStr(monthNumber) {
                var short = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : self.config.shorthandCurrentMonth;
                return self.l10n.months[(short ? 'short' : 'long') + 'hand'][monthNumber];
            }
        };
    }

    function setupFormats() {
        self.formats = {
            // weekday name, short, e.g. Thu
            D: function D(date) {
                return self.l10n.weekdays.shorthand[self.formats.w(date)];
            },

            // full month name e.g. January
            F: function F(date) {
                return self.utils.monthToStr(self.formats.n(date) - 1, false);
            },

            // hours with leading zero e.g. 03
            H: function H(date) {
                return Flatpickr.prototype.pad(date.getHours());
            },

            // day (1-30) with ordinal suffix e.g. 1st, 2nd
            J: function J(date) {
                return date.getDate() + self.l10n.ordinal(date.getDate());
            },

            // AM/PM
            K: function K(date) {
                return date.getHours() > 11 ? 'PM' : 'AM';
            },

            // shorthand month e.g. Jan, Sep, Oct, etc
            M: function M(date) {
                return self.utils.monthToStr(date.getMonth(), true);
            },

            // seconds 00-59
            S: function S(date) {
                return Flatpickr.prototype.pad(date.getSeconds());
            },

            // unix timestamp
            U: function U(date) {
                return date.getTime() / 1000;
            },

            // full year e.g. 2016
            Y: function Y(date) {
                return date.getFullYear();
            },

            // day in month, padded (01-30)
            d: function d(date) {
                return Flatpickr.prototype.pad(self.formats.j(date));
            },

            // hour from 1-12 (am/pm)
            h: function h(date) {
                return date.getHours() % 12 ? date.getHours() % 12 : 12;
            },

            // minutes, padded with leading zero e.g. 09
            i: function i(date) {
                return Flatpickr.prototype.pad(date.getMinutes());
            },

            // day in month (1-30)
            j: function j(date) {
                return date.getDate();
            },

            // weekday name, full, e.g. Thursday
            l: function l(date) {
                return self.l10n.weekdays.longhand[self.formats.w(date)];
            },

            // padded month number (01-12)
            m: function m(date) {
                return Flatpickr.prototype.pad(self.formats.n(date));
            },

            // the month number (1-12)
            n: function n(date) {
                return date.getMonth() + 1;
            },

            // seconds 0-59
            s: function s(date) {
                return date.getSeconds();
            },

            // number of the day of the week
            w: function w(date) {
                return date.getDay();
            },

            // last two digits of year e.g. 16 for 2016
            y: function y(date) {
                return String(self.formats.Y(date)).substring(2);
            }
        };
    }

    function setupInputs() {
        self.input = self.config.wrap ? self.element.querySelector('[data-input]') : self.element;

        self.input.classList.add('flatpickr-input');
        if (self.config.altInput) {
            // replicate self.element
            self.altInput = createElement(self.input.nodeName, self.config.altInputClass);
            self.altInput.placeholder = self.input.placeholder;
            self.altInput.type = 'text';

            self.input.type = 'hidden';
            if (self.input.parentNode) {
                self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
            }
        }

        if (!self.config.allowInput) {
            (self.altInput || self.input).setAttribute('readonly', 'readonly');
        }
    }

    function setupMobile() {
        var inputType = self.config.enableTime ? self.config.noCalendar ? 'time' : 'datetime-local' : 'date';

        self.mobileInput = createElement('input', 'flatpickr-input flatpickr-mobile');
        self.mobileInput.step = 'any';
        self.mobileInput.tabIndex = -1;
        self.mobileInput.type = inputType;
        self.mobileInput.disabled = self.input.disabled;

        self.mobileFormatStr = inputType === 'datetime-local' ? 'Y-m-d\\TH:i:S' : inputType === 'date' ? 'Y-m-d' : 'H:i:S';

        if (self.selectedDates.length) {
            self.mobileInput.defaultValue = self.mobileInput.value = formatDate(self.mobileFormatStr, self.selectedDates[0]);
        }

        if (self.config.minDate) {
            self.mobileInput.min = formatDate('Y-m-d', self.config.minDate);
        }

        if (self.config.maxDate) {
            self.mobileInput.max = formatDate('Y-m-d', self.config.maxDate);
        }

        self.input.type = 'hidden';
        if (self.config.altInput) {
            self.altInput.type = 'hidden';
        }

        try {
            self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
        } catch (e) {
            //
        }

        self.mobileInput.addEventListener('change', function (e) {
            self.setDate(e.target.value);
            triggerEvent('Change');
            triggerEvent('Close');
        });
    }

    function toggle() {
        if (self.isOpen) {
            self.close();
        } else {
            self.open();
        }
    }

    function triggerEvent(event, data) {
        if (self.config['on' + event]) {
            var hooks = Array.isArray(self.config['on' + event]) ? self.config['on' + event] : [self.config['on' + event]];

            for (var i = 0; i < hooks.length; i++) {
                hooks[i](self.selectedDates, self.input.value, self, data);
            }
        }

        if (event === 'Change') {
            try {
                self.input.dispatchEvent(new Event('change', { 'bubbles': true }));

                // many front-end frameworks bind to the input event
                self.input.dispatchEvent(new Event('input', { 'bubbles': true }));
            } catch (e) {
                if ('createEvent' in document) {
                    return self.input.dispatchEvent(self.changeEvent);
                }

                self.input.fireEvent('onchange');
            }
        }
    }

    function latestSelectedDateObj() {
        if (self.selectedDates.length) {
            return self.selectedDates[self.selectedDates.length - 1];
        }
        return null;
    }

    function isDateSelected(date) {
        for (var i = 0; i < self.selectedDates.length; i++) {
            if (compareDates(self.selectedDates[i], date) === 0) {
                return String(i);
            }
        }

        return false;
    }

    function isDateInRange(date) {
        if (self.config.mode !== 'range' || self.selectedDates.length < 2) {
            return false;
        }
        return compareDates(date, self.selectedDates[0]) >= 0 && compareDates(date, self.selectedDates[1]) <= 0;
    }

    function updateNavigationCurrentMonth() {
        if (self.config.noCalendar || self.isMobile || !self.monthNav) {
            return;
        }

        self.currentMonthElement.textContent = self.utils.monthToStr(self.currentMonth) + ' ';
        self.currentYearElement.value = self.currentYear;

        if (self.config.minDate) {
            var hidePrevMonthArrow = self.currentYear === self.config.minDate.getFullYear() ? (self.currentMonth + 11) % 12 < self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear();

            self.prevMonthNav.style.display = hidePrevMonthArrow ? 'none' : 'block';
        } else {
            self.prevMonthNav.style.display = 'block';
        }

        if (self.config.maxDate) {
            var hideNextMonthArrow = self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear();

            self.nextMonthNav.style.display = hideNextMonthArrow ? 'none' : 'block';
        } else {
            self.nextMonthNav.style.display = 'block';
        }
    }

    function updateValue() {
        if (!self.selectedDates.length) {
            return self.clear();
        }

        if (self.isMobile) {
            self.mobileInput.value = self.selectedDates.length ? formatDate(self.mobileFormatStr, latestSelectedDateObj()) : '';
        }

        var joinChar = self.config.mode !== 'range' ? '; ' : self.l10n.rangeSeparator;

        self.input.value = self.selectedDates.map(function (dObj) {
            return formatDate(self.config.dateFormat, dObj);
        }).join(joinChar);

        if (self.config.altInput) {
            self.altInput.value = self.selectedDates.map(function (dObj) {
                return formatDate(self.config.altFormat, dObj);
            }).join(joinChar);
        }

        triggerEvent('ValueUpdate');
    }

    function yearScroll(e) {
        e.preventDefault();

        var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.deltaY)),
            newYear = parseInt(e.target.value, 10) + delta;

        handleYearChange(newYear);
        e.target.value = self.currentYear;
    }

    function createElement(tag) {
        var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var content = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

        var e = document.createElement(tag);
        e.className = className;

        if (content) {
            e.innerHTML = content;
        }

        return e;
    }

    function debounce(func, wait, immediate) {
        var timeout = void 0;
        return function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            var context = this;
            var later = function later() {
                timeout = null;
                if (!immediate) {
                    func.apply(context, args);
                }
            };

            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (immediate && !timeout) {
                func.apply(context, args);
            }
        };
    }

    function compareDates(date1, date2) {
        if (!(date1 instanceof Date) || !(date2 instanceof Date)) {
            return false;
        }

        return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
    }

    function timeWrapper(e) {
        e.preventDefault();
        if (e && ((e.target.value || e.target.textContent).length >= 2 || // typed two digits
        e.type !== 'keydown' && e.type !== 'input' // scroll event
        )) {
            e.target.blur();
        }

        if (self.amPM && e.target === self.amPM) {
            return e.target.textContent = ['AM', 'PM'][e.target.textContent === 'AM' | 0];
        }

        var min = Number(e.target.min),
            max = Number(e.target.max),
            step = Number(e.target.step),
            curValue = parseInt(e.target.value, 10),
            delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.deltaY));

        var newValue = Number(curValue);

        if (e.type === 'wheel') {
            newValue = curValue + step * delta;
        } else if (e.type === 'keydown') {
            newValue = curValue + step * (e.which === 38 ? 1 : -1);
        }

        if (newValue < min) {
            newValue = max + newValue + (e.target !== self.hourElement) + (e.target === self.hourElement && !self.amPM);
        } else if (newValue > max) {
            newValue = e.target === self.hourElement ? newValue - max - !self.amPM : min;
        }

        if (self.amPM && e.target === self.hourElement && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) {
            self.amPM.textContent = self.amPM.innerHTML === 'PM' ? 'AM' : 'PM';
        }

        e.target.value = self.pad(newValue);
    }

    init();
    return self;
}

Flatpickr.defaultConfig = {

    mode: 'single',

    /* if true, dates will be parsed, formatted, and displayed in UTC.
    preloading date strings w/ timezones is recommended but not necessary */
    utc: false,

    // wrap: see https://chmln.github.io/flatpickr/#strap
    wrap: false,

    // enables week numbers
    weekNumbers: false,

    // allow manual datetime input
    allowInput: false,

    /*
    clicking on input opens the date(time)picker.
    disable if you wish to open the calendar manually with .open()
    */
    clickOpens: true,

    // display time picker in 24 hour mode
    time_24hr: false,

    // enables the time picker functionality
    enableTime: false,

    // noCalendar: true will hide the calendar. use for a time picker along w/ enableTime
    noCalendar: false,

    // more date format chars at https://chmln.github.io/flatpickr/#dateformat
    dateFormat: 'Y-m-d',

    // altInput - see https://chmln.github.io/flatpickr/#altinput
    altInput: false,

    // the created altInput element will have this class.
    altInputClass: 'flatpickr-input form-control input',

    // same as dateFormat, but for altInput
    altFormat: 'F j, Y', // defaults to e.g. June 10, 2016

    // defaultDate - either a datestring or a date object. used for datetimepicker"s initial value
    defaultDate: null,

    // the minimum date that user can pick (inclusive)
    minDate: null,

    // the maximum date that user can pick (inclusive)
    maxDate: null,

    // dateparser that transforms a given string to a date object
    parseDate: null,

    // dateformatter that transforms a given date object to a string, according to passed format
    formatDate: null,

    getWeek: function getWeek(givenDate) {
        var date = new Date(givenDate.getTime());
        date.setHours(0, 0, 0, 0);

        // Thursday in current week decides the year.
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        // January 4 is always in week 1.
        var week1 = new Date(date.getFullYear(), 0, 4);
        // Adjust to Thursday in week 1 and count number of weeks from date to week1.
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
    },

    // see https://chmln.github.io/flatpickr/#disable
    enable: [],

    // see https://chmln.github.io/flatpickr/#disable
    disable: [],

    // display the short version of month names - e.g. Sep instead of September
    shorthandCurrentMonth: false,

    // displays calendar inline. see https://chmln.github.io/flatpickr/#inline-calendar
    inline: false,

    // position calendar inside wrapper and next to the input element
    // leave at false unless you know what you"re doing
    static: false,

    // DOM node to append the calendar to in *static* mode
    appendTo: null,

    // code for previous/next icons. this is where you put your custom icon code e.g. fontawesome
    prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
    nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",

    // enables seconds in the time picker
    enableSeconds: false,

    // step size used when scrolling/incrementing the hour element
    hourIncrement: 1,

    // step size used when scrolling/incrementing the minute element
    minuteIncrement: 5,

    // initial value in the hour element
    defaultHour: 12,

    // initial value in the minute element
    defaultMinute: 0,

    // disable native mobile datetime input support
    disableMobile: false,

    // default locale
    locale: 'default',

    // onChange callback when user selects a date or time
    onChange: null, // function (dateObj, dateStr) {}

    // called every time calendar is opened
    onOpen: null, // function (dateObj, dateStr) {}

    // called every time calendar is closed
    onClose: null, // function (dateObj, dateStr) {}

    // called after calendar is ready
    onReady: null, // function (dateObj, dateStr) {}

    onValueUpdate: null,

    onDayCreate: null
};

Flatpickr.l10ns = {
    en: {
        weekdays: {
            shorthand: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            longhand: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
        },
        months: {
            shorthand: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            longhand: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
        },
        daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
        firstDayOfWeek: 0,
        ordinal: function ordinal(nth) {
            var s = nth % 100;
            if (s > 3 && s < 21) return 'th';
            switch (s % 10) {
                case 1:
                    return 'st';
                case 2:
                    return 'nd';
                case 3:
                    return 'rd';
                default:
                    return 'th';
            }
        },
        rangeSeparator: ' to ',
        weekAbbreviation: 'Wk',
        scrollTitle: 'Scroll to increment',
        toggleTitle: 'Click to toggle'
    }
};

Flatpickr.l10ns.default = Flatpickr.l10ns.en;

Flatpickr.localize = function (l10n) {
    return Object.assign(Flatpickr.l10ns.default, l10n || {});
};

Flatpickr.prototype = {
    pad: function pad(number) {
        return ('0' + number).slice(-2);
    }
};

function _flatpickr(nodeList, config) {
    var instances = [];
    for (var i = 0; i < nodeList.length; i++) {
        try {
            nodeList[i]._flatpickr = new Flatpickr(nodeList[i], config || {});
            instances.push(nodeList[i]._flatpickr);
        } catch (e) {
            console.warn(e, e.stack);
        }
    }

    return instances.length === 1 ? instances[0] : instances;
}
if (typeof HTMLElement !== 'undefined') {
    // browser env
    HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function (config) {
        return _flatpickr(this, config);
    };

    HTMLElement.prototype.flatpickr = function (config) {
        return _flatpickr([this], config);
    };
}

function flatpickr(selector, config) {
    return _flatpickr(document.querySelectorAll(selector), config);
}

if (typeof jQuery !== 'undefined') {
    jQuery.fn.flatpickr = function (config) {
        return _flatpickr(this, config);
    };
}

Date.prototype.fp_incr = function (days) {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate() + parseInt(days, 10));
};

Date.prototype.fp_isUTC = false;
Date.prototype.fp_toUTC = function () {
    var newDate = new Date(this.getUTCFullYear(), this.getUTCMonth(), this.getUTCDate(), this.getUTCHours(), this.getUTCMinutes(), this.getUTCSeconds());

    newDate.fp_isUTC = true;
    return newDate;
};

// IE9 classList polyfill
if (!('classList' in document.documentElement) && Object.defineProperty && typeof HTMLElement !== 'undefined') {
    Object.defineProperty(HTMLElement.prototype, 'classList', {
        get: function get() {
            var self = this;

            function update(fn) {
                return function (value) {
                    var classes = self.className.split(/\s+/),
                        index = classes.indexOf(value);

                    fn(classes, index, value);
                    self.className = classes.join(' ');
                };
            }

            var ret = {
                add: update(function (classes, index, value) {
                    if (!~index) {
                        classes.push(value);
                    }
                }),

                remove: update(function (classes, index) {
                    if (~index) {
                        classes.splice(index, 1);
                    }
                }),

                toggle: update(function (classes, index, value) {
                    if (~index) {
                        classes.splice(index, 1);
                    } else {
                        classes.push(value);
                    }
                }),

                contains: function contains(value) {
                    return Boolean(~self.className.split(/\s+/).indexOf(value));
                },

                item: function item(i) {
                    return self.className.split(/\s+/)[i] || null;
                }
            };

            Object.defineProperty(ret, 'length', {
                get: function get() {
                    return self.className.split(/\s+/).length;
                }
            });

            return ret;
        }
    });
}

if (true) {
    module.exports = Flatpickr;
}

/***/ }),
/* 556 */
/*!*************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-597efa4c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/datepicker/datepicker.vue ***!
  \*************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.message
    },
    on: {
      "change": _vm.inputting,
      "input": _vm.inputting
    }
  })
},staticRenderFns: []}

/***/ }),
/* 557 */
/*!***********************************************!*\
  !*** ./src/components/product/sortDialog.vue ***!
  \***********************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-4c95a419","scoped":true,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./sortDialog.vue */ 558)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./sortDialog.vue */ 559),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-4c95a419","hasScoped":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./sortDialog.vue */ 560),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4c95a419",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 558 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4c95a419","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/product/sortDialog.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 559 */
/*!******************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/product/sortDialog.vue ***!
  \******************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    data: function data() {
        return {
            innerShow: false
        };
    },

    props: {
        model: {
            type: Array,
            required: true
        },
        show: {
            require: true,
            'default': false
        }
    },
    computed: {},

    methods: {
        save: function save() {
            this.$emit('saveSort', this.model);
        },

        upIncludeItems: function upIncludeItems(index) {
            var temp = Object.assign(this.model[index], {});
            this.$set(this.model, index, Object.assign(this.model[index - 1], {}));
            this.$set(this.model, index - 1, Object.assign(temp, {}));
        },
        downIncludeItems: function downIncludeItems(index) {
            var temp = Object.assign(this.model[index], {});
            this.$set(this.model, index, Object.assign(this.model[index + 1], {}));
            this.$set(this.model, index + 1, Object.assign(temp, {}));
        }
    },
    watch: {
        show: function show() {
            this.innerShow = this.show;
        }
    },
    mounted: function mounted() {
        this.innerShow = this.show;
    }
};

/***/ }),
/* 560 */
/*!*********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c95a419","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/sortDialog.vue ***!
  \*********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.innerShow) ? _c('v-dialog', {
    attrs: {
      "title": "调整顺序",
      "size": "md",
      "show-close": true
    },
    model: {
      value: (_vm.innerShow),
      callback: function($$v) {
        _vm.innerShow = $$v
      },
      expression: "innerShow"
    }
  }, [_c('table', {
    staticClass: "table table-hover table-bordered"
  }, [_c('tbody', _vm._l((_vm.model), function(data, index) {
    return _c('tr', {
      key: index,
      staticStyle: {
        "cursor": "default !important"
      }
    }, [_c('td', [_vm._v("\n                " + _vm._s(data.levelName) + "\n            ")]), _vm._v(" "), _c('td', {
      staticClass: "row"
    }, [(index !== _vm.model.length - 1) ? _c('div', {
      staticClass: "col-sm-6",
      staticStyle: {
        "float": "right"
      }
    }, [_c('span', {
      staticClass: "icon-arrow-down control-icon click-able",
      on: {
        "click": function($event) {
          _vm.downIncludeItems(index)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (index !== 0) ? _c('div', {
      staticClass: "col-sm-6",
      staticStyle: {
        "float": "right"
      }
    }, [_c('span', {
      staticClass: "icon-arrow-up control-icon click-able",
      on: {
        "click": function($event) {
          _vm.upIncludeItems(index)
        }
      }
    })]) : _vm._e()])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v("保存")])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 561 */
/*!*******************************************!*\
  !*** ./src/components/product/refund.vue ***!
  \*******************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-699e3f8b","scoped":true,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./refund.vue */ 562)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./refund.vue */ 563),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-699e3f8b","hasScoped":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./refund.vue */ 567),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-699e3f8b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 562 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-699e3f8b","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/product/refund.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 563 */
/*!**************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/product/refund.vue ***!
  \**************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ 22);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(/*! babel-runtime/helpers/asyncToGenerator */ 23);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _index = __webpack_require__(/*! components/content-block/index.vue */ 76);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(/*! components/input-number-custom/index.vue */ 115);

var _index4 = _interopRequireDefault(_index3);

var _refundLimitTime = __webpack_require__(/*! components/product/refundLimitTime.vue */ 564);

var _refundLimitTime2 = _interopRequireDefault(_refundLimitTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        ContentBlock: _index2.default,
        CustomInputNumber: _index4.default,
        RefundLimitTime: _refundLimitTime2.default
    },
    data: function data() {
        return {
            hasNoRefund: false,
            bankInfo: '',
            contractsList: [],
            // 手续费类型
            refundFeeModeTypes: [{
                label: '无手续费',
                value: 1
            }, {
                label: '每张票需要手续费（元）',
                value: 2
            }, {
                label: '每笔订单需要手续费（元）',
                value: 3
            }, {
                label: '每笔订单销售价格百分比（%）',
                value: 4
            }],
            // 价格日历模式的时间限制类型
            priceTimeRestrictOpt: [{
                label: '无限制',
                value: 0
            }, {
                label: '游玩日期开始前',
                value: 1
            }, {
                label: '游玩日期截止前',
                value: 2
            }, {
                label: '游玩日期截止后',
                value: 3
            }],
            // 有效期模式的时间限制类型
            timeRestrictOpt: [{
                label: '无限制',
                value: 0
            }, {
                label: '有效期结束前',
                value: 2
            }, {
                label: '有效期结束后',
                value: 3
            }]
        };
    },

    props: {
        model: {
            type: Object,
            required: true
        },
        extra: {
            type: Object,
            required: true
        },
        mode: {
            type: String,
            required: true
        },
        isTuan: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        addStair: function addStair() {
            this.model.refundStairsRules.push({
                refundFeeMode: 2,
                refundFee: 0,
                refundFeeDump: 0,
                refundTimeType: 2,
                aheadDays: 1,
                hours: 0,
                minutes: 0,
                refundLimitMinutes: 0
            });
        },
        removeStair: function removeStair(index) {
            this.model.refundStairsRules.splice(index, 1);
        },
        changeStairRefundTime: function changeStairRefundTime(index) {
            var currentStair = this.model.refundStairsRules[index];
            if (currentStair.refundTimeType && currentStair.refundTimeType !== 0) {
                var minutes = currentStair.minutes;
                minutes = Number(minutes);
                var hours = currentStair.hours;
                hours = Number(hours);
                var day = currentStair.aheadDays;
                day = Number(day);
                switch (currentStair.refundTimeType) {
                    case 1:
                        minutes = day * 1440 - hours * 60 - minutes;
                        break;
                    case 2:
                        minutes = (day + 1) * 1440 - hours * 60 - minutes;
                        break;
                    case 3:
                        minutes = (day - 1) * 1440 + hours * 60 + minutes;
                        break;
                    default:
                        break;
                }
                currentStair.refundLimitMinutes = minutes;
            }
        },
        changeRefundFee: function changeRefundFee(index) {
            var that = this;
            setTimeout(function () {
                var currentStair = that.model.refundStairsRules[index];
                if (currentStair.refundFeeMode === 4) {
                    currentStair.refundFee = currentStair.refundFeeDump / 100;
                } else {
                    currentStair.refundFee = currentStair.refundFeeDump;
                }
            }, 0);
        },
        checkStairsRules: function checkStairsRules() {
            var isInit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            // 控制联动的当日不可退选项和退款规则检查
            var foundError = false;
            // 不是剧场票
            if (!this.model.IAmTheatre && this.model.useDateMode == 1 && this.extra.isDirectDeal && parseInt(this.model.refundType, 10) === 4) {
                var rules = this.model.refundStairsRules;
                // 对历史老数据处理
                if (rules.length === 1 && this.model.refundLimitDays !== null && isInit) {
                    this.$set(rules[0], 'aheadDays', this.model.refundLimitDays);
                    this.$set(rules[0], 'hours', this.model.refundLimitHours);
                    this.$set(rules[0], 'minutes', this.model.refundLimitMinutes);
                }
                this.hasNoRefund = false;
                for (var i = 0; i < rules.length; i++) {
                    if (rules[i].refundTimeType === 3) {
                        this.hasNoRefund = true;
                    }
                    // 处理最小天数数据
                    if (rules[i].refundTimeType === 1 || rules[i].refundTimeType === 3) {
                        if (rules[i].aheadDays === 0) {
                            rules[i].aheadDays = 1;
                        }
                    }
                    // 处理时间
                    this.changeStairRefundTime(i);

                    // 寻找是否有数据不统一的情况
                    if (!foundError && i !== rules.length - 1) {
                        for (var j = i + 1; j < rules.length; j++) {
                            if (rules[i].refundType === rules[j].refundType && rules[i].aheadDays === rules[j].aheadDays && rules[i].minutes === rules[j].minutes && rules[i].hours === rules[j].hours && rules[i].refundFeeMode !== rules[j].refundFeeMode) {
                                foundError = true;
                                break;
                            }
                        }
                    }
                }
                if (!this.hasNoRefund) {
                    this.model.oPCanRefundCurrentDate = false;
                    this.refundCurrent();
                }
            }
            // 处理error
            if (foundError) {
                this.validateErrors.add('tab3', {
                    key: 0,
                    modelName: 'model.refundStairsRules',
                    showError: true,
                    rule: 'required'
                });
            } else {
                this.validateErrors.removeAll('tab3', 'model.refundStairsRules');
            }
        },

        // 用于清空数据
        clearRefundStairsRules: function clearRefundStairsRules() {
            this.model.refundStairsRules = [{
                refundFeeMode: 2,
                refundFee: 0,
                refundFeeDump: 0,
                refundTimeType: 2,
                aheadDays: 1,
                hours: 0,
                minutes: 0,
                refundLimitMinutes: 0
            }];
        },
        refundCurrent: function refundCurrent() {
            this.model.canRefundCurrentDate = !this.model.oPCanRefundCurrentDate;
        }
    },
    watch: {
        'model.refundType': function modelRefundType() {
            // 退款方式改变，清空阶梯退款数据
            this.clearRefundStairsRules();
            // 当选择不可退款，清空限制每日
            if (parseInt(this.model.refundType) === 3) {
                this.model.hasRefundLimitTime = false;
            }
        },
        'model.useDateMode': function modelUseDateMode() {
            this.clearRefundStairsRules();
        },
        'model.useDateDays': function modelUseDateDays() {
            // 当days>2时，不能选useDateDays
            if (parseInt(this.model.useDateDays, 10) > 2) {
                this.model.oPCanRefundCurrentDate = false;
                this.refundCurrent();
            }
        },
        'model.refundStairsRules': {
            handler: function handler() {
                this.checkStairsRules();
            },
            deep: true
        },
        'model.ticketPriceType': function modelTicketPriceType() {
            // 剧场票的时候清洗部分可退数据
            if (parseInt(this.model.ticketPriceType, 10) === 1) {
                this.model.partlyRefund = false;
            } else {
                this.model.partlyRefund = true;
            }
        }
    },
    mounted: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, rule;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            // 对老数据处理
                            this.checkStairsRules(true);
                            // 直连单子，碰到急速退，统一改成随时退
                            if (parseInt(this.model.refundType, 10) === 2 && this.extra.isDirectDeal) {
                                this.model.refundType = 1;
                            }

                            this.model.oPCanRefundCurrentDate = !this.model.canRefundCurrentDate;

                            // 初始化阶梯退款数据

                            if (!(this.model.refundStairsRules && this.model.refundStairsRules.length > 0)) {
                                _context.next = 23;
                                break;
                            }

                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context.prev = 7;

                            for (_iterator = this.model.refundStairsRules[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                rule = _step.value;

                                if (rule.refundFeeMode === 4) {
                                    rule.refundFeeDump = rule.refundFee * 100;
                                } else {
                                    rule.refundFeeDump = rule.refundFee;
                                }
                            }
                            _context.next = 15;
                            break;

                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context['catch'](7);
                            _didIteratorError = true;
                            _iteratorError = _context.t0;

                        case 15:
                            _context.prev = 15;
                            _context.prev = 16;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }

                        case 18:
                            _context.prev = 18;

                            if (!_didIteratorError) {
                                _context.next = 21;
                                break;
                            }

                            throw _iteratorError;

                        case 21:
                            return _context.finish(18);

                        case 22:
                            return _context.finish(15);

                        case 23:
                            // 剧场票清洗数据，强制不可以部分退款
                            if (this.model.IAmTheatre) {
                                this.model.partlyRefund = false;
                            }
                            console.log(this.model.refundType);

                        case 25:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[7, 11, 15, 23], [16,, 18, 22]]);
        }));

        function mounted() {
            return _ref.apply(this, arguments);
        }

        return mounted;
    }()
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 564 */
/*!****************************************************!*\
  !*** ./src/components/product/refundLimitTime.vue ***!
  \****************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./refundLimitTime.vue */ 565),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-a1afbfe6","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./refundLimitTime.vue */ 566),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 565 */
/*!***********************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/product/refundLimitTime.vue ***!
  \***********************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    props: {
        model: {
            type: Object,
            required: true
        }
    },
    methods: {
        checkRefundLimitTime: function checkRefundLimitTime() {
            var hasErrors = false;
            if (this.model.hasRefundLimitTime) {
                if (this.model.refundLimitHourFrom > this.model.refundLimitHourTo) {
                    hasErrors = true;
                } else if (this.model.refundLimitHourFrom === this.model.refundLimitHourTo && this.model.refundLimitMinuteFrom >= this.model.refundLimitMinuteTo) {
                    hasErrors = true;
                }
            }
            if (hasErrors) {
                this.validateErrors.add('tab3', {
                    key: 0,
                    modelName: 'model.refundLimitTime',
                    showError: true,
                    rule: 'required'
                });
            } else {
                this.validateErrors.removeAll('tab3', 'model.refundLimitTime');
            }
        }
    },
    watch: {
        'model.refundLimitHourFrom': 'checkRefundLimitTime',
        'model.refundLimitMinuteFrom': 'checkRefundLimitTime',
        'model.refundLimitHourTo': 'checkRefundLimitTime',
        'model.refundLimitMinuteTo': 'checkRefundLimitTime',
        'model.hasRefundLimitTime': 'checkRefundLimitTime'
    }
};

/***/ }),
/* 566 */
/*!***************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1afbfe6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/refundLimitTime.vue ***!
  \***************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-pdl",
    style: ({
      color: _vm.model.hasRefundLimitTime ? 'inherit' : '#999'
    })
  }, [_c('label', {
    attrs: {
      "for": "refundLimitTime"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.hasRefundLimitTime),
      expression: "model.hasRefundLimitTime"
    }],
    attrs: {
      "id": "refundLimitTime",
      "type": "checkbox",
      "name": "refundLimitTime"
    },
    domProps: {
      "value": true,
      "checked": Array.isArray(_vm.model.hasRefundLimitTime) ? _vm._i(_vm.model.hasRefundLimitTime, true) > -1 : (_vm.model.hasRefundLimitTime)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.model.hasRefundLimitTime,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = true,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.hasRefundLimitTime = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.hasRefundLimitTime = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.hasRefundLimitTime = $$c
        }
      }
    }
  }), _vm._v("\n        限制每日\n    ")]), _vm._v(" "), _c('v-select', {
    staticClass: "nano-select inline-input",
    attrs: {
      "disabled": !_vm.model.hasRefundLimitTime,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.refundLimitHourFrom),
      callback: function($$v) {
        _vm.model.refundLimitHourFrom = $$v
      },
      expression: "model.refundLimitHourFrom"
    }
  }, _vm._l((24), function(n) {
    return _c('v-option', {
      key: n,
      attrs: {
        "label": n - 1,
        "value": n - 1
      }
    })
  })), _vm._v("\n    点\n    "), _c('v-select', {
    staticClass: "nano-select inline-input",
    attrs: {
      "disabled": !_vm.model.hasRefundLimitTime,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.refundLimitMinuteFrom),
      callback: function($$v) {
        _vm.model.refundLimitMinuteFrom = $$v
      },
      expression: "model.refundLimitMinuteFrom"
    }
  }, _vm._l((60), function(n) {
    return _c('v-option', {
      key: n,
      attrs: {
        "label": n - 1 < 10 ? '0' + (n - 1).toString() : n - 1,
        "value": n - 1
      }
    })
  })), _vm._v("\n    至\n    "), _c('v-select', {
    staticClass: "nano-select inline-input",
    attrs: {
      "disabled": !_vm.model.hasRefundLimitTime,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.refundLimitHourTo),
      callback: function($$v) {
        _vm.model.refundLimitHourTo = $$v
      },
      expression: "model.refundLimitHourTo"
    }
  }, _vm._l((24), function(n) {
    return _c('v-option', {
      key: n,
      attrs: {
        "label": n - 1,
        "value": n - 1
      }
    })
  })), _vm._v("\n    点\n    "), _c('v-select', {
    staticClass: "nano-select inline-input",
    attrs: {
      "disabled": !_vm.model.hasRefundLimitTime,
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.refundLimitMinuteTo),
      callback: function($$v) {
        _vm.model.refundLimitMinuteTo = $$v
      },
      expression: "model.refundLimitMinuteTo"
    }
  }, _vm._l((60), function(n) {
    return _c('v-option', {
      key: n,
      attrs: {
        "label": n - 1 < 10 ? '0' + (n - 1).toString() : n - 1,
        "value": n - 1
      }
    })
  })), _vm._v("可退\n    "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab3', 'model.refundLimitTime')),
      expression: "validateErrors.has('tab3', 'model.refundLimitTime')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("结束时间不能小于开始时间")])], 1)
},staticRenderFns: []}

/***/ }),
/* 567 */
/*!*****************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-699e3f8b","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/refund.vue ***!
  \*****************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [(_vm.extra.isDirectDeal) ? _c('div', {
    staticClass: "legend"
  }, [_vm._v("退款规则  "), _c('span', {
    staticClass: "tip icon-info"
  }, [_vm._v("重要提示：“随时退、有条件退”需要商家在三个工作日内确认，否则系统将默认同意退款，自动确认并退给用户")])]) : _c('div', {
    staticClass: "legend"
  }, [_vm._v("退款规则  "), _c('span', {
    staticClass: "tip icon-info"
  }, [_vm._v("重要提示：“随时退、有条件退”需要商家在24小时内确认，否则系统将默认同意退款，自动确认并退给用户")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), (_vm.model.generateTicketMethod == 2 && !_vm.extra.isDirectDeal && !_vm.isTuan) ? _c('div', {
    staticClass: "col-sm-8"
  }, [_vm._m(1)]) : _c('div', {
    staticClass: "col-sm-9"
  }, [(!_vm.extra.isDirectDeal && !_vm.extra.isDirect) ? _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.refundType),
      expression: "model.refundType"
    }],
    attrs: {
      "type": "radio",
      "required": "",
      "name": "refundType",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.model.refundType, "2")
    },
    on: {
      "__c": function($event) {
        _vm.model.refundType = "2"
      }
    }
  }), _vm._v("\n                    极速退\n                ")]), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.model.IAmTheatre),
      expression: "!model.IAmTheatre"
    }],
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.refundType),
      expression: "model.refundType"
    }],
    attrs: {
      "type": "radio",
      "required": "",
      "name": "refundType",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.model.refundType, "1")
    },
    on: {
      "__c": function($event) {
        _vm.model.refundType = "1"
      }
    }
  }), _vm._v("\n                    随时退\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "annotate"
  }, [_vm._v("未消费订单，无论是否过期，订单可多次退款，随时可退，无退款手续费。")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.refundType == 1 && _vm.extra.isDirectDeal),
      expression: "model.refundType==1 && extra.isDirectDeal"
    }],
    staticClass: "radio bd pd10"
  }, [_c('div', [_c('refund-limit-time', {
    attrs: {
      "model": _vm.model
    }
  }), _vm._v(" "), (_vm.model.useDateMode == 1) ? _c('div', {
    staticClass: "no-pdl",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('label', {
    style: ({
      color: _vm.model.canRefundCurrentDate ? '#999' : '#1f2d3d'
    }),
    attrs: {
      "for": "oPCanRefundCurrentDate"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.oPCanRefundCurrentDate),
      expression: "model.oPCanRefundCurrentDate"
    }],
    attrs: {
      "id": "oPCanRefundCurrentDate",
      "type": "checkbox",
      "disabled": _vm.model.useDateDays > 2,
      "name": "oPCanRefundCurrentDate"
    },
    domProps: {
      "value": true,
      "checked": Array.isArray(_vm.model.oPCanRefundCurrentDate) ? _vm._i(_vm.model.oPCanRefundCurrentDate, true) > -1 : (_vm.model.oPCanRefundCurrentDate)
    },
    on: {
      "change": _vm.refundCurrent,
      "__c": function($event) {
        var $$a = _vm.model.oPCanRefundCurrentDate,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = true,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.oPCanRefundCurrentDate = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.oPCanRefundCurrentDate = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.oPCanRefundCurrentDate = $$c
        }
      }
    }
  }), _vm._v("\n                            游玩当日不可申请退款\n                        ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.useDateDays > 2),
      expression: "model.useDateDays > 2"
    }],
    staticClass: "red",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("有效期设置请小于3天内有效")])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.refundType),
      expression: "model.refundType"
    }],
    attrs: {
      "type": "radio",
      "required": "",
      "name": "refundType",
      "value": "4"
    },
    domProps: {
      "checked": _vm._q(_vm.model.refundType, "4")
    },
    on: {
      "__c": function($event) {
        _vm.model.refundType = "4"
      }
    }
  }), _vm._v("\n                    有条件退\n                ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.refundType == 4 && !_vm.model.IAmTheatre),
      expression: "model.refundType==4 && !model.IAmTheatre"
    }],
    staticClass: "red",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("若选择极速退、随时退，订单量可增加约15%")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.refundType == 4),
      expression: "model.refundType==4"
    }],
    staticClass: "radio bd pd10"
  }, [_c('div', [(_vm.model.useDateMode == 1 && _vm.extra.isDirectDeal && !_vm.model.IAmTheatre) ? _c('div', {
    staticStyle: {
      "padding-left": "5px"
    },
    attrs: {
      "id": "stairsRefund"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._l((_vm.model.refundStairsRules), function(stair, index) {
    return _c('div', {
      staticClass: "row",
      staticStyle: {
        "padding-left": "10px"
      }
    }, [_c('v-select', {
      staticClass: "col-sm-3",
      staticStyle: {
        "margin-bottom": "15px",
        "max-width": "180px"
      },
      attrs: {
        "clearable": false,
        "size": "md",
        "placeholder": "请选择"
      },
      model: {
        value: (stair.refundTimeType),
        callback: function($$v) {
          stair.refundTimeType = $$v
        },
        expression: "stair.refundTimeType"
      }
    }, _vm._l((_vm.priceTimeRestrictOpt), function(item) {
      return (!(_vm.model.refundStairsRules.length > 1 && item.value == 0)) ? _c('v-option', {
        key: item.value,
        attrs: {
          "label": item.label,
          "value": item.value
        }
      }) : _vm._e()
    })), _vm._v(" "), _c('div', {
      staticClass: "inline-block col-sm-9 no-pdl",
      staticStyle: {
        "overflow": "visible"
      }
    }, [(stair.refundTimeType != 0) ? _c('div', {
      staticClass: "pull-left inline-block",
      staticStyle: {
        "margin-left": "4px"
      }
    }, [_c('custom-input-number', {
      staticClass: "form-control inline-block input-w-3",
      attrs: {
        "step": 1,
        "min": stair.refundTimeType == 3 || stair.refundTimeType == 1 ? 1 : 0,
        "max": 1000,
        "isInt": true
      },
      model: {
        value: (stair.aheadDays),
        callback: function($$v) {
          stair.aheadDays = $$v
        },
        expression: "stair.aheadDays"
      }
    }), _vm._v("\n                                         天\n                                        "), _c('custom-input-number', {
      staticClass: "form-control inline-block input-w-3",
      attrs: {
        "min": 0,
        "max": 23,
        "isInt": true
      },
      model: {
        value: (stair.hours),
        callback: function($$v) {
          stair.hours = $$v
        },
        expression: "stair.hours"
      }
    }), _vm._v("\n                                         点\n                                        "), _c('custom-input-number', {
      staticClass: "form-control inline-block input-w-3",
      attrs: {
        "min": 0,
        "max": 59,
        "isInt": true
      },
      model: {
        value: (stair.minutes),
        callback: function($$v) {
          stair.minutes = $$v
        },
        expression: "stair.minutes"
      }
    }), _vm._v("\n                                         分前可退\n                                    ")], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: " form-group",
      staticStyle: {
        "white-space": "nowrap"
      }
    }, [_c('div', {
      staticClass: "inline-block col-sm-4 no-pdl"
    }, [_c('v-select', {
      attrs: {
        "clearable": false,
        "size": "md",
        "placeholder": "请选择"
      },
      on: {
        "change": function($event) {
          _vm.changeRefundFee(index)
        }
      },
      model: {
        value: (stair.refundFeeMode),
        callback: function($$v) {
          stair.refundFeeMode = $$v
        },
        expression: "stair.refundFeeMode"
      }
    }, _vm._l((_vm.refundFeeModeTypes), function(item) {
      return _c('v-option', {
        key: item.value,
        attrs: {
          "label": item.label,
          "value": item.value
        }
      })
    }))], 1), _vm._v(" "), _c('div', {
      staticClass: "inline-block no-pdl",
      staticStyle: {
        "min-width": "70px"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (stair.refundFeeMode != 1),
        expression: "stair.refundFeeMode != 1"
      }],
      staticClass: "inline-block"
    }, [_c('div', {
      staticClass: "pull-left inline-block",
      staticStyle: {
        "margin-left": "4px"
      }
    }, [_c('custom-input-number', {
      staticClass: "form-control inline-block input-w-3",
      attrs: {
        "min": 0,
        "isInt": stair.refundFeeMode == 4
      },
      on: {
        "change": function($event) {
          _vm.changeRefundFee(index)
        }
      },
      model: {
        value: (stair.refundFeeDump),
        callback: function($$v) {
          stair.refundFeeDump = $$v
        },
        expression: "stair.refundFeeDump"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "inline-block no-pdl"
    }, [(index == 0 && stair.refundTimeType != 0) ? _c('v-button', {
      staticClass: "btn btn-link",
      on: {
        "click": function($event) {
          _vm.addStair()
        }
      }
    }, [_c('i', {
      staticClass: "icon-button icon-plus"
    })]) : (index != 0) ? _c('v-button', {
      staticClass: "btn btn-link",
      on: {
        "click": function($event) {
          _vm.removeStair(index)
        }
      }
    }, [_c('i', {
      staticClass: "icon-button delete icon-cancel",
      staticStyle: {
        "margin-left": "0"
      }
    })]) : _vm._e()], 1)])])], 1)
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validateErrors.has('tab3', 'model.refundStairsRules')),
      expression: "validateErrors.has('tab3', 'model.refundStairsRules')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("退款规则设置不一致")])], 2)]) : _c('div', {
    attrs: {
      "id": "normalRefund"
    }
  }, [_c('div', {
    staticClass: "no-pdl"
  }, [_c('label', {
    staticClass: "control-label col-sm-2"
  }, [_vm._v("时间限制")]), _vm._v(" "), _c('div', {
    staticClass: "inline-block col-sm-10 form-group"
  }, [_c('div', {
    staticClass: "inline-block col-sm-4"
  }, [(_vm.model.useDateMode == 0) ? _c('v-select', {
    attrs: {
      "clearable": false,
      "size": "md",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.refundTimeType),
      callback: function($$v) {
        _vm.model.refundTimeType = $$v
      },
      expression: "model.refundTimeType"
    }
  }, _vm._l((_vm.timeRestrictOpt), function(item) {
    return _c('v-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.model.useDateMode != 0) ? _c('v-select', {
    attrs: {
      "clearable": false,
      "size": "md",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.refundTimeType),
      callback: function($$v) {
        _vm.model.refundTimeType = $$v
      },
      expression: "model.refundTimeType"
    }
  }, _vm._l((_vm.priceTimeRestrictOpt), function(item) {
    return _c('v-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })) : _vm._e()], 1), _vm._v(" "), (_vm.model.refundTimeType != 0) ? _c('div', {
    staticClass: "inline-block col-sm-8"
  }, [_c('div', {
    staticClass: "pull-left inline-block",
    staticStyle: {
      "margin-left": "4px"
    }
  }, [_c('custom-input-number', {
    staticClass: "form-control inline-block input-w-3",
    attrs: {
      "step": 1,
      "min": 0,
      "max": 1000,
      "isInt": true
    },
    model: {
      value: (_vm.model.refundLimitDays),
      callback: function($$v) {
        _vm.model.refundLimitDays = $$v
      },
      expression: "model.refundLimitDays"
    }
  }), _vm._v("\n                                         天\n                                        "), _c('custom-input-number', {
    staticClass: "form-control inline-block input-w-3",
    attrs: {
      "min": 0,
      "max": 23,
      "isInt": true
    },
    model: {
      value: (_vm.model.refundLimitHours),
      callback: function($$v) {
        _vm.model.refundLimitHours = $$v
      },
      expression: "model.refundLimitHours"
    }
  }), _vm._v("\n                                         点\n                                        "), _c('custom-input-number', {
    staticClass: "form-control inline-block input-w-3",
    attrs: {
      "min": 0,
      "max": 59,
      "isInt": true
    },
    model: {
      value: (_vm.model.refundLimitMinutes),
      callback: function($$v) {
        _vm.model.refundLimitMinutes = $$v
      },
      expression: "model.refundLimitMinutes"
    }
  }), _vm._v("\n                                         分\n                                    ")], 1)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "no-pdl "
  }, [_c('label', {
    staticClass: "control-label col-sm-2"
  }, [_vm._v("手续费")]), _vm._v(" "), _c('div', {
    staticClass: "inline-block col-sm-10 form-group"
  }, [_c('div', {
    staticClass: "inline-block col-sm-4"
  }, [_c('v-select', {
    attrs: {
      "clearable": false,
      "size": "md",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.refundFeeMode),
      callback: function($$v) {
        _vm.model.refundFeeMode = $$v
      },
      expression: "model.refundFeeMode"
    }
  }, _vm._l((_vm.refundFeeModeTypes), function(item) {
    return (item.value != 4) ? _c('v-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    }) : _vm._e()
  }))], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.refundFeeMode != 1),
      expression: "model.refundFeeMode != 1"
    }],
    staticClass: "inline-block col-sm-8"
  }, [_c('div', {
    staticClass: "pull-left inline-block",
    staticStyle: {
      "margin-left": "4px"
    }
  }, [_c('custom-input-number', {
    staticClass: "form-control inline-block input-w-3",
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.model.refundFee),
      callback: function($$v) {
        _vm.model.refundFee = $$v
      },
      expression: "model.refundFee"
    }
  })], 1)])])])]), _vm._v(" "), (_vm.extra.isDirectDeal && !_vm.model.IAmTheatre) ? _c('div', {
    staticClass: "no-pdl",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('refund-limit-time', {
    style: ({
      'padding-left': _vm.model.useDateMode != 1 ? '8%' : '15px'
    }),
    attrs: {
      "model": _vm.model
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.model.useDateMode == 1 && this.hasNoRefund) ? _c('div', {
    staticClass: "no-pdl",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('label', {
    style: ({
      color: _vm.model.canRefundCurrentDate ? '#999' : '#1f2d3d'
    }),
    attrs: {
      "for": "oPCanRefundCurrentDate"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.oPCanRefundCurrentDate),
      expression: "model.oPCanRefundCurrentDate"
    }],
    attrs: {
      "id": "oPCanRefundCurrentDate",
      "type": "checkbox",
      "disabled": _vm.model.useDateDays > 2,
      "name": "oPCanRefundCurrentDate"
    },
    domProps: {
      "value": true,
      "checked": Array.isArray(_vm.model.oPCanRefundCurrentDate) ? _vm._i(_vm.model.oPCanRefundCurrentDate, true) > -1 : (_vm.model.oPCanRefundCurrentDate)
    },
    on: {
      "change": _vm.refundCurrent,
      "__c": function($event) {
        var $$a = _vm.model.oPCanRefundCurrentDate,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = true,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model.oPCanRefundCurrentDate = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.model.oPCanRefundCurrentDate = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model.oPCanRefundCurrentDate = $$c
        }
      }
    }
  }), _vm._v("\n                            游玩当日不可申请退款\n                        ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.useDateDays > 2),
      expression: "model.useDateDays > 2"
    }],
    staticClass: "red",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("有效期设置请小于3天内有效")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "no-pdl"
  }, [_c('label', {
    staticClass: "col-sm-2",
    class: {
      'control-label': !_vm.extra.isDirectDeal || _vm.model.useDateMode != 1
    },
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_vm._v("是否部分退款")]), _vm._v(" "), (!_vm.model.IAmTheatre) ? _c('div', {
    staticClass: "radio-inline"
  }, [_c('label', {
    attrs: {
      "for": "BatchRefund"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.partlyRefund),
      expression: "model.partlyRefund"
    }],
    attrs: {
      "id": "BatchRefund",
      "type": "radio",
      "value": "true",
      "name": "partlyRefund"
    },
    domProps: {
      "checked": _vm._q(_vm.model.partlyRefund, "true")
    },
    on: {
      "__c": function($event) {
        _vm.model.partlyRefund = "true"
      }
    }
  }), _vm._v("\n                                可分批退款")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "radio-inline"
  }, [_c('label', {
    attrs: {
      "for": "OnceCompletedRefund"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.partlyRefund),
      expression: "model.partlyRefund"
    }],
    attrs: {
      "id": "OnceCompletedRefund",
      "type": "radio",
      "value": "false",
      "name": "partlyRefund"
    },
    domProps: {
      "checked": _vm._q(_vm.model.partlyRefund, "false")
    },
    on: {
      "__c": function($event) {
        _vm.model.partlyRefund = "false"
      }
    }
  }), _vm._v("\n                                不可，只能一次退完")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.refundType),
      expression: "model.refundType"
    }],
    attrs: {
      "type": "radio",
      "required": "",
      "name": "refundType",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.model.refundType, "3")
    },
    on: {
      "__c": function($event) {
        _vm.model.refundType = "3"
      }
    }
  }), _vm._v("\n                    不可退款\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "annotate"
  }, [_vm._v("一经购买，不可退款。不可退可能造成商品曝光或销量的不良影响，请慎重勾选该项。")])])])]), _vm._v(" "), (_vm.extra.isDirectDeal) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label label-required col-lg-2 col-sm-3"
  }, [_vm._v("退款补充说明")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('v-input', {
    staticClass: "custom-textarea",
    attrs: {
      "type": "textarea",
      "rows": 5,
      "maxlength": 300,
      "placeholder": "选填，如果上述没有包含商家需要说明的退款条件或者流程，可以在这个地方填写。如果直接使用美团平台的退款流程，不需要填写本栏"
    },
    model: {
      value: (_vm.model.refundNote),
      callback: function($$v) {
        _vm.model.refundNote = $$v
      },
      expression: "model.refundNote"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "help-block textarea-counter",
    class: {
      'textarea-counter-red': _vm.model.refundNote.length > 300 ? true : false
    }
  }, [_vm._v(_vm._s(_vm.model.refundNote.length) + "/300字")])], 1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label label-required col-lg-2 col-sm-3"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("退款设置")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio"
  }, [_c('label', [_vm._v("\n                    极速退\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "inline-block annotate"
  }, [_vm._v("待出票的订单，用户申请退款，"), _c('span', {
    staticClass: "black"
  }, [_vm._v("不经过商家确认")]), _vm._v("，系统自动立即退款给用户")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "inline-block annotate"
  }, [_vm._v("未消费订单，无论是否过期，订单可多次退款，"), _c('span', {
    staticClass: "black"
  }, [_vm._v("无需商家确认立即退款")]), _vm._v("，选择本项的商家请验票后再入园，以防损失")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label-required",
    staticStyle: {
      "padding-bottom": "10px"
    }
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("退款时间和手续费设置")])
}]}

/***/ }),
/* 568 */
/*!************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cac3229","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ticket/product/item/Price.vue ***!
  \************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (Object.keys(_vm.model).length) ? _c('v-form', {
    staticClass: "form form-horizontal with-divider",
    attrs: {
      "id": "priceStockForm"
    }
  }, [_c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.extra.isBD && _vm.extra.isDirectDeal && _vm.model.theatreWhiteList),
      expression: "extra.isBD && extra.isDirectDeal && model.theatreWhiteList"
    }],
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [_c('div', {
    staticClass: "legend"
  }, [_vm._v("产品类型设置")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label label-required col-lg-2 col-sm-3"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("产品类型设置")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 pdt9"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.ticketPriceType),
      expression: "model.ticketPriceType"
    }],
    attrs: {
      "type": "radio",
      "disabled": !_vm.extra.isNew,
      "name": "ticketPriceType",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.model.ticketPriceType, "0")
    },
    on: {
      "__c": function($event) {
        _vm.model.ticketPriceType = "0"
      }
    }
  }), _vm._v("\n                    门票")]), _vm._v(" "), _c('label', {
    staticClass: "mgr10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.ticketPriceType),
      expression: "model.ticketPriceType"
    }],
    attrs: {
      "disabled": !_vm.extra.isNew,
      "type": "radio",
      "name": "ticketPriceType",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.model.ticketPriceType, "1")
    },
    on: {
      "__c": function($event) {
        _vm.model.ticketPriceType = "1"
      }
    }
  }), _vm._v("\n                    演出票")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.ticketPriceType == 1),
      expression: "model.ticketPriceType==1"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label label-required col-lg-2 col-sm-3"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("是否支持在线选座")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 pdt9"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.canSeatSelection),
      expression: "model.canSeatSelection"
    }],
    attrs: {
      "type": "radio",
      "name": "canSeatSelection",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.model.canSeatSelection, "true")
    },
    on: {
      "__c": function($event) {
        _vm.model.canSeatSelection = "true"
      }
    }
  }), _vm._v("\n                    支持")]), _vm._v(" "), _c('label', {
    staticClass: "mgr10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.canSeatSelection),
      expression: "model.canSeatSelection"
    }],
    attrs: {
      "type": "radio",
      "name": "canSeatSelection",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.model.canSeatSelection, "false")
    },
    on: {
      "__c": function($event) {
        _vm.model.canSeatSelection = "false"
      }
    }
  }), _vm._v("\n                    不支持")])])])]), _vm._v(" "), _c('fieldset', {
    class: {
      'tuan-field': _vm.isTuan
    },
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [(_vm.extra.isDirectDeal) ? _c('div', {
    staticClass: "legend"
  }, [_vm._v("有效期设置  "), _c('span', {
    staticClass: "tip icon-info"
  }, [_vm._v("重要提示：有效期模式一经设置不能修改，请在上单前与商家确认")])]) : _c('div', {
    staticClass: "legend"
  }, [_vm._v("有效期设置  "), _c('span', {
    staticClass: "tip icon-info"
  }, [_vm._v("重要提示：有效期模式设置后不能修改")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label label-required col-lg-2 col-sm-3"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v(_vm._s(_vm.model.IAmTheatre ? '有效期设置' : '日期设置'))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-lg-8"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.model.IAmTheatre),
      expression: "!model.IAmTheatre"
    }],
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.useDateMode),
      expression: "model.useDateMode"
    }],
    attrs: {
      "type": "radio",
      "value": "0",
      "disabled": _vm.mode == 'edit',
      "name": "dateMode"
    },
    domProps: {
      "checked": _vm._q(_vm.model.useDateMode, "0")
    },
    on: {
      "change": _vm.dateModeChange,
      "__c": function($event) {
        _vm.model.useDateMode = "0"
      }
    }
  }), _vm._v("有效期模式，无需用户指定使用日期\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.useDateMode),
      expression: "model.useDateMode"
    }],
    attrs: {
      "type": "radio",
      "value": "1",
      "disabled": _vm.mode == 'edit',
      "name": "dateMode"
    },
    domProps: {
      "checked": _vm._q(_vm.model.useDateMode, "1")
    },
    on: {
      "change": _vm.dateModeChange,
      "__c": function($event) {
        _vm.model.useDateMode = "1"
      }
    }
  }), _vm._v("\n                        使用日期模式，需要用户指定使用日期，自所选日期起\n                        "), _c('span', {
    staticClass: "inline-block input-w-3 relative"
  }, [_c('custom-input-number', {
    staticStyle: {
      "position": "absolute",
      "top": "-26px"
    },
    attrs: {
      "min": 1,
      "step": 1,
      "disabled": _vm.model.useDateMode == 0
    },
    model: {
      value: (_vm.model.useDateDays),
      callback: function($$v) {
        _vm.model.useDateDays = $$v
      },
      expression: "model.useDateDays"
    }
  })], 1), _vm._v("\n                        天内可使用\n                    ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.useDateMode == 1 && !_vm.model.IAmTheatre),
      expression: "model.useDateMode==1 && !model.IAmTheatre"
    }],
    staticClass: "inline-block annotate"
  }, [_vm._v("与无需指定日期相比，订单量约减少20%")])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needValidation && _vm.model.useDateMode == 1 && !_vm.model.useDateDays),
      expression: "needValidation && model.useDateMode == 1 && !model.useDateDays"
    }],
    staticClass: "warning-msg"
  }, [_vm._v("\n                    请填写几日内可使用")])])]), _vm._v(" "), (_vm.model.useDateMode == 0 && !_vm.model.IAmTheatre) ? _c('div', [_c('div', {
    staticClass: "form-group",
    attrs: {
      "fieldset-validator": "'checkGroup'"
    }
  }, [_c('label', {
    staticClass: "control-label label-require col-lg-2 col-sm-3"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("有效期时间段")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 input-w-4"
  }, [_c('v-datepicker', {
    attrs: {
      "message": _vm.voucherDateBeginEnd,
      "options": _vm.inDateOption
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needValidation && _vm.model.useDateMode == 0 && !_vm.model.voucherDateBegin),
      expression: "needValidation && model.useDateMode == 0 && !model.voucherDateBegin"
    }],
    staticClass: "warning-msg"
  }, [_vm._v("请选择有效期时间段")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "ng-class": "{'has-warning': (validWeekRuleForm.$invalid) && $ctrl.needValidation}"
    }
  }, [_c('label', {
    staticClass: "control-label label-require col-lg-2 col-sm-3"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("可用日期")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "checkbox-group pdt9"
  }, [_vm._l((_vm.weeks), function(i) {
    return _c('label', {
      key: i.val
    }, [(_vm.model.validWeekRule) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.model.validWeekRule[i.val]),
        expression: "model.validWeekRule[i.val]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "true"
      },
      domProps: {
        "checked": Array.isArray(_vm.model.validWeekRule[i.val]) ? _vm._i(_vm.model.validWeekRule[i.val], "true") > -1 : (_vm.model.validWeekRule[i.val])
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.model.validWeekRule[i.val],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "true",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.model.validWeekRule[i.val] = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.model.validWeekRule[i.val] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.model.validWeekRule, i.val, $$c)
          }
        }
      }
    }) : _vm._e(), _vm._v(_vm._s(i.text))])
  }), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.validWeekCheckedAll),
      expression: "validWeekCheckedAll"
    }],
    attrs: {
      "type": "checkbox",
      "value": "true"
    },
    domProps: {
      "checked": Array.isArray(_vm.validWeekCheckedAll) ? _vm._i(_vm.validWeekCheckedAll, "true") > -1 : (_vm.validWeekCheckedAll)
    },
    on: {
      "change": _vm.selectAllWeek,
      "__c": function($event) {
        var $$a = _vm.validWeekCheckedAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "true",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.validWeekCheckedAll = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.validWeekCheckedAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.validWeekCheckedAll = $$c
        }
      }
    }
  }), _vm._v("全选")])], 2), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needValidation && _vm.model.useDateMode == 0 && !_vm.hasWeekOne),
      expression: "needValidation && model.useDateMode == 0 && !hasWeekOne"
    }],
    staticClass: "warning-msg"
  }, [_vm._v("\n                        请选择可用日期")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-lg-2 col-sm-3"
  }, [_vm._v("不可用日期")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 bd minh249 pd10",
    staticStyle: {
      "margin-top": "1px"
    }
  }, _vm._l((_vm.model.unavailableDates), function(i) {
    return _c('span', {
      class: {
        'disable-date': true, 'mg10': true, 'disabled': i < _vm.today
      }
    }, [_vm._v(_vm._s(i) + "\n                    "), _c('span', {
      staticClass: "del",
      on: {
        "click": function($event) {
          _vm.mode !== 'readonly' && _vm.deleteUnavailableDates(i)
        }
      }
    }, [_vm._v("x")])])
  })), _vm._v(" "), (!_vm.isTuan) ? _c('div', {
    staticClass: "col-sm-4 no-input"
  }, [(Object.keys(_vm.model).length) ? _c('custom-datepicker', {
    attrs: {
      "message": _vm.unavailableDates,
      "options": _vm.inDateOptionOpen
    },
    on: {
      "update:options": function($event) {
        _vm.inDateOptionOpen = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-link no-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetUnavailableDates
    }
  }, [_vm._v("重置不可用日期\n                        ")])])], 1) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.model.IAmTheatre),
      expression: "!model.IAmTheatre"
    }]
  }, [(_vm.model.useDateMode == 0) ? _c('div', [_c('div', {
    staticClass: "legend"
  }, [_vm._v("价格库存")]), _vm._v(" "), _c('fieldset', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "disabled": _vm.mode == 'readonly' && !_vm.isTuan
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label label-require col-lg-2 col-sm-3"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("库存模式")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 pdt9"
  }, [_c('label', {
    attrs: {
      "for": "r11"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.stockType),
      expression: "model.stockType"
    }],
    attrs: {
      "disabled": _vm.mode == 'readonly',
      "id": "r11",
      "type": "radio",
      "name": "stockType",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.model.stockType, "1")
    },
    on: {
      "__c": function($event) {
        _vm.model.stockType = "1"
      }
    }
  }), _vm._v("\n                            不限库存")]), _vm._v(" "), _c('label', {
    staticClass: "mgr10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.stockType),
      expression: "model.stockType"
    }],
    attrs: {
      "disabled": _vm.mode == 'readonly',
      "type": "radio",
      "name": "stockType",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.model.stockType, "3")
    },
    on: {
      "__c": function($event) {
        _vm.model.stockType = "3"
      }
    }
  }), _vm._v("\n                            总库存")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.stockType == 3),
      expression: "model.stockType==3"
    }]
  }, [_vm._v("\n                    剩余总库存\n                "), _c('span', {
    staticClass: "inline-block input-w-3 relative"
  }, [_c('custom-input-number', {
    staticStyle: {
      "position": "absolute",
      "top": "-26px"
    },
    attrs: {
      "min": 0,
      "step": 1
    },
    model: {
      value: (_vm.model.stock),
      callback: function($$v) {
        _vm.model.stock = $$v
      },
      expression: "model.stock"
    }
  })], 1), _vm._v("\n                张 已售" + _vm._s(_vm.model.sold || 0) + "张\n                ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needValidation && _vm.model.stockType == 3 && !_vm.model.stock),
      expression: "needValidation && model.stockType == 3 && !model.stock"
    }],
    staticClass: "warning-msg"
  }, [_vm._v("\n                            请填写剩余总库存")])])])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label label-require col-lg-2 col-sm-3"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("价格设置")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', [_c('table', {
    staticClass: "table table-bordered table-centered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("门市价(元)")]), _vm._v(" "), _c('th', [_vm._v("美团价(元)")]), _vm._v(" "), _c('th', [_vm._v("结算价(元)")]), _vm._v(" "), _c('th', [_vm._v("费率(%)")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('custom-input-number', {
    attrs: {
      "placeholder": '请输入门市价',
      "min": 0,
      "step": 0.01,
      "disabled": _vm.mode == 'readonly'
    },
    model: {
      value: (_vm.model.marketPrice),
      callback: function($$v) {
        _vm.model.marketPrice = $$v
      },
      expression: "model.marketPrice"
    }
  })], 1), _vm._v(" "), _c('td', [_c('custom-input-number', {
    attrs: {
      "placeholder": '请输入美团价',
      "min": 0,
      "step": 0.01,
      "disabled": _vm.mode == 'readonly'
    },
    model: {
      value: (_vm.model.mtPrice),
      callback: function($$v) {
        _vm.model.mtPrice = $$v
      },
      expression: "model.mtPrice"
    }
  })], 1), _c('td', [_c('custom-input-number', {
    attrs: {
      "initAsNull": true,
      "placeholder": '请输入结算价',
      "min": 0,
      "disabled": _vm.mode == 'readonly',
      "step": 0.01
    },
    model: {
      value: (_vm.model.settlementPrice),
      callback: function($$v) {
        _vm.model.settlementPrice = $$v
      },
      expression: "model.settlementPrice"
    }
  })], 1), _c('td', {
    staticClass: "disabled"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ratioShow),
      expression: "ratioShow"
    }],
    class: {
      'red': _vm.ratioInvalid, 'no-border-input': true
    },
    attrs: {
      "readonly": "",
      "name": "ratio",
      "type": "text"
    },
    domProps: {
      "value": (_vm.ratioShow)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ratioShow = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "red"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.mtPrice > _vm.model.marketPrice),
      expression: "model.mtPrice > model.marketPrice"
    }]
  }, [_vm._v("美团价不能大于门市价")]), _vm._v(" "), (_vm.ratio > 50 || _vm.ratioInvalid == 4) ? _c('span', [_vm._v("请确认您是否输入了正确的价格 " + _vm._s(_vm.ratioInvalid == 4 ? '<' + (this.model.onlineMsRatioPriceInfo.oldMsRatio * 100) + '% 费率下降' : ''))]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.settlementPrice && _vm.ratio < _vm.model.baseMsRatioSnapshot * 100),
      expression: "model.settlementPrice && ratio < model.baseMsRatioSnapshot*100"
    }]
  }, [_vm._v("\n                                          重要提示：费率低于当前【" + _vm._s(_vm.model.maxMsRatioProvinceName) + "】的底线费率" + _vm._s(_vm.model.baseMsRatioSnapshot * 100) + "%")])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needValidation && _vm.model.useDateMode == 0 && (!_vm.model.marketPrice || !_vm.model.mtPrice)),
      expression: "needValidation && model.useDateMode == 0 && (!model.marketPrice || !model.mtPrice)"
    }],
    staticClass: "warning-msg"
  }, [_vm._v("\n                                请填写价格信息")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.model.useDateMode != 0) ? _c('div', [_c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly' && !_vm.isTuan
    }
  }, [_c('div', {
    staticClass: "legend"
  }, [_vm._v("价格库存")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label label-require col-lg-2 col-sm-3"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("库存模式")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 pdt9"
  }, [_c('label', {
    attrs: {
      "for": "r11"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.stockType),
      expression: "model.stockType"
    }],
    attrs: {
      "type": "radio",
      "disabled": _vm.mode == 'readonly',
      "name": "stockType",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.model.stockType, "1")
    },
    on: {
      "__c": function($event) {
        _vm.model.stockType = "1"
      }
    }
  }), _vm._v("\n                            不限库存")]), _vm._v(" "), _c('label', {
    staticClass: "mgr10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.stockType),
      expression: "model.stockType"
    }],
    attrs: {
      "type": "radio",
      "disabled": _vm.mode == 'readonly',
      "name": "stockType",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.model.stockType, "3")
    },
    on: {
      "__c": function($event) {
        _vm.model.stockType = "3"
      }
    }
  }), _vm._v("\n                            总库存")]), _vm._v(" "), _c('label', {
    staticClass: "mgr10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.stockType),
      expression: "model.stockType"
    }],
    attrs: {
      "disabled": _vm.mode == 'readonly',
      "type": "radio",
      "name": "stockType",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.model.stockType, "2")
    },
    on: {
      "__c": function($event) {
        _vm.model.stockType = "2"
      }
    }
  }), _vm._v("\n                            日库存")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.stockType == 3),
      expression: "model.stockType==3"
    }]
  }, [_vm._v("\n                    剩余总库存\n                "), _c('span', {
    staticClass: "inline-block input-w-3 relative"
  }, [_c('custom-input-number', {
    staticStyle: {
      "position": "absolute",
      "top": "-26px"
    },
    attrs: {
      "min": 0,
      "step": 1
    },
    model: {
      value: (_vm.model.stock),
      callback: function($$v) {
        _vm.model.stock = $$v
      },
      expression: "model.stock"
    }
  })], 1), _vm._v("\n                张 已售 " + _vm._s(_vm.model.sold || 0) + " 张\n                ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needValidation && _vm.model.stockType == 3 && !_vm.model.stock),
      expression: "needValidation && model.stockType == 3 && !model.stock"
    }],
    staticClass: "warning-msg"
  }, [_vm._v("\n                            请填写剩余总库存")])])])]), _vm._v(" "), _c('fieldset', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "disabled": _vm.mode == 'readonly' && !_vm.isTuan
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label label-require col-lg-2 col-sm-3"
  }, [(_vm.canPullPrice && _vm.model.useDateMode == 1) ? _c('button', {
    staticClass: "btn btn-primary pull-price-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.pullPrice(true)
      }
    }
  }, [_vm._v("\n                            拉取价格信息\n                        ")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("日期价格")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('label', {
    staticClass: "control-label label-require"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("请先选择日期")]), _vm._v(" "), _c('Calendar', {
    attrs: {
      "selected": _vm.dateSelected,
      "single": false,
      "lock-check": _vm.dayLock.bind(this),
      "readonly": _vm.mode == 'readonly',
      "isTuan": _vm.isTuan,
      "get-day-info": _vm.getInfoFun.bind(this),
      "before-time": _vm.today
    },
    on: {
      "update:selected": function($event) {
        _vm.dateSelected = $event
      },
      "calendar-remove-selected": _vm.onRemoveDate
    }
  })], 1), _vm._v(" "), (!_vm.isTuan) ? _c('div', {
    staticClass: "col-sm-9 col-md-offset-2",
    staticStyle: {
      "padding": "0",
      "padding-top": "10px"
    }
  }, [(!(_vm.canPullPrice && _vm.model.useDateMode == 1)) ? _c('div', {
    staticStyle: {
      "margin-left": "13px"
    }
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("价格设置\n                        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [(!(_vm.canPullPrice && _vm.model.useDateMode == 1)) ? _c('table', {
    staticClass: "table table-bordered table-centered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("门市价(元)")]), _vm._v(" "), _c('th', [_vm._v("美团价(元)")]), _vm._v(" "), _c('th', [_vm._v("结算价(元)")]), _vm._v(" "), _c('th', [_vm._v("费率(%)")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('custom-input-number', {
    attrs: {
      "placeholder": '请输入门市价',
      "min": 0,
      "step": 0.01,
      "disabled": _vm.mode == 'readonly'
    },
    model: {
      value: (_vm.modelLocal.marketPrice),
      callback: function($$v) {
        _vm.modelLocal.marketPrice = $$v
      },
      expression: "modelLocal.marketPrice"
    }
  })], 1), _vm._v(" "), _c('td', [_c('custom-input-number', {
    attrs: {
      "placeholder": '请输入美团价',
      "min": 0,
      "step": 0.01,
      "disabled": _vm.mode == 'readonly'
    },
    model: {
      value: (_vm.modelLocal.mtPrice),
      callback: function($$v) {
        _vm.modelLocal.mtPrice = $$v
      },
      expression: "modelLocal.mtPrice"
    }
  })], 1), _vm._v(" "), _c('td', [_c('custom-input-number', {
    attrs: {
      "placeholder": '请输入结算价',
      "min": 0,
      "step": 0.01,
      "disabled": _vm.mode == 'readonly',
      "initAsNull": true
    },
    model: {
      value: (_vm.modelLocal.settlementPrice),
      callback: function($$v) {
        _vm.modelLocal.settlementPrice = $$v
      },
      expression: "modelLocal.settlementPrice"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "disabled"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ratioShowLocal),
      expression: "ratioShowLocal"
    }],
    class: {
      'red': _vm.ratioInvalid || _vm.belowBase, 'no-border-input': true
    },
    attrs: {
      "readonly": "",
      "name": "ratio",
      "type": "text"
    },
    domProps: {
      "value": (_vm.ratioShowLocal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ratioShowLocal = $event.target.value
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "red"
  }, [(_vm.ratioLocal > 50 || _vm.modelLocal.settlementPrice && _vm.hasDeclined) ? _c('span', [_vm._v("请确认您是否输入了正确的价格 " + _vm._s(_vm.modelLocal.settlementPrice && _vm.hasDeclined ? '费率下降' : ''))]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modelLocal.mtPrice > _vm.modelLocal.marketPrice),
      expression: "modelLocal.mtPrice > modelLocal.marketPrice"
    }]
  }, [_vm._v("美团价不能大于门市价")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modelLocal.settlementPrice && _vm.ratioLocal < _vm.model.baseMsRatioSnapshot * 100),
      expression: "modelLocal.settlementPrice && ratioLocal < model.baseMsRatioSnapshot * 100"
    }]
  }, [_vm._v("\n                                          低于当前【" + _vm._s(_vm.model.maxMsRatioProvinceName) + "】的底线费率" + _vm._s(_vm.model.baseMsRatioSnapshot * 100) + "%")])]), _vm._v(" "), (_vm.belowBase) ? _c('table', {
    staticClass: "table table-bordered table-centered"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n                                        特殊费率详细信息\n                                        "), _c('span', {
    staticClass: "red"
  }, [_vm._v("当前【" + _vm._s(_vm.model.maxMsRatioProvinceName) + "】底线费率" + _vm._s(_vm.model.baseMsRatioSnapshot * 100) + "%")])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("日期")]), _vm._v(" "), _c('th', [_vm._v("美团价")]), _vm._v(" "), _c('th', [_vm._v("费率")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.invalidRatioList), function(group) {
    return _c('tr', [_c('td', [_c('ul', {
      staticClass: "list-unstyled"
    }, _vm._l((group.dates), function(item) {
      return _c('li', [_vm._v(_vm._s(item))])
    }))]), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s(group.mtPrice) + "\n                                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s(group.ratio) + "%\n                                    ")])])
  }))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!(_vm.canPullPrice && _vm.model.useDateMode == 1)) ? _c('div', {
    staticClass: "col-sm-6 col-md-offset-2 pdt9"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.stockType == 2),
      expression: "model.stockType==2"
    }]
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("剩余日库存\n                     "), _c('span', {
    staticClass: "inline-block input-w-3 relative"
  }, [_c('custom-input-number', {
    staticStyle: {
      "position": "absolute",
      "top": "-26px"
    },
    attrs: {
      "min": 0,
      "step": 1
    },
    model: {
      value: (_vm.modelLocal.stock),
      callback: function($$v) {
        _vm.modelLocal.stock = $$v
      },
      expression: "modelLocal.stock"
    }
  })], 1), _vm._v("\n                    张  \n                    ")]), _vm._v(" "), (!_vm.readonly || _vm.isTuan) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.modelLocal.marketPrice || !_vm.modelLocal.mtPrice || _vm.modelLocal.settlementPrice == undefined
    },
    on: {
      "click": function($event) {
        _vm.addDayPrice(_vm.modelLocal, _vm.dateSelected)
      }
    }
  }, [_vm._v("更新\n                        ")]) : _vm._e()]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.model.useDateMode == 0 && _vm.model.settlementPrice == 0) || (_vm.modelLocal.settlementPrice == 0 && _vm.model.useDateMode != 0) || _vm.foundFreeTicket),
      expression: "(model.useDateMode ==0 && model.settlementPrice == 0) || (modelLocal.settlementPrice==0 && model.useDateMode !=0) || foundFreeTicket"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label label-require col-lg-2 col-sm-3"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("免票类型")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('v-select', {
    attrs: {
      "clearable": false,
      "size": "md",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.updateFreeType
    },
    model: {
      value: (_vm.model.freeTicketType),
      callback: function($$v) {
        _vm.model.freeTicketType = $$v
      },
      expression: "model.freeTicketType"
    }
  }, _vm._l((_vm.freeTicketTypes), function(item) {
    return _c('v-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.freeTicketType == 0),
      expression: "model.freeTicketType==0"
    }]
  }, [_c('label', {
    staticClass: "control-label label-require col-lg-2 col-sm-3"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("关联账单")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('v-select', {
    class: {
      'has-warning': !_vm.model.statementId
    },
    attrs: {
      "clearable": false,
      "size": "md",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.updateStatements
    },
    model: {
      value: (_vm.model.statementId),
      callback: function($$v) {
        _vm.model.statementId = $$v
      },
      expression: "model.statementId"
    }
  }, _vm._l((_vm.model.associatedContractList), function(item) {
    return _c('v-option', {
      key: item.statementId,
      attrs: {
        "label": item.showName,
        "value": item.statementId + ''
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.freeTicketType == 1),
      expression: "model.freeTicketType==1"
    }]
  }, [_c('label', {
    staticClass: "control-label label-require col-lg-2 col-sm-3"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("关联广告合同编号")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.freeTicketAssociatedAccount),
      expression: "model.freeTicketAssociatedAccount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "freeTicketAssociatedAccount",
      "id": "freeTicketAssociatedAccount",
      "placeholder": "关联合同编号"
    },
    domProps: {
      "value": (_vm.model.freeTicketAssociatedAccount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.freeTicketAssociatedAccount = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needValidation && ((_vm.model.useDateMode == 0 && _vm.model.settlementPrice == 0) || (_vm.modelLocal.settlementPrice == 0 && _vm.model.useDateMode != 0) || _vm.foundFreeTicket) && (_vm.model.freeTicketType == null || _vm.model.freeTicketType == undefined)),
      expression: "needValidation && ((model.useDateMode ==0 && model.settlementPrice == 0) || (modelLocal.settlementPrice==0 && model.useDateMode !=0) || foundFreeTicket) && (model.freeTicketType==null || model.freeTicketType==undefined)"
    }],
    staticClass: "warning-msg  col-lg-offset-2 col-sm-offset-3",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_vm._v("\n                请选择免票类型")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.model.useDateMode == 0 && _vm.model.settlementPrice == 0) || (_vm.modelLocal.settlementPrice == 0 && _vm.model.useDateMode != 0) || _vm.foundFreeTicket),
      expression: "(model.useDateMode ==0 && model.settlementPrice == 0) || (modelLocal.settlementPrice==0 && model.useDateMode !=0) || foundFreeTicket"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label label-require col-lg-2 col-sm-3"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.freeTicketType == 4),
      expression: "model.freeTicketType == 4"
    }],
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("免票备注")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.freeTicketRemarks),
      expression: "model.freeTicketRemarks"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "freeTicketRemarks",
      "id": "include",
      "cols": "30",
      "rows": "5",
      "placeholder": "请填写免票备注的详细信息"
    },
    domProps: {
      "value": (_vm.model.freeTicketRemarks)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.freeTicketRemarks = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needValidation && ((_vm.model.useDateMode == 0 && _vm.model.settlementPrice == 0) || (_vm.modelLocal.settlementPrice == 0 && _vm.model.useDateMode != 0) || _vm.foundFreeTicket) && _vm.model.freeTicketType == 4),
      expression: "needValidation && ((model.useDateMode ==0 && model.settlementPrice == 0) || (modelLocal.settlementPrice==0 && model.useDateMode !=0) || foundFreeTicket) && model.freeTicketType == 4"
    }],
    staticClass: "warning-msg"
  }, [_vm._v("\n                        请填写免票备注")])])]), _vm._v(" "), ((_vm.model.useDateMode == 0 && (_vm.ratioInvalid == 4 || _vm.ratioInvalid == 3)) || (_vm.model.useDateMode == 1 && (_vm.hasDeclined || _vm.belowBase))) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-2 control-label label-require"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("特殊费率原因：")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('table', {
    staticClass: "rate-reason margin-left15"
  }, [_c('tbody', [_c('tr', [_c('td', [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.specialMsRatioReasonType),
      expression: "model.specialMsRatioReasonType"
    }],
    attrs: {
      "type": "radio",
      "name": "specialMsRatioReasonType",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.model.specialMsRatioReasonType, "1")
    },
    on: {
      "__c": function($event) {
        _vm.model.specialMsRatioReasonType = "1"
      }
    }
  }), _vm._v("同行价格劣势竞争\n                                        ")])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.specialMsRatioReasonType),
      expression: "model.specialMsRatioReasonType"
    }],
    attrs: {
      "type": "radio",
      "name": "specialMsRatioReasonType",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.model.specialMsRatioReasonType, "2")
    },
    on: {
      "__c": function($event) {
        _vm.model.specialMsRatioReasonType = "2"
      }
    }
  }), _vm._v("独家优势方案、资源、票种\n                                        ")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.specialMsRatioReasonType),
      expression: "model.specialMsRatioReasonType"
    }],
    attrs: {
      "type": "radio",
      "name": "specialMsRatioReasonType",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.model.specialMsRatioReasonType, "3")
    },
    on: {
      "__c": function($event) {
        _vm.model.specialMsRatioReasonType = "3"
      }
    }
  }), _vm._v("结算价格不变且无法使用促销\n                                        ")])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.specialMsRatioReasonType),
      expression: "model.specialMsRatioReasonType"
    }],
    attrs: {
      "type": "radio",
      "name": "specialMsRatioReasonType",
      "value": "4"
    },
    domProps: {
      "checked": _vm._q(_vm.model.specialMsRatioReasonType, "4")
    },
    on: {
      "__c": function($event) {
        _vm.model.specialMsRatioReasonType = "4"
      }
    }
  }), _vm._v("其他（请在下方文本框中填写理由）\n                                        ")])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.specialMsRatioReasonType == '4'),
      expression: "model.specialMsRatioReasonType == '4'"
    }],
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.specialMsRatioReason),
      expression: "model.specialMsRatioReason"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "rows": "3",
      "maxlength": "100",
      "placeholder": "请填写特殊费率原因"
    },
    domProps: {
      "value": (_vm.model.specialMsRatioReason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model.specialMsRatioReason = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      red: _vm.model.specialMsRatioReason.length == 100
    }
  }, [_vm._v(_vm._s(_vm.model.specialMsRatioReason.length || 0) + "/100字")])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needValidation && _vm.model.specialMsRatioReasonType == '4' && !_vm.model.specialMsRatioReason),
      expression: "needValidation && model.specialMsRatioReasonType == '4' && !model.specialMsRatioReason"
    }],
    staticClass: "warning-msg"
  }, [_vm._v("\n                        请填写特殊费率原因")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.IAmTheatre),
      expression: "model.IAmTheatre"
    }]
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [_c('div', {
    staticClass: "legend"
  }, [_vm._v("演出设置\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-top": "-50px"
    }
  }, [_c('div', {
    staticClass: "col-sm-8 col-sm-offset-1"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !(_vm.extra.partnerDealId && _vm.extra.supplierId),
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.fetchTheatreInfo(true)
      }
    }
  }, [_vm._v("拉取演出信息")]), _vm._v(" "), _c('v-tabs', {
    staticClass: "no-fixed",
    attrs: {
      "type": "panels"
    },
    on: {
      "tab-click": function($event) {}
    }
  }, [_c('v-tab-pane', {
    attrs: {
      "label": "1.价格日历"
    }
  }, [_c('Calendar', {
    attrs: {
      "selected": _vm.price.dateSelected,
      "single": !_vm.price.canEditPrice,
      "lock-check": _vm.dayLock.bind(this),
      "on-single-select": _vm.price.onDaySelect,
      "readonly": _vm.mode == 'readonly' && false,
      "get-day-info": _vm.price.getInfoFun.bind(this),
      "before-time": _vm.today
    },
    on: {
      "update:selected": function($event) {
        _vm.price.dateSelected = $event
      }
    }
  }), _vm._v(" "), (_vm.mode == 'edit' || _vm.mode == 'readonly' || _vm.mode == 'new' || _vm.mode == 'copy') ? _c('div', [_c('div', [_c('p', [_vm._v(_vm._s(!_vm.price.canEditPrice && !_vm.price.dateSelected.length ? '请选择日期以查看价格' : ''))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(!_vm.price.canEditPrice && _vm.price.dateSelected.length ? '已选择：' + _vm.price.dateSelected[0] :
    ''))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.price.canEditPrice ? '已选择: ' + _vm.price.dateSelected.length + '天' : ''))])])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-centered input-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("市场价(元)")]), _vm._v(" "), _c('th', [_vm._v("美团价(元)")]), _vm._v(" "), _c('th', [_vm._v("结算价(元)")]), _vm._v(" "), _c('th', [_vm._v("费率(%)")]), _vm._v(" "), _c('th', [_vm._v("价格说明")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "juchang"
  }, _vm._l((_vm.price.priceTable), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_c('custom-input-number', {
      attrs: {
        "placeholder": '请输入门市价',
        "min": 0,
        "step": 0.01,
        "disabled": !_vm.price.canEditPrice
      },
      model: {
        value: (item.marketPrice),
        callback: function($$v) {
          item.marketPrice = $$v
        },
        expression: "item.marketPrice"
      }
    })], 1), _vm._v(" "), _c('td', [_c('custom-input-number', {
      attrs: {
        "placeholder": '请输入美团价',
        "min": 0,
        "step": 0.01,
        "disabled": !_vm.price.canEditPrice
      },
      model: {
        value: (item.mtPrice),
        callback: function($$v) {
          item.mtPrice = $$v
        },
        expression: "item.mtPrice"
      }
    })], 1), _vm._v(" "), _c('td', [_c('custom-input-number', {
      attrs: {
        "placeholder": '请输入结算价',
        "min": 0,
        "disabled": !_vm.price.canEditPrice,
        "step": 0.01
      },
      model: {
        value: (item.settlementPrice),
        callback: function($$v) {
          item.settlementPrice = $$v
        },
        expression: "item.settlementPrice"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "disabled"
    }, [_vm._v("\n                                        " + _vm._s(_vm.correctRatio(item.mtPrice, item.settlementPrice)) + "\n                                    ")]), _vm._v(" "), _c('td', {
      staticClass: "disabled"
    }, [_vm._v("\n                                        " + _vm._s(item.priceDesc) + "\n                                    ")])])
  }))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode == 'edit' || _vm.mode == 'new' || _vm.mode == 'copy' || _vm.mode == 'readonly'),
      expression: "mode == 'edit' || mode == 'new' || mode == 'copy' || mode == 'readonly'"
    }]
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.price.canEditPrice),
      expression: "!price.canEditPrice"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.mode == 'readonly'
    },
    on: {
      "click": function($event) {
        _vm.price.canEditPrice = true;
      }
    }
  }, [_vm._v("编辑\n                                ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.price.canEditPrice),
      expression: "price.canEditPrice"
    }],
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.price.cancelCanEdit
    }
  }, [_vm._v("取消\n                                ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.price.canEditPrice),
      expression: "price.canEditPrice"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.price.savePrice
    }
  }, [_vm._v("保存\n                                ")])])], 1), _vm._v(" "), _c('v-tab-pane', {
    attrs: {
      "label": "2.场次信息",
      "hidden": !_vm.theatreTab.changci
    }
  }, [_c('Calendar', {
    attrs: {
      "selected": _vm.changci.dateSelected,
      "single": !_vm.changci.canEditPrice,
      "lock-check": _vm.dayLock.bind(this),
      "on-single-select": _vm.changci.onDaySelect,
      "readonly": _vm.mode == 'readonly' && false,
      "get-day-info": _vm.changci.getInfoFun.bind(this),
      "before-time": _vm.today
    },
    on: {
      "update:selected": function($event) {
        _vm.changci.dateSelected = $event
      }
    }
  }), _vm._v(" "), (_vm.mode == 'edit' || _vm.mode == 'new' || _vm.mode == 'readonly' || _vm.mode == 'copy') ? _c('div', [_c('div', [_c('p', [_vm._v(_vm._s(!_vm.changci.canEditPrice && !_vm.changci.dateSelected.length ? '请选择日期以查看场次信息' : ''))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(!_vm.changci.canEditPrice && _vm.changci.dateSelected.length ? '已选择：' + _vm.changci.dateSelected[0] :
    ''))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.changci.canEditPrice ? '已选择: ' + _vm.changci.dateSelected.length + '天' : ''))])])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-centered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("场次信息")]), _vm._v(" "), _c('th', [_vm._v("场次开始时间")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "juchang"
  }, _vm._l((_vm.changci.priceTable), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_c('v-input', {
      attrs: {
        "placeholder": "'请输入场次信息'",
        "disabled": !_vm.changci.canEditPrice
      },
      model: {
        value: (item.levelName),
        callback: function($$v) {
          item.levelName = $$v
        },
        expression: "item.levelName"
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s(item.mappingRel) + "\n                                    ")])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "sort-dialog",
    on: {
      "click": function($event) {
        _vm.sortDialog.sort('changci')
      }
    }
  }, [_vm._v("调整顺序"), _c('span', {
    staticClass: "sort-icon"
  })]), _vm._v(" "), _c('p', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.changci.canEditPrice),
      expression: "!changci.canEditPrice"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.mode == 'readonly'
    },
    on: {
      "click": function($event) {
        _vm.changci.canEditPrice = true;
      }
    }
  }, [_vm._v("编辑\n                                ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changci.canEditPrice),
      expression: "changci.canEditPrice"
    }],
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.changci.cancelCanEdit
    }
  }, [_vm._v("取消\n                                ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changci.canEditPrice),
      expression: "changci.canEditPrice"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.changci.savePrice
    }
  }, [_vm._v("保存\n                                ")])])], 1), _vm._v(" "), _c('v-tab-pane', {
    attrs: {
      "label": "3.席位信息",
      "hidden": !_vm.theatreTab.xiwei
    }
  }, [_c('Calendar', {
    attrs: {
      "selected": _vm.xiwei.dateSelected,
      "single": !_vm.xiwei.canEditPrice,
      "lock-check": _vm.dayLock.bind(this),
      "on-single-select": _vm.xiwei.onDaySelect,
      "readonly": _vm.mode == 'readonly' && false,
      "get-day-info": _vm.xiwei.getInfoFun.bind(this),
      "before-time": _vm.today
    },
    on: {
      "update:selected": function($event) {
        _vm.xiwei.dateSelected = $event
      }
    }
  }), _vm._v(" "), (_vm.mode == 'edit' || _vm.mode == 'new' || _vm.mode == 'readonly' || _vm.mode == 'copy') ? _c('div', [_c('div', [_c('p', [_vm._v(_vm._s(!_vm.xiwei.canEditPrice && !_vm.xiwei.dateSelected.length ? '请选择日期以查看席位信息' : ''))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(!_vm.xiwei.canEditPrice && _vm.xiwei.dateSelected.length ? '已选择：' + _vm.xiwei.dateSelected[0] :
    ''))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.xiwei.canEditPrice ? '已选择: ' + _vm.xiwei.dateSelected.length + '天' : ''))])])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-centered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("坐席信息")]), _vm._v(" "), _c('th', [_vm._v("坐席位置")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "juchang"
  }, _vm._l((_vm.xiwei.priceTable), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_c('v-input', {
      attrs: {
        "placeholder": "'请输入席位信息'",
        "disabled": !_vm.xiwei.canEditPrice
      },
      model: {
        value: (item.levelName),
        callback: function($$v) {
          item.levelName = $$v
        },
        expression: "item.levelName"
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s(item.mappingRel) + "\n                                    ")])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "sort-dialog",
    on: {
      "click": function($event) {
        _vm.sortDialog.sort('xiwei')
      }
    }
  }, [_vm._v("调整顺序"), _c('span', {
    staticClass: "sort-icon"
  })]), _vm._v(" "), _c('p', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.xiwei.canEditPrice),
      expression: "!xiwei.canEditPrice"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.mode == 'readonly'
    },
    on: {
      "click": function($event) {
        _vm.xiwei.canEditPrice = true;
      }
    }
  }, [_vm._v("编辑\n                                ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.xiwei.canEditPrice),
      expression: "xiwei.canEditPrice"
    }],
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.xiwei.cancelCanEdit
    }
  }, [_vm._v("取消\n                                ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.xiwei.canEditPrice),
      expression: "xiwei.canEditPrice"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.xiwei.savePrice
    }
  }, [_vm._v("保存\n                                ")])])], 1), _vm._v(" "), _c('v-tab-pane', {
    attrs: {
      "label": "4.场馆区域",
      "hidden": !_vm.theatreTab.changguan
    }
  }, [_c('Calendar', {
    attrs: {
      "selected": _vm.changguan.dateSelected,
      "single": !_vm.changguan.canEditPrice,
      "lock-check": _vm.dayLock.bind(this),
      "on-single-select": _vm.changguan.onDaySelect,
      "readonly": _vm.mode == 'readonly' && false,
      "get-day-info": _vm.changguan.getInfoFun.bind(this),
      "before-time": _vm.today
    },
    on: {
      "update:selected": function($event) {
        _vm.changguan.dateSelected = $event
      }
    }
  }), _vm._v(" "), (_vm.mode == 'edit' || _vm.mode == 'new' || _vm.mode == 'readonly' || _vm.mode == 'copy') ? _c('div', [_c('div', [_c('p', [_vm._v(_vm._s(!_vm.changguan.canEditPrice && !_vm.changguan.dateSelected.length ? '请选择日期以查看场馆信息' : ''))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(!_vm.changguan.canEditPrice && _vm.changguan.dateSelected.length ? '已选择：' + _vm.changguan.dateSelected[0] :
    ''))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.changguan.canEditPrice ? '已选择: ' + _vm.changguan.dateSelected.length + '天' : ''))])])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-centered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("场馆区域信息")]), _vm._v(" "), _c('th', [_vm._v("场馆位置")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "juchang"
  }, _vm._l((_vm.changguan.priceTable), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_c('v-input', {
      attrs: {
        "placeholder": "'请输入场馆区域信息'",
        "disabled": !_vm.changguan.canEditPric
      },
      model: {
        value: (item.levelName),
        callback: function($$v) {
          item.levelName = $$v
        },
        expression: "item.levelName"
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v("\n                                        " + _vm._s(item.mappingRel) + "\n                                    ")])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "sort-dialog",
    on: {
      "click": function($event) {
        _vm.sortDialog.sort('changguan')
      }
    }
  }, [_vm._v("调整顺序"), _c('span', {
    staticClass: "sort-icon"
  })]), _vm._v(" "), _c('p', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.changguan.canEditPrice),
      expression: "!changguan.canEditPrice"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.mode == 'readonly'
    },
    on: {
      "click": function($event) {
        _vm.changguan.canEditPrice = true;
      }
    }
  }, [_vm._v("编辑\n                                ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changguan.canEditPrice),
      expression: "changguan.canEditPrice"
    }],
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.changguan.cancelCanEdit
    }
  }, [_vm._v("取消\n                                ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changguan.canEditPrice),
      expression: "changguan.canEditPrice"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.changguan.savePrice
    }
  }, [_vm._v("保存\n                                ")])])], 1)], 1)], 1)])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [_c('div', {
    staticClass: "legend"
  }, [_vm._v("座位图片")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-8 col-sm-offset-1"
  }, [_c('div', {
    staticClass: "pdt9"
  }, [_c('custom-upload', {
    attrs: {
      "url": _vm.seatUpload.url,
      "file-name": 'file',
      "is-multiple": false,
      "max-limit": _vm.seatUpload.maxImgLength,
      "thumbnail-mode": true,
      "show-file-list": false,
      "type": 'imageList',
      "default-file-list": _vm.model.seatImageShow,
      "fileLimitSize": 2097152,
      "enable-head-image": false,
      "accept": 'image/jpg,image/jpeg,image/png'
    },
    on: {
      "on-max-limit": _vm.seatUpload.onMaxLimit,
      "on-success": _vm.seatUpload.onSuccess,
      "on-delete": _vm.seatUpload.onDelete,
      "on-file-size-max-limit": _vm.seatUpload.onSizeLimited
    }
  })], 1), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "pdt9 lh14"
  }, [_c('b', [_vm._v("注意事项：")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "annotate"
  }, [_vm._v("\n                                  1. 高度和宽度不低于440px，图片大小不超过2M，支持格式有jpg、png、jpeg"), _c('br'), _vm._v("\n                            2. 重要提示：图片不可有字、不可使用拼图、不可有重复图片、不可有除美团水印外的其他水印、不能有人物特写、明星宣传画等涉及人物肖像权的图片"), _c('br')])])])])])])]), _vm._v(" "), _c('refund', {
    attrs: {
      "model": _vm.model,
      "mode": _vm.mode,
      "isTuan": _vm.isTuan,
      "extra": _vm.extra
    }
  }), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly' && !_vm.isTuan
    }
  }, [_c('div', {
    staticClass: "legend"
  }, [_vm._v("上下架控制/其他信息")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 col-sm-3 control-label label-require"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("上架时间\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    attrs: {
      "for": "AuditPassOnline"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.scheduleOnlineType),
      expression: "model.scheduleOnlineType"
    }],
    attrs: {
      "disabled": _vm.mode == 'readonly',
      "id": "AuditPassOnline",
      "type": "radio",
      "required": "",
      "name": "scheduleOnlineType",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.model.scheduleOnlineType, "1")
    },
    on: {
      "__c": function($event) {
        _vm.model.scheduleOnlineType = "1"
      }
    }
  }), _vm._v("\n                        审核通过自动上架")])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', {
    attrs: {
      "for": "periodOfValidityOnline"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.scheduleOnlineType),
      expression: "model.scheduleOnlineType"
    }],
    attrs: {
      "disabled": _vm.mode == 'readonly',
      "id": "periodOfValidityOnline",
      "type": "radio",
      "required": "",
      "name": "scheduleOnlineType",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.model.scheduleOnlineType, "2")
    },
    on: {
      "__c": function($event) {
        _vm.model.scheduleOnlineType = "2"
      }
    }
  }), _vm._v("\n                        有效期始自动上架")])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.scheduleOnlineType),
      expression: "model.scheduleOnlineType"
    }],
    attrs: {
      "disabled": _vm.mode == 'readonly',
      "type": "radio",
      "required": "",
      "name": "scheduleOnlineType",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.model.scheduleOnlineType, "3")
    },
    on: {
      "__c": function($event) {
        _vm.model.scheduleOnlineType = "3"
      }
    }
  }), _vm._v("\n                        手动上架")])]), _vm._v(" "), _c('div', {
    staticClass: "radio",
    staticStyle: {
      "margin-top": "-8px"
    }
  }, [_c('label', {
    attrs: {
      "for": "specifyDateOnline"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.scheduleOnlineType),
      expression: "model.scheduleOnlineType"
    }],
    attrs: {
      "disabled": _vm.mode == 'readonly',
      "id": "specifyDateOnline",
      "type": "radio",
      "required": "",
      "name": "scheduleOnlineType",
      "value": "4"
    },
    domProps: {
      "checked": _vm._q(_vm.model.scheduleOnlineType, "4")
    },
    on: {
      "__c": function($event) {
        _vm.model.scheduleOnlineType = "4"
      }
    }
  }), _vm._v("\n                        指定日期上架\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "w200 inline-block"
  }, [_c('v-datepicker', {
    attrs: {
      "message": _vm.model.scheduleOnlineTime,
      "disabled": _vm.model.scheduleOnlineType != 4
    },
    model: {
      value: (_vm.model.scheduleOnlineTime),
      callback: function($$v) {
        _vm.model.scheduleOnlineTime = $$v
      },
      expression: "model.scheduleOnlineTime"
    }
  })], 1)]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needValidation && _vm.model.scheduleOnlineType == 4 && !_vm.model.scheduleOnlineTime),
      expression: "needValidation && model.scheduleOnlineType==4 && !model.scheduleOnlineTime"
    }],
    staticClass: "warning-msg"
  }, [_vm._v("请选择上架日期")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 col-sm-3 control-label label-require"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("\n                下架时间\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.scheduleOfflineType),
      expression: "model.scheduleOfflineType"
    }],
    attrs: {
      "disabled": _vm.mode == 'readonly' && !_vm.isTuan,
      "type": "radio",
      "required": "",
      "name": "scheduleOfflineType",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.model.scheduleOfflineType, "1")
    },
    on: {
      "__c": function($event) {
        _vm.model.scheduleOfflineType = "1"
      }
    }
  }), _vm._v("\n                        " + _vm._s(_vm.model.useDateMode == 0 ? '有效期' : '价格日历期限') + "已过自动下架")])]), _vm._v(" "), _c('div', {
    staticClass: "radio",
    staticStyle: {
      "margin-top": "-8px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.scheduleOfflineType),
      expression: "model.scheduleOfflineType"
    }],
    attrs: {
      "disabled": _vm.mode == 'readonly' && !_vm.isTuan,
      "type": "radio",
      "name": "scheduleOfflineType",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.model.scheduleOfflineType, "2")
    },
    on: {
      "__c": function($event) {
        _vm.model.scheduleOfflineType = "2"
      }
    }
  }), _vm._v("\n                        指定下架时间")]), _vm._v(" "), _c('div', {
    staticClass: "w200 inline-block"
  }, [_c('v-datepicker', {
    attrs: {
      "message": _vm.model.scheduleOfflineTime,
      "disabled": _vm.model.scheduleOfflineType == 1 || (_vm.mode == 'readonly' && !_vm.isTuan)
    },
    model: {
      value: (_vm.model.scheduleOfflineTime),
      callback: function($$v) {
        _vm.model.scheduleOfflineTime = $$v
      },
      expression: "model.scheduleOfflineTime"
    }
  })], 1), _vm._v(" "), _c('input', {
    staticClass: "input-w-3 inline-block",
    attrs: {
      "readonly": "",
      "disabled": "",
      "type": "text",
      "name": "scheduleOfflineType",
      "value": "00:00"
    }
  })]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needValidation && _vm.model.scheduleOfflineType == 2 && !_vm.model.scheduleOfflineTime),
      expression: "needValidation && model.scheduleOfflineType==2 && !model.scheduleOfflineTime"
    }],
    staticClass: "warning-msg"
  }, [_vm._v("请选择下架日期")])])])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.extra.isBD || _vm.model.IAmTheatre),
      expression: "extra.isBD || model.IAmTheatre"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 col-sm-3 control-label label-require"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("\n                是否单独售卖\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.sellType),
      expression: "model.sellType"
    }],
    attrs: {
      "type": "radio",
      "required": "",
      "name": "sellType",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.model.sellType, "1")
    },
    on: {
      "__c": function($event) {
        _vm.model.sellType = "1"
      }
    }
  }), _vm._v("\n                        可单独售卖")])]), _vm._v(" "), _c('div', {
    staticClass: "radio",
    staticStyle: {
      "margin-top": "-8px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.sellType),
      expression: "model.sellType"
    }],
    attrs: {
      "id": "ManualOnline222",
      "type": "radio",
      "required": "",
      "name": "sellType",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.model.sellType, "2")
    },
    on: {
      "__c": function($event) {
        _vm.model.sellType = "2"
      }
    }
  }), _vm._v("\n                        用于打包，不可单独售卖")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.sellType == 2),
      expression: "model.sellType==2"
    }],
    staticClass: "annotate"
  }, [_vm._v("选择后, 产品不会被用户看到和单独购买。支持单独售卖的产品请勿选")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.model.IAmTheatre && _vm.extra.isBD),
      expression: "!model.IAmTheatre && extra.isBD"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 col-sm-3 control-label label-require"
  }, [_c('i', {
    staticClass: "required-field"
  }, [_vm._v("＊")]), _vm._v("\n                是否上传附件\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.needSpecialAuthFile),
      expression: "model.needSpecialAuthFile"
    }],
    attrs: {
      "type": "radio",
      "required": "",
      "name": "needSpecialAuthFile",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.model.needSpecialAuthFile, "true")
    },
    on: {
      "__c": function($event) {
        _vm.model.needSpecialAuthFile = "true"
      }
    }
  }), _vm._v("\n                        需要")])]), _vm._v(" "), _c('div', {
    staticClass: "radio",
    staticStyle: {
      "margin-top": "-8px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.needSpecialAuthFile),
      expression: "model.needSpecialAuthFile"
    }],
    attrs: {
      "type": "radio",
      "required": "",
      "name": "needSpecialAuthFile",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.model.needSpecialAuthFile, "false")
    },
    on: {
      "__c": function($event) {
        _vm.model.needSpecialAuthFile = "false"
      }
    }
  }), _vm._v("\n                        不需要")])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.needSpecialAuthFile === 'true' || _vm.model.needSpecialAuthFile === true),
      expression: "model.needSpecialAuthFile==='true' || model.needSpecialAuthFile===true"
    }]
  }, [_c('div', {
    staticClass: "pdt9 tip icon-info lh14"
  }, [_vm._v("\n                        重要提示："), _c('br'), _vm._v("   \n                        1. 请将已走完特批流程的截图上传附件；若特批流程未完成，不能提交审核；"), _c('br'), _vm._v("   \n                        2. 上传的附件名称需与特批流程名称一致，若流程中有多图，请为图片增加序号以明确顺序（如，二次预约特批-1.ipg）"), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "pdt9"
  }, [_c('custom-upload', {
    attrs: {
      "url": _vm.upload.url,
      "file-name": 'file',
      "is-multiple": false,
      "max-limit": _vm.upload.maxImgLength,
      "thumbnail-mode": true,
      "show-file-list": false,
      "type": 'imageList',
      "default-file-list": _vm.model.specialAuthPicsShow,
      "fileLimitSize": 2097152,
      "enable-head-image": false
    },
    on: {
      "on-max-limit": _vm.upload.onMaxLimit,
      "on-error": _vm.upload.onError,
      "on-success": _vm.upload.onSuccess,
      "on-delete": _vm.upload.onDelete,
      "on-file-size-max-limit": _vm.upload.onSizeLimited
    }
  })], 1), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needValidation && _vm.extra.isBD && _vm.model.needSpecialAuthFile == 'true' && _vm.model.specialAuthPics.length < 1),
      expression: "needValidation && extra.isBD && model.needSpecialAuthFile=='true' && model.specialAuthPics.length < 1"
    }],
    staticClass: "warning-msg"
  }, [_vm._v("\n                        请上传附件")])])])]), _vm._v(" "), (!_vm.model.IAmTheatre && (_vm.extra.isBD || _vm.account.accountType == 1) && _vm.subAccounts.length) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-2 control-label"
  }, [_vm._v("关联子账号:")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 col-item"
  }, [_vm._l((_vm.subAccounts), function(subAccount) {
    return (_vm.ticketSubAccount(subAccount, 'all')) ? _c('label', [_c('input', {
      attrs: {
        "type": "checkbox",
        "checked": "",
        "disabled": "",
        "title": subAccount.accountName
      }
    }), _vm._v("\n                    " + _vm._s(subAccount.accountName) + "\n                ")]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.subAccounts), function(subAccount) {
    return (_vm.ticketSubAccount(subAccount, 'single')) ? [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.model.bindedBizAccountId),
        expression: "model.bindedBizAccountId"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": subAccount.accountId == _vm.account.userId,
        "title": subAccount.accountName
      },
      domProps: {
        "value": subAccount.accountId,
        "checked": Array.isArray(_vm.model.bindedBizAccountId) ? _vm._i(_vm.model.bindedBizAccountId, subAccount.accountId) > -1 : (_vm.model.bindedBizAccountId)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.model.bindedBizAccountId,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = subAccount.accountId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.model.bindedBizAccountId = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.model.bindedBizAccountId = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.model.bindedBizAccountId = $$c
          }
        }
      }
    }), _vm._v("\n                        " + _vm._s(subAccount.accountName) + "\n                    ")])] : _vm._e()
  }), _vm._v(" "), _c('label', [_c('button', {
    staticClass: "btn btn-link no-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.selectAllAccounts(_vm.subAccountAll)
      }
    }
  }, [_vm._v("全选\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "annotate"
  }, [_vm._v("\n                    被选中的子账号,将根据权限设置结果,对该产品拥有上单或验证权限\n                ")])], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bottom-filled"
  }), _vm._v(" "), _c('sort-dialog', {
    attrs: {
      "model": _vm.sortDialog.model,
      "show": _vm.sortDialog.show
    },
    on: {
      "update:show": function($event) {
        _vm.sortDialog.show = $event
      },
      "saveSort": _vm.sortDialog.save
    }
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 569 */
/*!********************************************!*\
  !*** ./src/components/product/preview.vue ***!
  \********************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-4e5d0f76","scoped":true,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./preview.vue */ 570)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./preview.vue */ 571),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-4e5d0f76","hasScoped":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./preview.vue */ 572),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4e5d0f76",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 570 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e5d0f76","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/product/preview.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 571 */
/*!***************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/product/preview.vue ***!
  \***************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    data: function data() {
        return {};
    },

    props: {
        url: {
            type: String,
            required: true
        },
        show: {
            required: false
        }
    },
    methods: {
        close: function close() {
            this.show = false;
        }
    }
};

/***/ }),
/* 572 */
/*!******************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e5d0f76","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/preview.vue ***!
  \******************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "phone-preview"
  }, [_c('section', {
    staticClass: "phone-preview-buttons"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.url) ? _c('div', {
    staticClass: "phone-preview-wrapper"
  }, [_c('div', {
    staticClass: "phone-preview-window"
  }, [_c('div', {
    staticClass: "phone-preview-content"
  }, [_c('iframe', {
    attrs: {
      "src": _vm.url,
      "frameborder": "0",
      "width": "100%",
      "height": "100%"
    }
  })])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 573 */
/*!***********************************************!*\
  !*** ./src/components/product/teHuiApply.vue ***!
  \***********************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-38aa6a76","scoped":true,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./teHuiApply.vue */ 574)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./teHuiApply.vue */ 575),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-38aa6a76","hasScoped":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./teHuiApply.vue */ 576),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-38aa6a76",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 574 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-38aa6a76","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/product/teHuiApply.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 575 */
/*!******************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/product/teHuiApply.vue ***!
  \******************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _helpers = __webpack_require__(/*! helpers */ 16);

var _ticket = __webpack_require__(/*! api/ticket */ 50);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    data: function data() {
        var _this = this;

        return {
            dateBeginEnd: '',
            query: {
                startTime: null,
                endTime: null,
                isMtRecommend: 1
            },
            inDateOption: {
                allowInput: false,
                mode: 'range',
                onChange: function onChange(dates) {
                    dates = dates.length ? dates : _this.dateBeginEnd.split(' ~ ');
                    if (dates && dates.length) {
                        _this.query.startTime = (0, _helpers.formatDate)(dates[0], 'yyyy-MM-dd');
                        _this.query.endTime = (0, _helpers.formatDate)(dates[1], 'yyyy-MM-dd');
                    }
                }
            }
        };
    },

    props: {
        options: {
            'default': null
        },
        show: {
            require: true,
            'default': false
        }
    },
    methods: {
        save: function save() {
            var _this2 = this;

            if (!this.query.startTime || !this.query.endTime) {
                this.$message('请选择日期范围！');
                return;
            }
            (0, _ticket.tehuiApply)({
                startTime: this.query.startTime,
                endTime: this.query.endTime,
                dealId: this.options.dealId,
                isMtRecommend: this.query.isMtRecommend
            }).then(function (json) {
                _this2.$notify({
                    title: '提示',
                    message: '特惠票申请成功',
                    type: 'success'
                });
                _this2.show = false;
                _this2.$emit('teHuiApplyFinish', 'success');
                _this2.options = null;
            }, function (res) {
                _this2.$emit('teHuiApplyFinish', 'fail');
                _this2.$notify({
                    title: '提示',
                    message: res && res.message || '特惠申请失败',
                    type: 'error'
                });
            });
        },
        cancel: function cancel() {
            this.$emit('teHuiApplyFinish', 'cancel');
            this.show = false;
            this.options = null;
            this.query.startTime = this.query.endTime = null;
        },
        change: function change(open) {
            if (!open) {
                this.cancel();
            }
        }
    },
    watch: {
        dateBeginEnd: function dateBeginEnd(value) {
            var dates = value.split('~');
            if (dates.length) {
                this.startTime = dates[0];
                this.endTime = dates[1];
            }
        },
        options: function options() {
            if (this.options && this.options.dealId) {
                if (this.options.startTime) {
                    this.inDateOption.minDate = this.options.startTime;
                }
                if (this.options.endTime) {
                    this.inDateOption.maxDate = this.options.endTime;
                }
            }
        }
    },
    mounted: function mounted() {
        if (this.options && this.options.dealId) {
            if (this.options.startTime) {
                this.inDateOption.minDate = this.options.startTime;
            }
            if (this.options.endTime) {
                this.inDateOption.maxDate = this.options.endTime;
            }
        }
    }
};

/***/ }),
/* 576 */
/*!*********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38aa6a76","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/teHuiApply.vue ***!
  \*********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('v-dialog', {
    attrs: {
      "title": "提示",
      "size": "md",
      "show-close": true
    },
    on: {
      "input": _vm.change
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "tehui-line"
  }, [_vm._v("\n        您创建的deal已经满足特惠票的需求，请问您是否需要申请特惠票\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "tehui-line"
  }, [_c('strong', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("申请时间：")]), _vm._v(" "), _c('span', {
    attrs: {
      "data-date-ranger": ""
    }
  }, [_c('v-datepicker', {
    attrs: {
      "message": _vm.dateBeginEnd,
      "options": _vm.inDateOption
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "red",
    staticStyle: {
      "font-size": "12px",
      "color": "red"
    }
  }, [_vm._v("\n            特惠票涉及大量资源位置，目前仅开放1月内申请，超出时间后可继续申请\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "tehui-line"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query.isMtRecommend),
      expression: "query.isMtRecommend"
    }],
    attrs: {
      "type": "checkbox",
      "true-value": 1,
      "false-value": 0
    },
    domProps: {
      "checked": Array.isArray(_vm.query.isMtRecommend) ? _vm._i(_vm.query.isMtRecommend, null) > -1 : _vm._q(_vm.query.isMtRecommend, 1)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.query.isMtRecommend,
          $$el = $event.target,
          $$c = $$el.checked ? (1) : (0);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.query.isMtRecommend = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.query.isMtRecommend = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.query.isMtRecommend = $$c
        }
      }
    }
  }), _vm._v("同时申请美团推荐\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("取消")])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 577 */
/*!*********************************************************!*\
  !*** ./src/components/messagebox-custom/message.box.js ***!
  \*********************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (Vue) {
    var MessageBoxCustomConstructor = Vue.extend(__webpack_require__(/*! ./message.box.vue */ 578));

    var instance = void 0;

    // let defaultCallback = (action) => {
    //     instance.resolve({
    //         value: instance.vm.inputValue,
    //         action: action
    //     });
    // };
    var MessageBoxCustom = function MessageBoxCustom(options) {
        options = options || {};
        if (typeof options === 'string') {
            options = {
                message: options
            };
        }
        var userOnClose = options.onClose;

        options.onClose = function () {
            MessageBoxCustom.close(id, userOnClose);
        };

        instance = new MessageBoxCustomConstructor({
            data: options
        });
        instance.vm = instance.$mount();
        document.body.appendChild(instance.vm.$el);
        instance.vm.visible = true;
        instance.dom = instance.vm.$el;
        return instance.vm;
    };
    ['alert_html', 'confirm_html', 'prompt_html', 'msgbox_html'].forEach(function (type) {
        var proxy = '$' + type;
        MessageBoxCustom[proxy] = function (options) {
            options.type = type;
            var promise = new Promise(function (resolve, reject) {
                options.resolve = resolve;
                options.reject = reject;
            });
            MessageBoxCustom(options);
            return promise;
        };
        Vue.prototype[proxy] = MessageBoxCustom[proxy];
    });
    return MessageBoxCustomConstructor;
};

/***/ }),
/* 578 */
/*!**********************************************************!*\
  !*** ./src/components/messagebox-custom/message.box.vue ***!
  \**********************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./message.box.vue */ 579),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-0090e32c","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./message.box.vue */ 581),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 579 */
/*!*****************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/messagebox-custom/message.box.vue ***!
  \*****************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _class = __webpack_require__(/*! wind-dom/src/class */ 580);

var typeMap = {
    success: 'circle-check',
    info: 'information',
    warning: 'warning',
    error: 'circle-cross'
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    data: function data() {
        return {
            title: undefined,
            message: '',
            type: '',
            closeOnClickModal: true,
            closeOnPressEscape: true,

            customDefaultClass: 'message-box-default',
            customAnimaiClass: 'message-box-enter',

            inputValue: '',
            inputPlaceholder: '',
            inputPattern: null,
            inputErrorMessage: '输入有误',
            errorMessageClass: 'hidden',

            showConfirmButton: true,
            showCancelButton: true,
            showModal: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            confirmButtonClass: 'btn btn-primary',
            cancelButtonClass: 'btn btn-default',

            visible: false,
            lockScroll: true,
            resolve: null,
            reject: null
        };
    },

    props: {
        componentTitle: {}
    },
    mounted: function mounted() {
        var that = this;
        if (that.lockScroll) {
            document.body.style.overflow = 'hidden';
        }
    },

    computed: {
        messageBoxCustom: function messageBoxCustom() {
            var that = this;
            return that.visible ? that.customAnimaiClass : '';
        },
        buttonDisabledClass: function buttonDisabledClass() {
            var that = this;
            return that.confirmBtnDisabled ? 'btn-disabled' : '';
        },
        inputWrong: function inputWrong() {
            var that = this;
            if (!that.inputPattern) {
                return false;
            }
            return !that.inputPattern.test(that.inputValue);
        },
        confirmBtnDisabled: function confirmBtnDisabled() {
            var that = this;
            if (that.type === 'prompt' && that.inputPattern && that.inputWrong) {
                return true;
            } else {
                return false;
            }
        }
    },
    methods: {
        modalClose: function modalClose() {
            var that = this;
            if (!closeOnClickModal) {
                return;
            }
            that.close();
        },
        close: function close() {
            this.closed = true;
            this.visible = false;
            this.$el.addEventListener('transitionend', this.destroyElement);
        },
        destroyElement: function destroyElement() {
            if (this.lockScroll) {
                document.body.style.overflow = '';
            }
            this.$el.removeEventListener('transitionend', this.destroyElement);
            this.$destroy(true);
            this.$el.parentNode.removeChild(this.$el);
        },
        doClose: function doClose() {
            var _this = this;

            this.visible = false;
            this._closing = true;
            this.onClose && this.onClose();
            if (this.lockScroll) {
                setTimeout(function () {
                    if (_this.modal && _this.bodyOverflow !== 'hidden') {
                        document.body.style.overflow = _this.bodyOverflow;
                        document.body.style.paddingRight = _this.bodyPaddingRight;
                    }
                    _this.bodyOverflow = null;
                    _this.bodyPaddingRight = null;
                }, 200);
            }
            this.opened = false;
            if (!this.transition) {
                this.doAfterClose();
            }
        },
        handleWrapperClick: function handleWrapperClick() {
            if (this.closeOnClickModal) {
                this.handleAction('cancel');
            }
        },
        handleAction: function handleAction(action) {
            if (action === 'confirm' && this.confirmBtnDisabled) {
                return;
            }
            this.setPromise(action);
            this.close();
        },
        setPromise: function setPromise(action) {
            var that = this;
            if (!that.reject && !that.resolve) {
                if (that.callback) {
                    callback();
                } else {
                    return;
                }
            }
            var type = that.type;
            var message = {
                type: action
            };
            if (type === 'alert' || action === 'confirm') {
                if (type === 'prompt') {
                    message.value = that.inputValue;
                } else {
                    message.value = true;
                }
                that.resolve(message);
            } else if (action === 'cancel') {
                message.value = false;
                that.reject(message);
            }
        }
    },
    watch: {
        inputWrong: function inputWrong(val) {
            var that = this;
            that.errorMessageClass = !val ? 'hidden' : 'show';
        },
        visible: function visible(val) {
            var _this2 = this;

            if (this.type === 'alert' || this.type === 'confirm') {
                this.$nextTick(function () {
                    _this2.$el.querySelector('button.message-box-confirm').focus();
                });
            }
            if (this.type !== 'prompt') return;
            if (val) {
                setTimeout(function () {
                    _this2.$el.querySelector('input').focus();
                }, 500);
            } else {
                this.editorErrorMessage = '';
                (0, _class.removeClass)(this.$el.querySelector('input'), 'invalid');
            }
        }
    }

};

/***/ }),
/* 580 */,
/* 581 */
/*!*********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0090e32c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/messagebox-custom/message.box.vue ***!
  \*********************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "messagebox-wrapper-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "xigua-modal-dialog message-box-wrapper",
    class: {
      'xigua-modal-hidden': !_vm.showModal
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleWrapperClick($event)
      }
    }
  }, [_vm._t("message-box", [_c('div', {
    staticClass: "message-box",
    class: [_vm.customDefaultClass, _vm.messageBoxCustom],
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._t("header-wrapper", [(_vm.title !== undefined || true) ? _c('div', {
    staticClass: "xigua-modal-header"
  }, [_vm._t("title", [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleAction('cancel')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h3', {
    staticClass: "xigua-modal-title"
  }, [_vm._v(_vm._s(_vm.title))])])], 2) : _vm._e()]), _vm._v(" "), _vm._t("content-wrapper", [_c('div', {
    staticClass: "message-box-content"
  }, [_vm._t("content", [(_vm.type == 'alert_html' || _vm.type == 'msgbox_html') ? _c('div', {
    staticClass: "message-box-content-alert-text",
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'confirm_html') ? _c('div', {
    staticClass: "message-box-content-confirm-text"
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e(), _vm._v(" "), _vm._t("prompt", [(_vm.type == 'prompt_html') ? _c('div', {
    staticClass: "message-box-content-prompt"
  }, [_c('div', {
    staticClass: "message-box-content-prompt-title"
  }, [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _vm._t("prompt-content", [_c('div', {
    staticClass: "message-box-content-prompt-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    staticClass: "message-box-content-prompt-content-input",
    attrs: {
      "autofocus": "autofocus",
      "placeholder": _vm.inputPlaceholder
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleAction('confirm')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "message-box-content-prompt-content-errMessage",
    class: _vm.errorMessageClass
  }, [_vm._v(_vm._s(_vm.inputErrorMessage))])])])], 2) : _vm._e()]), _vm._v(" "), _vm._t("self")])], 2)]), _vm._v(" "), _vm._t("btns-wapper", [_c('div', {
    staticClass: "dialog-footer message-box-btns"
  }, [_vm._t("btns", [(_vm.showConfirmButton) ? _c('button', {
    staticClass: "message-box-confirm",
    class: [_vm.confirmButtonClass, _vm.buttonDisabledClass],
    attrs: {
      "disabled": _vm.confirmBtnDisabled
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleAction('confirm')
      }
    }
  }, [_vm._v(_vm._s(_vm.confirmButtonText))]) : _vm._e(), _vm._v(" "), (_vm.showCancelButton) ? _c('button', {
    class: [_vm.cancelButtonClass],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.handleAction('cancel')
      }
    }
  }, [_vm._v(_vm._s(_vm.cancelButtonText))]) : _vm._e()])], 2)])], 2)])], 2)])
},staticRenderFns: []}

/***/ }),
/* 582 */
/*!********************************************************!*\
  !*** ./src/views/ticket/product/common/modelSchema.js ***!
  \********************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelReady: true,
    sourceType: 1,
    minBuyCount: 1,
    servicePhones: [{
        phone: '',
        startHour: 0,
        startMin: 0,
        endHour: 0,
        endMin: 0
    }],
    contractInfoType: 1,
    contractInfoRule: {
        mobile: false
    },
    visitorInfoType: 2,
    visitorInfoGroupSize: 2,
    visitorInfoRule: {
        name: true,
        credentials: false,
        mobile: false
    },
    aheadHoursType: 1,
    aheadHours: 0,
    minutes: 30,
    aheadDays: 0,
    hours: 0,
    orderCancelTime: 30,
    baseMsRatioSnapshot: null,
    voucherTimes: [{
        voucherStartTime: 0,
        voucherEndTime: 23 * 60 + 59,
        needVoucherOrGetInTimeSupplement: false,
        voucherOrGetInTimeSupplement: ''
    }],
    getVoucherRule: {
        needCertificateSupplement: false,
        certificateSupplement: '',
        voucherLoaders: [1]
    },
    getTicketRule: {
        needCertificateSupplement: false,
        certificateSupplement: '',
        voucherLoaders: [1]
    },
    generateTicketWorkTime: {
        startWorkHour: 8,
        startWorkMinute: 0,
        endWorkHour: 20,
        endWorkMinute: 0
    },
    needTicket: false,
    ticketGetAddress: [''],
    getInAddresses: [''],
    otherNote: '',
    // images
    dealImageInfos: [],
    includeItems: [{
        count: 1
    }],
    include: '',
    exclude: '',
    stock: null,
    stockType: 1,
    sellType: 1,
    useDateMode: 0,
    useDateDays: null,
    scheduleOfflineType: 1,
    scheduleOfflineTime: null,
    refundFeeMode: 1,
    refundFee: null,
    refundTimeType: 2,
    refundLimitDays: null,
    refundLimitHours: null,
    refundLimitMinutes: null,
    unavailableDates: [],
    partlyRefund: true,
    freeTicketType: null,
    associatedContractList: [],
    freeTicketAssociatedAccount: '',
    freeTicketAssociatedDetail: '',
    statementId: null,
    marketPrice: null,
    validWeekRule: {
        'monday': true,
        'tuesday': true,
        'wednesday': true,
        'thursday': true,
        'friday': true,
        'saturday': true,
        'sunday': true
    },
    voucherDateBegin: null,
    voucherDateEnd: null,
    needSpecialAuthFile: false,
    specialMsRatioReasonType: 1,
    specialMsRatioReason: '',
    onlineMsRatioPriceInfo: {},
    specialAuthPics: [],
    specialAuthPicsShow: [],
    mtPrice: null,
    settlementPrice: null,
    refundType: 2, // 极速退
    scheduleOnlineType: 1,
    scheduleOnlineTime: null,
    dayPriceStockRules: [],
    generateTicketMethod: 1,
    containInsurance: false,
    ticketCategory: {
        ticket: {},
        subTicket: {},
        poi: [],
        createTicketCategoryInfo: {
            ticketCategoryName: '',
            usePeople: 1,
            timeLimitedRange: 3,
            timeLimitedRangeText: '',
            ticketCategoryPrice: '',
            uploadMaterialType: 2,
            uploadMaterialText: '',
            uploadMaterialImage: []
        }
    },
    ticketPoiDiscounts: [],
    title: '',
    mtCategory: null,
    contractId: null,
    contractNum: null,
    isAllAvailable: true,
    availableCount: 1,
    scrAttrs: {
        needBookOffline: false,
        offlineBookRule: {
            bookTypes: []
        }
    },
    bindedBizAccountId: [],
    phoneLimitDays: 1,
    limitDayType: 0,
    phoneLimitUnitType: 0,
    idLimitDays: 1,
    idLimitUnitType: 0,
    // 剧场票
    theatreWhiteList: false,
    partnerDealId: '',
    IAmTheatre: false, // 辅助字段，便于各个tab数据共享
    ticketPriceType: 0, // 产品类型
    canSeatSelection: false, // 是否支持在线选座
    seatImage: '', // 座位图片
    seatImageShow: [],
    needAheadSupplement: false,
    aheadHoursBeforeUse: 0,
    aheadMinutesBeforeUse: 30,
    returnVoucher: true, //下单时是否传回凭证
    voucherText: '', //不传回凭证时的文案
    hasRefundLimitTime: false,
    canRefundCurrentDate: true,
    oPCanRefundCurrentDate: false,
    refundLimitHourFrom: 8,
    refundLimitMinuteFrom: 0,
    refundLimitHourTo: 21,
    refundLimitMinuteTo: 0,
    refundStairsRules: [{
        refundFeeMode: 1,
        refundFee: 0,
        refundFeeDump: 0,
        refundTimeType: 2,
        aheadDays: 0,
        hours: 0,
        minutes: 0,
        refundLimitMinutes: null
    }],
    refundNote: '',
    supplierProtocolRule: {
        rebateProtocols: [],
        packageProtocols: []
    },
    insuranceNote: ''
};

/***/ }),
/* 583 */
/*!**********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-750bbfee","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ticket/product/item/Main.vue ***!
  \**********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-item",
    attrs: {
      "loading": "loading"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.model.partnerDealId) + "\n    "), _c('section', {
    staticClass: "product-item-content"
  }, [_c('v-tabs', {
    ref: "tabs",
    staticClass: "fixed-header-content",
    attrs: {
      "active-name": _vm.activeIndex
    },
    on: {
      "tab-click": _vm.tabChange
    }
  }, [_c('v-tab-pane', {
    attrs: {
      "label": "产品基本信息"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showErrorOnTabs && _vm.errors[0] && _vm.errors[0].items && _vm.errors[0].items['tab1'] && _vm.errors[0].items['tab1'].length > 0),
      expression: "showErrorOnTabs && errors[0] && errors[0].items && errors[0].items['tab1'] && errors[0].items['tab1'].length > 0"
    }],
    staticClass: "icon-info help-icon tab-error-icon",
    slot: "title"
  }), _vm._v(" "), _c('info', {
    ref: "info",
    attrs: {
      "model": _vm.model,
      "errors": _vm.errors,
      "validate": _vm.tabs[0].status,
      "mode": _vm.mode,
      "extra": _vm.extra,
      "loaded": _vm.modelLoaded
    },
    on: {
      "update:model": function($event) {
        _vm.model = $event
      },
      "updateMsRatio": _vm.updateMsRatio,
      "update:errors": function($event) {
        _vm.errors = $event
      },
      "update:validate": function($event) {
        _vm.tabs[0].status = $event
      }
    }
  })], 1), _vm._v(" "), _c('v-tab-pane', {
    attrs: {
      "label": "购买使用说明"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showErrorOnTabs && _vm.errors[0] && _vm.errors[0].items && _vm.errors[0].items['tab2'] && _vm.errors[0].items['tab2'].length > 0),
      expression: "showErrorOnTabs && errors[0] && errors[0].items && errors[0].items['tab2'] && errors[0].items['tab2'].length > 0"
    }],
    staticClass: "icon-info help-icon tab-error-icon",
    slot: "title"
  }), _vm._v(" "), _c('instruction', {
    attrs: {
      "model": _vm.model,
      "validate": _vm.tabs[1].status,
      "errors": _vm.errors,
      "mode": _vm.mode,
      "extra": _vm.extra
    },
    on: {
      "update:model": function($event) {
        _vm.model = $event
      },
      "update:validate": function($event) {
        _vm.tabs[1].status = $event
      },
      "update:errors": function($event) {
        _vm.errors = $event
      }
    }
  })], 1), _vm._v(" "), _c('v-tab-pane', {
    attrs: {
      "label": "价格/库存/有效期"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showErrorOnTabs && _vm.errors[0] && _vm.errors[0].items && _vm.errors[0].items['tab3'] && _vm.errors[0].items['tab3'].length > 0),
      expression: "showErrorOnTabs && errors[0] && errors[0].items && errors[0].items['tab3'] && errors[0].items['tab3'].length > 0"
    }],
    staticClass: "icon-info help-icon tab-error-icon",
    slot: "title"
  }), _vm._v(" "), _c('price', {
    ref: "price",
    attrs: {
      "model": _vm.model,
      "errors": _vm.errors,
      "extra": _vm.extra,
      "mode": _vm.mode
    },
    on: {
      "update:model": function($event) {
        _vm.model = $event
      },
      "update:errors": function($event) {
        _vm.errors = $event
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "row button-area"
  }, [_c('div', {
    staticClass: "col-sm-4 col-sm-offset-2"
  }, [_c('v-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex > 1),
      expression: "activeIndex > 1"
    }],
    attrs: {
      "disabled": _vm.activeIndex == 1,
      "content": "上一步",
      "type": "primary"
    },
    on: {
      "click": _vm.prevStep
    }
  }), _vm._v(" "), _c('v-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode != 'new' || _vm.activeIndex == _vm.tabs.length),
      expression: "mode != 'new' || activeIndex== tabs.length"
    }],
    attrs: {
      "disabled": _vm.mode == 'readonly',
      "content": "保存",
      "type": "primary"
    },
    on: {
      "click": _vm.saveModel
    }
  }), _vm._v(" "), _c('v-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode != 'new' || _vm.activeIndex == _vm.tabs.length),
      expression: "mode != 'new' || activeIndex== tabs.length"
    }],
    attrs: {
      "disabled": _vm.mode == 'readonly',
      "content": "保存并提交审核",
      "type": "warning"
    },
    on: {
      "click": _vm.saveAndCheck
    }
  }), _vm._v(" "), _c('v-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeIndex < _vm.tabs.length),
      expression: "activeIndex < tabs.length"
    }],
    attrs: {
      "disabled": _vm.activeIndex == _vm.tabs.length,
      "content": "下一步",
      "type": "primary"
    },
    on: {
      "click": _vm.nextStep
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mode != 'readonly') ? _c('preview', {
    staticClass: "preview-product",
    attrs: {
      "url": _vm.previewUrl
    }
  }, [(_vm.previewShowTrigger) ? _c('button', {
    staticClass: "btn btn-sm btn-warning",
    on: {
      "click": function($event) {
        _vm.previewShowTrigger = false
      }
    }
  }, [_vm._v("X")]) : _vm._e(), _vm._v(" "), (_vm.previewShowTrigger) ? _c('button', {
    staticClass: "btn btn-sm btn-warning",
    on: {
      "click": function($event) {
        _vm.saveAndPreview()
      }
    }
  }, [_vm._v("更新手机并预览产品")]) : _vm._e(), _vm._v(" "), (!_vm.previewShowTrigger) ? _c('button', {
    staticClass: "btn btn-sm btn-warning",
    on: {
      "click": function($event) {
        _vm.saveAndPreview()
      }
    }
  }, [_vm._v("保存并手机预览产品")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('te-hui-apply', {
    attrs: {
      "options": _vm.teHuiOption,
      "show": _vm.teHuiShow
    },
    on: {
      "update:show": function($event) {
        _vm.teHuiShow = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 584 */
/*!************************************************!*\
  !*** ./src/views/ticket/product/tuan/Main.vue ***!
  \************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-a4f899e4","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Main.vue */ 585)
}
var Component = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Main.vue */ 586),
  /* template */
  __webpack_require__(/*! !../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-a4f899e4","hasScoped":false}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Main.vue */ 591),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 585 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a4f899e4","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/ticket/product/tuan/Main.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */
/*!*******************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/ticket/product/tuan/Main.vue ***!
  \*******************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ 22);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(/*! babel-runtime/helpers/asyncToGenerator */ 23);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _Instruction = __webpack_require__(/*! ../item/Instruction.vue */ 228);

var _Instruction2 = _interopRequireDefault(_Instruction);

var _Info = __webpack_require__(/*! ../item/Info.vue */ 229);

var _Info2 = _interopRequireDefault(_Info);

var _Price = __webpack_require__(/*! ../item/Price.vue */ 235);

var _Price2 = _interopRequireDefault(_Price);

var _Rule = __webpack_require__(/*! ./Rule.vue */ 587);

var _Rule2 = _interopRequireDefault(_Rule);

var _tuanTicket = __webpack_require__(/*! api/tuanTicket */ 237);

var _defaultModel = __webpack_require__(/*! ../common/defaultModel */ 159);

var _defaultModel2 = _interopRequireDefault(_defaultModel);

var _vuex = __webpack_require__(/*! vuex */ 14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        Instruction: _Instruction2.default,
        Info: _Info2.default,
        Price: _Price2.default,
        Rule: _Rule2.default
    },
    data: function data() {
        return {
            entryTime: '',
            teHuiOption: null,
            teHuiShow: false,
            previewShowTrigger: '',
            loading: false,
            id: '',
            errors: [],
            model: {},
            activeIndex: '0',
            mode: 'edit',
            showErrorOnTabs: false,
            userinfo: false,
            modelLoaded: false,
            saveLoading: false,
            onlineLoading: false
        };
    },
    created: function created() {
        // 组件创建完后获取数据，
        // 此时 data 已经被 observed 了
        window.router = this.$route;
        this.initProduct();
    },

    methods: {
        initProduct: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var id, supportModes, json;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                id = this.$route.params.id;

                                this.id = id;

                                supportModes = ['new', 'edit', 'readonly'];

                                if (supportModes.indexOf(this.$route.query.mode) > -1) {
                                    this.mode = this.$route.query.mode;
                                } else {
                                    this.mode = id ? 'edit' : 'new';
                                }

                                if (!id) {
                                    _context.next = 19;
                                    break;
                                }

                                this.loading = true;
                                _context.prev = 6;
                                _context.next = 9;
                                return (0, _tuanTicket.get)(id);

                            case 9:
                                json = _context.sent;

                                this.model = (0, _defaultModel2.default)(false, false, json.data);

                                _context.next = 17;
                                break;

                            case 13:
                                _context.prev = 13;
                                _context.t0 = _context['catch'](6);

                                this.error(_context.t0.message || '数据加载失败！');
                                this.model = (0, _defaultModel2.default)();

                            case 17:
                                _context.next = 21;
                                break;

                            case 19:
                                this.mode = 'new';
                                this.model = (0, _defaultModel2.default)();

                            case 21:
                                this.setDefaultValue();
                                this.modelLoaded = true;

                            case 23:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[6, 13]]);
            }));

            function initProduct() {
                return _ref.apply(this, arguments);
            }

            return initProduct;
        }(),
        setDefaultValue: function setDefaultValue() {
            // 一些强制设置的参数，以后肯定会改，先放在这
            // 不包含保险
            this.model.containInsurance = false;
            this.model.insuranceNote = null;

            // 不可退
            this.model.refundType = 3;

            // 不可单独售卖
            this.model.sellType = 1;

            // sourceType写死成1
            this.model.sourceType = 1;

            // 美团出票
            this.model.generateTicketMethod = 1;

            //只可手动上架
            this.model.scheduleOnlineType = 3;

            if (this.mode === 'new') {
                this.model.groupRule = {
                    relationMtDealId: 0,
                    groupNum: 2,
                    availableDays: 0,
                    availableHours: 1
                };
            }
        },
        save: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(parseInt(this.model.groupRule.relationMtDealId, 10) <= 0)) {
                                    _context2.next = 3;
                                    break;
                                }

                                this.error('请先拉取关联产品');
                                return _context2.abrupt('return');

                            case 3:
                                this.saveLoading = true;
                                _context2.next = 6;
                                return this.saveModel();

                            case 6:
                                if (!_context2.sent) {
                                    _context2.next = 8;
                                    break;
                                }

                                this.$Notice.success({ title: '保存成功' });

                            case 8:
                                this.saveLoading = false;

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function save() {
                return _ref2.apply(this, arguments);
            }

            return save;
        }(),
        saveAndOnline: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (!(parseInt(this.model.groupRule.relationMtDealId, 10) <= 0)) {
                                    _context3.next = 3;
                                    break;
                                }

                                this.error('请先拉取关联产品');
                                return _context3.abrupt('return');

                            case 3:
                                this.onlineLoading = true;
                                _context3.prev = 4;
                                _context3.next = 7;
                                return this.saveModel();

                            case 7:
                                if (!_context3.sent) {
                                    _context3.next = 11;
                                    break;
                                }

                                _context3.next = 10;
                                return (0, _tuanTicket.online)(this.id);

                            case 10:
                                this.$Notice.success({ title: '保存并上线成功' });

                            case 11:
                                _context3.next = 16;
                                break;

                            case 13:
                                _context3.prev = 13;
                                _context3.t0 = _context3['catch'](4);

                                this.$Notice.error({ title: '上线失败', desc: _context3.t0.message || '上线失败, 网络错误' });

                            case 16:
                                this.onlineLoading = false;

                            case 17:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[4, 13]]);
            }));

            function saveAndOnline() {
                return _ref3.apply(this, arguments);
            }

            return saveAndOnline;
        }(),
        saveModel: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
                var id, state;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.prev = 0;

                                if (!(this.mode === 'new')) {
                                    _context4.next = 14;
                                    break;
                                }

                                _context4.next = 4;
                                return (0, _tuanTicket.create)(this.prepareData(this.model));

                            case 4:
                                id = _context4.sent.data.dealId;

                                if (!id) {
                                    _context4.next = 11;
                                    break;
                                }

                                this.id = id;
                                this.mode = 'edit';
                                state = this.$router.resolve({ name: this.$route.name, query: { mode: 'edit', supplierId: this.extra.supplierId }, params: { id: id } });

                                history.pushState(null, 'notp', state.href);
                                return _context4.abrupt('return', true);

                            case 11:
                                throw new Error('接口错误，请稍后重试');

                            case 14:
                                _context4.next = 16;
                                return (0, _tuanTicket.update)(this.prepareData(this.model), this.id);

                            case 16:
                                return _context4.abrupt('return', true);

                            case 17:
                                _context4.next = 23;
                                break;

                            case 19:
                                _context4.prev = 19;
                                _context4.t0 = _context4['catch'](0);

                                this.$Notice.error({ title: '保存失败', desc: _context4.t0.message || '保存失败, 网络错误' });
                                return _context4.abrupt('return', false);

                            case 23:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this, [[0, 19]]);
            }));

            function saveModel() {
                return _ref4.apply(this, arguments);
            }

            return saveModel;
        }(),
        setModel: function () {
            var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(id, contractNum) {
                var json;
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                json = void 0;
                                _context5.prev = 1;
                                _context5.next = 4;
                                return (0, _tuanTicket.pullData)(id, contractNum);

                            case 4:
                                json = _context5.sent;
                                _context5.next = 11;
                                break;

                            case 7:
                                _context5.prev = 7;
                                _context5.t0 = _context5['catch'](1);

                                this.$Notice.error({ title: '拉取失败', desc: _context5.t0.message || '网络错误' });
                                return _context5.abrupt('return', false);

                            case 11:
                                this.model = (0, _defaultModel2.default)(false, false, json.data);
                                this.setDefaultValue();
                                this.model.contractNum = this.extra.contractNum;
                                this.model.contractId = this.extra.contractId;
                                this.model.groupRule.relationMtDealId = id;
                                _context5.next = 18;
                                return this.$refs.info.updateModel();

                            case 18:
                                this.$refs.instruction.updateModel();
                                return _context5.abrupt('return', true);

                            case 20:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this, [[1, 7]]);
            }));

            function setModel(_x, _x2) {
                return _ref5.apply(this, arguments);
            }

            return setModel;
        }(),
        error: function error(message) {
            this.$Message.error({
                content: message,
                duration: 5
            });
        },
        prepareData: function prepareData(model) {
            var data = JSON.parse(JSON.stringify(model));
            if (parseInt(data.scheduleOfflineType, 10) === 1) {
                data.scheduleOfflineTime = null;
            }
            if (!data.includeItems || data.includeItems && data.includeItems.length <= 1) {
                data.isAllAvailable = undefined;
                data.availableCount = undefined;
            }
            if (data.useDateMode == 1 && data.stockType === 1) {
                data.dayPriceStockRules.forEach(function (item) {
                    item.stock = -1;
                });
            }
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = data.ticketPoiDiscounts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var crowd = _step.value;

                    if (!crowd.ticketDiscountList || crowd.ticketDiscountList.length === 1 && crowd.ticketDiscountList[0].crowd === null) {
                        crowd.ticketDiscountList = null;
                    }
                }
                //有效期模式，不限库存，stock设为-1
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (parseInt(data.stockType, 10) === 1 && parseInt(data.useDateMode, 10) === 0) {
                data.stock = -1;
            }
            // 处理换票凭证和入园凭证，只能出现1和6
            data.getTicketRule.voucherLoaders = [];
            data.getVoucherRule.voucherLoaders = [];
            if (model.needTicket) {
                this.model.getTicketRule.voucherLoaders.indexOf(1) > -1 ? data.getTicketRule.voucherLoaders.push(1) : '';
                this.model.getTicketRule.voucherLoaders.indexOf(6) > -1 ? data.getTicketRule.voucherLoaders.push(6) : '';
            } else {
                this.model.getVoucherRule.voucherLoaders.indexOf(1) > -1 ? data.getVoucherRule.voucherLoaders.push(1) : '';
                this.model.getVoucherRule.voucherLoaders.indexOf(6) > -1 ? data.getVoucherRule.voucherLoaders.push(6) : '';
            }

            return data;
        }
    },
    computed: Object.assign({}, (0, _vuex.mapGetters)(['account']), {
        // 获取其他非deal的信息
        extra: function extra() {
            var DirectDealIDs = [2, // 直连V2
            4, // 直连V1
            5];
            return {
                partnerDealId: this.model.partnerDealId,
                // 是否是直签商家， true是，false为三方
                isDirect: false,
                // 是否直连产品
                isDirectDeal: false,
                // 是否是bd上单模板
                isBD: true,
                contractNum: this.$route.query.contractNum || this.model.contractNum,
                contractId: this.$route.query.contractId || this.model.contractId,
                supplierId: this.$route.query.supplierId || this.account.supplierId,
                isNew: (!this.id || this.mode === 'copy') && !this.model.mtDealId
            };
        }
    })
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 587 */
/*!************************************************!*\
  !*** ./src/views/ticket/product/tuan/Rule.vue ***!
  \************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-48f42a5e","scoped":true,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Rule.vue */ 588)
}
var Component = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Rule.vue */ 589),
  /* template */
  __webpack_require__(/*! !../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-48f42a5e","hasScoped":true}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Rule.vue */ 590),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-48f42a5e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 588 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-48f42a5e","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/ticket/product/tuan/Rule.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 589 */
/*!*******************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/ticket/product/tuan/Rule.vue ***!
  \*******************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ 22);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(/*! babel-runtime/helpers/asyncToGenerator */ 23);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _index = __webpack_require__(/*! components/content-block/index.vue */ 76);

var _index2 = _interopRequireDefault(_index);

var _ticket = __webpack_require__(/*! data/ticket */ 155);

var _tuanTicket = __webpack_require__(/*! api/tuanTicket */ 237);

var _defaultModel = __webpack_require__(/*! ../common/defaultModel */ 159);

var _defaultModel2 = _interopRequireDefault(_defaultModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    components: { ContentBlock: _index2.default },
    data: function data() {
        return {
            pulling: false,
            pullId: '',
            relationMtDealId: ''
        };
    },

    props: {
        model: {
            type: Object,
            required: true
        },
        mode: {
            type: String,
            required: false
        },
        setModel: {
            type: Function
        },
        extra: {
            type: Object,
            required: true
        }
    },
    created: function created() {
        if (parseInt(this.model.groupRule.relationMtDealId, 10) > 0) {
            this.relationMtDealId = this.model.groupRule.relationMtDealId;
        }
    },

    methods: {
        error: function error(message) {
            this.$Message.error({
                content: message,
                duration: 5
            });
        },
        pull: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                var _this = this;

                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this.$Modal.confirm({
                                    onOk: function () {
                                        var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                                            return _regenerator2.default.wrap(function _callee$(_context) {
                                                while (1) {
                                                    switch (_context.prev = _context.next) {
                                                        case 0:
                                                            _context.next = 2;
                                                            return _this.setModel(_this.pullId, _this.extra.contractNum);

                                                        case 2:
                                                            if (!_context.sent) {
                                                                _context.next = 4;
                                                                break;
                                                            }

                                                            _this.relationMtDealId = _this.pullId;

                                                        case 4:
                                                        case 'end':
                                                            return _context.stop();
                                                    }
                                                }
                                            }, _callee, _this);
                                        }));

                                        function onOk() {
                                            return _ref2.apply(this, arguments);
                                        }

                                        return onOk;
                                    }(),
                                    render: function render(h) {
                                        return h('Input', {
                                            props: {
                                                value: _this.pullId,
                                                autofocus: true,
                                                placeholder: '请输入拉取dealid'
                                            },
                                            on: {
                                                input: function input(val) {
                                                    _this.pullId = val;
                                                }
                                            }
                                        });
                                    }
                                });

                            case 1:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function pull() {
                return _ref.apply(this, arguments);
            }

            return pull;
        }()
    }
};

/***/ }),
/* 590 */
/*!**********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48f42a5e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ticket/product/tuan/Rule.vue ***!
  \**********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', {
    staticStyle: {
      "margin-bottom": "200px"
    },
    attrs: {
      "disabled": _vm.mode == 'readonly'
    }
  }, [_c('h2', [_vm._v("拼团信息")]), _vm._v(" "), _c('content-block', {
    attrs: {
      "title": "关联产品id",
      "isRequired": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.relationMtDealId))]), _vm._v(" "), (this.mode === 'new') ? _c('Button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.pulling,
      "loading": _vm.pulling
    },
    on: {
      "click": _vm.pull
    }
  }, [(!_vm.pulling) ? _c('span', [_vm._v("拉取产品信息")]) : _c('span', [_vm._v("拉取中...")])]) : _vm._e()], 1), _vm._v(" "), _c('content-block', {
    attrs: {
      "title": "成团人数",
      "isRequired": ""
    }
  }, [_c('InputNumber', {
    attrs: {
      "disabled": this.mode !== 'new',
      "max": 1000,
      "min": 2
    },
    model: {
      value: (_vm.model.groupRule.groupNum),
      callback: function($$v) {
        _vm.model.groupRule.groupNum = $$v
      },
      expression: "model.groupRule.groupNum"
    }
  }), _vm._v("\n            "), _c('span', {
    staticClass: "icon-error help-icon"
  }), _vm._v(" 在\"团有效时间\"内满足\"成团人数\"才能拼团成功，取值范围[2, 1000]正整数\n    ")], 1), _vm._v(" "), _c('content-block', {
    attrs: {
      "title": "团有效时间",
      "isRequired": ""
    }
  }, [_c('Select', {
    staticClass: "inline-input nano-select",
    attrs: {
      "disabled": this.mode !== 'new'
    },
    model: {
      value: (_vm.model.groupRule.availableDays),
      callback: function($$v) {
        _vm.model.groupRule.availableDays = $$v
      },
      expression: "model.groupRule.availableDays"
    }
  }, _vm._l((16), function(n) {
    return _c('Option', {
      key: n - 1,
      attrs: {
        "value": n - 1
      }
    }, [_vm._v(_vm._s(n - 1))])
  })), _vm._v("\n        天\n        "), _c('Select', {
    staticClass: "inline-input nano-select",
    attrs: {
      "disabled": this.mode !== 'new'
    },
    model: {
      value: (_vm.model.groupRule.availableHours),
      callback: function($$v) {
        _vm.model.groupRule.availableHours = $$v
      },
      expression: "model.groupRule.availableHours"
    }
  }, _vm._l((23), function(n) {
    return _c('Option', {
      key: n,
      attrs: {
        "value": n
      }
    }, [_vm._v(_vm._s(n))])
  })), _vm._v("\n        小时\n            "), _c('span', {
    staticClass: "icon-error help-icon"
  }), _vm._v(" 1个拼团从发起开始进行倒计时\n    ")], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 591 */
/*!***********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4f899e4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ticket/product/tuan/Main.vue ***!
  \***********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-item",
    attrs: {
      "loading": "loading"
    }
  }, [_c('section', {
    staticClass: "product-item-content"
  }, [_c('Tabs', {
    attrs: {
      "animated": false
    },
    model: {
      value: (_vm.activeIndex),
      callback: function($$v) {
        _vm.activeIndex = $$v
      },
      expression: "activeIndex"
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "拼团信息",
      "name": "0"
    }
  }, [(_vm.modelLoaded) ? _c('rule', {
    attrs: {
      "mode": _vm.mode,
      "setDefaultValue": _vm.setDefaultValue,
      "setModel": _vm.setModel,
      "model": _vm.model,
      "extra": _vm.extra
    },
    on: {
      "update:model": function($event) {
        _vm.model = $event
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "产品基本信息",
      "name": "1",
      "disabled": !_vm.modelLoaded
    }
  }, [_c('info', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modelLoaded),
      expression: "modelLoaded"
    }],
    ref: "info",
    attrs: {
      "model": _vm.model,
      "errors": _vm.errors,
      "validate": false,
      "mode": "readonly",
      "extra": _vm.extra,
      "loaded": _vm.modelLoaded,
      "is-tuan": _vm.mode !== 'readonly'
    },
    on: {
      "update:model": function($event) {
        _vm.model = $event
      },
      "update:errors": function($event) {
        _vm.errors = $event
      }
    }
  })], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "购买使用说明",
      "name": "2",
      "disabled": !_vm.modelLoaded
    }
  }, [_c('instruction', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modelLoaded),
      expression: "modelLoaded"
    }],
    ref: "instruction",
    attrs: {
      "model": _vm.model,
      "errors": _vm.errors,
      "validate": false,
      "extra": _vm.extra,
      "mode": "readonly",
      "is-tuan": _vm.mode !== 'readonly',
      "loaded": _vm.modelLoaded
    },
    on: {
      "update:model": function($event) {
        _vm.model = $event
      },
      "update:errors": function($event) {
        _vm.errors = $event
      }
    }
  })], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "价格/库存/有效期",
      "name": "3",
      "disabled": !_vm.modelLoaded
    }
  }, [_c('price', {
    ref: "price",
    attrs: {
      "model": _vm.model,
      "errors": _vm.errors,
      "extra": _vm.extra,
      "mode": "readonly",
      "is-tuan": _vm.mode !== 'readonly'
    },
    on: {
      "update:model": function($event) {
        _vm.model = $event
      },
      "update:errors": function($event) {
        _vm.errors = $event
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modelLoaded),
      expression: "modelLoaded"
    }],
    staticClass: "row button-area"
  }, [_c('div', {
    staticClass: "col-sm-4 col-sm-offset-2"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.onlineLoading,
      "loading": _vm.saveLoading
    },
    on: {
      "click": _vm.save
    }
  }, [(!_vm.saveLoading) ? _c('span', [_vm._v("保存")]) : _c('span', [_vm._v("保存中...")])]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.saveLoading,
      "loading": _vm.onlineLoading
    },
    on: {
      "click": _vm.saveAndOnline
    }
  }, [(!_vm.onlineLoading) ? _c('span', [_vm._v("保存并上线")]) : _c('span', [_vm._v("保存中...")])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 592 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4794acf8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/ticket/verify/phone/Main.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 593 */
/*!*******************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/ticket/verify/phone/Main.vue ***!
  \*******************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {};

/***/ }),
/* 594 */
/*!**********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4794acf8","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ticket/verify/phone/Main.vue ***!
  \**********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-voucher"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'ticketphone'
      }
    }
  }, [_vm._v("电话验证")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'ticketapp'
      }
    }
  }, [_vm._v("app验证")])], 1)]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 595 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a06f7a1","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/ticket/verify/phone/pages/phoneVerify.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 596 */
/*!********************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/ticket/verify/phone/pages/phoneVerify.vue ***!
  \********************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _phoneVerify = __webpack_require__(/*! api/phoneVerify.js */ 597);

var _vuex = __webpack_require__(/*! vuex */ 14);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    data: function data() {
        return {
            phones: [],
            //partnerSupplierId: 16769,
            phoneNumber: ''
        };
    },

    computed: Object.assign({}, (0, _vuex.mapGetters)(['account']), {
        partnerSupplierId: function partnerSupplierId() {
            return this.$route.query.supplierId || this.account.supplierId;
        }
    }),
    created: function created() {
        var _this = this;

        (0, _phoneVerify.getPhoneVerifyTable)({
            partnerSupplierId: this.partnerSupplierId
        }).then(function (response) {
            if (response.status === 0 && response.data && response.data.length) {
                _this.phones = response.data;
            }
        }).catch(function (error) {
            _this.alert(error);
        });
    },
    methods: {
        unbindPhone: function unbindPhone(item) {
            var _this2 = this;

            (0, _phoneVerify.unbindPhone)({
                phone: item.phone
            }).then(function (response) {
                if (response.status === 0) {
                    _this2.alert("操作成功");
                    _this2.getPhoneVerifyTable();
                }
            }).catch(function (error) {
                _this2.alert(error);
            });
        },
        bindPhone: function bindPhone() {
            var _this3 = this;

            (0, _phoneVerify.bindPhone)({
                phone: this.phoneNumber,
                partnerSupplierId: this.partnerSupplierId
            }).then(function (response) {
                if (response.status === 0) {
                    _this3.alert("操作成功");
                    _this3.getPhoneVerifyTable();
                    _this3.phoneNumber = '';
                }
            }).catch(function (error) {
                _this3.alert(error);
            });
        },
        getPhoneVerifyTable: function getPhoneVerifyTable() {
            var _this4 = this;

            (0, _phoneVerify.getPhoneVerifyTable)({
                partnerSupplierId: this.partnerSupplierId
            }).then(function (response) {
                if (response.status === 0 && response.data && response.data.length) {
                    _this4.phones = response.data;
                }
            }).catch(function (error) {
                _this4.alert(error);
            });
        },
        alert: function alert(message) {
            this.$alert({
                title: '提示',
                message: message,
                showCancelButton: false,
                closeOnClickModal: false
            });
        }
    }
};

/***/ }),
/* 597 */
/*!********************************!*\
  !*** ./src/api/phoneVerify.js ***!
  \********************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bindPhone = exports.unbindPhone = exports.getPhoneVerifyTable = undefined;

var _axios = __webpack_require__(/*! axios */ 12);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPhoneVerifyTable = exports.getPhoneVerifyTable = function getPhoneVerifyTable(queryparams) {
    return _axios2.default.get('virgo/fe/3f/supplier/ivr/phone/query', {
        params: Object.assign({ feclient: 'lvyou_web' }, queryparams)
    });
};

var unbindPhone = exports.unbindPhone = function unbindPhone(queryparams) {
    return _axios2.default.delete('virgo/fe/3f/supplier/ivr/phone/delete', {
        params: Object.assign({ feclient: 'lvyou_web' }, queryparams)
    });
};

var bindPhone = exports.bindPhone = function bindPhone(data) {
    var url = 'virgo/fe/3f/supplier/ivr/phone/add';
    return _axios2.default.post(url, data, {
        params: {
            feclient: 'lvyou_web'
        }
    });
};

/***/ }),
/* 598 */
/*!************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a06f7a1","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ticket/verify/phone/pages/phoneVerify.vue ***!
  \************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "margin-left": "-28px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 table-tips"
  }, [_c('span', {
    staticClass: "table-title"
  }, [_vm._v("绑定商家电话设置")]), _vm._v(" "), _c('span', [_vm._v("(只有已绑定的电话才有权限验证)")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover bound-table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_vm._l((_vm.phones), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.phone))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.unbindPhone(item)
        }
      }
    }, [_vm._v("撤销绑定")])])])
  }), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber),
      expression: "phoneNumber"
    }],
    staticStyle: {
      "width": "250px",
      "margin": "0 auto"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.bindPhone()
      }
    }
  }, [_vm._v("进行绑定")])])])], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("美团门票验证电话")]), _vm._v(" "), _c('p', {
    staticClass: "telephone"
  }, [_vm._v("400-660-1065")]), _vm._v(" "), _c('p', {
    staticClass: "telephone-tips"
  }, [_vm._v("1，按 \"3\" 进入验证功能")]), _vm._v(" "), _c('p', {
    staticClass: "telephone-tips"
  }, [_vm._v("2，再按 \"2\" 进入旅游门票验证")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "other-thead"
  }, [_c('span', {
    staticClass: "tip-status",
    staticStyle: {
      "margin-left": "5px"
    }
  }), _vm._v(" "), _c('span', [_vm._v("绑定的电话可以是固话或手机号，固话请加区号，录入纯数字不加’-‘")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("绑定电话")]), _vm._v(" "), _c('td', [_vm._v("操作")])])])
}]}

/***/ }),
/* 599 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-50898914","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/ticket/verify/phone/pages/appVerify.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 600 */
/*!**********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50898914","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ticket/verify/phone/pages/appVerify.vue ***!
  \**********************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coupon-history-container"
  }, [_c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": "//p1.meituan.net/codeman/e65a1cf67d9aa36a496eb840309a21e515921.png"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("美团旅行商家版")]), _vm._v("\n        用手机随时随地管理商铺\n        "), _c('p', {
    staticClass: "info"
  }, [_vm._v(" 如二维码不可用，请到应用商店搜索「美团旅行商家」")])]), _vm._v(" "), _c('div', {
    staticClass: "info-box"
  }, [_c('h2', [_vm._v("手机验证方法:")]), _vm._v(" "), _c('p', [_vm._v("1.扫描二维码下载商家app")]), _vm._v(" "), _c('p', [_vm._v("2.登录商家账号及密码,进入验证页面")]), _vm._v(" "), _c('p', [_vm._v("3.在页面输入门票密码或直接扫描二维码进行验证")])])])
}]}

/***/ }),
/* 601 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-95c11ec4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/ticket/verify/history/Main.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 602 */
/*!*********************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/ticket/verify/history/Main.vue ***!
  \*********************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {};

/***/ }),
/* 603 */
/*!************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95c11ec4","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ticket/verify/history/Main.vue ***!
  \************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "voucher-history"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'ticketsingleProgram'
      }
    }
  }, [_vm._v("单个项目消费明细")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'ticketallProgram'
      }
    }
  }, [_vm._v("所有项目消费明细")])], 1)]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 604 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0414e0cf","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/ticket/verify/history/pages/singleProgramConsumption.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 605 */
/*!***********************************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/ticket/verify/history/pages/singleProgramConsumption.vue ***!
  \***********************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _verifyHistory = __webpack_require__(/*! api/verifyHistory */ 160);

var _verifyHistory2 = _interopRequireDefault(_verifyHistory);

var _helpers = __webpack_require__(/*! helpers */ 16);

var _envConf = __webpack_require__(/*! config/env.conf.js */ 2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            consumptionList: [],
            current: 1,
            perPageCount: 10,
            totalCount: 0,
            isTableLoading: false,
            useTimeEnd: '',
            useTimeStart: '',
            dealId: '',
            bizAccountAccess: 'web',
            noData: false,
            totalVerifyNum: 0,
            totalRevocationNum: 0,
            selectedIndex: 0,
            dealList: [],
            baseUrl: "/meilv/scs/account/v1/voucher/statistics/excel",
            detailUrl: "/mtp/coupon/history/detail/",
            detailInterChar: "#?day=",
            searchInfo: false,
            apiHost: _envConf.apiHost,
            formdate: _helpers.formatDate
        };
    },

    filters: {
        formdate: function formdate(time) {
            var date = new Date(time);
            return (0, _helpers.formatDate)(date, 'yyyy-MM-dd');
        }
    },
    created: function created() {
        var _this = this;

        _verifyHistory2.default.getDeals({
            bizAccountAccess: this.bizAccountAccess
        }).then(function (response) {
            _this.isTableLoading = false;
            if (response.status === 0) {
                if (response.data && response.data && response.data.length) {
                    _this.dealList = response.data;
                    _this.dealId = response.data[0].mtDealId;
                    //console.log(response.data[0].mtDealId);
                    _this.searchInfo = true;
                    _this.before(0, 0);
                    _this.getConsumptionList();
                }
            } else {
                _this.alert(response.message || '接口返回信息有误');
            }
        }).catch(function (error) {
            _this.isTableLoading = false;
            _this.dealList = [];
            _this.alert(error);
        });
    },
    computed: {
        totalPage: function totalPage() {
            return Math.ceil(this.totalCount / this.perPageCount);
        },
        generateUrl: function generateUrl() {
            return this.baseUrl + "?dealId=" + this.dealId + "&useTimeStart=" + this.useTimeStart + "&useTimeEnd=" + this.useTimeEnd;
        }
    },
    methods: {
        alert: function alert(message) {
            this.$alert({
                title: '提示',
                message: message,
                showCancelButton: false,
                closeOnClickModal: false
            });
        },
        clearSelectedIndex: function clearSelectedIndex() {
            this.selectedIndex = '';
        },
        getFormateDate: function getFormateDate(date) {
            return this.formdate(date, 'yyyy-MM-dd');
        },
        getConsumptionList: function getConsumptionList() {
            var _this2 = this;

            if (!this.check()) {
                return;
            }
            if (this.searchInfo) {
                this.dealId = this.dealId;
                this.useTimeEnd = this.useTimeEnd;
                this.useTimeStart = this.useTimeStart;
                this.pageSize = this.pageSize;
                this.pageNo = this.current;
            }
            this.isTableLoading = true;
            _verifyHistory2.default.getConsumptionList({
                bizAccountAccess: this.bizAccountAccess,
                useTimeEnd: this.useTimeEnd,
                useTimeStart: this.useTimeStart,
                pageNo: this.current,
                pageSize: this.perPageCount,
                dealId: this.dealId
            }).then(function (response) {
                _this2.isTableLoading = false;
                if (response.status === 0) {
                    if (response.data) {
                        _this2.consumptionList = response.data.list;
                        _this2.totalVerifyNum = response.data.totalVerifyNum;
                        _this2.totalRevocationNum = response.data.totalRevocationNum;
                        _this2.totalCount = response.data.totalSize;
                    }
                    if (response.data.list.length === 0) {
                        _this2.noData = true;
                    } else {
                        _this2.noData = false;
                    }
                } else {
                    _this2.alert(response.message || '接口返回信息有误');
                }
            }).catch(function (error) {
                _this2.isTableLoading = false;
                _this2.consumptionList = [];
                _this2.alert(error.message || error);
            });
        },
        getDeals: function getDeals() {
            var _this3 = this;

            _verifyHistory2.default.getDeals({
                bizAccountAccess: this.bizAccountAccess
            }).then(function (response) {
                _this3.isTableLoading = false;
                if (response.status === 0) {
                    if (response.data) {
                        _this3.dealList = response.data;
                    }
                } else {
                    _this3.alert(response.message || '接口返回信息有误');
                }
            }).catch(function (error) {
                _this3.isTableLoading = false;
                _this3.dealList = [];
                _this3.alert(error);
            });
        },
        currentChangeFunc: function currentChangeFunc(data) {
            this.current = data.current;
            this.searchInfo = false;
            this.getConsumptionList();
        },
        before: function before(index, day) {
            var today = new Date();
            var nowVal = today.valueOf();
            var TimeStart = new Date(nowVal - day * 24 * 60 * 60 * 1000);
            this.useTimeStart = this.getDateTime(TimeStart);
            this.useTimeEnd = this.getDateTime(today);
            this.selectedIndex = index;
        },
        getDateTime: function getDateTime(date) {
            var result = '';
            if (date) {
                result += date.getFullYear() + '-';
                var month = date.getMonth() + 1;
                result += month < 10 ? '0' + month : month;
                result += '-';
                var dateInMonth = date.getDate();
                result += dateInMonth < 10 ? '0' + dateInMonth : dateInMonth;
            }
            return result;
        },
        check: function check() {
            if (!this.useTimeStart || !this.useTimeEnd) {
                this.alert('必须选择起止时间!');
                return false;
            }
            if (this.useTimeStart > this.useTimeEnd) {
                this.alert('开始时间必须小于结束时间!');
                return false;
            }
            return true;
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 606 */
/*!**************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0414e0cf","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ticket/verify/history/pages/singleProgramConsumption.vue ***!
  \**************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.getConsumptionList($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-item"
  }, [_c('span', {
    staticClass: "time-filter",
    class: {
      'active': _vm.selectedIndex === 0
    },
    on: {
      "click": function($event) {
        _vm.before(0, 0)
      }
    }
  }, [_vm._v("今天")]), _vm._v(" "), _c('span', {
    staticClass: "time-filter",
    class: {
      'active': _vm.selectedIndex === 1
    },
    on: {
      "click": function($event) {
        _vm.before(1, 3)
      }
    }
  }, [_vm._v("近三天")]), _vm._v(" "), _c('span', {
    staticClass: "time-filter",
    class: {
      'active': _vm.selectedIndex === 2
    },
    on: {
      "click": function($event) {
        _vm.before(2, 7)
      }
    }
  }, [_vm._v("近七天")]), _vm._v(" "), _c('span', {
    staticClass: "time-filter",
    class: {
      'active': _vm.selectedIndex === 3
    },
    on: {
      "click": function($event) {
        _vm.before(3, 30)
      }
    }
  }, [_vm._v("近30天")])]), _vm._v(" "), _c('div', {
    staticClass: "col-item"
  }, [_c('v-datepicker', {
    staticStyle: {
      "width": "200px",
      "display": "inline-block"
    },
    attrs: {
      "message": _vm.useTimeStart
    },
    on: {
      "input": _vm.clearSelectedIndex
    },
    model: {
      value: (_vm.useTimeStart),
      callback: function($$v) {
        _vm.useTimeStart = $$v
      },
      expression: "useTimeStart"
    }
  }), _vm._v("到\n                "), _c('v-datepicker', {
    staticStyle: {
      "width": "200px",
      "display": "inline-block"
    },
    attrs: {
      "message": _vm.useTimeEnd
    },
    on: {
      "input": _vm.clearSelectedIndex
    },
    model: {
      value: (_vm.useTimeEnd),
      callback: function($$v) {
        _vm.useTimeEnd = $$v
      },
      expression: "useTimeEnd"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dealId),
      expression: "dealId"
    }],
    staticStyle: {
      "width": "400px",
      "display": "inline-block",
      "margin-left": "20px"
    },
    attrs: {
      "name": "dealId",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.dealId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.dealList), function(deal) {
    return _c('option', {
      key: deal.mtDealId,
      domProps: {
        "value": deal.mtDealId
      }
    }, [_vm._v("\n                          " + _vm._s(deal.partnerDealName) + "\n                          ")])
  })), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "submit",
      "disabled": !_vm.dealId
    }
  }, [_vm._v("查询")])])]), _vm._v(" "), _c('div', {
    staticClass: "common-tip-blk"
  }, [_c('i', {
    staticClass: "F-glob F-glob-status-info"
  }), _vm._v(" "), _c('strong', [_vm._v("合计")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.useTimeStart))]), _vm._v("至\n        "), _c('span', [_vm._v(_vm._s(_vm.useTimeEnd))]), _vm._v("已验证了\n        "), _c('span', [_vm._v(_vm._s(_vm.totalVerifyNum || 0))]), _vm._v("张,已撤销\n        "), _c('span', [_vm._v(_vm._s(_vm.totalRevocationNum || 0))]), _vm._v("张\n    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isTableLoading),
      expression: "isTableLoading"
    }],
    staticClass: "table-wrapper",
    attrs: {
      "element-loading-text": "拼命加载中"
    }
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_c('a', {
    attrs: {
      "href": _vm.apiHost + _vm.generateUrl,
      "target": "_blank"
    }
  }, [_vm._v("下载明细记录")])]), _vm._v(" "), _c('table', {
    staticClass: "table table-hover table-bordered"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.consumptionList), function(item, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("formdate")(item.date)) + "," + _vm._s(item.weekday))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.verifyNum))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.revocationNum))]), _vm._v(" "), _c('td', [_c('div', [(item.verifyNum || item.revocationNum) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'ticketdetailProgram',
          params: {
            useTimeStart: _vm.getFormateDate(item.date),
            dealId: item.dealId,
            dealName: item.dealName
          }
        }
      }
    }, [_vm._v("查看明细")]) : _vm._e()], 1), _vm._v(" "), _c('div', [(!item.verifyNum && !item.revocationNum) ? _c('a', {
      attrs: {
        "disabled": ""
      }
    }, [_vm._v("查看明细")]) : _vm._e()])])])
  }))]), _vm._v(" "), (_vm.noData) ? _c('p', {
    staticClass: "nodata"
  }, [_vm._v("未查询到匹配内容")]) : _vm._e(), _vm._v(" "), _c('v-pagination', {
    staticClass: "pull-right",
    attrs: {
      "current": _vm.current,
      "total": _vm.totalPage,
      "size": 'md',
      "first": false,
      "last": false
    },
    on: {
      "current-change": function($event) {
        _vm.currentChangeFunc($event)
      }
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-item  control-label"
  }, [_c('strong', [_vm._v("消费时间:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-item control-label"
  }, [_c('strong', [_vm._v("消费项目:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "width-50"
  }, [_vm._v("验证日期")]), _vm._v(" "), _c('th', [_vm._v("验证数量")]), _vm._v(" "), _c('th', [_vm._v("撤销数量")]), _vm._v(" "), _c('th', [_vm._v("操作")])])])
}]}

/***/ }),
/* 607 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3ccb3a90","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/ticket/verify/history/pages/allProgramConsumption.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 608 */
/*!********************************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/ticket/verify/history/pages/allProgramConsumption.vue ***!
  \********************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _verifyHistory = __webpack_require__(/*! api/verifyHistory */ 160);

var _verifyHistory2 = _interopRequireDefault(_verifyHistory);

var _helpers = __webpack_require__(/*! helpers */ 16);

var _envConf = __webpack_require__(/*! config/env.conf.js */ 2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            options1: {},
            msg: "",
            consumptionList: [],
            current: 1,
            perPageCount: 10,
            totalCount: 0,
            isTableLoading: false,
            useTimeEnd: "",
            useTimeStart: "",
            bizAccountAccess: "",
            noData: false,
            totalVerifyNum: 0,
            totalRevocationNum: 0,
            selectedIndex: 0,
            dealId: "",
            searchInfo: false,
            baseUrl: "/meilv/scs/account/v1/voucher/log/excel?",
            apiHost: _envConf.apiHost,
            otpHost: _envConf.otpHost,
            formdate: _helpers.formatDate,
            detailUrl: "#/ticket/order/ticket/detail?id=",
            programNameUrl: "https://www.meituan.com/deal/"
        };
    },

    filters: {
        formdate: function formdate(time) {
            var date = new Date(time);
            return (0, _helpers.formatDate)(date, "yyyy-MM-dd hh:mm:ss");
        }
    },
    created: function created() {
        this.searchInfo = true;
        if (this.searchInfo) {
            this.before(0, 0);
        }
        this.getAllConsumptionList();
    },
    computed: {
        totalPage: function totalPage() {
            return Math.ceil(this.totalCount / this.perPageCount);
        },
        generateUrl: function generateUrl() {
            return this.baseUrl + "useTimeStart=" + this.useTimeStart + "&useTimeEnd=" + this.useTimeEnd;
        }
    },
    methods: {
        getFormateDate: function getFormateDate(date) {
            return this.formdate(date, "yyyy-MM-dd");
        },
        alert: function alert(message) {
            this.$alert({
                title: "提示",
                message: message,
                showCancelButton: false,
                closeOnClickModal: false
            });
        },
        clearSelectedIndex: function clearSelectedIndex() {
            this.selectedIndex = "";
        },
        getAllConsumptionList: function getAllConsumptionList() {
            var _this = this;

            this.isTableLoading = true;
            if (!this.check()) {
                return;
            }
            _verifyHistory2.default.getAllConsumptionList({
                useTimeEnd: this.useTimeEnd,
                useTimeStart: this.useTimeStart,
                pageNo: this.current,
                pageSize: this.perPageCount,
                bizAccountAccess: "web"
            }).then(function (response) {
                _this.isTableLoading = false;
                if (response.status === 0) {
                    if (response.data) {
                        _this.consumptionList = response.data.list;
                        _this.totalVerifyNum = response.data.totalVerifyNum;
                        _this.totalRevocationNum = response.data.totalRevocationNum;
                        _this.totalCount = response.data.totalSize;
                    }
                    if (response.data.totalSize === 0) {
                        _this.noData = true;
                    } else {
                        _this.noData = false;
                    }
                } else {
                    _this.alert(response.message || "接口返回信息有误");
                }
            }).catch(function (error) {
                _this.isTableLoading = false;
                _this.consumptionList = [];
                _this.alert(error.message || error);
            });
        },
        currentChangeFunc: function currentChangeFunc(data) {
            this.current = data.current;
            this.getAllConsumptionList();
        },
        before: function before(index, day) {
            var today = new Date();
            var nowVal = today.valueOf();
            var TimeStart = new Date(nowVal - day * 24 * 60 * 60 * 1000);
            this.useTimeStart = this.getDateTime(TimeStart);
            this.useTimeEnd = this.getDateTime(today);
            this.selectedIndex = index;
            //this.getAllConsumptionList();
        },
        getDateTime: function getDateTime(date) {
            var result = "";
            if (date) {
                result += date.getFullYear() + "-";
                var month = date.getMonth() + 1;
                result += month < 10 ? "0" + month : month;
                result += "-";
                var dateInMonth = date.getDate();
                result += dateInMonth < 10 ? "0" + dateInMonth : dateInMonth;
            }
            return result;
        },
        check: function check() {
            if (!this.useTimeStart || !this.useTimeEnd) {
                this.alert("必须选择起止时间!");
                return false;
            }
            if (this.useTimeStart > this.useTimeEnd) {
                this.alert("开始时间必须小于结束时间!");
                return false;
            }
            return true;
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 609 */
/*!***********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ccb3a90","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ticket/verify/history/pages/allProgramConsumption.vue ***!
  \***********************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('form', {
    staticClass: "form-horizontal",
    staticStyle: {
      "margin-top": "20px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.getAllConsumptionList($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-item"
  }, [_c('v-datepicker', {
    staticStyle: {
      "width": "200px",
      "display": "inline-block"
    },
    attrs: {
      "message": _vm.useTimeStart
    },
    on: {
      "input": _vm.clearSelectedIndex
    },
    model: {
      value: (_vm.useTimeStart),
      callback: function($$v) {
        _vm.useTimeStart = $$v
      },
      expression: "useTimeStart"
    }
  }), _vm._v("到\n                "), _c('v-datepicker', {
    staticStyle: {
      "width": "200px",
      "display": "inline-block"
    },
    attrs: {
      "message": _vm.useTimeEnd
    },
    on: {
      "input": _vm.clearSelectedIndex
    },
    model: {
      value: (_vm.useTimeEnd),
      callback: function($$v) {
        _vm.useTimeEnd = $$v
      },
      expression: "useTimeEnd"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-left": "98px"
    }
  }, [_c('div', [_c('span', {
    staticClass: "time-filter",
    class: {
      'active': _vm.selectedIndex === 0
    },
    on: {
      "click": function($event) {
        _vm.before(0, 0)
      }
    }
  }, [_vm._v("今天")]), _vm._v(" "), _c('span', {
    staticClass: "time-filter",
    class: {
      'active': _vm.selectedIndex === 1
    },
    on: {
      "click": function($event) {
        _vm.before(1, 3)
      }
    }
  }, [_vm._v("近三天")]), _vm._v(" "), _c('span', {
    staticClass: "time-filter",
    class: {
      'active': _vm.selectedIndex === 2
    },
    on: {
      "click": function($event) {
        _vm.before(2, 7)
      }
    }
  }, [_vm._v("近七天")]), _vm._v(" "), _c('span', {
    staticClass: "time-filter",
    class: {
      'active': _vm.selectedIndex === 3
    },
    on: {
      "click": function($event) {
        _vm.before(3, 30)
      }
    }
  }, [_vm._v("近30天")])])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "common-tip-blk"
  }, [_c('i', {
    staticClass: "F-glob F-glob-status-info"
  }), _vm._v(" "), _c('strong', [_vm._v("合计")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.useTimeStart))]), _vm._v("至\n        "), _c('span', [_vm._v(_vm._s(_vm.useTimeEnd))]), _vm._v("已验证了\n        "), _c('span', [_vm._v(_vm._s(_vm.totalVerifyNum || 0))]), _vm._v("张,已撤销\n        "), _c('span', [_vm._v(_vm._s(_vm.totalRevocationNum || 0))]), _vm._v("张\n    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isTableLoading),
      expression: "isTableLoading"
    }],
    staticClass: "table-wrapper",
    attrs: {
      "element-loading-text": "拼命加载中"
    }
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    attrs: {
      "href": _vm.apiHost + _vm.generateUrl,
      "target": "_blank"
    }
  }, [_vm._v("下载明细记录")])]), _vm._v(" "), _c('table', {
    staticClass: "table table-hover table-bordered"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.consumptionList), function(item, index) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": _vm.otpHost + _vm.detailUrl + item.orderId
      }
    }, [_vm._v(_vm._s(item.orderId))])]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm._f("formdate")(item.operationTime)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(item.operationType == 1 ? '验证' : '撤销') + "\n                    ")]), _vm._v(" "), _c('td', [_c('ul', {
      staticClass: "list-unstyled"
    }, [_c('li', [_c('a', {
      attrs: {
        "href": _vm.programNameUrl + item.dealId + '.html',
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.dealName))])]), _vm._v(" "), _c('li', {
      attrs: {
        "ng-if": "item.ticketType"
      }
    }, [_vm._v("\n                                " + _vm._s(item.ticketType) + "\n                            ")])])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(item.voucherCode))])]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(item.quantity) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.operatorName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.source))]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(item.sellPrice) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(item.totalPrice) + "\n                    ")])])
  }))]), _vm._v(" "), (_vm.noData) ? _c('p', {
    staticClass: "nodata"
  }, [_vm._v("未查询到匹配内容")]) : _vm._e(), _vm._v(" "), _c('v-pagination', {
    staticClass: "pull-right",
    attrs: {
      "current": _vm.current,
      "total": _vm.totalPage,
      "size": 'md',
      "first": false,
      "last": false
    },
    on: {
      "current-change": function($event) {
        _vm.currentChangeFunc($event)
      }
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-item  control-label"
  }, [_c('strong', [_vm._v("消费时间:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-left": "104px"
    }
  }, [_c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("查询")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("订单号")]), _vm._v(" "), _c('th', [_vm._v("操作时间")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("项目名称")]), _vm._v(" "), _c('th', [_vm._v("电子票密码")]), _vm._v(" "), _c('th', [_vm._v("操作数量")]), _vm._v(" "), _c('th', [_vm._v("操作人")]), _vm._v(" "), _c('th', [_vm._v("来源")]), _vm._v(" "), _c('th', [_vm._v("消费者购买价")]), _vm._v(" "), _c('th', [_vm._v("总价")])])])
}]}

/***/ }),
/* 610 */
/*!**********************************************!*\
  !*** ./src/views/dataCenter/programData.vue ***!
  \**********************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-ea3baa96","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./programData.vue */ 611)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./programData.vue */ 612),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-ea3baa96","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./programData.vue */ 613),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 611 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ea3baa96","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataCenter/programData.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 612 */
/*!*****************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataCenter/programData.vue ***!
  \*****************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dataCenter = __webpack_require__(/*! api/dataCenter.js */ 161);

var _formatDate = __webpack_require__(/*! helpers/formatDate.js */ 77);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    data: function data() {
        var _this = this;

        return {
            datalist: [],
            page: 1,
            count: 10,
            rank: 'desc',
            start: this.getFormateDate(new Date(new Date().valueOf() - 24 * 60 * 60 * 1000)),
            end: this.getFormateDate(new Date(new Date().valueOf() - 24 * 60 * 60 * 1000)),
            searchFlag: false,
            order: '',
            isDecrease: false,
            asc: 'asc',
            desc: 'desc',
            textLeft: "text-left",
            noData: true,
            intro: '',
            buttonDisable: false,
            timeOption: {
                //maxDate: new Date((new Date().valueOf() - 24 * 60 * 60 * 1000)),
                //minDate: new Date((new Date().valueOf() - 90 * 24 * 60 * 60 * 1000)),
                onChange: function onChange(date) {
                    _this.$nextTick(function (I) {
                        if (_this.start && _this.end) {
                            if (_this.end > _this.getFormateDate(new Date(new Date().valueOf() - 24 * 60 * 60 * 1000))) {
                                _this.intro = "结束时间应选在昨天之前";
                            } else if (_this.start > _this.end) {
                                _this.intro = "结束时间应大于开始时间";
                            } else if (_this.getFormateDate(new Date(new Date(_this.end).valueOf() - 90 * 24 * 60 * 60 * 1000)) > _this.start) {
                                _this.intro = "开始与结束时间间隔需小于90天";
                            } else if (_this.start < _this.getFormateDate(new Date(new Date().valueOf() - 90 * 24 * 60 * 60 * 1000)) || _this.end < _this.getFormateDate(new Date(new Date().valueOf() - 90 * 24 * 60 * 60 * 1000))) {
                                _this.intro = "请选择最近3个月内数据";
                            } else {
                                _this.intro = "";
                                _this.buttonDisable = false;
                            }
                            if (_this.intro) {
                                _this.buttonDisable = true;
                            }
                        }
                    });
                }
            }
        };
    },

    created: function created() {
        this.getDataTableList();
    },
    methods: {
        getDataTableList: function getDataTableList() {
            var _this2 = this;

            (0, _dataCenter.getDataTable)({
                page: this.page,
                count: this.count,
                rank: this.rank,
                start: this.start,
                end: this.end,
                order: this.order
            }).then(function (response) {
                if (response.status === 0 && response.data) {
                    _this2.datalist = response.data.list;
                    _this2.noData = !_this2.datalist.length;
                }
            }).catch(function (error) {
                _this2.alert(error);
            });
        },
        alert: function alert(message) {
            this.$alert({
                title: '提示',
                message: message,
                showCancelButton: false,
                closeOnClickModal: false
            });
        },
        getFormateDate: function getFormateDate(date) {
            return this.formdate(date, 'yyyy-MM-dd');
        },
        formdate: function formdate(time) {
            var date = new Date(time);
            return (0, _formatDate.formatDate)(date, 'yyyy-MM-dd');
        },
        orderBy: function orderBy(filter) {
            this.isDecrease = !this.isDecrease;
            this.order = filter;
            this.rank = this.isDecrease ? 'asc' : 'desc';
            this.getDataTableList();
        },
        check: function check() {
            if (this.start && this.end) {
                if (new Date(this.end) > this.getFormateDate(new Date(new Date().valueOf() - 24 * 60 * 60 * 1000))) {
                    this.intro = "结束时间应选在昨天之前";
                }
                if (new Date(this.start) > new Date(this.end)) {
                    this.intro = "结束时间应大于开始时间";
                }
            }
        }
    }
};

/***/ }),
/* 613 */
/*!*********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea3baa96","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataCenter/programData.vue ***!
  \*********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data-center"
  }, [_c('p', {
    staticClass: "alert alert-warning"
  }, [_vm._v("提示：本页面提供的数据仅供商户作为调整经营策略参考，不作为结款与验证的准确依据")]), _vm._v(" "), _c('div', {
    staticClass: "data-container"
  }, [_c('h2', [_vm._v("历史数据概览及数据趋势")]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('form', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-item control-label"
  }, [_vm._v("选择时间：")]), _vm._v(" "), _c('div', {
    staticClass: "col-item"
  }, [_c('v-datepicker', {
    attrs: {
      "message": _vm.start,
      "options": _vm.timeOption
    },
    model: {
      value: (_vm.start),
      callback: function($$v) {
        _vm.start = $$v
      },
      expression: "start"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-item margin-top"
  }, [_vm._v("\n                    ~\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-item"
  }, [_c('v-datepicker', {
    attrs: {
      "options": _vm.timeOption,
      "message": _vm.end
    },
    model: {
      value: (_vm.end),
      callback: function($$v) {
        _vm.end = $$v
      },
      expression: "end"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.buttonDisable
    },
    on: {
      "click": _vm.getDataTableList
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.intro))])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped  table-hover"
  }, [_c('thead', {
    class: [_vm.textLeft, _vm.isDecrease ? _vm.asc : _vm.desc]
  }, [_c('th', {
    class: {
      'active': _vm.order === 'name'
    },
    on: {
      "click": function($event) {
        _vm.orderBy('name')
      }
    }
  }, [_c('span', [_vm._v("项目名称")])]), _vm._v(" "), _c('th', {
    staticClass: "width-s",
    class: {
      'active': _vm.order === 'sales'
    },
    on: {
      "click": function($event) {
        _vm.orderBy('sales')
      }
    }
  }, [_c('span', [_vm._v("购买券")])]), _vm._v(" "), _c('th', {
    staticClass: "width-s",
    class: {
      'active': _vm.order === 'buy_rate'
    },
    on: {
      "click": function($event) {
        _vm.orderBy('buy_rate')
      }
    }
  }, [_c('span', [_vm._v("购买率")])]), _vm._v(" "), _c('th', {
    staticClass: "width-s",
    class: {
      'active': _vm.order === 'consumption'
    },
    on: {
      "click": function($event) {
        _vm.orderBy('consumption')
      }
    }
  }, [_c('span', [_vm._v("验证券")])]), _vm._v(" "), _c('th', {
    staticClass: "width-s",
    class: {
      'active': _vm.order === 'consumption_rate'
    },
    on: {
      "click": function($event) {
        _vm.orderBy('consumption_rate')
      }
    }
  }, [_c('span', [_vm._v("验证率")])]), _vm._v(" "), _c('th', {
    staticClass: "width-s",
    class: {
      'active': _vm.order === 'refund'
    },
    on: {
      "click": function($event) {
        _vm.orderBy('refund')
      }
    }
  }, [_c('span', [_vm._v("退款券")])]), _vm._v(" "), _c('th', {
    staticClass: "width-s",
    class: {
      'active': _vm.order === 'refund_rate'
    },
    on: {
      "click": function($event) {
        _vm.orderBy('refund_rate')
      }
    }
  }, [_c('span', [_vm._v("退款率")])]), _vm._v(" "), _c('th', {
    staticClass: "width-s",
    class: {
      'active': _vm.order === 'pv'
    },
    on: {
      "click": function($event) {
        _vm.orderBy('pv')
      }
    }
  }, [_c('span', [_vm._v("浏览量")])]), _vm._v(" "), _c('th', {
    staticClass: "width-s",
    class: {
      'active': _vm.order === 'uv'
    },
    on: {
      "click": function($event) {
        _vm.orderBy('uv')
      }
    }
  }, [_c('span', [_vm._v("访客量")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.datalist), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.sales))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("floatToPercent")(item.buyRate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.consumption))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("floatToPercent")(item.consumptionRate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.refund))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("floatToPercent")(item.refundRate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.pv))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.uv))])])
  }))]), _vm._v(" "), (_vm.noData) ? _c('p', {
    staticClass: "alert alert-warning"
  }, [_vm._v("该时间段内无数据。。")]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 614 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6cd5d6d8","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataCenter/operationData.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 615 */
/*!*******************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataCenter/operationData.vue ***!
  \*******************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dataCenter = __webpack_require__(/*! api/dataCenter.js */ 161);

var _formatDate = __webpack_require__(/*! helpers/formatDate.js */ 77);

var _toPercent2 = __webpack_require__(/*! filters/toPercent.js */ 245);

var _toPercent3 = _interopRequireDefault(_toPercent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        var _this2 = this;

        return {
            start: this.getFormateDate(new Date(new Date().valueOf() - 7 * 24 * 60 * 60 * 1000)),
            end: this.getFormateDate(new Date(new Date().valueOf() - 1 * 24 * 60 * 60 * 1000)),
            filter: 'sales',
            show: false,
            chartData: [],
            dayNumber: {
                tomorrow: 0,
                afterTomorrow: 0,
                total: 0,
                month: 0,
                week: 0
            },
            buttonDisable: false,
            intro: '',
            legendName: {
                'sales': '购买量（券）',
                'buyRate': '购买率',
                'consumption': '验证量（券)',
                'consumptionRate': '验证率',
                'refund': '退款量（券）',
                'refundRate': '退款率',
                'pv': '浏览量',
                'uv': '访客量'
            },
            total: {
                buyRate: 0.0,
                consumption: 0,
                consumptionRate: 0,
                pv: 0,
                refund: 0,
                refundRate: 0,
                sales: 0,
                uv: 0
            },
            timeOption: {
                //maxDate: new Date((new Date().valueOf() - 24 * 60 * 60 * 1000)),
                //minDate: new Date((new Date().valueOf() - 90 * 24 * 60 * 60 * 1000)),
                onChange: function onChange(date) {
                    _this2.$nextTick(function (I) {
                        if (_this2.start && _this2.end) {
                            if (_this2.end > _this2.getFormateDate(new Date(new Date().valueOf() - 24 * 60 * 60 * 1000))) {
                                _this2.intro = "结束时间应选在昨天之前";
                            } else if (_this2.start > _this2.end) {
                                _this2.intro = "结束时间应大于开始时间";
                            } else if (_this2.getFormateDate(new Date(new Date(_this2.end).valueOf() - 90 * 24 * 60 * 60 * 1000)) > _this2.start) {
                                _this2.intro = "开始与结束时间间隔需小于90天";
                            } else if (_this2.start < _this2.getFormateDate(new Date(new Date().valueOf() - 90 * 24 * 60 * 60 * 1000)) || _this2.end < _this2.getFormateDate(new Date(new Date().valueOf() - 90 * 24 * 60 * 60 * 1000))) {
                                _this2.intro = "请选择最近3个月内数据";
                            } else {
                                _this2.intro = "";
                                _this2.buttonDisable = false;
                            }
                            if (_this2.intro) {
                                _this2.buttonDisable = true;
                            }
                        }
                    });
                }
            },
            options: {
                tooltip: {
                    show: true
                },
                legend: {
                    data: ['购买量（券）'] // 数据属性
                },
                xAxis: [{
                    type: 'category',
                    boundaryGap: false,
                    data: [], // X坐标内容
                    color: '#000',
                    axisLine: {
                        lineStyle: {
                            color: '#000'
                        }
                    }
                }],
                yAxis: [{
                    type: 'value',
                    axisLine: {
                        lineStyle: {
                            color: '#000'
                        }
                    },
                    axisLabel: {}
                }],
                series: [{
                    'name': '购买量（券）',
                    'type': 'line',
                    'data': [],
                    'symbolSize': 4,
                    'symbol': 'emptyCircle'
                }],
                itemStyle: {
                    width: 2,
                    emphasis: {
                        borderWidth: 2,
                        borderColor: '#000'
                    },
                    normal: {
                        areaStyle: {
                            color: '#ff9200'
                        }
                    }
                }
            }
        };
    },

    created: function created() {
        this.getReserveData();
        this.getHistoryData();
    },
    filters: {},
    methods: {
        alert: function alert(message) {
            this.$alert({
                title: '提示',
                message: message,
                showCancelButton: false,
                closeOnClickModal: false
            });
        },
        getFormateDate: function getFormateDate(date) {
            return this.formdate(date, 'yyyy-MM-dd');
        },
        formdate: function formdate(time) {
            var date = new Date(time);
            return (0, _formatDate.formatDate)(date, 'yyyy-MM-dd');
        },
        toPercent: function toPercent(value) {
            return (0, _toPercent3.default)(value);
        },
        getHistoryData: function getHistoryData() {
            var _this3 = this;

            (0, _dataCenter.getHistoryData)({
                start: this.start,
                end: this.end
            }).then(function (response) {
                if (response.status === 0 && response.data) {
                    _this3.total = response.data.total;
                    _this3.chartData = response.data.list;
                    var arr = _this3.formatData(_this3.chartData);
                    _this3.options.xAxis[0].data = arr.xAxisData;
                    _this3.options.series[0].data = arr.seriesData[_this3.filter];
                    _this3.charts.setOption(_this3.options);
                }
            }).catch(function (error) {
                _this3.alert(error);
            });
        },
        getReserveData: function getReserveData() {
            var _this4 = this;

            (0, _dataCenter.getReserveData)().then(function (response) {
                if (response && response.data) {
                    _this4.dayNumber = response.data;
                }
            }).catch(function (error) {
                _this4.alert(error);
            });
        },
        changeFilter: function changeFilter(filter) {
            this.filter = filter;
            if (filter === 'buyRate' || filter === 'refundRate' || filter === 'consumptionRate') {
                this.options.yAxis[0].axisLabel.formatter = '{value} %';
            } else {
                this.options.yAxis[0].axisLabel.formatter = '{value}';
            }
            this.options.series[0].data = this.formatData(this.chartData).seriesData[filter];
            console.log(this.options.series[0].data);
            this.options.legend.data[0] = this.options.series[0].name = this.legendName[filter];
            this.charts.setOption(this.options);
        },
        getTrend: function getTrend() {
            this.getReserveData();
            this.getHistoryData();
        },
        drawPolyLine: function drawPolyLine(id) {
            this.charts = echarts.init(document.getElementById(id));
            this.charts.setOption(this.options);
        },
        formatData: function formatData(data) {
            var _this5 = this;

            if (!data || !Array.isArray(data)) {
                return;
            }
            var i = void 0;
            var l = void 0;
            // data 数据源；  type 展示属性； opt 图标配置项
            var xAxisData = [];
            var seriesData = {};

            var _loop = function _loop() {
                xAxisData.push(data[i].date);
                var item = data[i];
                var _this = _this5;
                Object.keys(item).forEach(function (key) {
                    var val = item[key];
                    if (!seriesData[key]) {
                        seriesData[key] = [];
                    }
                    if (key === 'buyRate' || key === 'refundRate' || key === 'consumptionRate') {
                        if (val) {
                            val = _this.toPercent(val);
                            console.log(val);
                        } else {
                            val = 0;
                        }
                    }
                    seriesData[key].push(val);
                });
            };

            for (i = 0, l = data.length; i < l; i++) {
                _loop();
            }
            return {
                xAxisData: xAxisData,
                seriesData: seriesData
            };
        }
    },
    mounted: function mounted() {
        this.$nextTick(function () {
            this.drawPolyLine('charts');
        });
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 616 */
/*!***********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cd5d6d8","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataCenter/operationData.vue ***!
  \***********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data-center"
  }, [_c('p', {
    staticClass: "alert alert-warning"
  }, [_vm._v("提示：本页面提供的数据仅供商户作为调整经营策略参考，不作为结款与验证的准确依据")]), _vm._v(" "), _c('div', {
    staticClass: "quantity-container"
  }, [_c('div', {
    staticClass: "quantity-detail"
  }, [_c('h2', [_vm._v("指定日预约量")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("指定日预约量（券）：是指用户在购买时已经选择了未来某一天作为使用日期的预约券数量")]), _vm._v(" "), _c('div', {
    staticClass: "item-container"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', [_c('p', [_vm._v("明天")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm.dayNumber.tomorrow))])])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("指定明天使用的预约券")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', [_c('p', [_vm._v("后天")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm.dayNumber.afterTomorrow))])])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("指定后天使用的预约券")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', [_c('p', [_vm._v("未来7天")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm.dayNumber.week))])])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("指定未来7天使用的预约券")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', [_c('p', [_vm._v("未来30天")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm.dayNumber.month))])])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("指定未来30天使用的预约券")])])])]), _vm._v(" "), _c('div', {
    staticClass: "quantity-whole"
  }, [_c('h2', [_vm._v("有效期预约量（券）")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("有效期预约量（券）：在未来的一个有效期内都可以使用的预约券数量")]), _vm._v(" "), _c('div', {
    staticClass: "item-container"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', [_c('p', [_vm._v("累计")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm._f("addCommas")(_vm.dayNumber.total)))])])]), _vm._v(" "), _c('p', {
    staticClass: "intro text-muted"
  }, [_vm._v("未指定使用日期的有效期预约券")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "data-container"
  }, [_c('h2', [_vm._v("历史数据概览及数据趋势")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("历史数据是从过去到昨天的任何一个时间段内的数值，")]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('form', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-item"
  }, [_c('v-datepicker', {
    attrs: {
      "message": _vm.start,
      "options": _vm.timeOption
    },
    model: {
      value: (_vm.start),
      callback: function($$v) {
        _vm.start = $$v
      },
      expression: "start"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-item margin-top"
  }, [_vm._v("\n                    ~\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-item"
  }, [_c('v-datepicker', {
    attrs: {
      "message": _vm.end,
      "options": _vm.timeOption
    },
    model: {
      value: (_vm.end),
      callback: function($$v) {
        _vm.end = $$v
      },
      expression: "end"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.buttonDisable
    },
    on: {
      "click": function($event) {
        _vm.getTrend()
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.intro))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-type-container"
  }, [_c('div', [_c('div', {
    staticClass: "data-reason",
    class: {
      'active': _vm.filter == 'sales' || _vm.filter == 'buyRate'
    }
  }, [_c('div', {
    staticClass: "reason-item",
    class: {
      'active': _vm.filter == 'sales'
    },
    on: {
      "click": function($event) {
        _vm.changeFilter('sales')
      }
    }
  }, [_c('div', [_c('p', [_vm._v("购买量（券）")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm._f("addCommas")(_vm.total.sales)))])])]), _vm._v(" "), _c('div', {
    staticClass: "reason-item",
    class: {
      'active': _vm.filter == 'buyRate'
    },
    on: {
      "click": function($event) {
        _vm.changeFilter('buyRate')
      }
    }
  }, [_c('div', [_c('p', [_vm._v("购买率")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm._f("floatToPercent")(_vm.total.buyRate)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "data-reason",
    class: {
      'active': _vm.filter == 'consumption' || _vm.filter == 'consumptionRate'
    }
  }, [_c('div', {
    staticClass: "reason-item",
    class: {
      'active': _vm.filter == 'consumption'
    },
    on: {
      "click": function($event) {
        _vm.changeFilter('consumption')
      }
    }
  }, [_c('div', [_c('p', [_vm._v("验证量（券）")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm._f("addCommas")(_vm.total.consumption)))])])]), _vm._v(" "), _c('div', {
    staticClass: "reason-item",
    class: {
      'active': _vm.filter == 'consumptionRate'
    },
    on: {
      "click": function($event) {
        _vm.changeFilter('consumptionRate')
      }
    }
  }, [_c('div', [_c('p', [_vm._v("验证率")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm._f("floatToPercent")(_vm.total.consumptionRate)))])])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "data-reason",
    class: {
      'active': _vm.filter == 'refund' || _vm.filter == 'refundRate'
    }
  }, [_c('div', {
    staticClass: "reason-item",
    class: {
      'active': _vm.filter == 'refund'
    },
    on: {
      "click": function($event) {
        _vm.changeFilter('refund')
      }
    }
  }, [_c('div', [_c('p', [_vm._v("退款量（券）")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm._f("addCommas")(_vm.total.refund)))])])]), _vm._v(" "), _c('div', {
    staticClass: "reason-item",
    class: {
      'active': _vm.filter == 'refundRate'
    },
    on: {
      "click": function($event) {
        _vm.changeFilter('refundRate')
      }
    }
  }, [_c('div', [_c('p', [_vm._v("退款率")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm._f("floatToPercent")(_vm.total.refundRate)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "data-reason",
    class: {
      'active': _vm.filter == 'pv' || _vm.filter == 'uv'
    }
  }, [_c('div', {
    staticClass: "reason-item",
    class: {
      'active': _vm.filter == 'pv'
    },
    on: {
      "click": function($event) {
        _vm.changeFilter('pv')
      }
    }
  }, [_c('div', [_c('p', [_vm._v("浏览量")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm._f("addCommas")(_vm.total.pv)))])])]), _vm._v(" "), _c('div', {
    staticClass: "reason-item",
    class: {
      'active': _vm.filter == 'uv'
    },
    on: {
      "click": function($event) {
        _vm.changeFilter('uv')
      }
    }
  }, [_c('div', [_c('p', [_vm._v("访客量")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm._f("addCommas")(_vm.total.uv)))])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "showIntro",
    on: {
      "click": function($event) {
        _vm.show = true
      }
    }
  }, [_c('a', [_vm._v("点此查看各数据指标定义")])]), _vm._v(" "), (_vm.show) ? _c('ul', {
    staticClass: "list-unstyled intros"
  }, [_c('li', [_vm._v("购买量（券）：旅游券的销售数量（非金额），反映了产品的整体售卖情况")]), _vm._v(" "), _c('li', [_vm._v("访购率：项目的购买人次/访客量，反映了项目的对消费者的吸引力")]), _vm._v(" "), _c('li', [_vm._v("验证量（券）：旅游券的验证数量（非金额），反映了项目的实际接待和收入情况")]), _vm._v(" "), _c('li', [_vm._v("验证率：项目的验证券数量/购买券数量，反映了项目的最终消费情况")]), _vm._v(" "), _c('li', [_vm._v("退款量（券）：旅游券的发生退款的数量（非金额）")]), _vm._v(" "), _c('li', [_vm._v("退款率：项目的退款量（券）/销售量（券）")]), _vm._v(" "), _c('li', [_vm._v("浏览量：项目页面的浏览次数，反映了项目的曝光程度")]), _vm._v(" "), _c('li', [_vm._v("访客量：项目页面的浏览用户数，反映了项目的曝光人数")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "charts",
    attrs: {
      "id": "charts"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("备注：选中相应的数据指标即可查看其数据趋势")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-item control-label"
  }, [_c('strong', [_vm._v("选择时间：")])])
}]}

/***/ }),
/* 617 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b7711928","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/view-wrapper/view-wrapper.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 618 */
/*!*************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/view-wrapper/view-wrapper.vue ***!
  \*************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//

exports.default = {
    data: function data() {
        return {
            msg: null
        };
    },
    created: function created() {
        var route = this.$route;
        this.msg = "Current Route Name is \"" + route.name + "\"";
    }
};

/***/ }),
/* 619 */
/*!****************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7711928","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view-wrapper/view-wrapper.vue ***!
  \****************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-wrapper"
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 620 */
/*!**************************************!*\
  !*** ./src/router/router.jiujing.js ***!
  \**************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _viewWrapper = __webpack_require__(/*! components/view-wrapper/view-wrapper.vue */ 52);

var _viewWrapper2 = _interopRequireDefault(_viewWrapper);

var _routeBuilder = __webpack_require__(/*! ./routeBuilder */ 66);

var _routeBuilder2 = _interopRequireDefault(_routeBuilder);

var _innerFrame = __webpack_require__(/*! components/inner-frame/inner-frame */ 42);

var _innerFrame2 = _interopRequireDefault(_innerFrame);

var _Main = __webpack_require__(/*! views/dataPlatform/operateData/Main.vue */ 162);

var _Main2 = _interopRequireDefault(_Main);

var _Main3 = __webpack_require__(/*! views/dataPlatform/productData/Main.vue */ 164);

var _Main4 = _interopRequireDefault(_Main3);

var _Main5 = __webpack_require__(/*! views/comment/list/Main.vue */ 118);

var _Main6 = _interopRequireDefault(_Main5);

var _nhomepage = __webpack_require__(/*! components/nhomepage/nhomepage.vue */ 97);

var _nhomepage2 = _interopRequireDefault(_nhomepage);

var _HomePage = __webpack_require__(/*! views/academy/HomePage.vue */ 67);

var _HomePage2 = _interopRequireDefault(_HomePage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var jiuJingBuilder = new _routeBuilder2.default('jiujing', _viewWrapper2.default, _innerFrame2.default);
var jiuJingRoutes = _routeBuilder2.default.buildBasicInfo(jiuJingBuilder, '/gtyOrder/', _nhomepage2.default, true);
var promotionInfo = _routeBuilder2.default.buildPromotionInfo(jiuJingBuilder);
var financeInfo = _routeBuilder2.default.buildFinanceInfo(jiuJingBuilder);
var dataSummaryInfo = _routeBuilder2.default.buildDataSummary(jiuJingBuilder, _Main2.default, _Main4.default);
var commentList = _routeBuilder2.default.buildReviewList(jiuJingBuilder, _Main6.default);
var qaqManage = _routeBuilder2.default.buildQaA(jiuJingBuilder);

var xgxy = _routeBuilder2.default.buildXAXY(jiuJingBuilder, _HomePage2.default);
var gzzx = _routeBuilder2.default.buildGZZX(jiuJingBuilder);
jiuJingRoutes.push(financeInfo);
jiuJingRoutes.push(dataSummaryInfo);
jiuJingRoutes.push(promotionInfo);
jiuJingRoutes.push(commentList);
jiuJingRoutes.push(qaqManage);
jiuJingRoutes.push(xgxy);
jiuJingRoutes.push(gzzx);

exports.default = jiuJingRoutes;

/***/ }),
/* 621 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6cf793fa","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/inner-frame/inner-frame.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 622 */
/*!***********************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/inner-frame/inner-frame.vue ***!
  \***********************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    src: {
      type: String,
      required: false,
      validator: function validator(val) {
        if (!val || !val.trim().length) {
          return false;
        }
        return true;
      }
    }
  },
  data: function data() {
    return {
      metaSrc: null,
      withPadding: false,
      isFrameLoading: false,
      loadingWidth: 0
    };
  },
  created: function created() {
    var _this = this;

    var route = this.$route;
    this.updateMetaSrc(route);
    this.unregisterRouteHookFn = this.$router.beforeEach(function (to, from, next) {
      _this.updateMetaSrc(to);
      next();
    });
  },

  methods: {
    updateMetaSrc: function updateMetaSrc(route) {
      if (route.meta) {
        if (route.meta.src) {
          this.metaSrc = route.meta.src;
        }
        this.withPadding = route.meta.withPadding;
      }
    }
  },
  destroyed: function destroyed() {
    if (this.unregisterRouteHookFn) {
      this.unregisterRouteHookFn();
    }
  },

  computed: {
    iframeSrc: function iframeSrc() {
      var src = this.src || this.metaSrc;
      if (src) {
        src = src.replace(".html/#", ".html#");
      }
      return src;
    }
  }
};

/***/ }),
/* 623 */
/*!**************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cf793fa","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inner-frame/inner-frame.vue ***!
  \**************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "frame-wrapper",
    class: {
      pad10: _vm.withPadding
    }
  }, [(_vm.iframeSrc) ? _c('iframe', {
    ref: "innerFrame",
    attrs: {
      "src": _vm.iframeSrc,
      "frameborder": "0"
    }
  }) : _c('p', [_vm._v("\n        嵌入错误\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 624 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1e1a4df6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/operateData/Main.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 625 */
/*!************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/operateData/Main.vue ***!
  \************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Title = __webpack_require__(/*! ../components/title/Title.vue */ 163);

var _Title2 = _interopRequireDefault(_Title);

var _KeyIndicators = __webpack_require__(/*! ./components/key-indicators/KeyIndicators.vue */ 629);

var _KeyIndicators2 = _interopRequireDefault(_KeyIndicators);

var _TransactionConversionProbability = __webpack_require__(/*! ./components/transaction-conversion-probability/TransactionConversionProbability.vue */ 644);

var _TransactionConversionProbability2 = _interopRequireDefault(_TransactionConversionProbability);

var _MarketingOverview = __webpack_require__(/*! ./components/marketing-overview/MarketingOverview.vue */ 651);

var _MarketingOverview2 = _interopRequireDefault(_MarketingOverview);

var _BusinessTrends = __webpack_require__(/*! ./components/business-trends/BusinessTrends.vue */ 658);

var _BusinessTrends2 = _interopRequireDefault(_BusinessTrends);

var _dataPlatform = __webpack_require__(/*! api/dataPlatform */ 19);

var _dataPlatform2 = _interopRequireDefault(_dataPlatform);

var _momentFormat = __webpack_require__(/*! ../filters/moment-format */ 6);

var _momentFormat2 = _interopRequireDefault(_momentFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        TitleComponent: _Title2.default,
        KeyIndicatorsComponent: _KeyIndicators2.default,
        TransactionConversionProbabilityComponent: _TransactionConversionProbability2.default,
        MarketingOverviewComponent: _MarketingOverview2.default,
        BusinessTrendsComponent: _BusinessTrends2.default
    },
    data: function data() {
        var data = {
            title: '经营数据',
            bizCode: null, // 业务线
            startDate: _momentFormat2.default.getYestoday(), // 开始日期，默认昨天
            endDate: _momentFormat2.default.getYestoday(), // 结束日期，默认昨天
            resultData: {}
        };
        switch (this.$route.params.type || this.$route.meta.type) {
            case 'gty':
                data.bizCode = 11021;
                break;
            case 'jiujing':
                data.bizCode = 11022;
                break;
            default:
                window.location.href = '/';
        }
        return data;
    },

    methods: {
        // 获取数据
        getOperationData: function getOperationData() {
            var _this = this;

            _dataPlatform2.default.getOperationData(this.bizCode, this.startDate, this.endDate).then(function (res) {
                console.log(res);
                if (res.status === 0) {
                    _this.resultData = res.data;
                } else {
                    _this.$notify.error({
                        title: '错误',
                        message: res.message || '请求失败'
                    });
                }
            }).catch(function (err) {
                console.log(err);
            });
        }
    },
    created: function created() {
        this.getOperationData();
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 626 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dbe6b3da","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/components/title/Title.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 627 */
/*!******************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/components/title/Title.vue ***!
  \******************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    data: function data() {
        return {};
    },

    props: ['title']
};

/***/ }),
/* 628 */
/*!*********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dbe6b3da","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/components/title/Title.vue ***!
  \*********************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "title-data"
  }, [_c('p', [_vm._v("提示：本页面提供的数据仅供商户作为调整经营策略参考，不作为结款与验证的准确依据。")])])
}]}

/***/ }),
/* 629 */
/*!****************************************************************************************!*\
  !*** ./src/views/dataPlatform/operateData/components/key-indicators/KeyIndicators.vue ***!
  \****************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-6cbfcae3","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./KeyIndicators.vue */ 630)
}
var Component = __webpack_require__(/*! ../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./KeyIndicators.vue */ 631),
  /* template */
  __webpack_require__(/*! !../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6cbfcae3","hasScoped":true}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./KeyIndicators.vue */ 643),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6cbfcae3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 630 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6cbfcae3","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/operateData/components/key-indicators/KeyIndicators.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 631 */
/*!***********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/operateData/components/key-indicators/KeyIndicators.vue ***!
  \***********************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _TitleDate = __webpack_require__(/*! ../../../components/title-date/TitleDate.vue */ 10);

var _TitleDate2 = _interopRequireDefault(_TitleDate);

var _IndicatorsData = __webpack_require__(/*! ../../../components/indicators-data/IndicatorsData.vue */ 93);

var _IndicatorsData2 = _interopRequireDefault(_IndicatorsData);

var _Tips = __webpack_require__(/*! ../../../components/tips/Tips.vue */ 53);

var _Tips2 = _interopRequireDefault(_Tips);

var _dataPlatform = __webpack_require__(/*! api/dataPlatform */ 19);

var _dataPlatform2 = _interopRequireDefault(_dataPlatform);

var _momentFormat = __webpack_require__(/*! ../../../filters/moment-format */ 6);

var _momentFormat2 = _interopRequireDefault(_momentFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		TitleDateComponent: _TitleDate2.default,
		IndicatorsDataComponent: _IndicatorsData2.default,
		TipsComponent: _Tips2.default
	},
	data: function data() {
		var data = {
			titleOption: { // 单元块名称和日期选择配置
				title: '关键指标', // 名称
				dateRadio: true, // 是否显示昨天、本周、本月日期单选框
				dateRangeSelect: false, // 是否显示日期区间下拉框
				download: false // 是否显示下载按钮
			},
			startDate: _momentFormat2.default.getYestoday(), // 开始日期，默认昨天
			endDate: _momentFormat2.default.getYestoday(), // 结束日期，默认昨天
			initDateRange: _momentFormat2.default.getYestoday() + ' ~ ' + _momentFormat2.default.getYestoday(),
			data: this.resultData
		};
		return data;
	},

	computed: {
		// 单个指标数据
		indicatorsData: function indicatorsData() {
			return {
				pageViews: {
					name: '浏览量',
					value: this.data.intentionPv,
					unit: '次',
					compare: this.data.intentionPvChg,
					title: '浏览次数'
				},
				visitors: {
					name: '访客数',
					value: this.data.intentionUv,
					unit: '人',
					compare: this.data.intentionUvChg,
					title: '浏览用户数量'
				},
				salesNumber: {
					name: '销售量',
					value: this.data.payQuantity,
					unit: '件',
					compare: this.data.payQuantityChg,
					title: '销量'
				},
				salesMoney: {
					name: '销售额',
					value: this.data.payAmt,
					unit: '元',
					compare: this.data.payAmtChg,
					title: '销售额'
				},
				salesRate: {
					name: '动销率',
					value: this.data.payProductRate,
					unit: '%',
					compare: this.data.payProductRateChg,
					title: '有销量的在线商品数／在线商品数'
				}
			};
		},


		// 底部建议
		info: function info() {
			var suggest = '';
			// 跟团业务线有服务指标页面
			if (this.bizCode === 11021) {
				suggest = "优化商品标题和描述，提升<a href='./index.html?#/gty/dataPlatform/serviceData'>服务指标</a>，对流量的稳步提升会有所帮助。";
			} else {
				suggest = "优化商品标题和描述，提升服务指标，对流量的稳步提升会有所帮助。";
			}
			return {
				value: this.data.intentionPvChg,
				title: "您经营的商品整体流量与上一周期相比",
				suggest: suggest
			};
		}
	},
	props: ["resultData", "bizCode"],
	watch: {
		resultData: {
			handler: function handler() {
				this.data = this.resultData;
			},
			deep: true
		}
	},
	methods: {
		getData: function getData() {
			var _this = this;

			_dataPlatform2.default.getOperationData(this.bizCode, this.startDate, this.endDate).then(function (res) {
				console.log(res);
				if (res.status === 0) {
					_this.data = res.data;
				} else {
					_this.data = {};
					_this.$notify.error({
						title: '错误',
						message: res.message || '请求失败'
					});
				}
			}).catch(function (err) {
				_this.data = {};
				console.log(err);
			});
		},


		// 切换日期
		changeDate: function changeDate(params) {
			this.startDate = params.dateRange.startDate;
			this.endDate = params.dateRange.endDate;
			this.getData();
		}
	}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 632 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-55ba80d0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/components/title-date/TitleDate.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 633 */
/*!***************************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/components/title-date/TitleDate.vue ***!
  \***************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = __webpack_require__(/*! moment */ 32);

var _moment2 = _interopRequireDefault(_moment);

var _momentFormat = __webpack_require__(/*! ../../filters/moment-format */ 6);

var _momentFormat2 = _interopRequireDefault(_momentFormat);

var _dataPlatform = __webpack_require__(/*! api/dataPlatform */ 19);

var _dataPlatform2 = _interopRequireDefault(_dataPlatform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            dateRadio: 0, // 昨天、7天、30天
            dateInputOption: { // 选择日期配置
                'mode': 'range',
                'maxDate': _momentFormat2.default.getYestoday(),
                'minDate': '',
                'onClose': function (value) {
                    // 清空对比日期
                    this.dateCompareRange.startDate = '';
                    this.dateCompareRange.endDate = '';
                    this.$emit('changeCompareDate', { dateRange: this.dateCompareRange });
                    if (value.length !== 2) {
                        return;
                    }
                    if (!this.titleOption.dateMaxRangeLength) {
                        // 最长限制30天周期
                        if ((0, _moment2.default)(value[1]).diff((0, _moment2.default)(value[0]), 'days') > 30) {
                            this.$notify.error({
                                title: '错误',
                                message: '最长可选30天周期'
                            });
                            return;
                        }
                    } else {
                        if ((0, _moment2.default)(value[1]).diff((0, _moment2.default)(value[0]), 'days') > parseInt(this.titleOption.dateMaxRangeLength)) {
                            this.$notify.error({
                                title: '错误',
                                message: '最长可选' + this.titleOption.dateMaxRangeLength + '天周期'
                            });
                            return;
                        }
                    }
                    this.differenceDays = (0, _moment2.default)(value[1]).diff((0, _moment2.default)(value[0]), 'days');
                    this.dateRange.startDate = (0, _moment2.default)(value[0]).format('YYYY-MM-DD');
                    this.dateRange.endDate = (0, _moment2.default)(value[1]).format('YYYY-MM-DD');
                    this.getData();
                }.bind(this)
            },
            dateRange: {
                startDate: this.titleOption.showDate ? this.titleOption.showDate.startDate : _momentFormat2.default.getYestoday(),
                endDate: this.titleOption.showDate ? this.titleOption.showDate.endDate : _momentFormat2.default.getYestoday()
            },
            differenceDays: 6, // 相差天数
            dateCompareRange: {
                startDate: '',
                endDate: ''
            }
        };
    },

    computed: {
        dateCompareInputOption: function dateCompareInputOption() {
            return {
                'mode': 'single',
                'maxDate': (0, _moment2.default)().subtract(_moment2.default.duration(this.differenceDays + 1, 'd')).format('YYYY-MM-DD'),
                'minDate': '',
                'onClose': function (value) {
                    this.dateCompareRange.startDate = (0, _moment2.default)(value[0]).format('YYYY-MM-DD');
                    this.dateCompareRange.endDate = (0, _moment2.default)(value[0]).add(_moment2.default.duration(this.differenceDays, 'd')).format('YYYY-MM-DD');
                }.bind(this)
            };
        }
    },
    props: ["titleOption", "initDateRange"],
    methods: {
        // 切换昨天、7天、30天
        changeDateRadio: function changeDateRadio(e) {
            var ev = e.target;
            if (ev.tagName === 'SPAN') {
                var type = parseInt(ev.dataset.type);
                if (this.dateRadio === type) {
                    return;
                }
                this.dateRadio = type;
                switch (this.dateRadio) {
                    case 0:
                        this.dateRange.startDate = _momentFormat2.default.getYestoday();
                        this.dateRange.endDate = _momentFormat2.default.getYestoday();
                        break;
                    case 1:
                        this.dateRange.startDate = _momentFormat2.default.getSevenDate();
                        this.dateRange.endDate = _momentFormat2.default.getYestoday();
                        break;
                    case 2:
                        this.dateRange.startDate = _momentFormat2.default.getThirtyDate();
                        this.dateRange.endDate = _momentFormat2.default.getYestoday();
                        break;
                }
                this.getData();
            } else {
                return;
            }
        },


        // 获取数据
        getData: function getData() {
            this.$emit('changeDate', { dateRange: this.dateRange });
        },


        // 下载
        downloadData: function downloadData() {
            if (this.titleOption.moduleId) {
                if (this.titleOption.moduleId === 1 || this.titleOption.moduleId === 2 || this.titleOption.moduleId === 3 || this.titleOption.moduleId === 4) {
                    _dataPlatform2.default.downloadData(this.titleOption.bizCode, this.dateRange.startDate, this.dateRange.endDate, this.titleOption.moduleId);
                } else {
                    _dataPlatform2.default.downloadProductData(this.titleOption.bizCode, this.dateRange.startDate, this.dateRange.endDate, this.titleOption.moduleId, this.titleOption.productId ? this.titleOption.productId.toString() : '');
                }
            } else {
                // 门票数据平台相关下载
                this.$emit('downloadMenpiaoData');
            }
        },


        // 更多
        moreData: function moreData() {
            router.push({ name: this.titleOption.moreUrl });
        },


        // 对比数据
        compareData: function compareData() {
            if (this.dateCompareRange.startDate === '' || this.dateCompareRange.endDate === '') {
                this.$notify.error({
                    title: '错误',
                    message: '请先选择对比日期'
                });
                return;
            }
            this.$emit('changeCompareDate', { dateRange: this.dateCompareRange });
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 634 */
/*!******************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55ba80d0","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/components/title-date/TitleDate.vue ***!
  \******************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "title-date"
  }, [_c('h2', [_vm._v(_vm._s(_vm.titleOption.title))]), _vm._v(" "), _c('section', {
    staticClass: "date"
  }, [(_vm.titleOption.dateRadio) ? _c('section', {
    staticClass: "date-radio",
    on: {
      "click": function($event) {
        _vm.changeDateRadio($event)
      }
    }
  }, [_c('span', {
    class: {
      'active': _vm.dateRadio === 0
    },
    attrs: {
      "data-type": "0"
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('span', {
    class: {
      'active': _vm.dateRadio === 1
    },
    attrs: {
      "data-type": "1"
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('span', {
    class: {
      'active': _vm.dateRadio === 2
    },
    attrs: {
      "data-type": "2"
    }
  }, [_vm._v("最近30天")])]) : _vm._e(), _vm._v(" "), (_vm.titleOption.dateCompareSelect) ? _c('section', {
    staticClass: "compare-box"
  }, [_c('v-datepicker', {
    attrs: {
      "options": _vm.dateCompareInputOption,
      "placeholder": "请添加对比日期"
    },
    model: {
      value: (_vm.dateCompareRange.startDate),
      callback: function($$v) {
        _vm.dateCompareRange.startDate = $$v
      },
      expression: "dateCompareRange.startDate"
    }
  }), _vm._v("\n            ~\n            "), _c('span', [_vm._v(_vm._s(_vm.dateCompareRange.endDate))]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "点击对比"
    },
    on: {
      "click": _vm.compareData
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.titleOption.dateRangeSelect) ? _c('v-datepicker', {
    attrs: {
      "options": _vm.dateInputOption,
      "message": _vm.initDateRange
    }
  }) : _vm._e(), _vm._v(" "), (_vm.titleOption.download) ? _c('section', {
    staticClass: "download",
    on: {
      "click": _vm.downloadData
    }
  }, [_vm._v("\n            下载\n        ")]) : _vm._e(), _vm._v(" "), (_vm.titleOption.more) ? _c('section', {
    staticClass: "more",
    on: {
      "click": _vm.moreData
    }
  }, [_vm._v("\n            更多\n        ")]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 635 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-644b3f48","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/components/indicators-data/IndicatorsData.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 636 */
/*!*************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/components/indicators-data/IndicatorsData.vue ***!
  \*************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _percentFormat = __webpack_require__(/*! ../../filters/percent-format */ 33);

var _percentFormat2 = _interopRequireDefault(_percentFormat);

var _dataFormat = __webpack_require__(/*! ../../filters/data-format */ 117);

var _dataFormat2 = _interopRequireDefault(_dataFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    filters: {
        percentformat: _percentFormat2.default,
        dataformat: _dataFormat2.default
    },
    data: function data() {
        return {};
    },

    computed: {
        // 格式化百分比数据
        compare_format: function compare_format() {
            var str = '';
            if ((0, _percentFormat2.default)(this.data.compare) === '--') {
                str = '--';
            } else {
                if (this.data.compare >= 0) {
                    str = '+' + (0, _percentFormat2.default)(this.data.compare) + '%';
                } else {
                    str = (0, _percentFormat2.default)(this.data.compare) + '%';
                }
            }
            return str;
        },
        compare_color: function compare_color() {
            var value = this.data.compare;
            if (isNaN(value) || value === null || value === '') {
                return {
                    'gray-1': true
                };
            } else if (value >= 0) {
                return {
                    'red-1': true
                };
            } else {
                return {
                    'green-1': true
                };
            }
        }
    },
    props: ["data"]
};

/***/ }),
/* 637 */
/*!****************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-644b3f48","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/components/indicators-data/IndicatorsData.vue ***!
  \****************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "indicators-data",
    attrs: {
      "title": _vm.data.title
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.data.name))]), _vm._v(" "), (_vm.data.unit !== '%') ? _c('span', [_vm._v(_vm._s(_vm._f("dataformat")(_vm.data.value))), _c('i', [_vm._v(_vm._s(_vm.data.unit))])]) : _vm._e(), _vm._v(" "), (_vm.data.unit === '%') ? _c('span', [_vm._v(_vm._s(_vm._f("percentformat")(_vm.data.value))), _c('i', [_vm._v(_vm._s(_vm.data.unit))])]) : _vm._e(), _vm._v(" "), (_vm.data.compareInfo) ? _c('span', [_vm._v(_vm._s(_vm.data.compareInfo))]) : _vm._e(), _vm._v(" "), _c('span', {
    class: _vm.compare_color,
    attrs: {
      "title": "较上一周期"
    }
  }, [_vm._v(_vm._s(_vm.compare_format))])])
},staticRenderFns: []}

/***/ }),
/* 638 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1278c5a1","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/components/tips/Tips.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 639 */
/*!****************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/components/tips/Tips.vue ***!
  \****************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(/*! babel-runtime/helpers/defineProperty */ 114);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _percentFormat = __webpack_require__(/*! ../../filters/percent-format */ 33);

var _percentFormat2 = _interopRequireDefault(_percentFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _defineProperty3.default)({
    filters: {
        percentformat: _percentFormat2.default
    },
    data: function data() {
        return {};
    },

    props: ['info'],
    methods: {}
}, 'filters', {
    // 负数转化为正数
    formatNum: function formatNum(num) {
        if (num >= 0) {
            return '上升了 ' + (0, _percentFormat2.default)(num) + '%';
        } else {
            return '下降了 ' + (0, _percentFormat2.default)(String(num).replace(/^-+/g, '')) + '%';
        }
    }
}); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 640 */
/*!*******************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1278c5a1","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/components/tips/Tips.vue ***!
  \*******************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "tips"
  }, [(_vm.info.reverse ? _vm.info.value <= 0 : _vm.info.value >= 0) ? _c('img', {
    attrs: {
      "src": __webpack_require__(/*! static/img/happy.png */ 641),
      "alt": "图"
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(/*! static/img/sad.png */ 642),
      "alt": "图"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [(_vm.info.title) ? _c('h2', [_vm._v("\n\t            " + _vm._s(_vm.info.title) + "\n\t            "), _c('em', {
    class: {
      'red': _vm.info.value < 0
    }
  }, [_vm._v("\n\t                " + _vm._s(_vm._f("formatNum")(_vm.info.value)) + "\n\t            ")])]) : _vm._e(), _vm._v(" "), _c('p', {
    class: {
      'other': !_vm.info.title
    },
    domProps: {
      "innerHTML": _vm._s(_vm.info.suggest)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 641 */
/*!******************************!*\
  !*** ./static/img/happy.png ***!
  \******************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/happy.b50da42.png";

/***/ }),
/* 642 */
/*!****************************!*\
  !*** ./static/img/sad.png ***!
  \****************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sad.5d7c5eb.png";

/***/ }),
/* 643 */
/*!**************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cbfcae3","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/operateData/components/key-indicators/KeyIndicators.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "key-indicators"
  }, [_c('title-date-component', {
    attrs: {
      "titleOption": _vm.titleOption,
      "initDateRange": _vm.initDateRange
    },
    on: {
      "changeDate": _vm.changeDate
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "indicators-data-box"
  }, _vm._l((_vm.indicatorsData), function(item, index) {
    return _c('indicators-data-component', {
      key: item.name,
      attrs: {
        "data": item
      }
    })
  })), _vm._v(" "), _c('tips-component', {
    attrs: {
      "info": _vm.info
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 644 */
/*!*******************************************************************************************************************************!*\
  !*** ./src/views/dataPlatform/operateData/components/transaction-conversion-probability/TransactionConversionProbability.vue ***!
  \*******************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-5811ec56","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./TransactionConversionProbability.vue */ 645)
}
var Component = __webpack_require__(/*! ../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./TransactionConversionProbability.vue */ 646),
  /* template */
  __webpack_require__(/*! !../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-5811ec56","hasScoped":true}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./TransactionConversionProbability.vue */ 650),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5811ec56",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 645 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5811ec56","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/operateData/components/transaction-conversion-probability/TransactionConversionProbability.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/*!**************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/operateData/components/transaction-conversion-probability/TransactionConversionProbability.vue ***!
  \**************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TitleDate = __webpack_require__(/*! ../../../components/title-date/TitleDate.vue */ 10);

var _TitleDate2 = _interopRequireDefault(_TitleDate);

var _LineTips = __webpack_require__(/*! ../line-tips/LineTips.vue */ 94);

var _LineTips2 = _interopRequireDefault(_LineTips);

var _Tips = __webpack_require__(/*! ../../../components/tips/Tips.vue */ 53);

var _Tips2 = _interopRequireDefault(_Tips);

var _dataFormat = __webpack_require__(/*! ../../../filters/data-format */ 117);

var _dataFormat2 = _interopRequireDefault(_dataFormat);

var _dataPlatform = __webpack_require__(/*! api/dataPlatform */ 19);

var _dataPlatform2 = _interopRequireDefault(_dataPlatform);

var _momentFormat = __webpack_require__(/*! ../../../filters/moment-format */ 6);

var _momentFormat2 = _interopRequireDefault(_momentFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    components: {
        TitleDateComponent: _TitleDate2.default,
        LineTipsComponent: _LineTips2.default,
        TipsComponent: _Tips2.default
    },
    filters: {
        dataformat: _dataFormat2.default
    },
    data: function data() {
        return {
            titleOption: { // 单元块名称和日期选择配置
                title: '交易转化概率', // 名称
                dateRadio: false, // 是否显示昨天、本周、本月日期单选框
                dateRangeSelect: true, // 是否显示日期区间下拉框
                download: true, // 是否显示下载按钮
                moduleId: 1,
                bizCode: this.bizCode
            },
            startDate: _momentFormat2.default.getYestoday(), // 开始日期，默认昨天
            endDate: _momentFormat2.default.getYestoday(), // 结束日期，默认昨天
            initDateRange: _momentFormat2.default.getYestoday() + ' ~ ' + _momentFormat2.default.getYestoday(),
            data: this.resultData
        };
    },

    computed: {
        // 访购率指标
        lineTipsInfo: function lineTipsInfo() {
            return {
                name: '访购率',
                value: this.data.purchaseRate,
                unit: '%',
                compare: this.data.purchaseRateChg,
                title: '支付用户数／浏览用户数'
            };
        },


        // 底部建议
        info: function info() {
            return {
                value: this.data.purchaseRateChg,
                title: "您经营的商品访购率与上一周期相比",
                suggest: "访购率是您经营的转化的重要指标，优化商品市场定位、商品描述、商品服务、价格对访购率的提升会所帮助。"
            };
        }
    },
    props: ["resultData", "bizCode"],
    watch: {
        resultData: {
            handler: function handler() {
                this.data = this.resultData;
            },
            deep: true
        }
    },
    methods: {
        getData: function getData() {
            var _this = this;

            _dataPlatform2.default.getOperationData(this.bizCode, this.startDate, this.endDate).then(function (res) {
                console.log(res);
                if (res.status === 0) {
                    _this.data = res.data;
                } else {
                    _this.data = {};
                    _this.$notify.error({
                        title: '错误',
                        message: res.message || '请求失败'
                    });
                }
            }).catch(function (err) {
                _this.data = {};
                console.log(err);
            });
        },


        // 切换日期
        changeDate: function changeDate(params) {
            this.startDate = params.dateRange.startDate;
            this.endDate = params.dateRange.endDate;
            this.getData();
        }
    }
};

/***/ }),
/* 647 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-63a31332","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/operateData/components/line-tips/LineTips.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 648 */
/*!*************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/operateData/components/line-tips/LineTips.vue ***!
  \*************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _IndicatorsData = __webpack_require__(/*! ../../../components/indicators-data/IndicatorsData.vue */ 93);

var _IndicatorsData2 = _interopRequireDefault(_IndicatorsData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        IndicatorsDataComponent: _IndicatorsData2.default
    },
    data: function data() {
        return {};
    },

    props: ["lineTipsInfo"],
    methods: {}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 649 */
/*!****************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63a31332","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/operateData/components/line-tips/LineTips.vue ***!
  \****************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "line-tips"
  }, [_c('section', {
    staticClass: "txt"
  }, [_c('indicators-data-component', {
    attrs: {
      "data": _vm.lineTipsInfo
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "sanjiao"
  })])
},staticRenderFns: []}

/***/ }),
/* 650 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5811ec56","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/operateData/components/transaction-conversion-probability/TransactionConversionProbability.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "transaction-conversion-probability"
  }, [_c('title-date-component', {
    attrs: {
      "titleOption": _vm.titleOption,
      "initDateRange": _vm.initDateRange
    },
    on: {
      "changeDate": _vm.changeDate
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "data-box"
  }, [_c('line-tips-component', {
    staticStyle: {
      "margin-top": "45px"
    },
    attrs: {
      "lineTipsInfo": _vm.lineTipsInfo
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "data"
  }, [_c('section', [_c('span', {
    attrs: {
      "title": "浏览次数"
    }
  }, [_c('i', [_vm._v("浏览量")]), _vm._v(_vm._s(_vm._f("dataformat")(_vm.data.intentionPv)))]), _vm._v(" "), _c('span', {
    attrs: {
      "title": "浏览用户数量"
    }
  }, [_c('i', [_vm._v("访客数")]), _vm._v(_vm._s(_vm._f("dataformat")(_vm.data.intentionUv)))])]), _vm._v(" "), _c('section', [_c('span', {
    attrs: {
      "title": "所售商品有下单行为的用户数量"
    }
  }, [_c('i', [_vm._v("下单用户数")]), _vm._v(_vm._s(_vm._f("dataformat")(_vm.data.orderUserNum)))]), _vm._v(" "), _c('span', {
    attrs: {
      "title": "所售商品产生的订单数量"
    }
  }, [_c('i', [_vm._v("订单量")]), _vm._v(_vm._s(_vm._f("dataformat")(_vm.data.orderOrderNum)))])]), _vm._v(" "), _c('section', [_c('span', {
    attrs: {
      "title": "产生的支付行为的用户数量"
    }
  }, [_c('i', [_vm._v("支付用户数")]), _vm._v(_vm._s(_vm._f("dataformat")(_vm.data.payUserNum)))]), _vm._v(" "), _c('span', {
    attrs: {
      "title": "产生的支付订单数量"
    }
  }, [_c('i', [_vm._v("支付订单量")]), _vm._v(_vm._s(_vm._f("dataformat")(_vm.data.payOrderNum)))]), _vm._v(" "), _c('span', {
    attrs: {
      "title": "销售额／支付用户数"
    }
  }, [_c('i', [_vm._v("客单价")]), _vm._v(_vm._s(_vm.data.unitPrice))])])])], 1), _vm._v(" "), _c('tips-component', {
    attrs: {
      "info": _vm.info
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "funnel"
  }, [_c('section', [_c('span', [_vm._v("浏览")])]), _vm._v(" "), _c('section', [_c('span', [_vm._v("下单")])]), _vm._v(" "), _c('section', [_c('span', [_vm._v("支付")])])])
}]}

/***/ }),
/* 651 */
/*!************************************************************************************************!*\
  !*** ./src/views/dataPlatform/operateData/components/marketing-overview/MarketingOverview.vue ***!
  \************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-2c9a5b26","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MarketingOverview.vue */ 652)
}
var Component = __webpack_require__(/*! ../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MarketingOverview.vue */ 653),
  /* template */
  __webpack_require__(/*! !../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-2c9a5b26","hasScoped":true}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MarketingOverview.vue */ 657),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2c9a5b26",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 652 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2c9a5b26","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/operateData/components/marketing-overview/MarketingOverview.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 653 */
/*!*******************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/operateData/components/marketing-overview/MarketingOverview.vue ***!
  \*******************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TitleDate = __webpack_require__(/*! ../../../components/title-date/TitleDate.vue */ 10);

var _TitleDate2 = _interopRequireDefault(_TitleDate);

var _LineTips = __webpack_require__(/*! ../line-tips/LineTips.vue */ 94);

var _LineTips2 = _interopRequireDefault(_LineTips);

var _Columnar = __webpack_require__(/*! ../../../components/echarts/Columnar.vue */ 247);

var _Columnar2 = _interopRequireDefault(_Columnar);

var _Tips = __webpack_require__(/*! ../../../components/tips/Tips.vue */ 53);

var _Tips2 = _interopRequireDefault(_Tips);

var _dataPlatform = __webpack_require__(/*! api/dataPlatform */ 19);

var _dataPlatform2 = _interopRequireDefault(_dataPlatform);

var _momentFormat = __webpack_require__(/*! ../../../filters/moment-format */ 6);

var _momentFormat2 = _interopRequireDefault(_momentFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    components: {
        TitleDateComponent: _TitleDate2.default,
        LineTipsComponent: _LineTips2.default,
        ColumnarComponent: _Columnar2.default,
        TipsComponent: _Tips2.default
    },
    data: function data() {
        return {
            titleOption: { // 单元块名称和日期选择配置
                title: '交易商品动销概况', // 名称
                dateRadio: false, // 是否显示昨天、本周、本月日期单选框
                dateRangeSelect: true, // 是否显示日期区间下拉框
                download: true, // 是否显示下载按钮
                moduleId: 2,
                bizCode: this.bizCode
            },
            startDate: _momentFormat2.default.getYestoday(), // 开始日期，默认昨天
            endDate: _momentFormat2.default.getYestoday(), // 结束日期，默认昨天
            initDateRange: _momentFormat2.default.getYestoday() + ' ~ ' + _momentFormat2.default.getYestoday(),
            data: this.resultData
        };
    },

    computed: {
        // 动销率指标
        lineTipsInfo: function lineTipsInfo() {
            return {
                name: '动销率',
                value: this.data.payProductRate,
                unit: '%',
                compare: this.data.payProductRateChg,
                title: '有销量的在线商品数／在线商品数'
            };
        },


        // 底部建议
        info: function info() {
            return {
                value: 1,
                suggest: "动销率是关于商品滞销情况的关键数据。动销率＞100%，说明您备货不足，部分商品缺货，需要更好的及时备货和货品管理；动销＜100%，需要根据商品分析定位和问题，降低滞销商品的数量。"
            };
        },


        // 图表数据
        columnarData: function columnarData() {
            return [this.data.payProductNum, this.data.orderProductNum, this.data.viewProductNum, this.data.onlineProductNum];
        }
    },
    props: ["resultData", "bizCode"],
    watch: {
        resultData: {
            handler: function handler() {
                this.data = this.resultData;
            },
            deep: true
        }
    },
    methods: {
        getData: function getData() {
            var _this = this;

            _dataPlatform2.default.getOperationData(this.bizCode, this.startDate, this.endDate).then(function (res) {
                console.log(res);
                if (res.status === 0) {
                    _this.data = res.data;
                } else {
                    _this.data = {};
                    _this.$notify.error({
                        title: '错误',
                        message: res.message || '请求失败'
                    });
                }
            }).catch(function (err) {
                _this.data = {};
                console.log(err);
            });
        },


        // 切换日期
        changeDate: function changeDate(params) {
            this.startDate = params.dateRange.startDate;
            this.endDate = params.dateRange.endDate;
            this.getData();
        }
    }
};

/***/ }),
/* 654 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1d6ff03a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/components/echarts/Columnar.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 655 */
/*!***********************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/components/echarts/Columnar.vue ***!
  \***********************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    components: {},
    data: function data() {
        return {
            myChart: {}
        };
    },

    props: ["columnarData"],
    computed: {
        getOption: function getOption() {
            var opt = {
                tooltip: {
                    show: true,
                    backgroundColor: 'rgba(255, 255, 255, .92)',
                    textStyle: {
                        color: '#142C3D'
                    },
                    extraCssText: 'box-shadow: 0 1px 18px 0 rgba(151, 189, 208, .3);'
                },
                grid: {
                    left: '2%',
                    right: '2%',
                    top: '2%',
                    bottom: '2%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    axisLine: {
                        lineStyle: {
                            color: '#E9EEF0'
                        }
                    },
                    axisLabel: {
                        color: '#6E808B'
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#E9EEF0'
                        }
                    }
                },
                yAxis: {
                    type: 'category',
                    data: ['被支付商品数', '被下单商品数', '被浏览商品数', '在售商品数'],
                    axisLine: {
                        lineStyle: {
                            color: '#E9EEF0'
                        }
                    },
                    axisLabel: {
                        color: '#142C3D',
                        fontSize: 14
                    }
                },
                series: [{
                    name: '数量',
                    type: 'bar',
                    data: this.columnarData,
                    itemStyle: {
                        normal: {
                            color: '#26ABFF'
                        }
                    },
                    barWidth: '50%'
                }]
            };
            return opt;
        }
    },
    watch: {
        'columnarData': function columnarData() {
            this.changeEcharts();
        }
    },
    methods: {
        setEcharts: function setEcharts() {
            var dom = document.getElementById('myColumnarEcharts');
            this.myChart = echarts.init(dom);
            this.myChart.setOption(this.getOption);
        },
        changeEcharts: function changeEcharts() {
            this.myChart.setOption(this.getOption);
        }
    },
    mounted: function mounted() {
        this.setEcharts();
    }
};

/***/ }),
/* 656 */
/*!**************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d6ff03a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/components/echarts/Columnar.vue ***!
  \**************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "columnar",
    attrs: {
      "id": "myColumnarEcharts"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 657 */
/*!**********************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c9a5b26","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/operateData/components/marketing-overview/MarketingOverview.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "marketing-overview"
  }, [_c('title-date-component', {
    attrs: {
      "titleOption": _vm.titleOption,
      "initDateRange": _vm.initDateRange
    },
    on: {
      "changeDate": _vm.changeDate
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "data-box"
  }, [_c('LineTipsComponent', {
    staticStyle: {
      "width": "180px",
      "margin-top": "33px"
    },
    attrs: {
      "lineTipsInfo": _vm.lineTipsInfo
    }
  }), _vm._v(" "), _c('columnar-component', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "columnarData": _vm.columnarData
    }
  })], 1), _vm._v(" "), _c('tips-component', {
    attrs: {
      "info": _vm.info
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 658 */
/*!******************************************************************************************!*\
  !*** ./src/views/dataPlatform/operateData/components/business-trends/BusinessTrends.vue ***!
  \******************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-8989b902","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BusinessTrends.vue */ 659)
}
var Component = __webpack_require__(/*! ../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BusinessTrends.vue */ 660),
  /* template */
  __webpack_require__(/*! !../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-8989b902","hasScoped":true}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BusinessTrends.vue */ 667),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8989b902",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 659 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8989b902","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/operateData/components/business-trends/BusinessTrends.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 660 */
/*!*************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/operateData/components/business-trends/BusinessTrends.vue ***!
  \*************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
				value: true
});

var _TitleDate = __webpack_require__(/*! ../../../components/title-date/TitleDate.vue */ 10);

var _TitleDate2 = _interopRequireDefault(_TitleDate);

var _Nav = __webpack_require__(/*! ../../../components/nav/Nav.vue */ 37);

var _Nav2 = _interopRequireDefault(_Nav);

var _Line = __webpack_require__(/*! ../../../components/echarts/Line.vue */ 78);

var _Line2 = _interopRequireDefault(_Line);

var _dataPlatform = __webpack_require__(/*! api/dataPlatform */ 19);

var _dataPlatform2 = _interopRequireDefault(_dataPlatform);

var _momentFormat = __webpack_require__(/*! ../../../filters/moment-format */ 6);

var _momentFormat2 = _interopRequireDefault(_momentFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
				components: {
								TitleDateComponent: _TitleDate2.default,
								NavComponent: _Nav2.default,
								LineComponent: _Line2.default
				},
				data: function data() {
								var data = {
												titleOption: { // 单元块名称和日期选择配置
																title: '经营趋势', // 名称
																dateRadio: false, // 是否显示昨天、本周、本月日期单选框
																dateRangeSelect: true, // 是否显示日期区间下拉框
																dateCompareSelect: true,
																download: true, // 是否显示下载按钮
																moduleId: 3,
																bizCode: this.bizCode,
																showDate: {
																				startDate: _momentFormat2.default.getSevenDate(),
																				endDate: _momentFormat2.default.getYestoday()
																}
												},
												type: [{
																name: '销量',
																value: 'payQuantity'
												}, {
																name: '销售额',
																value: 'payAmt'
												}, {
																name: '浏览量',
																value: 'intentionPv'
												}, {
																name: '访客量',
																value: 'intentionUv'
												}, {
																name: '访购率',
																value: 'purchaseRate'
												}, {
																name: '下单用户数',
																value: 'orderUserNum'
												}, {
																name: '支付用户数',
																value: 'payUserNum'
												}, {
																name: '客单价',
																value: 'unitPrice'
												}],
												currentType: 'payQuantity', // 当前纬度
												startDate: _momentFormat2.default.getSevenDate(), // 开始日期
												endDate: _momentFormat2.default.getYestoday(), // 结束日期
												initDateRange: _momentFormat2.default.getSevenDate() + ' ~ ' + _momentFormat2.default.getYestoday(),
												typeData: {
																allTypeData: { // 所有维度数据
																				payQuantity: [],
																				payAmt: [],
																				intentionPv: [],
																				intentionUv: [],
																				purchaseRate: [],
																				orderUserNum: [],
																				payUserNum: [],
																				unitPrice: []
																},
																allTypeCompareData: { // 所有对比纬度数据
																				payQuantity: [],
																				payAmt: [],
																				intentionPv: [],
																				intentionUv: [],
																				purchaseRate: [],
																				orderUserNum: [],
																				payUserNum: [],
																				unitPrice: []
																}
												},
												resultData: {
																dateArr: [],
																dataArr: [],
																dateCompareArr: [], // 对比日期
																dataCompareArr: [], // 对比数据
																currentTypeName: '销量'
												}
								};
								return data;
				},

				props: ["bizCode"],
				methods: {
								// 获取经营趋势数据
								getOperationTrendData: function getOperationTrendData() {
												var _this = this;

												_dataPlatform2.default.getOperationTrendData(this.bizCode, this.startDate, this.endDate, this.titleOption.moduleId).then(function (res) {
																console.log(res);
																if (res.status === 0) {
																				var data = res.data;
																				var date = [];
																				var initData = {
																								payQuantity: [],
																								payAmt: [],
																								intentionPv: [],
																								intentionUv: [],
																								purchaseRate: [],
																								orderUserNum: [],
																								payUserNum: [],
																								unitPrice: []
																				};
																				data.forEach(function (item, index) {
																								date.push(item.date);
																								initData.payQuantity.push(item.payQuantity);
																								initData.payAmt.push(item.payAmt);
																								initData.intentionPv.push(item.intentionPv);
																								initData.intentionUv.push(item.intentionUv);
																								initData.purchaseRate.push(item.purchaseRate);
																								initData.orderUserNum.push(item.orderUserNum);
																								initData.payUserNum.push(item.payUserNum);
																								initData.unitPrice.push(item.unitPrice);
																				});
																				_this.typeData.allTypeData = initData;
																				_this.$set(_this.resultData, 'dateArr', date);
																				_this.$set(_this.resultData, 'dataArr', _this.typeData.allTypeData[_this.currentType]);
																} else {
																				_this.$notify.error({
																								title: '错误',
																								message: res.message || '请求失败'
																				});
																}
												}).catch(function (err) {
																_this.resultData.dateArr = [];
																_this.resultData.dataArr = [];
																console.log(err);
												});
								},


								// 切换类型
								changeNavType: function changeNavType(type) {
												var _this2 = this;

												this.currentType = type;
												var currentTypeName = this.type.find(function (item) {
																return item.value === _this2.currentType;
												});
												this.$set(this.resultData, 'dataArr', this.typeData.allTypeData[this.currentType]);
												this.$set(this.resultData, 'dataCompareArr', this.typeData.allTypeCompareData[this.currentType]);
												this.$set(this.resultData, 'currentTypeName', currentTypeName.name);
								},


								// 切换日期
								changeDate: function changeDate(params) {
												this.startDate = params.dateRange.startDate;
												this.endDate = params.dateRange.endDate;
												this.getOperationTrendData();
								},


								// 切换对比日期
								changeCompareDate: function changeCompareDate(params) {
												var _this3 = this;

												if (params.dateRange.startDate === '' || params.dateRange.endDate === '') {
																this.resultData.dateCompareArr = [];
																this.resultData.dataCompareArr = [];
																return;
												}
												_dataPlatform2.default.getOperationTrendData(this.bizCode, params.dateRange.startDate, params.dateRange.endDate, this.titleOption.moduleId).then(function (res) {
																console.log(res);
																if (res.status === 0) {
																				var data = res.data;
																				var date = [];
																				var initData = {
																								payQuantity: [],
																								payAmt: [],
																								intentionPv: [],
																								intentionUv: [],
																								purchaseRate: [],
																								orderUserNum: [],
																								payUserNum: [],
																								unitPrice: []
																				};
																				data.forEach(function (item, index) {
																								date.push(item.date);
																								initData.payQuantity.push(item.payQuantity);
																								initData.payAmt.push(item.payAmt);
																								initData.intentionPv.push(item.intentionPv);
																								initData.intentionUv.push(item.intentionUv);
																								initData.purchaseRate.push(item.purchaseRate);
																								initData.orderUserNum.push(item.orderUserNum);
																								initData.payUserNum.push(item.payUserNum);
																								initData.unitPrice.push(item.unitPrice);
																				});
																				_this3.typeData.allTypeCompareData = initData;
																				_this3.$set(_this3.resultData, 'dateCompareArr', date);
																				_this3.$set(_this3.resultData, 'dataCompareArr', _this3.typeData.allTypeCompareData[_this3.currentType]);
																} else {
																				_this3.$notify.error({
																								title: '错误',
																								message: res.message || '请求失败'
																				});
																}
												}).catch(function (err) {
																_this3.resultData.dateCompareArr = [];
																_this3.resultData.dataCompareArr = [];
																console.log(err);
												});
								}
				},
				mounted: function mounted() {
								this.getOperationTrendData();
				}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 661 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6d0ca32e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/components/nav/Nav.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 662 */
/*!**************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/components/nav/Nav.vue ***!
  \**************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    data: function data() {
        return {};
    },

    props: ['type', 'currentType'],
    methods: {
        // 切换类型
        changeType: function changeType(e) {
            var ev = e.target;
            if (ev.tagName === 'SPAN') {
                var type = ev.dataset.type;
                if (type === this.currentType) {
                    return;
                }
                this.$emit('changeNavType', type);
            } else {
                return;
            }
        }
    }
};

/***/ }),
/* 663 */
/*!*****************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d0ca32e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/components/nav/Nav.vue ***!
  \*****************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "nav",
    on: {
      "click": function($event) {
        _vm.changeType($event)
      }
    }
  }, _vm._l((_vm.type), function(item) {
    return _c('span', {
      class: {
        'active': item.value === _vm.currentType
      },
      attrs: {
        "data-type": item.value
      }
    }, [_vm._v(_vm._s(item.name))])
  }))
},staticRenderFns: []}

/***/ }),
/* 664 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-423e4527","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/components/echarts/Line.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 665 */
/*!*******************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/components/echarts/Line.vue ***!
  \*******************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
    components: {},
    data: function data() {
        return {
            myChart: {}
        };
    },

    props: ["resultData"],
    computed: {
        getOption: function getOption() {
            var _this = this;

            var opt = {
                tooltip: {
                    show: true,
                    trigger: 'axis',
                    backgroundColor: 'rgba(255, 255, 255, .92)',
                    textStyle: {
                        color: '#142C3D'
                    },
                    extraCssText: 'box-shadow: 0 1px 18px 0 rgba(151, 189, 208, .3);',
                    axisPointer: {
                        lineStyle: {
                            color: '#26ABFF',
                            width: 2
                        }
                    },
                    formatter: function formatter(params) {
                        var str = _this.resultData.dateArr[params[0].dataIndex] + '<br>' + params[0].marker + params[0].seriesName + ':' + params[0].value;
                        if (params.length === 2) {
                            str += '<br>' + _this.resultData.dateCompareArr[params[1].dataIndex] + '<br>' + params[1].marker + params[1].seriesName + ':' + params[1].value;
                        }
                        return str;
                    }
                },
                grid: {
                    left: '2%',
                    right: '3%',
                    top: '2%',
                    bottom: '2%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        lineStyle: {
                            color: '#E9EEF0'
                        }
                    },
                    axisLabel: {
                        color: '#6E808B'
                    },
                    data: this.formatDays(this.resultData.dateArr)
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        lineStyle: {
                            color: '#E9EEF0'
                        }
                    },
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        color: '#6E808B'
                    }
                },
                series: [{
                    name: this.resultData.currentTypeName,
                    type: 'line',
                    data: this.formatDatas(this.resultData.dataArr),
                    smooth: true,
                    connectNulls: true,
                    itemStyle: {
                        normal: {
                            color: '#26ABFF'
                        }
                    },
                    areaStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(11, 147, 255, .2)'
                            }, {
                                offset: 1,
                                color: 'rgba(72, 199, 255, 0)'
                            }])
                        }
                    }
                }]
            };
            if (this.resultData && this.resultData.dateCompareArr.length !== 0 && this.resultData.dataCompareArr.length !== 0) {
                opt.series.push({
                    name: this.resultData.currentTypeName,
                    type: 'line',
                    data: this.formatDatas(this.resultData.dataCompareArr),
                    smooth: true,
                    connectNulls: true,
                    itemStyle: {
                        normal: {
                            color: '#1bd380'
                        }
                    },
                    areaStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(76, 238, 166, .2)'
                            }, {
                                offset: 1,
                                color: 'rgba(45, 212, 137, 0)'
                            }])
                        }
                    }
                });
            }
            return opt;
        }
    },
    watch: {
        resultData: {
            handler: function handler() {
                this.changeEcharts();
            },
            deep: true
        }
    },
    methods: {
        setEcharts: function setEcharts() {
            var dom = document.getElementById('myLineEcharts');
            this.myChart = echarts.init(dom);
            this.myChart.setOption(this.getOption, true);
        },
        changeEcharts: function changeEcharts() {
            this.myChart.setOption(this.getOption, true);
        },
        formatDays: function formatDays(arr) {
            if (this.resultData && this.resultData.dateCompareArr.length !== 0 && this.resultData.dataCompareArr.length !== 0) {
                var days = [];
                arr.forEach(function (item, index) {
                    days.push('第' + (index + 1) + '天');
                });
                return days;
            } else {
                return arr;
            }
        },
        formatDatas: function formatDatas(arr) {
            var datas = arr.map(function (item) {
                return !item || item === null || item === '' ? 0 : item;
            });
            return datas;
        }
    },
    mounted: function mounted() {
        this.setEcharts();
    }
};

/***/ }),
/* 666 */
/*!**********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-423e4527","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/components/echarts/Line.vue ***!
  \**********************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "line",
    attrs: {
      "id": "myLineEcharts"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 667 */
/*!****************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8989b902","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/operateData/components/business-trends/BusinessTrends.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "business-trends"
  }, [_c('title-date-component', {
    attrs: {
      "titleOption": _vm.titleOption,
      "initDateRange": _vm.initDateRange
    },
    on: {
      "changeDate": _vm.changeDate,
      "changeCompareDate": _vm.changeCompareDate
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "data-box"
  }, [_c('nav-component', {
    attrs: {
      "type": _vm.type,
      "currentType": _vm.currentType
    },
    on: {
      "changeNavType": _vm.changeNavType
    }
  }), _vm._v(" "), _c('line-component', {
    staticStyle: {
      "width": "95%",
      "height": "320px",
      "margin-top": "50px"
    },
    attrs: {
      "resultData": _vm.resultData
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 668 */
/*!***************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e1a4df6","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/operateData/Main.vue ***!
  \***************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('title-component', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _c('key-indicators-component', {
    attrs: {
      "resultData": _vm.resultData,
      "bizCode": _vm.bizCode
    }
  }), _vm._v(" "), _c('transaction-conversion-probability-component', {
    attrs: {
      "resultData": _vm.resultData,
      "bizCode": _vm.bizCode
    }
  }), _vm._v(" "), _c('marketing-overview-component', {
    attrs: {
      "resultData": _vm.resultData,
      "bizCode": _vm.bizCode
    }
  }), _vm._v(" "), _c('business-trends-component', {
    attrs: {
      "bizCode": _vm.bizCode
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 669 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c7b7890c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/productData/Main.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 670 */
/*!************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/productData/Main.vue ***!
  \************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Title = __webpack_require__(/*! ../components/title/Title.vue */ 163);

var _Title2 = _interopRequireDefault(_Title);

var _PopularProduct = __webpack_require__(/*! ./components/popular-product/PopularProduct.vue */ 671);

var _PopularProduct2 = _interopRequireDefault(_PopularProduct);

var _ProgressProduct = __webpack_require__(/*! ./components/progress-product/ProgressProduct.vue */ 681);

var _ProgressProduct2 = _interopRequireDefault(_ProgressProduct);

var _AbnormalProduct = __webpack_require__(/*! ./components/abnormal-product/AbnormalProduct.vue */ 685);

var _AbnormalProduct2 = _interopRequireDefault(_AbnormalProduct);

var _ProductAnalysis = __webpack_require__(/*! ./components/product-analysis/ProductAnalysis.vue */ 689);

var _ProductAnalysis2 = _interopRequireDefault(_ProductAnalysis);

var _Tc = __webpack_require__(/*! ./components/tc/Tc.vue */ 693);

var _Tc2 = _interopRequireDefault(_Tc);

var _index = __webpack_require__(/*! helpers/index */ 16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    TitleComponent: _Title2.default,
    PopularProductComponent: _PopularProduct2.default,
    ProgressProductComponent: _ProgressProduct2.default,
    AbnormalProductComponent: _AbnormalProduct2.default,
    ProductAnalysisComponent: _ProductAnalysis2.default,
    TcComponent: _Tc2.default
  },
  data: function data() {
    var data = {
      title: '商品数据',
      showTc: false, // 是否显示弹层
      bizCode: null, // 业务线
      productId: 0,
      productName: '',
      startDate: '',
      endDate: ''
    };
    switch (this.$route.params.type || this.$route.meta.type) {
      case 'gty':
        data.bizCode = 11021;
        break;
      case 'jiujing':
        data.bizCode = 11022;
        break;
      default:
        window.location.href = '/';
    }
    return data;
  },

  methods: {
    // 改变弹层显示状态
    changeShowTc: function changeShowTc(status) {
      this.showTc = status;
    }
  },
  created: function created() {
    var _this = this;

    _index.eventBus.$on('showTc', function (params) {
      _this.productId = params.productId;
      _this.productName = params.productName;
      _this.startDate = params.startDate;
      _this.endDate = params.endDate;
      _this.changeShowTc(true);
    });

    _index.eventBus.$on('closeTc', function () {
      _this.changeShowTc(false);
    });
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 671 */
/*!******************************************************************************************!*\
  !*** ./src/views/dataPlatform/productData/components/popular-product/PopularProduct.vue ***!
  \******************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-7f97605c","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PopularProduct.vue */ 672)
}
var Component = __webpack_require__(/*! ../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PopularProduct.vue */ 673),
  /* template */
  __webpack_require__(/*! !../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7f97605c","hasScoped":true}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PopularProduct.vue */ 680),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7f97605c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 672 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7f97605c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/productData/components/popular-product/PopularProduct.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 673 */
/*!*************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/productData/components/popular-product/PopularProduct.vue ***!
  \*************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TitleDate = __webpack_require__(/*! ../../../components/title-date/TitleDate.vue */ 10);

var _TitleDate2 = _interopRequireDefault(_TitleDate);

var _Rose = __webpack_require__(/*! ../../../components/echarts/Rose.vue */ 248);

var _Rose2 = _interopRequireDefault(_Rose);

var _Table = __webpack_require__(/*! ../../../components/table/Table.vue */ 43);

var _Table2 = _interopRequireDefault(_Table);

var _Tips = __webpack_require__(/*! ../../../components/tips/Tips.vue */ 53);

var _Tips2 = _interopRequireDefault(_Tips);

var _dataPlatform = __webpack_require__(/*! api/dataPlatform */ 19);

var _dataPlatform2 = _interopRequireDefault(_dataPlatform);

var _momentFormat = __webpack_require__(/*! ../../../filters/moment-format */ 6);

var _momentFormat2 = _interopRequireDefault(_momentFormat);

var _percentFormat = __webpack_require__(/*! ../../../filters/percent-format */ 33);

var _percentFormat2 = _interopRequireDefault(_percentFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        TitleDateComponent: _TitleDate2.default,
        RoseComponent: _Rose2.default,
        TableComponent: _Table2.default,
        TipsComponent: _Tips2.default
    },
    data: function data() {
        return {
            titleOption: { // 单元块名称和日期选择配置
                title: '畅销商品', // 名称
                dateRadio: false, // 是否显示昨天、本周、本月日期单选框
                dateRangeSelect: true, // 是否显示日期区间下拉框
                download: true, // 是否显示下载按钮
                moduleId: 5,
                bizCode: this.bizCode,
                productId: [],
                showDate: {
                    startDate: _momentFormat2.default.getSevenDate(),
                    endDate: _momentFormat2.default.getYestoday()
                }
            },
            rankType: 1,
            startDate: _momentFormat2.default.getSevenDate(), // 开始日期，默认昨天
            endDate: _momentFormat2.default.getYestoday(), // 结束日期，默认昨天
            initDateRange: _momentFormat2.default.getSevenDate() + ' ~ ' + _momentFormat2.default.getYestoday(),
            roseInfo: [], // 南丁格尔图数据
            tableInfo: { // 表格数据
                title: [{
                    name: '商品名称',
                    value: 'productName',
                    style: 'width:25%;'
                }, {
                    name: '销量',
                    value: 'payQuantity'
                }, {
                    name: '销售额',
                    value: 'payAmt'
                }, {
                    name: '销售占比',
                    value: 'saleProportion'
                }, {
                    name: '支付转化率',
                    value: 'payConversionRate'
                }, {
                    name: '',
                    value: 'action'
                }],
                data: []
            },
            info: {
                value: 1,
                suggest: "这里为您展示了销量最好的top5商品，你可以特别关注这些为您带来主要收入的商品，点击“查看趋势”可以看具体数据趋势情况。同时根据畅销商品分析原因，改善您的其他商品的销售情况。"
            },
            color: ['#FF2F40', '#FFBC37', '#139BFD', '#1DD978', '#4D7BF3']
        };
    },

    props: ["bizCode"],
    methods: {
        // 获取单品数据
        getRankTypeData: function getRankTypeData() {
            var _this = this;

            _dataPlatform2.default.getRankTypeData(this.bizCode, this.startDate, this.endDate, this.rankType).then(function (res) {
                console.log(res);
                if (res.status === 0) {
                    var data = res.data;
                    var arr = [];
                    var roseArr = [];
                    var productId = [];
                    data.forEach(function (item, index) {
                        var o = {};
                        o.productName = {};
                        o.productName.value = '<span style="background-color:' + _this.color[index] + '">' + (index + 1) + '</span>' + item.productName;
                        o.payQuantity = {};
                        o.payQuantity.value = item.payQuantity;
                        o.payAmt = {};
                        o.payAmt.value = item.payAmt;
                        o.saleProportion = {};
                        o.saleProportion.value = (0, _percentFormat2.default)(item.saleProportion, true);
                        o.payConversionRate = {};
                        o.payConversionRate.value = (0, _percentFormat2.default)(item.payConversionRate, true);
                        o.action = {};
                        o.action.value = '<a href="javascript:void(0);">查看趋势</a>';
                        o.action.showTc = true;
                        o.action.params = {
                            productId: item.productId,
                            productName: item.productName,
                            startDate: _this.startDate,
                            endDate: _this.endDate
                        };
                        roseArr.push({
                            name: item.productName,
                            value: item.payAmt,
                            color: _this.color[index]
                        });
                        productId.push(item.productId);
                        arr.push(o);
                    });
                    _this.roseInfo = roseArr;
                    _this.tableInfo.data = arr;
                    _this.titleOption.productId = productId;
                } else {
                    _this.$notify.error({
                        title: '错误',
                        message: res.message || '请求失败'
                    });
                }
            }).catch(function (err) {
                console.log(err);
            });
        },


        // 切换日期
        changeDate: function changeDate(params) {
            this.startDate = params.dateRange.startDate;
            this.endDate = params.dateRange.endDate;
            this.getRankTypeData();
        }
    },
    mounted: function mounted() {
        this.getRankTypeData();
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 674 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-111a1dfc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/components/echarts/Rose.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 675 */
/*!*******************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/components/echarts/Rose.vue ***!
  \*******************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    components: {},
    data: function data() {
        return {
            myChart: {}
        };
    },

    props: ["roseInfo"],
    computed: {
        getOption: function getOption() {
            var opt = {
                tooltip: {
                    show: true,
                    confine: true,
                    backgroundColor: 'rgba(255, 255, 255, .92)',
                    textStyle: {
                        color: '#142C3D'
                    },
                    extraCssText: 'box-shadow: 0 1px 18px 0 rgba(151, 189, 208, .3);'
                },
                grid: {
                    left: '2%',
                    right: '2%',
                    top: '2%',
                    bottom: '2%',
                    containLabel: true
                },
                series: [{
                    name: '销售额',
                    type: 'pie',
                    radius: [25, 130],
                    center: ['50%', '50%'],
                    roseType: 'radius',
                    label: {
                        normal: {
                            show: false
                        },
                        emphasis: {
                            show: false
                        }
                    },
                    labelLine: {
                        normal: {
                            show: false
                        },
                        emphasis: {
                            show: false
                        }
                    },
                    color: this.color,
                    data: this.roseInfo
                }]
            };
            return opt;
        },
        color: function color() {
            var color = [];
            this.roseInfo.forEach(function (item) {
                color.push(item.color);
            });
            return color;
        }
    },
    watch: {
        roseInfo: {
            handler: function handler() {
                this.changeEcharts();
            },
            deep: true
        }
    },
    methods: {
        setEcharts: function setEcharts() {
            var dom = document.getElementById('myRoseEcharts');
            this.myChart = echarts.init(dom);
            this.myChart.setOption(this.getOption);
        },
        changeEcharts: function changeEcharts() {
            this.myChart.setOption(this.getOption);
        }
    },
    mounted: function mounted() {
        this.setEcharts();
    }
};

/***/ }),
/* 676 */
/*!**********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-111a1dfc","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/components/echarts/Rose.vue ***!
  \**********************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "rose",
    attrs: {
      "id": "myRoseEcharts"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 677 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-72a35b02","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/components/table/Table.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/*!******************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/components/table/Table.vue ***!
  \******************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _index = __webpack_require__(/*! helpers/index */ 16);

exports.default = {
    data: function data() {
        return {};
    },

    props: ["tableInfo"],
    methods: {
        // 格式化title属性
        formatTitle: function formatTitle(val) {
            return val !== null ? String(val).replace(/<span.+<\/span>/g, '') : '';
        },


        // 显示弹层
        showTc: function showTc(params) {
            _index.eventBus.$emit('showTc', params);
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 679 */
/*!**********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72a35b02","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/components/table/Table.vue ***!
  \**********************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "table-data"
  }, [_c('table', [_c('thead', [_c('tr', _vm._l((_vm.tableInfo.title), function(item) {
    return _c('th', {
      style: (item.style)
    }, [_vm._v(_vm._s(item.name))])
  }))]), _vm._v(" "), (_vm.tableInfo.data && _vm.tableInfo.data.length > 0) ? _c('tbody', _vm._l((_vm.tableInfo.data), function(item) {
    return _c('tr', _vm._l((item), function(val) {
      return _c('td', {
        style: (val.style),
        attrs: {
          "title": _vm.formatTitle(val.value)
        },
        domProps: {
          "innerHTML": _vm._s(val.value === null ? '--' : val.value)
        },
        on: {
          "click": function($event) {
            val.showTc ? _vm.showTc(val.params) : function() {}
          }
        }
      })
    }))
  })) : _vm._e(), _vm._v(" "), (!_vm.tableInfo.data || _vm.tableInfo.data.length === 0) ? _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": _vm.tableInfo.title.length
    }
  }, [_vm._v("暂无数据")])])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 680 */
/*!****************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f97605c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/productData/components/popular-product/PopularProduct.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "popular-product"
  }, [_c('title-date-component', {
    attrs: {
      "titleOption": _vm.titleOption,
      "initDateRange": _vm.initDateRange
    },
    on: {
      "changeDate": _vm.changeDate
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "data-box"
  }, [_c('rose-component', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "roseInfo": _vm.roseInfo
    }
  }), _vm._v(" "), _c('table-component', {
    staticStyle: {
      "width": "62%",
      "margin-left": "4%"
    },
    attrs: {
      "tableInfo": _vm.tableInfo
    }
  })], 1), _vm._v(" "), _c('tips-component', {
    attrs: {
      "info": _vm.info
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 681 */
/*!********************************************************************************************!*\
  !*** ./src/views/dataPlatform/productData/components/progress-product/ProgressProduct.vue ***!
  \********************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-05ba0e6a","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ProgressProduct.vue */ 682)
}
var Component = __webpack_require__(/*! ../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ProgressProduct.vue */ 683),
  /* template */
  __webpack_require__(/*! !../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-05ba0e6a","hasScoped":true}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ProgressProduct.vue */ 684),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-05ba0e6a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 682 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-05ba0e6a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/productData/components/progress-product/ProgressProduct.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 683 */
/*!***************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/productData/components/progress-product/ProgressProduct.vue ***!
  \***************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TitleDate = __webpack_require__(/*! ../../../components/title-date/TitleDate.vue */ 10);

var _TitleDate2 = _interopRequireDefault(_TitleDate);

var _Nav = __webpack_require__(/*! ../../../components/nav/Nav.vue */ 37);

var _Nav2 = _interopRequireDefault(_Nav);

var _Table = __webpack_require__(/*! ../../../components/table/Table.vue */ 43);

var _Table2 = _interopRequireDefault(_Table);

var _Tips = __webpack_require__(/*! ../../../components/tips/Tips.vue */ 53);

var _Tips2 = _interopRequireDefault(_Tips);

var _dataPlatform = __webpack_require__(/*! api/dataPlatform */ 19);

var _dataPlatform2 = _interopRequireDefault(_dataPlatform);

var _momentFormat = __webpack_require__(/*! ../../../filters/moment-format */ 6);

var _momentFormat2 = _interopRequireDefault(_momentFormat);

var _percentFormat = __webpack_require__(/*! ../../../filters/percent-format */ 33);

var _percentFormat2 = _interopRequireDefault(_percentFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        TitleDateComponent: _TitleDate2.default,
        NavComponent: _Nav2.default,
        TableComponent: _Table2.default,
        TipsComponent: _Tips2.default
    },
    data: function data() {
        return {
            titleOption: { // 单元块名称和日期选择配置
                title: '潜力商品', // 名称
                dateRadio: false, // 是否显示昨天、本周、本月日期单选框
                dateRangeSelect: true, // 是否显示日期区间下拉框
                download: true, // 是否显示下载按钮
                moduleId: 6,
                bizCode: this.bizCode,
                productId: [],
                showDate: {
                    startDate: _momentFormat2.default.getSevenDate(),
                    endDate: _momentFormat2.default.getYestoday()
                }
            },
            type: [{
                name: '流量提升',
                value: '2'
            }, {
                name: '访购率提升',
                value: '3'
            }, {
                name: '销量提升',
                value: '4'
            }],
            rankType: '2',
            startDate: _momentFormat2.default.getSevenDate(), // 开始日期，默认昨天
            endDate: _momentFormat2.default.getYestoday(), // 结束日期，默认昨天
            initDateRange: _momentFormat2.default.getSevenDate() + ' ~ ' + _momentFormat2.default.getYestoday(),
            resultData: {},
            tableInfo: {
                title: [{
                    name: '商品名称',
                    value: 'productName',
                    style: 'width:25%;'
                }, {
                    name: '浏览量',
                    value: 'intentionPv'
                }, {
                    name: '流量增幅',
                    value: 'flowChg'
                }, {
                    name: '访客数',
                    value: 'intentionUv'
                }, {
                    name: '访购率',
                    value: 'purchaseRate'
                }, {
                    name: '销量',
                    value: 'payQuantity'
                }, {
                    name: '',
                    value: 'action'
                }],
                data: []
            },
            info: {
                value: 1,
                suggest: "潜力商品是您近一段时间内表现有进步的商品，这些商品最近有增长势头，您可以根据分析其中增长的原因来判断：您的商品调整方案是否效；是否需要对应提升备货等。"
            },
            color: ['rgba(12, 222, 101, 1)', 'rgba(12, 222, 101, .8)', 'rgba(12, 222, 101, .6)', 'rgba(12, 222, 101, .4)', 'rgba(12, 222, 101, .2)']
        };
    },

    props: ["bizCode"],
    methods: {
        // 获取单品数据
        getRankTypeData: function getRankTypeData() {
            var _this = this;

            _dataPlatform2.default.getRankTypeData(this.bizCode, this.startDate, this.endDate, parseInt(this.rankType)).then(function (res) {
                console.log(res);
                if (res.status === 0) {
                    var data = res.data;
                    var arr = [];
                    var productId = [];
                    data.forEach(function (item, index) {
                        var o = {};
                        o.productName = {};
                        o.productName.value = '<span style="background-color:' + _this.color[index] + '">' + (index + 1) + '</span>' + item.productName;
                        o.intentionPv = {};
                        o.intentionPv.value = item.intentionPv;
                        if (_this.rankType === '2') {
                            o.flowChg = {};
                            o.flowChg.value = (0, _percentFormat2.default)(item.flowChg, true);
                        }
                        o.intentionUv = {};
                        o.intentionUv.value = item.intentionUv;
                        o.purchaseRate = {};
                        o.purchaseRate.value = (0, _percentFormat2.default)(item.purchaseRate, true);
                        if (_this.rankType === '3') {
                            o.purchaseRateChg = {};
                            o.purchaseRateChg.value = (0, _percentFormat2.default)(item.purchaseRateChg, true);
                        }
                        o.payQuantity = {};
                        o.payQuantity.value = item.payQuantity;
                        if (_this.rankType === '4') {
                            o.payQuantityChg = {};
                            o.payQuantityChg.value = (0, _percentFormat2.default)(item.payQuantityChg, true);
                        }
                        o.action = {};
                        o.action.value = '<a href="javascript:void(0);">查看趋势</a>';
                        o.action.showTc = true;
                        o.action.params = {
                            productId: item.productId,
                            productName: item.productName,
                            startDate: _this.startDate,
                            endDate: _this.endDate
                        };
                        productId.push(item.productId);
                        arr.push(o);
                    });
                    _this.tableInfo.data = arr;
                    _this.titleOption.productId = productId;
                } else {
                    _this.$notify.error({
                        title: '错误',
                        message: res.message || '请求失败'
                    });
                }
            }).catch(function (err) {
                console.log(err);
            });
        },


        // 切换类型
        changeNavType: function changeNavType(type) {
            this.rankType = type;
            var arr = [{
                name: '商品名称',
                value: 'productName',
                style: 'width:25%;'
            }, {
                name: '浏览量',
                value: 'intentionPv'
            }, {
                name: '访客数',
                value: 'intentionUv'
            }, {
                name: '访购率',
                value: 'purchaseRate'
            }, {
                name: '销量',
                value: 'payQuantity'
            }, {
                name: '',
                value: 'action'
            }];
            if (this.rankType === '2') {
                arr.splice(2, 0, {
                    name: '流量增幅',
                    value: 'flowChg'
                });
            } else if (this.rankType === '3') {
                arr.splice(4, 0, {
                    name: '访购率增幅',
                    value: 'purchaseRateChg'
                });
            } else if (this.rankType === '4') {
                arr.splice(5, 0, {
                    name: '销量涨幅',
                    value: 'payQuantityChg'
                });
            }
            this.tableInfo.title = arr;
            this.getRankTypeData();
        },


        // 切换日期
        changeDate: function changeDate(params) {
            this.startDate = params.dateRange.startDate;
            this.endDate = params.dateRange.endDate;
            this.getRankTypeData();
        }
    },
    mounted: function mounted() {
        this.getRankTypeData();
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 684 */
/*!******************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05ba0e6a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/productData/components/progress-product/ProgressProduct.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "progress-product"
  }, [_c('title-date-component', {
    attrs: {
      "titleOption": _vm.titleOption,
      "initDateRange": _vm.initDateRange
    },
    on: {
      "changeDate": _vm.changeDate
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "data-box"
  }, [_c('nav-component', {
    attrs: {
      "type": _vm.type,
      "currentType": _vm.rankType
    },
    on: {
      "changeNavType": _vm.changeNavType
    }
  }), _vm._v(" "), _c('table-component', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "tableInfo": _vm.tableInfo
    }
  })], 1), _vm._v(" "), _c('tips-component', {
    attrs: {
      "info": _vm.info
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 685 */
/*!********************************************************************************************!*\
  !*** ./src/views/dataPlatform/productData/components/abnormal-product/AbnormalProduct.vue ***!
  \********************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-6db2590a","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./AbnormalProduct.vue */ 686)
}
var Component = __webpack_require__(/*! ../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./AbnormalProduct.vue */ 687),
  /* template */
  __webpack_require__(/*! !../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6db2590a","hasScoped":true}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./AbnormalProduct.vue */ 688),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6db2590a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 686 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6db2590a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/productData/components/abnormal-product/AbnormalProduct.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 687 */
/*!***************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/productData/components/abnormal-product/AbnormalProduct.vue ***!
  \***************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _TitleDate = __webpack_require__(/*! ../../../components/title-date/TitleDate.vue */ 10);

var _TitleDate2 = _interopRequireDefault(_TitleDate);

var _Nav = __webpack_require__(/*! ../../../components/nav/Nav.vue */ 37);

var _Nav2 = _interopRequireDefault(_Nav);

var _Table = __webpack_require__(/*! ../../../components/table/Table.vue */ 43);

var _Table2 = _interopRequireDefault(_Table);

var _Tips = __webpack_require__(/*! ../../../components/tips/Tips.vue */ 53);

var _Tips2 = _interopRequireDefault(_Tips);

var _dataPlatform = __webpack_require__(/*! api/dataPlatform */ 19);

var _dataPlatform2 = _interopRequireDefault(_dataPlatform);

var _momentFormat = __webpack_require__(/*! ../../../filters/moment-format */ 6);

var _momentFormat2 = _interopRequireDefault(_momentFormat);

var _percentFormat = __webpack_require__(/*! ../../../filters/percent-format */ 33);

var _percentFormat2 = _interopRequireDefault(_percentFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		TitleDateComponent: _TitleDate2.default,
		NavComponent: _Nav2.default,
		TableComponent: _Table2.default,
		TipsComponent: _Tips2.default
	},
	data: function data() {
		return {
			titleOption: { // 单元块名称和日期选择配置
				title: '异常商品', // 名称
				dateRadio: false, // 是否显示昨天、本周、本月日期单选框
				dateRangeSelect: true, // 是否显示日期区间下拉框
				download: true, // 是否显示下载按钮
				moduleId: 6,
				bizCode: this.bizCode,
				productId: [],
				showDate: {
					startDate: _momentFormat2.default.getSevenDate(),
					endDate: _momentFormat2.default.getYestoday()
				}
			},
			type: [{
				name: '流量下降',
				value: '5'
			}, {
				name: '访购率下降',
				value: '6'
			}, {
				name: '访购率低',
				value: '7'
			}, {
				name: '销量下降',
				value: '8'
			}],
			rankType: '5',
			startDate: _momentFormat2.default.getSevenDate(), // 开始日期，默认昨天
			endDate: _momentFormat2.default.getYestoday(), // 结束日期，默认昨天
			initDateRange: _momentFormat2.default.getSevenDate() + ' ~ ' + _momentFormat2.default.getYestoday(),
			resultData: {},
			tableInfo: {
				title: [{
					name: '商品名称',
					value: 'productName',
					style: 'width:25%;'
				}, {
					name: '浏览量',
					value: 'intentionPv'
				}, {
					name: '流量降幅',
					value: 'flowChg'
				}, {
					name: '访客数',
					value: 'intentionUv'
				}, {
					name: '访购率',
					value: 'purchaseRate'
				}, {
					name: '销量',
					value: 'payQuantity'
				}, {
					name: '',
					value: 'action'
				}],
				data: []
			},
			info: {
				value: -1,
				suggest: "异常商品是您所经营的商品中表现不佳需要特殊关注的商品，您可以分析这些数据来判断是哪些原因导致商品出现这些波动，针对性的对这些商品进行调整。"
			},
			color: ['rgba(255, 47, 64, 1)', 'rgba(255, 47, 64, .8)', 'rgba(255, 47, 64, .6)', 'rgba(255, 47, 64, .4)', 'rgba(255, 47, 64, .2)']
		};
	},

	props: ["bizCode"],
	methods: {
		// 获取单品数据
		getRankTypeData: function getRankTypeData() {
			var _this = this;

			_dataPlatform2.default.getRankTypeData(this.bizCode, this.startDate, this.endDate, parseInt(this.rankType)).then(function (res) {
				console.log(res);
				if (res.status === 0) {
					var data = res.data;
					var arr = [];
					var productId = [];
					data.forEach(function (item, index) {
						var o = {};
						o.productName = {};
						o.productName.value = '<span style="background-color:' + _this.color[index] + '">' + (index + 1) + '</span>' + item.productName;
						o.intentionPv = {};
						o.intentionPv.value = item.intentionPv;
						if (_this.rankType === '5') {
							o.flowChg = {};
							o.flowChg.value = (0, _percentFormat2.default)(item.flowChg, true);
						}
						o.intentionUv = {};
						o.intentionUv.value = item.intentionUv;
						o.purchaseRate = {};
						o.purchaseRate.value = (0, _percentFormat2.default)(item.purchaseRate, true);
						if (_this.rankType === '6' || _this.rankType === '7') {
							o.purchaseRateChg = {};
							o.purchaseRateChg.value = (0, _percentFormat2.default)(item.purchaseRateChg, true);
						}
						o.payQuantity = {};
						o.payQuantity.value = item.payQuantity;
						if (_this.rankType === '8') {
							o.payQuantityChg = {};
							o.payQuantityChg.value = (0, _percentFormat2.default)(item.payQuantityChg, true);
						}
						o.action = {};
						o.action.value = '<a href="javascript:void(0);">查看趋势</a>';
						o.action.showTc = true;
						o.action.params = {
							productId: item.productId,
							productName: item.productName,
							startDate: _this.startDate,
							endDate: _this.endDate
						};
						productId.push(item.productId);
						arr.push(o);
					});
					_this.tableInfo.data = arr;
					_this.titleOption.productId = productId;
				} else {
					_this.$notify.error({
						title: '错误',
						message: res.message || '请求失败'
					});
				}
			}).catch(function (err) {
				console.log(err);
			});
		},


		// 切换类型
		changeNavType: function changeNavType(type) {
			this.rankType = type;
			var arr = [{
				name: '商品名称',
				value: 'productName',
				style: 'width:25%;'
			}, {
				name: '浏览量',
				value: 'intentionPv'
			}, {
				name: '访客数',
				value: 'intentionUv'
			}, {
				name: '访购率',
				value: 'purchaseRate'
			}, {
				name: '销量',
				value: 'payQuantity'
			}, {
				name: '',
				value: 'action'
			}];
			if (this.rankType === '5') {
				arr.splice(2, 0, {
					name: '流量降幅',
					value: 'flowChg'
				});
			} else if (this.rankType === '6' || this.rankType === '7') {
				arr.splice(4, 0, {
					name: '访购率跌幅',
					value: 'purchaseRateChg'
				});
			} else if (this.rankType === '8') {
				arr.splice(5, 0, {
					name: '销量跌幅',
					value: 'payQuantityChg'
				});
			}
			this.tableInfo.title = arr;
			this.getRankTypeData();
		},


		// 切换日期
		changeDate: function changeDate(params) {
			this.startDate = params.dateRange.startDate;
			this.endDate = params.dateRange.endDate;
			this.getRankTypeData();
		}
	},
	mounted: function mounted() {
		this.getRankTypeData();
	}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 688 */
/*!******************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6db2590a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/productData/components/abnormal-product/AbnormalProduct.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "abnormal-product"
  }, [_c('title-date-component', {
    attrs: {
      "titleOption": _vm.titleOption,
      "initDateRange": _vm.initDateRange
    },
    on: {
      "changeDate": _vm.changeDate
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "data-box"
  }, [_c('nav-component', {
    attrs: {
      "type": _vm.type,
      "currentType": _vm.rankType
    },
    on: {
      "changeNavType": _vm.changeNavType
    }
  }), _vm._v(" "), _c('table-component', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "tableInfo": _vm.tableInfo
    }
  })], 1), _vm._v(" "), _c('tips-component', {
    attrs: {
      "info": _vm.info
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 689 */
/*!********************************************************************************************!*\
  !*** ./src/views/dataPlatform/productData/components/product-analysis/ProductAnalysis.vue ***!
  \********************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-63cd3dfe","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ProductAnalysis.vue */ 690)
}
var Component = __webpack_require__(/*! ../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ProductAnalysis.vue */ 691),
  /* template */
  __webpack_require__(/*! !../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-63cd3dfe","hasScoped":true}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ProductAnalysis.vue */ 692),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-63cd3dfe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 690 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-63cd3dfe","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/productData/components/product-analysis/ProductAnalysis.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 691 */
/*!***************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/productData/components/product-analysis/ProductAnalysis.vue ***!
  \***************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _TitleDate = __webpack_require__(/*! ../../../components/title-date/TitleDate.vue */ 10);

var _TitleDate2 = _interopRequireDefault(_TitleDate);

var _Table = __webpack_require__(/*! ../../../components/table/Table.vue */ 43);

var _Table2 = _interopRequireDefault(_Table);

var _Tips = __webpack_require__(/*! ../../../components/tips/Tips.vue */ 53);

var _Tips2 = _interopRequireDefault(_Tips);

var _dataPlatform = __webpack_require__(/*! api/dataPlatform */ 19);

var _dataPlatform2 = _interopRequireDefault(_dataPlatform);

var _momentFormat = __webpack_require__(/*! ../../../filters/moment-format */ 6);

var _momentFormat2 = _interopRequireDefault(_momentFormat);

var _percentFormat = __webpack_require__(/*! ../../../filters/percent-format */ 33);

var _percentFormat2 = _interopRequireDefault(_percentFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
	components: {
		TitleDateComponent: _TitleDate2.default,
		TableComponent: _Table2.default,
		TipsComponent: _Tips2.default
	},
	data: function data() {
		return {
			titleOption: { // 单元块名称和日期选择配置
				title: '商品分析', // 名称
				dateRadio: false, // 是否显示昨天、本周、本月日期单选框
				dateRangeSelect: true, // 是否显示日期区间下拉框
				download: true, // 是否显示下载按钮
				moduleId: 7,
				bizCode: this.bizCode,
				showDate: {
					startDate: _momentFormat2.default.getSevenDate(),
					endDate: _momentFormat2.default.getYestoday()
				}
			},
			productName: '',
			productIds: '',
			startDate: _momentFormat2.default.getSevenDate(), // 开始日期，默认昨天
			endDate: _momentFormat2.default.getYestoday(), // 结束日期，默认昨天
			initDateRange: _momentFormat2.default.getSevenDate() + ' ~ ' + _momentFormat2.default.getYestoday(),
			currentPage: 1,
			totalCount: 0,
			tableInfo: {
				title: [{
					name: '商品编号',
					value: 'productId'
				}, {
					name: '商品名称',
					value: 'productName',
					style: 'width:25%; text-align:left;'
				}, {
					name: '浏览量',
					value: 'intentionPv'
				}, {
					name: '访客数',
					value: 'intentionUv'
				}, {
					name: '访购率',
					value: 'purchaseRate'
				}, {
					name: '销量',
					value: 'payQuantity'
				}, {
					name: '销售额',
					value: 'payAmt'
				}, {
					name: '商家拒单率',
					value: 'rejectRate'
				}, {
					name: '用户退款率',
					value: 'refundRate'
				}, {
					name: '',
					value: 'action'
				}],
				data: []
			},
			info: {
				value: 1,
				suggest: "您可以使用商品编号和商品名称对商品进行精确查找，分析具体某个商品的数据情况，针对性进行调整。"
			}
		};
	},

	props: ["bizCode"],
	methods: {
		// 获取单品数据
		getProductData: function getProductData() {
			var _this = this;

			_dataPlatform2.default.getProductData(this.bizCode, this.startDate, this.endDate, this.productIds, this.productName, this.currentPage, 10).then(function (res) {
				console.log(res);
				if (res.status === 0) {
					var data = res.data.productOperation;
					var arr = [];
					data.forEach(function (item, index) {
						var o = {};
						o.productId = {};
						o.productId.value = item.productId;
						o.productName = {};
						o.productName.value = item.productName;
						o.productName.style = 'text-align:left;';
						o.intentionPv = {};
						o.intentionPv.value = item.intentionPv;
						o.intentionUv = {};
						o.intentionUv.value = item.intentionUv;
						o.purchaseRate = {};
						o.purchaseRate.value = (0, _percentFormat2.default)(item.purchaseRate, true);
						o.payQuantity = {};
						o.payQuantity.value = item.payQuantity;
						o.payAmt = {};
						o.payAmt.value = item.payAmt;
						o.rejectRate = {};
						o.rejectRate.value = (0, _percentFormat2.default)(item.rejectRate, true);
						o.refundRate = {};
						o.refundRate.value = (0, _percentFormat2.default)(item.refundRate, true);
						o.action = {};
						o.action.value = '<a href="javascript:void(0);">查看趋势</a>';
						o.action.showTc = true;
						o.action.params = {
							productId: item.productId,
							productName: item.productName,
							startDate: _this.startDate,
							endDate: _this.endDate
						};
						arr.push(o);
					});
					_this.tableInfo.data = arr;
					_this.totalCount = res.data.count;
				} else {
					_this.$notify.error({
						title: '错误',
						message: res.message || '请求失败'
					});
				}
			}).catch(function (err) {
				_this.$notify.error({
					title: '错误',
					message: err.message || '请求失败'
				});
				console.log(err);
			});
		},


		// 切换页码
		currentChangeFunc: function currentChangeFunc(ev) {
			this.currentPage = ev.current;
			this.getProductData();
		},


		// 切换日期
		changeDate: function changeDate(params) {
			this.startDate = params.dateRange.startDate;
			this.endDate = params.dateRange.endDate;
			this.currentPage = 1;
			this.getProductData();
		}
	},
	mounted: function mounted() {
		this.getProductData();
	}
};

/***/ }),
/* 692 */
/*!******************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63cd3dfe","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/productData/components/product-analysis/ProductAnalysis.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "product-analysis"
  }, [_c('title-date-component', {
    attrs: {
      "titleOption": _vm.titleOption,
      "initDateRange": _vm.initDateRange
    },
    on: {
      "changeDate": _vm.changeDate
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "data-box"
  }, [_c('section', {
    staticClass: "search-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productName),
      expression: "productName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入商品名称"
    },
    domProps: {
      "value": (_vm.productName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.productName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productIds),
      expression: "productIds"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入商品编号"
    },
    domProps: {
      "value": (_vm.productIds)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.productIds = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "搜索"
    },
    on: {
      "click": function($event) {
        _vm.getProductData()
      }
    }
  })]), _vm._v(" "), _c('table-component', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "tableInfo": _vm.tableInfo
    }
  }), _vm._v(" "), _c('v-pagination', {
    attrs: {
      "current": _vm.currentPage,
      "total": Math.ceil(_vm.totalCount / 10),
      "size": 'md',
      "first": false,
      "last": false
    },
    on: {
      "current-change": function($event) {
        _vm.currentChangeFunc($event)
      }
    }
  })], 1), _vm._v(" "), _c('tips-component', {
    attrs: {
      "info": _vm.info
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 693 */
/*!*****************************************************************!*\
  !*** ./src/views/dataPlatform/productData/components/tc/Tc.vue ***!
  \*****************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-4e6c30d2","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Tc.vue */ 694)
}
var Component = __webpack_require__(/*! ../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Tc.vue */ 695),
  /* template */
  __webpack_require__(/*! !../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-4e6c30d2","hasScoped":true}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Tc.vue */ 696),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4e6c30d2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 694 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e6c30d2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/productData/components/tc/Tc.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 695 */
/*!************************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/productData/components/tc/Tc.vue ***!
  \************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _TitleDate = __webpack_require__(/*! ../../../components/title-date/TitleDate.vue */ 10);

var _TitleDate2 = _interopRequireDefault(_TitleDate);

var _Nav = __webpack_require__(/*! ../../../components/nav/Nav.vue */ 37);

var _Nav2 = _interopRequireDefault(_Nav);

var _Line = __webpack_require__(/*! ../../../components/echarts/Line.vue */ 78);

var _Line2 = _interopRequireDefault(_Line);

var _dataPlatform = __webpack_require__(/*! api/dataPlatform */ 19);

var _dataPlatform2 = _interopRequireDefault(_dataPlatform);

var _index = __webpack_require__(/*! helpers/index */ 16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		TitleDateComponent: _TitleDate2.default,
		NavComponent: _Nav2.default,
		LineComponent: _Line2.default
	},
	data: function data() {
		return {
			titleOption: { // 单元块名称和日期选择配置
				title: this.productName, // 名称
				dateRadio: false, // 是否显示昨天、本周、本月日期单选框
				dateRangeSelect: true, // 是否显示日期区间下拉框
				dateCompareSelect: true,
				download: true, // 是否显示下载按钮
				moduleId: 8,
				productId: [this.productId],
				showDate: {
					startDate: this.startDateParams,
					endDate: this.endDateParams
				},
				bizCode: this.bizCode
			},
			type: [{
				name: '销量',
				value: 'payQuantity'
			}, {
				name: '销售额',
				value: 'payAmt'
			}, {
				name: '浏览量',
				value: 'intentionPv'
			}, {
				name: '访客量',
				value: 'intentionUv'
			}, {
				name: '访购率',
				value: 'purchaseRate'
			}, {
				name: '下单用户数',
				value: 'orderUserNum'
			}, {
				name: '支付用户数',
				value: 'payUserNum'
			}, {
				name: '客单价',
				value: 'unitPrice'
			}],
			currentType: 'payQuantity', // 当前纬度
			startDate: this.startDateParams,
			endDate: this.endDateParams,
			initDateRange: this.startDateParams + ' ~ ' + this.endDateParams,
			typeData: {
				allTypeData: {
					payQuantity: [],
					payAmt: [],
					intentionPv: [],
					intentionUv: [],
					purchaseRate: [],
					orderUserNum: [],
					payUserNum: [],
					unitPrice: []
				},
				allTypeCompareData: {
					payQuantity: [],
					payAmt: [],
					intentionPv: [],
					intentionUv: [],
					purchaseRate: [],
					orderUserNum: [],
					payUserNum: [],
					unitPrice: []
				}
			},
			resultData: {
				dateArr: [],
				dataArr: [],
				dateCompareArr: [], // 对比日期
				dataCompareArr: [], // 对比数据
				currentTypeName: '销量'
			}
		};
	},

	props: ["bizCode", "productId", "productName", "startDateParams", "endDateParams"],
	methods: {
		// 关闭弹层
		closeTc: function closeTc() {
			_index.eventBus.$emit('closeTc');
		},

		// 获取单品数据
		getProductTrendData: function getProductTrendData() {
			var _this = this;

			_dataPlatform2.default.getProductTrendData(this.bizCode, this.startDate, this.endDate, this.productId).then(function (res) {
				console.log(res);
				if (res.status === 0) {
					var data = res.data;
					var date = [];
					var initData = {
						payQuantity: [],
						payAmt: [],
						intentionPv: [],
						intentionUv: [],
						purchaseRate: [],
						orderUserNum: [],
						payUserNum: [],
						unitPrice: []
					};
					data.forEach(function (item, index) {
						date.push(item.date);
						initData.payQuantity.push(item.payQuantity);
						initData.payAmt.push(item.payAmt);
						initData.intentionPv.push(item.intentionPv);
						initData.intentionUv.push(item.intentionUv);
						initData.purchaseRate.push(item.purchaseRate);
						initData.orderUserNum.push(item.orderUserNum);
						initData.payUserNum.push(item.payUserNum);
						initData.unitPrice.push(item.unitPrice);
					});
					_this.typeData.allTypeData = initData;
					_this.$set(_this.resultData, 'dateArr', date);
					_this.$set(_this.resultData, 'dataArr', _this.typeData.allTypeData[_this.currentType]);
				} else {
					_this.$notify.error({
						title: '错误',
						message: res.message || '请求失败'
					});
				}
			}).catch(function (err) {
				console.log(err);
			});
		},


		// 切换类型
		changeNavType: function changeNavType(type) {
			var _this2 = this;

			this.currentType = type;
			var currentTypeName = this.type.find(function (item) {
				return item.value === _this2.currentType;
			});
			this.$set(this.resultData, 'dataArr', this.typeData.allTypeData[this.currentType]);
			this.$set(this.resultData, 'dataCompareArr', this.typeData.allTypeCompareData[this.currentType]);
			this.$set(this.resultData, 'currentTypeName', currentTypeName.name);
		},


		// 切换日期
		changeDate: function changeDate(params) {
			this.startDate = params.dateRange.startDate;
			this.endDate = params.dateRange.endDate;
			this.getProductTrendData();
		},


		// 切换对比日期
		changeCompareDate: function changeCompareDate(params) {
			var _this3 = this;

			if (params.dateRange.startDate === '' || params.dateRange.endDate === '') {
				this.resultData.dateCompareArr = [];
				this.resultData.dataCompareArr = [];
				return;
			}
			_dataPlatform2.default.getProductTrendData(this.bizCode, params.dateRange.startDate, params.dateRange.endDate).then(function (res) {
				console.log(res);
				if (res.status === 0) {
					var data = res.data;
					var date = [];
					var initData = {
						payQuantity: [],
						payAmt: [],
						intentionPv: [],
						intentionUv: [],
						purchaseRate: [],
						orderUserNum: [],
						payUserNum: [],
						unitPrice: []
					};
					data.forEach(function (item, index) {
						date.push(item.date);
						initData.payQuantity.push(item.payQuantity);
						initData.payAmt.push(item.payAmt);
						initData.intentionPv.push(item.intentionPv);
						initData.intentionUv.push(item.intentionUv);
						initData.purchaseRate.push(item.purchaseRate);
						initData.orderUserNum.push(item.orderUserNum);
						initData.payUserNum.push(item.payUserNum);
						initData.unitPrice.push(item.unitPrice);
					});
					_this3.typeData.allTypeCompareData = initData;
					_this3.$set(_this3.resultData, 'dateCompareArr', date);
					_this3.$set(_this3.resultData, 'dataCompareArr', _this3.typeData.allTypeCompareData[_this3.currentType]);
				} else {
					_this3.$notify.error({
						title: '错误',
						message: res.message || '请求失败'
					});
				}
			}).catch(function (err) {
				_this3.resultData.dateCompareArr = [];
				_this3.resultData.dataCompareArr = [];
				console.log(err);
			});
		}
	},
	created: function created() {
		this.getProductTrendData();
	}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 696 */
/*!***************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e6c30d2","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/productData/components/tc/Tc.vue ***!
  \***************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "dark"
  }, [_c('section', {
    staticClass: "content-box"
  }, [_c('title-date-component', {
    attrs: {
      "titleOption": _vm.titleOption,
      "initDateRange": _vm.initDateRange
    },
    on: {
      "changeDate": _vm.changeDate,
      "changeCompareDate": _vm.changeCompareDate
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "data-box"
  }, [_c('nav-component', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "type": _vm.type,
      "currentType": _vm.currentType
    },
    on: {
      "changeNavType": _vm.changeNavType
    }
  }), _vm._v(" "), _c('line-component', {
    staticStyle: {
      "height": "320px",
      "margin-top": "50px"
    },
    attrs: {
      "resultData": _vm.resultData
    }
  })], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "close-btn",
    on: {
      "click": _vm.closeTc
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 697 */
/*!***************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7b7890c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/productData/Main.vue ***!
  \***************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('title-component', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _c('popular-product-component', {
    attrs: {
      "bizCode": _vm.bizCode
    }
  }), _vm._v(" "), _c('progress-product-component', {
    attrs: {
      "bizCode": _vm.bizCode
    }
  }), _vm._v(" "), _c('abnormal-product-component', {
    attrs: {
      "bizCode": _vm.bizCode
    }
  }), _vm._v(" "), _c('product-analysis-component', {
    attrs: {
      "bizCode": _vm.bizCode
    }
  }), _vm._v(" "), (_vm.showTc) ? _c('tc-component', {
    attrs: {
      "bizCode": _vm.bizCode,
      "productId": _vm.productId,
      "productName": _vm.productName,
      "startDateParams": _vm.startDate,
      "endDateParams": _vm.endDate
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 698 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cbeb821a","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/comment/list/Main.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 699 */
/*!************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/comment/list/Main.vue ***!
  \************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Title = __webpack_require__(/*! ./components/title/Title.vue */ 700);

var _Title2 = _interopRequireDefault(_Title);

var _Filter = __webpack_require__(/*! ./components/filter/Filter.vue */ 704);

var _Filter2 = _interopRequireDefault(_Filter);

var _List = __webpack_require__(/*! ./components/list/List.vue */ 709);

var _List2 = _interopRequireDefault(_List);

var _Product = __webpack_require__(/*! ./components/product/Product.vue */ 725);

var _Product2 = _interopRequireDefault(_Product);

var _comment = __webpack_require__(/*! api/comment */ 95);

var _comment2 = _interopRequireDefault(_comment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        TitleComponent: _Title2.default,
        FilterComponent: _Filter2.default,
        ListComponent: _List2.default,
        ProductComponent: _Product2.default
    },
    data: function data() {
        var _this = this;

        var data = {
            did: '',
            dealName: '',
            businessType: '', // 业务线 2 门票 3 跟团 4 酒景
            businessTypeName: '',
            loading: false, // 加载动画
            showProductStatus: false // 是否显示切换产品弹层
        };
        data.businessTypeName = this.$route.params.type || this.$route.meta.type;
        switch (data.businessTypeName) {
            case 'ticket':
                data.businessType = 2;
                break;
            case 'gty':
                data.businessType = 3;
                break;
            case 'jiujing':
                data.businessType = 4;
                break;
            default:
                window.location.href = '/';
        }
        _comment2.default.getDefaultProduct(data.businessType).then(function (res) {
            if (res.data[0].dealId && res.data[0].dealName) {
                data.did = res.data[0].dealId;
                data.dealName = res.data[0].dealName;
                _this.$router.push({
                    name: data.businessTypeName + 'reviewDetail',
                    params: {
                        type: data.businessTypeName,
                        id: data.did,
                        name: data.dealName
                    }
                });
            } else {
                _this.$notify.error({
                    title: '错误',
                    message: '未获取到产品ID或名称'
                });
            }
        }).catch(function (err) {
            console.log(err);
        });
        return data;
    },

    watch: {
        // 监听路由变化
        '$route': function $route() {
            this.did = this.$route.params.id;
            this.dealName = this.$route.params.name;
            this.showProductStatus = false;
        }
    },
    methods: {
        // 加载动画，status传入true or false
        changeLoading: function changeLoading(status) {
            this.loading = status;
        },


        // 显示或隐藏切换产品弹层，status传入true or false
        changeProductTc: function changeProductTc(status) {
            this.showProductStatus = status;
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 700 */
/*!***********************************************************!*\
  !*** ./src/views/comment/list/components/title/Title.vue ***!
  \***********************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-6d2e413c","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Title.vue */ 701)
}
var Component = __webpack_require__(/*! ../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Title.vue */ 702),
  /* template */
  __webpack_require__(/*! !../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6d2e413c","hasScoped":false}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Title.vue */ 703),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 701 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6d2e413c","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/comment/list/components/title/Title.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 702 */
/*!******************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/comment/list/components/title/Title.vue ***!
  \******************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    data: function data() {
        return {};
    },

    props: ['dealName'],
    methods: {
        // 显示切换产品弹层
        showProductTc: function showProductTc() {
            this.$emit('showProductTc');
        }
    }
};

/***/ }),
/* 703 */
/*!**********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d2e413c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/comment/list/components/title/Title.vue ***!
  \**********************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.dealName))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.showProductTc
    }
  }, [_vm._v("切换产品")])])
},staticRenderFns: []}

/***/ }),
/* 704 */
/*!*************************************************************!*\
  !*** ./src/views/comment/list/components/filter/Filter.vue ***!
  \*************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-19ec4870","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Filter.vue */ 705)
}
var Component = __webpack_require__(/*! ../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Filter.vue */ 706),
  /* template */
  __webpack_require__(/*! !../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-19ec4870","hasScoped":false}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Filter.vue */ 708),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 705 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-19ec4870","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/comment/list/components/filter/Filter.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 706 */
/*!********************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/comment/list/components/filter/Filter.vue ***!
  \********************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _commentData = __webpack_require__(/*! data/comment-data */ 707);

var _comment = __webpack_require__(/*! api/comment */ 95);

var _comment2 = _interopRequireDefault(_comment);

var _moment = __webpack_require__(/*! moment */ 32);

var _moment2 = _interopRequireDefault(_moment);

var _index = __webpack_require__(/*! helpers/index */ 16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    data: function data() {
        return {
            channel: '1', // 当前展示平台，1 美团 2 点评
            channelData: {
                '1': {
                    name: '美团',
                    score: '',
                    tags: []
                },
                '2': {
                    name: '点评',
                    score: '',
                    tags: []
                }
            },
            tagSelected: '全部',
            showDateAndStarFilter: true, // 是否显示日期和星级筛选
            dateInputOption: { // 选择日期配置
                'mode': 'range',
                'maxDate': (0, _moment2.default)().format('YYYY-MM-DD'),
                'minDate': (0, _moment2.default)().subtract(_moment2.default.duration(90, 'd')).format('YYYY-MM-DD'),
                'onClose': function (value) {
                    if (Array.isArray(value) && value.length === 2) {
                        this.commentDateRange = (0, _moment2.default)(value[0]).format('YYYY-MM-DD') + ' ~ ' + (0, _moment2.default)(value[1]).format('YYYY-MM-DD');
                        this.getCommentData();
                    }
                }.bind(this)
            },
            commentDate: _commentData.commentDate, // 评价日期
            commentStar: _commentData.commentStar, // 评价星级
            commentDateSelected: '', // 当前选中的日期，值为'0' '1' '2' '3' 'range'
            commentStarSelected: ['1', '2', '3', '4', '5'], // 当前选中的星级
            commentDateRange: '' // 当前日期区间的值，格式为 2017-08-01 ~ 2017-08-08
        };
    },

    props: ['did'],
    watch: {
        'did': function did() {
            if (!this.did) {
                return;
            }
            this.tagSelected = '全部';
            this.showDateAndStarFilter = true;
            this.commentDateSelected = '';
            this.commentStarSelected = ['1', '2', '3', '4', '5'];
            this.commentDateRange = '';
            this.getTagsData(this.did, '1');
            _index.eventBus.$emit('getDataForReply', { did: this.did, channel: this.channel, replyType: 1 });
        }
    },
    methods: {
        // 切换平台
        changeChannel: function changeChannel(e) {
            var ev = e.target;
            if (ev.tagName === 'SPAN') {
                var channel = ev.dataset.channel;
                this.channel = channel;
                this.tagSelected = '全部';
                this.showDateAndStarFilter = true;
                this.commentDateSelected = '';
                this.commentStarSelected = ['1', '2', '3', '4', '5'];
                this.commentDateRange = '';
                _index.eventBus.$emit('getDataForReply', { did: this.did, channel: this.channel, replyType: 1 });
            } else {
                return;
            }
        },


        // 点击标签
        changeTag: function changeTag(e) {
            var ev = e.target;
            if (ev.tagName === 'SPAN') {
                var tag = ev.dataset.tag;
                if (this.tagSelected === tag) {
                    return;
                }
                this.tagSelected = tag;
                if (this.tagSelected === '全部') {
                    // 全部状态下，显示日期和星级筛选
                    this.showDateAndStarFilter = true;
                    this.commentDateSelected = '';
                    this.commentStarSelected = ['1', '2', '3', '4', '5'];
                    this.commentDateRange = '';
                    _index.eventBus.$emit('getDataForReply', { did: this.did, channel: this.channel, replyType: 1 });
                } else if (this.tagSelected === '30天未回复') {
                    this.showDateAndStarFilter = false;
                    _index.eventBus.$emit('getDataForReply', { did: this.did, channel: this.channel, replyType: 2 });
                } else if (this.tagSelected === '有内容评价') {
                    this.showDateAndStarFilter = false;
                    _index.eventBus.$emit('getDataForContent', { did: this.did, contentType: 1 });
                } else {
                    this.showDateAndStarFilter = false;
                    _index.eventBus.$emit('getDataForTags', { did: this.did, channel: this.channel, tag: this.tagSelected });
                }
            } else {
                return;
            }
        },


        // 选择评价星级，至少保证一个选中状态
        selectCommentStar: function selectCommentStar(value) {
            var k = this.commentStarSelected.indexOf(value);
            var len = this.commentStarSelected.length;
            if (k !== -1) {
                if (len > 1) {
                    this.commentStarSelected.splice(k, 1);
                    this.getCommentData();
                } else {
                    return;
                }
            } else {
                this.commentStarSelected.push(value);
                this.getCommentData();
            }
        },


        // 选择评价日期
        selectCommentDate: function selectCommentDate(value) {
            if (value === this.commentDateSelected && value !== 'range') {
                return;
            }
            this.commentDateSelected = value;
            if (this.commentDateSelected === 'range') {
                return;
            } else {
                this.getCommentData();
            }
        },


        // 请求筛选返回的数据
        getCommentData: function getCommentData() {
            var startDate = '';
            var endDate = '';
            var starLevels = this.commentStarSelected.join(',');
            switch (this.commentDateSelected) {
                case '0':
                    startDate = (0, _moment2.default)().format('YYYY-MM-DD');
                    endDate = (0, _moment2.default)().format('YYYY-MM-DD');
                    break;
                case '1':
                    startDate = (0, _moment2.default)().subtract(_moment2.default.duration(1, 'd')).format('YYYY-MM-DD');
                    endDate = (0, _moment2.default)().subtract(_moment2.default.duration(1, 'd')).format('YYYY-MM-DD');
                    break;
                case '2':
                    startDate = (0, _moment2.default)().subtract(_moment2.default.duration(6, 'd')).format('YYYY-MM-DD');
                    endDate = (0, _moment2.default)().format('YYYY-MM-DD');
                    break;
                case '3':
                    startDate = (0, _moment2.default)().subtract(_moment2.default.duration(29, 'd')).format('YYYY-MM-DD');
                    endDate = (0, _moment2.default)().format('YYYY-MM-DD');
                    break;
                case 'range':
                    var arr = this.commentDateRange.indexOf('~') !== -1 ? this.commentDateRange.split(' ~ ') : ['', ''];
                    startDate = arr[0];
                    endDate = arr[1];
                    break;
            }
            _index.eventBus.$emit('getDataForOthers', { did: this.did, channel: this.channel, startDate: startDate, endDate: endDate, starLevels: starLevels });
        },


        // 获取标签数据
        getTagsData: function getTagsData(did, channel) {
            var _this = this;

            if (!did || !channel) {
                return;
            }
            _comment2.default.getTags(did, channel).then(function (res) {
                _this.channelData[channel].score = res.data.score;
                _this.channelData[channel].tags = res.data.reviewTags;
            }).catch(function (err) {
                console.log(err);
            });
        }
    }
};

/***/ }),
/* 707 */
/*!**********************************!*\
  !*** ./src/data/comment-data.js ***!
  \**********************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// 评价日期
var commentDate = exports.commentDate = [{
    name: '今日',
    value: '0'
}, {
    name: '昨日',
    value: '1'
}, {
    name: '最近7天',
    value: '2'
}, {
    name: '最近30天',
    value: '3'
}];

// 评价星级
var commentStar = exports.commentStar = [{
    name: '一星',
    value: '1'
}, {
    name: '二星',
    value: '2'
}, {
    name: '三星',
    value: '3'
}, {
    name: '四星',
    value: '4'
}, {
    name: '五星',
    value: '5'
}];

/***/ }),
/* 708 */
/*!************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19ec4870","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/comment/list/components/filter/Filter.vue ***!
  \************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "filter"
  }, [_c('section', {
    staticClass: "top",
    on: {
      "click": function($event) {
        _vm.changeChannel($event)
      }
    }
  }, [_c('span', {
    class: {
      'active': _vm.channel === '1'
    },
    attrs: {
      "data-channel": "1"
    }
  }, [_vm._v(_vm._s(_vm.channelData['1'].name + ' ' + _vm.channelData['1'].score + '分'))]), _vm._v(" "), (false) ? _c('span', {
    class: {
      'active': _vm.channel === '2'
    },
    attrs: {
      "data-channel": "2"
    }
  }, [_vm._v(_vm._s(_vm.channelData['2'].name + ' ' + _vm.channelData['2'].score + '分'))]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "tags",
    on: {
      "click": function($event) {
        _vm.changeTag($event)
      }
    }
  }, [_c('span', {
    class: _vm.tagSelected === '全部' ? 'active' : '',
    attrs: {
      "data-tag": "全部"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('span', {
    class: _vm.tagSelected === '30天未回复' ? 'active' : '',
    attrs: {
      "data-tag": "30天未回复"
    }
  }, [_vm._v("30天未回复")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.channel === '1'),
      expression: "channel === '1'"
    }],
    class: _vm.tagSelected === '有内容评价' ? 'active' : '',
    attrs: {
      "data-tag": "有内容评价"
    }
  }, [_vm._v("有内容评价")]), _vm._v(" "), _vm._l((_vm.channelData[this.channel].tags), function(item) {
    return _c('span', {
      class: {
        'bad': item.isPositive === 0, 'active': item.tag === _vm.tagSelected
      },
      attrs: {
        "data-tag": item.tag
      }
    }, [_vm._v(_vm._s(item.tag + ' ' + item.count))])
  })], 2), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDateAndStarFilter),
      expression: "showDateAndStarFilter"
    }],
    staticClass: "filter-content"
  }, [_c('section', [_c('label', [_vm._v("评价日期")]), _vm._v(" "), _vm._l((_vm.commentDate), function(item) {
    return _c('span', {
      class: _vm.commentDateSelected === item.value ? 'active' : '',
      attrs: {
        "value": item.value
      },
      on: {
        "click": function($event) {
          _vm.selectCommentDate(item.value)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), _vm._v(" "), _c('span', {
    class: _vm.commentDateSelected === 'range' ? 'active' : '',
    staticStyle: {
      "width": "185px"
    },
    on: {
      "click": function($event) {
        _vm.selectCommentDate('range')
      }
    }
  }, [_c('v-datepicker', {
    attrs: {
      "options": _vm.dateInputOption,
      "placeholder": "自定时段"
    },
    model: {
      value: (_vm.commentDateRange),
      callback: function($$v) {
        _vm.commentDateRange = $$v
      },
      expression: "commentDateRange"
    }
  })], 1)], 2), _vm._v(" "), _c('section', [_c('label', [_vm._v("评价星级")]), _vm._v(" "), _vm._l((_vm.commentStar), function(item) {
    return _c('span', {
      class: _vm.commentStarSelected.indexOf(item.value) !== -1 ? 'active' : '',
      attrs: {
        "value": item.value
      },
      on: {
        "click": function($event) {
          _vm.selectCommentStar(item.value)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 709 */
/*!*********************************************************!*\
  !*** ./src/views/comment/list/components/list/List.vue ***!
  \*********************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-7038d320","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./List.vue */ 710)
}
var Component = __webpack_require__(/*! ../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./List.vue */ 711),
  /* template */
  __webpack_require__(/*! !../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7038d320","hasScoped":false}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./List.vue */ 724),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 710 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7038d320","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/comment/list/components/list/List.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 711 */
/*!****************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/comment/list/components/list/List.vue ***!
  \****************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(/*! babel-runtime/helpers/toConsumableArray */ 96);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _Content = __webpack_require__(/*! ./Content.vue */ 716);

var _Content2 = _interopRequireDefault(_Content);

var _comment = __webpack_require__(/*! api/comment */ 95);

var _comment2 = _interopRequireDefault(_comment);

var _index = __webpack_require__(/*! helpers/index */ 16);

var _packageProduct = __webpack_require__(/*! config/packageProduct */ 165);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    components: {
        ContentComponent: _Content2.default
    },
    data: function data() {
        return {
            channel: '1', // 当前展示平台 1 美团 2 点评
            tag: '', // 标签
            replyType: '1', // 回复情况 1 全部 2 未回复
            startDate: '', // 开始日期
            endDate: '', // 结束日期
            starLevels: '', // 星级
            contentType: '0', // 有无内容 0 全部 1 有内容 2 无内容
            commentData: { // 评论列表数据
                data: [],
                totalCount: 0
            },
            renderType: 1, // 当前渲染的逻辑 1 根据回复情况 2 根据标签 3 根据日期星级 4 根据有无内容
            currentPage: 1 // 当前页
        };
    },

    props: ['did'],
    mounted: function mounted() {
        this.workSpaceEle = document.querySelector('.work-space');
        if (this.workSpaceEle) {
            this.workSpaceEle.addEventListener('scroll', this.updateImgs);
        };
    },
    destroyed: function destroyed() {
        if (this.workSpaceEle) {
            this.workSpaceEle.removeEventListener('scroll', this.updateImgs);
        }
    },

    methods: {
        // 根据回复情况获取评价
        getDataForReply: function getDataForReply() {
            var _this = this;

            if (!this.did) {
                return;
            }
            if (this.isRequesting) {
                return;
            }
            this.$emit('changeLoading', true);
            this.isRequesting = true;
            _comment2.default.getCommentsForReply(this.did, this.channel, this.replyType, this.currentPage).then(function (res) {
                _this.renderData(res);
                _this.isRequesting = false;
            }).catch(function (err) {
                console.log(err);
                _this.$emit('changeLoading', false);
                _this.$notify.error({
                    title: '错误',
                    message: err.message || '出错了，请稍后再试'
                });
            });
        },


        // 根据标签获取评价
        getDataForTags: function getDataForTags() {
            var _this2 = this;

            if (!this.did) {
                return;
            }
            this.$emit('changeLoading', true);
            _comment2.default.getCommentsForTag(this.did, this.channel, this.tag, this.currentPage).then(function (res) {
                _this2.renderData(res);
            }).catch(function (err) {
                console.log(err);
                _this2.$emit('changeLoading', false);
                _this2.$notify.error({
                    title: '错误',
                    message: err.message || '出错了，请稍后再试'
                });
            });
        },


        // 根据日期、星级获取评价
        getDataForOthers: function getDataForOthers() {
            var _this3 = this;

            if (!this.did) {
                return;
            }
            this.$emit('changeLoading', true);
            _comment2.default.getCommentsForOthers(this.did, this.channel, this.startDate, this.endDate, this.starLevels, this.currentPage).then(function (res) {
                _this3.renderData(res);
            }).catch(function (err) {
                console.log(err);
                _this3.$emit('changeLoading', false);
                _this3.$notify.error({
                    title: '错误',
                    message: err.message || '出错了，请稍后再试'
                });
            });
        },


        // 根据有无内容获取评价
        getDataForContent: function getDataForContent() {
            var _this4 = this;

            if (!this.did) {
                return;
            }
            this.$emit('changeLoading', true);
            _comment2.default.getCommentsForContent(this.did, this.contentType, this.currentPage).then(function (res) {
                _this4.renderData(res);
            }).catch(function (err) {
                console.log(err);
                _this4.$emit('changeLoading', false);
                _this4.$notify.error({
                    title: '错误',
                    message: err.message || '出错了，请稍后再试'
                });
            });
        },


        // 渲染数据
        renderData: function renderData(res) {
            var _this5 = this;

            if (res.status !== 0) {
                this.$notify.error({
                    title: '错误',
                    message: err.message || '出错了，请稍后再试'
                });
                this.$emit('changeLoading', false);
                return;
            } else {
                this.commentData.data = res.data;
                this.$nextTick(function () {
                    _this5.updateImgs();
                });
                this.commentData.totalCount = res.totalCount;
                document.body.scrollTop = 0;
                this.$emit('changeLoading', false);
            }
        },
        updateImgs: function updateImgs(ev) {
            var target = ev && ev.target || this.workSpaceEle;
            if (target) {
                var imgs = [].concat((0, _toConsumableArray3.default)(target.querySelectorAll('img[' + _packageProduct.Lazy_Load_Attr + ']')));
                if (!imgs || !imgs.length) return;
                var _document$body = document.body,
                    clientHeight = _document$body.clientHeight,
                    clientWidth = _document$body.clientWidth;

                imgs.forEach(function (img) {
                    if (img.getAttribute('src') === _packageProduct.Lazy_Img_Src) {
                        var _img$getBoundingClien = img.getBoundingClientRect(),
                            height = _img$getBoundingClien.height,
                            width = _img$getBoundingClien.width,
                            top = _img$getBoundingClien.top,
                            left = _img$getBoundingClien.left;

                        if (top + height > 0 && top + height < clientHeight && left + width > 0 && left + width < clientWidth) {
                            img.setAttribute('src', img.getAttribute(_packageProduct.Lazy_Load_Attr));
                            img.removeAttribute(_packageProduct.Lazy_Load_Attr);
                        }
                    }
                });
            }
        },

        // 切换页码
        currentChangeFunc: function currentChangeFunc(data) {
            this.currentPage = data.current;
            switch (this.renderType) {
                case 1:
                    this.getDataForReply();
                    break;
                case 2:
                    this.getDataForTags();
                    break;
                case 3:
                    this.getDataForOthers();
                    break;
                case 4:
                    this.getDataForContent();
                    break;
                default:
                    this.getDataForReply();
                    break;
            }
        },

        // 下载评价
        uploadComment: function uploadComment() {
            _comment2.default.uploadComment(this.did, this.channel);
        }
    },
    created: function created() {
        var _this6 = this;

        // 初始化
        this.getDataForReply();
        // 监听标签变化
        _index.eventBus.$on('getDataForTags', function (params) {
            _this6.did = params.did;
            _this6.channel = params.channel;
            _this6.tag = params.tag;
            _this6.currentPage = 1;
            _this6.renderType = 2;
            _this6.getDataForTags();
        });
        // 监听回复情况变化
        _index.eventBus.$on('getDataForReply', function (params) {
            _this6.did = params.did;
            _this6.channel = params.channel;
            _this6.replyType = params.replyType;
            _this6.currentPage = 1;
            _this6.renderType = 1;
            _this6.getDataForReply();
        });
        // 监听日期、星级变化
        _index.eventBus.$on('getDataForOthers', function (params) {
            _this6.did = params.did;
            _this6.channel = params.channel;
            _this6.startDate = params.startDate;
            _this6.endDate = params.endDate;
            _this6.starLevels = params.starLevels;
            _this6.currentPage = 1;
            _this6.renderType = 3;
            _this6.getDataForOthers();
        });
        // 监听有无内容变化
        _index.eventBus.$on('getDataForContent', function (params) {
            _this6.did = params.did;
            _this6.contentType = params.contentType;
            _this6.currentPage = 1;
            _this6.renderType = 4;
            _this6.getDataForContent();
        });
    }
};

/***/ }),
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */
/*!************************************************************!*\
  !*** ./src/views/comment/list/components/list/Content.vue ***!
  \************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-35a26e17","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Content.vue */ 717)
}
var Component = __webpack_require__(/*! ../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Content.vue */ 718),
  /* template */
  __webpack_require__(/*! !../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-35a26e17","hasScoped":false}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Content.vue */ 723),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 717 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-35a26e17","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/comment/list/components/list/Content.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 718 */
/*!*******************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/comment/list/components/list/Content.vue ***!
  \*******************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _packageProduct = __webpack_require__(/*! config/packageProduct */ 165);

var _Reply = __webpack_require__(/*! ./Reply.vue */ 719);

var _Reply2 = _interopRequireDefault(_Reply);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var avatarImgPostfix = "@50h_50w_2e_90Q",
    defaultAvatar = "https://p0.meituan.net/codeman/54dc25852f4a3a4321f3a5ca79c39eb619622.png";
exports.default = {
  components: {
    ReplyComponent: _Reply2.default
  },
  data: function data() {
    return {
      contentImgActive: "", // 当前激活状态的缩略图index
      imgShowStatus: false, // 大图是否显示
      imgShowSrc: "", // 大图显示的src
      replyShowStatus: false, // 回复按钮是否显示
      replyContentShowStatus: true, // 商家回复框是否显示
      defaultAvatarSrc: defaultAvatar + avatarImgPostfix,
      avatarImgPostfix: avatarImgPostfix,
      commentImgPostfix: "@80h_80w_2e_90Q",
      commentDetailImgSrc: _packageProduct.Lazy_Img_Src
    };
  },

  computed: {
    // 高亮显示标签
    infoContentHtml: function infoContentHtml() {
      var tag = this.info.highlight;
      var re = new RegExp(tag, "gi");
      return this.info.userComment.replace(re, "<span>" + tag + "</span>");
    }
  },
  props: ["info"],
  methods: {
    // 显示大图
    showImg: function showImg(item, index) {
      this.contentImgActive = index;
      this.imgShowStatus = true;
      this.imgShowSrc = item;
    },


    // 隐藏大图
    hideImg: function hideImg() {
      this.contentImgActive = "";
      this.imgShowStatus = false;
      this.imgShowSrc = "";
    },


    // 显示回复框
    showReply: function showReply() {
      this.replyContentShowStatus = false;
      this.replyShowStatus = true;
    },


    // 隐藏回复框
    hideReply: function hideReply(res) {
      // 回复成功后更新内容
      if (res) {
        this.info.bizReplyContent = res.bizReply || this.info.bizReplyContent;
        this.info.bizReplyTime = res.replyTime || this.info.bizReplyTime;
      }
      this.replyContentShowStatus = true;
      this.replyShowStatus = false;
    }
  }
};

/***/ }),
/* 719 */
/*!**********************************************************!*\
  !*** ./src/views/comment/list/components/list/Reply.vue ***!
  \**********************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-664bd588","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Reply.vue */ 720)
}
var Component = __webpack_require__(/*! ../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Reply.vue */ 721),
  /* template */
  __webpack_require__(/*! !../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-664bd588","hasScoped":false}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Reply.vue */ 722),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 720 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-664bd588","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/comment/list/components/list/Reply.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 721 */
/*!*****************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/comment/list/components/list/Reply.vue ***!
  \*****************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _comment = __webpack_require__(/*! api/comment */ 95);

var _comment2 = _interopRequireDefault(_comment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            reply: this.replyContent, // 回复内容
            submitStatus: true // 提交按钮状态
        };
    },

    props: ['replyContent', 'did', 'commentId', 'poiId'],
    computed: {
        fontNum: function fontNum() {
            return this.reply.length;
        }
    },
    methods: {
        // 点击取消按钮
        hideReply: function hideReply() {
            this.$emit('cancel');
        },


        // 限制输入框字数
        changeFontNum: function changeFontNum() {
            if (this.fontNum >= 500 || this.fontNum <= 0) {
                this.submitStatus = true;
            } else {
                this.submitStatus = false;
            }
        },


        // 提交
        submitReply: function submitReply() {
            var _this = this;

            if (!this.did) {
                return;
            }
            if (this.submitStatus || this.fontNum >= 500 || this.fontNum <= 0) {
                this.$notify.error({
                    title: '错误',
                    message: '格式错误'
                });
                return;
            }
            _comment2.default.postCommentReply(this.did, this.reply, this.commentId, this.poiId).then(function (res) {
                if (res.status === 0) {
                    _this.$message.success('提交成功');
                    _this.$emit('cancel', { bizReply: res.data.bizReply, replyTime: res.data.replyTime });
                } else {
                    _this.$notify.error({
                        title: '错误',
                        message: err.message || '提交失败，请稍后再试'
                    });
                }
            }).catch(function (err) {
                console.log(err);
                _this.$notify.error({
                    title: '错误',
                    message: err.message || '出错了，请稍后再试'
                });
            });
        }
    },
    created: function created() {
        this.changeFontNum();
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 722 */
/*!*********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-664bd588","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/comment/list/components/list/Reply.vue ***!
  \*********************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "reply-box"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.reply),
      expression: "reply",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "placeholder": "您的回复会被公开展示，请注意措辞"
    },
    domProps: {
      "value": (_vm.reply)
    },
    on: {
      "keyup": _vm.changeFontNum,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reply = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('footer', [_c('span', [_vm._v("已经输入" + _vm._s(_vm.fontNum) + "个字，共可以输入500字")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "提交",
      "disabled": _vm.submitStatus
    },
    on: {
      "click": _vm.submitReply
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "取消"
    },
    on: {
      "click": _vm.hideReply
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 723 */
/*!***********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35a26e17","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/comment/list/components/list/Content.vue ***!
  \***********************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "head"
  }, [(_vm.info.userIcon) ? _c('img', {
    attrs: {
      "src": _vm.info.userIcon + _vm.avatarImgPostfix
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.defaultAvatarSrc
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "content-right"
  }, [_c('h3', [_vm._v(_vm._s(_vm.info.userName))]), _vm._v("\n        打分\n        "), _c('v-rate', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.info.score),
      callback: function($$v) {
        _vm.info.score = $$v
      },
      expression: "info.score"
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.infoContentHtml)
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "content-img"
  }, _vm._l((_vm.info.userCommentImage), function(item, index) {
    return _c('img', {
      key: index,
      class: index === _vm.contentImgActive ? 'active' : '',
      attrs: {
        "src": _vm.commentDetailImgSrc,
        "data-src": (item + _vm.commentImgPostfix)
      },
      on: {
        "click": function($event) {
          _vm.showImg(item, index)
        }
      }
    })
  })), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imgShowStatus),
      expression: "imgShowStatus"
    }],
    staticClass: "img-show",
    on: {
      "click": _vm.hideImg
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgShowSrc
    }
  })]), _vm._v(" "), _c('time', [_vm._v(_vm._s(_vm.info.userCommentTime))]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.replyShowStatus && !_vm.info.bizReplyContent),
      expression: "!replyShowStatus && !info.bizReplyContent"
    }],
    staticClass: "reply-btn",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.showReply
    }
  }, [_vm._v("回复")]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.bizReplyContent && _vm.replyContentShowStatus),
      expression: "info.bizReplyContent && replyContentShowStatus"
    }],
    staticClass: "reply-content"
  }, [_c('p', [_vm._v("商家回复：" + _vm._s(_vm.info.bizReplyContent))]), _vm._v(" "), _c('time', [_vm._v(_vm._s(_vm.info.bizReplyTime))]), _vm._v(" "), _c('a', {
    staticClass: "reply-btn",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.showReply
    }
  }, [_vm._v("修改")])]), _vm._v(" "), _c('reply-component', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.replyShowStatus),
      expression: "replyShowStatus"
    }],
    attrs: {
      "replyContent": _vm.info.bizReplyContent,
      "did": _vm.info.dealId,
      "commentId": _vm.info.id,
      "poiId": _vm.info.poiId
    },
    on: {
      "cancel": _vm.hideReply
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 724 */
/*!********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7038d320","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/comment/list/components/list/List.vue ***!
  \********************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "list"
  }, [_c('header', [_c('span', [_vm._v("共有" + _vm._s(_vm.commentData.totalCount) + "条评价")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.uploadComment
    }
  }, [_vm._v("下载评价")])]), _vm._v(" "), _c('section', {
    staticClass: "comment"
  }, _vm._l((_vm.commentData.data), function(item, index) {
    return _c('content-component', {
      key: item.id,
      attrs: {
        "info": item
      }
    })
  })), _vm._v(" "), _c('v-pagination', {
    attrs: {
      "current": _vm.currentPage,
      "total": Math.ceil(_vm.commentData.totalCount / 20),
      "size": 'md',
      "first": false,
      "last": false
    },
    on: {
      "current-change": function($event) {
        _vm.currentChangeFunc($event)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 725 */
/*!***************************************************************!*\
  !*** ./src/views/comment/list/components/product/Product.vue ***!
  \***************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-206b3860","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Product.vue */ 726)
}
var Component = __webpack_require__(/*! ../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Product.vue */ 727),
  /* template */
  __webpack_require__(/*! !../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-206b3860","hasScoped":false}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Product.vue */ 728),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 726 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-206b3860","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/comment/list/components/product/Product.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 727 */
/*!**********************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/comment/list/components/product/Product.vue ***!
  \**********************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _comment = __webpack_require__(/*! api/comment */ 95);

var _comment2 = _interopRequireDefault(_comment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            loading: false, // 表格加载
            searchInput: '', // 搜索内容
            productData: {
                data: [],
                totalCount: 0
            },
            currentPage: 1
        };
    },

    props: ['did', 'businessType', 'businessTypeName'],
    methods: {
        // 关闭弹层
        closeProductTc: function closeProductTc() {
            this.$emit('closeProductTc');
        },

        // 获取产品列表
        getProductList: function getProductList() {
            var _this = this;

            var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            var isSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (isSearch) {
                this.currentPage = 1;
            }
            this.loading = true;
            _comment2.default.getProductList(this.businessType, this.searchInput, page).then(function (res) {
                _this.productData.data = res.data;
                _this.productData.totalCount = res.totalCount;
                _this.loading = false;
            }).catch(function (err) {
                _this.loading = false;
                console.log(err);
                _this.$notify.error({
                    title: '错误',
                    message: err.message || '出错了，请稍后再试'
                });
            });
        },


        // 切换页码
        currentChangeFunc: function currentChangeFunc(data) {
            this.currentPage = data.current;
            this.getProductList(this.currentPage);
        }
    },
    filters: {
        // 格式化在线状态
        formatOnlineStatus: function formatOnlineStatus(status) {
            var str = '';
            switch (status) {
                case 1:
                    str = '已上线';
                    break;
                case 0:
                    str = '未上线';
                    break;
                default:
                    str = '未知';
            }
            return str;
        }
    },
    created: function created() {
        this.getProductList();
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 728 */
/*!**************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-206b3860","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/comment/list/components/product/Product.vue ***!
  \**************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "dark",
    on: {
      "click": _vm.closeProductTc
    }
  }, [_c('section', {
    staticClass: "product-box",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('header', [_c('img', {
    attrs: {
      "src": __webpack_require__(/*! static/img/search-gray.png */ 729),
      "alt": "icon"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchInput),
      expression: "searchInput"
    }],
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": "请输入产品名称或美团产品编号"
    },
    domProps: {
      "value": (_vm.searchInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchInput = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "搜索"
    },
    on: {
      "click": function($event) {
        _vm.getProductList(1, true)
      }
    }
  })]), _vm._v(" "), _c('table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.productData.data), function(item, index) {
    return _c('tr', {
      key: item.dealId
    }, [_c('td', [_vm._v(_vm._s(item.dealId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.dealName))]), _vm._v(" "), _c('td', [(item.mtReviewCount !== 0) ? _c('span', [_vm._v(_vm._s(item.mtScore) + "分 " + _vm._s(item.mtReviewCount) + "条评价")]) : _c('span', {
      staticClass: "span-gray"
    }, [_vm._v("暂无评价")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatOnlineStatus")(item.onlineStatus)))]), _vm._v(" "), _c('td', [(item.mtReviewCount !== 0 && _vm.did != item.dealId) ? _c('router-link', {
      attrs: {
        "to": {
          name: _vm.businessTypeName + 'reviewDetail',
          params: {
            type: _vm.businessTypeName,
            id: item.dealId,
            name: item.dealName
          }
        }
      }
    }, [_vm._v("查看")]) : _c('span', {
      staticClass: "span-gray"
    }, [_vm._v("查看")])], 1)])
  }))]), _vm._v(" "), _c('v-pagination', {
    attrs: {
      "current": _vm.currentPage,
      "total": Math.ceil(_vm.productData.totalCount / 10),
      "size": 'md',
      "first": false,
      "last": false
    },
    on: {
      "current-change": function($event) {
        _vm.currentChangeFunc($event)
      }
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("产品编号")]), _vm._v(" "), _c('th', [_vm._v("产品名称")]), _vm._v(" "), _c('th', [_vm._v("美团评价")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("产品状态")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("操作")])])])
}]}

/***/ }),
/* 729 */
/*!************************************!*\
  !*** ./static/img/search-gray.png ***!
  \************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFASURBVHgBpZLtTQJBEIZnZu8OQtRQwtmBdAAVoBVIB5KYmJNI/EgEgn+0AqAC6QA70A6EDogaEvZ2d9y9SMKSy4XE98f+2N1nvt5B+FOS9GMKwjYSnQNwlQHnyPymU3k/GFzPYUfkjm532KKoNLPAUtO69vhwiUauG4xmIaLovdMZnuyCmGVykFJnvd7Vx+4HB2EgXrWUje3MJMLolrV+yYOc3D2DmYBtwysVEU5ZqykUyJAaE2HTAxmgmtf8tspQXiJA7IPMi+SuHxeBUqb2nb1WCBCmpIJWEYhCXDCjDxqZPjvv8kbulNw81W3wurF+esHc4SAKxIwZxlLrSbpazcNKJS6RaNqa2nYOS1basytbAHehpKy5QUUBjQ6ODj9D650Bgz9f38cOcl5uV4WwpzaLsMlM+4LZImSZaQT/0S8mOZbeiy7cjwAAAABJRU5ErkJggg=="

/***/ }),
/* 730 */
/*!***************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbeb821a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/comment/list/Main.vue ***!
  \***************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'comment-main': true, 'fix': _vm.showProductStatus
    }
  }, [(_vm.loading) ? _c('Spin', {
    attrs: {
      "size": "large",
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('title-component', {
    attrs: {
      "dealName": _vm.dealName
    },
    on: {
      "showProductTc": function($event) {
        _vm.changeProductTc(true)
      }
    }
  }), _vm._v(" "), _c('filter-component', {
    attrs: {
      "did": _vm.did
    }
  }), _vm._v(" "), _c('list-component', {
    attrs: {
      "did": _vm.did
    },
    on: {
      "changeLoading": _vm.changeLoading
    }
  }), _vm._v(" "), (_vm.showProductStatus) ? _c('product-component', {
    attrs: {
      "did": _vm.did,
      "businessType": _vm.businessType,
      "businessTypeName": _vm.businessTypeName
    },
    on: {
      "closeProductTc": function($event) {
        _vm.changeProductTc(false)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 731 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7be59d06","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/nhomepage/nhomepage.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 732 */
/*!*******************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/nhomepage/nhomepage.vue ***!
  \*******************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Card = __webpack_require__(/*! components/homepage/Card.vue */ 166);

var _Card2 = _interopRequireDefault(_Card);

var _serviceItem = __webpack_require__(/*! components/homepage/serviceItem.vue */ 249);

var _serviceItem2 = _interopRequireDefault(_serviceItem);

var _ActiveItem = __webpack_require__(/*! components/homepage/ActiveItem.vue */ 250);

var _ActiveItem2 = _interopRequireDefault(_ActiveItem);

var _notices = __webpack_require__(/*! components/homepage/notices.vue */ 251);

var _notices2 = _interopRequireDefault(_notices);

var _CourseItem = __webpack_require__(/*! components/homepage/CourseItem.vue */ 253);

var _CourseItem2 = _interopRequireDefault(_CourseItem);

var _Footer = __webpack_require__(/*! components/homepage/Footer.vue */ 254);

var _Footer2 = _interopRequireDefault(_Footer);

var _BannerTexts = __webpack_require__(/*! components/homepage/BannerTexts */ 255);

var _BannerTexts2 = _interopRequireDefault(_BannerTexts);

var _BannerImages = __webpack_require__(/*! components/homepage/BannerImages */ 256);

var _BannerImages2 = _interopRequireDefault(_BannerImages);

var _TopNotice = __webpack_require__(/*! components/homepage/TopNotice */ 257);

var _TopNotice2 = _interopRequireDefault(_TopNotice);

var _MidNotices = __webpack_require__(/*! components/homepage/MidNotices */ 258);

var _MidNotices2 = _interopRequireDefault(_MidNotices);

var _utils = __webpack_require__(/*! components/nhomepage/utils */ 771);

var _nshared = __webpack_require__(/*! api/nshared */ 773);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    data: function data() {
        return (0, _utils.getDefaultData)();
    },
    props: {
        bizLineId: {
            type: String,
            required: false
        }
    },
    created: function created() {
        this.updateData(this.$route);
    },
    mounted: function mounted() {
        var _this = this;

        this.unregisterRouteHookFn = this.$router.beforeEach(function (to, from, next) {
            _this.updateData(to, true);
            next();
        });
    },
    destroyed: function destroyed() {
        if (this.unregisterRouteHookFn) {
            this.unregisterRouteHookFn();
        }
    },

    components: {
        HomePageCard: _Card2.default,
        ServiceItem: _serviceItem2.default,
        ActiveItem: _ActiveItem2.default,
        Notices: _notices2.default,
        CourseItem: _CourseItem2.default,
        HomePageFooter: _Footer2.default,
        BannerTexts: _BannerTexts2.default,
        BannerImages: _BannerImages2.default,
        TopNotice: _TopNotice2.default,
        MidNotice: _MidNotices2.default
    },
    methods: {
        resetData: function resetData() {
            Object.assign(this, (0, _utils.getDefaultData)());
        },
        updateData: function updateData(route, notCreated) {
            if (notCreated) {
                this.resetData();
            }
            this.bizLineIdNum = Number.parseInt(this.bizLineId || route.meta.bizLineId);
            if (!this.bizLineIdNum) {
                console.error("bizlineId should be a number!");
                return;
            }
            this.serviceItems = (0, _utils.getServiceItems)(this.bizLineIdNum);
            this.hasServiceCard = this.serviceItems && this.serviceItems.length;
            this.getAnnounces();
        },
        servicItemClicked: function servicItemClicked(item) {
            (0, _utils.processServiceItem)(item, this.$router);
        },
        getAnnounces: function getAnnounces() {
            var _this2 = this;

            (0, _nshared.getAnnounces)(this.bizLineIdNum).then(function (notices) {
                if (notices) {
                    if (notices.notices) {
                        _this2.notices = notices.notices;
                    }
                    if (notices.midDialogDecorateList) {
                        _this2.midNotices = notices.midDialogDecorateList;
                    }
                    if (notices.rules) {
                        _this2.rules = notices.rules;
                    }
                    if (notices.courses) {
                        _this2.courses = notices.courses;
                    }
                    if (notices.bannerTexts) {
                        _this2.bannerTexts = notices.bannerTexts;
                    }
                    if (notices.bannerImages) {
                        _this2.bannerImgs = notices.bannerImages;
                    }
                    if (notices.topNotices) {
                        _this2.topNotices = notices.topNotices;
                    }
                }
            }).catch(function (err) {
                var msg = err && err.message || "获取公告出错";
                _this2.$Message.error(msg);
            });
        },
        moreNoticesClicked: function moreNoticesClicked(type) {
            (0, _utils.moreNotices)(type, this.bizLineIdNum, this.$router);
        },
        noticeClicked: function noticeClicked(id) {
            (0, _utils.openNoticeDetail)(id);
        },
        createSelfProClicked: function createSelfProClicked() {
            (0, _utils.toCreateSelfPromotion)(this.bizLineIdNum, this.$router);
        }
    }
};

/***/ }),
/* 733 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b0b021e4","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/homepage/Card.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 734 */
/*!*************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/Card.vue ***!
  \*************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//

exports.default = {
    props: {
        title: {
            type: String,
            required: true
        },
        padding: {
            type: Number,
            default: 20
        },
        extra: {
            type: String,
            default: null
        }
    }
};

/***/ }),
/* 735 */
/*!*****************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0b021e4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/Card.vue ***!
  \*****************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Card', {
    staticClass: "homepagecard",
    attrs: {
      "bordered": false,
      "padding": _vm.padding,
      "shadow": true
    }
  }, [_c('p', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.extra) ? _c('a', {
    staticClass: "hompage-card-extra",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.$emit('extraClick')
      }
    },
    slot: "extra"
  }, [_vm._v(_vm._s(_vm.extra))]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 736 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c395c0c","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/homepage/serviceItem.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 737 */
/*!********************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/serviceItem.vue ***!
  \********************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//

exports.default = {
    props: {
        id: {
            type: Number,
            default: 0
        },
        icon: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        desc: {
            type: String,
            required: true
        }
    }
};

/***/ }),
/* 738 */
/*!************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c395c0c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/serviceItem.vue ***!
  \************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "service-item"
  }, [_c('i', {
    staticClass: "service-icon",
    class: _vm.icon
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.desc))])])
},staticRenderFns: []}

/***/ }),
/* 739 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7a68e392","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/homepage/ActiveItem.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 740 */
/*!*******************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/ActiveItem.vue ***!
  \*******************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//

exports.default = {
    props: {
        name: {
            type: String,
            required: true
        },
        date: {
            type: String,
            required: true
        },
        bgclass: {
            type: String,
            required: true
        }
    },
    computed: {
        title: function title() {
            return this.name.substr(0, 2);
        }
    }
};

/***/ }),
/* 741 */
/*!***********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a68e392","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/ActiveItem.vue ***!
  \***********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "activity-item"
  }, [_c('i', {
    class: _vm.bgclass
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "activity-name"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('span', {
    staticClass: "activity-date"
  }, [_vm._v(_vm._s(_vm.date))])])])
},staticRenderFns: []}

/***/ }),
/* 742 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-971502a6","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/homepage/notices.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 743 */
/*!****************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/notices.vue ***!
  \****************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Card = __webpack_require__(/*! components/homepage/Card.vue */ 166);

var _Card2 = _interopRequireDefault(_Card);

var _noticeItem = __webpack_require__(/*! components/homepage/noticeItem.vue */ 252);

var _noticeItem2 = _interopRequireDefault(_noticeItem);

var _notices = __webpack_require__(/*! utils/notices */ 51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { HomePageCard: _Card2.default, NoticeItem: _noticeItem2.default },
    props: {
        title: {
            type: String,
            required: true
        },
        notices: {
            type: Array,
            required: true
        }
    },
    methods: {
        noticeClicked: function noticeClicked(id) {
            window.open((0, _notices.getNoticeDetailUrl)(id), "_blank");
        }
    }
}; //
//
//
//
//
//
//

/***/ }),
/* 744 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f90e302e","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/homepage/noticeItem.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 745 */
/*!*******************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/noticeItem.vue ***!
  \*******************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    props: {
        name: {
            type: String,
            required: true
        },
        date: {
            type: String,
            required: true
        },
        isNew: {
            type: Boolean,
            default: false
        }
    }
};

/***/ }),
/* 746 */
/*!***********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f90e302e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/noticeItem.vue ***!
  \***********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "notice-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.$emit('itemClicked')
      }
    }
  }, [_vm._v(_vm._s(_vm.name) + "\n        "), (_vm.isNew) ? _c('span', {
    staticClass: "notice-new"
  }, [_c('img', {
    attrs: {
      "src": "//awp-assets.meituan.net/hfe/fep/8998afcc22bad060d889bc2aee1766d5/newnotice.svg"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.date))])])
},staticRenderFns: []}

/***/ }),
/* 747 */
/*!********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-971502a6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/notices.vue ***!
  \********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('HomePageCard', {
    staticClass: "platform-notices",
    attrs: {
      "title": _vm.title,
      "extra": "更多"
    },
    on: {
      "extraClick": function($event) {
        _vm.$emit('extraClicked')
      }
    }
  }, [_c('ul', {
    staticClass: "notice-list"
  }, _vm._l((_vm.notices), function(noticeItem) {
    return _c('NoticeItem', {
      key: noticeItem.id,
      attrs: {
        "isNew": noticeItem.isNew,
        "name": noticeItem.name,
        "date": noticeItem.date
      },
      on: {
        "itemClicked": function($event) {
          _vm.noticeClicked(noticeItem.id)
        }
      }
    })
  }))])
},staticRenderFns: []}

/***/ }),
/* 748 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1b8b0a4c","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/homepage/CourseItem.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 749 */
/*!*******************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/CourseItem.vue ***!
  \*******************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//

exports.default = {
    props: {
        src: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        subTitle: {
            type: String,
            required: true
        }
    }
};

/***/ }),
/* 750 */
/*!***********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b8b0a4c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/CourseItem.vue ***!
  \***********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "course-item"
  }, [_c('a', [_c('img', {
    attrs: {
      "src": _vm.src + '@153h_252w_2e_90Q'
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.subTitle))])])])
},staticRenderFns: []}

/***/ }),
/* 751 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6b75aace","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/homepage/Footer.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 752 */
/*!***************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/Footer.vue ***!
  \***************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = __webpack_require__(/*! vuex */ 14);

var _ticket = __webpack_require__(/*! api/ticket */ 50);

var _notices = __webpack_require__(/*! utils/notices */ 51);

exports.default = {
    data: function data() {
        return {
            defaultBd: {
                name: null,
                phone: null
            },
            bds: [],
            bdModal: false
        };
    },
    created: function created() {
        var _this = this;

        this.getUser().then(function (bizUser) {
            if (bizUser) {
                (0, _ticket.getBdsInfo)(bizUser.supplierId).then(function (bds) {
                    if (bds && bds.length) {
                        var defaultBd = bds[0];
                        _this.defaultBd.name = defaultBd.bdName;
                        _this.defaultBd.phone = (0, _notices.formatPhone)(defaultBd.bdTelephone);
                        _this.bds = bds.map(function (bd) {
                            return {
                                name: bd.bdName,
                                phone: (0, _notices.formatPhone)(bd.bdTelephone),
                                email: bd.bdOwnEmail
                            };
                        });
                    }
                });
            }
        });
    },

    methods: Object.assign({}, (0, _vuex.mapActions)(["getUser"]), {
        moreBds: function moreBds() {
            if (!this.bds || !this.bds.length) {
                this.$Notice.info({
                    title: "暂无更多BD"
                });
            } else {
                this.bdModal = true;
            }
        },
        closeBdModal: function closeBdModal() {
            this.bdModal = false;
        }
    })
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 753 */
/*!******************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b75aace","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/Footer.vue ***!
  \******************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "homefooter"
  }, [_c('div', {
    staticClass: "contract-info"
  }, [_vm._m(0), _vm._v(" "), (_vm.defaultBd.name) ? _c('div', {
    staticClass: "item"
  }, [_c('h3', {
    staticClass: "footer-item-title"
  }, [_vm._v("联系BD：" + _vm._s(_vm.defaultBd.name))]), _vm._v(" "), _c('span', {
    staticClass: "footer-item-content"
  }, [_vm._v(_vm._s(_vm.defaultBd.phone))]), _vm._v(" "), _c('a', {
    staticClass: "other-bds",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.moreBds($event)
      }
    }
  }, [_vm._v("联系其他BD\n        "), _c('Icon', {
    attrs: {
      "type": "turbo-ui-arrow-right"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "600"
    },
    model: {
      value: (_vm.bdModal),
      callback: function($$v) {
        _vm.bdModal = $$v
      },
      expression: "bdModal"
    }
  }, [_c('p', {
    slot: "header"
  }, [_vm._v("\n        联系BD\n      ")]), _vm._v(" "), _c('ul', _vm._l((_vm.bds), function(bd) {
    return _c('li', {
      key: bd.phone,
      staticClass: "bd-info-item"
    }, [_c('span', {
      staticClass: "bd-info-name"
    }, [_vm._v("姓名：" + _vm._s(bd.name))]), _vm._v(" "), _c('span', {
      staticClass: "bd-info-phone"
    }, [_vm._v("联系电话：" + _vm._s(bd.phone))]), _vm._v(" "), _c('span', {
      staticClass: "bd-info-email"
    }, [_vm._v("联系邮箱：\n            "), _c('a', {
      attrs: {
        "href": 'mailto:' + bd.email
      }
    }, [_vm._v(_vm._s(bd.email))])])])
  })), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.closeBdModal
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('h3', {
    staticClass: "footer-item-title"
  }, [_vm._v("联系美团 & 电话验证")]), _vm._v(" "), _c('span', {
    staticClass: "footer-item-content"
  }, [_vm._v("400-660-1065")]), _vm._v(" "), _c('span', {
    staticClass: "extra"
  }, [_vm._v("周一到周日 09:00-21:00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('h3', {
    staticClass: "footer-item-title"
  }, [_vm._v("反馈 & 投诉")]), _vm._v(" "), _c('a', {
    staticClass: "footer-item-content mail",
    attrs: {
      "href": "mailto:lianzheng@meituan.com"
    }
  }, [_vm._v("lianzheng@meituan.com")]), _vm._v(" "), _c('span', {
    staticClass: "extra"
  }, [_vm._v("周一到周日 09:00-21:00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item qr-code-wrapper"
  }, [_c('div', {
    staticClass: "qrcode"
  }, [_c('img', {
    staticClass: "qr-code",
    attrs: {
      "src": "//p0.meituan.net/codeman/3cb78560876cc53cb80c37d0229fe90c6357.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer-item-content"
  }, [_c('h2', [_vm._v("美团旅行商家App")]), _vm._v(" "), _c('span', [_vm._v("扫描二维码下载")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "//www.meituan.com/",
      "target": "_blank"
    }
  }, [_vm._v("©美团网团购meituan.com")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.miitbeian.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("京ICP证070791号京ICP备10211739号 ")])])])
}]}

/***/ }),
/* 754 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f3abcae8","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/homepage/BannerTexts.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 755 */
/*!********************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/BannerTexts.vue ***!
  \********************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//

exports.default = {
    props: {
        bannerTexts: {
            type: Array,
            required: true
        }
    },
    data: function data() {
        return {
            bannerTextIndex: 0
        };
    }
};

/***/ }),
/* 756 */
/*!************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3abcae8","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/BannerTexts.vue ***!
  \************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Carousel', {
    staticClass: "banner-texts",
    attrs: {
      "autoplay": "",
      "arrow": "never",
      "dots": _vm.bannerTexts && _vm.bannerTexts.length > 1 ? 'inside' : 'none'
    },
    model: {
      value: (_vm.bannerTextIndex),
      callback: function($$v) {
        _vm.bannerTextIndex = $$v
      },
      expression: "bannerTextIndex"
    }
  }, _vm._l((_vm.bannerTexts), function(bannerTextItem) {
    return _c('CarouselItem', {
      key: bannerTextItem.id
    }, [_c('a', {
      staticClass: "banner-link",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.$emit('bannerItemClicked', bannerTextItem.id)
        }
      }
    }, [_vm._v(_vm._s(bannerTextItem.text))])])
  }))
},staticRenderFns: []}

/***/ }),
/* 757 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-48f090c2","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/homepage/BannerImages.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 758 */
/*!*********************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/BannerImages.vue ***!
  \*********************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//

exports.default = {
    props: {
        images: {
            type: Array,
            required: true
        }
    },
    data: function data() {
        return {
            bannerImgIndex: 0
        };
    }
};

/***/ }),
/* 759 */
/*!*************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48f090c2","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/BannerImages.vue ***!
  \*************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Carousel', {
    staticClass: "banner-imgs",
    attrs: {
      "autoplay": "",
      "arrow": "never",
      "dots": _vm.images && _vm.images.length > 1 ? 'inside' : 'none'
    },
    model: {
      value: (_vm.bannerImgIndex),
      callback: function($$v) {
        _vm.bannerImgIndex = $$v
      },
      expression: "bannerImgIndex"
    }
  }, _vm._l((_vm.images), function(bannerImgItem) {
    return _c('CarouselItem', {
      key: bannerImgItem.id
    }, [_c('img', {
      staticClass: "banner-imgitem",
      attrs: {
        "src": bannerImgItem.src
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.$emit('bannerItemClicked', bannerImgItem.id)
        }
      }
    })])
  }))
},staticRenderFns: []}

/***/ }),
/* 760 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6e39faff","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/homepage/TopNotice.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 761 */
/*!******************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/TopNotice.vue ***!
  \******************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _NoticeInnerLink = __webpack_require__(/*! components/homepage/NoticeInnerLink */ 762);

var _NoticeInnerLink2 = _interopRequireDefault(_NoticeInnerLink);

var _vue = __webpack_require__(/*! vue */ 30);

var _vue2 = _interopRequireDefault(_vue);

var _notices = __webpack_require__(/*! utils/notices */ 51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component("NoticeInnerLink", _NoticeInnerLink2.default); //
//
//

var cornerKey = "CORNER_STORAGE_KEY";
var namePrefix = "topNotice";
exports.default = {
    props: {
        notices: {
            type: Array,
            required: true
        }
    },
    data: function data() {
        return {
            topNotices: []
        };
    },
    created: function created() {
        var _this = this;

        this.noticesHasRead = [];
        this.noticesShowing = [];
        if (window.localStorage) {
            try {
                var noticesHasReadStr = window.localStorage.getItem(cornerKey);
                if (noticesHasReadStr) {
                    this.noticesHasRead = JSON.parse(noticesHasReadStr);
                }
            } catch (ex) {
                console.error(err);
            }
        }
        if (this.notices && this.notices.length) {
            var noticeUnread = this.notices.find(function (noticeItem) {
                return !_this.noticesHasRead.includes(noticeItem.id);
            });
            if (noticeUnread) {
                this.showTopNotice(noticeUnread);
            }
        }
    },
    destroyed: function destroyed() {
        var _this2 = this;

        this.noticesShowing.forEach(function (notice) {
            _this2.$Notice.close(namePrefix + notice);
        });
    },

    methods: {
        markAsRead: function markAsRead(id) {
            window.open((0, _notices.getNoticeDetailUrl)(id), "_blank");
            this.$Notice.close(namePrefix + id);
            if (!this.noticesHasRead.includes(id)) {
                this.noticesHasRead.push(id);
                if (window.localStorage) {
                    try {
                        window.localStorage.setItem(cornerKey, JSON.stringify(this.noticesHasRead));
                    } catch (err) {
                        console.error(err);
                    }
                }
            }
        },
        showTopNotice: function showTopNotice(item) {
            var _this3 = this;

            if (this.noticesShowing.indexOf(item.id) !== -1) {
                return;
            }
            this.noticesShowing.push(item.id);
            this.$Notice.info({
                title: item.title,
                desc: item.title,
                duration: 0,
                name: namePrefix + item.id,
                onClose: function onClose() {
                    _this3.noticesShowing.splice(_this3.noticesShowing.indexOf(item.id), 1);
                },
                render: function render(h) {
                    return h("NoticeInnerLink", {
                        props: {
                            item: item
                        },
                        on: {
                            toDetail: function toDetail(id) {
                                _this3.markAsRead(id);
                            }
                        }
                    });
                }
            });
        }
    }
};

/***/ }),
/* 762 */
/*!*****************************************************!*\
  !*** ./src/components/homepage/NoticeInnerLink.vue ***!
  \*****************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-4ca8c4ea","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./NoticeInnerLink.vue */ 763)
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-4ca8c4ea","scoped":false,"hasInlineConfig":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=1!./NoticeInnerLink.vue */ 764)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./NoticeInnerLink.vue */ 765),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-4ca8c4ea","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./NoticeInnerLink.vue */ 766),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 763 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4ca8c4ea","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/homepage/NoticeInnerLink.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 764 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4ca8c4ea","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/homepage/NoticeInnerLink.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 765 */
/*!************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/NoticeInnerLink.vue ***!
  \************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//

exports.default = {
    props: {
        item: {
            type: Object,
            required: true
        }
    }
};

/***/ }),
/* 766 */
/*!****************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ca8c4ea","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/NoticeInnerLink.vue ***!
  \****************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "notice-inner"
  }, [_vm._v(_vm._s(_vm.item.content) + "\n    "), _c('a', {
    attrs: {
      "href": "javscript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.$emit('toDetail', _vm.item.id)
      }
    }
  }, [_vm._v("查看详情")])])
},staticRenderFns: []}

/***/ }),
/* 767 */
/*!**********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e39faff","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/TopNotice.vue ***!
  \**********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 768 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3c3a9b31","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/homepage/MidNotices.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 769 */
/*!*******************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/MidNotices.vue ***!
  \*******************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _notices = __webpack_require__(/*! utils/notices */ 51);

//
//
//

var midKey = "MIDDIALOG_STORAGE_KEY";

var namePrefix = "midNotice";
exports.default = {
    props: {
        notices: {
            type: Array,
            required: true
        }
    },
    created: function created() {
        var _this = this;

        this.noticesHasRead = [];
        this.noticesShowing = [];
        if (window.localStorage) {
            try {
                var noticesHasReadStr = window.localStorage.getItem(midKey);
                if (noticesHasReadStr) {
                    this.noticesHasRead = JSON.parse(noticesHasReadStr);
                }
            } catch (ex) {
                console.error(err);
            }
        }
        if (this.notices && this.notices.length) {
            var noticeUnread = this.notices.find(function (noticeItem) {
                return !_this.noticesHasRead.includes(noticeItem.announceId);
            });
            if (noticeUnread) {
                this.showMidNotice(noticeUnread);
            }
        }
    },

    methods: {
        markAsRead: function markAsRead(id) {
            window.open((0, _notices.getNoticeDetailUrl)(id), "_blank");
            if (!this.noticesHasRead.includes(id)) {
                this.noticesHasRead.push(id);
                if (window.localStorage) {
                    try {
                        window.localStorage.setItem(midKey, JSON.stringify(this.noticesHasRead));
                    } catch (err) {
                        console.error(err);
                    }
                }
            }
        },
        showMidNotice: function showMidNotice(item) {
            var _this2 = this;

            if (this.noticesShowing.indexOf(item.announceId) !== -1) {
                return;
            }
            this.noticesShowing.push(item.announceId);
            this.$Modal.info({
                title: item.decorateTitle,
                content: item.decorateContent,
                name: namePrefix + item.announceId,
                okText: "查看详情",
                maskClosable: false,
                closable: false,
                onOk: function onOk() {
                    _this2.$nextTick(function () {
                        _this2.noticesShowing.splice(_this2.noticesShowing.indexOf(item.announceId), 1);
                        _this2.markAsRead(item.announceId);
                    });
                }
            });
        }
    }
};

/***/ }),
/* 770 */
/*!***********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c3a9b31","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/MidNotices.vue ***!
  \***********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 771 */
/*!*******************************************!*\
  !*** ./src/components/nhomepage/utils.js ***!
  \*******************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDefaultData = exports.toCreateSelfPromotion = exports.moreNotices = exports.openNoticeDetail = exports.processServiceItem = exports.getServiceItems = undefined;

var _typeof2 = __webpack_require__(/*! babel-runtime/helpers/typeof */ 116);

var _typeof3 = _interopRequireDefault(_typeof2);

var _notification = __webpack_require__(/*! data/notification */ 79);

var _caches = __webpack_require__(/*! utils/caches */ 772);

var _common = __webpack_require__(/*! config/common */ 167);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var servicesItems = [{
    id: 1,
    icon: "zicu",
    name: "商家自促",
    desc: "精准投放，稳定拉新",
    to: "createSelfPromotion"
}, {
    id: 2,
    icon: "app",
    name: "手机App",
    desc: "快捷便携，及时处理",
    url: "//sj.qq.com/myapp/detail.htm?apkName=com.meituan.tripBizApp"
}, {
    id: 3,
    icon: "comment",
    name: "评论管理",
    desc: "维护客情，提升服务",
    to: "reviewlist"
}, {
    id: 4,
    icon: "datacenter",
    name: "数据分析",
    desc: "指标监控，销量提升",
    to: "operatingData"
}];

var BizLineServiceItemsConfig = {
    4: [0, 1, 3],
    3: [0, 1, 2, 3]
};

var getBizLineInfoCacheKeyPrefix = 'getBizLineInfo';

function getBizLineInfo(bizLineId) {
    var key = getBizLineInfoCacheKeyPrefix + bizLineId;
    if (_caches.caches[key]) {
        return _caches.caches[key];
    }
    var bizLineInfo = _common.bizLines.find(function (bizLine) {
        return bizLine.bizLineId === bizLineId;
    });
    if (!bizLineInfo) {
        console.error('can not find the target bizlineinfo');
    }
    _caches.caches[key] = bizLineInfo;
    return bizLineInfo;
}

var getServiceItemsCacheKeyPrefix = "getServiceItems";

var getServiceItems = exports.getServiceItems = function getServiceItems(bizLineId) {
    var key = getServiceItemsCacheKeyPrefix + bizLineId;
    if (_caches.caches[key]) {
        return _caches.caches[key];
    } else {
        var serviceItems = [];
        if (_common.bizLines && _common.bizLines.length) {
            var bizLineInfo = getBizLineInfo(bizLineId);
            if (!bizLineInfo) {
                console.error('can not find the bizline');
                return serviceItems;
            }
            var config = BizLineServiceItemsConfig[bizLineId] || [];
            serviceItems = servicesItems.filter(function (item, index) {
                return config.includes(index);
            }).map(function (item) {
                return Object.assign({}, item);
            });
            serviceItems.forEach(function (item) {
                if (typeof item.to === 'string') {
                    item.to = bizLineInfo.value + item.to;
                } else if ((0, _typeof3.default)(item.to) === 'object') {
                    item.to = item.to[bizLineId];
                }
                if (typeof item.url === 'string') {
                    item.url = item.url.replace('${bizLineId}', bizLineId);
                    item.url = item.url.replace('${bizLineValue}', bizLineInfo.value);
                } else if ((0, _typeof3.default)(item.url) === 'object') {
                    item.url = item.url[bizLineId];
                }
            });
        } else {
            console.error('no bizlines found!');
        }
        _caches.caches[key] = serviceItems;
        return serviceItems;
    }
};

var processServiceItem = exports.processServiceItem = function processServiceItem(item, router) {
    if (item.to) {
        router.push({ name: item.to });
        return;
    }
    if (item.url) {
        window.open(item.url, "_blank");
    }
};

var openNoticeDetail = exports.openNoticeDetail = function openNoticeDetail(id) {
    window.open(window.location.pathname + ("#/announce/" + id), '_blank');
};

var xgxyRouteNamePostfix = 'academy';
var gzzxRouteNamePostfix = 'policyrule';
var ptgzRouteNamePrefix = 'broadcast';

var moreNotices = exports.moreNotices = function moreNotices(type, bizLineId, router) {
    var bizLineInfo = getBizLineInfo(bizLineId);
    var ptgzRouteInfo = _notification.businessLines.find(function (bizLine) {
        return bizLine.bizLineId === bizLineId;
    });
    var routeName = '';
    switch (type.toString()) {
        case '5':
            routeName = bizLineInfo.value + xgxyRouteNamePostfix;
            break;
        case '10':
            routeName = bizLineInfo.value + gzzxRouteNamePostfix;
            break;
        case '3':
            routeName = ptgzRouteNamePrefix + ptgzRouteInfo.value;
            break;
        default:
            break;
    }
    if (routeName) {
        router.push({ name: routeName });
    }
};

var createSelfPromotionPostfix = 'createSelfPromotion';

var toCreateSelfPromotion = exports.toCreateSelfPromotion = function toCreateSelfPromotion(bizLineId, router) {
    var bizLineInfo = getBizLineInfo(bizLineId);
    router.push({ name: bizLineInfo.value + createSelfPromotionPostfix });
};

var getDefaultData = exports.getDefaultData = function getDefaultData() {
    return {
        serviceItems: [],
        activeItems: [],
        notices: [],
        rules: [],
        courses: [],
        bizLineIdNum: null,
        hasServiceCard: false,
        bannerTexts: [],
        bannerImgs: [],
        topNotices: [],
        midNotices: []
    };
};

/***/ }),
/* 772 */
/*!*****************************!*\
  !*** ./src/utils/caches.js ***!
  \*****************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var caches = exports.caches = {};

/***/ }),
/* 773 */
/*!****************************!*\
  !*** ./src/api/nshared.js ***!
  \****************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getAnnounces = undefined;

var _axios = __webpack_require__(/*! axios */ 12);

var _axios2 = _interopRequireDefault(_axios);

var _notices = __webpack_require__(/*! utils/notices */ 51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAnnounces = exports.getAnnounces = function getAnnounces(bizLineId) {
    return _axios2.default.get('/trip-notify/acc/announces/special', {
        params: {
            bizLineId: bizLineId,
            servicePlatform: 1
        }
    }).then(function (respone) {
        var data = respone && respone.data;
        if (data.noticeAnnPublishList) {
            data.notices = data.noticeAnnPublishList.map(function (noticeItem) {
                return (0, _notices.mapNoticeItem)(noticeItem);
            });
        }
        if (data.ruleAnnPublishList) {
            data.rules = data.ruleAnnPublishList.map(function (ruleItem) {
                return (0, _notices.mapNoticeItem)(ruleItem);
            });
        }
        if (data.meidaAnnPublishList) {
            data.courses = data.meidaAnnPublishList.map(function (courseItem) {
                return (0, _notices.mapCourseItem)(courseItem);
            });
        }
        if (data.stripeDecorateList) {
            data.bannerTexts = data.stripeDecorateList.map(function (stripItem) {
                return {
                    id: stripItem.announceId,
                    text: stripItem.decorateContent
                };
            });
        }
        if (data.bannerDecorateList) {
            data.bannerImages = data.bannerDecorateList.map(function (imgItem) {
                return {
                    id: imgItem.announceId,
                    src: imgItem.decorateContent
                };
            });
        }
        if (data.rightDialogDecorateList) {
            data.topNotices = data.rightDialogDecorateList.map(function (dialogItem) {
                return {
                    title: dialogItem.decorateTitle,
                    content: dialogItem.decorateContent,
                    id: dialogItem.announceId
                };
            });
        }
        return data;
    });
};

/***/ }),
/* 774 */
/*!***********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7be59d06","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nhomepage/nhomepage.vue ***!
  \***********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nhomepage"
  }, [(_vm.topNotices && _vm.topNotices.length) ? _c('TopNotice', {
    attrs: {
      "notices": _vm.topNotices
    }
  }) : _vm._e(), _vm._v(" "), (_vm.midNotices && _vm.midNotices.length) ? _c('MidNotice', {
    attrs: {
      "notices": _vm.midNotices
    }
  }) : _vm._e(), _vm._v(" "), (_vm.bannerTexts && _vm.bannerTexts.length) ? _c('div', {
    staticClass: "nhomepage-banner-area"
  }, [_c('BannerTexts', {
    attrs: {
      "bannerTexts": _vm.bannerTexts
    },
    on: {
      "bannerItemClicked": _vm.noticeClicked
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.bannerImgs && _vm.bannerImgs.length) ? _c('div', {
    staticClass: "nhomepage-banner-imgs"
  }, [_c('BannerImages', {
    attrs: {
      "images": _vm.bannerImgs
    },
    on: {
      "bannerItemClicked": _vm.noticeClicked
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasServiceCard) ? _c('div', {
    staticClass: "home-flex-row"
  }, [_c('HomePageCard', {
    staticClass: "home-recomm-services",
    attrs: {
      "title": "推荐服务"
    }
  }, [_vm._l((_vm.serviceItems), function(data) {
    return [(data.icon !== 'app') ? _c('ServiceItem', {
      key: _vm.bizLineIdNum + data.name,
      attrs: {
        "icon": data.icon,
        "name": data.name,
        "desc": data.desc
      },
      nativeOn: {
        "click": function($event) {
          _vm.servicItemClicked(data)
        }
      }
    }) : _vm._e(), _vm._v(" "), (data.icon === 'app') ? _c('Tooltip', {
      key: data.name,
      attrs: {
        "placement": "right"
      }
    }, [_c('ServiceItem', {
      key: data.name,
      attrs: {
        "icon": data.icon,
        "name": data.name,
        "desc": data.desc,
        "delay": 350
      }
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": "//p0.meituan.net/codeman/8acc947084d6b22070523f39dcb7c91428173.png",
        "width": "226px"
      },
      slot: "content"
    })], 1) : _vm._e()]
  })], 2), _vm._v(" "), _c('HomePageCard', {
    staticClass: "home-recomm-actives",
    attrs: {
      "title": "推荐活动"
    }
  }, [(_vm.activeItems && _vm.activeItems.length) ? _c('ul', _vm._l((_vm.activeItems), function(data) {
    return _c('ActiveItem', {
      key: data.id,
      attrs: {
        "name": data.name,
        "date": data.date,
        "bgclass": data.bg
      }
    })
  })) : _c('div', {
    staticClass: "create-selfpro-tip"
  }, [_c('div', [_c('p', {
    staticClass: "main-desc"
  }, [_vm._v("暂无可参加的活动")]), _vm._v(" "), _c('p', {
    staticClass: "sub-desc"
  }, [_vm._v("自己做促销，同样可以吸引顾客")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.createSelfProClicked
    }
  }, [_vm._v("创建自促活动")])], 1)])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "home-flex-row"
  }, [_c('div', {
    staticClass: "nhomepage-notices"
  }, [_c('Notices', {
    attrs: {
      "title": "平台公告",
      "notices": _vm.notices
    },
    on: {
      "extraClicked": function($event) {
        _vm.moreNoticesClicked(3)
      }
    }
  }), _vm._v(" "), _c('Notices', {
    attrs: {
      "title": "规则中心",
      "notices": _vm.rules
    },
    on: {
      "extraClicked": function($event) {
        _vm.moreNoticesClicked(10)
      }
    }
  })], 1), _vm._v(" "), _c('HomePageCard', {
    staticClass: "nhomepage-xigua-academy",
    attrs: {
      "title": "西瓜学院",
      "extra": "更多"
    },
    on: {
      "extraClick": function($event) {
        _vm.moreNoticesClicked(5)
      }
    }
  }, [_c('ul', {
    staticClass: "course-list"
  }, _vm._l((_vm.courses), function(courseItem) {
    return _c('CourseItem', {
      key: courseItem.id,
      attrs: {
        "src": courseItem.src,
        "title": courseItem.title,
        "subTitle": courseItem.subTitle
      },
      nativeOn: {
        "click": function($event) {
          _vm.noticeClicked(courseItem.id)
        }
      }
    })
  }))])], 1), _vm._v(" "), _c('HomePageFooter')], 1)
},staticRenderFns: []}

/***/ }),
/* 775 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-75887188","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/academy/HomePage.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 776 */
/*!***********************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/academy/HomePage.vue ***!
  \***********************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SlideShow = __webpack_require__(/*! ./SlideShow */ 777);

var _SlideShow2 = _interopRequireDefault(_SlideShow);

var _Announcement = __webpack_require__(/*! ./Announcement */ 781);

var _Announcement2 = _interopRequireDefault(_Announcement);

var _academy = __webpack_require__(/*! api/academy */ 259);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            offsetLeft: null,
            isLoading: true,
            activeTagId: -2,
            tagListFixed: false,
            announcements: [],
            tags: [{
                id: -2,
                typeName: "好课推荐"
            }, {
                id: -1,
                typeName: "全部课程"
            }],
            imgs: [],
            goodCourses: []
        };
    },
    components: { SlideShow: _SlideShow2.default, Announcement: _Announcement2.default },
    methods: {
        bannerImgClicked: function bannerImgClicked(imgItem) {
            this.$router.push({
                name: "announceDetail",
                params: { id: imgItem.announceId }
            });
        },
        alert: function alert(message) {
            this.$alert({
                title: "提示",
                message: message,
                showCancelButton: false,
                closeOnClickModal: false
            });
        },
        changeTag: function changeTag(tag) {
            var _this = this;

            this.activeTagId = tag.id;
            if (tag.id === -2) {
                (0, _academy.getGoodCoursesList)({ bizlineId: this.bizLineId }).then(function (response) {
                    var data = response && response.data || [];
                    if (data && data.length) {
                        var topAnnounces = data.find(function (announceItem) {
                            return announceItem.id === -2;
                        });
                        if (topAnnounces && (!topAnnounces.announcePublishVOList || !topAnnounces.announcePublishVOList.length)) {
                            _this.tags.splice(0, 1);
                            _this.activeTagId = _this.tags[0].id;
                            _this.loadAnnounces(_this.activeTagId);
                        }
                        _this.goodCourses = data;
                    }
                    _this.isLoading = false;
                }).catch(function () {
                    _this.isLoading = false;
                });
            } else {
                this.loadAnnounces(tag.id);
            }
        },
        loadAnnounces: function loadAnnounces(tagId) {
            var _this2 = this;

            if (!this.isLoading) {
                this.isLoading = true;
            }
            this.announcements.length = 0;
            (0, _academy.getAnnounces)({ bizlineId: this.bizLineId, contentTag: tagId }).then(function (response) {
                if (!response || !response.data) {
                    return;
                }
                _this2.announcements = response.data;
                _this2.isLoading = false;
            }).catch(function (err) {
                _this2.alert(err && err.message || "网络错误");
                _this2.isLoading = false;
            });
        },
        announceClicked: function announceClicked(item) {
            var href = this.$router.resolve({
                name: "announceDetail",
                params: { id: item.id }
            }).href;
            if (href) {
                window.open(href, "_blank");
            }
        },
        handleScroll: function handleScroll(ev) {
            var scrollTop = window.pageXOffset || document.documentElement.scrollTop || document.body.scrollTop;
            var offsetTop = document.querySelector(".tag-list").offsetTop;
            if (scrollTop > offsetTop) {
                this.offsetLeft = document.querySelector(".main-container").offsetLeft + 10;
                this.tagListFixed = true;
            } else {
                this.tagListFixed = false;
            }
        }
    },
    created: function created() {
        var _this3 = this;

        this.bizLineId = this.$route.params.bizLineId || this.$route.meta.bizLineId || 2;
        //获取banner图片列表
        (0, _academy.getBannerImgs)({ bizLineId: this.bizLineId }).then(function (response) {
            if (response && response.data) {
                _this3.imgs = response.data;
            }
        }).catch(function (err) {
            _this3.alert(err && err.message || "网络错误");
        });
        //获取公告标签
        (0, _academy.getTags)({ bizLineId: this.bizLineId }).then(function (response) {
            var tags = response.data;
            if (tags && tags.length) {
                _this3.tags = _this3.tags.concat(tags.map(function (tagItem) {
                    return tagItem;
                }));
            }
            _this3.changeTag(_this3.tags[0]);
        }).catch(function (err) {
            _this3.alert(err && err.message || "网络错误");
            _this3.isLoading = false;
        });
    },
    mounted: function mounted() {
        window.addEventListener("scroll", this.handleScroll);
    },
    destroyed: function destroyed() {
        window.removeEventListener("scroll", this.handleScroll);
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 777 */
/*!*****************************************!*\
  !*** ./src/views/academy/SlideShow.vue ***!
  \*****************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-3d459b78","scoped":true,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SlideShow.vue */ 778)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SlideShow.vue */ 779),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3d459b78","hasScoped":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SlideShow.vue */ 780),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d459b78",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 778 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3d459b78","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/academy/SlideShow.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 779 */
/*!************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/academy/SlideShow.vue ***!
  \************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(/*! babel-runtime/helpers/defineProperty */ 114);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = (0, _defineProperty3.default)({
    props: {
        index: {
            type: Number,
            default: 0
        },
        intervalMS: {
            type: Number,
            default: 3000
        },
        imgs: {
            type: Array,
            validator: function validator(val) {
                if (val && Array.isArray(val)) {
                    return val.find(function (item) {
                        return !item.decorateContent || !item.decorateContent.length;
                    }) ? false : true;
                }
            }
        }
    },
    data: function data() {
        return {
            mark: this.index
        };
    },
    created: function created() {},
    methods: {
        autoPlay: function autoPlay() {
            this.mark++;
            if (this.mark === this.imgs.length) {
                this.mark = 0;
            }
        },
        play: function play() {
            this.timerId = setInterval(this.autoPlay, this.intervalMS);
        },
        change: function change(i) {
            this.mark = i;
        },
        move: function move() {
            this.play();
        },
        stop: function stop() {
            clearInterval(this.timerId);
        },
        imgClicked: function imgClicked() {
            var imgItem = this.imgs[this.mark];
            this.$emit("imgClick", imgItem);
        }
    }
}, "created", function created() {
    this.play();
});

/***/ }),
/* 780 */
/*!***************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d459b78","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/academy/SlideShow.vue ***!
  \***************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slide",
    on: {
      "mouseover": _vm.stop,
      "mouseout": _vm.move
    }
  }, [_c('div', {
    staticClass: "slideshow"
  }, [_c('transition-group', {
    attrs: {
      "tag": "ul",
      "name": "image"
    }
  }, _vm._l((_vm.imgs), function(img, index) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === _vm.mark),
        expression: "index === mark"
      }],
      key: index,
      on: {
        "click": _vm.imgClicked
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      }
    }, [_c('img', {
      attrs: {
        "src": img.decorateContent + '@160h_1020w_2e_90Q'
      }
    })])])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "bar"
  }, _vm._l((_vm.imgs), function(item, index) {
    return _c('span', {
      key: index,
      class: {
        'active': index === _vm.mark
      },
      on: {
        "click": function($event) {
          _vm.change(index)
        }
      }
    })
  }))])
},staticRenderFns: []}

/***/ }),
/* 781 */
/*!********************************************!*\
  !*** ./src/views/academy/Announcement.vue ***!
  \********************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-3cc47541","scoped":true,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Announcement.vue */ 782)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Announcement.vue */ 783),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3cc47541","hasScoped":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Announcement.vue */ 784),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3cc47541",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 782 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3cc47541","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/academy/Announcement.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 783 */
/*!***************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/academy/Announcement.vue ***!
  \***************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//

var propsRequired = ["id", "title", "coverPic"];
exports.default = {
  props: {
    item: {
      type: Object,
      validator: function validator(val) {
        var valid = true;
        propsRequired.forEach(function (prop) {
          if (!valid) {
            return;
          }
          valid = Boolean(val[prop]);
        });
        return valid;
      }
    }
  },
  methods: {
    itemClicked: function itemClicked() {
      this.$emit("itemClicked", this.item);
    }
  }
};

/***/ }),
/* 784 */
/*!******************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cc47541","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/academy/Announcement.vue ***!
  \******************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "academy-course-item",
    on: {
      "click": _vm.itemClicked
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.item.coverPic + '@140h_230w_2e_90Q'
    }
  }), _vm._v(" "), _c('h3', {
    attrs: {
      "title": _vm.item.title
    }
  }, [_vm._v(_vm._s(_vm.item.title))]), _vm._v(" "), _c('h5', {
    attrs: {
      "title": _vm.item.subTitle
    }
  }, [_vm._v(_vm._s(_vm.item.subTitle))])])
},staticRenderFns: []}

/***/ }),
/* 785 */
/*!**************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75887188","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/academy/HomePage.vue ***!
  \**************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "main-container",
    attrs: {
      "element-loading-text": "拼命加载中"
    }
  }, [(_vm.imgs.length) ? _c('SlideShow', {
    attrs: {
      "imgs": _vm.imgs
    },
    on: {
      "imgClick": _vm.bannerImgClicked
    }
  }) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "clearfix tag-list",
    class: {
      "fixed": _vm.tagListFixed
    },
    style: ({
      'padding-left': (_vm.tagListFixed && _vm.offsetLeft ? _vm.offsetLeft : 0) + 'px'
    })
  }, _vm._l((_vm.tags), function(tag) {
    return _c('li', {
      key: tag.id,
      class: {
        'active': tag.id === _vm.activeTagId
      },
      on: {
        "click": function($event) {
          _vm.changeTag(tag)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tag.typeName) + "\n        ")])
  })), _vm._v(" "), (_vm.activeTagId !== -2) ? _c('ul', {
    staticClass: "clearfix announcement-list"
  }, _vm._l((_vm.announcements), function(announcement) {
    return _c('Announcement', {
      key: announcement.id,
      attrs: {
        "item": announcement
      },
      on: {
        "itemClicked": _vm.announceClicked
      }
    })
  })) : _vm._e(), _vm._v(" "), _vm._l((_vm.goodCourses), function(courses) {
    return (_vm.activeTagId === -2 && courses.announcePublishVOList && courses.announcePublishVOList.length) ? _c('section', {
      key: courses.id
    }, [(courses.tagName) ? _c('h3', {
      staticClass: "section-class"
    }, [_c('hr'), _vm._v(" "), _c('span', [_vm._v(_vm._s(courses.tagName))]), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _c('ul', {
      staticClass: "clearfix announcement-list"
    }, _vm._l((courses.announcePublishVOList), function(announcement, index) {
      return (index <= 3) ? _c('Announcement', {
        key: announcement.id,
        attrs: {
          "item": announcement
        },
        on: {
          "itemClicked": _vm.announceClicked
        }
      }) : _vm._e()
    }))]) : _vm._e()
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 786 */
/*!************************************!*\
  !*** ./src/router/router.jijiu.js ***!
  \************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _viewWrapper = __webpack_require__(/*! components/view-wrapper/view-wrapper.vue */ 52);

var _viewWrapper2 = _interopRequireDefault(_viewWrapper);

var _routeBuilder = __webpack_require__(/*! ./routeBuilder */ 66);

var _routeBuilder2 = _interopRequireDefault(_routeBuilder);

var _innerFrame = __webpack_require__(/*! components/inner-frame/inner-frame */ 42);

var _innerFrame2 = _interopRequireDefault(_innerFrame);

var _nhomepage = __webpack_require__(/*! components/nhomepage/nhomepage.vue */ 97);

var _nhomepage2 = _interopRequireDefault(_nhomepage);

var _HomePage = __webpack_require__(/*! views/academy/HomePage.vue */ 67);

var _HomePage2 = _interopRequireDefault(_HomePage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var jiJiuBuilder = new _routeBuilder2.default('jijiu', _viewWrapper2.default, _innerFrame2.default);
var jiJiuRoutes = _routeBuilder2.default.buildBasicInfo(jiJiuBuilder, null, _nhomepage2.default);

var xgxy = _routeBuilder2.default.buildXAXY(jiJiuBuilder, _HomePage2.default);
var gzzx = _routeBuilder2.default.buildGZZX(jiJiuBuilder);
var financeInfo = _routeBuilder2.default.buildFinanceInfo(jiJiuBuilder);

exports.default = jiJiuRoutes.concat([financeInfo, xgxy, gzzx]);

/***/ }),
/* 787 */
/*!**************************************!*\
  !*** ./src/router/router.chepiao.js ***!
  \**************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _viewWrapper = __webpack_require__(/*! components/view-wrapper/view-wrapper.vue */ 52);

var _viewWrapper2 = _interopRequireDefault(_viewWrapper);

var _routeBuilder = __webpack_require__(/*! ./routeBuilder */ 66);

var _routeBuilder2 = _interopRequireDefault(_routeBuilder);

var _innerFrame = __webpack_require__(/*! components/inner-frame/inner-frame */ 42);

var _innerFrame2 = _interopRequireDefault(_innerFrame);

var _nhomepage = __webpack_require__(/*! components/nhomepage/nhomepage.vue */ 97);

var _nhomepage2 = _interopRequireDefault(_nhomepage);

var _HomePage = __webpack_require__(/*! views/academy/HomePage.vue */ 67);

var _HomePage2 = _interopRequireDefault(_HomePage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var chePiaoBuilder = new _routeBuilder2.default('chepiao', _viewWrapper2.default, _innerFrame2.default);
var chePiaoRoutes = _routeBuilder2.default.buildBasicInfo(chePiaoBuilder, null, _nhomepage2.default);
var financeInfo = _routeBuilder2.default.buildFinanceInfo(chePiaoBuilder, true);
chePiaoRoutes.push(financeInfo);

var xgxy = _routeBuilder2.default.buildXAXY(chePiaoBuilder, _HomePage2.default);
var gzzx = _routeBuilder2.default.buildGZZX(chePiaoBuilder);

exports.default = chePiaoRoutes.concat([xgxy, gzzx]);

/***/ }),
/* 788 */
/*!**********************************!*\
  !*** ./src/router/router.gty.js ***!
  \**********************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _viewWrapper = __webpack_require__(/*! components/view-wrapper/view-wrapper.vue */ 52);

var _viewWrapper2 = _interopRequireDefault(_viewWrapper);

var _innerFrame = __webpack_require__(/*! components/inner-frame/inner-frame */ 42);

var _innerFrame2 = _interopRequireDefault(_innerFrame);

var _routeBuilder = __webpack_require__(/*! ./routeBuilder */ 66);

var _routeBuilder2 = _interopRequireDefault(_routeBuilder);

var _env = __webpack_require__(/*! ./../config/env.conf */ 2);

var _Main = __webpack_require__(/*! views/dataPlatform/operateData/Main.vue */ 162);

var _Main2 = _interopRequireDefault(_Main);

var _Main3 = __webpack_require__(/*! views/dataPlatform/productData/Main.vue */ 164);

var _Main4 = _interopRequireDefault(_Main3);

var _Main5 = __webpack_require__(/*! views/dataPlatform/serviceData/Main.vue */ 260);

var _Main6 = _interopRequireDefault(_Main5);

var _Main7 = __webpack_require__(/*! views/comment/list/Main.vue */ 118);

var _Main8 = _interopRequireDefault(_Main7);

var _HomePage = __webpack_require__(/*! views/academy/HomePage.vue */ 67);

var _HomePage2 = _interopRequireDefault(_HomePage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bizLine = 'gty';
var baseUrl = _env.otpHost + '/#/' + bizLine + '/';
var productPrefix = baseUrl + 'product/';
var orderPrefix = baseUrl + 'order/';
var gtyBuiler = new _routeBuilder2.default(bizLine, _viewWrapper2.default, _innerFrame2.default);
var financeInfo = _routeBuilder2.default.buildFinanceInfo(gtyBuiler);
//

var dataSummaryInfo = _routeBuilder2.default.buildDataSummary(gtyBuiler, _Main2.default, _Main4.default, _Main6.default);
var promotionInfo = _routeBuilder2.default.buildPromotionInfo(gtyBuiler);

var reviewList = _routeBuilder2.default.buildReviewList(gtyBuiler, _Main8.default);
var commentDetail = _routeBuilder2.default.buildReviewDetail(gtyBuiler, _Main8.default);
var qaManagement = _routeBuilder2.default.buildQaA(gtyBuiler);

var xgxy = _routeBuilder2.default.buildXAXY(gtyBuiler, _HomePage2.default);
var gzzx = _routeBuilder2.default.buildGZZX(gtyBuiler);

function getBizName(name) {
    return bizLine + name;
}

exports.default = [{
    name: getBizName('home'),
    path: '',
    component: __webpack_require__(/*! components/nhomepage/nhomepage.vue */ 97),
    meta: {
        title: '首页',
        icon: 'turbo-ui-home',
        bizLineId: 3
    }
}, {
    name: getBizName('product'),
    path: 'product',
    component: _innerFrame2.default,
    meta: {
        title: '产品管理',
        icon: 'turbo-ui-setting'
    },
    children: [{
        name: getBizName('productNew'),
        path: 'detail',
        component: _innerFrame2.default,
        meta: {
            title: '添加新产品',
            src: productPrefix + 'item/detail/?tab=0\''
        }
    }, {
        name: getBizName('productList'),
        path: 'list',
        component: _innerFrame2.default,
        meta: {
            title: '产品查询',
            src: productPrefix + 'product-list'
        }
    }, {
        name: getBizName('productOnlineList'),
        path: 'onlineList',
        component: _innerFrame2.default,
        meta: {
            title: '已上线查询',
            src: productPrefix + 'product-online?status=online'
        }
    }, {
        name: getBizName('productReadyList'),
        path: 'readyList',
        component: _innerFrame2.default,
        meta: {
            title: '未上线查询',
            src: productPrefix + 'product-ready?status=ready'
        }
    }, {
        name: getBizName('productOfflineList'),
        path: 'offlineList',
        meta: {
            title: '已下线查询',
            src: productPrefix + 'product-offline?status=offline'
        }
    }, {
        name: getBizName('productCancelList'),
        path: 'cancelList',
        component: _innerFrame2.default,
        meta: {
            title: '取消团期',
            src: productPrefix + 'product-cancel'
        }
    }]
}, {
    name: getBizName('order'),
    path: 'order',
    component: _viewWrapper2.default,
    meta: {
        title: '订单管理',
        icon: 'assignment'
    },
    children: [{
        name: getBizName('orderlist'),
        path: 'list',
        component: _innerFrame2.default,
        meta: {
            title: '订单查询',
            src: orderPrefix + 'gty-list-order'
        }
    }, {
        name: getBizName('orderConfirmList'),
        path: 'confirmlist',
        component: _innerFrame2.default,
        meta: {
            title: '待确认订单',
            src: orderPrefix + 'gty-confirm-order?defaultStatus=1'
        }
    }, {
        name: getBizName('nopayOrderList'),
        path: 'nopayorderlist',
        component: _innerFrame2.default,
        meta: {
            title: '未付款订单',
            src: orderPrefix + 'gty-list-workorder'
        }
    }]
}, financeInfo, dataSummaryInfo, promotionInfo, reviewList, commentDetail, qaManagement, xgxy, gzzx];

/***/ }),
/* 789 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0c34d374","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/serviceData/Main.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 790 */
/*!************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/serviceData/Main.vue ***!
  \************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Title = __webpack_require__(/*! ../components/title/Title.vue */ 163);

var _Title2 = _interopRequireDefault(_Title);

var _KeyIndicators = __webpack_require__(/*! ./components/key-indicators/KeyIndicators.vue */ 791);

var _KeyIndicators2 = _interopRequireDefault(_KeyIndicators);

var _BusinessTrends = __webpack_require__(/*! ./components/business-trends/BusinessTrends.vue */ 795);

var _BusinessTrends2 = _interopRequireDefault(_BusinessTrends);

var _dataPlatform = __webpack_require__(/*! api/dataPlatform */ 19);

var _dataPlatform2 = _interopRequireDefault(_dataPlatform);

var _momentFormat = __webpack_require__(/*! ../filters/moment-format */ 6);

var _momentFormat2 = _interopRequireDefault(_momentFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        TitleComponent: _Title2.default,
        KeyIndicatorsComponent: _KeyIndicators2.default,
        BusinessTrendsComponent: _BusinessTrends2.default
    },
    data: function data() {
        var _this = this;

        var data = {
            title: '服务数据',
            bizCode: null, // 业务线
            startDate: _momentFormat2.default.getYestoday(), // 开始日期，默认昨天
            endDate: _momentFormat2.default.getYestoday(), // 结束日期，默认昨天
            resultData: {}
        };
        switch (this.$route.params.type || this.$route.meta.type) {
            case 'gty':
                data.bizCode = 11021;
                break;
            case 'jiujing':
                data.bizCode = 11022;
                break;
            default:
                window.location.href = '/';
        }
        // 获取初始数据
        _dataPlatform2.default.getOperationData(data.bizCode, data.startDate, data.endDate).then(function (res) {
            console.log(res);
            if (res.status === 0) {
                data.resultData = res.data;
            } else {
                _this.$notify.error({
                    title: '错误',
                    message: res.message || '请求失败'
                });
            }
        }).catch(function (err) {
            console.log(err);
        });
        return data;
    },

    methods: {}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 791 */
/*!****************************************************************************************!*\
  !*** ./src/views/dataPlatform/serviceData/components/key-indicators/KeyIndicators.vue ***!
  \****************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-3355fbd8","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./KeyIndicators.vue */ 792)
}
var Component = __webpack_require__(/*! ../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./KeyIndicators.vue */ 793),
  /* template */
  __webpack_require__(/*! !../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3355fbd8","hasScoped":true}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./KeyIndicators.vue */ 794),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3355fbd8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 792 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3355fbd8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/serviceData/components/key-indicators/KeyIndicators.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 793 */
/*!***********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/serviceData/components/key-indicators/KeyIndicators.vue ***!
  \***********************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _TitleDate = __webpack_require__(/*! ../../../components/title-date/TitleDate.vue */ 10);

var _TitleDate2 = _interopRequireDefault(_TitleDate);

var _IndicatorsData = __webpack_require__(/*! ../../../components/indicators-data/IndicatorsData.vue */ 93);

var _IndicatorsData2 = _interopRequireDefault(_IndicatorsData);

var _Tips = __webpack_require__(/*! ../../../components/tips/Tips.vue */ 53);

var _Tips2 = _interopRequireDefault(_Tips);

var _dataPlatform = __webpack_require__(/*! api/dataPlatform */ 19);

var _dataPlatform2 = _interopRequireDefault(_dataPlatform);

var _momentFormat = __webpack_require__(/*! ../../../filters/moment-format */ 6);

var _momentFormat2 = _interopRequireDefault(_momentFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		TitleDateComponent: _TitleDate2.default,
		IndicatorsDataComponent: _IndicatorsData2.default,
		TipsComponent: _Tips2.default
	},
	data: function data() {
		return {
			titleOption: { // 单元块名称和日期选择配置
				title: '关键指标', // 名称
				dateRadio: true, // 是否显示昨天、本周、本月日期单选框
				dateRangeSelect: false, // 是否显示日期区间下拉框
				download: false // 是否显示下载按钮
			},
			startDate: _momentFormat2.default.getYestoday(), // 开始日期，默认昨天
			endDate: _momentFormat2.default.getYestoday(), // 结束日期，默认昨天
			initDateRange: _momentFormat2.default.getYestoday() + ' ~ ' + _momentFormat2.default.getYestoday(),
			data: this.resultData
		};
	},

	computed: {
		// 单个指标数据
		indicatorsData: function indicatorsData() {
			return {
				pageViews: {
					name: '商家拒单率',
					value: this.data.rejectRate,
					unit: '%',
					compare: this.data.rejectRateChg,
					title: '商家拒单订单数/支付订单数'
				},
				visitors: {
					name: '用户退款率',
					value: this.data.refundRate,
					unit: '%',
					compare: this.data.refundRateChg,
					title: '用户申请退款的订单数/支付订单数'
				}
			};
		},


		// 底部建议
		info: function info() {
			return {
				value: this.data.rejectRateChg,
				title: "您的拒单率与上一周期相比",
				suggest: "提升服务降低拒单率，会对您商品的流量有稳步提升的效果，请重点关注。",
				reverse: true // 表情反向显示
			};
		}
	},
	props: ["resultData", "bizCode"],
	watch: {
		resultData: {
			handler: function handler() {
				this.data = this.resultData;
			},
			deep: true
		}
	},
	methods: {
		getData: function getData() {
			var _this = this;

			_dataPlatform2.default.getOperationData(this.bizCode, this.startDate, this.endDate).then(function (res) {
				console.log(res);
				if (res.status === 0) {
					_this.data = res.data;
				} else {
					_this.data = {};
					_this.$notify.error({
						title: '错误',
						message: res.message || '请求失败'
					});
				}
			}).catch(function (err) {
				_this.data = {};
				console.log(err);
			});
		},


		// 切换日期
		changeDate: function changeDate(params) {
			this.startDate = params.dateRange.startDate;
			this.endDate = params.dateRange.endDate;
			this.getData();
		}
	}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 794 */
/*!**************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3355fbd8","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/serviceData/components/key-indicators/KeyIndicators.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "key-indicators"
  }, [_c('title-date-component', {
    attrs: {
      "titleOption": _vm.titleOption,
      "initDateRange": _vm.initDateRange
    },
    on: {
      "changeDate": _vm.changeDate
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "indicators-data-box"
  }, _vm._l((_vm.indicatorsData), function(item, index) {
    return _c('indicators-data-component', {
      key: index,
      attrs: {
        "data": item
      }
    })
  })), _vm._v(" "), _c('tips-component', {
    attrs: {
      "info": _vm.info
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 795 */
/*!******************************************************************************************!*\
  !*** ./src/views/dataPlatform/serviceData/components/business-trends/BusinessTrends.vue ***!
  \******************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-245f5270","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BusinessTrends.vue */ 796)
}
var Component = __webpack_require__(/*! ../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BusinessTrends.vue */ 797),
  /* template */
  __webpack_require__(/*! !../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-245f5270","hasScoped":true}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BusinessTrends.vue */ 798),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-245f5270",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 796 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-245f5270","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/serviceData/components/business-trends/BusinessTrends.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 797 */
/*!*************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/serviceData/components/business-trends/BusinessTrends.vue ***!
  \*************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
				value: true
});

var _TitleDate = __webpack_require__(/*! ../../../components/title-date/TitleDate.vue */ 10);

var _TitleDate2 = _interopRequireDefault(_TitleDate);

var _Nav = __webpack_require__(/*! ../../../components/nav/Nav.vue */ 37);

var _Nav2 = _interopRequireDefault(_Nav);

var _Line = __webpack_require__(/*! ../../../components/echarts/Line.vue */ 78);

var _Line2 = _interopRequireDefault(_Line);

var _dataPlatform = __webpack_require__(/*! api/dataPlatform */ 19);

var _dataPlatform2 = _interopRequireDefault(_dataPlatform);

var _momentFormat = __webpack_require__(/*! ../../../filters/moment-format */ 6);

var _momentFormat2 = _interopRequireDefault(_momentFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
				components: {
								TitleDateComponent: _TitleDate2.default,
								NavComponent: _Nav2.default,
								LineComponent: _Line2.default
				},
				data: function data() {
								return {
												titleOption: { // 单元块名称和日期选择配置
																title: '服务指标趋势', // 名称
																dateRadio: false, // 是否显示昨天、本周、本月日期单选框
																dateRangeSelect: true, // 是否显示日期区间下拉框
																dateCompareSelect: true,
																download: true, // 是否显示下载按钮
																moduleId: 4,
																bizCode: this.bizCode,
																showDate: {
																				startDate: _momentFormat2.default.getSevenDate(),
																				endDate: _momentFormat2.default.getYestoday()
																}
												},
												type: [{
																name: '商家拒单率',
																value: 'rejectRate'
												}, {
																name: '用户退款数',
																value: 'refundRequestOrderNum'
												}, {
																name: '用户退款率',
																value: 'refundRate'
												}],
												currentType: 'rejectRate',
												startDate: _momentFormat2.default.getSevenDate(), // 开始日期
												endDate: _momentFormat2.default.getYestoday(), // 结束日期
												initDateRange: _momentFormat2.default.getSevenDate() + ' ~ ' + _momentFormat2.default.getYestoday(),
												typeData: {
																allTypeData: {
																				rejectRate: [],
																				refundRequestOrderNum: [],
																				refundRate: []
																},
																allTypeCompareData: { // 所有对比纬度数据
																				rejectRate: [],
																				refundRequestOrderNum: [],
																				refundRate: []
																}
												},
												resultData: {
																dateArr: [],
																dataArr: [],
																dateCompareArr: [], // 对比日期
																dataCompareArr: [], // 对比数据
																currentTypeName: '商家拒单率'
												}
								};
				},

				props: ["bizCode"],
				methods: {
								// 获取服务指标趋势数据
								getServiceTrendData: function getServiceTrendData() {
												var _this = this;

												_dataPlatform2.default.getOperationTrendData(this.bizCode, this.startDate, this.endDate, this.titleOption.moduleId).then(function (res) {
																console.log(res);
																if (res.status === 0) {
																				var data = res.data;
																				var date = [];
																				var initData = {
																								rejectRate: [],
																								refundRequestOrderNum: [],
																								refundRate: []
																				};
																				data.forEach(function (item, index) {
																								date.push(item.date);
																								initData.rejectRate.push(item.rejectRate);
																								initData.refundRequestOrderNum.push(item.refundRequestOrderNum);
																								initData.refundRate.push(item.refundRate);
																				});
																				_this.typeData.allTypeData = initData;
																				_this.$set(_this.resultData, 'dateArr', date);
																				_this.$set(_this.resultData, 'dataArr', _this.typeData.allTypeData[_this.currentType]);
																				console.log(_this.resultData);
																} else {
																				_this.$notify.error({
																								title: '错误',
																								message: res.message || '请求失败'
																				});
																}
												}).catch(function (err) {
																_this.resultData.dateArr = [];
																_this.resultData.dataArr = [];
																console.log(err);
												});
								},


								// 切换类型
								changeNavType: function changeNavType(type) {
												var _this2 = this;

												this.currentType = type;
												var currentTypeName = this.type.find(function (item) {
																return item.value === _this2.currentType;
												});
												this.$set(this.resultData, 'dataArr', this.typeData.allTypeData[this.currentType]);
												this.$set(this.resultData, 'dataCompareArr', this.typeData.allTypeCompareData[this.currentType]);
												this.$set(this.resultData, 'currentTypeName', currentTypeName.name);
								},


								// 切换日期
								changeDate: function changeDate(params) {
												this.startDate = params.dateRange.startDate;
												this.endDate = params.dateRange.endDate;
												this.getServiceTrendData();
								},


								// 切换对比日期
								changeCompareDate: function changeCompareDate(params) {
												var _this3 = this;

												if (params.dateRange.startDate === '' || params.dateRange.endDate === '') {
																this.resultData.dateCompareArr = [];
																this.resultData.dataCompareArr = [];
																return;
												}
												_dataPlatform2.default.getOperationTrendData(this.bizCode, params.dateRange.startDate, params.dateRange.endDate, this.titleOption.moduleId).then(function (res) {
																console.log(res);
																if (res.status === 0) {
																				var data = res.data;
																				var date = [];
																				var initData = {
																								rejectRate: [],
																								refundRequestOrderNum: [],
																								refundRate: []
																				};
																				data.forEach(function (item, index) {
																								date.push(item.date);
																								initData.rejectRate.push(item.rejectRate);
																								initData.refundRequestOrderNum.push(item.refundRequestOrderNum);
																								initData.refundRate.push(item.refundRate);
																				});
																				_this3.typeData.allTypeCompareData = initData;
																				_this3.$set(_this3.resultData, 'dateCompareArr', date);
																				_this3.$set(_this3.resultData, 'dataCompareArr', _this3.typeData.allTypeCompareData[_this3.currentType]);
																} else {
																				_this3.$notify.error({
																								title: '错误',
																								message: res.message || '请求失败'
																				});
																}
												}).catch(function (err) {
																_this3.resultData.dateCompareArr = [];
																_this3.resultData.dataCompareArr = [];
																console.log(err);
												});
								}
				},
				mounted: function mounted() {
								this.getServiceTrendData();
				}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 798 */
/*!****************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-245f5270","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/serviceData/components/business-trends/BusinessTrends.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "business-trends"
  }, [_c('title-date-component', {
    attrs: {
      "titleOption": _vm.titleOption,
      "initDateRange": _vm.initDateRange
    },
    on: {
      "changeDate": _vm.changeDate,
      "changeCompareDate": _vm.changeCompareDate
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "data-box"
  }, [_c('nav-component', {
    attrs: {
      "type": _vm.type,
      "currentType": _vm.currentType
    },
    on: {
      "changeNavType": _vm.changeNavType
    }
  }), _vm._v(" "), _c('line-component', {
    staticStyle: {
      "width": "95%",
      "height": "320px",
      "margin-top": "50px"
    },
    attrs: {
      "resultData": _vm.resultData
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 799 */
/*!***************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c34d374","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/serviceData/Main.vue ***!
  \***************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('title-component', {
    attrs: {
      "title": _vm.title
    }
  }), _vm._v(" "), _c('key-indicators-component', {
    attrs: {
      "resultData": _vm.resultData,
      "bizCode": _vm.bizCode
    }
  }), _vm._v(" "), _c('business-trends-component', {
    attrs: {
      "bizCode": _vm.bizCode
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 800 */
/*!***************************************!*\
  !*** ./src/router/router.ticketng.js ***!
  \***************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _env = __webpack_require__(/*! ./../config/env.conf */ 2);

var _viewWrapper = __webpack_require__(/*! components/view-wrapper/view-wrapper.vue */ 52);

var _viewWrapper2 = _interopRequireDefault(_viewWrapper);

var _innerFrame = __webpack_require__(/*! components/inner-frame/inner-frame */ 42);

var _innerFrame2 = _interopRequireDefault(_innerFrame);

var _routeBuilder = __webpack_require__(/*! ./routeBuilder */ 66);

var _routeBuilder2 = _interopRequireDefault(_routeBuilder);

var _Main = __webpack_require__(/*! views/comment/list/Main.vue */ 118);

var _Main2 = _interopRequireDefault(_Main);

var _HomePage = __webpack_require__(/*! views/academy/HomePage.vue */ 67);

var _HomePage2 = _interopRequireDefault(_HomePage);

var _routerHelper = __webpack_require__(/*! ./routerHelper */ 246);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bizLine = 'ticket';
var baseUrl = _env.otpHost + '/#/' + bizLine + '/';
var bizVerifyPrefix = baseUrl + 'voucher/';
var productPrefix = baseUrl + 'product/';
var orderPrefix = baseUrl + 'order/';
var promotionPrefix = baseUrl + 'promotion/';
var mscBase = _env.mscHost + '//msc/fe/index.html#/';

var ticketBuiler = new _routeBuilder2.default(bizLine, _viewWrapper2.default, _innerFrame2.default);
var comment = _routeBuilder2.default.buildReviewList(ticketBuiler, _Main2.default);
var commentDetail = _routeBuilder2.default.buildReviewDetail(ticketBuiler, _Main2.default);

var xgxy = _routeBuilder2.default.buildXAXY(ticketBuiler, _HomePage2.default);
var gzzx = _routeBuilder2.default.buildGZZX(ticketBuiler);


function getBizName(name) {
    return bizLine + name;
}

exports.default = [{
    name: getBizName('home'),
    path: '',
    component: __webpack_require__(/*! views/homepage/homepage.vue */ 801),
    meta: {
        title: '首页',
        icon: 'turbo-ui-home'
    }
}, {
    name: getBizName('voucher'),
    path: 'voucher',
    component: _viewWrapper2.default,
    children: [{
        name: getBizName('voucherVerify'),
        path: 'verify',
        component: _innerFrame2.default,
        meta: {
            src: bizVerifyPrefix + 'verify',
            title: '验券'
        }
    }, {
        name: getBizName('voucherRevert'),
        path: 'revert',
        component: _innerFrame2.default,
        meta: {
            src: bizVerifyPrefix + 'revert',
            title: '撤销验券'
        }
    }, {
        name: getBizName('voucherHistory'),
        path: 'history',
        component: __webpack_require__(/*! views/ticket/verify/history/Main.vue */ 241),
        redirect: { name: getBizName('singleProgram') },
        meta: {
            title: '验券历史'
        },
        children: [{
            name: getBizName('singleProgram'),
            path: 'singleProgram',
            component: __webpack_require__(/*! views/ticket/verify/history/pages/singleProgramConsumption.vue */ 242),
            meta: {
                noAuth: true,
                activeName: getBizName('voucherHistory')
            }
        }, {
            name: getBizName('allProgram'),
            path: 'allProgram',
            component: __webpack_require__(/*! views/ticket/verify/history/pages/allProgramConsumption.vue */ 243),
            meta: {
                noAuth: true,
                activeName: getBizName('voucherHistory')
            }
        }, {
            name: getBizName('detailProgram'),
            path: 'detail/:dealName/:dealId/:useTimeStart',
            component: __webpack_require__(/*! views/ticket/verify/history/pages/detailConsumption.vue */ 814),
            meta: {
                notMenu: true,
                noAuth: true
            }
        }]
    }, {
        name: getBizName('voucherPhone'),
        path: 'phone',
        redirect: { name: getBizName('app') },
        meta: {
            title: '手机验券'
        },
        component: __webpack_require__(/*! views/ticket/verify/phone/Main.vue */ 238),
        children: [{
            name: getBizName('phone'),
            path: 'phone',
            component: __webpack_require__(/*! views/ticket/verify/phone/pages/phoneVerify.vue */ 239),
            meta: {
                noAuth: true,
                notMenu: true,
                activeName: getBizName('voucherPhone')
            }
        }, {
            name: getBizName('app'),
            path: 'app',
            component: __webpack_require__(/*! views/ticket/verify/phone/pages/appVerify.vue */ 240),
            meta: {
                noAuth: true,
                notMenu: true,
                activeName: getBizName('voucherPhone')
            }
        }]
    }],
    meta: {
        title: '验券管理',
        icon: 'turbo-ui-ticket'
    }
}, {
    name: getBizName('product'),
    path: 'product',
    component: _viewWrapper2.default,
    children: [{
        name: getBizName('newProduct'),
        path: 'new',
        component: _innerFrame2.default,
        meta: {
            title: '新建产品',
            src: productPrefix + 'new'
        }
    }, {
        name: getBizName('listProduct'),
        path: 'list',
        component: _innerFrame2.default,
        meta: {
            title: '产品列表',
            src: productPrefix + 'list?third=1'
        }
    }, {
        name: getBizName('directProduct'),
        path: 'direct',
        component: _innerFrame2.default,
        meta: {
            title: '直连产品锁定',
            src: productPrefix + 'direct'
        }
    }, {
        name: getBizName('listCertificate'),
        path: 'list-certificate',
        component: _innerFrame2.default,
        meta: {
            title: '授权书管理',
            src: productPrefix + 'list-certificate'
        }
    }, {
        name: getBizName('directSignTicketProductList'),
        path: 'direct-list',
        component: _innerFrame2.default,
        meta: {
            title: '产品列表',
            src: productPrefix + 'direct-list'
        }
    }, {
        name: getBizName('directSignTicketNewProduct'),
        path: 'direct-new-product',
        component: _innerFrame2.default,
        meta: {
            title: '添加新产品',
            src: productPrefix + 'direct-new-product'
        }
    }, {
        name: getBizName('directSignTicketNewPull'),
        path: 'direct-new-pull',
        component: _innerFrame2.default,
        meta: {
            title: '拉取新产品',
            src: productPrefix + 'direct-new-pull'
        }
    }, {
        name: getBizName('misCreateTicket'),
        path: '/mis/ticket/product/item/:id?',
        redirect: { name: 'misCreateTicket' },
        meta: {
            notMenu: false
        }
    }, {
        name: getBizName('bizCreateTicket'),
        path: 'item/:id?',
        redirect: { name: 'bizCreateTicket' },
        meta: {
            notMenu: false
        }
    }],
    meta: {
        title: '产品管理',
        icon: 'turbo-ui-setting'
    }
}, {
    name: getBizName('order'),
    path: 'order',
    component: _viewWrapper2.default,
    children: [{
        name: getBizName('ticketOrderList'),
        path: 'ticket',
        component: _innerFrame2.default,
        meta: {
            title: '订单列表',
            src: orderPrefix + 'ticket'
        }
    }, {
        name: getBizName('ticketOrderReserve'),
        path: 'reserve-ticket',
        component: _innerFrame2.default,
        meta: {
            title: '待出票订单',
            src: orderPrefix + 'reserve-ticket'
        }
    }, {
        name: getBizName('OrderRefund'),
        path: 'refund-ticket',
        component: _innerFrame2.default,
        meta: {
            title: '申诉退款订单',
            src: orderPrefix + 'refund-ticket'
        }
    }],
    meta: {
        title: '订单管理',
        icon: 'assignment'
    }
}, {
    name: getBizName('finance'),
    path: 'finance',
    component: _viewWrapper2.default,
    children: [{
        name: getBizName('financeaytrace'),
        path: 'paytrace',
        component: _innerFrame2.default,
        meta: {
            title: '查看对账单',
            src: (0, _routerHelper.getMscSrc)(mscBase + 'statement/travel/'),
            withPadding: true
        }
    }, {
        name: getBizName('financeStatement'),
        path: 'statement',
        component: _innerFrame2.default,
        meta: {
            title: '付款记录',
            src: (0, _routerHelper.getMscSrc)(mscBase + 'paytrace/travel/tickets'),
            withPadding: true
        }
    }, {
        name: getBizName('financePre'),
        path: 'pre',
        component: _innerFrame2.default,
        meta: {
            title: '预付款结算',
            src: (0, _routerHelper.getMscSrc)(mscBase + 'statement/ap-travel/tickets'),
            withPadding: true
        }
    }, {
        name: getBizName('invoiceManage'),
        path: 'invoice',
        component: _innerFrame2.default,
        meta: {
            title: '发票管理',
            src: (0, _routerHelper.getMscSrc)(_env.mscHost + '/msc/biz/travel/invoice/queryPartnerInvoiceModel?buzParty=TRAVEL&bizline=tickets&sellType=tickets'),
            withPadding: true
        }
    }, {
        name: getBizName('invoiceAnswer'),
        path: 'answer',
        component: _innerFrame2.default,
        meta: {
            title: '财务问答',
            src: (0, _routerHelper.getMscSrc)(mscBase + 'question/travel/'),
            withPadding: true
        }
    }],
    meta: {
        title: '财务管理',
        icon: 'turbo-ui-money'
    }
}, {
    name: getBizName('reporter'),
    path: 'reporter',
    component: _viewWrapper2.default,
    children: [{
        name: getBizName('reporterIndexData'),
        path: 'indexData',
        component: __webpack_require__(/*! views/dataPlatform/menpiao/indexData/Main.vue */ 818),
        meta: {
            title: '数据概览'
        }
    }, {
        name: getBizName('reporterOperations'),
        path: 'operations',
        component: __webpack_require__(/*! views/dataPlatform/menpiao/operateData/Main.vue */ 833),
        meta: {
            title: '经营分析'
        }
    }, {
        name: getBizName('reporterProjects'),
        path: 'projects',
        component: __webpack_require__(/*! views/dataPlatform/menpiao/productData/Main.vue */ 837),
        meta: {
            title: '商品分析'
        }
    }, {
        name: getBizName('reporterTransactionData'),
        path: 'transaction',
        component: __webpack_require__(/*! views/dataPlatform/menpiao/transactionData/Main.vue */ 861),
        meta: {
            title: '交易分析'
        }
    }, {
        name: getBizName('customeResource'),
        path: 'customerResource',
        component: __webpack_require__(/*! views/newGtyDataCenter/customerSourceAnalyse.vue */ 261),
        meta: {
            title: '景区客源分析',
            type: bizLine
        }
    }, {
        name: getBizName('reporterReserveTicket'),
        path: 'operations',
        component: __webpack_require__(/*! views/dataCenter/operationData.vue */ 244),
        meta: {
            title: '预约券量',
            type: bizLine
        }
    }],
    meta: {
        title: '数据分析',
        icon: 'turbo-ui-bargraph'
    }
}, {
    name: getBizName('promotion'),
    path: 'promotion',
    component: _viewWrapper2.default,
    children: [{
        name: getBizName('flowInvestList'),
        path: 'flow-invest-list',
        component: _innerFrame2.default,
        meta: {
            title: '流量招商活动',
            src: promotionPrefix + 'flow-invest-list'
        }
    }, {
        name: getBizName('selfPromotionDealList'),
        path: 'deal-list',
        component: _innerFrame2.default,
        meta: {
            title: '自助活动创建',
            src: promotionPrefix + 'deal-list'
        }
    }, {
        name: getBizName('selfPromotionList'),
        path: 'self-promotion-list',
        component: _innerFrame2.default,
        meta: {
            title: '自助活动查询',
            src: promotionPrefix + 'self-promotion-list'
        }
    }],
    meta: {
        title: '营销中心',
        icon: 'turbo-ui-fire'
    }
}, comment, commentDetail, xgxy, gzzx];

/***/ }),
/* 801 */
/*!*****************************************!*\
  !*** ./src/views/homepage/homepage.vue ***!
  \*****************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-63d15468","scoped":false,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./homepage.vue */ 802)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./homepage.vue */ 803),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-63d15468","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./homepage.vue */ 813),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 802 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-63d15468","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/homepage/homepage.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 803 */
/*!************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/homepage/homepage.vue ***!
  \************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Card = __webpack_require__(/*! components/homepage/Card.vue */ 166);

var _Card2 = _interopRequireDefault(_Card);

var _dataItem = __webpack_require__(/*! components/homepage/dataItem.vue */ 804);

var _dataItem2 = _interopRequireDefault(_dataItem);

var _serviceItem = __webpack_require__(/*! components/homepage/serviceItem.vue */ 249);

var _serviceItem2 = _interopRequireDefault(_serviceItem);

var _ActiveItem = __webpack_require__(/*! components/homepage/ActiveItem.vue */ 250);

var _ActiveItem2 = _interopRequireDefault(_ActiveItem);

var _noticeItem = __webpack_require__(/*! components/homepage/noticeItem.vue */ 252);

var _noticeItem2 = _interopRequireDefault(_noticeItem);

var _CourseItem = __webpack_require__(/*! components/homepage/CourseItem.vue */ 253);

var _CourseItem2 = _interopRequireDefault(_CourseItem);

var _Footer = __webpack_require__(/*! components/homepage/Footer.vue */ 254);

var _Footer2 = _interopRequireDefault(_Footer);

var _MidNotices = __webpack_require__(/*! components/homepage/MidNotices */ 258);

var _MidNotices2 = _interopRequireDefault(_MidNotices);

var _momentFormat = __webpack_require__(/*! views/dataPlatform/filters/moment-format */ 6);

var _momentFormat2 = _interopRequireDefault(_momentFormat);

var _menpiaoDataPlatform = __webpack_require__(/*! api/menpiaoDataPlatform */ 34);

var _menpiaoDataPlatform2 = _interopRequireDefault(_menpiaoDataPlatform);

var _dataCenter = __webpack_require__(/*! api/dataCenter.js */ 161);

var _env = __webpack_require__(/*! config/env.conf */ 2);

var _ticket = __webpack_require__(/*! api/ticket */ 50);

var _notices = __webpack_require__(/*! utils/notices */ 51);

var _notices2 = __webpack_require__(/*! components/homepage/notices.vue */ 251);

var _notices3 = _interopRequireDefault(_notices2);

var _vuex = __webpack_require__(/*! vuex */ 14);

var _BannerTexts = __webpack_require__(/*! components/homepage/BannerTexts */ 255);

var _BannerTexts2 = _interopRequireDefault(_BannerTexts);

var _BannerImages = __webpack_require__(/*! components/homepage/BannerImages */ 256);

var _BannerImages2 = _interopRequireDefault(_BannerImages);

var _TopNotice = __webpack_require__(/*! components/homepage/TopNotice */ 257);

var _TopNotice2 = _interopRequireDefault(_TopNotice);

var _CodeDetail = __webpack_require__(/*! components/homepage/CodeDetail */ 808);

var _CodeDetail2 = _interopRequireDefault(_CodeDetail);

var _falconReport = __webpack_require__(/*! utils/falconReport */ 812);

var _vue = __webpack_require__(/*! vue */ 30);

var _vue2 = _interopRequireDefault(_vue);

var _moment = __webpack_require__(/*! moment */ 32);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

_vue2.default.component("CodeDetailDialog", _CodeDetail2.default);

var yestodayStr = _momentFormat2.default.getYestoday();
var salePlatform = 0;
var fixedNum = 2;
var bgIndexMap = { 0: "first", 1: "second" };
var bizLineId = 2;
var tomorrowStr = (0, _moment2.default)().add(_moment2.default.duration(1, "d")).format("MM-DD");
var afterTomorrowStr = (0, _moment2.default)().add(_moment2.default.duration(2, "d")).format("MM-DD");
var noNumReg = /[^\d]*/g;
var dataMap = {
    name: "取票人",
    mobile: "手机",
    credentials: "身份证",
    email: "邮箱",
    pinyin: "拼音"
};
var defaultCodeItem = { dealInfo: {}, orderInfo: {}, voucherInfo: {} };
var bizLinePrefix = "ticket";

exports.default = {
    data: function data() {
        return {
            bizLineId: bizLineId,
            code: "",
            bannerTextIndex: null,
            yesterdayDatas: [{
                name: "销售额",
                value: null,
                unit: "元",
                compareValue: null
            }, {
                name: "销售量",
                value: null,
                unit: "件",
                compareValue: null
            }, {
                name: "访购率",
                value: null,
                unit: "%",
                compareValue: null
            }],
            orderTicketsData: [{
                name: "明天",
                extra: tomorrowStr,
                value: null
            }, {
                name: "后天",
                extra: afterTomorrowStr,
                value: null
            }, {
                name: "未来七天",
                value: null
            }, {
                name: "未来三十天",
                value: null
            }, {
                name: "有效期内未消费券数",
                value: null
            }],
            serviceItems: [{
                id: 1,
                icon: "zicu",
                name: "商家自促",
                desc: "精准投放，稳定拉新",
                to: "ticketselfPromotionDealList"
            }, {
                id: 2,
                icon: "app",
                name: "手机App",
                desc: "快捷便携，及时处理",
                url: "//sj.qq.com/myapp/detail.htm?apkName=com.meituan.tripBizApp"
            }, {
                id: 3,
                icon: "comment",
                name: "评论管理",
                desc: "维护客情，提升服务",
                to: "ticketreviewlist"
            }, {
                id: 4,
                icon: "datacenter",
                name: "数据分析",
                desc: "指标监控，销量提升",
                to: "ticketreporterIndexData"
            }],
            activeItems: [],
            notices: [],
            rules: [],
            courses: [],
            bannerTexts: [],
            bannerImgs: [],
            topNotices: [],
            midNotices: [],
            codeItem: { dealInfo: {}, orderInfo: {}, voucherInfo: {} },
            codeCount: null,
            dataMap: dataMap,
            isCodeRequesting: false,
            showCodeDetail: false,
            showCodeResult: false
        };
    },
    components: {
        HomePageCard: _Card2.default,
        DataItem: _dataItem2.default,
        ServiceItem: _serviceItem2.default,
        ActiveItem: _ActiveItem2.default,
        NoticeItem: _noticeItem2.default,
        CourseItem: _CourseItem2.default,
        HomePageFooter: _Footer2.default,
        Notices: _notices3.default,
        BannerTexts: _BannerTexts2.default,
        BannerImages: _BannerImages2.default,
        TopNotice: _TopNotice2.default,
        MidNotice: _MidNotices2.default
    },
    computed: {
        totalPrice: function totalPrice() {
            if (this.codeCount && this.codeItem && this.codeItem.orderInfo && this.codeItem.orderInfo.price) {
                var price = Number.parseFloat(this.codeItem.orderInfo.price * this.codeCount);
                if (price) {
                    return price.toFixed(2);
                }
            }
            return 0;
        }
    },
    mounted: function mounted() {
        this.codeInput = document.querySelector("#ticketHomeVoucherCodeInput");
    },
    created: function created() {
        var _this = this;

        this.getYestodayData();
        this.getReserveData();
        this.getSignUpActivities();
        this.getNotices();
        this.getUser().then(function (bizUser) {
            if (bizUser && bizUser.directSign === 1) {
                var dcServiceItem = _this.serviceItems.find(function (serviceItem) {
                    return serviceItem.id === 4;
                });
                dcServiceItem.name = "客源分析";
                dcServiceItem.desc = "地域分布，精准掌握";
                dcServiceItem.to = "ticketcustomeResource";
            }
        });
    },

    methods: Object.assign({
        moreYesterdayData: function moreYesterdayData() {
            this.$router.push({ name: bizLinePrefix + "reporterIndexData" });
        },
        codeChanged: function codeChanged(ev) {
            var _this2 = this;

            var noNumReg = /[^\d]*/g;
            var couponCode = this.code;
            if (couponCode) {
                couponCode = couponCode.replace(noNumReg, "").replace(/([\d]{4})/g, "$1 ").trim();
                this.$nextTick(function () {
                    _this2.code = couponCode;
                    if (_this2.code && _this2.code.length === 14) {
                        _this2.verify();
                    }
                });
            }
        },
        verify: function verify() {
            var _this3 = this;

            var couponCode = this.code;
            if (couponCode) {
                couponCode = this.code.replace(noNumReg, "");
                if (couponCode && couponCode.length === 12) {
                    var codePrefix = couponCode.slice(0, 2);
                    if ((Number.parseInt(codePrefix) > 31 || codePrefix === "00") && codePrefix !== "88") {
                        this.$Message.error({
                            content: "请核对是否正确的输入了12位券码。提示:订单号不能用于验证"
                        });
                    } else {
                        this.isCodeRequesting = true;
                        (0, _ticket.codeDetail)(couponCode).then(function (response) {
                            if (response && response.status === 0 && response.data) {
                                _this3.codeItem = response.data;
                                _this3.showCodeDetail = true;
                                _this3.codeCount = null;
                                _this3.codeItem.mainOrderInfo = {};
                                _this3.formatCodeItem(_this3.codeItem);
                                if (_this3.codeItem.orderInfo.orderSource === 4) {
                                    (0, _ticket.getMainOrderInfo)({
                                        subOrderType: 2,
                                        subOrderNo: _this3.codeItem.orderInfo.orderId
                                    }).then(function (response) {
                                        var data = response && response.data;
                                        _this3.codeItem.mainOrderInfo = data.mainOrderInfo;
                                    }).catch(function (err) {
                                        var msg = err && err.message || "获取订单信息出错";
                                        _this3.$Message.error({ content: msg });
                                    });
                                }
                            }
                            _this3.isCodeRequesting = false;
                        }).catch(function (data) {
                            if (data && data.status === 31) {
                                _this3.$Modal.confirm({
                                    title: "验证团购券",
                                    okText: "去验证",
                                    cancelText: "关闭",
                                    onOK: function onOK() {
                                        window.open("//e.meituan.com/#http://common.e.meituan.com/coupon/", "_blank");
                                    }
                                });
                            } else {
                                var msg = data && data.message || "服务器错误，请重试";
                                _this3.$Message.error({ content: msg });
                                (0, _falconReport.falconReport)({
                                    metric: "otp.ticket.ticketVerify.fail",
                                    tags: "failMsg=\u9A8C\u5238\u5931\u8D25" + (data.message ? "" : ",alertMsg=null") + ",status=" + data.status,
                                    statusIgnored: [4]
                                });
                            }
                            _this3.isCodeRequesting = false;
                        });
                    }
                } else {
                    this.$Message.error("有效的美团券为12位数字");
                }
            } else {
                this.$Message.error("请输入美团券");
            }
        },
        revokeVerify: function revokeVerify() {
            this.$router.push({ name: "ticketvoucherRevert" });
        },
        verifyHistory: function verifyHistory() {
            this.$router.push({ name: "ticketvoucherHistory" });
        }
    }, (0, _vuex.mapActions)(["getUser"]), {
        getNotices: function getNotices() {
            var _this4 = this;

            (0, _ticket.getAnnounces)(bizLineId).then(function (notices) {
                if (notices) {
                    if (notices.notices) {
                        _this4.notices = notices.notices;
                    }
                    if (notices.rules) {
                        _this4.rules = notices.rules;
                    }
                    if (notices.midDialogDecorateList) {
                        _this4.midNotices = notices.midDialogDecorateList;
                    }
                    if (notices.courses) {
                        _this4.courses = notices.courses;
                    }
                    if (notices.bannerTexts) {
                        _this4.bannerTexts = notices.bannerTexts;
                    }
                    if (notices.bannerImages) {
                        _this4.bannerImgs = notices.bannerImages;
                    }
                    if (notices.topNotices) {
                        _this4.topNotices = notices.topNotices;
                    }
                }
            }).catch(function (err) {
                var msg = err && err.data && err.data.message || "获取公告出错";
                _this4.error(msg);
            });
        },
        getSignUpActivities: function getSignUpActivities() {
            var _this5 = this;

            (0, _ticket.getSignUpActivities)(2, 2).then(function (activities) {
                _this5.activeItems = activities.map(function (activity, index) {
                    return {
                        id: activity.slotId,
                        name: activity.topActivityName + " " + slotName,
                        date: activity.startTime.substr(0, 10),
                        bg: bgIndexMap[index]
                    };
                });
            }).catch(function (err) {
                var errMsg = err && err.data && err.data.message || "网络错误";
                _this5.error(errMsg);
            });
        },
        getYestodayData: function getYestodayData() {
            var _this6 = this;

            this.isLoadingYestodayData = true;
            _menpiaoDataPlatform2.default.getIndexData(salePlatform, yestodayStr, yestodayStr, false).then(function (res) {
                if (res.status === 0) {
                    var sum = res.data && res.data.sum || null;
                    if (sum) {
                        var payAmount = sum.payAmount;
                        var payAmountPercent = _this6.getPercentNum(sum.payAmountPercent);
                        var payQuantity = sum.payQuantity;
                        var payQuantityPercent = _this6.getPercentNum(sum.payQuantityPercent);
                        var visitPurchaseRate = _this6.getPercentNum(sum.visitPurchaseRate);
                        var visitPurchaseRatePercent = _this6.getPercentNum(sum.visitPurchaseRatePercent);
                        _this6.yesterdayDatas.forEach(function (yesDataItem) {
                            switch (yesDataItem.name) {
                                case "销售额":
                                    yesDataItem.value = payAmount;
                                    yesDataItem.compareValue = payAmountPercent;
                                    break;
                                case "销售量":
                                    yesDataItem.value = payQuantity;
                                    yesDataItem.compareValue = payQuantityPercent;
                                    break;
                                case "访购率":
                                    yesDataItem.value = visitPurchaseRate;
                                    yesDataItem.compareValue = visitPurchaseRatePercent;
                                    break;
                                default:
                            }
                        });
                    }
                }
                _this6.isLoadingYestodayData = false;
            }).catch(function (err) {
                var msg = err && err.data && err.data.message || "请求昨日数据失败";
                _this6.error(msg);
                _this6.isLoadingYestodayData = false;
            });
        },
        getReserveData: function getReserveData() {
            var _this7 = this;

            (0, _dataCenter.getReserveData)().then(function (response) {
                if (response && response.data) {
                    var dayNumber = response.data;
                    _this7.orderTicketsData.forEach(function (orderTicketItem) {
                        switch (orderTicketItem.name) {
                            case "明天":
                                orderTicketItem.value = dayNumber.tomorrow || 0;
                                break;
                            case "后天":
                                orderTicketItem.value = dayNumber.afterTomorrow || 0;
                                break;
                            case "未来七天":
                                orderTicketItem.value = dayNumber.week || 0;
                                break;
                            case "有效期内未消费券数":
                                orderTicketItem.value = dayNumber.total || 0;
                                break;
                            case "未来三十天":
                                orderTicketItem.value = dayNumber.month || 0;
                                break;
                            default:
                                break;
                        }
                    });
                }
            }).catch(function (err) {
                console.log(err);
                var msg = err && err.data && err.data.message || "请求预约票量失败";
                console.error(msg);
            });
        },
        error: function error(msg) {
            this.$Notice.error({
                title: msg,
                message: null
            });
        },
        getPercentNum: function getPercentNum(num) {
            return Number.parseFloat(num) ? (Number.parseFloat(num) * 100).toFixed(fixedNum) : null;
        },
        servicItemClicked: function servicItemClicked(item) {
            if (item.to) {
                this.$router.push({ name: item.to });
                return;
            }
            if (item.url) {
                window.open(item.url, "_blank");
            }
        },
        navToDataSummary: function navToDataSummary() {
            this.$router.push({ name: "ticketreporterIndexData" });
        },
        createSelfPro: function createSelfPro() {
            this.$router.push({ name: "ticketselfPromotionDealList" });
        },
        openCourseDetail: function openCourseDetail(id) {
            window.open((0, _notices.getNoticeDetailUrl)(id), "_blank");
        },
        activityItemClicked: function activityItemClicked(id) {
            alert(id);
        },
        moreNotices: function moreNotices(type) {
            switch (type) {
                case 5:
                    this.$router.push({ name: "ticketacademy" });
                    break;
                case 10:
                    this.$router.push({ name: "ticketpolicyrule" });
                    break;
                case 3:
                    this.$router.push({ name: "broadcastticket" });
                    break;
                default:
                    break;
            }
        },
        codeFormated: function codeFormated(codeItem) {
            if (codeItem && codeItem.voucherInfo && codeItem.voucherInfo.voucherCode) {
                var codeFormatReg = /([\d]{4})/g;
                return codeItem.voucherInfo.voucherCode.replace(codeFormatReg, "$1 ");
            }
        },
        openOrderDetail: function openOrderDetail(orderId) {
            window.open((_env.otpHost + ("/#/ticket/order/ticket/detail?id=" + orderId)).replace(".html/", ".html"), "_blank");
        },
        verifyCode: function verifyCode(_force) {
            var _this8 = this;

            if (this.codeItem && this.codeItem.voucherInfo && this.codeItem.voucherInfo.voucherCode) {
                var voucherCode = this.codeItem.voucherInfo.voucherCode;
                var verifyCount = this.codeCount;
                if (voucherCode && verifyCount) {
                    (0, _ticket.verify)({
                        voucherCode: voucherCode,
                        verifyCount: verifyCount,
                        manualConfirm: Boolean(_force)
                    }).then(function (response) {
                        var data = response && response.data;
                        if (data.needConfirm) {
                            _this8.$Modal.confirm({
                                title: "确定验证",
                                content: data.message,
                                okText: "确定验证",
                                cancelText: "放弃验证",
                                onOk: function onOk() {
                                    _this8.verifyCode(true);
                                }
                            });
                        } else {
                            _this8.showCodeResult = true;
                        }
                    }).catch(function (err) {
                        var msg = err && err.message || "验券错误";
                        _this8.$Message.error({ content: msg });
                    });
                } else {
                    this.$Message.error("请选择验证张数");
                }
            }
        },
        closeVerifyResult: function closeVerifyResult() {
            this.showCodeResult = false;
            this.codeItem = defaultCodeItem;
            this.code = "";
            this.showCodeDetail = false;
            this.codeCount = null;
        },
        formatCodeItem: function formatCodeItem(couponInfo) {
            if (couponInfo && couponInfo.voucherInfo && couponInfo.voucherInfo.credentials && couponInfo.voucherInfo.credentials.length) {
                couponInfo.voucherInfo.credentials.forEach(function (item, index) {
                    var results = [];
                    if (item.bookInfo && item.bookInfo.length) {
                        item.bookInfo.forEach(function (bookItem, bookIndex) {
                            if (bookItem.dataStrMap) {
                                bookItem.labelName = couponInfo.credentialsType[Object.keys(bookItem.dataStrMap)[0]];
                                bookItem.labelValue = Object.values(bookItem.dataStrMap)[0];
                            } else {
                                bookItem.labelName = dataMap[bookItem.key];
                                bookItem.labelValue = bookItem.dataStr;
                            }
                            results.push(bookItem.labelName + "\uFF1A" + bookItem.labelValue);
                        });
                    }
                    item.credentialsAllInfo = results.join(" ");
                });
            }
        }
    })
};

/***/ }),
/* 804 */
/*!**********************************************!*\
  !*** ./src/components/homepage/dataItem.vue ***!
  \**********************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-3eb6c83b","scoped":false,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./dataItem.vue */ 805)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./dataItem.vue */ 806),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3eb6c83b","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./dataItem.vue */ 807),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 805 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3eb6c83b","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/homepage/dataItem.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 806 */
/*!*****************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/dataItem.vue ***!
  \*****************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var defaultCompareValue = "--";
exports.default = {
    props: {
        name: {
            type: String,
            required: true
        },
        value: {
            type: Number | String,
            default: 0
        },
        valueUnit: {
            type: String,
            required: true
        },
        compareName: {
            type: String,
            default: "较上周同期"
        },
        compareValue: {
            type: String,
            default: ""
        },
        hasCompareValue: {
            type: Boolean,
            default: false
        },
        extra: {
            type: String,
            default: ""
        }
    },
    data: function data() {
        return {
            defaultCompareValue: defaultCompareValue
        };
    },
    computed: {
        isLower: function isLower() {
            if (this.compareValue && this.compareValue !== defaultCompareValue) {
                return this.compareValue.includes("-");
            }
            return false;
        },
        isHigher: function isHigher() {
            if (this.compareValue && this.compareValue !== defaultCompareValue) {
                return this.compareValue.includes("+");
            }
            return false;
        }
    }
};

/***/ }),
/* 807 */
/*!*********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3eb6c83b","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/dataItem.vue ***!
  \*********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data-item"
  }, [_c('h3', {
    staticClass: "item-name"
  }, [_vm._v(_vm._s(_vm.name) + "\n    "), (_vm.extra) ? _c('span', {
    staticClass: "extra"
  }, [_vm._v(_vm._s(_vm.extra))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s((_vm.value || _vm.value === 0) ? _vm.value : '--'))]), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.valueUnit))])]), _vm._v(" "), (_vm.hasCompareValue) ? [_c('span', {
    staticClass: "compare-name"
  }, [_vm._v(_vm._s(_vm.compareName))]), _vm._v(" "), _c('span', {
    staticClass: "compare-value",
    class: {
      'lower': _vm.isLower, 'higher': _vm.isHigher
    }
  }, [_vm._v(_vm._s(_vm.compareValue ? _vm.compareValue + '%' : _vm.defaultCompareValue))])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 808 */
/*!************************************************!*\
  !*** ./src/components/homepage/CodeDetail.vue ***!
  \************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-87b0b5c8","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CodeDetail.vue */ 809)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CodeDetail.vue */ 810),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-87b0b5c8","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CodeDetail.vue */ 811),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 809 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-87b0b5c8","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/homepage/CodeDetail.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 810 */
/*!*******************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/homepage/CodeDetail.vue ***!
  \*******************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//

exports.default = {
    props: {
        item: {
            type: Object,
            required: true
        }
    }
};

/***/ }),
/* 811 */
/*!***********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87b0b5c8","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/CodeDetail.vue ***!
  \***********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "code-detail"
  })
},staticRenderFns: []}

/***/ }),
/* 812 */
/*!***********************************!*\
  !*** ./src/utils/falconReport.js ***!
  \***********************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.falconReport = undefined;

var _axios = __webpack_require__(/*! axios */ 12);

var _axios2 = _interopRequireDefault(_axios);

var _env = __webpack_require__(/*! ../config/env.conf */ 2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var falconReport = exports.falconReport = function falconReport(_ref) {
    var metric = _ref.metric,
        tags = _ref.tags,
        statusIgnored = _ref.statusIgnored,
        counterType = _ref.counterType;

    var matchRes = tags.match(/status=(\d+)/);
    var status = matchRes && Number(matchRes[1]);
    if (Array.isArray(statusIgnored) && statusIgnored.indexOf(status) > -1) {
        console.info('falcon\u4FE1\u606F:status ' + status + ' \u8FC7\u6EE4\u6389\u4E0D\u4E0A\u62A5');
        return;
    }

    var data = {
        metric: metric,
        tags: tags || '',
        counterType: counterType || 'INCREMENT'
    };
    _handle(data);
};

function _handle(data) {
    _axios2.default.post(_env.falconHost, data);
}

/***/ }),
/* 813 */
/*!****************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63d15468","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/homepage/homepage.vue ***!
  \****************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homepage"
  }, [(_vm.topNotices && _vm.topNotices.length) ? _c('TopNotice', {
    attrs: {
      "notices": _vm.topNotices
    }
  }) : _vm._e(), _vm._v(" "), (_vm.midNotices && _vm.midNotices.length) ? _c('MidNotice', {
    attrs: {
      "notices": _vm.midNotices
    }
  }) : _vm._e(), _vm._v(" "), (_vm.bannerTexts && _vm.bannerTexts.length) ? _c('div', {
    staticClass: "banner-area"
  }, [_c('BannerTexts', {
    attrs: {
      "bannerTexts": _vm.bannerTexts
    },
    on: {
      "bannerItemClicked": _vm.openCourseDetail
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.bannerImgs && _vm.bannerImgs.length) ? _c('div', {
    staticClass: "banner-imgs"
  }, [_c('BannerImages', {
    attrs: {
      "images": _vm.bannerImgs
    },
    on: {
      "bannerItemClicked": _vm.openCourseDetail
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('Modal', {
    attrs: {
      "class-name": "code-detail",
      "width": "550"
    },
    model: {
      value: (_vm.showCodeDetail),
      callback: function($$v) {
        _vm.showCodeDetail = $$v
      },
      expression: "showCodeDetail"
    }
  }, [_c('p', {
    slot: "header"
  }, [_vm._v("验证门票")]), _vm._v(" "), _c('div', {
    staticClass: "code-detail-info"
  }, [_c('h4', {
    staticClass: "code-detail-title"
  }, [_vm._v(_vm._s(_vm.codeItem.dealInfo.poiName) + " | " + _vm._s(_vm.codeItem.dealInfo.ticketTypeName) + " ")]), _vm._v(" "), (_vm.codeItem.orderInfo.orderSource === 4) ? _c('div', {
    staticClass: "from-package-product"
  }, [_c('p', [_vm._v("此订单来自打包产品：" + _vm._s(_vm.codeItem.mainOrderInfo.title))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "price-valid-date"
  }, [_c('label', [_vm._v("购买单价：")]), _vm._v(" "), _c('span', {
    staticClass: "code-detail-money"
  }, [_c('span', {
    staticClass: "unit"
  }, [_vm._v("￥")]), _vm._v(_vm._s(_vm.codeItem.orderInfo.price))]), _vm._v(" "), _c('label', [_vm._v(" 有效期：")]), _vm._v(" "), _c('span', {
    staticClass: "code-detail-validdate"
  }, [_vm._v(_vm._s(_vm.codeItem.voucherInfo.voucherDateBegin) + " 至 " + _vm._s(_vm.codeItem.voucherInfo.voucherDateEnd))])]), _vm._v(" "), (_vm.codeItem.dealInfo.costDetail && _vm.codeItem.dealInfo.costDetail.length) ? _c('div', {
    staticClass: "cost-detail-part"
  }, [_c('h4', {
    staticClass: "cost-detail-title"
  }, [_vm._v("费用包含：")]), _vm._v(" "), _c('ol', {
    staticClass: "cost-details"
  }, _vm._l((_vm.codeItem.dealInfo.costDetail), function(item) {
    return _c('li', {
      key: item
    }, [_vm._v("\n            " + _vm._s(item) + "\n          ")])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "code-use-info"
  }, [_c('label', [_vm._v("查询券号：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.codeFormated(_vm.codeItem)))]), _vm._v(" "), _c('label', [_vm._v("可消费门票：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.codeItem.orderInfo.canUse))])]), _vm._v(" "), _c('div', {
    staticClass: "code-order-info"
  }, [_c('label', [_vm._v("订单号：")]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.openOrderDetail(_vm.codeItem.orderInfo.orderId)
      }
    }
  }, [_vm._v(_vm._s(_vm.codeItem.orderInfo.orderId))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.codeItem.orderInfo.orderSource === 4) ? _c('span', {
    staticClass: "from-package-product"
  }, [_vm._v("(打包订单号：" + _vm._s(_vm.codeItem.mainOrderInfo.orderNo) + ")")]) : _vm._e()]), _vm._v(" "), _c('label', [_vm._v("购买时间：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.codeItem.orderInfo.createDate))])]), _vm._v(" "), (_vm.codeItem.voucherInfo.holder && _vm.codeItem.voucherInfo.holder.length) ? _c('div', {
    staticClass: "voucher-holder"
  }, [_c('ul', _vm._l((_vm.codeItem.voucherInfo.holder), function(item) {
    return _c('li', {
      key: item.dataStr
    }, [_c('label', [_vm._v(_vm._s(_vm.dataMap[item.key]) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.dataStr))])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.codeItem.voucherInfo.credentials && _vm.codeItem.voucherInfo.credentials.length) ? _c('div', {
    staticClass: "credentials-info"
  }, [_c('ul', _vm._l((_vm.codeItem.voucherInfo.credentials), function(person) {
    return _c('li', {
      key: person.credentialsAllInfo
    }, [(person.bookInfo) ? _c('span', [_vm._v("\n              " + _vm._s(person.credentialsAllInfo) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('Button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (person.credentialsAllInfo),
        expression: "person.credentialsAllInfo",
        arg: "copy"
      }],
      key: person.credentialsAllInfo,
      attrs: {
        "type": "primary",
        "size": "small"
      }
    }, [_vm._v("复制")])], 1)
  }))]) : _vm._e(), _vm._v(" "), (_vm.codeItem.orderInfo.canUse) ? _c('div', {
    staticClass: "voucher-code"
  }, [_vm._v("\n        验证\n        "), _c('Select', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.codeCount),
      callback: function($$v) {
        _vm.codeCount = $$v
      },
      expression: "codeCount"
    }
  }, _vm._l((_vm.codeItem.orderInfo.canUse), function(num) {
    return _c('Option', {
      key: num,
      attrs: {
        "value": num
      }
    }, [_vm._v(_vm._s(num))])
  })), _vm._v("张，总价\n        "), _c('span', {
    staticClass: "price"
  }, [_vm._v("￥" + _vm._s(_vm.totalPrice))])], 1) : _vm._e(), _vm._v(" "), (!_vm.codeItem.orderInfo.canUse) ? _c('div', {
    staticClass: "code-no-canuse"
  }, [_vm._v("\n        验证此订单门票均已消费/退款，无法验证\n      ")]) : _vm._e(), _vm._v(" "), (_vm.codeItem.orderInfo.canUse) ? _c('div', {
    staticClass: "verify-btn"
  }, [_c('Button', {
    attrs: {
      "type": "success",
      "disabled": !_vm.codeCount,
      "long": ""
    },
    on: {
      "click": function($event) {
        _vm.verifyCode(false)
      }
    }
  }, [_vm._v("验证")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    slot: "footer"
  })]), _vm._v(" "), _c('Modal', {
    attrs: {
      "class-name": "code-result",
      "width": "550"
    },
    model: {
      value: (_vm.showCodeResult),
      callback: function($$v) {
        _vm.showCodeResult = $$v
      },
      expression: "showCodeResult"
    }
  }, [_c('p', {
    slot: "header"
  }, [_vm._v("验证成功")]), _vm._v(" "), _c('div', {
    staticClass: "code-result-info"
  }, [_c('h4', [_vm._v(_vm._s(_vm.codeItem.dealInfo.poiName) + " | " + _vm._s(_vm.codeItem.dealInfo.ticketTypeName))]), _vm._v(" "), _c('section', {
    staticClass: "code-count-info"
  }, [_c('p', [_vm._v(_vm._s(_vm.codeFormated(_vm.codeItem)) + " * " + _vm._s(_vm.codeCount) + "张")])]), _vm._v(" "), _c('section', {
    staticClass: "code-verify-info"
  }, [_c('p', [_c('label', [_vm._v("订单号：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.codeItem.orderInfo.orderId))])]), _vm._v(" "), _c('p', [_c('label', [_vm._v("成功数量：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.codeCount) + "张 * ￥" + _vm._s(_vm.codeItem.orderInfo.price))])]), _vm._v(" "), _c('p', [_c('label', [_vm._v("总金额：")]), _vm._v(" "), _c('span', [_vm._v("￥" + _vm._s(_vm.totalPrice))])])]), _vm._v(" "), (_vm.codeItem.dealInfo.costDetail && _vm.codeItem.dealInfo.costDetail.length) ? _c('section', {
    staticClass: "fee-info"
  }, [_c('h4', {
    staticClass: "cost-detail-title"
  }, [_vm._v("费用包含：")]), _vm._v(" "), _c('ol', {
    staticClass: "cost-details"
  }, _vm._l((_vm.codeItem.dealInfo.costDetail), function(item) {
    return _c('li', {
      key: item
    }, [_vm._v("\n            " + _vm._s(item) + "\n          ")])
  }))]) : _vm._e(), _vm._v(" "), (_vm.codeItem.voucherInfo.credentials && _vm.codeItem.voucherInfo.credentials.length) ? _c('section', {
    staticClass: "credentials-info"
  }, [_c('ul', _vm._l((_vm.codeItem.voucherInfo.credentials), function(person) {
    return _c('li', {
      key: person.credentialsAllInfo
    }, [_c('label', [_vm._v("游玩人：")]), _vm._v(" "), (person.credentialsAllInfo) ? _c('span', [_vm._v("\n              " + _vm._s(person.credentialsAllInfo.replace('取票人：', '')) + "\n            ")]) : _vm._e(), _vm._v(" "), (person.credentialsAllInfo) ? _c('Button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (person.credentialsAllInfo),
        expression: "person.credentialsAllInfo",
        arg: "copy"
      }],
      key: person.credentialsAllInfo,
      attrs: {
        "type": "primary",
        "size": "small"
      }
    }, [_vm._v("复制")]) : _vm._e()], 1)
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "success",
      "long": ""
    },
    on: {
      "click": function($event) {
        _vm.closeVerifyResult()
      }
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [_c('HomePageCard', {
    staticClass: "verify-card",
    attrs: {
      "title": "美团券验证"
    }
  }, [_c('Input', {
    staticClass: "code-input",
    attrs: {
      "placeholder": "请输入美团券码",
      "maxlength": 14,
      "disabled": _vm.isCodeRequesting,
      "autocomplete": "off",
      "element-id": "ticketHomeVoucherCodeInput"
    },
    on: {
      "on-change": _vm.codeChanged
    },
    model: {
      value: (_vm.code),
      callback: function($$v) {
        _vm.code = $$v
      },
      expression: "code"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isCodeRequesting,
      "disabled": !_vm.code || _vm.isCodeRequesting
    },
    on: {
      "click": _vm.verify
    },
    slot: "append"
  }, [_vm._v("验证")])], 1), _vm._v(" "), _c('div', {
    staticClass: "action-area"
  }, [_c('div', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.revokeVerify($event)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "turbo-ui-revoke"
    }
  }), _vm._v("撤销验证")], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.verifyHistory($event)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "turbo-ui-history"
    }
  }), _vm._v("验证历史")], 1)])])], 1), _vm._v(" "), _c('HomePageCard', {
    staticClass: "yesterday-data",
    attrs: {
      "title": "昨日数据",
      "extra": "更多"
    },
    on: {
      "extraClick": function($event) {
        _vm.moreYesterdayData()
      }
    }
  }, [_c('div', {
    staticClass: "data-area"
  }, _vm._l((_vm.yesterdayDatas), function(data) {
    return _c('DataItem', {
      key: data.name,
      attrs: {
        "valueUnit": data.unit,
        "name": data.name,
        "value": data.value,
        "hasCompareValue": true,
        "compareName": "较上周同期",
        "compareValue": data.compareValue
      },
      nativeOn: {
        "click": function($event) {
          _vm.navToDataSummary($event)
        }
      }
    })
  }))])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [_c('HomePageCard', {
    staticClass: "yuyue-ticket",
    attrs: {
      "title": "预约票量"
    }
  }, [_c('div', {
    staticClass: "ticket-count"
  }, _vm._l((_vm.orderTicketsData), function(data) {
    return _c('DataItem', {
      key: data.id,
      attrs: {
        "id": data.id,
        "extra": data.extra,
        "valueUnit": "件",
        "name": data.name,
        "value": data.value
      }
    })
  }))])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [_c('HomePageCard', {
    staticClass: "recomm-services",
    attrs: {
      "title": "推荐服务"
    }
  }, [_c('div', [_vm._l((_vm.serviceItems), function(data) {
    return [(data.icon !== 'app') ? _c('ServiceItem', {
      key: data.name,
      attrs: {
        "icon": data.icon,
        "name": data.name,
        "desc": data.desc
      },
      nativeOn: {
        "click": function($event) {
          _vm.servicItemClicked(data)
        }
      }
    }) : _vm._e(), _vm._v(" "), (data.icon === 'app') ? _c('Tooltip', {
      key: data.name,
      attrs: {
        "placement": "top"
      }
    }, [_c('ServiceItem', {
      key: data.name,
      attrs: {
        "icon": data.icon,
        "name": data.name,
        "desc": data.desc,
        "delay": 350
      }
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": "//p0.meituan.net/codeman/8acc947084d6b22070523f39dcb7c91428173.png",
        "width": "226px"
      },
      slot: "content"
    })], 1) : _vm._e()]
  })], 2)]), _vm._v(" "), _c('HomePageCard', {
    staticClass: "recomm-actives",
    attrs: {
      "title": "推荐活动"
    }
  }, [(_vm.activeItems && _vm.activeItems.length) ? _c('ul', _vm._l((_vm.activeItems), function(data) {
    return _c('ActiveItem', {
      key: data.id,
      attrs: {
        "name": data.name,
        "date": data.date,
        "bgclass": data.bg
      },
      nativeOn: {
        "click": function($event) {
          _vm.activityItemClicked(data.id)
        }
      }
    })
  })) : _c('div', {
    staticClass: "create-selfpro"
  }, [_c('div', [_c('p', {
    staticClass: "main-desc"
  }, [_vm._v("暂无可参加的活动")]), _vm._v(" "), _c('p', {
    staticClass: "sub-desc"
  }, [_vm._v("自己做促销，同样可以吸引顾客")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.createSelfPro
    }
  }, [_vm._v("创建自促活动")])], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [_c('div', {
    staticClass: "notices"
  }, [_c('Notices', {
    attrs: {
      "title": "平台公告",
      "notices": _vm.notices
    },
    on: {
      "extraClicked": function($event) {
        _vm.moreNotices(3)
      }
    }
  }), _vm._v(" "), _c('Notices', {
    attrs: {
      "title": "规则中心",
      "notices": _vm.rules
    },
    on: {
      "extraClicked": function($event) {
        _vm.moreNotices(10)
      }
    }
  })], 1), _vm._v(" "), _c('HomePageCard', {
    staticClass: "xigua-academy",
    attrs: {
      "title": "西瓜学院",
      "extra": "更多"
    },
    on: {
      "extraClick": function($event) {
        _vm.moreNotices(5)
      }
    }
  }, [_c('ul', {
    staticClass: "course-list"
  }, _vm._l((_vm.courses), function(courseItem) {
    return _c('CourseItem', {
      key: courseItem.id,
      attrs: {
        "src": courseItem.src,
        "title": courseItem.title,
        "subTitle": courseItem.subTitle
      },
      nativeOn: {
        "click": function($event) {
          _vm.openCourseDetail(courseItem.id)
        }
      }
    })
  }))])], 1), _vm._v(" "), _c('HomePageFooter')], 1)
},staticRenderFns: []}

/***/ }),
/* 814 */
/*!*********************************************************************!*\
  !*** ./src/views/ticket/verify/history/pages/detailConsumption.vue ***!
  \*********************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-7615824a","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./detailConsumption.vue */ 815)
}
var Component = __webpack_require__(/*! ../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./detailConsumption.vue */ 816),
  /* template */
  __webpack_require__(/*! !../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7615824a","hasScoped":true}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./detailConsumption.vue */ 817),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7615824a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 815 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7615824a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/ticket/verify/history/pages/detailConsumption.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 816 */
/*!****************************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/ticket/verify/history/pages/detailConsumption.vue ***!
  \****************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _verifyHistory = __webpack_require__(/*! api/verifyHistory */ 160);

var _verifyHistory2 = _interopRequireDefault(_verifyHistory);

var _helpers = __webpack_require__(/*! helpers */ 16);

var _envConf = __webpack_require__(/*! config/env.conf.js */ 2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            options1: {
                "allowInput": true
            },
            msg: "",
            current: 1,
            perPageCount: 10,
            totalCount: 0,
            isTableLoading: false,
            useTimeEnd: '',
            useTimeStart: '',
            dealId: '',
            bizAccountAccess: 'web',
            noData: false,
            totalVerifyNum: 0,
            totalRevocationNum: 0,
            selectedIndex: 0,
            dealList: [],
            baseUrl: "/meilv/scs/account/v1/voucher/log/excel?",
            detailUrl: "#/ticket/order/ticket/detail?id=",
            programNameUrl: "https://www.meituan.com/deal/",
            searchInfo: false,
            apiHost: _envConf.apiHost,
            otpHost: _envConf.otpHost,
            formdate: _helpers.formatDate,
            detailList: [],
            dealName: ""
        };
    },

    created: function created() {
        this.searchInfo = true;
        if (this.searchInfo) {
            this.getDetailList();
        }
    },
    filters: {
        formdate: function formdate(time) {
            var date = new Date(time);
            return (0, _helpers.formatDate)(date, 'yyyy-MM-dd hh:mm:ss');
        }
    },
    computed: {
        totalPage: function totalPage() {
            return Math.ceil(this.totalCount / this.perPageCount);
        },
        generateUrl: function generateUrl() {
            return this.baseUrl + "?dealId=" + this.dealId + "&useTimeStart=" + this.useTimeStart + "&useTimeEnd=" + this.useTimeEnd;
        }
    },
    methods: {
        alert: function alert(message) {
            this.$alert({
                title: '提示',
                message: message,
                showCancelButton: false,
                closeOnClickModal: false
            });
        },
        getFormateDate: function getFormateDate(date) {
            return this.formdate(date, 'yyyy-MM-dd hh:mm:ss'); //为什么写成大写的HH就时间显示不出来
        },
        getDetailList: function getDetailList() {
            var _this = this;

            if (this.searchInfo) {
                this.dealId = this.$route.params.dealId;
                this.useTimeStart = this.$route.params.useTimeStart;
                this.dealName = this.$route.params.dealName;
                this.useTimeEnd = this.useTimeStart;
            }
            console.log(this.dealId);
            this.isTableLoading = true;
            _verifyHistory2.default.getAllConsumptionList({
                bizAccountAccess: this.bizAccountAccess,
                useTimeEnd: this.useTimeEnd,
                useTimeStart: this.useTimeStart,
                pageNo: this.current,
                pageSize: this.perPageCount,
                dealId: this.dealId
            }).then(function (response) {
                _this.isTableLoading = false;
                //console.log(response);
                if (response.status === 0) {
                    if (response.data) {
                        _this.detailList = response.data.list;
                        _this.totalVerifyNum = response.data.totalVerifyNum;
                        _this.totalRevocationNum = response.data.totalRevocationNum;
                        _this.totalCount = response.data.totalSize;
                    }
                    if (response.data.list.length === 0) {
                        _this.noData = true;
                    } else {
                        _this.noData = false;
                    }
                } else {
                    _this.alert(response.message || '接口返回信息有误');
                }
            }).catch(function (error) {
                _this.isTableLoading = false;
                _this.consumptionList = [];
                _this.alert(error);
            });
        },
        currentChangeFunc: function currentChangeFunc(data) {
            this.current = data.current;
            this.searchInfo = false;
            this.getDetailList();
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 817 */
/*!*******************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7615824a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ticket/verify/history/pages/detailConsumption.vue ***!
  \*******************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "super-title"
  }, [_vm._v("已消费美团券明细")]), _vm._v(" "), _c('router-link', {
    staticClass: "head-link",
    attrs: {
      "to": {
        name: 'ticketsingleProgram'
      }
    }
  }, [_vm._v("返回“单个项目消费明细”")])], 1), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-text"
  }, [_c('a', {
    attrs: {
      "href": _vm.programNameUrl + _vm.dealId + '.html',
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.dealName))])])])]), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("门票已验证但却找不到？请确认是否选错了项目，或在\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'ticketallProgram'
      }
    }
  }, [_vm._v("所有项目消费明细")])], 1), _vm._v(" "), _c('div', {
    staticClass: "common-tip-blk"
  }, [_c('span', [_c('i', {
    staticClass: "F-glob F-glob-status-info"
  }), _vm._v(" "), _c('strong', [_vm._v("合计")]), _vm._v(_vm._s(_vm.useTimeStart) + "累计验证\n            "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.totalVerifyNum || 0))]), _vm._v("张,撤销\n            "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.totalRevocationNum || 0))]), _vm._v("张,明细如下:\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('a', {
    attrs: {
      "href": _vm.apiHost + _vm.generateUrl,
      "target": "_blank"
    }
  }, [_vm._v("下载明细记录")])])]), _vm._v(" "), _c('div', {
    staticClass: "tablewrapper"
  }, [_c('table', {
    staticClass: "table table-hover table-bordered"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.detailList), function(item, index) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": _vm.otpHost + _vm.detailUrl + item.orderId
      }
    }, [_vm._v(_vm._s(item.orderId))])]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm._f("formdate")(item.operationTime)) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(item.operationType == 1 ? '验证' : '撤销') + "\n                    ")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(item.voucherCode))])]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(item.quantity) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.operatorName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.source))]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(item.sellPrice) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(item.totalPrice) + "\n                    ")])])
  }))]), _vm._v(" "), (_vm.noData) ? _c('p', {
    staticClass: "nodata"
  }, [_vm._v("未查询到匹配内容")]) : _vm._e(), _vm._v(" "), _c('v-pagination', {
    staticClass: "pull-right",
    attrs: {
      "current": _vm.current,
      "total": _vm.totalPage,
      "size": 'md',
      "first": false,
      "last": false
    },
    on: {
      "current-change": function($event) {
        _vm.currentChangeFunc($event)
      }
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-item  control-label"
  }, [_c('strong', [_vm._v("项目名称：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("订单号")]), _vm._v(" "), _c('th', [_vm._v("操作时间")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("电子票密码")]), _vm._v(" "), _c('th', [_vm._v("操作数量")]), _vm._v(" "), _c('th', [_vm._v("操作人")]), _vm._v(" "), _c('th', [_vm._v("来源")]), _vm._v(" "), _c('th', [_vm._v("消费者购买价")]), _vm._v(" "), _c('th', [_vm._v("总价")])])])
}]}

/***/ }),
/* 818 */
/*!***********************************************************!*\
  !*** ./src/views/dataPlatform/menpiao/indexData/Main.vue ***!
  \***********************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-673692c9","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Main.vue */ 819)
}
var Component = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Main.vue */ 820),
  /* template */
  __webpack_require__(/*! !../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-673692c9","hasScoped":true}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Main.vue */ 832),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-673692c9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 819 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-673692c9","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/menpiao/indexData/Main.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 820 */
/*!******************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/menpiao/indexData/Main.vue ***!
  \******************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _PlatForm = __webpack_require__(/*! ../components/PlatForm.vue */ 119);

var _PlatForm2 = _interopRequireDefault(_PlatForm);

var _TitleDate = __webpack_require__(/*! ../../components/title-date/TitleDate.vue */ 10);

var _TitleDate2 = _interopRequireDefault(_TitleDate);

var _IndicatorsData = __webpack_require__(/*! ../../components/indicators-data/IndicatorsData.vue */ 93);

var _IndicatorsData2 = _interopRequireDefault(_IndicatorsData);

var _Transaction = __webpack_require__(/*! ./components/transaction/Transaction.vue */ 824);

var _Transaction2 = _interopRequireDefault(_Transaction);

var _ProductAnalysis = __webpack_require__(/*! ./components/productAnalysis/ProductAnalysis.vue */ 828);

var _ProductAnalysis2 = _interopRequireDefault(_ProductAnalysis);

var _menpiaoDataPlatform = __webpack_require__(/*! api/menpiaoDataPlatform */ 34);

var _menpiaoDataPlatform2 = _interopRequireDefault(_menpiaoDataPlatform);

var _momentFormat = __webpack_require__(/*! ../../filters/moment-format */ 6);

var _momentFormat2 = _interopRequireDefault(_momentFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        PlatFormComponent: _PlatForm2.default,
        TitleDateComponent: _TitleDate2.default,
        IndicatorsDataComponent: _IndicatorsData2.default,
        TransactionComponent: _Transaction2.default,
        ProductAnalysisComponent: _ProductAnalysis2.default
    },
    data: function data() {
        var data = {
            titleOption: {
                title: '经营概况',
                more: true,
                moreUrl: 'menpiaoOperateData'
            },
            resultData: {},
            salePlatform: 0, // 平台
            date: {
                startDate: _momentFormat2.default.getYestoday(), // 默认昨天
                endDate: _momentFormat2.default.getYestoday()
            },
            compareInfo: '较上周同期',
            isLoading: false
        };
        return data;
    },

    computed: {
        indicatorsData: function indicatorsData() {
            return {
                payAmount: {
                    name: '销售额',
                    value: this.resultData.payAmount,
                    unit: '元',
                    compare: this.resultData.payAmountPercent,
                    title: '销售额',
                    compareInfo: this.compareInfo
                },
                payQuantity: {
                    name: '销售量',
                    value: this.resultData.payQuantity,
                    unit: '件',
                    compare: this.resultData.payQuantityPercent,
                    title: '销量',
                    compareInfo: this.compareInfo
                },
                consumeOrderNum: {
                    name: '消费券量',
                    value: this.resultData.consumeQuantity,
                    unit: '件',
                    compare: this.resultData.consumeQuantityPercent,
                    title: '验证的券量',
                    compareInfo: this.compareInfo
                },
                visitPurchaseRate: {
                    name: '访购率',
                    value: this.resultData.visitPurchaseRate,
                    unit: '%',
                    compare: this.resultData.visitPurchaseRatePercent,
                    title: '支付用户数/浏览用户数',
                    compareInfo: this.compareInfo
                },
                refundRate: {
                    name: '退款率',
                    value: this.resultData.refundRate,
                    unit: '%',
                    compare: this.resultData.refundRatePercent,
                    title: '用户申请退款的订单数/支付订单数',
                    compareInfo: this.compareInfo
                }
            };
        }
    },
    methods: {
        // 获取数据
        getData: function getData() {
            var _this = this;

            this.isLoading = true;
            _menpiaoDataPlatform2.default.getIndexData(this.salePlatform, this.date.startDate, this.date.endDate, false).then(function (res) {
                console.log(res);
                if (res.status === 0) {
                    _this.resultData = res.data.sum === null ? {} : res.data.sum;
                    _this.resultData.compareInfo = _this.compareInfo;
                } else {
                    _this.$notify.error({
                        title: '错误',
                        message: res.message || '请求失败'
                    });
                }
                _this.isLoading = false;
            }).catch(function (err) {
                console.log(err);
                _this.isLoading = false;
            });
        },


        // 更新数据
        updateData: function updateData(params) {
            this.salePlatform = params.salePlatform;
            this.date.startDate = params.dateRange.startDate;
            this.date.endDate = params.dateRange.endDate;
            if (params.dateRadio === 0) {
                this.compareInfo = '较上周同期';
            } else if (params.dateRadio === 1) {
                this.compareInfo = '较上周整体';
            } else if (params.dateRadio === 2) {
                this.compareInfo = '环比上月';
            } else {
                this.compareInfo = '较上一周期';
            }
            this.getData();
        }
    },
    created: function created() {
        this.getData();
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 821 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-67620d02","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/menpiao/components/PlatForm.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 822 */
/*!***********************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/menpiao/components/PlatForm.vue ***!
  \***********************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _momentFormat = __webpack_require__(/*! ../../filters/moment-format */ 6);

var _momentFormat2 = _interopRequireDefault(_momentFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            platformRadio: 0, // 平台
            dateRadio: 0, // 昨天、7天、30天
            dateRange: {
                startDate: _momentFormat2.default.getYestoday(),
                endDate: _momentFormat2.default.getYestoday()
            }
        };
    },

    props: ['option'],
    methods: {
        // 切换昨天、7天、30天
        changeDateRadio: function changeDateRadio(e) {
            var ev = e.target;
            if (ev.tagName === 'SPAN') {
                var type = parseInt(ev.dataset.type);
                if (this.dateRadio === type) {
                    return;
                }
                this.dateRadio = type;
                switch (this.dateRadio) {
                    case 0:
                        this.dateRange.startDate = _momentFormat2.default.getYestoday();
                        this.dateRange.endDate = _momentFormat2.default.getYestoday();
                        break;
                    case 1:
                        this.dateRange.startDate = _momentFormat2.default.getSevenDate();
                        this.dateRange.endDate = _momentFormat2.default.getYestoday();
                        break;
                    case 2:
                        this.dateRange.startDate = _momentFormat2.default.getThirtyDate();
                        this.dateRange.endDate = _momentFormat2.default.getYestoday();
                        break;
                }
                this.updateData();
            }
        },


        // 切换平台
        changePlatformRadio: function changePlatformRadio(e) {
            var ev = e.target;
            if (ev.tagName === 'SPAN') {
                var type = parseInt(ev.dataset.type);
                if (this.platformRadio === type) {
                    return;
                }
                this.platformRadio = type;
                this.updateData();
            }
        },


        // 更新数据
        updateData: function updateData() {
            this.$emit('updateData', { salePlatform: this.platformRadio, dateRange: this.dateRange, dateRadio: this.dateRadio
            });
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 823 */
/*!**************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67620d02","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/menpiao/components/PlatForm.vue ***!
  \**************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "platform"
  }, [_c('section', {
    staticClass: "platform-radio",
    on: {
      "click": function($event) {
        _vm.changePlatformRadio($event)
      }
    }
  }, [_c('span', {
    class: {
      'active': _vm.platformRadio === 0
    },
    attrs: {
      "data-type": "0"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('span', {
    class: {
      'active': _vm.platformRadio === 1
    },
    attrs: {
      "data-type": "1"
    }
  }, [_vm._v("美团")]), _vm._v(" "), _c('span', {
    class: {
      'active': _vm.platformRadio === 2
    },
    attrs: {
      "data-type": "2"
    }
  }, [_vm._v("点评")])]), _vm._v(" "), (_vm.option.dateRadio) ? _c('section', {
    staticClass: "date"
  }, [_c('section', {
    staticClass: "date-radio",
    on: {
      "click": function($event) {
        _vm.changeDateRadio($event)
      }
    }
  }, [_c('span', {
    class: {
      'active': _vm.dateRadio === 0
    },
    attrs: {
      "data-type": "0"
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('span', {
    class: {
      'active': _vm.dateRadio === 1
    },
    attrs: {
      "data-type": "1"
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('span', {
    class: {
      'active': _vm.dateRadio === 2
    },
    attrs: {
      "data-type": "2"
    }
  }, [_vm._v("最近30天")])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 824 */
/*!*****************************************************************************************!*\
  !*** ./src/views/dataPlatform/menpiao/indexData/components/transaction/Transaction.vue ***!
  \*****************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-ef7bbaf8","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Transaction.vue */ 825)
}
var Component = __webpack_require__(/*! ../../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Transaction.vue */ 826),
  /* template */
  __webpack_require__(/*! !../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-ef7bbaf8","hasScoped":true}!../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Transaction.vue */ 827),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ef7bbaf8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 825 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ef7bbaf8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/menpiao/indexData/components/transaction/Transaction.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 826 */
/*!************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/menpiao/indexData/components/transaction/Transaction.vue ***!
  \************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TitleDate = __webpack_require__(/*! ../../../../components/title-date/TitleDate.vue */ 10);

var _TitleDate2 = _interopRequireDefault(_TitleDate);

var _LineTips = __webpack_require__(/*! ../../../../operateData/components/line-tips/LineTips.vue */ 94);

var _LineTips2 = _interopRequireDefault(_LineTips);

var _dataFormat = __webpack_require__(/*! ../../../../filters/data-format */ 117);

var _dataFormat2 = _interopRequireDefault(_dataFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        LineTipsComponent: _LineTips2.default,
        TitleDateComponent: _TitleDate2.default
    },
    filters: {
        dataformat: _dataFormat2.default
    },
    data: function data() {
        return {
            titleOption: {
                title: '交易分析',
                more: true,
                moreUrl: 'menpiaoTransactionData'
            }
        };
    },

    props: ['resultData'],
    computed: {
        // 访购率指标
        lineTipsInfo: function lineTipsInfo() {
            return {
                name: '访购率',
                value: this.resultData.visitPurchaseRate,
                unit: '%',
                compare: this.resultData.visitPurchaseRatePercent,
                title: '支付用户数/浏览用户数',
                compareInfo: this.resultData.compareInfo
            };
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 827 */
/*!***************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef7bbaf8","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/menpiao/indexData/components/transaction/Transaction.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "transaction-box"
  }, [_c('title-date-component', {
    attrs: {
      "titleOption": _vm.titleOption
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "data-box"
  }, [_c('line-tips-component', {
    staticStyle: {
      "margin-top": "45px",
      "width": "150px"
    },
    attrs: {
      "lineTipsInfo": _vm.lineTipsInfo
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "data"
  }, [_c('section', [_c('span', {
    attrs: {
      "title": "浏览用户数量"
    }
  }, [_c('i', [_vm._v("访客数")]), _vm._v(_vm._s(_vm._f("dataformat")(_vm.resultData.intentionUV)))])]), _vm._v(" "), _c('section', [_c('span', {
    attrs: {
      "title": "所售商品有下单行为的用户数量"
    }
  }, [_c('i', [_vm._v("下单用户数")]), _vm._v(_vm._s(_vm._f("dataformat")(_vm.resultData.orderUserNum)))])]), _vm._v(" "), _c('section', [_c('span', {
    attrs: {
      "title": "产生的支付行为的用户数量"
    }
  }, [_c('i', [_vm._v("支付用户数")]), _vm._v(_vm._s(_vm._f("dataformat")(_vm.resultData.payUserNum)))])])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "funnel"
  }, [_c('section', [_c('span', [_vm._v("浏览")])]), _vm._v(" "), _c('section', [_c('span', [_vm._v("下单")])]), _vm._v(" "), _c('section', [_c('span', [_vm._v("支付")])])])
}]}

/***/ }),
/* 828 */
/*!*************************************************************************************************!*\
  !*** ./src/views/dataPlatform/menpiao/indexData/components/productAnalysis/ProductAnalysis.vue ***!
  \*************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-49111dc4","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ProductAnalysis.vue */ 829)
}
var Component = __webpack_require__(/*! ../../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ProductAnalysis.vue */ 830),
  /* template */
  __webpack_require__(/*! !../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-49111dc4","hasScoped":true}!../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ProductAnalysis.vue */ 831),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-49111dc4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 829 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-49111dc4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/menpiao/indexData/components/productAnalysis/ProductAnalysis.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 830 */
/*!********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/menpiao/indexData/components/productAnalysis/ProductAnalysis.vue ***!
  \********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TitleDate = __webpack_require__(/*! ../../../../components/title-date/TitleDate.vue */ 10);

var _TitleDate2 = _interopRequireDefault(_TitleDate);

var _LineTips = __webpack_require__(/*! ../../../../operateData/components/line-tips/LineTips.vue */ 94);

var _LineTips2 = _interopRequireDefault(_LineTips);

var _Columnar = __webpack_require__(/*! ../../../../components/echarts/Columnar.vue */ 247);

var _Columnar2 = _interopRequireDefault(_Columnar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        TitleDateComponent: _TitleDate2.default,
        LineTipsComponent: _LineTips2.default,
        ColumnarComponent: _Columnar2.default
    },
    data: function data() {
        return {
            titleOption: {
                title: '商品分析',
                more: true,
                moreUrl: 'menpiaoProductData'
            }
        };
    },

    props: ['resultData'],
    computed: {
        // 动销率指标
        lineTipsInfo: function lineTipsInfo() {
            return {
                name: '动销率',
                value: this.resultData.saleProductRate,
                unit: '%',
                compare: this.resultData.saleProductRatePercent,
                title: '有销量的在线商品数/在线商品数',
                compareInfo: this.resultData.compareInfo
            };
        },


        // 图表数据
        columnarData: function columnarData() {
            return [this.resultData.payProductNum, this.resultData.orderProductNum, this.resultData.visitProductNum, this.resultData.onlineProductNum];
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 831 */
/*!***********************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49111dc4","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/menpiao/indexData/components/productAnalysis/ProductAnalysis.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "marketing-overview"
  }, [_c('title-date-component', {
    attrs: {
      "titleOption": _vm.titleOption
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "data-box"
  }, [_c('LineTipsComponent', {
    staticStyle: {
      "width": "20%",
      "margin-top": "33px"
    },
    attrs: {
      "lineTipsInfo": _vm.lineTipsInfo
    }
  }), _vm._v(" "), _c('columnar-component', {
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "columnarData": _vm.columnarData
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 832 */
/*!*********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-673692c9","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/menpiao/indexData/Main.vue ***!
  \*********************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "main"
  }, [_c('plat-form-component', {
    attrs: {
      "option": {
        dateRadio: true
      }
    },
    on: {
      "updateData": _vm.updateData
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "operate"
  }, [_c('title-date-component', {
    attrs: {
      "titleOption": _vm.titleOption
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "indicators-data-box"
  }, _vm._l((_vm.indicatorsData), function(item, index) {
    return _c('indicators-data-component', {
      key: index,
      attrs: {
        "data": item
      }
    })
  }))], 1), _vm._v(" "), _c('section', {
    staticClass: "box"
  }, [_c('section', {
    staticClass: "analysis"
  }, [_c('transaction-component', {
    attrs: {
      "resultData": _vm.resultData
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "analysis"
  }, [_c('product-analysis-component', {
    attrs: {
      "resultData": _vm.resultData
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 833 */
/*!*************************************************************!*\
  !*** ./src/views/dataPlatform/menpiao/operateData/Main.vue ***!
  \*************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-57ec8617","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Main.vue */ 834)
}
var Component = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Main.vue */ 835),
  /* template */
  __webpack_require__(/*! !../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-57ec8617","hasScoped":true}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Main.vue */ 836),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-57ec8617",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 834 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-57ec8617","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/menpiao/operateData/Main.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 835 */
/*!********************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/menpiao/operateData/Main.vue ***!
  \********************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _PlatForm = __webpack_require__(/*! ../components/PlatForm.vue */ 119);

var _PlatForm2 = _interopRequireDefault(_PlatForm);

var _TitleDate = __webpack_require__(/*! ../../components/title-date/TitleDate.vue */ 10);

var _TitleDate2 = _interopRequireDefault(_TitleDate);

var _IndicatorsData = __webpack_require__(/*! ../../components/indicators-data/IndicatorsData.vue */ 93);

var _IndicatorsData2 = _interopRequireDefault(_IndicatorsData);

var _Nav = __webpack_require__(/*! ../../components/nav/Nav.vue */ 37);

var _Nav2 = _interopRequireDefault(_Nav);

var _Line = __webpack_require__(/*! ../../components/echarts/Line.vue */ 78);

var _Line2 = _interopRequireDefault(_Line);

var _Table = __webpack_require__(/*! ../../components/table/Table.vue */ 43);

var _Table2 = _interopRequireDefault(_Table);

var _menpiaoDataPlatform = __webpack_require__(/*! api/menpiaoDataPlatform */ 34);

var _menpiaoDataPlatform2 = _interopRequireDefault(_menpiaoDataPlatform);

var _momentFormat = __webpack_require__(/*! ../../filters/moment-format */ 6);

var _momentFormat2 = _interopRequireDefault(_momentFormat);

var _percentFormat = __webpack_require__(/*! ../../filters/percent-format */ 33);

var _percentFormat2 = _interopRequireDefault(_percentFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        PlatFormComponent: _PlatForm2.default,
        TitleDateComponent: _TitleDate2.default,
        IndicatorsDataComponent: _IndicatorsData2.default,
        NavComponent: _Nav2.default,
        LineComponent: _Line2.default,
        TableComponent: _Table2.default
    },
    data: function data() {
        var data = {
            titleOption: { // 单元块名称和日期选择配置
                title: '经营分析', // 名称
                dateRangeSelect: true, // 是否显示日期区间下拉框
                dateMaxRangeLength: 60, // 日期区间最大跨度
                dateCompareSelect: true,
                download: true, // 是否显示下载按钮
                showDate: {
                    startDate: _momentFormat2.default.getSevenDate(),
                    endDate: _momentFormat2.default.getYestoday()
                }
            },
            resultData: {},
            salePlatform: 0, // 平台
            date: {
                startDate: _momentFormat2.default.getSevenDate(),
                endDate: _momentFormat2.default.getYestoday()
            },
            initDateRange: _momentFormat2.default.getSevenDate() + ' ~ ' + _momentFormat2.default.getYestoday(),
            type: [{
                name: '销售额',
                value: 'payAmount'
            }, {
                name: '销售量',
                value: 'payQuantity'
            }, {
                name: '消费券量',
                value: 'consumeQuantity'
            }, {
                name: '访购率',
                value: 'visitPurchaseRate'
            }, {
                name: '退款率',
                value: 'refundRate'
            }],
            currentType: 'payAmount', // 当前纬度
            typeData: {
                allTypeData: { // 所有维度数据
                    payAmount: [],
                    payQuantity: [],
                    consumeQuantity: [],
                    visitPurchaseRate: [],
                    refundRate: []
                },
                allTypeCompareData: { // 所有对比纬度数据
                    payAmount: [],
                    payQuantity: [],
                    consumeQuantity: [],
                    visitPurchaseRate: [],
                    refundRate: []
                }
            },
            lineResultData: {
                dateArr: [],
                dataArr: [],
                dateCompareArr: [], // 对比日期
                dataCompareArr: [], // 对比数据
                currentTypeName: '销售额'
            },
            tableInfo: {
                title: [{
                    name: '日期',
                    value: 'date'
                }, {
                    name: '销售额',
                    value: 'payAmount'
                }, {
                    name: '销售量',
                    value: 'payQuantity'
                }, {
                    name: '消费券量',
                    value: 'consumeQuantity'
                }, {
                    name: '退款量',
                    value: 'refundOrderNum'
                }, {
                    name: '验证率',
                    value: 'consumeRate'
                }, {
                    name: '退款率',
                    value: 'refundRate'
                }],
                data: []
            },
            isLoading: false
        };
        return data;
    },

    computed: {
        indicatorsData: function indicatorsData() {
            return {
                payAmount: {
                    name: '销售额',
                    value: this.resultData.payAmount,
                    unit: '元',
                    compare: this.resultData.payAmountPercent,
                    title: '销售额'
                },
                payQuantity: {
                    name: '销售量',
                    value: this.resultData.payQuantity,
                    unit: '件',
                    compare: this.resultData.payQuantityPercent,
                    title: '销量'
                },
                consumeOrderNum: {
                    name: '消费券量',
                    value: this.resultData.consumeQuantity,
                    unit: '件',
                    compare: this.resultData.consumeQuantityPercent,
                    title: '验证的券量'
                },
                visitPurchaseRate: {
                    name: '访购率',
                    value: this.resultData.visitPurchaseRate,
                    unit: '%',
                    compare: this.resultData.visitPurchaseRatePercent,
                    title: '支付用户数/浏览用户数'
                },
                refundRate: {
                    name: '退款率',
                    value: this.resultData.refundRate,
                    unit: '%',
                    compare: this.resultData.refundRatePercent,
                    title: '用户申请退款的订单数/支付订单数'
                }
            };
        }
    },
    methods: {
        getData: function getData(isCompare, date) {
            var _this = this;

            this.isLoading = true;
            _menpiaoDataPlatform2.default.getIndexData(this.salePlatform, date.startDate, date.endDate, true).then(function (res) {
                console.log(res);
                if (res.status === 0) {
                    if (!isCompare) {
                        _this.resultData = res.data.sum === null ? {} : res.data.sum;
                    }
                    var data = res.data.daily === null ? [] : res.data.daily;
                    _this.formatAllData(data, isCompare);
                } else {
                    _this.$notify.error({
                        title: '错误',
                        message: res.message || '请求失败'
                    });
                }
                _this.isLoading = false;
            }).catch(function (err) {
                if (isCompare === true) {
                    _this.lineResultData.dateCompareArr = [];
                    _this.lineResultData.dataCompareArr = [];
                } else {
                    _this.lineResultData.dateArr = [];
                    _this.lineResultData.dataArr = [];
                }
                console.log(err);
                _this.isLoading = false;
            });
        },
        formatAllData: function formatAllData(data, isCompare) {
            var date = [];
            var initData = {
                payQuantity: [],
                payAmount: [],
                consumeQuantity: [],
                visitPurchaseRate: [],
                refundRate: []
            };
            var arr = [];
            data.forEach(function (item) {
                date.push(item.date);
                initData.payQuantity.push(item.payQuantity);
                initData.payAmount.push(item.payAmount);
                initData.consumeQuantity.push(item.consumeQuantity);
                initData.visitPurchaseRate.push(item.visitPurchaseRate);
                initData.refundRate.push(item.refundRate);
                // table数据
                var o = {};
                o.date = {};
                o.date.value = item.date;
                o.payAmount = {};
                o.payAmount.value = item.payAmount;
                o.payQuantity = {};
                o.payQuantity.value = item.payQuantity;
                o.consumeQuantity = {};
                o.consumeQuantity.value = item.consumeQuantity;
                o.refundOrderNum = {};
                o.refundOrderNum.value = item.refundOrderNum;
                o.consumeRate = {};
                o.consumeRate.value = (0, _percentFormat2.default)(item.consumeRate, true);
                o.refundRate = {};
                o.refundRate.value = (0, _percentFormat2.default)(item.refundRate, true);
                arr.push(o);
            });
            if (isCompare === true) {
                this.typeData.allTypeCompareData = initData;
                this.$set(this.lineResultData, 'dateCompareArr', date);
                this.$set(this.lineResultData, 'dataCompareArr', this.typeData.allTypeCompareData[this.currentType]);
            } else {
                this.typeData.allTypeData = initData;
                this.$set(this.lineResultData, 'dateArr', date);
                this.$set(this.lineResultData, 'dataArr', this.typeData.allTypeData[this.currentType]);
                this.tableInfo.data = arr;
            }
        },


        // 更新数据
        updateData: function updateData(params) {
            this.salePlatform = params.salePlatform;
            this.getData(false, this.date);
        },


        // 切换类型
        changeNavType: function changeNavType(type) {
            var _this2 = this;

            this.currentType = type;
            var currentTypeName = this.type.find(function (item) {
                return item.value === _this2.currentType;
            });
            this.$set(this.lineResultData, 'dataArr', this.typeData.allTypeData[this.currentType]);
            this.$set(this.lineResultData, 'dataCompareArr', this.typeData.allTypeCompareData[this.currentType]);
            this.$set(this.lineResultData, 'currentTypeName', currentTypeName.name);
            console.log(this.lineResultData);
        },


        // 切换日期
        changeDate: function changeDate(params) {
            this.date.startDate = params.dateRange.startDate;
            this.date.endDate = params.dateRange.endDate;
            this.getData(false, this.date);
        },


        // 切换对比日期
        changeCompareDate: function changeCompareDate(params) {
            if (params.dateRange.startDate === '' || params.dateRange.endDate === '') {
                this.lineResultData.dateCompareArr = [];
                this.lineResultData.dataCompareArr = [];
                return;
            }
            this.getData(true, params.dateRange);
        },


        // 下载
        downloadMenpiaoData: function downloadMenpiaoData() {
            _menpiaoDataPlatform2.default.downloadOperateData(this.salePlatform, this.date.startDate, this.date.endDate, true);
        }
    },
    created: function created() {
        this.getData(false, this.date);
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 836 */
/*!***********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57ec8617","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/menpiao/operateData/Main.vue ***!
  \***********************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "main"
  }, [_c('plat-form-component', {
    attrs: {
      "option": {
        dateRadio: false
      }
    },
    on: {
      "updateData": _vm.updateData
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "operate"
  }, [_c('title-date-component', {
    attrs: {
      "titleOption": _vm.titleOption,
      "initDateRange": _vm.initDateRange
    },
    on: {
      "changeDate": _vm.changeDate,
      "changeCompareDate": _vm.changeCompareDate,
      "downloadMenpiaoData": _vm.downloadMenpiaoData
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "indicators-data-box"
  }, _vm._l((_vm.indicatorsData), function(item, index) {
    return _c('indicators-data-component', {
      key: index,
      attrs: {
        "data": item
      }
    })
  })), _vm._v(" "), _c('section', {
    staticClass: "data-box"
  }, [_c('nav-component', {
    attrs: {
      "type": _vm.type,
      "currentType": _vm.currentType
    },
    on: {
      "changeNavType": _vm.changeNavType
    }
  }), _vm._v(" "), _c('line-component', {
    staticStyle: {
      "width": "95%",
      "height": "320px",
      "margin-top": "50px"
    },
    attrs: {
      "resultData": _vm.lineResultData
    }
  }), _vm._v(" "), _c('table-component', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "tableInfo": _vm.tableInfo
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 837 */
/*!*************************************************************!*\
  !*** ./src/views/dataPlatform/menpiao/productData/Main.vue ***!
  \*************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-031de88c","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Main.vue */ 838)
}
var Component = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Main.vue */ 839),
  /* template */
  __webpack_require__(/*! !../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-031de88c","hasScoped":true}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Main.vue */ 860),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-031de88c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 838 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-031de88c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/menpiao/productData/Main.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 839 */
/*!********************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/menpiao/productData/Main.vue ***!
  \********************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _PlatForm = __webpack_require__(/*! ../components/PlatForm.vue */ 119);

var _PlatForm2 = _interopRequireDefault(_PlatForm);

var _PopularProduct = __webpack_require__(/*! ./components/popular-product/PopularProduct.vue */ 840);

var _PopularProduct2 = _interopRequireDefault(_PopularProduct);

var _ProgressProduct = __webpack_require__(/*! ./components/progress-product/ProgressProduct.vue */ 844);

var _ProgressProduct2 = _interopRequireDefault(_ProgressProduct);

var _AbnormalProduct = __webpack_require__(/*! ./components/abnormal-product/AbnormalProduct.vue */ 848);

var _AbnormalProduct2 = _interopRequireDefault(_AbnormalProduct);

var _ProductAnalysis = __webpack_require__(/*! ./components/product-analysis/ProductAnalysis.vue */ 852);

var _ProductAnalysis2 = _interopRequireDefault(_ProductAnalysis);

var _Tc = __webpack_require__(/*! ../components/Tc.vue */ 856);

var _Tc2 = _interopRequireDefault(_Tc);

var _index = __webpack_require__(/*! helpers/index */ 16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        PlatFormComponent: _PlatForm2.default,
        PopularProductComponent: _PopularProduct2.default,
        ProgressProductComponent: _ProgressProduct2.default,
        AbnormalProductComponent: _AbnormalProduct2.default,
        ProductAnalysisComponent: _ProductAnalysis2.default,
        TcComponent: _Tc2.default
    },
    data: function data() {
        var data = {
            salePlatform: 0, // 平台
            isLoading: false,
            showTc: false, // 是否显示弹层
            productId: 0,
            productName: '',
            startDate: '',
            endDate: ''
        };
        return data;
    },

    methods: {
        // 更新数据
        updateData: function updateData(params) {
            this.salePlatform = params.salePlatform;
        },


        // 改变弹层显示状态
        changeShowTc: function changeShowTc(status) {
            this.showTc = status;
        }
    },
    created: function created() {
        var _this = this;

        _index.eventBus.$on('showTc', function (params) {
            _this.productId = params.productId;
            _this.productName = params.productName;
            _this.startDate = params.startDate;
            _this.endDate = params.endDate;
            _this.changeShowTc(true);
        });

        _index.eventBus.$on('closeTc', function () {
            _this.changeShowTc(false);
        });
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 840 */
/*!**************************************************************************************************!*\
  !*** ./src/views/dataPlatform/menpiao/productData/components/popular-product/PopularProduct.vue ***!
  \**************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-1c81c600","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PopularProduct.vue */ 841)
}
var Component = __webpack_require__(/*! ../../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PopularProduct.vue */ 842),
  /* template */
  __webpack_require__(/*! !../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1c81c600","hasScoped":true}!../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PopularProduct.vue */ 843),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1c81c600",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 841 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1c81c600","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/menpiao/productData/components/popular-product/PopularProduct.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 842 */
/*!*********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/menpiao/productData/components/popular-product/PopularProduct.vue ***!
  \*********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TitleDate = __webpack_require__(/*! ../../../../components/title-date/TitleDate.vue */ 10);

var _TitleDate2 = _interopRequireDefault(_TitleDate);

var _Rose = __webpack_require__(/*! ../../../../components/echarts/Rose.vue */ 248);

var _Rose2 = _interopRequireDefault(_Rose);

var _Table = __webpack_require__(/*! ../../../../components/table/Table.vue */ 43);

var _Table2 = _interopRequireDefault(_Table);

var _menpiaoDataPlatform = __webpack_require__(/*! api/menpiaoDataPlatform */ 34);

var _menpiaoDataPlatform2 = _interopRequireDefault(_menpiaoDataPlatform);

var _momentFormat = __webpack_require__(/*! ../../../../filters/moment-format */ 6);

var _momentFormat2 = _interopRequireDefault(_momentFormat);

var _percentFormat = __webpack_require__(/*! ../../../../filters/percent-format */ 33);

var _percentFormat2 = _interopRequireDefault(_percentFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    components: {
        TitleDateComponent: _TitleDate2.default,
        RoseComponent: _Rose2.default,
        TableComponent: _Table2.default
    },
    data: function data() {
        return {
            titleOption: {
                title: '7天畅销商品'
            },
            rankType: 1,
            date: {
                startDate: _momentFormat2.default.getSevenDate(),
                endDate: _momentFormat2.default.getYestoday()
            },
            roseInfo: [], // 南丁格尔图数据
            tableInfo: { // 表格数据
                title: [{
                    name: '商品名称',
                    value: 'productName',
                    style: 'width:25%;'
                }, {
                    name: '销量',
                    value: 'payQuantity'
                }, {
                    name: '销售额',
                    value: 'payAmount'
                }, {
                    name: '销售占比',
                    value: 'payAmountRate'
                }, {
                    name: '支付转化率',
                    value: 'payRate'
                }, {
                    name: '',
                    value: 'action'
                }],
                data: []
            },
            color: ['#FF2F40', '#FFBC37', '#139BFD', '#1DD978', '#4D7BF3']
        };
    },

    props: ['salePlatform'],
    watch: {
        salePlatform: {
            handler: function handler() {
                this.getData();
            },
            deep: true
        }
    },
    methods: {
        getData: function getData() {
            var _this = this;

            _menpiaoDataPlatform2.default.getSevenData(this.salePlatform, this.date.endDate, 2, 'payAmount', 2).then(function (res) {
                console.log(res);
                if (res.status === 0) {
                    var data = res.data;
                    var arr = [];
                    var roseArr = [];
                    var productId = [];
                    data.forEach(function (item, index) {
                        var o = {};
                        o.productName = {};
                        o.productName.value = '<span style="background-color:' + _this.color[index] + '">' + (index + 1) + '</span>' + item.productName;
                        o.payQuantity = {};
                        o.payQuantity.value = item.week.payQuantity;
                        o.payAmount = {};
                        o.payAmount.value = item.week.payAmount;
                        o.payAmountRate = {};
                        o.payAmountRate.value = (0, _percentFormat2.default)(item.week.payAmountRate, true);
                        o.payRate = {};
                        o.payRate.value = (0, _percentFormat2.default)(item.week.payRate, true);
                        o.action = {};
                        o.action.value = '<a href="javascript:void(0);">查看趋势</a>';
                        o.action.showTc = true;
                        o.action.params = {
                            productId: item.productId,
                            productName: item.productName,
                            startDate: _this.date.startDate,
                            endDate: _this.date.endDate
                        };
                        roseArr.push({
                            name: item.productName,
                            value: item.week.payAmount,
                            color: _this.color[index]
                        });
                        productId.push(item.productId);
                        arr.push(o);
                    });
                    _this.roseInfo = roseArr;
                    _this.tableInfo.data = arr;
                } else {
                    _this.$notify.error({
                        title: '错误',
                        message: res.message || '请求失败'
                    });
                }
            }).catch(function (err) {
                console.log(err);
            });
        }
    },
    mounted: function mounted() {
        this.getData();
    }
};

/***/ }),
/* 843 */
/*!************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c81c600","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/menpiao/productData/components/popular-product/PopularProduct.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "popular-product"
  }, [_c('title-date-component', {
    attrs: {
      "titleOption": _vm.titleOption
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "data-box"
  }, [_c('rose-component', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "roseInfo": _vm.roseInfo
    }
  }), _vm._v(" "), _c('table-component', {
    staticStyle: {
      "width": "62%",
      "margin-left": "4%"
    },
    attrs: {
      "tableInfo": _vm.tableInfo
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 844 */
/*!****************************************************************************************************!*\
  !*** ./src/views/dataPlatform/menpiao/productData/components/progress-product/ProgressProduct.vue ***!
  \****************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-f6fa9dd0","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ProgressProduct.vue */ 845)
}
var Component = __webpack_require__(/*! ../../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ProgressProduct.vue */ 846),
  /* template */
  __webpack_require__(/*! !../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-f6fa9dd0","hasScoped":true}!../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ProgressProduct.vue */ 847),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f6fa9dd0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 845 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f6fa9dd0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/menpiao/productData/components/progress-product/ProgressProduct.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 846 */
/*!***********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/menpiao/productData/components/progress-product/ProgressProduct.vue ***!
  \***********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TitleDate = __webpack_require__(/*! ../../../../components/title-date/TitleDate.vue */ 10);

var _TitleDate2 = _interopRequireDefault(_TitleDate);

var _Nav = __webpack_require__(/*! ../../../../components/nav/Nav.vue */ 37);

var _Nav2 = _interopRequireDefault(_Nav);

var _Table = __webpack_require__(/*! ../../../../components/table/Table.vue */ 43);

var _Table2 = _interopRequireDefault(_Table);

var _menpiaoDataPlatform = __webpack_require__(/*! api/menpiaoDataPlatform */ 34);

var _menpiaoDataPlatform2 = _interopRequireDefault(_menpiaoDataPlatform);

var _momentFormat = __webpack_require__(/*! ../../../../filters/moment-format */ 6);

var _momentFormat2 = _interopRequireDefault(_momentFormat);

var _percentFormat = __webpack_require__(/*! ../../../../filters/percent-format */ 33);

var _percentFormat2 = _interopRequireDefault(_percentFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    components: {
        TitleDateComponent: _TitleDate2.default,
        NavComponent: _Nav2.default,
        TableComponent: _Table2.default
    },
    data: function data() {
        return {
            titleOption: {
                title: '7天潜力商品'
            },
            type: [{
                name: '流量提升',
                value: 'intentionPV'
            }, {
                name: '访购率提升',
                value: 'visitPurchaseRate'
            }, {
                name: '销量提升',
                value: 'payQuantity'
            }],
            rankType: 'intentionPV',
            date: {
                startDate: _momentFormat2.default.getSevenDate(),
                endDate: _momentFormat2.default.getYestoday()
            },
            resultData: {},
            tableInfo: {
                title: [{
                    name: '商品名称',
                    value: 'productName',
                    style: 'width:35%;'
                }, {
                    name: '商品编号',
                    value: 'productId'
                }, {
                    name: '浏览量',
                    value: 'intentionPV'
                }, {
                    name: '流量提升',
                    value: 'growthRate'
                }],
                data: []
            },
            color: ['rgba(255, 47, 64, 1)', 'rgba(255, 47, 64, .8)', 'rgba(255, 47, 64, .6)', 'rgba(255, 47, 64, .4)', 'rgba(255, 47, 64, .2)'],
            isLoading: false
        };
    },

    props: ["salePlatform"],
    watch: {
        salePlatform: {
            handler: function handler() {
                this.getData();
            },
            deep: true
        }
    },
    methods: {
        getData: function getData() {
            var _this = this;

            this.isLoading = true;
            _menpiaoDataPlatform2.default.getSevenData(this.salePlatform, this.date.endDate, 2, this.rankType, 1).then(function (res) {
                console.log(res);
                if (res.status === 0) {
                    var data = res.data;
                    var arr = [];
                    data.forEach(function (item, index) {
                        var o = {};
                        o.productName = {};
                        o.productName.value = '<span style="background-color:' + _this.color[index] + '">' + (index + 1) + '</span>' + item.productName;
                        o.productId = {};
                        o.productId.value = item.productId;
                        if (_this.rankType === 'intentionPV') {
                            o.intentionPV = {};
                            o.intentionPV.value = item.week.intentionPV;
                        }
                        if (_this.rankType === 'visitPurchaseRate') {
                            o.visitPurchaseRate = {};
                            o.visitPurchaseRate.value = (0, _percentFormat2.default)(item.week.visitPurchaseRate, true);
                        }
                        if (_this.rankType === 'payQuantity') {
                            o.payQuantity = {};
                            o.payQuantity.value = item.week.payQuantity;
                        }
                        o.growthRate = {};
                        o.growthRate.value = item.growthRate;
                        arr.push(o);
                    });
                    _this.tableInfo.data = arr;
                } else {
                    _this.$notify.error({
                        title: '错误',
                        message: res.message || '请求失败'
                    });
                }
                _this.isLoading = false;
            }).catch(function (err) {
                console.log(err);
                _this.isLoading = false;
            });
        },


        // 切换类型
        changeNavType: function changeNavType(type) {
            this.rankType = type;
            var arr = [{
                name: '商品名称',
                value: 'productName',
                style: 'width:25%;'
            }, {
                name: '商品编号',
                value: 'productId'
            }];
            if (this.rankType === 'intentionPV') {
                arr.push({
                    name: '浏览量',
                    value: 'intentionPV'
                }, {
                    name: '流量提升',
                    value: 'growthRate'
                });
            } else if (this.rankType === 'visitPurchaseRate') {
                arr.push({
                    name: '访购率',
                    value: 'visitPurchaseRate'
                }, {
                    name: '访购率提升',
                    value: 'growthRate'
                });
            } else if (this.rankType === 'payQuantity') {
                arr.push({
                    name: '销量',
                    value: 'payQuantity'
                }, {
                    name: '销量提升',
                    value: 'growthRate'
                });
            }
            this.tableInfo.title = arr;
            this.getData();
        }
    },
    mounted: function mounted() {
        this.getData();
    }
};

/***/ }),
/* 847 */
/*!**************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6fa9dd0","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/menpiao/productData/components/progress-product/ProgressProduct.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "progress-product"
  }, [_c('title-date-component', {
    attrs: {
      "titleOption": _vm.titleOption
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "data-box"
  }, [_c('nav-component', {
    attrs: {
      "type": _vm.type,
      "currentType": _vm.rankType
    },
    on: {
      "changeNavType": _vm.changeNavType
    }
  }), _vm._v(" "), _c('table-component', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "tableInfo": _vm.tableInfo
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 848 */
/*!****************************************************************************************************!*\
  !*** ./src/views/dataPlatform/menpiao/productData/components/abnormal-product/AbnormalProduct.vue ***!
  \****************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-270a0890","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./AbnormalProduct.vue */ 849)
}
var Component = __webpack_require__(/*! ../../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./AbnormalProduct.vue */ 850),
  /* template */
  __webpack_require__(/*! !../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-270a0890","hasScoped":true}!../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./AbnormalProduct.vue */ 851),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-270a0890",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 849 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-270a0890","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/menpiao/productData/components/abnormal-product/AbnormalProduct.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 850 */
/*!***********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/menpiao/productData/components/abnormal-product/AbnormalProduct.vue ***!
  \***********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TitleDate = __webpack_require__(/*! ../../../../components/title-date/TitleDate.vue */ 10);

var _TitleDate2 = _interopRequireDefault(_TitleDate);

var _Nav = __webpack_require__(/*! ../../../../components/nav/Nav.vue */ 37);

var _Nav2 = _interopRequireDefault(_Nav);

var _Table = __webpack_require__(/*! ../../../../components/table/Table.vue */ 43);

var _Table2 = _interopRequireDefault(_Table);

var _menpiaoDataPlatform = __webpack_require__(/*! api/menpiaoDataPlatform */ 34);

var _menpiaoDataPlatform2 = _interopRequireDefault(_menpiaoDataPlatform);

var _momentFormat = __webpack_require__(/*! ../../../../filters/moment-format */ 6);

var _momentFormat2 = _interopRequireDefault(_momentFormat);

var _percentFormat = __webpack_require__(/*! ../../../../filters/percent-format */ 33);

var _percentFormat2 = _interopRequireDefault(_percentFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    components: {
        TitleDateComponent: _TitleDate2.default,
        NavComponent: _Nav2.default,
        TableComponent: _Table2.default
    },
    data: function data() {
        return {
            titleOption: {
                title: '7天退步商品'
            },
            type: [{
                name: '流量下降',
                value: 'intentionPV'
            }, {
                name: '访购率下降',
                value: 'visitPurchaseRate'
            }, {
                name: '销量下降',
                value: 'payQuantity'
            }],
            rankType: 'intentionPV',
            date: {
                startDate: _momentFormat2.default.getSevenDate(),
                endDate: _momentFormat2.default.getYestoday()
            },
            resultData: {},
            tableInfo: {
                title: [{
                    name: '商品名称',
                    value: 'productName',
                    style: 'width:35%;'
                }, {
                    name: '商品编号',
                    value: 'productId'
                }, {
                    name: '浏览量',
                    value: 'intentionPV'
                }, {
                    name: '流量下降',
                    value: 'growthRate'
                }],
                data: []
            },
            color: ['rgba(12, 222, 101, 1)', 'rgba(12, 222, 101, .8)', 'rgba(12, 222, 101, .6)', 'rgba(12, 222, 101, .4)', 'rgba(12, 222, 101, .2)'],
            isLoading: false
        };
    },

    props: ["salePlatform"],
    watch: {
        salePlatform: {
            handler: function handler() {
                this.getData();
            },
            deep: true
        }
    },
    methods: {
        getData: function getData() {
            var _this = this;

            this.isLoading = true;
            _menpiaoDataPlatform2.default.getSevenData(this.salePlatform, this.date.endDate, 1, this.rankType, 1).then(function (res) {
                console.log(res);
                if (res.status === 0) {
                    var data = res.data;
                    var arr = [];
                    var productId = [];
                    data.forEach(function (item, index) {
                        var o = {};
                        o.productName = {};
                        o.productName.value = '<span style="background-color:' + _this.color[index] + '">' + (index + 1) + '</span>' + item.productName;
                        o.productId = {};
                        o.productId.value = item.productId;
                        if (_this.rankType === 'intentionPV') {
                            o.intentionPV = {};
                            o.intentionPV.value = item.week.intentionPV;
                        }
                        if (_this.rankType === 'visitPurchaseRate') {
                            o.visitPurchaseRate = {};
                            o.visitPurchaseRate.value = (0, _percentFormat2.default)(item.week.visitPurchaseRate, true);
                        }
                        if (_this.rankType === 'payQuantity') {
                            o.payQuantity = {};
                            o.payQuantity.value = item.week.payQuantity;
                        }
                        o.growthRate = {};
                        o.growthRate.value = item.growthRate;
                        arr.push(o);
                    });
                    _this.tableInfo.data = arr;
                } else {
                    _this.$notify.error({
                        title: '错误',
                        message: res.message || '请求失败'
                    });
                }
                _this.isLoading = false;
            }).catch(function (err) {
                console.log(err);
                _this.isLoading = false;
            });
        },


        // 切换类型
        changeNavType: function changeNavType(type) {
            this.rankType = type;
            var arr = [{
                name: '商品名称',
                value: 'productName',
                style: 'width:25%;'
            }, {
                name: '商品编号',
                value: 'productId'
            }];
            if (this.rankType === 'intentionPV') {
                arr.push({
                    name: '浏览量',
                    value: 'intentionPV'
                }, {
                    name: '流量下降',
                    value: 'growthRate'
                });
            } else if (this.rankType === 'visitPurchaseRate') {
                arr.push({
                    name: '访购率',
                    value: 'visitPurchaseRate'
                }, {
                    name: '访购率下降',
                    value: 'growthRate'
                });
            } else if (this.rankType === 'payQuantity') {
                arr.push({
                    name: '销量',
                    value: 'payQuantity'
                }, {
                    name: '销量下降',
                    value: 'growthRate'
                });
            }
            this.tableInfo.title = arr;
            this.getData();
        }
    },
    mounted: function mounted() {
        this.getData();
    }
};

/***/ }),
/* 851 */
/*!**************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-270a0890","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/menpiao/productData/components/abnormal-product/AbnormalProduct.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "abnormal-product"
  }, [_c('title-date-component', {
    attrs: {
      "titleOption": _vm.titleOption
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "data-box"
  }, [_c('nav-component', {
    attrs: {
      "type": _vm.type,
      "currentType": _vm.rankType
    },
    on: {
      "changeNavType": _vm.changeNavType
    }
  }), _vm._v(" "), _c('table-component', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "tableInfo": _vm.tableInfo
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 852 */
/*!****************************************************************************************************!*\
  !*** ./src/views/dataPlatform/menpiao/productData/components/product-analysis/ProductAnalysis.vue ***!
  \****************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-3ad43ea8","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ProductAnalysis.vue */ 853)
}
var Component = __webpack_require__(/*! ../../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ProductAnalysis.vue */ 854),
  /* template */
  __webpack_require__(/*! !../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3ad43ea8","hasScoped":true}!../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ProductAnalysis.vue */ 855),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3ad43ea8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 853 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3ad43ea8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/menpiao/productData/components/product-analysis/ProductAnalysis.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 854 */
/*!***********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/menpiao/productData/components/product-analysis/ProductAnalysis.vue ***!
  \***********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TitleDate = __webpack_require__(/*! ../../../../components/title-date/TitleDate.vue */ 10);

var _TitleDate2 = _interopRequireDefault(_TitleDate);

var _Table = __webpack_require__(/*! ../../../../components/table/Table.vue */ 43);

var _Table2 = _interopRequireDefault(_Table);

var _menpiaoDataPlatform = __webpack_require__(/*! api/menpiaoDataPlatform */ 34);

var _menpiaoDataPlatform2 = _interopRequireDefault(_menpiaoDataPlatform);

var _momentFormat = __webpack_require__(/*! ../../../../filters/moment-format */ 6);

var _momentFormat2 = _interopRequireDefault(_momentFormat);

var _percentFormat = __webpack_require__(/*! ../../../../filters/percent-format */ 33);

var _percentFormat2 = _interopRequireDefault(_percentFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        TitleDateComponent: _TitleDate2.default,
        TableComponent: _Table2.default
    },
    data: function data() {
        return {
            titleOption: { // 单元块名称和日期选择配置
                title: '商品分析', // 名称
                dateRangeSelect: true, // 是否显示日期区间下拉框
                dateMaxRangeLength: 60, // 日期区间最大跨度
                download: true, // 是否显示下载按钮
                showDate: {
                    startDate: _momentFormat2.default.getSevenDate(),
                    endDate: _momentFormat2.default.getYestoday()
                }
            },
            productStr: '',
            date: {
                startDate: _momentFormat2.default.getSevenDate(),
                endDate: _momentFormat2.default.getYestoday()
            },
            initDateRange: _momentFormat2.default.getSevenDate() + ' ~ ' + _momentFormat2.default.getYestoday(),
            currentPage: 1,
            totalCount: 0,
            tableInfo: {
                title: [{
                    name: '商品编号',
                    value: 'productId',
                    style: 'width:120px; text-align:left;'
                }, {
                    name: '商品名称',
                    value: 'productName',
                    style: 'width:25%; text-align:left;'
                }, {
                    name: '浏览量',
                    value: 'intentionPV'
                }, {
                    name: '访客数',
                    value: 'intentionUV'
                }, {
                    name: '访购率',
                    value: 'visitPurchaseRate'
                }, {
                    name: '销量',
                    value: 'payQuantity'
                }, {
                    name: '销售额',
                    value: 'payAmount'
                }, {
                    name: '验证量',
                    value: 'consumeQuantity'
                }, {
                    name: '退款券量',
                    value: 'refundQuantity'
                }, {
                    name: '用户退款率',
                    value: 'refundRate'
                }, {
                    name: '',
                    value: 'action'
                }],
                data: []
            }
        };
    },

    props: ["salePlatform"],
    watch: {
        salePlatform: {
            handler: function handler() {
                this.getData();
            },
            deep: true
        }
    },
    methods: {
        getData: function getData() {
            var _this = this;

            _menpiaoDataPlatform2.default.getProductData(this.salePlatform, this.date.startDate, this.date.endDate, this.productStr, false, this.currentPage, 10).then(function (res) {
                console.log(res);
                if (res.status === 0) {
                    var data = res.data;
                    var arr = [];
                    data.forEach(function (item, index) {
                        var o = {};
                        o.productId = {};
                        o.productId.value = item.productId;
                        o.productName = {};
                        o.productName.value = item.productName;
                        o.productName.style = 'text-align:left;';
                        o.intentionPV = {};
                        o.intentionPV.value = item.sum.intentionPV;
                        o.intentionUV = {};
                        o.intentionUV.value = item.sum.intentionUV;
                        o.visitPurchaseRate = {};
                        o.visitPurchaseRate.value = (0, _percentFormat2.default)(item.sum.visitPurchaseRate, true);
                        o.payQuantity = {};
                        o.payQuantity.value = item.sum.payQuantity;
                        o.payAmount = {};
                        o.payAmount.value = item.sum.payAmount;
                        o.consumeQuantity = {};
                        o.consumeQuantity.value = item.sum.consumeQuantity;
                        o.refundQuantity = {};
                        o.refundQuantity.value = item.sum.refundQuantity;
                        o.refundRate = {};
                        o.refundRate.value = (0, _percentFormat2.default)(item.sum.refundRate, true);
                        o.action = {};
                        o.action.value = '<a href="javascript:void(0);">查看趋势</a>';
                        o.action.showTc = true;
                        o.action.params = {
                            productId: item.productId,
                            productName: item.productName,
                            startDate: _this.date.startDate,
                            endDate: _this.date.endDate
                        };
                        arr.push(o);
                    });
                    _this.tableInfo.data = arr;
                    _this.totalCount = res.totalCount;
                } else {
                    _this.$notify.error({
                        title: '错误',
                        message: res.message || '请求失败'
                    });
                }
            }).catch(function (err) {
                _this.$notify.error({
                    title: '错误',
                    message: err.message || '请求失败'
                });
                console.log(err);
            });
        },


        // 切换页码
        currentChangeFunc: function currentChangeFunc(ev) {
            this.currentPage = ev.current;
            this.getData();
        },


        // 切换日期
        changeDate: function changeDate(params) {
            this.date.startDate = params.dateRange.startDate;
            this.date.endDate = params.dateRange.endDate;
            this.currentPage = 1;
            this.getData();
        },


        // 下载
        downloadMenpiaoData: function downloadMenpiaoData() {
            _menpiaoDataPlatform2.default.downloadProductData(this.salePlatform, this.date.startDate, this.date.endDate, this.productStr, false);
        }
    },
    mounted: function mounted() {
        this.getData();
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 855 */
/*!**************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ad43ea8","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/menpiao/productData/components/product-analysis/ProductAnalysis.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "product-analysis"
  }, [_c('title-date-component', {
    attrs: {
      "titleOption": _vm.titleOption,
      "initDateRange": _vm.initDateRange
    },
    on: {
      "changeDate": _vm.changeDate,
      "downloadMenpiaoData": _vm.downloadMenpiaoData
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "data-box"
  }, [_c('section', {
    staticClass: "search-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productStr),
      expression: "productStr"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入商品名称、编号"
    },
    domProps: {
      "value": (_vm.productStr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.productStr = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "搜索"
    },
    on: {
      "click": function($event) {
        _vm.getData()
      }
    }
  })]), _vm._v(" "), _c('table-component', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "tableInfo": _vm.tableInfo
    }
  }), _vm._v(" "), _c('v-pagination', {
    attrs: {
      "current": _vm.currentPage,
      "total": Math.ceil(_vm.totalCount / 10),
      "size": 'md',
      "first": false,
      "last": false
    },
    on: {
      "current-change": function($event) {
        _vm.currentChangeFunc($event)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 856 */
/*!**********************************************************!*\
  !*** ./src/views/dataPlatform/menpiao/components/Tc.vue ***!
  \**********************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-44be4c5b","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Tc.vue */ 857)
}
var Component = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Tc.vue */ 858),
  /* template */
  __webpack_require__(/*! !../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-44be4c5b","hasScoped":true}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Tc.vue */ 859),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-44be4c5b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 857 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-44be4c5b","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/menpiao/components/Tc.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 858 */
/*!*****************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/menpiao/components/Tc.vue ***!
  \*****************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TitleDate = __webpack_require__(/*! ../../components/title-date/TitleDate.vue */ 10);

var _TitleDate2 = _interopRequireDefault(_TitleDate);

var _Nav = __webpack_require__(/*! ../../components/nav/Nav.vue */ 37);

var _Nav2 = _interopRequireDefault(_Nav);

var _Line = __webpack_require__(/*! ../../components/echarts/Line.vue */ 78);

var _Line2 = _interopRequireDefault(_Line);

var _menpiaoDataPlatform = __webpack_require__(/*! api/menpiaoDataPlatform */ 34);

var _menpiaoDataPlatform2 = _interopRequireDefault(_menpiaoDataPlatform);

var _index = __webpack_require__(/*! helpers/index */ 16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        TitleDateComponent: _TitleDate2.default,
        NavComponent: _Nav2.default,
        LineComponent: _Line2.default
    },
    data: function data() {
        return {
            titleOption: {
                title: this.productName,
                dateRangeSelect: true,
                dateMaxRangeLength: 60, // 日期区间最大跨度
                dateCompareSelect: true,
                showDate: {
                    startDate: this.startDateParams,
                    endDate: this.endDateParams
                }
            },
            type: [{
                name: '销量',
                value: 'payQuantity'
            }, {
                name: '销售额',
                value: 'payAmount'
            }, {
                name: '浏览量',
                value: 'intentionPV'
            }, {
                name: '访客量',
                value: 'intentionUV'
            }, {
                name: '访购率',
                value: 'visitPurchaseRate'
            }, {
                name: '下单用户数',
                value: 'orderUserNum'
            }, {
                name: '支付用户数',
                value: 'payUserNum'
            }, {
                name: '客单价',
                value: 'customerPrice'
            }],
            currentType: 'payQuantity', // 当前纬度
            date: {
                startDate: this.startDateParams,
                endDate: this.endDateParams
            },
            initDateRange: this.startDateParams + ' ~ ' + this.endDateParams,
            typeData: {
                allTypeData: { // 所有维度数据
                    payQuantity: [],
                    payAmount: [],
                    intentionPV: [],
                    intentionUV: [],
                    visitPurchaseRate: [],
                    orderUserNum: [],
                    payUserNum: [],
                    customerPrice: []
                },
                allTypeCompareData: { // 所有对比纬度数据
                    payQuantity: [],
                    payAmount: [],
                    intentionPV: [],
                    intentionUV: [],
                    visitPurchaseRate: [],
                    orderUserNum: [],
                    payUserNum: [],
                    customerPrice: []
                }
            },
            resultData: {
                dateArr: [],
                dataArr: [],
                dateCompareArr: [], // 对比日期
                dataCompareArr: [], // 对比数据
                currentTypeName: '销量'
            }
        };
    },

    props: ["salePlatform", "productId", "productName", "startDateParams", "endDateParams"],
    methods: {
        // 关闭弹层
        closeTc: function closeTc() {
            _index.eventBus.$emit('closeTc');
        },

        // 获取单品数据
        getData: function getData(isCompare, date) {
            var _this = this;

            this.isLoading = true;
            _menpiaoDataPlatform2.default.getProductData(this.salePlatform, date.startDate, date.endDate, this.productId, true).then(function (res) {
                console.log(res);
                if (res.status === 0) {
                    var data = res.data.length === 0 || res.data[0].daily === null ? [] : res.data[0].daily;
                    _this.formatAllData(data, isCompare);
                } else {
                    _this.$notify.error({
                        title: '错误',
                        message: res.message || '请求失败'
                    });
                }
                _this.isLoading = false;
            }).catch(function (err) {
                if (isCompare === true) {
                    _this.resultData.dateCompareArr = [];
                    _this.resultData.dataCompareArr = [];
                } else {
                    _this.resultData.dateArr = [];
                    _this.resultData.dataArr = [];
                }
                console.log(err);
                _this.isLoading = false;
            });
        },
        formatAllData: function formatAllData(data, isCompare) {
            var date = [];
            var initData = {
                payQuantity: [],
                payAmount: [],
                intentionPV: [],
                intentionUV: [],
                visitPurchaseRate: [],
                orderUserNum: [],
                payUserNum: [],
                customerPrice: []
            };
            data.forEach(function (item) {
                date.push(item.date);
                initData.payQuantity.push(item.payQuantity);
                initData.payAmount.push(item.payAmount);
                initData.intentionPV.push(item.intentionPV);
                initData.intentionUV.push(item.intentionUV);
                initData.visitPurchaseRate.push(item.visitPurchaseRate);
                initData.orderUserNum.push(item.orderUserNum);
                initData.payUserNum.push(item.payUserNum);
                initData.customerPrice.push(item.customerPrice);
            });
            if (isCompare === true) {
                this.typeData.allTypeCompareData = initData;
                this.$set(this.resultData, 'dateCompareArr', date);
                this.$set(this.resultData, 'dataCompareArr', this.typeData.allTypeCompareData[this.currentType]);
            } else {
                this.typeData.allTypeData = initData;
                this.$set(this.resultData, 'dateArr', date);
                this.$set(this.resultData, 'dataArr', this.typeData.allTypeData[this.currentType]);
            }
        },


        // 切换类型
        changeNavType: function changeNavType(type) {
            var _this2 = this;

            this.currentType = type;
            var currentTypeName = this.type.find(function (item) {
                return item.value === _this2.currentType;
            });
            this.$set(this.resultData, 'dataArr', this.typeData.allTypeData[this.currentType]);
            this.$set(this.resultData, 'dataCompareArr', this.typeData.allTypeCompareData[this.currentType]);
            this.$set(this.resultData, 'currentTypeName', currentTypeName.name);
        },


        // 切换日期
        changeDate: function changeDate(params) {
            this.date.startDate = params.dateRange.startDate;
            this.date.endDate = params.dateRange.endDate;
            this.getData(false, this.date);
        },


        // 切换对比日期
        changeCompareDate: function changeCompareDate(params) {
            if (params.dateRange.startDate === '' || params.dateRange.endDate === '') {
                this.resultData.dateCompareArr = [];
                this.resultData.dataCompareArr = [];
                return;
            }
            this.getData(true, params.dateRange);
        }
    },
    created: function created() {
        this.getData(false, this.date);
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 859 */
/*!********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44be4c5b","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/menpiao/components/Tc.vue ***!
  \********************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "dark"
  }, [_c('section', {
    staticClass: "content-box"
  }, [_c('title-date-component', {
    attrs: {
      "titleOption": _vm.titleOption,
      "initDateRange": _vm.initDateRange
    },
    on: {
      "changeDate": _vm.changeDate,
      "changeCompareDate": _vm.changeCompareDate
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "data-box"
  }, [_c('nav-component', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "type": _vm.type,
      "currentType": _vm.currentType
    },
    on: {
      "changeNavType": _vm.changeNavType
    }
  }), _vm._v(" "), _c('line-component', {
    staticStyle: {
      "height": "320px",
      "margin-top": "50px"
    },
    attrs: {
      "resultData": _vm.resultData
    }
  })], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "close-btn",
    on: {
      "click": _vm.closeTc
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 860 */
/*!***********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-031de88c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/menpiao/productData/Main.vue ***!
  \***********************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "main"
  }, [_c('plat-form-component', {
    attrs: {
      "option": {
        dateRadio: false
      }
    },
    on: {
      "updateData": _vm.updateData
    }
  }), _vm._v(" "), _c('popular-product-component', {
    attrs: {
      "salePlatform": _vm.salePlatform
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "box"
  }, [_c('progress-product-component', {
    attrs: {
      "salePlatform": _vm.salePlatform
    }
  }), _vm._v(" "), _c('abnormal-product-component', {
    attrs: {
      "salePlatform": _vm.salePlatform
    }
  })], 1), _vm._v(" "), _c('product-analysis-component', {
    attrs: {
      "salePlatform": _vm.salePlatform
    }
  }), _vm._v(" "), (_vm.showTc) ? _c('tc-component', {
    attrs: {
      "salePlatform": _vm.salePlatform,
      "productId": _vm.productId,
      "productName": _vm.productName,
      "startDateParams": _vm.startDate,
      "endDateParams": _vm.endDate
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 861 */
/*!*****************************************************************!*\
  !*** ./src/views/dataPlatform/menpiao/transactionData/Main.vue ***!
  \*****************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-8d471706","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Main.vue */ 862)
}
var Component = __webpack_require__(/*! ../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Main.vue */ 863),
  /* template */
  __webpack_require__(/*! !../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-8d471706","hasScoped":true}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Main.vue */ 872),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8d471706",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 862 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8d471706","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/menpiao/transactionData/Main.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 863 */
/*!************************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/menpiao/transactionData/Main.vue ***!
  \************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _PlatForm = __webpack_require__(/*! ../components/PlatForm.vue */ 119);

var _PlatForm2 = _interopRequireDefault(_PlatForm);

var _Transaction = __webpack_require__(/*! ./components/transaction/Transaction.vue */ 864);

var _Transaction2 = _interopRequireDefault(_Transaction);

var _Trends = __webpack_require__(/*! ./components/trends/Trends.vue */ 868);

var _Trends2 = _interopRequireDefault(_Trends);

var _menpiaoDataPlatform = __webpack_require__(/*! api/menpiaoDataPlatform */ 34);

var _menpiaoDataPlatform2 = _interopRequireDefault(_menpiaoDataPlatform);

var _momentFormat = __webpack_require__(/*! ../../filters/moment-format */ 6);

var _momentFormat2 = _interopRequireDefault(_momentFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        PlatFormComponent: _PlatForm2.default,
        TransactionComponent: _Transaction2.default,
        TrendsComponent: _Trends2.default
    },
    data: function data() {
        var data = {
            resultDataSum: {},
            resultDataDaily: {},
            salePlatform: 0, // 平台
            date: {
                startDate: _momentFormat2.default.getSevenDate(),
                endDate: _momentFormat2.default.getYestoday()
            },
            isLoading: false
        };
        return data;
    },

    methods: {
        // 获取数据
        getData: function getData() {
            var _this = this;

            this.isLoading = true;
            _menpiaoDataPlatform2.default.getIndexData(this.salePlatform, this.date.startDate, this.date.endDate, true).then(function (res) {
                console.log(res);
                if (res.status === 0) {
                    _this.resultDataSum = res.data.sum || {};
                    _this.resultDataDaily = res.data.daily || [];
                } else {
                    _this.$notify.error({
                        title: '错误',
                        message: res.message || '请求失败'
                    });
                }
                _this.isLoading = false;
            }).catch(function (err) {
                console.log(err);
                _this.isLoading = false;
            });
        },


        // 更新数据
        updateData: function updateData(params) {
            this.salePlatform = params.salePlatform;
        }
    },
    created: function created() {
        this.getData();
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 864 */
/*!***********************************************************************************************!*\
  !*** ./src/views/dataPlatform/menpiao/transactionData/components/transaction/Transaction.vue ***!
  \***********************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-d155dd90","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Transaction.vue */ 865)
}
var Component = __webpack_require__(/*! ../../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Transaction.vue */ 866),
  /* template */
  __webpack_require__(/*! !../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-d155dd90","hasScoped":true}!../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Transaction.vue */ 867),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d155dd90",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 865 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d155dd90","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/menpiao/transactionData/components/transaction/Transaction.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 866 */
/*!******************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/menpiao/transactionData/components/transaction/Transaction.vue ***!
  \******************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TitleDate = __webpack_require__(/*! ../../../../components/title-date/TitleDate.vue */ 10);

var _TitleDate2 = _interopRequireDefault(_TitleDate);

var _LineTips = __webpack_require__(/*! ../../../../operateData/components/line-tips/LineTips.vue */ 94);

var _LineTips2 = _interopRequireDefault(_LineTips);

var _menpiaoDataPlatform = __webpack_require__(/*! api/menpiaoDataPlatform */ 34);

var _menpiaoDataPlatform2 = _interopRequireDefault(_menpiaoDataPlatform);

var _dataFormat = __webpack_require__(/*! ../../../../filters/data-format */ 117);

var _dataFormat2 = _interopRequireDefault(_dataFormat);

var _momentFormat = __webpack_require__(/*! ../../../../filters/moment-format */ 6);

var _momentFormat2 = _interopRequireDefault(_momentFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        LineTipsComponent: _LineTips2.default,
        TitleDateComponent: _TitleDate2.default
    },
    filters: {
        dataformat: _dataFormat2.default
    },
    data: function data() {
        return {
            titleOption: {
                title: '交易分析',
                dateRangeSelect: true,
                dateMaxRangeLength: 60
            },
            date: {
                startDate: _momentFormat2.default.getSevenDate(),
                endDate: _momentFormat2.default.getYestoday()
            },
            initDateRange: _momentFormat2.default.getSevenDate() + ' ~ ' + _momentFormat2.default.getYestoday(),
            resultData: this.resultDataSum,
            isLoading: false
        };
    },

    props: ['resultDataSum', 'salePlatform'],
    computed: {
        // 访购率指标
        lineTipsInfo: function lineTipsInfo() {
            return {
                name: '访购率',
                value: this.resultData.visitPurchaseRate,
                unit: '%',
                compare: this.resultData.visitPurchaseRatePercent,
                title: '访购率'
            };
        }
    },
    watch: {
        salePlatform: {
            handler: function handler() {
                this.getData();
            },
            deep: true
        },

        resultDataSum: {
            handler: function handler() {
                this.resultData = this.resultDataSum;
            },
            deep: true
        }
    },
    methods: {
        getData: function getData() {
            var _this = this;

            this.isLoading = true;
            _menpiaoDataPlatform2.default.getIndexData(this.salePlatform, this.date.startDate, this.date.endDate, false).then(function (res) {
                console.log(res);
                if (res.status === 0) {
                    _this.resultData = res.data.sum === null ? {} : res.data.sum;
                } else {
                    _this.$notify.error({
                        title: '错误',
                        message: res.message || '请求失败'
                    });
                }
                _this.isLoading = false;
            }).catch(function (err) {
                console.log(err);
                _this.isLoading = false;
            });
        },


        // 切换日期
        changeDate: function changeDate(params) {
            this.date.startDate = params.dateRange.startDate;
            this.date.endDate = params.dateRange.endDate;
            this.getData();
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 867 */
/*!*********************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d155dd90","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/menpiao/transactionData/components/transaction/Transaction.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "transaction-box"
  }, [_c('title-date-component', {
    attrs: {
      "titleOption": _vm.titleOption,
      "initDateRange": _vm.initDateRange
    },
    on: {
      "changeDate": _vm.changeDate
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "data-box"
  }, [_c('line-tips-component', {
    staticStyle: {
      "margin-top": "45px"
    },
    attrs: {
      "lineTipsInfo": _vm.lineTipsInfo
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "data"
  }, [_c('section', [_c('span', {
    attrs: {
      "title": "浏览次数"
    }
  }, [_c('i', [_vm._v("浏览量")]), _vm._v(_vm._s(_vm._f("dataformat")(_vm.resultData.intentionPV)))]), _vm._v(" "), _c('span', {
    attrs: {
      "title": "浏览用户数量"
    }
  }, [_c('i', [_vm._v("访客数")]), _vm._v(_vm._s(_vm._f("dataformat")(_vm.resultData.intentionUV)))])]), _vm._v(" "), _c('section', [_c('span', {
    attrs: {
      "title": "所售商品有下单行为的用户数量"
    }
  }, [_c('i', [_vm._v("下单用户数")]), _vm._v(_vm._s(_vm._f("dataformat")(_vm.resultData.orderUserNum)))]), _vm._v(" "), _c('span', {
    attrs: {
      "title": "所售商品产生的订单数量"
    }
  }, [_c('i', [_vm._v("订单量")]), _vm._v(_vm._s(_vm._f("dataformat")(_vm.resultData.orderNum)))])]), _vm._v(" "), _c('section', [_c('span', {
    attrs: {
      "title": "产生的支付行为的用户数量"
    }
  }, [_c('i', [_vm._v("支付用户数")]), _vm._v(_vm._s(_vm._f("dataformat")(_vm.resultData.payUserNum)))]), _vm._v(" "), _c('span', {
    attrs: {
      "title": "产生的支付订单数量"
    }
  }, [_c('i', [_vm._v("支付订单量")]), _vm._v(_vm._s(_vm._f("dataformat")(_vm.resultData.payOrderNum)))]), _vm._v(" "), _c('span', {
    attrs: {
      "title": "销售额/支付用户数"
    }
  }, [_c('i', [_vm._v("客单价")]), _vm._v(_vm._s(_vm.resultData.customerPrice))])])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "funnel"
  }, [_c('section', [_c('span', [_vm._v("浏览")])]), _vm._v(" "), _c('section', [_c('span', [_vm._v("下单")])]), _vm._v(" "), _c('section', [_c('span', [_vm._v("支付")])])])
}]}

/***/ }),
/* 868 */
/*!*************************************************************************************!*\
  !*** ./src/views/dataPlatform/menpiao/transactionData/components/trends/Trends.vue ***!
  \*************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-03b6098c","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Trends.vue */ 869)
}
var Component = __webpack_require__(/*! ../../../../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Trends.vue */ 870),
  /* template */
  __webpack_require__(/*! !../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-03b6098c","hasScoped":true}!../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Trends.vue */ 871),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-03b6098c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 869 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-03b6098c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dataPlatform/menpiao/transactionData/components/trends/Trends.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 870 */
/*!********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dataPlatform/menpiao/transactionData/components/trends/Trends.vue ***!
  \********************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TitleDate = __webpack_require__(/*! ../../../../components/title-date/TitleDate.vue */ 10);

var _TitleDate2 = _interopRequireDefault(_TitleDate);

var _Nav = __webpack_require__(/*! ../../../../components/nav/Nav.vue */ 37);

var _Nav2 = _interopRequireDefault(_Nav);

var _Line = __webpack_require__(/*! ../../../../components/echarts/Line.vue */ 78);

var _Line2 = _interopRequireDefault(_Line);

var _menpiaoDataPlatform = __webpack_require__(/*! api/menpiaoDataPlatform */ 34);

var _menpiaoDataPlatform2 = _interopRequireDefault(_menpiaoDataPlatform);

var _momentFormat = __webpack_require__(/*! ../../../../filters/moment-format */ 6);

var _momentFormat2 = _interopRequireDefault(_momentFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        TitleDateComponent: _TitleDate2.default,
        NavComponent: _Nav2.default,
        LineComponent: _Line2.default
    },
    data: function data() {
        var data = {
            titleOption: { // 单元块名称和日期选择配置
                title: '交易趋势分析', // 名称
                dateRangeSelect: true, // 是否显示日期区间下拉框
                dateMaxRangeLength: 60, // 日期区间最大跨度
                dateCompareSelect: true,
                download: true, // 是否显示下载按钮
                showDate: {
                    startDate: _momentFormat2.default.getSevenDate(),
                    endDate: _momentFormat2.default.getYestoday()
                }
            },
            type: [{
                name: '销量',
                value: 'payQuantity'
            }, {
                name: '销售额',
                value: 'payAmount'
            }, {
                name: '浏览量',
                value: 'intentionPV'
            }, {
                name: '访客量',
                value: 'intentionUV'
            }, {
                name: '访购率',
                value: 'visitPurchaseRate'
            }, {
                name: '下单用户数',
                value: 'orderUserNum'
            }, {
                name: '支付用户数',
                value: 'payUserNum'
            }, {
                name: '客单价',
                value: 'customerPrice'
            }],
            currentType: 'payQuantity', // 当前纬度
            date: {
                startDate: _momentFormat2.default.getSevenDate(),
                endDate: _momentFormat2.default.getYestoday()
            },
            initDateRange: _momentFormat2.default.getSevenDate() + ' ~ ' + _momentFormat2.default.getYestoday(),
            typeData: {
                allTypeData: { // 所有维度数据
                    payQuantity: [],
                    payAmount: [],
                    intentionPV: [],
                    intentionUV: [],
                    visitPurchaseRate: [],
                    orderUserNum: [],
                    payUserNum: [],
                    customerPrice: []
                },
                allTypeCompareData: { // 所有对比纬度数据
                    payQuantity: [],
                    payAmount: [],
                    intentionPV: [],
                    intentionUV: [],
                    visitPurchaseRate: [],
                    orderUserNum: [],
                    payUserNum: [],
                    customerPrice: []
                }
            },
            resultData: {
                dateArr: [],
                dataArr: [],
                dateCompareArr: [], // 对比日期
                dataCompareArr: [], // 对比数据
                currentTypeName: '销量'
            }
        };
        return data;
    },

    props: ['resultDataDaily', 'salePlatform'],
    watch: {
        salePlatform: {
            handler: function handler() {
                this.getData(false, this.date);
            },
            deep: true
        },

        resultDataDaily: {
            handler: function handler() {
                this.formatAllData(this.resultDataDaily);
            },
            deep: true
        }
    },
    methods: {
        formatAllData: function formatAllData(data, isCompare) {
            var date = [];
            var initData = {
                payQuantity: [],
                payAmount: [],
                intentionPV: [],
                intentionUV: [],
                visitPurchaseRate: [],
                orderUserNum: [],
                payUserNum: [],
                customerPrice: []
            };
            data.forEach(function (item) {
                date.push(item.date);
                initData.payQuantity.push(item.payQuantity);
                initData.payAmount.push(item.payAmount);
                initData.intentionPV.push(item.intentionPV);
                initData.intentionUV.push(item.intentionUV);
                initData.visitPurchaseRate.push(item.visitPurchaseRate);
                initData.orderUserNum.push(item.orderUserNum);
                initData.payUserNum.push(item.payUserNum);
                initData.customerPrice.push(item.customerPrice);
            });
            if (isCompare === true) {
                this.typeData.allTypeCompareData = initData;
                this.$set(this.resultData, 'dateCompareArr', date);
                this.$set(this.resultData, 'dataCompareArr', this.typeData.allTypeCompareData[this.currentType]);
            } else {
                this.typeData.allTypeData = initData;
                this.$set(this.resultData, 'dateArr', date);
                this.$set(this.resultData, 'dataArr', this.typeData.allTypeData[this.currentType]);
            }
        },
        getData: function getData(isCompare, date) {
            var _this = this;

            this.isLoading = true;
            _menpiaoDataPlatform2.default.getIndexData(this.salePlatform, date.startDate, date.endDate, true).then(function (res) {
                console.log(res);
                if (res.status === 0) {
                    var data = res.data.daily === null ? [] : res.data.daily;
                    _this.formatAllData(data, isCompare);
                } else {
                    _this.$notify.error({
                        title: '错误',
                        message: res.message || '请求失败'
                    });
                }
                _this.isLoading = false;
            }).catch(function (err) {
                if (isCompare === true) {
                    _this.resultData.dateCompareArr = [];
                    _this.resultData.dataCompareArr = [];
                } else {
                    _this.resultData.dateArr = [];
                    _this.resultData.dataArr = [];
                }
                console.log(err);
                _this.isLoading = false;
            });
        },


        // 切换类型
        changeNavType: function changeNavType(type) {
            var _this2 = this;

            this.currentType = type;
            var currentTypeName = this.type.find(function (item) {
                return item.value === _this2.currentType;
            });
            this.$set(this.resultData, 'dataArr', this.typeData.allTypeData[this.currentType]);
            this.$set(this.resultData, 'dataCompareArr', this.typeData.allTypeCompareData[this.currentType]);
            this.$set(this.resultData, 'currentTypeName', currentTypeName.name);
        },


        // 切换日期
        changeDate: function changeDate(params) {
            this.date.startDate = params.dateRange.startDate;
            this.date.endDate = params.dateRange.endDate;
            this.getData(false, this.date);
        },


        // 切换对比日期
        changeCompareDate: function changeCompareDate(params) {
            if (params.dateRange.startDate === '' || params.dateRange.endDate === '') {
                this.resultData.dateCompareArr = [];
                this.resultData.dataCompareArr = [];
                return;
            }
            this.getData(true, params.dateRange);
        },


        // 下载
        downloadMenpiaoData: function downloadMenpiaoData() {
            _menpiaoDataPlatform2.default.downloadTransactionData(this.salePlatform, this.date.startDate, this.date.endDate, true);
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 871 */
/*!***********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03b6098c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/menpiao/transactionData/components/trends/Trends.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "business-trends"
  }, [_c('title-date-component', {
    attrs: {
      "titleOption": _vm.titleOption,
      "initDateRange": _vm.initDateRange
    },
    on: {
      "changeDate": _vm.changeDate,
      "changeCompareDate": _vm.changeCompareDate,
      "downloadMenpiaoData": _vm.downloadMenpiaoData
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "data-box"
  }, [_c('nav-component', {
    attrs: {
      "type": _vm.type,
      "currentType": _vm.currentType
    },
    on: {
      "changeNavType": _vm.changeNavType
    }
  }), _vm._v(" "), _c('line-component', {
    staticStyle: {
      "width": "95%",
      "height": "320px",
      "margin-top": "50px"
    },
    attrs: {
      "resultData": _vm.resultData
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 872 */
/*!***************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d471706","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/menpiao/transactionData/Main.vue ***!
  \***************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "main"
  }, [_c('plat-form-component', {
    attrs: {
      "option": {
        dateRadio: false
      }
    },
    on: {
      "updateData": _vm.updateData
    }
  }), _vm._v(" "), _c('transaction-component', {
    attrs: {
      "resultDataSum": _vm.resultDataSum,
      "salePlatform": _vm.salePlatform
    }
  }), _vm._v(" "), _c('trends-component', {
    attrs: {
      "resultDataDaily": _vm.resultDataDaily,
      "salePlatform": _vm.salePlatform
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 873 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-24189c8d","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/newGtyDataCenter/customerSourceAnalyse.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 874 */
/*!*********************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/newGtyDataCenter/customerSourceAnalyse.vue ***!
  \*********************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _customerSourceAnalyse = __webpack_require__(/*! api/customerSourceAnalyse */ 875);

var _pie = __webpack_require__(/*! ./echarts/pie.vue */ 876);

var _pie2 = _interopRequireDefault(_pie);

var _map = __webpack_require__(/*! ./echarts/map.vue */ 880);

var _map2 = _interopRequireDefault(_map);

var _toFixedPercent = __webpack_require__(/*! filters/toFixedPercent.js */ 168);

var _toFixedPercent2 = _interopRequireDefault(_toFixedPercent);

var _table = __webpack_require__(/*! ./table.vue */ 885);

var _table2 = _interopRequireDefault(_table);

var _index = __webpack_require__(/*! components/datepicker/index */ 236);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// require("flatpickr/dist/themes/material-blue.css");
exports.default = {
    components: {
        PieGram: _pie2.default,
        DataMap: _map2.default,
        dataTable: _table2.default,
        rangeDatepicker: _index2.default
    },
    data: function data() {
        return {
            poiList: [],
            //省份客源
            dataList: [],
            initLoading: true,
            tableDataList: [], //城市客源
            poiOtherProvinces: [], //省份維度的poi省份客源,
            allOtherProvinces: [], //省份維度的省份客源,
            poiOtherCities: [], //省份維度的省外城市poi客源,
            allOtherCities: [], //省份維度的省外城市省份客源,
            cityDataList: [],
            tableTitle: "",
            provinceId: "",
            color: '#fff',
            bgColor: "#1da1ff",
            disableColor: "#ccc",
            changeClass: true,
            showTableMask: false,
            tableText: true,
            cityText: true,
            poiName: "",
            provinceName: "",
            selectedIndex: 2,
            searchPoi: "",
            poiId: "",
            region: 2,
            showTable: true,
            showTd: false,
            mapIdOne: "chartsMapOne",
            mapIdTwo: "chartsMapTwo",
            show: false,
            description: "",
            subDescription: "",
            provinceDescription: [],
            cityDescription: [],
            searchInfo: false,
            dateInputOption: {
                mode: "range",
                maxDate: this.getDateTime(new Date(new Date().valueOf())),
                onClose: function (value) {
                    this.getDateRange();
                }.bind(this)
            },
            dateRange: "",
            startDate: this.getDateTime(new Date(new Date().valueOf() - 30 * 24 * 60 * 60 * 1000)),
            endDate: this.getDateTime(new Date(new Date().valueOf()))
        };
    },

    created: function created() {
        var _this = this;

        this.getPoi().then(function (i) {
            setTimeout(function () {
                _this.initLoading = false;
            }, 600);
            _this.poiName = _this.poiList[0].poiName;
            _this.poiId = _this.poiList[0].poiId;
            _this.provinceName = _this.poiList[0].provinceName;
            _this.getPoiSales();
            _this.getPoiSalesInProvince();
        });
    },
    watch: {
        startDate: function startDate() {
            this.getPoiSales();
        },
        endDate: function endDate() {
            this.getPoiSales();
        },
        poiId: function poiId() {
            this.getPoiSales();
            this.getPoiSalesInProvince();
        },
        provinceId: function provinceId() {
            this.getPoiSalesInProvinceCity();
        }
    },
    methods: {
        showPoiList: function showPoiList() {
            this.show = true;
            this.getPoi();
        },
        hidePoiList: function hidePoiList(e) {
            if (e.target.id !== "poiInput") {
                this.show = false;
            }
        },
        getPoiList: function getPoiList(poi) {
            if (poi.poiName && poi.poiName.indexOf("无对应匹配项") === -1) {
                this.poiName = poi.poiName;
                this.poiId = poi.poiId;
                this.provinceName = poi.provinceName;
                this.show = false;
            }
            this.getPoiSales();
        },
        getPoi: function getPoi() {
            var _this2 = this;

            return (0, _customerSourceAnalyse.getPoi)().then(function (response) {
                if (response.status === 0) {
                    if (response.data) {
                        _this2.poiList = response.data.poiInfos;
                        _this2.searchInfo = true;
                    }
                } else {
                    _this2.alert(response.message || "接口返回信息有误");
                }
            }).catch(function (error) {
                _this2.searchInfo = false;
                _this2.poiList = [];
                _this2.alert(error);
            });
        },
        getPoiSales: function getPoiSales() {
            var _this3 = this;

            return (0, _customerSourceAnalyse.getPoiSales)({
                poiId: this.poiId,
                region: this.region,
                startDate: this.startDate,
                endDate: this.endDate
            }).then(function (response) {
                if (response.status === 0) {
                    if (response.data) {
                        if (_this3.region === 2) {
                            _this3.dataList = response.data.ratioInfos;
                            _this3.dataList = _this3.convertName(_this3.dataList);
                        }
                        if (_this3.region === 1) {
                            _this3.tableDataList = response.data.ratioInfos;
                        }
                        _this3.description = response.data.desc;
                        _this3.subDescription = response.data.subDesc;
                    }
                } else {
                    _this3.alert(response.message || "接口返回信息有误");
                }
            }).catch(function (error) {
                _this3.dataList = [];
                _this3.alert(error);
            });
        },
        getPoiSalesInProvince: function getPoiSalesInProvince() {
            var _this4 = this;

            (0, _customerSourceAnalyse.getPoiSalesInProvince)({
                poiId: this.poiId
            }).then(function (response) {
                if (response.status === 0) {
                    if (response.data) {
                        _this4.poiOtherProvinces = _this4.convertName(response.data.poiOtherProvinces);
                        _this4.allOtherProvinces = _this4.convertName(response.data.allOtherProvinces);
                        _this4.allOtherCities = _this4.convertName(response.data.allOtherCities.slice(0, 10));
                        _this4.poiOtherCities = _this4.convertName(response.data.poiOtherCities.slice(0, 10));
                        _this4.provinceDescription = response.data.provinceDescs;
                        _this4.cityDescription = response.data.cityDescs;
                    }
                } else {
                    _this4.alert(response.message || "接口返回信息有误");
                }
            }).catch(function (error) {
                _this4.poiList = [];
                _this4.alert(error);
            });
        },
        getPoiSalesInProvinceCity: function getPoiSalesInProvinceCity() {
            var _this5 = this;

            (0, _customerSourceAnalyse.getPoiSalesInProvinceCity)({
                poiId: this.poiId,
                provinceId: this.provinceId,
                startDate: this.startDate,
                endDate: this.endDate
            }).then(function (response) {
                if (response.status === 0) {
                    if (response.data) {
                        _this5.cityDataList = response.data.saleRatioInfos;
                    }
                } else {
                    _this5.alert(response.message || "接口返回信息有误");
                }
            }).catch(function (error) {
                _this5.poiList = [];
                _this5.alert(error);
            });
        },
        selectTime: function selectTime(index, day) {
            var today = new Date();
            var nowVal = today.valueOf();
            var TimeStart = new Date(nowVal - day * 24 * 60 * 60 * 1000);
            this.startDate = this.getDateTime(TimeStart);
            this.endDate = this.getDateTime(today);
            this.selectedIndex = index;
            if (this.selectedIndex !== 3) {
                this.dateRange = "自定义时段";
            }
            this.getPoiSales();
        },
        getDateTime: function getDateTime(date) {
            var result = "";
            if (date) {
                result += date.getFullYear();
                var month = date.getMonth() + 1;
                result += month < 10 ? "0" + month : month;
                var dateInMonth = date.getDate();
                result += dateInMonth < 10 ? "0" + dateInMonth : dateInMonth;
            }
            return result;
        },
        selectRegion: function selectRegion(region) {
            this.region = region;
            this.getPoiSales();
        },
        alert: function alert(message) {
            this.$alert({
                title: "提示",
                message: message,
                showCancelButton: false,
                closeOnClickModal: false
            });
        },
        search: function search(text) {
            var str = text.replace(/^\s+|\s+$/g, "");
            var searchArr = [];
            if (!str) {
                this.getPoi();
            }
            this.poiList.forEach(function (element) {
                if (element.poiName.indexOf(str) !== -1) {
                    searchArr.push(element);
                }
            });
            if (str && searchArr.length === 0) {
                this.poiList = [{ poiName: "无对应匹配项" }];
            } else if (str && searchArr.length) {
                this.poiList = searchArr;
            }
        },
        tableMask: function tableMask(item) {
            var str = "省内销量分布";
            this.tableTitle = item.name + str;
            this.provinceId = item.provinceId;
            this.getPoiSalesInProvinceCity();
            this.showTableMask = true;
            //this.alert(name)
        },
        hideTableModal: function hideTableModal() {
            this.showTableMask = false;
        },
        convertName: function convertName(arr) {
            var _this6 = this;

            var tempArr = [];
            arr.forEach(function (item) {
                var tempName = item.name.replace(/(省|自治区|维吾尔自治区|壮族自治区|回族自治区|特别行政区|市)$/g, "");
                if (arr === _this6.dataList) {
                    tempArr.push({
                        name: tempName,
                        ratio: item.ratio,
                        provinceId: item.provinceId
                    });
                } else {
                    tempArr.push({ name: tempName, ratio: item.ratio });
                }
            });
            return tempArr;
        },
        getDateRange: function getDateRange() {
            var arr = this.dateRange.indexOf("~") !== -1 ? this.dateRange.split(" ~ ") : ["", ""];
            if (arr[0] && arr[1]) {
                this.startDate = arr[0].replace(/-/g, "");
                this.endDate = arr[1].replace(/-/g, "");
                this.getPoiSales();
            }
        },
        selectDefineTime: function selectDefineTime() {
            this.selectedIndex = 3;
        }
    }
};

/***/ }),
/* 875 */
/*!******************************************!*\
  !*** ./src/api/customerSourceAnalyse.js ***!
  \******************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPoiSalesInProvinceCity = exports.getPoiSalesInProvince = exports.getPoiSales = exports.getPoi = undefined;

var _axios = __webpack_require__(/*! axios */ 12);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPoi = exports.getPoi = function getPoi() {
    return _axios2.default.get('/rimet//fe/mtp/poi/customer/stat/list', {
        params: {}
    });
};

var getPoiSales = exports.getPoiSales = function getPoiSales(queryParms) {
    return _axios2.default.get('rimet/fe/mtp/poi/customer/stat', {
        params: queryParms
    });
};

var getPoiSalesInProvince = exports.getPoiSalesInProvince = function getPoiSalesInProvince(queryParms) {
    return _axios2.default.get('rimet//fe/mtp/poi/customer/stat/province', {
        params: queryParms
    });
};
var getPoiSalesInProvinceCity = exports.getPoiSalesInProvinceCity = function getPoiSalesInProvinceCity(queryParms) {
    return _axios2.default.get('rimet//fe/mtp/poi/customer/stat/city', {
        params: queryParms
    });
};

/***/ }),
/* 876 */
/*!****************************************************!*\
  !*** ./src/views/newGtyDataCenter/echarts/pie.vue ***!
  \****************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-1545a22a","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./pie.vue */ 877)
}
var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./pie.vue */ 878),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1545a22a","hasScoped":false}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./pie.vue */ 879),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 877 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1545a22a","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/newGtyDataCenter/echarts/pie.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 878 */
/*!***********************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/newGtyDataCenter/echarts/pie.vue ***!
  \***********************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//

exports.default = {
    props: {
        dataList: {
            type: Array,
            required: true
        }
    },
    data: function data() {
        return {
            option: {
                title: {
                    x: "left"
                },
                tooltip: {
                    trigger: "item",
                    backgroundColor: "rgba(255, 255, 255, .90)",
                    textStyle: {
                        color: "#142C3D"
                    },
                    extraCssText: "box-shadow: 0 1px 18px 0 rgba(151, 189, 208, .3);",
                    formatter: '<span style="font-weight:500">{b}</span><br/> 销量占比:  {c}%'
                },
                legend: {
                    x: "center",
                    y: "bottom",
                    width: 260,
                    itemWidth: 18,
                    itemGap: 30,
                    itemHeight: 18,
                    textStyle: {
                        fontSize: 14
                    },
                    data: this.toolTipName(this.dataList)
                },
                calculable: true,
                series: [{
                    name: "半径模式",
                    type: "pie",
                    radius: [40, 150],
                    center: ["50%", "40%"],
                    label: {
                        normal: {
                            show: false
                        },
                        emphasis: {
                            show: false
                        }
                    },
                    lableLine: {
                        normal: {
                            show: false
                        },
                        emphasis: {
                            show: false
                        }
                    },
                    data: this.convertData(this.dataList)
                }],
                color: ["#FF2F40", "#FFBC37", "#139BFD", "#1DD978", "#4D7BF3", "#214E9F"]
            }
        };
    },

    created: function created() {},
    watch: {
        dataList: function dataList(value) {
            if (Array.isArray(value)) {
                this.option.legend.data = this.toolTipName(value);
                this.option.series[0].data = this.convertData(value);
                this.charts.setOption(this.option);
            }
        }
    },
    methods: {
        convertData: function convertData(data) {
            var res = [];
            var tempData = data.slice(0, 5);
            for (var i = 0; i < tempData.length; i++) {
                res.push({
                    name: tempData[i].name,
                    value: tempData[i].ratio
                });
            }
            if (data.length >= 6) {
                var subData = data.slice(5);
                var val = 0;
                for (var j = 0; j < subData.length; j++) {
                    val += parseFloat(subData[j].ratio);
                }
                res.push({
                    name: '其他',
                    value: val.toFixed(2)
                });
            }
            return res;
        },
        toolTipName: function toolTipName(data) {
            var res = [];
            var tempData = data.slice(0, 5);
            for (var i = 0; i < tempData.length; i++) {
                res.push(tempData[i].name);
            }
            if (data.length >= 6) {
                res.push("其他");
            }
            return res;
        },
        alert: function alert(message) {
            this.$alert({
                title: "提示",
                message: message,
                showCancelButton: false,
                closeOnClickModal: false
            });
        },
        drawPie: function drawPie(id) {
            this.charts = echarts.init(document.getElementById(id));
            this.charts.setOption(this.option);
        }
    },
    mounted: function mounted() {
        this.$nextTick(function () {
            this.drawPie("charts");
        });
    }
};

/***/ }),
/* 879 */
/*!***************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1545a22a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/newGtyDataCenter/echarts/pie.vue ***!
  \***************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "charts",
    attrs: {
      "id": "charts"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 880 */
/*!****************************************************!*\
  !*** ./src/views/newGtyDataCenter/echarts/map.vue ***!
  \****************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-69872dfa","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./map.vue */ 881)
}
var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./map.vue */ 882),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-69872dfa","hasScoped":false}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./map.vue */ 884),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 881 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-69872dfa","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/newGtyDataCenter/echarts/map.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 882 */
/*!***********************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/newGtyDataCenter/echarts/map.vue ***!
  \***********************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _provinceData = __webpack_require__(/*! data/province-data */ 883);

var _provinceData2 = _interopRequireDefault(_provinceData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        dataList: {
            type: Array,
            required: true
        },
        id: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            option: {
                title: {
                    text: "",
                    subtext: "",
                    left: "center"
                },
                tooltip: {
                    trigger: "item",
                    backgroundColor: "rgba(255, 255, 255, .90)",
                    textStyle: {
                        color: "#142C3D"
                    },
                    extraCssText: "box-shadow: 0 1px 18px 0 rgba(151, 189, 208, .3);",
                    formatter: '<span style="font-weight:500">{b}</span><br/>销量占比:  {c}%'
                },
                legend: {
                    orient: "vertical",
                    left: "left",
                    data: []
                },
                visualMap: {
                    min: 0,
                    max: 100,
                    left: "left",
                    top: "90%",
                    orient: "horizontal",
                    text: ["高", "低"],
                    color: "#6E808B",
                    inRange: {
                        color: ["#e9f5fe", " #1087ed"]
                    },
                    calculable: false
                },
                series: [{
                    name: "",
                    type: "map",
                    mapType: "china",
                    showLegendSymbol: false, //去除地图上的指示点
                    roam: false, //地图进行缩放
                    label: {
                        normal: {
                            show: false
                        },
                        emphasis: {
                            show: true
                        }
                    },
                    data: this.convertData(this.dataList)
                }]
            }
        };
    },

    watch: {
        dataList: function dataList(value) {
            if (Array.isArray(value)) {
                this.option.series[0].data = this.convertData(value);
                this.charts.setOption(this.option);
            }
        }
    },
    created: function created() {},
    methods: {
        convertData: function convertData(data) {
            var res = [];
            for (var i = 0; i < data.length; i++) {
                res.push({
                    name: data[i].name,
                    value: parseFloat(data[i].ratio)
                });
            }
            _provinceData2.default.forEach(function (item) {
                var flag = true;
                for (var _i = 0; _i < res.length; _i++) {
                    if (res[_i].name.indexOf(item.name) !== -1) {
                        flag = false;
                        break;
                    }
                }
                if (flag) {
                    res.push({
                        name: item.name,
                        value: 0
                    });
                }
            });
            return res;
        },
        alert: function alert(message) {
            this.$alert({
                title: "提示",
                message: message,
                showCancelButton: false,
                closeOnClickModal: false
            });
        },
        drawMap: function drawMap(id) {
            this.charts = echarts.init(document.getElementById(id));
            this.charts.setOption(this.option);
        }
    },
    mounted: function mounted() {
        this.$nextTick(function () {
            this.drawMap(this.id);
        });
    }
}; //
//
//
//
//
//
//
//
//

/***/ }),
/* 883 */
/*!***********************************!*\
  !*** ./src/data/province-data.js ***!
  \***********************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = [{ name: '北京', value: 0 }, { name: '天津', value: 0 }, { name: '上海', value: 0 }, { name: '重庆', value: 0 }, { name: '河北', value: 0 }, { name: '河南', value: 0 }, { name: '云南', value: 0 }, { name: '辽宁', value: 0 }, { name: '黑龙江', value: 0 }, { name: '湖南', value: 0 }, { name: '安徽', value: 0 }, { name: '山东', value: 0 }, { name: '新疆', value: 0 }, { name: '江苏', value: 0 }, { name: '浙江', value: 0 }, { name: '江西', value: 0 }, { name: '湖北', value: 0 }, { name: '广西', value: 0 }, { name: '甘肃', value: 0 }, { name: '山西', value: 0 }, { name: '内蒙古', value: 0 }, { name: '陕西', value: 0 }, { name: '吉林', value: 0 }, { name: '福建', value: 0 }, { name: '贵州', value: 0 }, { name: '广东', value: 0 }, { name: '青海', value: 0 }, { name: '西藏', value: 0 }, { name: '四川', value: 0 }, { name: '宁夏', value: 0 }, { name: '海南', value: 0 }, { name: '台湾', value: 0 }, { name: '香港', value: 0 }, { name: '澳门', value: 0 }];

/***/ }),
/* 884 */
/*!***************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69872dfa","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/newGtyDataCenter/echarts/map.vue ***!
  \***************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "charts-map",
    attrs: {
      "id": _vm.id
    }
  })
},staticRenderFns: []}

/***/ }),
/* 885 */
/*!**********************************************!*\
  !*** ./src/views/newGtyDataCenter/table.vue ***!
  \**********************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-5c31f87e","scoped":true,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./table.vue */ 886)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./table.vue */ 887),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-5c31f87e","hasScoped":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./table.vue */ 888),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5c31f87e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 886 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5c31f87e","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/newGtyDataCenter/table.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 887 */
/*!*****************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/newGtyDataCenter/table.vue ***!
  \*****************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toFixedPercent = __webpack_require__(/*! filters/toFixedPercent.js */ 168);

var _toFixedPercent2 = _interopRequireDefault(_toFixedPercent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: {
        dataList: {
            type: Array,
            required: true
        },
        showTd: {
            type: Boolean,
            required: false
        },
        tableText: {
            type: Boolean,
            required: false
        },
        changeClass: {
            type: Boolean,
            required: false
        },
        cityText: {
            type: Boolean,
            required: false
        }
    },
    data: function data() {
        return {
            backgroundImage: "linear-gradient(93deg, #26abff, #0b93ff)",
            height: "22px",
            marginLeft: "10px",
            marginBottom: "-6px",
            display: "inline-block",
            ratio: 0,
            index: 0,
            barWidth: []
        };
    },

    methods: {
        computedWidth: function computedWidth(ratio, index) {
            var percent = 0;
            ratio = parseFloat(ratio);
            if (index === 0) {
                percent = "82%";
                this.base = ratio / 0.82;
            } else {
                percent = ratio / this.base * 100 + "%";
            }
            return percent;
        },
        showDataTable: function showDataTable(name) {
            this.$emit("tableModal", name);
        }
    },
    watch: {
        dataList: function dataList(value) {
            var _this = this;

            if (Array.isArray(value)) {
                this.barWidth.length = 0;
                value.forEach(function (i, index) {
                    _this.barWidth.push(_this.computedWidth(i.ratio, index));
                });
            }
        }
    },
    mounted: function mounted() {
        this.$nextTick(function () {
            var _this2 = this;

            this.dataList.forEach(function (i, index) {
                _this2.barWidth.push(_this2.computedWidth(i.ratio, index));
            });
        });
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 888 */
/*!********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c31f87e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/newGtyDataCenter/table.vue ***!
  \********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table right-gram"
  }, [_c('thead', [_c('th', {
    class: {
      'diff-thead': !_vm.showTd
    }
  }, [_vm._v(_vm._s(_vm.tableText ? '城市' : _vm.cityText ? '省外城市' : '省份'))]), _vm._v(" "), _c('th', [_vm._v("销量占比")]), _vm._v(" "), (_vm.showTd) ? _c('th', [_vm._v("省内分布")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    class: [_vm.changeClass ? 'auto-height' : 'fixed-height']
  }, [_c('table', {
    staticClass: "table right-gram"
  }, [_c('tbody', _vm._l((_vm.dataList), function(item, index) {
    return _c('tr', [_c('td', {
      class: {
        'diff-thead': !_vm.showTd
      }
    }, [_c('span', {
      staticClass: "icon-box",
      class: {
        'td1': _vm.showTd && index === 0, 'td2': _vm.showTd && index === 1, 'td3': _vm.showTd && index === 2, 'td4': _vm.showTd && index === 3, 'td5': _vm.showTd && index === 4, 'td-one': !_vm.showTd && index === 0, 'td-two': !_vm.showTd && index === 1, 'td-three': !_vm.showTd && index === 2
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(_vm._s(item.name) + "\n                ")]), _vm._v(" "), _c('td', {
      class: {
        'diff-width': !_vm.showTd
      },
      attrs: {
        "id": "bar"
      }
    }, [_c('span', {
      staticClass: "limit-width"
    }, [_vm._v(_vm._s(_vm._f("toFixedPercent")(item.ratio)))]), _c('span', {
      staticClass: "bule-bar",
      style: ({
        'background-image': _vm.backgroundImage,
        'margin-left': _vm.marginLeft,
        height: '22px',
        'margin-bottom': _vm.marginBottom,
        'border-right': 'solid 1px #2a99f1',
        display: _vm.display,
        width: _vm.barWidth[index]
      })
    })]), _vm._v(" "), (_vm.showTd) ? _c('td', {
      on: {
        "click": function($event) {
          _vm.showDataTable(item)
        }
      }
    }, [_vm._m(0, true)]) : _vm._e()])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("查看"), _c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")])])
}]}

/***/ }),
/* 889 */
/*!************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24189c8d","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/newGtyDataCenter/customerSourceAnalyse.vue ***!
  \************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrapper",
    on: {
      "click": function($event) {
        _vm.hidePoiList($event)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.initLoading),
      expression: "initLoading"
    }],
    staticClass: "content-wrapper",
    attrs: {
      "element-loading-text": "拼命加载中"
    }
  }, [_c('header', {
    staticClass: "customer-source-header"
  }, [_c('div', {
    staticClass: "poi-wrapper",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showPoiList($event)
      }
    }
  }, [_c('span', {
    staticClass: "poi-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "poi",
    attrs: {
      "data-value": "poiName"
    }
  }, [_vm._v(_vm._s(_vm.poiName))]), _vm._v(" "), _c('span', {
    staticClass: "img-icon",
    class: {
      'img-rotate': _vm.show
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "poi-select",
    class: {
      'poi-select1': _vm.show
    }
  }, [_c('div', {
    staticClass: "poi-input-container"
  }, [_c('div', {
    staticClass: "triangle"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchPoi),
      expression: "searchPoi"
    }],
    staticClass: "poi-input",
    attrs: {
      "id": "poiInput",
      "type": "text",
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.searchPoi)
    },
    on: {
      "keyup": function($event) {
        _vm.search(_vm.searchPoi)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchPoi = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "poi-list"
  }, _vm._l((_vm.poiList), function(poi) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.getPoiList(poi)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(poi.poiName) + "\n                    ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "time-header-time"
  }, [_c('ul', [_c('li', {
    class: {
      'active': _vm.selectedIndex === 0
    },
    on: {
      "click": function($event) {
        _vm.selectTime(0, 1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.selectedIndex === 1
    },
    on: {
      "click": function($event) {
        _vm.selectTime(1, 7)
      }
    }
  }, [_vm._v("本周")]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.selectedIndex === 2
    },
    on: {
      "click": function($event) {
        _vm.selectTime(2, 30)
      }
    }
  }, [_vm._v("本月")]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.selectedIndex === 3
    },
    on: {
      "click": function($event) {
        _vm.selectDefineTime(3)
      }
    }
  }, [_c('range-datepicker', {
    attrs: {
      "options": _vm.dateInputOption,
      "color": _vm.color,
      "bgColor": _vm.bgColor,
      "disableColor": _vm.disableColor,
      "placeholder": "自定义时段"
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "place",
    class: {
      'active': _vm.region === 2
    },
    on: {
      "click": function($event) {
        _vm.selectRegion(2)
      }
    }
  }, [_vm._v("省份")]), _vm._v(" "), _c('div', {
    staticClass: "place",
    class: {
      'active': _vm.region === 1
    },
    on: {
      "click": function($event) {
        _vm.selectRegion(1)
      }
    }
  }, [_vm._v("城市")])])]), _vm._v(" "), _c('div', {
    staticClass: "diagram"
  }, [(_vm.dataList.length && _vm.region === 2) ? _c('pie-gram', {
    staticClass: "left-gram",
    attrs: {
      "dataList": _vm.dataList
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: [_vm.region === 1 ? 'all-table-wrapper' : '', 'table-wrapper']
  }, [(_vm.dataList.length && _vm.region === 2) ? _c('data-table', {
    staticClass: "inner-table",
    attrs: {
      "dataList": _vm.dataList,
      "showTd": _vm.showTable
    },
    on: {
      "tableModal": _vm.tableMask
    }
  }) : _vm._e(), _vm._v(" "), (_vm.region === 1 && _vm.tableDataList.length) ? _c('data-table', {
    staticClass: "inner-table",
    attrs: {
      "dataList": _vm.tableDataList
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.description || _vm.subDescription) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.description || _vm.subDescription) ? _c('div', {
    staticClass: "desc-wrapper"
  }, [_c('img', {
    staticClass: "descIcon",
    attrs: {
      "src": __webpack_require__(/*! static/img/group-26.png */ 169),
      "alt": "icon"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('div', [_vm._v(_vm._s(_vm.description))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "fontSize": "12px"
    }
  }, [_vm._v(_vm._s(_vm.subDescription))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper intergap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flex-box"
  }, [_c('div', {
    staticClass: "left-container"
  }, [_c('span', {
    staticClass: "province-poi",
    attrs: {
      "data-value": "poiName"
    }
  }, [_vm._v(_vm._s(_vm.poiName))]), _vm._v(" "), _c('data-map', {
    attrs: {
      "id": _vm.mapIdOne,
      "dataList": _vm.poiOtherProvinces
    }
  }), _vm._v(" "), (_vm.poiOtherProvinces.length) ? _c('data-table', {
    attrs: {
      "dataList": _vm.poiOtherProvinces.slice(0, 10),
      "showTd": _vm.showTd
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "middle-container"
  }), _vm._v(" "), _c('div', {
    staticClass: "right-container"
  }, [_c('span', {
    staticClass: "province-poi",
    attrs: {
      "data-value": "provinceName"
    }
  }, [_vm._v(_vm._s(_vm.provinceName))]), _vm._v(" "), (_vm.allOtherProvinces.length) ? _c('data-map', {
    attrs: {
      "id": _vm.mapIdTwo,
      "dataList": _vm.allOtherProvinces
    }
  }) : _vm._e(), _vm._v(" "), (_vm.allOtherProvinces.length) ? _c('data-table', {
    attrs: {
      "dataList": _vm.allOtherProvinces.slice(0, 10),
      "showTd": _vm.showTd
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.provinceDescription && _vm.provinceDescription.length) ? _c('div', {
    staticClass: "desc-wrapper"
  }, [_c('img', {
    staticClass: "descIcon",
    attrs: {
      "src": __webpack_require__(/*! static/img/group-26.png */ 169),
      "alt": "icon"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "description",
    class: {
      'vertical-center': _vm.provinceDescription.length === 1
    }
  }, _vm._l((_vm.provinceDescription), function(item) {
    return _c('div', [_vm._v(_vm._s(item))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.provinceDescription && _vm.provinceDescription.length) ? _c('hr') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-box"
  }, [_c('div', {
    staticClass: "left-container"
  }, [(_vm.poiOtherCities.length) ? _c('data-table', {
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "cityText": _vm.cityText,
      "dataList": _vm.poiOtherCities,
      "showTd": _vm.showTd
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "middle-container"
  }), _vm._v(" "), _c('div', {
    staticClass: "right-container"
  }, [(_vm.allOtherCities.length) ? _c('data-table', {
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "cityText": _vm.cityText,
      "dataList": _vm.allOtherCities,
      "showTd": _vm.showTd
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.cityDescription && _vm.cityDescription.length) ? _c('div', {
    staticClass: "desc-wrapper"
  }, [_c('img', {
    staticClass: "descIcon",
    attrs: {
      "src": __webpack_require__(/*! static/img/group-26.png */ 169),
      "alt": "icon"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "description",
    class: {
      'vertical-center': _vm.cityDescription.length === 1
    }
  }, _vm._l((_vm.cityDescription), function(item) {
    return _c('div', [_vm._v(_vm._s(item))])
  }))]) : _vm._e()]), _vm._v(" "), (_vm.showTableMask) ? _c('div', {
    staticClass: "mask"
  }) : _vm._e(), _vm._v(" "), (_vm.showTableMask) ? _c('div', {
    staticClass: "tableModal"
  }, [_c('div', {
    staticClass: "table-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.tableTitle))]), _vm._v(" "), _c('span', {
    staticClass: "iconfont",
    on: {
      "click": _vm.hideTableModal
    }
  }, [_vm._v("")])]), _vm._v(" "), (_vm.cityDataList.length) ? _c('data-table', {
    staticClass: "outer-table",
    attrs: {
      "tableText": _vm.tableText,
      "changeClass": _vm.changeClass,
      "dataList": _vm.cityDataList
    }
  }) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('span', {
    staticClass: "poi-bar poi-bar-diff"
  }), _vm._v(" "), _c('span', {
    staticClass: "poi poi-diff",
    attrs: {
      "type": "text"
    }
  }, [_vm._v("景区客源VS省份客源")]), _vm._v(" "), _c('div', {
    staticClass: "time-header-time month-date"
  }, [_vm._v("近30天")])])
}]}

/***/ }),
/* 890 */
/*!**************************************!*\
  !*** ./src/router/router.account.js ***!
  \**************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _env = __webpack_require__(/*! config/env.conf */ 2);

var _innerFrame = __webpack_require__(/*! components/inner-frame/inner-frame */ 42);

var _innerFrame2 = _interopRequireDefault(_innerFrame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var baseUrl = _env.otpHost + '/#/account/';

exports.default = [{
    name: 'adminAccount',
    path: 'admin',
    component: _innerFrame2.default,
    meta: {
        title: "账号管理",
        notMenu: true,
        src: baseUrl + 'admin',
        noAuth: true,
        icon: 'person'
    }
}, {
    name: 'subAccount',
    path: 'sub',
    component: _innerFrame2.default,
    meta: {
        title: "账号管理",
        notMenu: true,
        src: baseUrl + 'sub',
        noAuth: true,
        icon: 'person'
    }
}];

/***/ }),
/* 891 */
/*!************************************!*\
  !*** ./src/router/router.purse.js ***!
  \************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _env = __webpack_require__(/*! config/env.conf */ 2);

var _innerFrame = __webpack_require__(/*! components/inner-frame/inner-frame */ 42);

var _innerFrame2 = _interopRequireDefault(_innerFrame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var baseUrl = _env.otpHost + '/#/purse/';

exports.default = [{
    name: 'purseList',
    path: 'list',
    component: _innerFrame2.default,
    meta: {
        title: '钱包列表',
        src: baseUrl,
        icon: 'turbo-ui-wallet'
    }
}];

/***/ }),
/* 892 */
/*!*******************************************!*\
  !*** ./src/router/router.notification.js ***!
  \*******************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(/*! babel-runtime/helpers/toConsumableArray */ 96);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _env = __webpack_require__(/*! config/env.conf */ 2);

var _verify = __webpack_require__(/*! views/notification/verify.vue */ 893);

var _verify2 = _interopRequireDefault(_verify);

var _vendorsViolationVerify = __webpack_require__(/*! views/notification/vendorsViolationVerify.vue */ 898);

var _vendorsViolationVerify2 = _interopRequireDefault(_vendorsViolationVerify);

var _broadcast = __webpack_require__(/*! views/notification/broadcast.vue */ 902);

var _broadcast2 = _interopRequireDefault(_broadcast);

var _Main = __webpack_require__(/*! views/layout/Main.vue */ 262);

var _Main2 = _interopRequireDefault(_Main);

var _notification = __webpack_require__(/*! data/notification */ 79);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var baseUrl = _env.otpHost + '/#/notification/';

exports.default = [{
    name: 'verify',
    path: 'verify',
    component: _verify2.default,
    meta: {
        title: '审核消息',
        src: baseUrl,
        icon: 'check-circle'
    }
}, {
    name: 'vendorsViolationVerify',
    path: 'vendorsViolationVerify',
    component: _vendorsViolationVerify2.default,
    meta: {
        title: '违规消息',
        src: baseUrl,
        icon: 'check-circle'
    }
}, {
    name: 'broadcast',
    path: 'broadcast',
    component: _Main2.default,
    meta: {
        title: '平台公告',
        icon: 'volume-up'
    },
    children: [].concat((0, _toConsumableArray3.default)(_notification.businessLines.map(function (line) {
        return {
            name: 'broadcast' + line.value,
            path: line.value,
            component: _broadcast2.default,
            meta: {
                title: line.name + '平台公告',
                src: baseUrl + 'broadcast/',
                bizLineId: line.bizLineId
            }
        };
    })))
}];

/***/ }),
/* 893 */
/*!*******************************************!*\
  !*** ./src/views/notification/verify.vue ***!
  \*******************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-29c51e56","scoped":false,"hasInlineConfig":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./verify.vue */ 894)
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-29c51e56","scoped":true,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=1!./verify.vue */ 895)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./verify.vue */ 896),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-29c51e56","hasScoped":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./verify.vue */ 897),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-29c51e56",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 894 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-29c51e56","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/notification/verify.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 895 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-29c51e56","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/notification/verify.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 896 */
/*!**************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/notification/verify.vue ***!
  \**************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(/*! babel-runtime/helpers/toConsumableArray */ 96);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ 22);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(/*! babel-runtime/helpers/asyncToGenerator */ 23);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _tripNotify = __webpack_require__(/*! api/tripNotify */ 73);

var _notification = __webpack_require__(/*! data/notification */ 79);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 几个获取列表的常量
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var LIST_COUNT = 20;
var LIST_CONDITION = 0; //全部
var LIST_NEEDHANDLE = false;

exports.default = {
    data: function data() {
        return {
            types: [{ name: "全部", id: 0 }],
            subTypesMap: { 0: [] },
            currentTypeId: 0,
            currentSubTypeId: null,
            page: 1,
            msgs: [],
            paging: {
                count: 0,
                page: 1,
                total: 0
            },
            modal: true,
            handleResultList: [{
                id: 3,
                name: "已解决"
            }, {
                id: 4,
                name: "无法解决"
            }],
            handleResult: 3,
            LIST_COUNT: LIST_COUNT
        };
    },
    created: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            var res, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, categoryType, subTypeMsgs;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            this.currentSubTypeId = this.routerSubTypeId;
                            _context.prev = 1;
                            _context.next = 4;
                            return (0, _tripNotify.getCategoryList)(0);

                        case 4:
                            res = _context.sent;

                            if (!res.data) {
                                _context.next = 26;
                                break;
                            }

                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context.prev = 9;

                            for (_iterator = res.data[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                categoryType = _step.value;

                                this.types.push({
                                    name: categoryType.categoryName,
                                    id: categoryType.categoryCode
                                });
                                subTypeMsgs = categoryType.msgTypeVOList;

                                if (subTypeMsgs && subTypeMsgs.length) {
                                    this.subTypesMap[categoryType.categoryCode] = subTypeMsgs.map(function (subType) {
                                        var newSubType = {
                                            id: subType.typeId,
                                            name: subType.typeDesc,
                                            weight: subType.typeWeight
                                        };
                                        return newSubType;
                                    });
                                }
                                this.subTypesMap[0] = this.subTypesMap[0].concat(this.subTypesMap[categoryType.categoryCode] || []);
                            }
                            _context.next = 17;
                            break;

                        case 13:
                            _context.prev = 13;
                            _context.t0 = _context["catch"](9);
                            _didIteratorError = true;
                            _iteratorError = _context.t0;

                        case 17:
                            _context.prev = 17;
                            _context.prev = 18;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }

                        case 20:
                            _context.prev = 20;

                            if (!_didIteratorError) {
                                _context.next = 23;
                                break;
                            }

                            throw _iteratorError;

                        case 23:
                            return _context.finish(20);

                        case 24:
                            return _context.finish(17);

                        case 25:
                            if (this.subTypesMap && !this.currentSubTypeId) {
                                this.currentSubTypeId = this.subTypesMap[this.currentTypeId][0].id;
                            }

                        case 26:
                            _context.next = 31;
                            break;

                        case 28:
                            _context.prev = 28;
                            _context.t1 = _context["catch"](1);

                            console.log(_context.t1);

                        case 31:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, this, [[1, 28], [9, 13, 17, 25], [18,, 20, 24]]);
        }));

        function created() {
            return _ref.apply(this, arguments);
        }

        return created;
    }(),

    watch: {
        currentSubTypeId: function currentSubTypeId() {
            this.resetPage();
            this.updateList();
        },
        currentTypeId: function currentTypeId() {
            this.currentSubTypeId = this.subTypesMap[this.currentTypeId][0].id;
        },
        routerSubTypeId: function routerSubTypeId() {
            this.currentSubTypeId = this.routerSubTypeId;
        }
    },
    computed: {
        routerSubTypeId: function routerSubTypeId() {
            return parseInt(this.$route.query.categoryId, 10) || null;
        }
    },
    methods: {
        updateList: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                var _this = this;

                var res, currentSubType;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!this.currentSubTypeId) {
                                    _context2.next = 13;
                                    break;
                                }

                                _context2.prev = 1;
                                _context2.next = 4;
                                return (0, _tripNotify.getList)({
                                    typeId: this.currentSubTypeId,
                                    needHandle: LIST_NEEDHANDLE,
                                    condition: LIST_CONDITION,
                                    page: this.page,
                                    count: LIST_COUNT
                                });

                            case 4:
                                res = _context2.sent;

                                this.msgs = res.data;
                                currentSubType = this.subTypesMap[this.currentTypeId].find(function (subType) {
                                    return subType.id === _this.currentSubTypeId;
                                });

                                if (currentSubType && currentSubType.weight === 1) {
                                    (0, _tripNotify.readAllMessage)([this.currentSubTypeId]);
                                }
                                if (res.paging) {
                                    this.paging = res.paging;
                                }
                                _context2.next = 13;
                                break;

                            case 11:
                                _context2.prev = 11;
                                _context2.t0 = _context2["catch"](1);

                            case 13:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[1, 11]]);
            }));

            function updateList() {
                return _ref2.apply(this, arguments);
            }

            return updateList;
        }(),
        changeSubType: function changeSubType(index) {
            this.currentSubTypeId = index;
        },
        changeType: function changeType(name) {
            this.currentTypeId = parseInt(name, 10);
        },
        getBtnTextByMessage: function getBtnTextByMessage(msg) {
            var landPageInfo = _notification.LandingPageMap[msg.typeId || msg.msgTypeId];
            return landPageInfo ? "去处理" : "已联系BD";
        },
        handle: function handle(msg) {
            var _this2 = this;

            var landPageInfo = _notification.LandingPageMap[this.currentSubTypeId];
            if (landPageInfo) {
                var params = {};
                var msgId = msg && msg.broadCastId || null;
                (0, _tripNotify.handleMsg)(msgId);
                if (landPageInfo.urlPattern) {
                    window.open(landPageInfo.urlPattern.replace("$bizKey", msg.bizKey), "_blank");
                    this.updateList();
                    return;
                }
                params[landPageInfo.paramName] = msg.bizKey;
                this.$router.push({ name: landPageInfo.stateName, params: params });
                return;
            }
            if (msg.redirectUrl) {
                try {
                    var confirmStatus = function () {
                        var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                            return _regenerator2.default.wrap(function _callee3$(_context3) {
                                while (1) {
                                    switch (_context3.prev = _context3.next) {
                                        case 0:
                                            _context3.prev = 0;
                                            _context3.next = 3;
                                            return (0, _tripNotify.update)({
                                                msgId: msg.msgId,
                                                status: this.handleResult
                                            });

                                        case 3:
                                            _context3.next = 8;
                                            break;

                                        case 5:
                                            _context3.prev = 5;
                                            _context3.t0 = _context3["catch"](0);

                                            this.$Notice.error({
                                                title: "接口错误",
                                                desc: _context3.t0.message
                                            });

                                        case 8:
                                        case "end":
                                            return _context3.stop();
                                    }
                                }
                            }, _callee3, this, [[0, 5]]);
                        }));

                        return function confirmStatus() {
                            return _ref3.apply(this, arguments);
                        };
                    }();
                    this.$Modal.confirm({
                        title: "处理结果",
                        onOk: confirmStatus.bind(this),
                        render: function render(h) {
                            return h("Select", {
                                props: {
                                    value: 3
                                },
                                style: {
                                    marginTop: "20px"
                                },
                                on: {
                                    "on-change": _this2.optionChangeHander
                                }
                            }, [].concat((0, _toConsumableArray3.default)(_this2.handleResultList.map(function (item) {
                                return h("Option", {
                                    props: {
                                        value: item.id,
                                        key: item.id
                                    },
                                    domProps: {
                                        innerHTML: item.name
                                    }
                                });
                            }))));
                        }
                    });
                } catch (e) {
                    console.log(e);
                }
                this.updateList();
            }
        },
        optionChangeHander: function optionChangeHander(val) {
            this.handleResult = val;
        },
        changePage: function changePage(page) {
            this.page = page;
            this.updateList();
        },
        resetPage: function resetPage() {
            this.page = 1;
        }
    },
    mounted: function mounted() {}
};

/***/ }),
/* 897 */
/*!*****************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29c51e56","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/notification/verify.vue ***!
  \*****************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "verify"
  }, [_c('div', [_c('Tabs', {
    attrs: {
      "animated": false
    },
    on: {
      "on-click": _vm.changeType
    }
  }, _vm._l((_vm.types), function(type) {
    return _c('TabPane', {
      attrs: {
        "label": type.name,
        "name": type.id.toString()
      }
    }, [_c('div', {
      staticClass: "button-list"
    }, _vm._l((_vm.subTypesMap[type.id]), function(subType) {
      return _c('Button', {
        attrs: {
          "shape": "circle",
          "type": _vm.currentSubTypeId === subType.id ? 'primary' : 'ghost',
          "size": "large"
        },
        on: {
          "click": function($event) {
            _vm.changeSubType(subType.id)
          }
        }
      }, [_vm._v(_vm._s(subType.name))])
    }))])
  }))], 1), _vm._v(" "), _c('ul', {
    staticClass: "msg-list"
  }, _vm._l((_vm.msgs), function(msg) {
    return _c('li', {
      staticClass: "one-msg"
    }, [((msg.msgStatus === 1 || msg.msgStatus === 5) && (msg.typeWeight === 2 || msg.typeWeight === 3)) ? _c('span', {
      staticClass: "unread-icon"
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "create-time"
    }, [_vm._v(_vm._s(msg.msgTime))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(msg.msgDesc))]), _vm._v(" "), _c('div', {
      staticClass: "msgContent"
    }, [_c('p', [_vm._v(_vm._s(msg.content))])]), _vm._v(" "), _c('div', {
      staticClass: "action-area"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((msg.msgStatus === 5 || msg.msgStatus === 6) && msg.typeWeight === 1),
        expression: "(msg.msgStatus === 5 || msg.msgStatus === 6) && msg.typeWeight===1"
      }],
      staticClass: "text-info"
    }, [_vm._v("已读")]), _vm._v(" "), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (msg.msgStatus === 5 && msg.typeWeight !== 1),
        expression: "msg.msgStatus === 5 && msg.typeWeight!==1"
      }],
      staticClass: "btn btn-link",
      on: {
        "click": function($event) {
          _vm.handle(msg)
        }
      }
    }, [_vm._v(_vm._s(_vm.getBtnTextByMessage(msg)))]), _vm._v(" "), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (msg.msgStatus === 1 && msg.typeWeight !== 1),
        expression: "msg.msgStatus === 1 && msg.typeWeight!==1"
      }],
      staticClass: "btn btn-link",
      on: {
        "click": function($event) {
          _vm.handle(msg)
        }
      }
    }, [_vm._v(_vm._s(_vm.getBtnTextByMessage(msg)))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (msg.msgStatus === 2),
        expression: "msg.msgStatus === 2"
      }],
      staticClass: "text-info"
    }, [_vm._v("已过期")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (msg.msgStatus === 3),
        expression: "msg.msgStatus === 3"
      }],
      staticClass: "text-info"
    }, [_vm._v("已解决")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (msg.msgStatus === 4),
        expression: "msg.msgStatus === 4"
      }],
      staticClass: "text-info"
    }, [_vm._v("无法解决")])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('Page', {
    attrs: {
      "page-size": _vm.LIST_COUNT,
      "current": _vm.page,
      "total": _vm.paging.total,
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 898 */
/*!***********************************************************!*\
  !*** ./src/views/notification/vendorsViolationVerify.vue ***!
  \***********************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-d63ae5a0","scoped":true,"hasInlineConfig":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./vendorsViolationVerify.vue */ 899)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./vendorsViolationVerify.vue */ 900),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-d63ae5a0","hasScoped":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./vendorsViolationVerify.vue */ 901),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d63ae5a0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 899 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d63ae5a0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/notification/vendorsViolationVerify.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 900 */
/*!******************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/notification/vendorsViolationVerify.vue ***!
  \******************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ 22);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(/*! babel-runtime/helpers/asyncToGenerator */ 23);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _tripNotify = __webpack_require__(/*! api/tripNotify */ 73);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LIST_COUNT = 20; //
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    data: function data() {
        return {
            needHandle: false,
            parentMsgType: 4,
            condition: 0,
            colums: [{
                key: "msgDesc"
            }, {
                key: "content"
            }],
            list: [],
            page: 1,
            total: 0,
            loading: true,
            LIST_COUNT: LIST_COUNT
        };
    },
    created: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            this.updateList();

                        case 1:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function created() {
            return _ref.apply(this, arguments);
        }

        return created;
    }(),

    methods: {
        updateList: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                var typeRes, typeList, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, type, listRes;

                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.prev = 0;
                                _context2.next = 3;
                                return (0, _tripNotify.getType)();

                            case 3:
                                typeRes = _context2.sent;
                                typeList = typeRes.data;
                                _iteratorNormalCompletion = true;
                                _didIteratorError = false;
                                _iteratorError = undefined;
                                _context2.prev = 8;
                                _iterator = typeList[Symbol.iterator]();

                            case 10:
                                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                    _context2.next = 18;
                                    break;
                                }

                                type = _step.value;

                                if (!(type.parentMsgType === this.parentMsgType)) {
                                    _context2.next = 15;
                                    break;
                                }

                                this.needHandle = type.needHandle;
                                return _context2.abrupt("break", 18);

                            case 15:
                                _iteratorNormalCompletion = true;
                                _context2.next = 10;
                                break;

                            case 18:
                                _context2.next = 24;
                                break;

                            case 20:
                                _context2.prev = 20;
                                _context2.t0 = _context2["catch"](8);
                                _didIteratorError = true;
                                _iteratorError = _context2.t0;

                            case 24:
                                _context2.prev = 24;
                                _context2.prev = 25;

                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }

                            case 27:
                                _context2.prev = 27;

                                if (!_didIteratorError) {
                                    _context2.next = 30;
                                    break;
                                }

                                throw _iteratorError;

                            case 30:
                                return _context2.finish(27);

                            case 31:
                                return _context2.finish(24);

                            case 32:
                                _context2.next = 34;
                                return (0, _tripNotify.pageList)({
                                    msgTypes: ["29", "30", "31", "32"].join(","),
                                    needHandle: this.needHandle,
                                    condition: this.condition,
                                    page: this.page,
                                    count: LIST_COUNT
                                });

                            case 34:
                                listRes = _context2.sent;

                                this.total = listRes.paging.total;
                                this.list = listRes.data;
                                this.loading = false;
                                _context2.next = 44;
                                break;

                            case 40:
                                _context2.prev = 40;
                                _context2.t1 = _context2["catch"](0);

                                this.loading = false;
                                console.log(_context2.t1);

                            case 44:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[0, 40], [8, 20, 24, 32], [25,, 27, 31]]);
            }));

            function updateList() {
                return _ref2.apply(this, arguments);
            }

            return updateList;
        }(),
        changePage: function changePage(page) {
            this.page = page;
            this.updateList();
        }
    }
};

/***/ }),
/* 901 */
/*!*********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d63ae5a0","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/notification/vendorsViolationVerify.vue ***!
  \*********************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-responsive wgxx"
  }, [_c('div', [_c('Table', {
    attrs: {
      "show-header": false,
      "columns": _vm.colums,
      "data": _vm.list,
      "border": true,
      "loading": _vm.loading
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('Page', {
    attrs: {
      "page-size": _vm.LIST_COUNT,
      "current": _vm.page,
      "total": _vm.total,
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 902 */
/*!**********************************************!*\
  !*** ./src/views/notification/broadcast.vue ***!
  \**********************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-bd288e18","scoped":false,"hasInlineConfig":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./broadcast.vue */ 903)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./broadcast.vue */ 904),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-bd288e18","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./broadcast.vue */ 905),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 903 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bd288e18","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/notification/broadcast.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 904 */
/*!*****************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/notification/broadcast.vue ***!
  \*****************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ 22);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(/*! babel-runtime/helpers/asyncToGenerator */ 23);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _moment = __webpack_require__(/*! moment */ 32);

var _moment2 = _interopRequireDefault(_moment);

var _env = __webpack_require__(/*! config/env.conf */ 2);

var _tripNotify = __webpack_require__(/*! api/tripNotify */ 73);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LIST_COUNT = 10; //
//
//
//
//
//
//
//
//
//
//

exports.default = {
    data: function data() {
        var _this = this;

        return {
            LIST_COUNT: LIST_COUNT,
            page: 1,
            list: [],
            loading: true,
            total: 0,
            columns: [{
                key: "title",
                render: function render(h, params) {
                    return h("div", [h("strong", {
                        style: {
                            verticalAlign: "middle",
                            fontSize: "15px",
                            cursor: "pointer"
                        },
                        attrs: {
                            "data-id": params.row.id
                        },
                        domProps: {
                            innerHTML: params.row.title
                        },
                        on: {
                            click: _this.jumpAway
                        }
                    }), params.row.isNew ? h("Badge", {
                        props: {
                            count: "new"
                        },
                        style: {
                            verticalAlign: "baseline",
                            paddingLeft: "10px"
                        }
                    }) : ""]);
                }
            }, {
                key: "publishTime",
                align: "right"
            }]
        };
    },
    created: function created() {
        this.updateList();
    },

    computed: {
        title: function title() {
            return this.$route.meta.title;
        },
        bizLineId: function bizLineId() {
            return this.$route.meta.bizLineId;
        }
    },
    watch: {
        "$route.meta.bizLineId": function $routeMetaBizLineId() {
            this.page = 1;
            this.updateList();
        }
    },
    methods: {
        updateList: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var res, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, one;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.loading = true;
                                _context.prev = 1;
                                _context.next = 4;
                                return (0, _tripNotify.noticeList)({
                                    page: this.page,
                                    pageCount: LIST_COUNT,
                                    publishType: 3,
                                    servicePlatform: 1,
                                    bizlineId: this.$route.meta.bizLineId
                                });

                            case 4:
                                res = _context.sent;

                                console.log(res);
                                // 处理data中的时间

                                if (!(res.data.length > 0)) {
                                    _context.next = 26;
                                    break;
                                }

                                _iteratorNormalCompletion = true;
                                _didIteratorError = false;
                                _iteratorError = undefined;
                                _context.prev = 10;

                                for (_iterator = res.data[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                    one = _step.value;

                                    one.publishTime = (0, _moment2.default)(one.publishTime).format("YYYY-MM-DD hh:mm:ss");
                                }
                                _context.next = 18;
                                break;

                            case 14:
                                _context.prev = 14;
                                _context.t0 = _context["catch"](10);
                                _didIteratorError = true;
                                _iteratorError = _context.t0;

                            case 18:
                                _context.prev = 18;
                                _context.prev = 19;

                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }

                            case 21:
                                _context.prev = 21;

                                if (!_didIteratorError) {
                                    _context.next = 24;
                                    break;
                                }

                                throw _iteratorError;

                            case 24:
                                return _context.finish(21);

                            case 25:
                                return _context.finish(18);

                            case 26:
                                this.list = res.data;
                                this.total = res.paging.total;
                                _context.next = 33;
                                break;

                            case 30:
                                _context.prev = 30;
                                _context.t1 = _context["catch"](1);

                                console.log(_context.t1);

                            case 33:
                                this.loading = false;

                            case 34:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[1, 30], [10, 14, 18, 26], [19,, 21, 25]]);
            }));

            function updateList() {
                return _ref.apply(this, arguments);
            }

            return updateList;
        }(),
        getAnnounceDetailUrl: function getAnnounceDetailUrl(id) {
            return "#/announce/" + id;
        },
        jumpAway: function jumpAway(e) {
            var id = e.srcElement.getAttribute("data-id");
            var url = this.getAnnounceDetailUrl(id);
            window.open(url, "noticeDetail" + id);
        },
        changePage: function changePage(page) {
            this.page = page;
            this.updateList();
        }
    }
};

/***/ }),
/* 905 */
/*!*********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd288e18","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/notification/broadcast.vue ***!
  \*********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "boradcast"
  }, [_c('Table', {
    attrs: {
      "loading": _vm.loading,
      "data": _vm.list,
      "columns": _vm.columns,
      "show-header": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('Page', {
    attrs: {
      "page-size": _vm.LIST_COUNT,
      "current": _vm.page,
      "total": _vm.total,
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 906 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cae76352","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/layout/Main.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 907 */
/*!******************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/layout/Main.vue ***!
  \******************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _noticeIcon = __webpack_require__(/*! @hfe/turbos/lib/notice-icon */ 908);

var _noticeIcon2 = _interopRequireDefault(_noticeIcon);

var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ 22);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(/*! babel-runtime/helpers/asyncToGenerator */ 23);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

__webpack_require__(/*! @hfe/turbos/lib/notice-icon/style */ 909);

var _main = __webpack_require__(/*! views/aside/main.vue */ 910);

var _main2 = _interopRequireDefault(_main);

var _menuConfig = __webpack_require__(/*! config/menuConfig */ 263);

var _menu = __webpack_require__(/*! utils/menu */ 170);

var _WebSocketMesssage = __webpack_require__(/*! utils/WebSocketMesssage */ 915);

var _WebSocketMesssage2 = _interopRequireDefault(_WebSocketMesssage);

var _common = __webpack_require__(/*! api/common */ 223);

var _tripNotify = __webpack_require__(/*! api/tripNotify.js */ 73);

var _vuex = __webpack_require__(/*! vuex */ 14);

var _env = __webpack_require__(/*! config/env.conf */ 2);

var _messageCenter = __webpack_require__(/*! components/message/messageCenter.vue */ 917);

var _messageCenter2 = _interopRequireDefault(_messageCenter);

var _toastAndAlertNotification = __webpack_require__(/*! components/message/toastAndAlertNotification.js */ 921);

var _toastAndAlertNotification2 = _interopRequireDefault(_toastAndAlertNotification);

var _voiceNotification = __webpack_require__(/*! components/message/voiceNotification.vue */ 922);

var _voiceNotification2 = _interopRequireDefault(_voiceNotification);

var _ConfirmOrders = __webpack_require__(/*! components/ConfirmOrders/ConfirmOrders */ 926);

var _ConfirmOrders2 = _interopRequireDefault(_ConfirmOrders);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var preSaleUrl = "";
switch ("production") {
  case "production":
    preSaleUrl = "//fuwu.meituan.com/";
    break;
  case "staging":
    preSaleUrl = "//fuwu.hfe.st.meituan.com/";
    break;
  default:
    preSaleUrl = _env.iHost + "/awp/hfe/hotel-fe-chat/index.html";
}
preSaleUrl += "#/chat/business";
var walletEntranceCode = 1;
exports.default = {
  data: function data() {
    return {
      authBizLines: [],
      currentBizLine: null,
      unregisterRouteHookFn: null,
      userName: null,
      accountType: null,
      userMenus: [{ name: "账号管理", id: "1" }, { name: "我的信息", id: "3" }, { name: "系统设置", id: 4 }, { name: "退出登录", id: "2" }],
      spinShow: false,
      hideBizLines: false,
      hasWalletList: false,
      timerId: null,
      toastAndAlertNotificationInstance: false,
      hasJiuJing: false,
      push: null,
      webSocketRetryLimit: 4
    };
  },
  created: function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
      var _this = this;

      var bizUser, routes, bizLines, currentRoute, matches, bizLineRoute;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              bizUser = this.$store.state.bizUser;

              if (bizUser) {
                this.userName = bizUser.userName;
                if (!bizUser.freeLogin) {
                  this.accountTypeCode = bizUser.accountType;
                  this.accountType = _menuConfig.accountTypeMap[this.accountTypeCode];
                } else {
                  this.accountType = "免密登录";
                }
              }
              routes = this.$router.options.routes;
              bizLines = (0, _menu.getAuthBizLines)(routes, bizUser);

              this.hasJiuJing = bizLines.find(function (bizLine) {
                return bizLine.value === "jiujinghome";
              }) ? true : false;
              if (bizLines && bizLines.length) {
                this.authBizLines = bizLines;
                currentRoute = this.$route;
                matches = currentRoute.matched;

                if (matches && matches[0] && matches[0].name === _menuConfig.rootRouteName) {
                  bizLineRoute = matches[1];

                  if (bizLineRoute && bizLineRoute.meta) {
                    if (bizLineRoute.meta.notBizMenu) {
                      this.hideBizLines = true;
                    } else {
                      this.hideBizLines = false;
                      this.currentBizLine = bizLineRoute.meta.name;
                    }
                  } else {
                    this.navToDefaultBizLine();
                  }
                }
              } else {
                this.$router.push({ name: "unauthorized" });
              }
              this.updateHeaderLinks();
              this.unregisterRouteHookFn = this.$router.beforeEach(function (to, from, next) {
                if (to.name === _menuConfig.rootRouteName) {
                  _this.navToDefaultBizLine(next);
                } else {
                  var _matches = to.matched;
                  if (_matches && _matches[0] && _matches[0].name === _menuConfig.rootRouteName) {
                    var _bizLineRoute = _matches[1];
                    if (_bizLineRoute && _bizLineRoute.meta) {
                      if (_bizLineRoute.meta.notBizMenu) {
                        _this.hideBizLines = true;
                      }
                      _this.$nextTick(function () {
                        _this.currentBizLine = _bizLineRoute.meta.name;
                      });
                    }
                  }
                  _this.updateHeaderLinks(to);
                  next();
                }
              });
              (0, _common.getAccountPermission)(walletEntranceCode).then(function (response) {
                var entrances = response.data || [];
                var walletEntrance = entrances.find(function (entrance) {
                  return entrance.entranceCode === walletEntranceCode;
                });
                if (!walletEntrance || walletEntrance.checked === 1) {
                  _this.hasWalletList = true;
                }
              }).catch(function (err) {
                var msg = err && err.data && err.data.message || "获取用户权限出错";
                console.error(msg);
              });

              _context.next = 11;
              return this.connectMsgSYS();

            case 11:
              /*
              if (window && window.setInterval && !this.timerId) {
              this.getCount();
              this.timerId = window.setInterval(() => this.getCount(), 30000);
              }
              */
              if (!this.toastAndAlertNotificationInstance) {
                this.toastAndAlertNotificationInstance = new _toastAndAlertNotification2.default(this.$Modal, this.$Notice, this.$router);
              }

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),

  components: {
    menuAside: _main2.default,
    NoticeIcon: _noticeIcon2.default,
    tab: _noticeIcon2.default.Tab,
    msgCenter: _messageCenter2.default,
    VoiceNotification: _voiceNotification2.default,
    ConfirmOrders: _ConfirmOrders2.default
  },
  destroyed: function destroyed() {
    if (this.unregisterRouteHookFn) {
      this.unregisterRouteHookFn();
    }
    if (this.timerId) {
      window.clearInterval(this.timerId);
      this.timerId = null;
    }
  },

  methods: Object.assign({}, (0, _vuex.mapActions)(["doLogout", "getCount", "setCount"]), {
    error: function error(message) {
      this.$Modal.error({
        title: "提示",
        content: message
      });
    },
    connectMsgSYS: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var _this2 = this;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!this.push && this.webSocketRetryLimit > 0)) {
                  _context2.next = 13;
                  break;
                }

                _context2.prev = 1;
                _context2.next = 4;
                return (0, _tripNotify.insertCookie)();

              case 4:
                this.push = new _WebSocketMesssage2.default({
                  url: ( true ? 'wss' : 'ws') + ":" + _env.webSocketHost + "/trip-notify/webpush/msg",
                  appkey: 'com.sankuai.trip.tdc.tripnotify',
                  bizAccountId: this.$store.state.bizUser.userId,
                  forcePoll: false
                });

                this.push.on('msg', function (msg) {
                  if (msg.length > 0) {
                    _this2.setCount(JSON.parse(msg));
                    //收到消息，说明websocket正常
                    if (_this2.webSocketRetryLimit !== 4) _this2.webSocketRetryLimit = 4;
                    if (_this2.timerId) {
                      window.clearInterval(_this2.timerId);
                      _this2.timerId = null;
                    }
                  }
                });

                // 降级
                this.push.on('poll', function (reason) {
                  _this2.owlAddError('poll', reason);
                  _this2.messagePoll();
                });
                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](1);

                this.owlAddError('poll', _context2.t0.message);
                this.messagePoll();

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 9]]);
      }));

      function connectMsgSYS() {
        return _ref2.apply(this, arguments);
      }

      return connectMsgSYS;
    }(),
    messagePoll: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
        var _this3 = this;

        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.push) this.push.off('msg');

                if (!(window && window.setInterval && !this.timerId)) {
                  _context4.next = 6;
                  break;
                }

                _context4.next = 4;
                return this.getCount();

              case 4:
                if (!_context4.sent) {
                  _context4.next = 6;
                  break;
                }

                this.startCount();

              case 6:
                if (this.webSocketRetryLimit > 0 && window && window.setTimeout) {
                  this.push = null;
                  this.webSocketRetryLimit--;
                  this.owlAddError('reBoot', '');
                  window.setTimeout((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                    return _regenerator2.default.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return _this3.connectMsgSYS();

                          case 2:
                            return _context3.abrupt("return", _context3.sent);

                          case 3:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this3);
                  })), 1000 * 60 * 3);
                }

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function messagePoll() {
        return _ref3.apply(this, arguments);
      }

      return messagePoll;
    }(),
    startCount: function startCount() {
      var _this4 = this;

      this.timerId = window.setInterval((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this4.getCount();

              case 2:
                if (_context5.sent) {
                  _context5.next = 5;
                  break;
                }

                clearInterval(_this4.timerId);
                _this4.timerId = null;

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      })), 30000);
    },
    owlAddError: function owlAddError(msg, reason) {
      if (Owl) {
        Owl.addError("WebSocket - " + msg + " - " + reason, {
          level: 'info',
          combo: false
        });
      }
    },
    updateHeaderLinks: function updateHeaderLinks(route) {
      var targetRoute = route || this.$route;
      var matches = targetRoute && targetRoute.matched || [];
      if (matches && matches.length > 2) {
        this.matches = matches.filter(function (key, index) {
          return index > 1;
        });
      }
    },
    openPreSale: function openPreSale() {
      if (preSaleUrl) {
        window.open(preSaleUrl, "_blank");
      }
    },
    navToWalletList: function navToWalletList() {
      this.$router.push({ name: "purseList" });
    },
    dropDownMenuClicked: function dropDownMenuClicked(id) {
      var _this5 = this;

      switch (Number.parseInt(id, 10)) {
        case 1:
          if (this.accountTypeCode === 1) {
            this.$router.push({ name: "adminAccount" });
          } else {
            this.$router.push({ name: "subAccount" });
          }
          break;
        case 2:
          this.spinShow = true;
          this.doLogout().then(function () {
            window.location.href = window.location.href.split("#")[0] + "#/login";
            window.location.reload();
            _this5.spinShow = false;
          }).catch(function (err) {
            var msg = err && err.message || "登出失败";
            _this5.error(msg);
            _this5.spinShow = false;
          });
          break;
        case 3:
          this.$router.push({ name: "jiujingauthInfo" });
          break;
        case 4:
          this.$router.push({ name: "systemSetting" });
          break;
        default:
          break;
      }
    },
    navToRoute: function navToRoute(name) {
      this.$router.push({ name: name });
    },
    bizLineChanged: function bizLineChanged(name) {
      var router = this.$router;
      var route = router.currentRoute;
      var hrefObj = router.resolve({ name: name });
      if (hrefObj) {
        var lineHomeHash = hrefObj.href;
        if (lineHomeHash) {
          var currentHash = window.location.hash;
          if (currentHash && currentHash.includes(lineHomeHash)) {
            return;
          }
        }
      }
      this.$router.push({ name: name });
    },
    navToDefaultBizLine: function navToDefaultBizLine(next) {
      var _this6 = this;

      this.$nextTick(function () {
        _this6.hideBizLines = false;
        _this6.currentBizLine = _this6.authBizLines[0].value;
        var pathObj = { name: _this6.currentBizLine };
        if (!next) {
          _this6.$router.push(pathObj);
        } else {
          next(pathObj);
        }
      });
    }
  }),
  computed: {
    unreadMap: function unreadMap() {
      return this.$store.state.unreadMap;
    }
  },
  watch: {
    unreadMap: function unreadMap() {
      if (this.toastAndAlertNotificationInstance) {
        this.toastAndAlertNotificationInstance.onUnreadChange(this.$store.state.unreadMap);
      }
    }
  }
};

/***/ }),
/* 908 */,
/* 909 */,
/* 910 */
/*!**********************************!*\
  !*** ./src/views/aside/main.vue ***!
  \**********************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":true,"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]_0"}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-74b0b4f2","scoped":false,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./main.vue */ 911)
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-74b0b4f2","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=1!./main.vue */ 912)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./main.vue */ 913),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-74b0b4f2","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./main.vue */ 914),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 911 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":true,"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]_0"}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-74b0b4f2","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/aside/main.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"menuTips":"_3vKm2APempVHm7EuaNMfqh_0"};

/***/ }),
/* 912 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-74b0b4f2","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/aside/main.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 913 */
/*!*****************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/aside/main.vue ***!
  \*****************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _menu = __webpack_require__(/*! utils/menu */ 170);

exports.default = {
    data: function data() {
        return {
            menus: [],
            activeName: null,
            openNames: []
        };
    },
    created: function created() {
        this.routes = this.$router.options.routes;
        this.sfCustoms = this.$store.state.sfCustoms;
        this.rootRoute = (0, _menu.getRootRoute)(this.routes);
        this.bizUser = this.$store.state.bizUser;
    },

    computed: {
        jiuJingConfirmOrders: function jiuJingConfirmOrders() {
            return this.$store.state.jiuJingConfirmOrders;
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.unregisterRouteHookFn = this.$router.beforeEach(function (to, from, next) {
            next();
            _this.updateMenus(to);
        });
        this.updateMenus(this.$route);
    },
    destroyed: function destroyed() {
        if (this.unregisterRouteHookFn) {
            this.unregisterRouteHookFn();
        }
    },

    methods: {
        updateMenus: function updateMenus(currentRoute) {
            var _this2 = this;

            this.menus.splice(0, this.menus.length);
            (0, _menu.getMenus)(this.routes, currentRoute, this.sfCustoms, this.bizUser).forEach(function (menuItem) {
                _this2.menus.push(menuItem);
            });
            var activeInfo = (0, _menu.getActiveMenuInfo)(currentRoute);
            if (activeInfo && this.$refs.mainMenu) {
                var mainMenu = this.$refs.mainMenu;
                this.openNames = activeInfo.openNames || [];
                this.activeName = activeInfo.activeName;
                this.$nextTick(function () {
                    mainMenu.updateOpened();
                    mainMenu.updateActiveName();
                });
            }
        },
        navToMenuItem: function navToMenuItem(menuName) {
            this.$router.push({ name: menuName });
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 914 */
/*!*********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b0b4f2","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/aside/main.vue ***!
  \*********************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "sidebar"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sidebar-menu"
  }, [_c('Menu', {
    ref: "mainMenu",
    attrs: {
      "theme": "dark",
      "accordion": true,
      "width": "160px",
      "active-name": _vm.activeName,
      "open-names": _vm.openNames
    },
    on: {
      "on-select": _vm.navToMenuItem
    }
  }, [_vm._l((_vm.menus), function(menuItem) {
    return [(!menuItem.children && (menuItem.meta && !menuItem.meta.notMenu)) ? _c('MenuItem', {
      key: menuItem.name,
      attrs: {
        "name": menuItem.name
      }
    }, [(menuItem.meta.icon) ? _c('Icon', {
      key: menuItem.name,
      attrs: {
        "type": menuItem.meta.icon
      }
    }) : _vm._e(), _vm._v("\n                " + _vm._s(menuItem.meta.title) + "\n                ")], 1) : _vm._e(), _vm._v(" "), (menuItem.children && (menuItem.meta && !menuItem.meta.notMenu)) ? _c('Submenu', {
      key: menuItem.name,
      attrs: {
        "name": menuItem.name
      }
    }, [_c('template', {
      slot: "title"
    }, [(menuItem.meta.icon) ? _c('Icon', {
      key: menuItem.name,
      attrs: {
        "type": menuItem.meta.icon
      }
    }) : _vm._e(), _vm._v("\n                        " + _vm._s(menuItem.meta.title) + "\n                        "), (menuItem.name === 'jiujingorder' && _vm.jiuJingConfirmOrders > 0) ? _c('span', {
      class: _vm.$style.menuTips
    }, [_vm._v(_vm._s(_vm.jiuJingConfirmOrders > 9 ? '9+' : _vm.jiuJingConfirmOrders))]) : _vm._e()], 1), _vm._v(" "), _vm._l((menuItem.children), function(subMenu) {
      return (!subMenu.meta.notMenu) ? _c('MenuItem', {
        key: subMenu.name,
        attrs: {
          "name": subMenu.name
        }
      }, [_vm._v(_vm._s(subMenu.meta.title))]) : _vm._e()
    })], 2) : _vm._e()]
  })], 2)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brand"
  }, [_c('a', {
    staticClass: "brand-link",
    attrs: {
      "href": "#/"
    }
  }, [_c('img', {
    attrs: {
      "src": "//awp-assets.meituan.net/hfe/fep/0302a6c4b5c7692a71f3f904adce12d1/3flogo.svg"
    }
  })])])
}]}

/***/ }),
/* 915 */
/*!****************************************!*\
  !*** ./src/utils/WebSocketMesssage.js ***!
  \****************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ 74);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ 75);

var _createClass3 = _interopRequireDefault(_createClass2);

var _EventBus = __webpack_require__(/*! ./EventBus.ts */ 916);

var _EventBus2 = _interopRequireDefault(_EventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var emitter = (0, _EventBus2.default)(); /*
                                         version 0.0.1
                                          */

var wsPush = function () {
    function wsPush(options) {
        (0, _classCallCheck3.default)(this, wsPush);

        this.options = {
            forcePoll: false,
            HBRetry: 10 //HB无响应次数后，降级
        };
        this.ws = null;
        this.token = null;
        this.msgSeqId = null;
        this.interval = null;
        this.options = Object.assign(this.options, options);
        // 将on和off暴露出去
        this.on = emitter.on;
        this.off = emitter.off;
        if (this.options.forcePoll || !('WebSocket' in window) || !this.options.url) {
            throw new Error('WebSocket 强制降级');
        } else {
            var url = this.options.url + '?appkey=' + this.options.appkey + '&userId=' + this.options.bizAccountId;
            this.start(url);
        }
    }

    (0, _createClass3.default)(wsPush, [{
        key: 'start',
        value: function start(url) {
            try {
                this.ws = new WebSocket(url);
                this.ws.addEventListener('message', this.processMessage.bind(this));
                this.ws.addEventListener('open', this.register.bind(this));
                this.ws.addEventListener('error', this.poll.bind(this, 'Connect failed'));
                this.ws.addEventListener('close', this.close.bind(this));
            } catch (e) {
                // 将错误跑出去
                throw new Error('创建Socket失败');
            }
        }
    }, {
        key: 'register',
        value: function register(evt) {
            this.sendMsg('register');
        }
    }, {
        key: 'processMessage',
        value: function processMessage(evt) {
            var _this = this;

            // ACK不做任何处理
            if (evt.data === 'ACK') return;
            try {
                var result = JSON.parse(evt.data);
                switch (result.statMsg) {
                    case 'REGISTER OK':
                        this.token = result.token;
                        this.sendMsg('pull', { token: this.token });
                        break;
                    case 'PULL OK':
                        this.msgSeqId = result.msgSeqId;
                        emitter.emit('msg', result.msgData);
                        // pull成功后保持心跳，持续发心跳包
                        if (!this.interval) {
                            this.interval = setInterval(function () {
                                _this.sendMsg('HB', { token: _this.token });
                                _this.options.HBRetry--;
                                if (_this.options.HBRetry <= 0) {
                                    _this.poll('HB out');
                                }
                            }, 30000);
                        }
                        break;
                    case 'PUSH OK':
                        if (result.msgSeqId) this.msgSeqId = result.msgSeqId;
                        emitter.emit('msg', result.msgData);
                        this.sendMsg('ack', { token: this.token, msgSeqId: this.msgSeqId });
                        break;
                    case 'HB_ACK':
                        this.options.HBRetry++;
                        break;
                    case 'ACK':
                        break; // PUSH的ack的ack，不做处理
                    case 'Need Re-rigister':
                        this.sendMsg('register'); //重新注册
                        break;
                    default:
                        console.log('未监听Error：', evt);
                }
            } catch (e) {
                console.log(e);
                this.poll('catch error');
            }
        }
    }, {
        key: 'sendMsg',
        value: function sendMsg(cmd) {
            var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var basic = {
                appkey: this.options.appkey,
                bizAccountId: this.options.bizAccountId,
                cmd: cmd
            };
            var str = JSON.stringify(Object.assign(basic, content));
            this.ws.send(str);
        }
    }, {
        key: 'close',
        value: function close(evt) {
            this.poll('closed');
        }
    }, {
        key: 'poll',
        value: function poll(message) {
            // 降级
            emitter.emit('poll', message);
            // 停止循环HB
            if (this.interval) window.clearInterval(this.interval);
            this.ws.close();
        }
    }]);
    return wsPush;
}();

exports.default = wsPush;

/***/ }),
/* 916 */
/*!*******************************!*\
  !*** ./src/utils/EventBus.ts ***!
  \*******************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function EventBus(all) {
    all = all || Object.create(null);
    return {
        on: function (type, handler) {
            (all[type] || (all[type] = [])).push(handler);
        },
        off: function (type, handler) {
            if (all[type]) {
                all[type].splice(all[type].indexOf(handler) >>> 0, 1);
            }
        },
        emit: function (type, evt) {
            (all[type] || []).slice().map(function (handler) { handler(evt); });
            (all['*'] || []).slice().map(function (handler) { handler(type, evt); });
        }
    };
}
exports.default = EventBus;


/***/ }),
/* 917 */
/*!**************************************************!*\
  !*** ./src/components/message/messageCenter.vue ***!
  \**************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-559a21de","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./messageCenter.vue */ 918)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./messageCenter.vue */ 919),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-559a21de","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./messageCenter.vue */ 920),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 918 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-559a21de","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/message/messageCenter.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 919 */
/*!*********************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/message/messageCenter.vue ***!
  \*********************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _notification = __webpack_require__(/*! data/notification */ 79);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    components: {},
    data: function data() {
        return {
            unreadMsg: {},
            unreadCount: 0,
            msgCate: _notification.MsgCategories,
            OtherMsgTypesMap: _notification.OtherMsgTypesMap
        };
    },

    computed: {
        unreadMap: function unreadMap() {
            return this.$store.state.unreadMap;
        }
    },
    watch: {
        unreadMap: function unreadMap() {
            if (this.getNotificationUnread(this.unreadMap)) {}
        }
    },
    methods: {
        getNotificationUnread: function getNotificationUnread(unreadMap) {
            if (unreadMap && (unreadMap[1] || unreadMap[2] || unreadMap[3])) {
                this.unreadMsg = unreadMap;
                var totalCount = 0;
                Object.keys(unreadMap).forEach(function (keyCurr) {
                    var unreadItems = unreadMap[keyCurr];
                    var categoryCount = 0;
                    if (unreadItems && unreadItems.length) {
                        unreadItems.forEach(function (unreadItem) {
                            if (unreadItem) {
                                var msgCount = Number.parseInt(unreadItem.count);
                                if (msgCount && msgCount > 0) {
                                    categoryCount += msgCount;
                                }
                            }
                        });
                        if (categoryCount > 0) {
                            totalCount += categoryCount;
                        }
                    }
                    unreadItems.categoryCount = categoryCount;
                });
                this.unreadMsg.length = totalCount;
                this.unreadCount = totalCount;
                return true;
            }
            return false;
        },
        gotoMessageCenter: function gotoMessageCenter() {
            this.$router.push({ name: 'verify' });
        },
        jumpNotification: function jumpNotification(categoryId) {
            this.$router.push({ name: 'verify', query: { categoryId: categoryId } });
        },
        jumpOther: function jumpOther(obj) {
            this.$router.push({ name: obj.stateName, query: obj.params });
        }
    }
};

/***/ }),
/* 920 */
/*!*************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-559a21de","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/message/messageCenter.vue ***!
  \*************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Poptip', {
    attrs: {
      "placement": "bottom",
      "transfer": false
    }
  }, [_c('Badge', {
    attrs: {
      "count": _vm.unreadCount
    }
  }, [_c('Icon', {
    attrs: {
      "type": "turbo-ui-bell"
    }
  })], 1), _vm._v(" "), _c('Tabs', {
    attrs: {
      "animated": false
    },
    slot: "content"
  }, _vm._l((_vm.msgCate), function(cate) {
    return _c('TabPane', {
      attrs: {
        "label": cate.name,
        "name": cate.name
      }
    }, [(_vm.unreadMsg[cate.id] && _vm.unreadMsg[cate.id].categoryCount > 0) ? _c('div', _vm._l((_vm.unreadMsg[cate.id]), function(unreadItem) {
      return _c('div', [(unreadItem.count > 0) ? _c('div', [(cate.id === 1 && unreadItem.typeId != 888) ? _c('a', {
        staticClass: "msg",
        on: {
          "click": function($event) {
            _vm.jumpNotification(unreadItem.typeId)
          }
        }
      }, [_c('span', {
        staticClass: "unread-count"
      }, [_vm._v(_vm._s(unreadItem.count || 100))]), _c('span', {
        staticClass: "unread-desc"
      }, [_vm._v(_vm._s('条' + unreadItem.typeDesc.replace('消息', '')))])]) : _vm._e(), _vm._v(" "), (cate.id !== 1 || unreadItem.typeId === 888) ? _c('a', {
        staticClass: "msg",
        on: {
          "click": function($event) {
            _vm.jumpOther(_vm.OtherMsgTypesMap[unreadItem.typeId])
          }
        }
      }, [_c('span', {
        staticClass: "unread-count"
      }, [_vm._v(_vm._s(unreadItem.count))]), _c('span', {
        staticClass: "unread-desc"
      }, [_vm._v(_vm._s('条' + unreadItem.typeDesc.replace('消息', '')))])]) : _vm._e()]) : _vm._e()])
    })) : _c('div', [_c('a', {
      staticClass: "msg",
      attrs: {
        "href": "javascript:void(0)"
      }
    }, [_c('span', {
      staticClass: "unread-desc"
    }, [_vm._v("当前无消息")])])]), _vm._v(" "), (cate.id === 1) ? _c('div', {
      staticClass: "bordertop"
    }, [_c('a', {
      staticClass: "see-all",
      on: {
        "click": _vm.gotoMessageCenter
      }
    }, [_vm._v("查看全部"), _c('i', {
      staticClass: "icon icon-arrow-right"
    })])]) : _vm._e()])
  }))], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 921 */
/*!*************************************************************!*\
  !*** ./src/components/message/toastAndAlertNotification.js ***!
  \*************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = __webpack_require__(/*! babel-runtime/helpers/typeof */ 116);

var _typeof3 = _interopRequireDefault(_typeof2);

var _regenerator = __webpack_require__(/*! babel-runtime/regenerator */ 22);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(/*! babel-runtime/helpers/asyncToGenerator */ 23);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ 74);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ 75);

var _createClass3 = _interopRequireDefault(_createClass2);

var _tripNotify = __webpack_require__(/*! api/tripNotify */ 73);

var _notification = __webpack_require__(/*! data/notification */ 79);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noAlertMsgsTypes = [];
var pageMsgsTypes = {
    65: {
        pathRegs: [/#\/jiujing\/$/, /#\/jiujing\/product\/list/]
    }
};

var ToastAndAlertNotification = function () {
    function ToastAndAlertNotification(Modal, Notice, router) {
        (0, _classCallCheck3.default)(this, ToastAndAlertNotification);

        this.Modal = Modal;
        this.Notice = Notice;
        this.STRONGWEIGHT = 3;
        this.MIDDLEWEIGHT = 2;
        this.hasStrongMsg = false;
        this.hasMiddleMsg = false;
        this.unreadChanged = false;
        this.showingStrongMsg = false;
        this.showingMiddleToast = false;
        this.router = router;
    }

    (0, _createClass3.default)(ToastAndAlertNotification, [{
        key: 'onUnreadChange',
        value: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(map) {
                var _this = this;

                var msgs, i, msg, _ret;

                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!this.unreadChanged) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 2:
                                if (!this.showingStrongMsg) {
                                    _context2.next = 4;
                                    break;
                                }

                                return _context2.abrupt('return');

                            case 4:
                                this.unreadChanged = true;
                                msgs = [];

                                Object.keys(map).forEach(function (categoryId) {
                                    msgs = msgs.concat(map[categoryId] || []);
                                });
                                i = 0;

                            case 8:
                                if (!(i < msgs.length)) {
                                    _context2.next = 28;
                                    break;
                                }

                                msg = msgs[i];

                                if (!(msg.typeWeight === this.STRONGWEIGHT)) {
                                    _context2.next = 13;
                                    break;
                                }

                                this.hasStrongMsg = true;
                                return _context2.abrupt('break', 28);

                            case 13:
                                if (msg.typeWeight === this.MIDDLEWEIGHT) {
                                    this.hasMiddleMsg = true;
                                }

                                if (!(this.hasStrongMsg || this.hasMiddleMsg)) {
                                    _context2.next = 25;
                                    break;
                                }

                                _context2.prev = 15;
                                return _context2.delegateYield(_regenerator2.default.mark(function _callee() {
                                    var lastData, latestMsgs, strongMsg, msgType, msgPageConfig, pageRegs, hash, isMsgPage;
                                    return _regenerator2.default.wrap(function _callee$(_context) {
                                        while (1) {
                                            switch (_context.prev = _context.next) {
                                                case 0:
                                                    _context.next = 2;
                                                    return (0, _tripNotify.getLastestMsg)(_this.hasStrongMsg ? 3 : 2);

                                                case 2:
                                                    lastData = _context.sent;
                                                    latestMsgs = lastData && lastData.data || [];

                                                    if (!latestMsgs.length) {
                                                        _context.next = 17;
                                                        break;
                                                    }

                                                    strongMsg = latestMsgs.find(function (msg) {
                                                        return msg.typeWeight === _this.STRONGWEIGHT;
                                                    });
                                                    msgType = strongMsg && strongMsg.msgInfo && strongMsg.msgInfo.typeId || null;

                                                    if (!(noAlertMsgsTypes.indexOf(msgType) !== -1)) {
                                                        _context.next = 9;
                                                        break;
                                                    }

                                                    return _context.abrupt('return', {
                                                        v: void 0
                                                    });

                                                case 9:
                                                    msgPageConfig = pageMsgsTypes[msgType];

                                                    if (!msgPageConfig) {
                                                        _context.next = 16;
                                                        break;
                                                    }

                                                    pageRegs = msgPageConfig.pathRegs || [];
                                                    hash = window.location.hash;
                                                    isMsgPage = pageRegs.find(function (reg) {
                                                        return reg.test(hash);
                                                    }) ? true : false;

                                                    if (isMsgPage) {
                                                        _context.next = 16;
                                                        break;
                                                    }

                                                    return _context.abrupt('return', {
                                                        v: void 0
                                                    });

                                                case 16:
                                                    if (strongMsg && !_this.showingStrongMsg) {
                                                        _this.showingStrongMsg = true;
                                                        _this.showStrongAlert(strongMsg.msgInfo.typeDesc, strongMsg.msgInfo.msgBody, _this.getBtnTextByMessage(strongMsg.msgInfo), function () {
                                                            var msgId = strongMsg.msgInfo.broadCastId;
                                                            if (!_this.ignoreMarkAsRead(strongMsg)) {
                                                                (0, _tripNotify.handleMsg)(msgId);
                                                            }
                                                            _this.processMsg(strongMsg);
                                                            _this.showingStrongMsg = false;
                                                            setTimeout(function () {
                                                                return _this.showMiddleToastMsg(latestMsgs);
                                                            }, 10000);
                                                        });
                                                    } else {
                                                        _this.showMiddleToastMsg(latestMsgs);
                                                    }

                                                case 17:
                                                case 'end':
                                                    return _context.stop();
                                            }
                                        }
                                    }, _callee, _this);
                                })(), 't0', 17);

                            case 17:
                                _ret = _context2.t0;

                                if (!((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object")) {
                                    _context2.next = 20;
                                    break;
                                }

                                return _context2.abrupt('return', _ret.v);

                            case 20:
                                _context2.next = 25;
                                break;

                            case 22:
                                _context2.prev = 22;
                                _context2.t1 = _context2['catch'](15);

                                console.log(_context2.t1);

                            case 25:
                                ++i;
                                _context2.next = 8;
                                break;

                            case 28:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[15, 22]]);
            }));

            function onUnreadChange(_x) {
                return _ref.apply(this, arguments);
            }

            return onUnreadChange;
        }()
    }, {
        key: 'showMiddleToastMsg',
        value: function showMiddleToastMsg(latestMsgs) {
            var _this2 = this;

            if (this.showingMiddleToast) {
                return;
            }
            var middleMsg = latestMsgs.find(function (msg) {
                return msg.typeWeight === _this2.MIDDLEWEIGHT;
            });
            if (middleMsg && !this.showingMiddleToast) {
                this.showingMiddleToast = true;
                var msgId = middleMsg && middleMsg.msgInfo && middleMsg.msgInfo.broadCastId || null;
                this.showMiddleToast(middleMsg.msgInfo.typeDesc, middleMsg.msgInfo.msgBody, this.getBtnTextByMessage(middleMsg.msgInfo), msgId, function () {
                    _this2.showingMiddleToast = false;
                    if (!_this2.ignoreMarkAsRead(middleMsg)) {
                        (0, _tripNotify.handleMsg)(msgId);
                    }
                    _this2.processMsg(middleMsg);
                    _this2.showingMiddleToast = false;
                    _this2.Notice.close(msgId);
                });
            }
        }
    }, {
        key: 'showMiddleToast',
        value: function showMiddleToast(title, msg, btnText, name, okCallBack) {
            this.Notice.warning({
                duration: 0,
                name: name,
                title: title,
                render: function render(h) {
                    return h('div', [h('div', [msg]), h('div', [h('Button', {
                        style: {
                            float: 'right',
                            marginTop: '10px'
                        },
                        props: {
                            type: 'info'
                        },
                        on: {
                            click: okCallBack
                        }
                    }, [btnText])])]);
                }
            });
        }
    }, {
        key: 'showStrongAlert',
        value: function showStrongAlert(title, msg, btnText, okCallBack) {
            this.Modal.warning({
                title: title,
                content: msg,
                okText: btnText || '去处理',
                closable: true,
                onOk: okCallBack
            });
        }
    }, {
        key: 'getBtnTextByMessage',
        value: function getBtnTextByMessage(msg) {
            var landPageInfo = _notification.LandingPageMap[msg.typeId || msg.msgTypeId];
            return landPageInfo ? '去处理' : '已联系BD';
        }
    }, {
        key: 'processMsg',
        value: function processMsg(msg) {
            if (msg.msgInfo && msg.msgInfo.typeId) {
                var landPageInfo = _notification.LandingPageMap[msg.msgInfo.typeId + 'taa'] || _notification.LandingPageMap[msg.msgInfo.typeId];
                if (landPageInfo.urlPattern) {
                    window.open(landPageInfo.urlPattern.replace("$bizKey", msg.msgInfo.bizKey), "_blank");
                    return;
                }
                if (landPageInfo) {
                    var params = {};
                    if (landPageInfo.paramName) {
                        params[landPageInfo.paramName] = msg.msgInfo.bizKey;
                    }
                    if (landPageInfo.paramsExt) {
                        params = Object.assign(landPageInfo.paramsExt, params);
                    }
                    if (landPageInfo.query) {
                        query = Object.assign({}, landPageInfo.query);
                    }
                    this.router.push({ name: landPageInfo.stateName, query: params, params: params });
                }
            }
        }
    }, {
        key: 'ignoreMarkAsRead',
        value: function ignoreMarkAsRead(msg) {
            if (msg && msg.msgInfo && msg.msgInfo.typeId === 65) {
                return true;
            }
            return false;
        }
    }]);
    return ToastAndAlertNotification;
}();

exports.default = ToastAndAlertNotification;

/***/ }),
/* 922 */
/*!******************************************************!*\
  !*** ./src/components/message/voiceNotification.vue ***!
  \******************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./voiceNotification.vue */ 923),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3e354c12","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./voiceNotification.vue */ 925),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 923 */
/*!*************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/message/voiceNotification.vue ***!
  \*************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(/*! babel-runtime/helpers/toConsumableArray */ 96);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _AppService = __webpack_require__(/*! utils/AppService.js */ 924);

var _AppService2 = _interopRequireDefault(_AppService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: {
        audioElemMap: {
            ticketQaVoiceNotify: {
                audioElem: null, // dom元素
                next: null // 指向下一个
            },
            jiujingQaVoiceNotify: {
                audioElem: null,
                next: null
            },
            gtyQaVoiceNotify: {
                audioElem: null,
                next: null
            }
        },
        queue: [],
        appService: {}
    },
    beforeCreate: function beforeCreate() {
        this.appService = new _AppService2.default();
    },

    computed: {
        unreadMap: function unreadMap() {
            return this.$store.state.unreadMap;
        }
    },
    watch: {
        unreadMap: function unreadMap() {
            if (this.getQAnoticeUnhandled(this.$store.state.unreadMap)) {
                this.playNotice();
            }
        }
    },
    methods: {
        getQAnoticeUnhandled: function getQAnoticeUnhandled(changesMap) {
            var msgCountRecord = void 0;
            try {
                msgCountRecord = JSON.parse(this.appService.getSerialized('sessionStorage', 'msgCountRecord'));
            } catch (e) {
                msgCountRecord = null;
            }

            // 如果sessionStorage中没有消息数目记录
            if (!msgCountRecord) {
                msgCountRecord = {
                    ticketQaVoiceNotify: 0,
                    jiujingQaVoiceNotify: 0,
                    gtyQaVoiceNotify: 0
                };
                this.appService.setSerialized('sessionStorage', 'msgCountRecord', JSON.stringify(msgCountRecord));
            }

            var filterResArr = Object.keys(changesMap).filter(function (filterItem) {
                // msgCountRecord[filterItem]为undefined时永远为false，故无须判断msgCountRecord[filterItem]
                if (msgCountRecord[filterItem] < changesMap[filterItem]) {
                    // 如果未处理消息数量有新增
                    msgCountRecord[filterItem] = changesMap[filterItem];
                    return true;
                }
                // 如果没有新增
                if (msgCountRecord[filterItem]) {
                    msgCountRecord[filterItem] = changesMap[filterItem] || 0;
                }
                return false;
            });

            this.appService.setSerialized('sessionStorage', 'msgCountRecord', JSON.stringify(msgCountRecord));

            this.queue = [].concat((0, _toConsumableArray3.default)(filterResArr));

            return this.queue.length > 0;
        },
        playNotice: function playNotice() {
            var queue = this.queue;
            var index = queue.length - 1;
            var lastOfQueue = void 0;

            while (index > 0) {
                lastOfQueue = queue[index--];
                this.audioElemMap[lastOfQueue].next = queue[index];
            }

            this._playAudioInQueue();
        },
        _playAudioInQueue: function _playAudioInQueue() {
            var _this = this;

            var queue = _queue || this.queue;
            var lastOfQueue = queue.pop();
            // 代表一个voiceNotify节点(这些抽象的节点包含了消息数目、下一个节点2种信息，类似一个链表)
            var voiceNode = this.audioElemMap[lastOfQueue];

            if (!voiceNode.audioElem) {
                voiceNode.audioElem = document.querySelector('#' + lastOfQueue);
            }

            voiceNode.audioElem.play();

            voiceNode.audioElem.addEventListener('ended', function () {
                if (queue.length > 0) {
                    _this._playAudioInQueue(queue);
                }
            });
        }
    }
}; //
//
//
//
//
//
//

/***/ }),
/* 924 */
/*!*********************************!*\
  !*** ./src/utils/AppService.js ***!
  \*********************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ 74);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ 75);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * manage app state and allow those state persistent in storage
 */

var AppService = function () {
    function AppService() {
        (0, _classCallCheck3.default)(this, AppService);

        this.appId = '3f';
    }

    // 通用获取序列化数据 storage可能取值'localStorage'、'sessionStorage'


    (0, _createClass3.default)(AppService, [{
        key: 'getSerialized',
        value: function getSerialized(storage, key) {
            var actualKey = this.appId + '.' + key;
            var res = void 0;
            if (!window[storage]) {
                throw new Error(storage + '\u4E0D\u5B58\u5728');
            }
            try {
                res = JSON.parse(window[storage].getItem(actualKey));
            } catch (e) {
                res = null;
            }
            return res;
        }

        // 通用设置序列化数据 storage可能取值'localStorage'、'sessionStorage'

    }, {
        key: 'setSerialized',
        value: function setSerialized(storage, key, value) {
            var actualKey = this.appId + '.' + key;
            if (!window[storage]) {
                throw new Error(storage + '\u4E0D\u5B58\u5728');
            }
            try {
                window[storage].setItem(actualKey, JSON.stringify(value));
            } catch (e) {
                console.log(e, 'you may exit privacy mode');
            }
        }
    }, {
        key: 'getSerializedValue',
        value: function getSerializedValue(key) {
            return this.getSerialized('localStorage', key);
        }
    }, {
        key: 'setSerializedValue',
        value: function setSerializedValue(key, value) {
            this.setSerialized('localStorage', key, value);
        }
    }, {
        key: 'getSessionSerializedValue',
        value: function getSessionSerializedValue(key) {
            return this.getSerialized('sessionStorage', key);
        }
    }, {
        key: 'setSessionSerializedValue',
        value: function setSessionSerializedValue(key, value) {
            this.setSerialized('sessionStorage', key, value);
        }
    }, {
        key: 'getObject',
        value: function getObject(key) {
            var obj = this.getSerializedValue(key);
            if (angular.isString(obj)) {
                try {
                    return JSON.parse(obj);
                } catch (e) {
                    return obj;
                }
            }
            return obj;

            // let serializedState = this.getSerializedValue(key);
            // return serializedState ? JSON.parse(serializedState) : null;
        }
    }, {
        key: 'getString',
        value: function getString(key) {
            return this.getSerializedValue(key);
        }
    }, {
        key: 'getNumber',
        value: function getNumber(key) {
            return Number(this.getSerializedValue(key));
        }
    }, {
        key: 'setObject',
        value: function setObject(key, value) {
            // let serializedState = JSON.stringify(value);
            this.setSerializedValue(key, value);
        }
    }, {
        key: 'setString',
        value: function setString(key, value) {
            this.setSerializedValue(key, value);
        }
    }, {
        key: 'setNumber',
        value: function setNumber(key, value) {
            this.setSerializedValue(key, String(value));
        }
    }, {
        key: 'clear',
        value: function clear() {
            var key = void 0;
            for (var i = 0; i < localStorage.length; i++) {
                key = localStorage.key(i);
                if (this._startsWith(key, this.appId + '.')) {
                    localStorage.removeItem(key);
                    i--;
                }
            }
        }
    }, {
        key: '_startsWith',
        value: function _startsWith(subject, search) {
            return subject.substr(0, search.length) === search;
        }
    }]);
    return AppService;
}();

exports.default = AppService;

/***/ }),
/* 925 */
/*!*****************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e354c12","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/message/voiceNotification.vue ***!
  \*****************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "visibility": "hidden"
    }
  }, [_c('audio', {
    attrs: {
      "id": "gtyQaVoiceNotify",
      "src": "https://awp-assets.meituan.net/hfe/fep/gtynotice.mp3"
    }
  }), _vm._v(" "), _c('audio', {
    attrs: {
      "id": "jiujingQaVoiceNotify",
      "src": "https://awp-assets.meituan.net/hfe/fep/jingjiunotice.mp3"
    }
  })])
}]}

/***/ }),
/* 926 */
/*!********************************************************!*\
  !*** ./src/components/ConfirmOrders/ConfirmOrders.vue ***!
  \********************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ConfirmOrders.vue */ 927),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6a63b358","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ConfirmOrders.vue */ 929),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 927 */
/*!***************************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ConfirmOrders/ConfirmOrders.vue ***!
  \***************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _env = __webpack_require__(/*! config/env.conf */ 2);

var _packageProduct = __webpack_require__(/*! config/packageProduct */ 165);

var _packageproduct = __webpack_require__(/*! api/packageproduct */ 928);

var storageKey = "3f.orderToastedList"; //
//

exports.default = {
    data: function data() {
        return {};
    },
    created: function created() {
        var _this = this;

        this.timerId = null;
        this.timerId = window.setInterval(function () {
            _this.getConfirmOrders();
        }, _packageProduct.Package_Order_Interval);
        this.getConfirmOrders();
    },

    methods: {
        getConfirmOrders: function getConfirmOrders() {
            var _this2 = this;

            (0, _packageproduct.getConfirmOrders)().then(function (data) {
                var orderNum = data.pageInfo && data.pageInfo.dataNum || 0;
                if (orderNum > 0) {
                    _this2.showConfirmOrdersDialog(orderNum, data.orderListInfos);
                }
                _this2.$store.state.jiuJingConfirmOrders = orderNum;
            });
        },
        showConfirmOrdersDialog: function showConfirmOrdersDialog(totalOrderNum, orderList) {
            var handledOrdersStr = window.localStorage.getItem(storageKey);
            var handledOrders = [];
            if (handledOrdersStr) {
                handledOrders = JSON.parse(handledOrdersStr);
            }
            var newOrders = [];
            if (handledOrders && handledOrders.length) {
                orderList.forEach(function (orderItem) {
                    var isNewOrder = handledOrders.find(function (orderId) {
                        return orderId === orderItem.orderId;
                    }) ? false : true;
                    if (isNewOrder) {
                        newOrders.push(orderItem.orderId);
                    }
                });
            } else {
                newOrders = orderList.map(function (orderItem) {
                    return orderItem.orderId;
                });
            }
            if (newOrders && newOrders.length) {
                var hasMore = totalOrderNum > orderList.length ? true : false;
                this.$Player.play("https://s0.meituan.net/ecom/voice/hotel-poll.mp3");
                this.$TitleMessager.show("您有新的酒景待确认订单需要处理");
                var self = this;
                window.localStorage.setItem(storageKey, JSON.stringify(handledOrders.concat(newOrders)));
                this.$Modal.info({
                    title: "酒景待确认订单列表",
                    scrollable: true,
                    closable: false,
                    render: function render(h) {
                        return h("OrdersInDialog", {
                            props: {
                                hasMore: hasMore,
                                orders: newOrders
                            }
                        });
                    },
                    onOk: function onOk() {
                        self.$Player.stop();
                        self.$TitleMessager.reset();
                    }
                });
            }
        }
    },
    destroyed: function destroyed() {
        if (this.timerId) {
            window.clearInterval(this.timerId);
        }
    }
};

/***/ }),
/* 928 */
/*!***********************************!*\
  !*** ./src/api/packageproduct.js ***!
  \***********************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getConfirmOrders = undefined;

var _axios = __webpack_require__(/*! axios */ 12);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var confirmOrderParams = { payStatus: 1, orderStatus: 2, pageId: 1, pageSize: 10 };
var baseServiceUrl = '/trip-package-auditapi/api/biz/';

var getConfirmOrders = exports.getConfirmOrders = function getConfirmOrders(params) {
    return _axios2.default.get(baseServiceUrl + 'order/list', {
        params: Object.assign(confirmOrderParams, params || {})
    }).then(function (response) {
        return response.data;
    });
};

/***/ }),
/* 929 */
/*!*******************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a63b358","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfirmOrders/ConfirmOrders.vue ***!
  \*******************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 930 */
/*!**********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cae76352","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Main.vue ***!
  \**********************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.spinShow) ? _c('Spin', {
    attrs: {
      "size": "large",
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('menu-aside'), _vm._v(" "), (_vm.hasJiuJing) ? _c('ConfirmOrders') : _vm._e(), _vm._v(" "), _c('header', {
    staticClass: "header"
  }, [(!_vm.hideBizLines) ? _c('Select', {
    staticClass: "bizline-select",
    on: {
      "on-change": _vm.bizLineChanged
    },
    model: {
      value: (_vm.currentBizLine),
      callback: function($$v) {
        _vm.currentBizLine = $$v
      },
      expression: "currentBizLine"
    }
  }, _vm._l((_vm.authBizLines), function(bizLine) {
    return _c('Option', {
      key: bizLine.value,
      attrs: {
        "value": bizLine.value
      }
    }, [_vm._v(_vm._s(bizLine.name))])
  })) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "account-actions"
  }, [_c('Dropdown', {
    attrs: {
      "placement": "bottom-end",
      "trigger": "click"
    },
    on: {
      "on-click": _vm.dropDownMenuClicked
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.userName) + "\n          "), _c('Icon', {
    attrs: {
      "type": "arrow-down-b"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    slot: "list"
  }, _vm._l((_vm.userMenus), function(menu) {
    return _c('DropdownItem', {
      key: menu.id,
      attrs: {
        "name": menu.id
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      }
    }, [_vm._v(_vm._s(menu.name))])])
  }))], 1), _vm._v(" "), _c('span', {
    staticClass: "account-type"
  }, [_vm._v(_vm._s(_vm.accountType))]), _vm._v(" "), _c('span', {
    staticClass: "msg-center"
  }, [_c('msg-center'), _vm._v(" "), _c('voice-notification')], 1), _vm._v(" "), _c('span', {
    staticClass: "presale-chat",
    attrs: {
      "title": "售前服务"
    },
    on: {
      "click": _vm.openPreSale
    }
  }, [_c('Icon', {
    attrs: {
      "type": 'turbo-ui-headset'
    }
  })], 1), _vm._v(" "), (_vm.hasWalletList) ? _c('span', {
    staticClass: "my-wallet",
    attrs: {
      "title": "我的钱包"
    },
    on: {
      "click": _vm.navToWalletList
    }
  }, [_c('Icon', {
    attrs: {
      "type": 'turbo-ui-wallet'
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "work-space"
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 931 */
/*!****************************************!*\
  !*** ./src/router/router.wenchuang.js ***!
  \****************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _viewWrapper = __webpack_require__(/*! components/view-wrapper/view-wrapper.vue */ 52);

var _viewWrapper2 = _interopRequireDefault(_viewWrapper);

var _innerFrame = __webpack_require__(/*! components/inner-frame/inner-frame */ 42);

var _innerFrame2 = _interopRequireDefault(_innerFrame);

var _routeBuilder = __webpack_require__(/*! ./routeBuilder */ 66);

var _routeBuilder2 = _interopRequireDefault(_routeBuilder);

var _HomePage = __webpack_require__(/*! views/academy/HomePage.vue */ 67);

var _HomePage2 = _interopRequireDefault(_HomePage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bizLine = 'wenchuang';

var wcBuilder = new _routeBuilder2.default(bizLine, _viewWrapper2.default, _innerFrame2.default);

var xgxy = _routeBuilder2.default.buildXAXY(wcBuilder, _HomePage2.default);

function getBizLineRouteName(name) {
    return bizLine + name;
}
exports.default = [{
    name: getBizLineRouteName('home'),
    path: '',
    component: __webpack_require__(/*! components/nhomepage/nhomepage.vue */ 97),
    meta: {
        title: '首页',
        icon: 'turbo-ui-home',
        bizLineId: 1
    }
}, {
    name: getBizLineRouteName('order'),
    path: 'order',
    component: _viewWrapper2.default,
    meta: {
        title: '订单管理',
        icon: 'assignment'
    },
    children: [{
        name: getBizLineRouteName('orderList'),
        path: 'orderList',
        component: __webpack_require__(/*! views/wenchuang/orderList/Main.vue */ 932),
        meta: {
            title: '订单列表'
        }
    }, {
        name: getBizLineRouteName('shippingOrderList'),
        path: 'shippingOrderList',
        component: __webpack_require__(/*! views/wenchuang/shippingOrder/Main.vue */ 936),
        meta: {
            title: '待出货订单'
        }
    }, {
        name: getBizLineRouteName('refundOrderList'),
        path: 'refundOrderList',
        component: __webpack_require__(/*! views/wenchuang/refundOrder/Main.vue */ 940),
        meta: {
            title: '待退款订单'
        }
    }, {
        name: getBizLineRouteName('OrderDetails'),
        path: 'refundOrderList',
        component: __webpack_require__(/*! views/wenchuang/orderDetails/Main.vue */ 944),
        meta: {
            title: '订单详情',
            notMenu: true
        }
    }]
}, xgxy];

/***/ }),
/* 932 */
/*!************************************************!*\
  !*** ./src/views/wenchuang/orderList/Main.vue ***!
  \************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-6626d1b8","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Main.vue */ 933)
}
var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Main.vue */ 934),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-6626d1b8","hasScoped":true}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Main.vue */ 935),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6626d1b8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 933 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6626d1b8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/wenchuang/orderList/Main.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 934 */
/*!*******************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/wenchuang/orderList/Main.vue ***!
  \*******************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _wenchuang = __webpack_require__(/*! api/wenchuang */ 120);

var _wenchuang2 = _interopRequireDefault(_wenchuang);

var _moment = __webpack_require__(/*! moment */ 32);

var _moment2 = _interopRequireDefault(_moment);

var _constant = __webpack_require__(/*! ../constant.js */ 171);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            form: {
                id: '',
                customerPhone: ''
            },
            orderState: -1, // 全部订单
            ORDER_STATE_LIST: _constant.ORDER_STATE_LIST,
            currentPage: 1,
            totalCount: 0,
            tableData: [],
            tableColumn: [{
                key: 'id',
                name: '订单号'
            }, {
                key: 'productInfo',
                name: '产品名称',
                type: 'slot',
                slot: 'productInfo'
            }, {
                key: 'totalPrice',
                name: '总价'
            }, {
                key: 'refundGoodsInfo',
                name: '商家信息'
            }, {
                key: 'orderCreateTime',
                name: '下单时间'
            }, {
                key: 'customerInfo',
                name: '联系人信息',
                type: 'slot',
                slot: 'customerInfo'
            }, {
                key: 'extInfo',
                name: '备注'
            }, {
                key: 'orderStatusStr',
                name: '状态'
            }, {
                key: 'action',
                name: '操作',
                type: 'btn',
                opt: [{
                    text: '查看订单',
                    method: 'getOrderDetails'
                }]
            }],
            isLoading: false
        };
    },

    methods: {

        // 获取订单数据
        getTableData: function getTableData() {
            var _this = this;

            this.isLoading = true;
            _wenchuang2.default.getOrderListData(this.orderState, this.form, this.currentPage).then(function (res) {
                console.log(res);
                if (res.status === 0) {
                    var data = res.data;
                    var tableData = [];
                    data.forEach(function (item) {
                        tableData.push({
                            id: item.id,
                            productInfo: {
                                productName: item.productName,
                                productNo: item.productNo,
                                goodsNo: item.goodsNo
                            },
                            totalPrice: item.totalPrice,
                            refundGoodsInfo: item.refundGoodsInfo,
                            orderCreateTime: (0, _moment2.default)(item.orderCreateTime).format('YYYY-MM-DD HH:mm:ss'),
                            customerInfo: {
                                customerName: item.customerName,
                                customerPhone: item.customerPhone,
                                customerAddress: item.customerAddress
                            },
                            extInfo: item.extInfo,
                            orderStatusStr: item.orderStatusStr
                        });
                    });
                    _this.tableData = tableData;
                    _this.totalCount = res.paging.count;
                } else {
                    _this.$notify.error({
                        title: '错误',
                        message: res.message || '请求失败'
                    });
                }
                _this.isLoading = false;
            }).catch(function (err) {
                console.log(err);
                _this.isLoading = false;
            });
        },


        // 查看订单
        getOrderDetails: function getOrderDetails(row, col, val, data) {
            console.log(row, col, val, data);
            if (data.id) {
                router.push({ name: 'wenchuangOrderDetails', params: { orderId: data.id } });
            }
        },


        // 搜索订单
        searchOrder: function searchOrder() {
            this.getTableData();
        },


        // 导出订单
        exportExcel: function exportExcel() {
            var params = {
                orderState: this.orderState,
                id: this.form.id,
                customerPhone: this.form.customerPhone
            };
            _wenchuang2.default.downloadOrder(params);
        },


        // 切换页码
        currentChangeFunc: function currentChangeFunc(ev) {
            this.currentPage = ev.current;
            this.getTableData();
        }
    },
    created: function created() {
        this.getTableData();
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 935 */
/*!**********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6626d1b8","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/wenchuang/orderList/Main.vue ***!
  \**********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('h2', [_vm._v("订单查询")]), _vm._v(" "), _c('v-form', {
    staticStyle: {
      "width": "100%",
      "margin-top": "40px"
    },
    attrs: {
      "label-width": "6em",
      "model": _vm.form
    }
  }, [_c('v-form-item', {
    attrs: {
      "label": "订单号"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.id),
      expression: "form.id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.id = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-form-item', {
    attrs: {
      "label": "联系人手机"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.customerPhone),
      expression: "form.customerPhone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.customerPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.customerPhone = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-form', {
    staticStyle: {
      "width": "100%",
      "margin-top": "30px"
    },
    attrs: {
      "label-width": "6em",
      "model": _vm.form
    }
  }, [_c('v-form-item', {
    attrs: {
      "label": "订单状态"
    }
  }, [_c('v-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.orderState),
      callback: function($$v) {
        _vm.orderState = $$v
      },
      expression: "orderState"
    }
  }, _vm._l((_vm.ORDER_STATE_LIST), function(item) {
    return _c('v-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('v-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searchOrder
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('h2', [_vm._v("查询结果"), _c('v-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出订单")])], 1), _vm._v(" "), _c('v-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticStyle: {
      "width": "100%",
      "background-color": "#FFF",
      "margin-top": "20px"
    },
    attrs: {
      "data": _vm.tableData,
      "column": _vm.tableColumn
    },
    on: {
      "getOrderDetails": _vm.getOrderDetails
    },
    scopedSlots: _vm._u([{
      key: "productInfo",
      fn: function(props) {
        return [_c('div', [_vm._v("产品名称：" + _vm._s(props.data.productName))]), _vm._v(" "), _c('div', [_vm._v("产品编号：" + _vm._s(props.data.productNo))]), _vm._v(" "), _c('div', [_vm._v("货号：" + _vm._s(props.data.goodsNo))])]
      }
    }, {
      key: "customerInfo",
      fn: function(props) {
        return [_c('div', [_vm._v(_vm._s(props.data.customerName))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(props.data.customerPhone))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(props.data.customerAddress))])]
      }
    }])
  }), _vm._v(" "), _c('v-pagination', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "current": _vm.currentPage,
      "total": Math.ceil(_vm.totalCount / 20),
      "size": 'md',
      "first": false,
      "last": false
    },
    on: {
      "current-change": function($event) {
        _vm.currentChangeFunc($event)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 936 */
/*!****************************************************!*\
  !*** ./src/views/wenchuang/shippingOrder/Main.vue ***!
  \****************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-41ba7904","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Main.vue */ 937)
}
var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Main.vue */ 938),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-41ba7904","hasScoped":true}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Main.vue */ 939),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-41ba7904",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 937 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-41ba7904","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/wenchuang/shippingOrder/Main.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 938 */
/*!***********************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/wenchuang/shippingOrder/Main.vue ***!
  \***********************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _wenchuang = __webpack_require__(/*! api/wenchuang */ 120);

var _wenchuang2 = _interopRequireDefault(_wenchuang);

var _moment = __webpack_require__(/*! moment */ 32);

var _moment2 = _interopRequireDefault(_moment);

var _constant = __webpack_require__(/*! ../constant.js */ 171);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            form: {
                id: '',
                customerPhone: '',
                productNo: '',
                productName: ''
            },
            orderState: 1, // 待发货订单
            currentPage: 1,
            totalCount: 0,
            tableData: [],
            tableColumn: [{
                key: 'id',
                name: '订单号'
            }, {
                key: 'productInfo',
                name: '产品名称',
                type: 'slot',
                slot: 'productInfo'
            }, {
                key: 'totalPrice',
                name: '总价'
            }, {
                key: 'refundGoodsInfo',
                name: '商家信息'
            }, {
                key: 'orderCreateTime',
                name: '下单时间'
            }, {
                key: 'customerInfo',
                name: '联系人信息',
                type: 'slot',
                slot: 'customerInfo'
            }, {
                key: 'extInfo',
                name: '备注'
            }, {
                key: 'action',
                name: '操作',
                type: 'slot',
                slot: 'action'
            }],
            sendProductDialog: false, // 发货弹层
            sendProductInfo: { // 发货信息
                id: '',
                productName: '',
                productNo: '',
                orderCreateTime: '',
                totalPrice: '',
                customerName: '',
                customerPhone: '',
                customerAddress: ''
            },
            expressInfo: [], // 所有快递公司信息
            deliver: {
                deliverCode: '', // 快递公司编号
                deliverNo: '' // 快递单号
            },
            REJECT_REASON: _constant.REJECT_REASON, //放弃理由
            rejectDialog: false, // 放弃弹层
            rejectInfo: {
                id: '',
                reason: '',
                describe: ''
            },
            isLoading: false
        };
    },

    methods: {

        // 获取订单数据
        getTableData: function getTableData() {
            var _this = this;

            this.isLoading = true;
            _wenchuang2.default.getOrderListData(this.orderState, this.form, this.currentPage).then(function (res) {
                console.log(res);
                if (res.status === 0) {
                    var data = res.data;
                    var tableData = [];
                    data.forEach(function (item) {
                        tableData.push({
                            id: item.id,
                            productInfo: {
                                productName: item.productName,
                                productNo: item.productNo,
                                goodsNo: item.goodsNo
                            },
                            totalPrice: item.totalPrice,
                            refundGoodsInfo: item.refundGoodsInfo,
                            orderCreateTime: (0, _moment2.default)(item.orderCreateTime).format('YYYY-MM-DD HH:mm:ss'),
                            customerInfo: {
                                customerName: item.customerName,
                                customerPhone: item.customerPhone,
                                customerAddress: item.customerAddress
                            },
                            extInfo: item.extInfo,
                            action: {
                                id: item.id,
                                productName: item.productName,
                                productNo: item.productNo,
                                orderCreateTime: (0, _moment2.default)(item.orderCreateTime).format('YYYY-MM-DD HH:mm:ss'),
                                totalPrice: item.totalPrice,
                                customerName: item.customerName,
                                customerPhone: item.customerPhone,
                                customerAddress: item.customerAddress
                            }
                        });
                    });
                    _this.tableData = tableData;
                    _this.totalCount = res.paging.count;
                } else {
                    _this.$notify.error({
                        title: '错误',
                        message: res.message || '请求失败'
                    });
                }
                _this.isLoading = false;
            }).catch(function (err) {
                console.log(err);
                _this.isLoading = false;
            });
        },


        // 获取快递公司信息
        getExpressInfo: function getExpressInfo() {
            var _this2 = this;

            _wenchuang2.default.getExpressInfo().then(function (res) {
                console.log(res);
                if (res.status === 0) {
                    _this2.expressInfo = res.data;
                } else {
                    _this2.$notify.error({
                        title: '错误',
                        message: res.message || '请求失败'
                    });
                }
            }).catch(function (err) {
                console.log(err);
            });
        },


        // 显示发货弹层
        sendProduct: function sendProduct(data) {
            this.sendProductInfo = {
                id: data.id,
                productName: data.productName,
                productNo: data.productNo,
                orderCreateTime: data.orderCreateTime,
                totalPrice: data.totalPrice,
                customerName: data.customerName,
                customerPhone: data.customerPhone,
                customerAddress: data.customerAddress
            };
            this.sendProductDialog = true;
        },


        // 取消发货
        cancelSendProduct: function cancelSendProduct() {
            this.sendProductDialog = false;
        },


        // 确定发货
        submitSendProduct: function submitSendProduct() {
            var _this3 = this;

            if (this.deliver.deliverCode === '' || this.deliver.deliverNo.trim() === '') {
                this.$message({
                    message: '请填写快递公司和快递单号',
                    type: 'error'
                });
                return;
            }
            _wenchuang2.default.sendProduct(this.sendProductInfo.id, this.deliver.deliverCode, this.deliver.deliverNo).then(function (res) {
                console.log(res);
                if (res.status === 0) {
                    _this3.sendProductDialog = false;
                    _this3.$alert({
                        title: '提示',
                        message: '发货成功',
                        showCancelButton: false,
                        closeOnClickModal: false
                    }).then(function () {
                        window.location.reload();
                    });
                } else {
                    _this3.$message({
                        message: '提交失败',
                        type: 'error'
                    });
                }
            }).catch(function (err) {
                console.log(err);
                _this3.$message({
                    message: '操作失败' + (err.data ? '，' + err.data : ''),
                    type: 'error'
                });
            });
        },


        // 显示放弃弹层
        reject: function reject(data) {
            this.rejectInfo.id = data.id;
            this.rejectDialog = true;
        },


        // 取消放弃
        cancelReject: function cancelReject() {
            this.rejectInfo = {
                id: '',
                reason: '',
                describe: ''
            };
            this.rejectDialog = false;
        },


        // 确定放弃
        submitReject: function submitReject() {
            var _this4 = this;

            if (this.rejectInfo.reason === '') {
                this.$message({
                    message: '请选择放弃理由',
                    type: 'error'
                });
                return;
            }
            if (this.rejectInfo.describe.trim().length > 30 || this.rejectInfo.describe.trim().length === 0) {
                this.$message({
                    message: '请填写不超过30字的描述',
                    type: 'error'
                });
                return;
            }
            _wenchuang2.default.reject(this.rejectInfo.id, this.rejectInfo.reason, this.rejectInfo.describe).then(function (res) {
                console.log(res);
                if (res.status === 0) {
                    _this4.rejectDialog = false;
                    _this4.$alert({
                        title: '提示',
                        message: '放弃成功',
                        showCancelButton: false,
                        closeOnClickModal: false
                    }).then(function () {
                        window.location.reload();
                    });
                } else {
                    _this4.$message({
                        message: '提交失败',
                        type: 'error'
                    });
                }
            }).catch(function (err) {
                console.log(err);
                _this4.$message({
                    message: '操作失败' + (err.data ? '，' + err.data : ''),
                    type: 'error'
                });
            });
        },


        // 搜索订单
        searchOrder: function searchOrder() {
            this.getTableData();
        },


        // 导出订单
        exportExcel: function exportExcel() {
            var params = {
                orderState: this.orderState,
                id: this.form.id,
                customerPhone: this.form.customerPhone,
                productNo: this.form.productNo,
                productName: this.form.productName,
                orderRefundStatus: -1
            };
            _wenchuang2.default.downloadOrder(params);
        },


        // 切换页码
        currentChangeFunc: function currentChangeFunc(ev) {
            this.currentPage = ev.current;
            this.getTableData();
        }
    },
    created: function created() {
        this.getTableData();
        this.getExpressInfo();
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 939 */
/*!**************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41ba7904","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/wenchuang/shippingOrder/Main.vue ***!
  \**************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('h2', [_vm._v("订单查询")]), _vm._v(" "), _c('v-form', {
    staticStyle: {
      "width": "100%",
      "margin-top": "40px"
    },
    attrs: {
      "label-width": "6em",
      "model": _vm.form
    }
  }, [_c('v-form-item', {
    attrs: {
      "label": "订单号"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.id),
      expression: "form.id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.id = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-form-item', {
    attrs: {
      "label": "联系人手机"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.customerPhone),
      expression: "form.customerPhone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.customerPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.customerPhone = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-form', {
    staticStyle: {
      "width": "100%",
      "margin-top": "30px"
    },
    attrs: {
      "label-width": "6em",
      "model": _vm.form
    }
  }, [_c('v-form-item', {
    attrs: {
      "label": "产品编号"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.productNo),
      expression: "form.productNo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.productNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.productNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-form-item', {
    attrs: {
      "label": "产品关键字"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.productName),
      expression: "form.productName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.productName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.productName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searchOrder
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('h2', [_vm._v("查询结果"), _c('v-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出订单")])], 1), _vm._v(" "), _c('v-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticStyle: {
      "width": "100%",
      "background-color": "#FFF",
      "margin-top": "20px"
    },
    attrs: {
      "data": _vm.tableData,
      "column": _vm.tableColumn
    },
    scopedSlots: _vm._u([{
      key: "productInfo",
      fn: function(props) {
        return [_c('div', [_vm._v("产品名称：" + _vm._s(props.data.productName))]), _vm._v(" "), _c('div', [_vm._v("产品编号：" + _vm._s(props.data.productNo))]), _vm._v(" "), _c('div', [_vm._v("货号：" + _vm._s(props.data.goodsNo))])]
      }
    }, {
      key: "customerInfo",
      fn: function(props) {
        return [_c('div', [_vm._v(_vm._s(props.data.customerName))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(props.data.customerPhone))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(props.data.customerAddress))])]
      }
    }, {
      key: "action",
      fn: function(props) {
        return [_c('div', {
          staticClass: "allow-btn",
          on: {
            "click": function($event) {
              _vm.sendProduct(props.data)
            }
          }
        }, [_vm._v("发货")]), _vm._v(" "), _c('div', {
          staticClass: "refuse-btn",
          on: {
            "click": function($event) {
              _vm.reject(props.data)
            }
          }
        }, [_vm._v("放弃")])]
      }
    }])
  }), _vm._v(" "), _c('v-pagination', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "current": _vm.currentPage,
      "total": Math.ceil(_vm.totalCount / 20),
      "size": 'md',
      "first": false,
      "last": false
    },
    on: {
      "current-change": function($event) {
        _vm.currentChangeFunc($event)
      }
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "title": "订单信息",
      "modalAppendToBody": false
    },
    model: {
      value: (_vm.sendProductDialog),
      callback: function($$v) {
        _vm.sendProductDialog = $$v
      },
      expression: "sendProductDialog"
    }
  }, [_c('ul', [_c('li', [_c('label', [_vm._v("订单号：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.sendProductInfo.id))])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("产品名称：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.sendProductInfo.productName))])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("产品编号：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.sendProductInfo.productNo))])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("货号：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.sendProductInfo.id))])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("下单时间：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.sendProductInfo.orderCreateTime))])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("总价：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.sendProductInfo.totalPrice))])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("联系人信息：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.sendProductInfo.customerName + ' ' + _vm.sendProductInfo.customerPhone + ' ' + _vm.sendProductInfo.customerAddress))])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("快递公司：")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "placeholder": "请选择",
      "filterable": ""
    },
    model: {
      value: (_vm.deliver.deliverCode),
      callback: function($$v) {
        _vm.deliver.deliverCode = $$v
      },
      expression: "deliver.deliverCode"
    }
  }, _vm._l((_vm.expressInfo), function(item) {
    return _c('v-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), _c('li', [_c('label', [_vm._v("快递单号：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deliver.deliverNo),
      expression: "deliver.deliverNo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.deliver.deliverNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deliver.deliverNo = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.cancelSendProduct
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": _vm.submitSendProduct
    }
  }, [_vm._v("确认发货")])])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "title": "放弃",
      "modalAppendToBody": false
    },
    model: {
      value: (_vm.rejectDialog),
      callback: function($$v) {
        _vm.rejectDialog = $$v
      },
      expression: "rejectDialog"
    }
  }, [_c('ul', [_c('li', [_c('label', [_vm._v("放弃理由：")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.rejectInfo.reason),
      callback: function($$v) {
        _vm.rejectInfo.reason = $$v
      },
      expression: "rejectInfo.reason"
    }
  }, _vm._l((_vm.REJECT_REASON), function(item, key) {
    return _c('v-option', {
      key: key,
      attrs: {
        "label": item,
        "value": key
      }
    })
  }))], 1), _vm._v(" "), _c('li', [_c('label', [_vm._v("描述：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rejectInfo.describe),
      expression: "rejectInfo.describe"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.rejectInfo.describe)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rejectInfo.describe = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.cancelReject
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": _vm.submitReject
    }
  }, [_vm._v("确认放弃")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 940 */
/*!**************************************************!*\
  !*** ./src/views/wenchuang/refundOrder/Main.vue ***!
  \**************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-13ae6b64","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Main.vue */ 941)
}
var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Main.vue */ 942),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-13ae6b64","hasScoped":true}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Main.vue */ 943),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-13ae6b64",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 941 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-13ae6b64","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/wenchuang/refundOrder/Main.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 942 */
/*!*********************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/wenchuang/refundOrder/Main.vue ***!
  \*********************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _wenchuang = __webpack_require__(/*! api/wenchuang */ 120);

var _wenchuang2 = _interopRequireDefault(_wenchuang);

var _moment = __webpack_require__(/*! moment */ 32);

var _moment2 = _interopRequireDefault(_moment);

var _constant = __webpack_require__(/*! ../constant.js */ 171);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            form: {
                id: '',
                customerPhone: '',
                productNo: '',
                productName: ''
            },
            orderState: 5, // 申请退款订单
            currentPage: 1,
            totalCount: 0,
            tableData: [],
            tableColumn: [{
                key: 'id',
                name: '订单号'
            }, {
                key: 'productInfo',
                name: '产品名称',
                type: 'slot',
                slot: 'productInfo'
            }, {
                key: 'totalPrice',
                name: '总价'
            }, {
                key: 'refundGoodsInfo',
                name: '商家信息'
            }, {
                key: 'orderCreateTime',
                name: '下单时间'
            }, {
                key: 'customerInfo',
                name: '联系人信息',
                type: 'slot',
                slot: 'customerInfo'
            }, {
                key: 'extInfo',
                name: '备注'
            }, {
                key: 'action',
                name: '操作',
                type: 'slot',
                slot: 'action'
            }],
            nowOrderId: '', // 当前弹层的订单id
            refuseRefundDialog: false, // 拒绝退款弹层
            REFUSE_REASON: _constant.REFUSE_REASON, // 拒绝原因
            refuse_reason_val: '', // 拒绝原因值
            allowRefundDialog: false, // 允许退款弹层
            refund_reason_val: '', // 退款原因
            isLoading: false
        };
    },

    filters: {
        formatOrderStatus: function formatOrderStatus(deliveryNo) {
            if (!deliveryNo || deliveryNo === '') {
                return '未发货';
            } else {
                return '已发货';
            }
        }
    },
    methods: {

        // 获取订单数据
        getTableData: function getTableData() {
            var _this = this;

            this.isLoading = true;
            _wenchuang2.default.getOrderListData(this.orderState, this.form, this.currentPage).then(function (res) {
                console.log(res);
                if (res.status === 0) {
                    var data = res.data;
                    var tableData = [];
                    data.forEach(function (item) {
                        tableData.push({
                            id: item.id,
                            productInfo: {
                                productName: item.productName,
                                productNo: item.productNo,
                                goodsNo: item.goodsNo
                            },
                            totalPrice: item.totalPrice,
                            refundGoodsInfo: item.refundGoodsInfo,
                            orderCreateTime: (0, _moment2.default)(item.orderCreateTime).format('YYYY-MM-DD HH:mm:ss'),
                            customerInfo: {
                                customerName: item.customerName,
                                customerPhone: item.customerPhone,
                                customerAddress: item.customerAddress
                            },
                            extInfo: item.extInfo,
                            action: {
                                id: item.id,
                                deliveryNo: item.deliveryNo
                            }
                        });
                    });
                    _this.tableData = tableData;
                    _this.totalCount = res.paging.count;
                } else {
                    _this.$notify.error({
                        title: '错误',
                        message: res.message || '请求失败'
                    });
                }
                _this.isLoading = false;
            }).catch(function (err) {
                console.log(err);
                _this.isLoading = false;
            });
        },


        // 显示拒绝退款弹层
        showRefuseRefundDialog: function showRefuseRefundDialog(data) {
            this.nowOrderId = data.id;
            this.refuseRefundDialog = true;
        },


        // 取消弹层
        cancel: function cancel() {
            this.refuseRefundDialog = false;
            this.allowRefundDialog = false;
        },


        // 确定拒绝退款
        refuseRefund: function refuseRefund() {
            var _this2 = this;

            if (this.refuse_reason_val === '') {
                this.$message({
                    message: '请选择拒绝原因',
                    type: 'error'
                });
                return;
            }
            _wenchuang2.default.handleRefund(this.nowOrderId, 2, this.refuse_reason_val).then(function (res) {
                console.log(res);
                if (res.status === 0) {
                    _this2.refuseRefundDialog = false;
                    _this2.$alert({
                        title: '提示',
                        message: '拒绝退款成功',
                        showCancelButton: false,
                        closeOnClickModal: false
                    }).then(function () {
                        window.location.reload();
                    });
                } else {
                    _this2.$message({
                        message: '提交失败',
                        type: 'error'
                    });
                }
            }).catch(function (err) {
                console.log(err);
                _this2.$message({
                    message: '操作失败' + (err.data ? '，' + err.data : ''),
                    type: 'error'
                });
            });
        },


        // 显示允许退款弹层
        showAllowRefundDialog: function showAllowRefundDialog(data) {
            this.nowOrderId = data.id;
            this.allowRefundDialog = true;
        },


        // 确定允许退款
        allowRefund: function allowRefund() {
            var _this3 = this;

            if (this.refund_reason_val.trim().length > 30 || this.refund_reason_val.trim().length === 0) {
                this.$message({
                    message: '请填写不超过30字的退款原因',
                    type: 'error'
                });
                return;
            }
            _wenchuang2.default.handleRefund(this.nowOrderId, 1, this.refund_reason_val).then(function (res) {
                console.log(res);
                if (res.status === 0) {
                    _this3.allowRefundDialog = false;
                    _this3.$alert({
                        title: '提示',
                        message: '允许退款成功',
                        showCancelButton: false,
                        closeOnClickModal: false
                    }).then(function () {
                        window.location.reload();
                    });
                } else {
                    _this3.$message({
                        message: '提交失败',
                        type: 'error'
                    });
                }
            }).catch(function (err) {
                console.log(err);
                _this3.$message({
                    message: '操作失败' + (err.data ? '，' + err.data : ''),
                    type: 'error'
                });
            });
        },


        // 搜索订单
        searchOrder: function searchOrder() {
            this.getTableData();
        },


        // 导出订单
        exportExcel: function exportExcel() {
            var params = {
                orderState: this.orderState,
                id: this.form.id,
                customerPhone: this.form.customerPhone,
                productNo: this.form.productNo,
                productName: this.form.productName,
                orderRefundStatus: -1
            };
            _wenchuang2.default.downloadOrder(params);
        },


        // 切换页码
        currentChangeFunc: function currentChangeFunc(ev) {
            this.currentPage = ev.current;
            this.getTableData();
        }
    },
    created: function created() {
        this.getTableData();
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 943 */
/*!************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13ae6b64","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/wenchuang/refundOrder/Main.vue ***!
  \************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('h2', [_vm._v("订单查询")]), _vm._v(" "), _c('v-form', {
    staticStyle: {
      "width": "100%",
      "margin-top": "40px"
    },
    attrs: {
      "label-width": "6em",
      "model": _vm.form
    }
  }, [_c('v-form-item', {
    attrs: {
      "label": "订单号"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.id),
      expression: "form.id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.id = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-form-item', {
    attrs: {
      "label": "联系人手机"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.customerPhone),
      expression: "form.customerPhone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.customerPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.customerPhone = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-form', {
    staticStyle: {
      "width": "100%",
      "margin-top": "30px"
    },
    attrs: {
      "label-width": "6em",
      "model": _vm.form
    }
  }, [_c('v-form-item', {
    attrs: {
      "label": "产品编号"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.productNo),
      expression: "form.productNo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.productNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.productNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-form-item', {
    attrs: {
      "label": "产品关键字"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.productName),
      expression: "form.productName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.productName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.productName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searchOrder
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('h2', [_vm._v("查询结果"), _c('v-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出订单")])], 1), _vm._v(" "), _c('v-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticStyle: {
      "width": "100%",
      "background-color": "#FFF",
      "margin-top": "20px"
    },
    attrs: {
      "data": _vm.tableData,
      "column": _vm.tableColumn
    },
    scopedSlots: _vm._u([{
      key: "productInfo",
      fn: function(props) {
        return [_c('div', [_vm._v("产品名称：" + _vm._s(props.data.productName))]), _vm._v(" "), _c('div', [_vm._v("产品编号：" + _vm._s(props.data.productNo))]), _vm._v(" "), _c('div', [_vm._v("货号：" + _vm._s(props.data.goodsNo))])]
      }
    }, {
      key: "customerInfo",
      fn: function(props) {
        return [_c('div', [_vm._v(_vm._s(props.data.customerName))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(props.data.customerPhone))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(props.data.customerAddress))])]
      }
    }, {
      key: "action",
      fn: function(props) {
        return [_c('div', [_vm._v(_vm._s(_vm._f("formatOrderStatus")(props.data.deliveryNo)))]), _vm._v(" "), _c('div', {
          staticClass: "refuse-btn",
          on: {
            "click": function($event) {
              _vm.showRefuseRefundDialog(props.data)
            }
          }
        }, [_vm._v("拒绝退款")]), _vm._v(" "), _c('div', {
          staticClass: "allow-btn",
          on: {
            "click": function($event) {
              _vm.showAllowRefundDialog(props.data)
            }
          }
        }, [_vm._v("允许退款")])]
      }
    }])
  }), _vm._v(" "), _c('v-pagination', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "current": _vm.currentPage,
      "total": Math.ceil(_vm.totalCount / 20),
      "size": 'md',
      "first": false,
      "last": false
    },
    on: {
      "current-change": function($event) {
        _vm.currentChangeFunc($event)
      }
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "title": "拒绝退款",
      "modalAppendToBody": false
    },
    model: {
      value: (_vm.refuseRefundDialog),
      callback: function($$v) {
        _vm.refuseRefundDialog = $$v
      },
      expression: "refuseRefundDialog"
    }
  }, [_c('ul', [_c('li', [_c('label', [_vm._v("拒绝原因：")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.refuse_reason_val),
      callback: function($$v) {
        _vm.refuse_reason_val = $$v
      },
      expression: "refuse_reason_val"
    }
  }, _vm._l((_vm.REFUSE_REASON), function(item, key) {
    return _c('v-option', {
      key: key,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": _vm.refuseRefund
    }
  }, [_vm._v("拒绝退款")])])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "title": "允许退款",
      "modalAppendToBody": false
    },
    model: {
      value: (_vm.allowRefundDialog),
      callback: function($$v) {
        _vm.allowRefundDialog = $$v
      },
      expression: "allowRefundDialog"
    }
  }, [_c('ul', [_c('li', [_c('label', [_vm._v("退款备注：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.refund_reason_val),
      expression: "refund_reason_val"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.refund_reason_val)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.refund_reason_val = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": _vm.allowRefund
    }
  }, [_vm._v("允许退款")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 944 */
/*!***************************************************!*\
  !*** ./src/views/wenchuang/orderDetails/Main.vue ***!
  \***************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-b7420430","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Main.vue */ 945)
}
var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Main.vue */ 946),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-b7420430","hasScoped":true}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Main.vue */ 947),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b7420430",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 945 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b7420430","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/wenchuang/orderDetails/Main.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 946 */
/*!**********************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/wenchuang/orderDetails/Main.vue ***!
  \**********************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _wenchuang = __webpack_require__(/*! api/wenchuang */ 120);

var _wenchuang2 = _interopRequireDefault(_wenchuang);

var _moment = __webpack_require__(/*! moment */ 32);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    data: function data() {
        return {
            orderId: this.$route.params.orderId,
            info: {
                productName: '',
                productNo: '',
                id: '',
                orderStatusStr: '',
                orderCreateTime: '',
                totalPrice: '',
                deliverName: '',
                deliverNo: '',
                refundCondition: ''
            },
            tableData: [],
            tableColumn: [{
                key: 'id',
                name: '序号'
            }, {
                key: 'money',
                name: '退款金额'
            }, {
                key: 'refundStatusStr',
                name: '退款状态'
            }, {
                key: 'refundReason',
                name: '退款原因'
            }, {
                key: 'refundNo',
                name: '退款流水号',
                type: 'slot',
                slot: 'refundNo'
            }, {
                key: 'rejectReason',
                name: '拒绝理由'
            }, {
                key: 'applyPerson',
                name: '退款发起人'
            }, {
                key: 'refundMark',
                name: '退款备注'
            }, {
                key: 'applyTime',
                name: '退款申请时间'
            }, {
                key: 'handleTime',
                name: '处理时间'
            }],
            isLoading: false
        };
    },

    watch: {
        // 监听路由变化
        '$route': function $route() {
            this.orderId = this.$route.params.orderId;
            this.getDetailsData();
        }
    },
    methods: {

        // 获取订单详情数据
        getDetailsData: function getDetailsData() {
            var _this = this;

            this.isLoading = true;
            _wenchuang2.default.getOrderDetails(this.orderId).then(function (res) {
                console.log(res);
                if (res.status === 0) {
                    var data = res.data;
                    var tableData = [];
                    _this.info = {
                        productName: data.productName,
                        productNo: data.productNo,
                        id: data.id,
                        orderStatusStr: data.orderStatusStr,
                        orderCreateTime: (0, _moment2.default)(data.orderCreateTime).format('YYYY-MM-DD HH:mm:ss'),
                        totalPrice: data.totalPrice,
                        deliverName: data.deliverName,
                        deliverNo: data.deliverNo,
                        refundCondition: data.refundCondition
                    };
                    data.refundModels.forEach(function (item) {
                        tableData.push({
                            id: item.id,
                            money: item.money,
                            refundStatusStr: item.refundStatusStr,
                            refundReason: item.refundReason,
                            refundNo: item.refundNo,
                            rejectReason: item.rejectReason,
                            applyPerson: item.applyPerson,
                            refundMark: item.refundMark,
                            applyTime: (0, _moment2.default)(item.applyTime).format('YYYY-MM-DD HH:mm:ss'),
                            handleTime: (0, _moment2.default)(item.handleTime).format('YYYY-MM-DD HH:mm:ss')
                        });
                    });
                    _this.tableData = tableData;
                } else {
                    _this.$notify.error({
                        title: '错误',
                        message: res.message || '请求失败'
                    });
                }
                _this.isLoading = false;
            }).catch(function (err) {
                console.log(err);
                _this.$alert({
                    title: '错误',
                    message: '请求失败',
                    showCancelButton: false,
                    closeOnClickModal: false
                }).then(function () {
                    window.history.back();
                });
            });
        }
    },
    created: function created() {
        this.getDetailsData();
    }
};

/***/ }),
/* 947 */
/*!*************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7420430","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/wenchuang/orderDetails/Main.vue ***!
  \*************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "main"
  }, [_c('h2', [_vm._v("订单信息")]), _vm._v(" "), _c('ul', [_c('li', [_c('label', [_vm._v("产品名称：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.info.productName))])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("产品编号：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.info.productNo))])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("订单号：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.info.id))])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("订单状态：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.info.orderStatusStr))])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("下单时间：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.info.orderCreateTime))])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("订单金额：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.info.totalPrice))])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("物流公司：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.info.deliverName))])]), _vm._v(" "), _c('li', [_c('label', [_vm._v("物流单号：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.info.deliverNo))])])]), _vm._v(" "), _c('h2', [_vm._v("退款")]), _vm._v(" "), _c('ul', [_c('li', [_c('label', [_vm._v("退款条件：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.info.refundCondition))])])]), _vm._v(" "), _c('h2', [_vm._v("历史退款")]), _vm._v(" "), _c('v-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "column": _vm.tableColumn
    },
    scopedSlots: _vm._u([{
      key: "refundNo",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "word-break": "break-all"
          }
        }, [_vm._v(_vm._s(props.data))])]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 948 */
/*!***********************************!*\
  !*** ./src/router/router.info.js ***!
  \***********************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _viewWrapper = __webpack_require__(/*! components/view-wrapper/view-wrapper.vue */ 52);

var _viewWrapper2 = _interopRequireDefault(_viewWrapper);

var _innerFrame = __webpack_require__(/*! components/inner-frame/inner-frame */ 42);

var _innerFrame2 = _interopRequireDefault(_innerFrame);

var _routeBuilder = __webpack_require__(/*! ./routeBuilder */ 66);

var _routeBuilder2 = _interopRequireDefault(_routeBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var infoBuilder = new _routeBuilder2.default('jiujing', _viewWrapper2.default, _innerFrame2.default);
var infoRoutes = _routeBuilder2.default.buildMyInfo(infoBuilder, true);
exports.default = infoRoutes;

/***/ }),
/* 949 */
/*!**********************************!*\
  !*** ./src/views/login/Main.vue ***!
  \**********************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-33a6c696","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Main.vue */ 950)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Main.vue */ 951),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-33a6c696","hasScoped":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Main.vue */ 961),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-33a6c696",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 950 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-33a6c696","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/login/Main.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 951 */
/*!*****************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/login/Main.vue ***!
  \*****************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = __webpack_require__(/*! vuex */ 14);

var _env = __webpack_require__(/*! config/env.conf */ 2);

var _common = __webpack_require__(/*! config/common */ 167);

var _layout = __webpack_require__(/*! components/layout */ 172);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    data: function data() {
        return {
            setTokenUrl: _env.apiHost + "/rimet/out/auth/redirect?feclient=lvyou_web",
            loginSrc: null
        };
    },

    components: {
        FooterBar: _layout.FooterBar
    },
    methods: Object.assign({}, (0, _vuex.mapActions)(["formPage"]), {
        getLoginSrc: function getLoginSrc() {
            var pathname = location.pathname.indexOf("index.html") > -1 ? location.pathname.replace("index.html", "redirect.html") : location.pathname + "redirect.html";
            var redirectUrl = window.location.protocol + "//" + location.host + pathname;
            var href = window.location.href;
            var referrerUrl = "";
            var gotoUrl = "";
            if (href.includes(_common.dxEnvUrlMap["production"])) {
                var urlReg = /[?&]redirect_uri=(.+?)(&|$|#)/;
                var matchArr = urlReg.exec(href);
                if (matchArr && matchArr[1]) {
                    referrerUrl = matchArr[1];
                    gotoUrl = "" + window.location.protocol + _env.apiHost + "/rimet/out/xmAuth/redirect?feclient=lvyou_web&redirectUrl=" + referrerUrl;
                }
            }
            gotoUrl = encodeURIComponent(gotoUrl);
            var continueUrl = window.location.protocol.replace(':', '') + ":" + this.setTokenUrl + "&redirect=" + encodeURIComponent(redirectUrl + (gotoUrl ? "?goto=" + gotoUrl : ""));
            return _env.loginHost + "/account/unitivelogin?bg_source=5&service=lvyou&continue=" + encodeURIComponent(continueUrl);
        }
    }),
    mounted: function mounted() {
        var _this = this;

        this.loginSrc = this.getLoginSrc();
        window.LOGINSUCCESSCALLBACK = function () {
            if (_this.fromPage && _this.fromPage.path !== "/login") {
                _this.$router.replace(_this.fromPage);
            } else {
                _this.$router.replace({ name: "newHome" });
            }
        };
    }
};

/***/ }),
/* 952 */
/*!******************************************!*\
  !*** ./src/components/layout/NavBar.vue ***!
  \******************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-76819af2","scoped":true,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./NavBar.vue */ 953)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./NavBar.vue */ 954),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-76819af2","hasScoped":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./NavBar.vue */ 955),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-76819af2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 953 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-76819af2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layout/NavBar.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 954 */
/*!*************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/NavBar.vue ***!
  \*************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = __webpack_require__(/*! vuex */ 14);

exports.default = {
    name: 'navBar',
    computed: Object.assign({}, (0, _vuex.mapState)({
        userInfo: function userInfo(state) {
            return state.userInfo;
        },
        env: function env(state) {
            return state.ENV;
        }
    })),
    methods: {}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 955 */
/*!****************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76819af2","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/NavBar.vue ***!
  \****************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "layout-header"
  }, [_c('ul', {
    staticClass: "ngui2-nav"
  }, [_c('li', {}, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("欢迎你，" + _vm._s(_vm.userInfo.name))])]), _vm._v(" "), _c('li', [(['production', 'staging'].includes(_vm.env)) ? _c('span', [_c('a', {
    staticClass: "logout",
    attrs: {
      "href": "https://sso.sankuai.com/logout"
    }
  }, [_vm._v("退出")])]) : _c('span', [_c('a', {
    staticClass: "logout",
    attrs: {
      "href": "http://develop.sso.test.sankuai.info/logout"
    }
  }, [_vm._v("退出")])])])])])
},staticRenderFns: []}

/***/ }),
/* 956 */
/*!*********************************************!*\
  !*** ./src/components/layout/FooterBar.vue ***!
  \*********************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-c2096334","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./FooterBar.vue */ 957)
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-c2096334","scoped":false,"hasInlineConfig":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=1!./FooterBar.vue */ 958)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./FooterBar.vue */ 959),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-c2096334","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./FooterBar.vue */ 960),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 957 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c2096334","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layout/FooterBar.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 958 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c2096334","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/layout/FooterBar.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 959 */
/*!****************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layout/FooterBar.vue ***!
  \****************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = __webpack_require__(/*! vuex */ 14);

exports.default = {
    name: "footerBar",
    computed: Object.assign({}, (0, _vuex.mapState)({
        version: function version(state) {
            return state.version;
        }
    }))
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 960 */
/*!********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2096334","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/FooterBar.vue ***!
  \********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_c('p', [_vm._v("©\n            "), _c('span', [_vm._v("2017")]), _vm._v(" "), _c('a', {
    staticClass: "unstyled",
    attrs: {
      "href": "https://www.meituan.com/"
    }
  }, [_vm._v("美团网团购")]), _vm._v("\n            meituan.com\n            "), _c('a', {
    staticClass: "unstyled",
    attrs: {
      "href": "http://www.beianbeian.com/beianxinxi/283f39a9-4c00-427a-97ef-3c7a9e1e0af1.html",
      "target": "_blank"
    }
  }, [_vm._v("京ICP证070791号")]), _vm._v(" "), _c('span', [_vm._v("版本:" + _vm._s(_vm.version))])])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-data"
  }, [_c('ul', {
    staticClass: "list-unstyled tel-data"
  }, [_c('li', [_c('h4', [_vm._v("商家咨询及电话验证请致电")]), _vm._v(" "), _c('h4', [_vm._v("400-660-1065")]), _vm._v(" "), _c('p', [_vm._v("周一到周日 09:00 - 21:00")])]), _vm._v(" "), _c('li', [_c('h4', [_vm._v("消费者咨询请致电")]), _vm._v(" "), _c('h4', [_vm._v("10107888")]), _vm._v(" "), _c('p', [_vm._v("周一到周日 09:00 - 22:00")])]), _vm._v(" "), _c('li', [_c('h4', [_vm._v("廉政邮箱")]), _vm._v(" "), _c('h4', [_vm._v("lianzheng@meituan.com")]), _vm._v(" "), _c('p', [_vm._v("周一到周日 09:00 - 21:00")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "footer-mark list-unstyled",
    attrs: {
      "ng-if": "$ctrl.showMark"
    }
  }, [_c('li', [_c('a', {
    staticClass: "footer-icon footer-icon-1",
    attrs: {
      "title": "备案信息",
      "href": "http://www.meituan.com/about/openinfo",
      "hidefocus": "true",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://p0.meituan.net/codeman/c144939183a31861e666846fb5f711733601.png"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "footer-icon footer-icon-2",
    attrs: {
      "href": "http://t.knet.cn/index_new.jsp",
      "target": "_blank",
      "title": "可信网站认证",
      "rel": "nofollow"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://p1.meituan.net/codeman/bd7c7958fd27346dac8802826b863e435343.png"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "footer-icon footer-icon-3",
    attrs: {
      "href": "http://www.bj315.org/xfwq/lstd/201209/t20120910_3344.shtml?dnrpluojqxbceiqq",
      "target": "_blank",
      "title": "12315消费争议",
      "rel": "nofollow"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://p1.meituan.net/codeman/bdf473bd76b1eb3f73b71a57a3afaf962232.png"
    }
  })])])])
}]}

/***/ }),
/* 961 */
/*!********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33a6c696","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/Main.vue ***!
  \********************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-root"
  }, [_c('div', {
    staticClass: "login-main"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "width": "900px",
      "margin": "auto"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    staticClass: "iframe-title"
  }, [_vm._v("商家登录")]), _vm._v(" "), (_vm.loginSrc) ? _c('iframe', {
    attrs: {
      "id": "login-content-iframe",
      "src": _vm.loginSrc,
      "frameborder": "0"
    }
  }, [_vm._v("\n                    美团商家登录平台使用了框架技术，但是您的浏览器不支持框架，请升级您的浏览器以便正常访问。\n                ")]) : _vm._e()])])]), _vm._v(" "), _c('footer-bar', {
    attrs: {
      "show-mark": "true"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-container"
  }, [_c('section', {
    staticClass: "login-desc"
  }, [_c('div', {
    staticClass: "login-desc-icon"
  }, [_c('img', {
    attrs: {
      "src": "//awp-assets.meituan.net/hfe/fep/a8e56801f64e0c6261770c41ed95a679/loginlogo.svg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-desc-title"
  }, [_vm._v("\n                        境内度假商家中心\n                    ")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_vm._v("基于新美大双平台强大的流量优势")]), _vm._v(" "), _c('li', [_vm._v("一站式解决旅游商家从日常运营到渠道拓展的全部诉求")])])])])
}]}

/***/ }),
/* 962 */
/*!***********************************!*\
  !*** ./src/views/ticket/Main.vue ***!
  \***********************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-e7fcc696","scoped":true,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Main.vue */ 963)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Main.vue */ 964),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-e7fcc696","hasScoped":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Main.vue */ 965),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e7fcc696",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 963 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e7fcc696","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/ticket/Main.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 964 */
/*!******************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/ticket/Main.vue ***!
  \******************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = __webpack_require__(/*! vuex */ 14);

exports.default = {
    data: function data() {
        return {};
    },


    methods: Object.assign({}, (0, _vuex.mapActions)(['getUser'])),
    mounted: function mounted() {}
}; //
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 965 */
/*!*********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7fcc696","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ticket/Main.vue ***!
  \*********************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 966 */
/*!***************************************!*\
  !*** ./src/views/setting/setting.vue ***!
  \***************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-4801176c","scoped":false,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./setting.vue */ 967)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./setting.vue */ 968),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-4801176c","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./setting.vue */ 974),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 967 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4801176c","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/setting/setting.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 968 */
/*!**********************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/setting/setting.vue ***!
  \**********************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _systemSetting = __webpack_require__(/*! ./systemSetting */ 969);

var _systemSetting2 = _interopRequireDefault(_systemSetting);

var _assert = __webpack_require__(/*! assert */ 970);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            useCache: true,
            disabledCacheSetting: false,
            initing: true,
            saveSuccessed: false
        };
    },
    created: function created() {
        var _this = this;

        if (window.localStorage) {
            var savedSetting = _systemSetting2.default.getSetting();
            if (savedSetting) {
                _systemSetting.SettingProperties.forEach(function (propertyName) {
                    _this[propertyName] = savedSetting[propertyName];
                });
            }
        }
        this.initing = false;
    },

    methods: {
        saveSetting: function saveSetting() {
            var _this2 = this;

            var saveObj = {};
            _systemSetting.SettingProperties.forEach(function (propertyName) {
                saveObj[propertyName] = _this2[propertyName];
            });
            if (_systemSetting2.default.saveSetting(saveObj)) {
                this.saveSuccessed = true;
            } else {
                this.$Message.error("保存失败");
            }
        },
        reloadPage: function reloadPage() {
            window.location.reload();
        }
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 969 */
/*!********************************************!*\
  !*** ./src/views/setting/systemSetting.js ***!
  \********************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var keyName = "notpSetting";
var SettingProperties = exports.SettingProperties = ["useCache"];

function getSetting() {
    if (window.localStorage) {
        return JSON.parse(localStorage.getItem(keyName));
    }
    return null;
}

function saveSetting(saveObj) {
    if (window.localStorage) {
        localStorage.setItem(keyName, JSON.stringify(saveObj));
        return true;
    }
    return false;
}

exports.default = { getSetting: getSetting, saveSetting: saveSetting };

/***/ }),
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */
/*!**************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4801176c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/setting/setting.vue ***!
  \**************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-setting"
  }, [(_vm.initing) ? _c('Spin', {
    attrs: {
      "fix": "",
      "size": "large"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "setting-row with-separator"
  }, [_c('label', [_vm._v("缓存技术：")]), _vm._v(" "), _c('iSwitch', {
    attrs: {
      "size": "large",
      "disabled": _vm.disabledCacheSetting
    },
    model: {
      value: (_vm.useCache),
      callback: function($$v) {
        _vm.useCache = $$v
      },
      expression: "useCache"
    }
  }, [_c('span', {
    slot: "open"
  }, [_vm._v("开")]), _vm._v(" "), _c('span', {
    slot: "close"
  }, [_vm._v("关")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "setting-row"
  }, [_c('Button', {
    staticClass: "save-btn",
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.saveSetting()
      }
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "保存成功"
    },
    on: {
      "on-ok": function($event) {
        _vm.reloadPage()
      }
    },
    model: {
      value: (_vm.saveSuccessed),
      callback: function($$v) {
        _vm.saveSuccessed = $$v
      },
      expression: "saveSuccessed"
    }
  }, [_c('p', [_vm._v("保存成功，刷新后立刻生效，是否刷新页面？")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 975 */
/*!********************************!*\
  !*** ./src/components/403.vue ***!
  \********************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-62fb72d4","scoped":true,"hasInlineConfig":false}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./403.vue */ 976)
}
var Component = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../node_modules/vue-loader/lib/selector?type=script&index=0!./403.vue */ 977),
  /* template */
  __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-62fb72d4","hasScoped":true}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./403.vue */ 978),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-62fb72d4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 976 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-62fb72d4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/403.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 977 */
/*!***************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/403.vue ***!
  \***************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _layout = __webpack_require__(/*! components/layout */ 172);

exports.default = {
    components: {
        NavBar: _layout.NavBar,
        FooterBar: _layout.FooterBar,
        Sidebar: _layout.Sidebar
    },
    methods: {},
    data: function data() {
        return {};
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 978 */
/*!******************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62fb72d4","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/403.vue ***!
  \******************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('footerBar')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "layout-content"
  }, [_c('div', {
    staticClass: "layout-main"
  }, [_c('div', {
    staticClass: "box-body text-center"
  }, [_c('p', [_c('img', {
    attrs: {
      "src": "https://p1.meituan.net/codeman/1e54ebe59c5c072b48d73c36ae8ec4b640004.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  })])])])])
}]}

/***/ }),
/* 979 */
/*!*********************************!*\
  !*** ./src/components/Home.vue ***!
  \*********************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-f6db2b9c","scoped":true,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Home.vue */ 980)
}
var Component = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Home.vue */ 981),
  /* template */
  __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-f6db2b9c","hasScoped":true}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Home.vue */ 982),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f6db2b9c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 980 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f6db2b9c","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Home.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 981 */
/*!****************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Home.vue ***!
  \****************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = __webpack_require__(/*! vuex */ 14);

exports.default = {
    data: function data() {
        return {};
    },


    methods: Object.assign({}, (0, _vuex.mapActions)(['getUser'])),
    mounted: function mounted() {}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 982 */
/*!*******************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6db2b9c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue ***!
  \*******************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homepage"
  }, [_vm._v("\n    欢迎访问商家系统\n")])
},staticRenderFns: []}

/***/ }),
/* 983 */
/*!**********************************************!*\
  !*** ./src/views/academy/AnnounceDetail.vue ***!
  \**********************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-382a87d8","scoped":false,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./AnnounceDetail.vue */ 984)
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-382a87d8","scoped":true,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=1!./AnnounceDetail.vue */ 985)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./AnnounceDetail.vue */ 986),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-382a87d8","hasScoped":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./AnnounceDetail.vue */ 988),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-382a87d8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 984 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-382a87d8","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/academy/AnnounceDetail.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 985 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-382a87d8","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/academy/AnnounceDetail.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 986 */
/*!*****************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/academy/AnnounceDetail.vue ***!
  \*****************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(/*! babel-runtime/helpers/toConsumableArray */ 96);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _timeformat = __webpack_require__(/*! filters/timeformat */ 987);

var _timeformat2 = _interopRequireDefault(_timeformat);

var _academy = __webpack_require__(/*! api/academy */ 259);

var _lazyLoad = __webpack_require__(/*! utils/lazyLoad */ 264);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var videojsUrls = ['//awp-assets.meituan.net/hfe/fep/b2817623d49522f2f015c2fb3aeb4347.js', '//awp-assets.meituan.net/hfe/fep/6fbdfe1b23c24b13f7eb64f887ea0c7c.css']; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    data: function data() {
        return {
            isLoading: true,
            detail: {
                title: null,
                contentText: null,
                videos: [],
                files: [],
                coverPic: null
            }
        };
    },
    filters: {
        timeformat: _timeformat2.default
    },
    created: function created() {
        var _this = this;

        var id = this.$route.params.id;
        (0, _academy.readAnnounnce)(id);
        (0, _academy.getAnnounceDetail)(id).then(function (response) {
            var data = response && response.data;
            _this.detail = data;
            if (_this.detail.videos && _this.detail.videos.length) {
                setTimeout(function () {
                    _this.loadVideo();
                }, 0);
            } else {
                _this.isLoading = false;
            }
            setTimeout(function () {
                var ele = _this.$refs.richText;
                if (ele) {
                    var width = ele.offsetWidth;
                    if (ele.querySelectorAll) {
                        var imgs = ele.querySelectorAll("img");
                        if (imgs && imgs.length) {
                            [].concat((0, _toConsumableArray3.default)(imgs)).forEach(function (img) {
                                if (img.width && img.width > width) {
                                    console.log("width");
                                    img.setAttribute("width", width.toString());
                                } else {
                                    img.onload = function (ev) {
                                        var srcEle = ev.srcElement;
                                        if (srcEle.width > width) {
                                            console.log("loadWidth");
                                            srcEle.setAttribute("width", width.toString());
                                        }
                                    };
                                }
                            });
                        }
                    }
                }
            }, 0);
        }).catch(function (err) {});
    },

    methods: {
        previewAttachment: function previewAttachment(file) {
            window.open(file.content, "_blank");
        },
        loadVideo: function loadVideo() {
            var _this2 = this;

            var options = { techOrder: ["Html5", "flash"] };
            this.isLoading = true;
            (0, _lazyLoad.addSources)(videojsUrls).then(function () {
                videojs("video-player", options);
                _this2.isLoading = false;
            }).catch(function (err) {
                console.error(err);
            });
        }
    }
};

/***/ }),
/* 987 */
/*!***********************************!*\
  !*** ./src/filters/timeformat.js ***!
  \***********************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @file timeformat
 * @author yuanhuihui  2017/8/4
 */

module.exports = function (_value, _fmt) {
    var date = _value;
    var fmt = _fmt;
    var k = void 0,
        o = void 0;
    date = date instanceof Date ? date : new Date(date);
    o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        'S': date.getMilliseconds() // 毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, String(date.getFullYear()).substr(4 - RegExp.$1.length));
    }
    for (k in o) {
        if (o.hasOwnProperty(k) && new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(String(o[k]).length));
        }
    }
    return fmt;
};

/***/ }),
/* 988 */
/*!********************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-382a87d8","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/academy/AnnounceDetail.vue ***!
  \********************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "announce-detail",
    attrs: {
      "element-loading-text": "拼命加载中"
    }
  }, [(_vm.detail.videos && _vm.detail.videos.length) ? _c('section', {
    staticClass: "video-wrap"
  }, [_c('div', {
    staticClass: "video"
  }, [_c('video', {
    staticClass: "video-js vjs-big-play-centered",
    attrs: {
      "id": "video-player",
      "controls": "",
      "poster": _vm.detail.coverPic
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.detail.videos && _vm.detail.videos.length ? _vm.detail.videos[0].content : '',
      "type": "application/x-mpegURL"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "announce-desc"
  }, [_c('header', {
    staticClass: "clearfix"
  }, [_vm._l((_vm.detail.files), function(file) {
    return _c('button', {
      key: file.src,
      staticClass: "btn-sm btn btn-preview",
      on: {
        "click": function($event) {
          _vm.previewAttachment(file)
        }
      }
    }, [_vm._v("查看课件")])
  }), _vm._v(" "), _c('h2', {
    staticClass: "announce-title"
  }, [_vm._v(_vm._s(_vm.detail.title))])], 2), _vm._v(" "), _c('section', [_c('section', {
    staticClass: "online-time"
  }, [_vm._v(_vm._s(_vm._f("timeformat")(_vm.detail.onlineTime, 'yyyy-MM-dd')))]), _vm._v(" "), _c('section', {
    ref: "richText",
    staticClass: "image-text",
    domProps: {
      "innerHTML": _vm._s(_vm.detail.contentText)
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 989 */
/*!*****************************************!*\
  !*** ./src/views/unauthorized/Main.vue ***!
  \*****************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":true,"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]_0"}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-3031b70d","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Main.vue */ 990)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Main.vue */ 991),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3031b70d","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Main.vue */ 992),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 990 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":true,"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]_0"}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3031b70d","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/unauthorized/Main.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"unauthorized":"_5me4PlddiGi4KG2uEUpqP_0","unauthorized-content":"_3ygXnLRjhrHTd6ZBDs50Sh_0","unauthorized-icon":"_1UQJ5NXKJLW9_n0ZVICmjJ_0","unauthorized-info":"RgoNRFymQgqo0F6hDq75K_0","content":"_3uuORmsnfittjcL9cV3JWX_0","btn":"_1rmBQgU74td6RncS9Ehxrx_0","btn-warning":"_1ATmR3od0Yc3tESZfeV5zS_0"};

/***/ }),
/* 991 */
/*!************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/unauthorized/Main.vue ***!
  \************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = __webpack_require__(/*! vuex */ 14);

exports.default = {
    data: function data() {
        return {
            isLogingOut: false
        };
    },
    methods: Object.assign({}, (0, _vuex.mapActions)(["doLogout"]), {
        error: function error(message) {
            this.$Modal.error({
                title: "提示",
                content: message
            });
        },
        logout: function logout() {
            var _this = this;

            this.isLogingOut = true;
            this.doLogout().then(function () {
                _this.$router.push({ name: "login" });
                _this.isLogingOut = false;
            }).catch(function (err) {
                var msg = err && err.message || "登出失败";
                _this.error(msg);
                _this.isLogingOut = false;
            });
        },
        backtoHomePage: function backtoHomePage() {
            this.$router.push({ name: "newHome" });
        }
    })
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 992 */
/*!****************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3031b70d","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/unauthorized/Main.vue ***!
  \****************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.unauthorized
  }, [(_vm.isLogingOut) ? _c('Spin', {
    attrs: {
      "size": "large",
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.$style['unauthorized-content']
  }, [_c('div', {
    class: _vm.$style['unauthorized-icon']
  }, [_c('img', {
    attrs: {
      "src": "//awp-assets.meituan.net/hfe/fep/a76da17f268c522891943db9cb3aa8e9/3funauthorized.svg"
    }
  })]), _vm._v(" "), _c('div', {
    class: _vm.$style['unauthorized-info']
  }, [_c('p', [_vm._v("\n                尊敬的商家：\n            ")]), _vm._v(" "), _c('p', {
    class: _vm.$style.content
  }, [_vm._v("\n                抱歉，您没有访问该页面的权限！\n            ")]), _vm._v(" "), _c('p', {
    class: _vm.$style.content
  }, [_vm._v("\n                如果您已是三方商家，请联系自己的业务经理咨询解决，谢谢合作！\n            ")]), _vm._v(" "), _c('button', {
    class: [_vm.$style.btn, _vm.$style['btn-warning']],
    on: {
      "click": _vm.backtoHomePage
    }
  }, [_vm._v("返回首页")]), _vm._v(" "), _c('button', {
    class: [_vm.$style.btn, _vm.$style['btn-primary']],
    attrs: {
      "disabled": _vm.isLogingOut
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n                退出登录\n            ")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 993 */
/*!********************************!*\
  !*** ./src/components/404.vue ***!
  \********************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-63098a55","scoped":true,"hasInlineConfig":false}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./404.vue */ 994)
}
var Component = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../node_modules/vue-loader/lib/selector?type=script&index=0!./404.vue */ 995),
  /* template */
  __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-63098a55","hasScoped":true}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./404.vue */ 996),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-63098a55",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 994 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-63098a55","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/404.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 995 */
/*!***************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/404.vue ***!
  \***************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _layout = __webpack_require__(/*! components/layout */ 172);

exports.default = {
    components: {
        NavBar: _layout.NavBar,
        FooterBar: _layout.FooterBar
    },
    methods: {},
    data: function data() {
        return {};
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 996 */
/*!******************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63098a55","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/404.vue ***!
  \******************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "layout-content"
  }, [_c('div', {
    staticClass: "layout-main"
  }, [_c('div', {
    staticClass: "box-body text-center"
  }, [_c('p', [_c('img', {
    attrs: {
      "src": "https://ms0.meituan.net/touch/css/i/404.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("\n                            你所访问的页面不存在\n                            "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("返回首页")])])])])])])
}]}

/***/ }),
/* 997 */
/*!*************************************************!*\
  !*** ./src/views/gtyDataCenter/programData.vue ***!
  \*************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-7aaefc23","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./programData.vue */ 998)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./programData.vue */ 999),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7aaefc23","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./programData.vue */ 1000),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 998 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7aaefc23","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/gtyDataCenter/programData.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 999 */
/*!********************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/gtyDataCenter/programData.vue ***!
  \********************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(/*! babel-runtime/helpers/defineProperty */ 114);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _gtyDataCenter = __webpack_require__(/*! api/gtyDataCenter.js */ 265);

var _formatDate = __webpack_require__(/*! helpers/formatDate.js */ 77);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    data: function data() {
        var _this = this,
            _ref;

        return _ref = {
            datalist: [],
            page: 1,
            count: 10,
            rank: 'desc',
            startTime: this.getFormateDate(new Date(new Date().valueOf() - 24 * 60 * 60 * 1000)),
            endTime: this.getFormateDate(new Date(new Date().valueOf() - 24 * 60 * 60 * 1000)),
            mtDealId: '',
            title: '',
            sortField: '',
            sortType: '2'
        }, (0, _defineProperty3.default)(_ref, 'title', ''), (0, _defineProperty3.default)(_ref, 'searchFlag', false), (0, _defineProperty3.default)(_ref, 'isDecrease', false), (0, _defineProperty3.default)(_ref, 'asc', 'asc'), (0, _defineProperty3.default)(_ref, 'desc', 'desc'), (0, _defineProperty3.default)(_ref, 'textLeft', "text-left"), (0, _defineProperty3.default)(_ref, 'noData', true), (0, _defineProperty3.default)(_ref, 'intro', ''), (0, _defineProperty3.default)(_ref, 'buttonDisable', false), (0, _defineProperty3.default)(_ref, 'timeOption', {
            onChange: function onChange(date) {
                _this.$nextTick(function (I) {
                    if (_this.startTime && _this.endTime) {
                        if (_this.endTime > _this.getFormateDate(new Date(new Date().valueOf() - 24 * 60 * 60 * 1000))) {
                            _this.intro = "结束时间应选在昨天之前";
                        } else if (_this.startTime > _this.endTime) {
                            _this.intro = "结束时间应大于开始时间";
                        } else if (_this.getFormateDate(new Date(new Date(_this.endTime).valueOf() - 90 * 24 * 60 * 60 * 1000)) > _this.startTime) {
                            _this.intro = "开始与结束时间间隔需小于90天";
                        } else if (_this.startTime < _this.getFormateDate(new Date(new Date().valueOf() - 90 * 24 * 60 * 60 * 1000)) || _this.endTime < _this.getFormateDate(new Date(new Date().valueOf() - 90 * 24 * 60 * 60 * 1000))) {
                            _this.intro = "请选择最近3个月内数据";
                        } else {
                            _this.intro = "";
                            _this.buttonDisable = false;
                        }
                        if (_this.intro) {
                            _this.buttonDisable = true;
                        }
                    }
                });
            }
        }), _ref;
    },

    created: function created() {
        this.getDataTableList();
    },
    methods: {
        getDataTableList: function getDataTableList() {
            var _this2 = this;

            (0, _gtyDataCenter.getDataTable)({
                page: this.page,
                count: this.count,
                rank: this.rank,
                startTime: this.startTime,
                endTime: this.endTime,
                mtDealId: this.mtDealId,
                sortField: this.sortField,
                sortType: this.sortType,
                title: this.title
            }).then(function (response) {
                if (response.status === 0 && response.data) {
                    _this2.datalist = response.data.list;
                    _this2.noData = !_this2.datalist.length;
                }
            }).catch(function (error) {
                _this2.alert(error);
            });
        },
        alert: function alert(message) {
            this.$alert({
                title: '提示',
                message: message,
                showCancelButton: false,
                closeOnClickModal: false
            });
        },
        getFormateDate: function getFormateDate(date) {
            return this.formdate(date, 'yyyy-MM-dd');
        },
        formdate: function formdate(time) {
            var date = new Date(time);
            return (0, _formatDate.formatDate)(date, 'yyyy-MM-dd');
        },
        orderBy: function orderBy(filter) {
            this.isDecrease = !this.isDecrease;
            this.sortField = filter;
            this.sortType = this.isDecrease ? '2' : '1';
            this.getDataTableList();
        },
        check: function check() {
            this.alert(1);
            if (this.startTime && this.endTime) {
                if (new Date(this.endTime) > this.getFormateDate(new Date(new Date().valueOf() - 24 * 60 * 60 * 1000))) {
                    this.intro = "结束时间应选在昨天之前";
                }
                if (this.startTime > this.endTime) {
                    this.intro = "结束时间应大于开始时间";
                }
            }
        }
    }
};

/***/ }),
/* 1000 */
/*!************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7aaefc23","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/gtyDataCenter/programData.vue ***!
  \************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data-center"
  }, [_c('p', {
    staticClass: "alert alert-warning"
  }, [_vm._v("提示：本页面提供的数据仅供商户作为调整经营策略参考，不作为结款与验证的准确依据")]), _vm._v(" "), _c('div', {
    staticClass: "data-container"
  }, [_c('h2', [_vm._v("项目数据概览")]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-item"
  }, [_c('v-datepicker', {
    attrs: {
      "message": _vm.startTime,
      "options": _vm.timeOption
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-item margin-top"
  }, [_vm._v("\n                    ~\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-item"
  }, [_c('v-datepicker', {
    attrs: {
      "options": _vm.timeOption,
      "message": _vm.endTime
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-itemdata control-label",
    staticStyle: {
      "margin-right": "15px"
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  }, [_c('strong', [_vm._v("产品编号：")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mtDealId),
      expression: "mtDealId"
    }],
    staticStyle: {
      "width": "200px",
      "display": "inline-block"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.mtDealId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mtDealId = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticStyle: {
      "width": "200px",
      "display": "inline-block"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.buttonDisable
    },
    on: {
      "click": _vm.getDataTableList
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.intro))])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped  table-hover"
  }, [_c('thead', {
    staticClass: "text-left",
    class: {
      'asc': _vm.sortType == '2', 'desc': _vm.sortType == '1'
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('th', {
    staticClass: "width-s",
    class: {
      'active': _vm.sortField === '1'
    },
    on: {
      "click": function($event) {
        _vm.orderBy('1')
      }
    }
  }, [_c('span', [_vm._v("销量")])]), _vm._v(" "), _c('th', {
    staticClass: "width-s",
    class: {
      'active': _vm.sortField === '2'
    },
    on: {
      "click": function($event) {
        _vm.orderBy('2')
      }
    }
  }, [_c('span', [_vm._v("销售额")])]), _vm._v(" "), _c('th', {
    staticClass: "width-s",
    class: {
      'active': _vm.sortField === '3'
    },
    on: {
      "click": function($event) {
        _vm.orderBy('3')
      }
    }
  }, [_c('span', [_vm._v("用户退款率")])]), _vm._v(" "), _c('th', {
    staticClass: "width-s",
    class: {
      'active': _vm.sortField === '4'
    },
    on: {
      "click": function($event) {
        _vm.orderBy('4')
      }
    }
  }, [_c('span', [_vm._v("商家拒单率")])]), _vm._v(" "), _c('th', {
    staticClass: "width-s",
    class: {
      'active': _vm.sortField === '5'
    },
    on: {
      "click": function($event) {
        _vm.orderBy('5')
      }
    }
  }, [_c('span', [_vm._v("访客数")])]), _vm._v(" "), _c('th', {
    staticClass: "width-s",
    class: {
      'active': _vm.sortField === '6'
    },
    on: {
      "click": function($event) {
        _vm.orderBy('6')
      }
    }
  }, [_c('span', [_vm._v("访购率")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.datalist), function(item) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(item.mtDealId))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.soldCount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.sales))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("floatToPercent")(item.refundRatio)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("floatToPercent")(item.rejectRatio)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.uv))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("floatToPercent")(item.payRatio)))])])
  }))]), _vm._v(" "), (_vm.noData) ? _c('p', {
    staticClass: "alert alert-warning"
  }, [_vm._v("该时间段内无数据。。")]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-item control-label"
  }, [_c('strong', [_vm._v("选择时间：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-itemdata control-label"
  }, [_c('strong', [_vm._v("产品名称：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticStyle: {
      "width": "150px",
      "max-width": "200px"
    }
  }, [_c('span', [_vm._v("产品编号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('span', [_vm._v("产品名称")])])
}]}

/***/ }),
/* 1001 */
/*!***************************************************!*\
  !*** ./src/views/gtyDataCenter/operationData.vue ***!
  \***************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-c697f674","scoped":false,"hasInlineConfig":false}!postcss-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./operationData.vue */ 1002)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./operationData.vue */ 1003),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-c697f674","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./operationData.vue */ 1004),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1002 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c697f674","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/gtyDataCenter/operationData.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1003 */
/*!**********************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/gtyDataCenter/operationData.vue ***!
  \**********************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _gtyDataCenter = __webpack_require__(/*! api/gtyDataCenter.js */ 265);

var _formatDate = __webpack_require__(/*! helpers/formatDate.js */ 77);

var _toPercent = __webpack_require__(/*! filters/toPercent.js */ 245);

var _toPercent2 = _interopRequireDefault(_toPercent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        var _this2 = this;

        return {
            startTime: this.getFormateDate(new Date(new Date().valueOf() - 8 * 24 * 60 * 60 * 1000)),
            endTime: this.getFormateDate(new Date(new Date().valueOf() - 24 * 60 * 60 * 1000)),
            noData: true,
            formData: {},
            dataList: [],
            intro: '',
            buttonDisable: false,
            filter: 'soldCount',
            legendName: {
                'soldCount': '销量',
                'sales': '销售额（元）',
                'payRatio': '访购率',
                'refundRatio': '用户退款率',
                'rejectRatio': '商家拒单率',
                'uv': '访客数'
            },
            timeOption: {
                onChange: function onChange(date) {
                    _this2.$nextTick(function (I) {
                        if (_this2.startTime && _this2.endTime) {
                            if (_this2.endTime > _this2.getFormateDate(new Date(new Date().valueOf() - 24 * 60 * 60 * 1000))) {
                                _this2.intro = "结束时间应选在昨天之前";
                            } else if (_this2.startTime > _this2.endTime) {
                                _this2.intro = "结束时间应大于开始时间";
                            } else if (_this2.getFormateDate(new Date(new Date(_this2.endTime).valueOf() - 90 * 24 * 60 * 60 * 1000)) > _this2.startTime) {
                                _this2.intro = "开始与结束时间间隔需小于90天";
                            } else if (_this2.startTime < _this2.getFormateDate(new Date(new Date().valueOf() - 90 * 24 * 60 * 60 * 1000)) || _this2.endTime < _this2.getFormateDate(new Date(new Date().valueOf() - 90 * 24 * 60 * 60 * 1000))) {
                                _this2.intro = "请选择最近3个月内数据";
                            } else {
                                _this2.intro = "";
                                _this2.buttonDisable = false;
                            }
                            if (_this2.intro) {
                                _this2.buttonDisable = true;
                            }
                        }
                    });
                }
            },
            options: {
                tooltip: {
                    show: true
                },
                legend: {
                    data: ['销量'] // 数据属性
                },
                xAxis: [{
                    type: 'category',
                    boundaryGap: false,
                    data: [], // X坐标内容
                    color: '#000',
                    axisLine: {
                        lineStyle: {
                            color: '#000'
                        }
                    }
                }],
                yAxis: [{
                    type: 'value',
                    axisLine: {
                        lineStyle: {
                            color: '#000'
                        }
                    },
                    axisLabel: {}
                }],
                series: [{
                    'name': '销量',
                    'type': 'line',
                    'data': [], // 数据
                    'symbolSize': 4,
                    'symbol': 'emptyCircle'
                }],
                itemStyle: {
                    width: 2,
                    emphasis: {
                        borderWidth: 2,
                        borderColor: '#000'
                    },
                    normal: {
                        areaStyle: {
                            color: '#ff9200'
                        }
                    }
                }
            }
        };
    },

    created: function created() {
        this.getGtyData();
    },
    methods: {
        getGtyData: function getGtyData() {
            var _this3 = this;

            (0, _gtyDataCenter.getGtyData)({
                startTime: this.startTime,
                endTime: this.endTime
            }).then(function (response) {
                if (response.status === 0 && response.data) {
                    _this3.datalist = response.data.details;
                    _this3.formData = response.data;
                    var arr = _this3.formatData(_this3.datalist);
                    _this3.options.xAxis[0].data = arr.xAxisData;
                    _this3.options.series[0].data = arr.seriesData[_this3.filter];
                    _this3.charts.setOption(_this3.options);
                }
            }).catch(function (error) {
                _this3.alert(error);
            });
        },
        alert: function alert(message) {
            this.$alert({
                title: '提示',
                message: message,
                showCancelButton: false,
                closeOnClickModal: false
            });
        },
        getFormateDate: function getFormateDate(date) {
            return this.formdate(date, 'yyyy-MM-dd');
        },
        toPercent: function toPercent(value) {
            return (0, _toPercent2.default)(value);
        },
        formdate: function formdate(time) {
            var date = new Date(time);
            return (0, _formatDate.formatDate)(date, 'yyyy-MM-dd');
        },
        changeFilter: function changeFilter(filter) {
            this.filter = filter;
            if (filter === 'rejectRatio' || filter === 'refundRatio' || filter === 'payRatio') {
                this.options.yAxis[0].axisLabel.formatter = '{value} %';
            } else {
                this.options.yAxis[0].axisLabel.formatter = '{value}';
            }
            this.options.series[0].data = this.formatData(this.datalist).seriesData[filter];
            this.options.legend.data[0] = this.options.series[0].name = this.legendName[filter];
            this.charts.setOption(this.options);
        },
        drawPolyLine: function drawPolyLine(id) {
            this.charts = echarts.init(document.getElementById(id));
            this.charts.setOption(this.options);
        },
        formatData: function formatData(data) {
            var _this4 = this;

            if (!data || !Array.isArray(data)) {
                return;
            }
            var i = void 0;
            var l = void 0;
            var xAxisData = [];
            var seriesData = {};

            var _loop = function _loop() {
                xAxisData.push(_this4.getFormateDate(data[i].date));
                var item = data[i];
                var _this = _this4;
                Object.keys(item).forEach(function (key) {
                    var val = item[key];
                    if (!seriesData[key]) {
                        seriesData[key] = [];
                    }
                    if (key === 'rejectRatio' || key === 'refundRatio' || key === 'payRatio') {
                        if (val) {
                            val = _this.toPercent(val);
                        } else {
                            val = 0;
                        }
                    }
                    seriesData[key].push(val);
                });
            };

            for (i = 0, l = data.length; i < l; i++) {
                _loop();
            }
            return {
                xAxisData: xAxisData,
                seriesData: seriesData
            };
        }
    },
    mounted: function mounted() {
        this.$nextTick(function () {
            this.drawPolyLine('charts');
        });
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 1004 */
/*!**************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c697f674","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/gtyDataCenter/operationData.vue ***!
  \**************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data-center"
  }, [_c('p', {
    staticClass: "alert alert-warning"
  }, [_vm._v("提示：本页面提供的数据仅供商户作为调整经营策略参考，不作为结款与验证的准确依据")]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-item"
  }, [_c('v-datepicker', {
    attrs: {
      "message": _vm.startTime,
      "options": _vm.timeOption
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-item margin-top"
  }, [_vm._v("\n                ~\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-item"
  }, [_c('v-datepicker', {
    attrs: {
      "value": _vm.endTime,
      "options": _vm.timeOption
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.buttonDisable
    },
    on: {
      "click": _vm.getGtyData
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.intro))])])]), _vm._v(" "), _c('h2', [_vm._v("经营关键指标")]), _vm._v(" "), _c('div', {
    staticClass: "box-container"
  }, [_c('div', {
    staticClass: "half-container"
  }, [_c('div', {
    staticClass: "item-container"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', [_c('p', [_vm._v("销量")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm.formData.totalSoldCount))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "half-container"
  }, [_c('div', {
    staticClass: "item-container"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "item-content"
  }, [_c('div', [_c('p', [_vm._v("销售额(元)")]), _vm._v(" "), _c('p', {
    staticClass: "quantity"
  }, [_vm._v(_vm._s(_vm.formData.totalSales))])])])])])])]), _vm._v(" "), _c('h2', [_vm._v("运营数据曲线")]), _vm._v(" "), _c('div', {
    staticClass: "data-container margin-top"
  }, [_c('h3', {
    staticClass: "projectLink"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'gtyProgramData'
      }
    }
  }, [_vm._v("查看项目数据")])], 1), _vm._v(" "), _c('div', {
    staticClass: "data-type-container"
  }, [_c('div', [_c('div', {
    staticClass: "data-reason"
  }, [_c('div', {
    staticClass: "button-item",
    class: {
      'activeButton': _vm.filter == 'soldCount'
    },
    on: {
      "click": function($event) {
        _vm.changeFilter('soldCount')
      }
    }
  }, [_vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "data-reason"
  }, [_c('div', {
    staticClass: "button-item",
    class: {
      'activeButton': _vm.filter == 'sales'
    },
    on: {
      "click": function($event) {
        _vm.changeFilter('sales')
      }
    }
  }, [_vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "data-reason"
  }, [_c('div', {
    staticClass: "button-item",
    class: {
      'activeButton': _vm.filter == 'rejectRatio'
    },
    on: {
      "click": function($event) {
        _vm.changeFilter('rejectRatio')
      }
    }
  }, [_vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "data-reason"
  }, [_c('div', {
    staticClass: "button-item",
    class: {
      'activeButton': _vm.filter == 'refundRatio'
    },
    on: {
      "click": function($event) {
        _vm.changeFilter('refundRatio')
      }
    }
  }, [_vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "data-reason"
  }, [_c('div', {
    staticClass: "button-item",
    class: {
      'activeButton': _vm.filter == 'payRatio'
    },
    on: {
      "click": function($event) {
        _vm.changeFilter('payRatio')
      }
    }
  }, [_vm._m(5)])]), _vm._v(" "), _c('div', {
    staticClass: "data-reason"
  }, [_c('div', {
    staticClass: "button-item",
    class: {
      'activeButton': _vm.filter == 'uv'
    },
    on: {
      "click": function($event) {
        _vm.changeFilter('uv')
      }
    }
  }, [_vm._m(6)])])]), _vm._v(" "), _c('div', {
    staticClass: "charts",
    attrs: {
      "id": "charts"
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-item control-label"
  }, [_c('strong', [_vm._v("选择时间：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("销量")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("销售额(元)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("商家拒单率")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("用户退款率")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("访购率")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("访客数")])])
}]}

/***/ }),
/* 1005 */
/*!**************************************!*\
  !*** ./src/store/modules/message.js ***!
  \**************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ 74);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ 75);

var _createClass3 = _interopRequireDefault(_createClass2);

var _notification = __webpack_require__(/*! data/notification */ 79);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Message = function () {
    function Message() {
        (0, _classCallCheck3.default)(this, Message);

        this.unreadMap = {};
        this.unreadData = {};
        this.unreadMsgMap = {};
        this.userId = 0;
    }

    (0, _createClass3.default)(Message, [{
        key: 'updateUnread',
        value: function updateUnread(userId, data) {
            // 不同用户，清空单例消息，适用于登出重新登录
            if (this.userId !== userId) {
                this.userId = userId;
                this.unreadMsgMap = {};
            }
            // 以下拷贝自老项目otp，不是我写的
            var unreadData = data || [];
            var unreadMsgMap = {};

            var hasUnread = false;
            if (Array.isArray(unreadData)) {
                try {
                    unreadData.forEach(function (categoryMsg) {
                        if (categoryMsg && categoryMsg.categoryCode && categoryMsg.msgTypeVOList) {
                            unreadMsgMap[categoryMsg.categoryCode] = categoryMsg.msgTypeVOList;
                        }
                    });
                    var msgs = this.unreadMsgMap && this.unreadMsgMap[_notification.TICKETORDERCODE] && this.unreadMsgMap[_notification.TICKETORDERCODE] || [];
                    var ticketOrderMsg = msgs.find(function (msg) {
                        return msg.typeId === _notification.TICKETORDERTYPE;
                    });
                    if (ticketOrderMsg) {
                        unreadMsgMap[_notification.TICKETORDERCODE].unshift(ticketOrderMsg);
                    }
                    for (var i = 0; i < _notification.MsgCategories.length; ++i) {
                        var categoryItem = _notification.MsgCategories[i];
                        var oldCategoryMsg = this.unreadMsgMap[categoryItem.id];
                        var newCategoryMsg = unreadMsgMap[categoryItem.id];
                        if (!newCategoryMsg) {
                            continue;
                        }
                        if (!oldCategoryMsg && newCategoryMsg) {
                            hasUnread = true;
                            break;
                        }

                        var _loop = function _loop(j) {
                            var newTypeMsg = newCategoryMsg[j];
                            var oldTypeMsg = oldCategoryMsg.find(function (typeMsg) {
                                return typeMsg.typeId === newTypeMsg.typeId;
                            });
                            if (!newTypeMsg) {
                                return 'continue';
                            }
                            if (!oldTypeMsg && newTypeMsg) {
                                hasUnread = true;
                                return 'break';
                            }
                            if (oldTypeMsg.count < newTypeMsg.count) {
                                hasUnread = true;
                                return 'break';
                            }
                        };

                        _loop2: for (var j = 0; j < newCategoryMsg.length; ++j) {
                            var _ret = _loop(j);

                            switch (_ret) {
                                case 'continue':
                                    continue;

                                case 'break':
                                    break _loop2;}
                        }

                        if (hasUnread) {
                            break;
                        }
                    }
                } catch (ex) {
                    console.error(ex);
                }
                this.unreadMsgMap = unreadMsgMap;
            } else {
                if (!this.unreadMsgMap) {
                    this.unreadMsgMap = {};
                }
                var _ticketOrderMsg = null;
                var _msgs = this.unreadMsgMap && this.unreadMsgMap[_notification.TICKETORDERCODE] && this.unreadMsgMap[_notification.TICKETORDERCODE] || [];
                if (_msgs.length) {
                    _ticketOrderMsg = _msgs.find(function (msg) {
                        return msg.typeId === _notification.TICKETORDERTYPE;
                    });
                }
                if (!_ticketOrderMsg) {
                    _ticketOrderMsg = { typeId: _notification.TICKETORDERTYPE, typeDesc: '待出票订单', typeWeight: 1, count: data.reserveOrderConfirm, checked: null };
                    _msgs.unshift(_ticketOrderMsg);
                    hasUnread = true;
                } else {
                    if (_ticketOrderMsg.count !== data.reserveOrderConfirm) {
                        _ticketOrderMsg.count = data.reserveOrderConfirm;
                        hasUnread = true;
                    }
                }
                this.unreadMsgMap[_notification.TICKETORDERCODE] = _msgs;
                if (!data.reserveOrderConfirm && data.reserveOrderConfirm !== 0) {
                    this.unreadMsgMap = Object.assign(this.unreadMsgMap, unreadData);
                    hasUnread = true;
                }
                unreadMsgMap = this.unreadMsgMap;
            }
            if (hasUnread) {
                return unreadMsgMap;
            } else {
                return false;
            }
        }
    }]);
    return Message;
}();

exports.default = Message;

/***/ }),
/* 1006 */
/*!*****************************!*\
  !*** ./src/utils/neixin.js ***!
  \*****************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.redirectToNeiXin = undefined;

var _common = __webpack_require__(/*! config/common */ 167);

var _env = __webpack_require__(/*! config/env.conf */ 2);

var urlIsChanging = false;
var redirectToNeiXin = exports.redirectToNeiXin = function redirectToNeiXin(userInfo) {
    if (userInfo && userInfo.userId && !urlIsChanging) {
        var referrerUrl = '';
        var href = document.location.href;
        if (href.includes(_common.dxEnvUrlMap["production"])) {
            referrerUrl = document.location.href;
            var urlReg = /[?&]redirect_uri=(.+?)(&|$|#)/;
            var matchArr = urlReg.exec(referrerUrl);
            if (matchArr && matchArr[1]) {
                referrerUrl = matchArr[1];
            }
        }
        if (referrerUrl && referrerUrl.length) {
            var redirectUrl = _env.apiHost + '/rimet/out/xmAuth/redirect?feclient=lvyou_web';
            redirectUrl += '&redirectUrl=' + (referrerUrl.includes('/') ? encodeURIComponent(referrerUrl) : referrerUrl);
            location.href = redirectUrl;
            urlIsChanging = true;
            return true;
        }
    }
    return false;
};

/***/ }),
/* 1007 */
/*!******************************!*\
  !*** ./src/filters/index.js ***!
  \******************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(/*! vue */ 30);

var _vue2 = _interopRequireDefault(_vue);

var _formatDate = __webpack_require__(/*! helpers/formatDate */ 77);

var _floatToPercent = __webpack_require__(/*! filters/floatToPercent.js */ 1008);

var _floatToPercent2 = _interopRequireDefault(_floatToPercent);

var _addCommas = __webpack_require__(/*! filters/addCommas.js */ 1009);

var _addCommas2 = _interopRequireDefault(_addCommas);

var _toFixedPercent = __webpack_require__(/*! filters/toFixedPercent.js */ 168);

var _toFixedPercent2 = _interopRequireDefault(_toFixedPercent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.filter('date', _formatDate.formatDate);
_vue2.default.filter('floatToPercent', _floatToPercent2.default);
_vue2.default.filter('toFixedPercent', _toFixedPercent2.default);
_vue2.default.filter('addCommas', _addCommas2.default);

/***/ }),
/* 1008 */
/*!***************************************!*\
  !*** ./src/filters/floatToPercent.js ***!
  \***************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (rate) {
    return (rate * 100).toFixed(1) + '%';
};

/***/ }),
/* 1009 */
/*!**********************************!*\
  !*** ./src/filters/addCommas.js ***!
  \**********************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (_nStr) {
    var nStr = _nStr;
    var x;
    var x1;
    var x2;
    var rgx;
    nStr = String(nStr);
    x = nStr.split('.');
    x1 = x[0];
    x2 = x.length > 1 ? '.' + x[1] : '';
    rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1,$2');
    }
    return x1 + x2;
};

/***/ }),
/* 1010 */
/*!***********************************************!*\
  !*** ./src/components/validate/myValidate.js ***!
  \***********************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(/*! babel-runtime/helpers/classCallCheck */ 74);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(/*! babel-runtime/helpers/createClass */ 75);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorBag = function () {
    function ErrorBag() {
        (0, _classCallCheck3.default)(this, ErrorBag);

        this.items = {};
    }

    (0, _createClass3.default)(ErrorBag, [{
        key: 'add',
        value: function add(page, error) {
            if (!this.items[page]) {
                Vue.set(this.items, page, []);
            }
            Vue.set(this.items[page], this.items[page].length, error);
        }
    }, {
        key: 'remove',
        value: function remove(page, index) {
            var modelName = this.items[page].modelName;
            var rule = this.items[page].rule;
            Vue.delete(this.items[page], index);
            // 重新整理index
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.items[page][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var error = _step.value;

                    if (error.modelName === modelName && error.modelName.rule === rule && error.index > index) {
                        error.index--;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, {
        key: 'removeAll',
        value: function removeAll(page, modelName) {
            var rule = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

            var index = this.search(page, modelName, rule, key);
            while (index !== -1) {
                this.remove(page, index);
                index = this.search(page, modelName, rule, key);
            }
        }
    }, {
        key: 'search',
        value: function search(page, modelName) {
            var rule = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

            if (this.items[page]) {
                for (var i = 0; i < this.items[page].length; i++) {
                    if (rule && this.items[page][i].rule !== rule) {
                        continue;
                    }
                    if (key !== null && this.items[page][i].key !== key) {
                        continue;
                    }
                    if (this.items[page][i].modelName === modelName) {
                        return i;
                    }
                }
            }

            return -1;
        }
    }, {
        key: 'has',
        value: function has(page, modelName) {
            var rule = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

            var index = this.search(page, modelName, rule, key);
            if (index >= 0 && this.items[page][index].showError) {
                return true;
            }
            return false;
        }
    }, {
        key: 'showAllError',
        value: function showAllError(page) {
            for (var i = 0; i < this.items[page].length; i++) {
                //Vue.set(this.items[i], 'showError', true)
                this.items[page][i].showError = true;
            }
        }
    }]);
    return ErrorBag;
}();

var checkFuncs = {
    required: function required(value) {
        return ~[null, undefined, ''].indexOf(value);
    },
    mobile: function mobile(value) {
        return !/^1\d{10}$/.test(value);
    },
    tel: function tel(value) {
        return !/^[0-9-]{10,15}$/.test(value);
    },
    integer: function integer(value) {
        var number = Number(value);
        return !(number % 1 === 0 && number > 0 || value === '');
    },
    forbidden: function forbidden(value, forbiddenList) {
        if (!forbiddenList || !(forbiddenList.length > 0)) return false;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = forbiddenList[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var forbidden = _step2.value;

                if (value === forbidden) {
                    return true;
                }
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        return false;
    }
};

function _validate(page, value, modelName, rule, showError, errorBag) {
    var key = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
    var forbiddenList = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [];

    var rules = rule.split('|');
    for (var i = 0; i < rules.length; i++) {
        var index = errorBag.search(page, modelName, rules[i], key);

        var checkErr = false;
        if (rules[i] === 'forbidden') {
            if (forbiddenList.length <= 0) {
                return;
            }
            checkErr = checkFuncs[rules[i]](value, forbiddenList);
        } else {
            checkErr = checkFuncs[rules[i]] && checkFuncs[rules[i]](value);
        }
        if (checkErr) {
            if (index === -1) {
                errorBag.add(page, {
                    key: key,
                    modelName: modelName,
                    showError: showError,
                    rule: rules[i]
                });
            } else {
                errorBag.items[page][index].showError = showError;
            }
            break;
        } else {
            if (index >= 0) {
                errorBag.remove(page, index);
            }
        }
    }
}

var main = {
    ErrorBag: ErrorBag
};

var warn = function warn(message) {
    console.warn('[vee-validate] ' + message); // eslint-disable-line
};

var Vue = void 0;
main.install = function (_Vue, options) {
    if (Vue) {
        warn('already installed, Vue.use(VeeValidate) should only be called once.');
        return;
    }

    Vue = _Vue;

    var myErrors = new ErrorBag();

    Vue.mixin({
        beforeCreate: function beforeCreate() {

            if (!this.$options.computed) {
                this.$options.computed = {};
            }

            Vue.util.defineReactive(this, 'validateErrors', myErrors);

            this.$options.computed['validateErrors'] = function errorBagGetter() {
                return myErrors;
            };
        }
    });
    Vue.directive('va', {
        bind: function bind(el, binding, vnode) {
            if (binding.value) {
                var key = vnode.data.attrs && vnode.data.attrs['data-key'] || 0;
                var page = binding.rawName.replace('v-va.', '');
                var forbiddenList = vnode.data.attrs.forbiddenList || [];
                // bind的时候就将不符合的全加入bag，但是不显示报错
                // 如果是普通的input或者是西瓜ui的input
                if (el.tagName !== 'INPUT' && el.className.indexOf('el-input') !== -1) {
                    var inputEL = el;
                    if (el.className.indexOf('el-input') !== -1) {
                        inputEL = el.getElementsByTagName('input')[0];
                    }
                    inputEL.addEventListener('blur', function () {
                        _validate(page, inputEL.value, vnode.data.model.expression, binding.value, true, myErrors, key, forbiddenList);
                    });
                    inputEL.addEventListener('blur', function () {
                        _validate(page, inputEL.value, vnode.data.model.expression, binding.value, true, myErrors, key, forbiddenList);
                    });
                    _validate(page, inputEL.value, vnode.data.model.expression, binding.value, false, myErrors, key, forbiddenList);
                } else {
                    var value = vnode.data.domProps && vnode.data.domProps.value || vnode.data.model && vnode.data.model.value || '';
                    _validate(page, value, vnode.data.model.expression, binding.value, false, myErrors, key, forbiddenList);
                }
            }
        },
        update: function update(el, binding, vnode, oldVnode) {
            // update的时候如果还有错，就显示出来
            // 用model来判断值，比较方便
            // 当model有变化
            var forbiddenList = vnode.data.attrs.forbiddenList || [];
            var newValue = vnode.data.domProps && vnode.data.domProps.value || vnode.data.model && vnode.data.model.value || '';
            var oldValue = oldVnode.data.domProps && oldVnode.data.domProps.value || oldVnode.data.model && oldVnode.data.model.value || '';

            if (newValue !== oldValue) {
                var key = vnode.data.attrs && vnode.data.attrs['data-key'] || 0;
                var page = binding.rawName.replace('v-va.', '');
                _validate(page, newValue, vnode.data.model.expression, binding.value, true, myErrors, key, forbiddenList);
            }
        },
        unbind: function unbind(el, binding, vnode) {
            var key = vnode.data.attrs && vnode.data.attrs['data-key'] || 0;
            var page = binding.rawName.replace('v-va.', '');
            myErrors.removeAll(page, vnode.data.model.expression, null, key);
        }
    });
};

exports.default = main;

/***/ }),
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */
/*!*****************************************!*\
  !*** ./src/components/Player/player.ts ***!
  \*****************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AudioTagPlayer_1 = __webpack_require__(/*! ./AudioTagPlayer */ 1021);
var VoicePlayer = (function () {
    function VoicePlayer() {
        this.player = AudioTagPlayer_1.default.getInstance();
    }
    VoicePlayer.prototype.play = function (audioSource) {
        this.player.play(audioSource);
    };
    VoicePlayer.prototype.stop = function () {
        this.player.stop();
    };
    VoicePlayer.prototype.pause = function () {
        this.player.pause();
    };
    VoicePlayer.getInstance = function () {
        if (!VoicePlayer.instance) {
            VoicePlayer.instance = new VoicePlayer();
        }
        return VoicePlayer.instance;
    };
    VoicePlayer.install = function (Vue) {
        if (VoicePlayer.installed)
            return;
        Vue.prototype.$Player = VoicePlayer.getInstance();
        VoicePlayer.installed = true;
    };
    VoicePlayer.installed = false;
    return VoicePlayer;
}());
exports.default = VoicePlayer;


/***/ }),
/* 1021 */
/*!*************************************************!*\
  !*** ./src/components/Player/AudioTagPlayer.ts ***!
  \*************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AudioTagPlayer = (function () {
    function AudioTagPlayer() {
        this.el = document.createElement('audio');
        this.el.style.display = 'none';
        document.body.appendChild(this.el);
    }
    AudioTagPlayer.prototype.play = function (audioSource) {
        if (audioSource) {
            this.el.src = audioSource;
            this.el.currentTime = 0;
        }
        this.el.play();
    };
    AudioTagPlayer.prototype.stop = function () {
        this.el.currentTime = 0;
        this.el.pause();
    };
    AudioTagPlayer.prototype.pause = function () {
        this.el.pause();
    };
    AudioTagPlayer.getInstance = function () {
        if (!AudioTagPlayer.instance) {
            AudioTagPlayer.instance = new AudioTagPlayer();
        }
        return AudioTagPlayer.instance;
    };
    return AudioTagPlayer;
}());
exports.default = AudioTagPlayer;


/***/ }),
/* 1022 */
/*!*************************************************!*\
  !*** ./src/components/ConfirmOrders/orders.vue ***!
  \*************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-60c9447c","scoped":false,"hasInlineConfig":false}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./orders.vue */ 1023)
}
var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !happypack/loader?id=js!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./orders.vue */ 1024),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-60c9447c","hasScoped":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./orders.vue */ 1025),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1023 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"importLoaders":true,"modules":false,"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-60c9447c","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ConfirmOrders/orders.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1024 */
/*!********************************************************************************************************************************************************!*\
  !*** ./node_modules/happypack/loader.js?id=js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ConfirmOrders/orders.vue ***!
  \********************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _env = __webpack_require__(/*! config/env.conf */ 2);

exports.default = {
  props: {
    hasMore: {
      required: true
    },
    orders: {
      required: true,
      type: Array
    }
  },
  data: function data() {
    return {
      orderDetailUrlPrefix: _env.otpHost + "#/jiujing/gtyOrder/detail-order?orderId="
    };
  }
}; //
//
//
//
//
//
//

/***/ }),
/* 1025 */
/*!************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60c9447c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfirmOrders/orders.vue ***!
  \************************************************************************************************************************************************************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orders-dialog"
  }, _vm._l((_vm.orders), function(orderId) {
    return _c('p', {
      key: orderId,
      staticClass: "dialog-order-item"
    }, [_c('a', {
      attrs: {
        "href": _vm.orderDetailUrlPrefix + orderId,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(orderId))])])
  }))
},staticRenderFns: []}

/***/ }),
/* 1026 */
/*!*******************************************************!*\
  !*** ./src/components/TitleMessager/TitleMessager.ts ***!
  \*******************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Msg_Change_Interval = 100;
var TitleMessager = (function () {
    function TitleMessager() {
        this.msgs = [];
        this.timerId = null;
        this.originTitle = '';
        this.currIndex = 0;
        this.originTitle = document.title || '美团旅行境内度假商家中心';
        this.msgs.push(this.originTitle);
    }
    TitleMessager.prototype.show = function (msg) {
        var _this = this;
        if (!this.timerId) {
            this.timerId = window.setInterval(function () {
                var inx = _this.currIndex++ % _this.msgs.length;
                var newTitle = _this.msgs[inx];
                document.title = newTitle;
            }, Msg_Change_Interval);
        }
        this.msgs.push(msg);
    };
    TitleMessager.prototype.reset = function (msg) {
        if (this.timerId) {
            window.clearInterval(this.timerId);
            if (msg) {
                var inx = this.msgs.indexOf(msg);
                this.msgs.splice(inx, 1);
            }
            else {
                this.msgs = [this.originTitle];
            }
        }
        document.title = this.originTitle;
    };
    TitleMessager.getInstance = function () {
        if (!TitleMessager.instance) {
            TitleMessager.instance = new TitleMessager();
        }
        return TitleMessager.instance;
    };
    TitleMessager.install = function (Vue) {
        Vue.prototype.$TitleMessager = TitleMessager.getInstance();
    };
    return TitleMessager;
}());
exports.default = TitleMessager;


/***/ }),
/* 1027 */,
/* 1028 */
/*!*********************************************************************!*\
  !*** ./node_modules/@hfe/turbo-ui/dist/font/turboicons.cb539f2.eot ***!
  \*********************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/turboicons.cb539f2.cb539f2.eot";

/***/ }),
/* 1029 */
/*!*********************************************************************!*\
  !*** ./node_modules/@hfe/turbo-ui/dist/font/turboicons.a1590e4.ttf ***!
  \*********************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/turboicons.a1590e4.a1590e4.ttf";

/***/ }),
/* 1030 */
/*!**********************************************************************!*\
  !*** ./node_modules/@hfe/turbo-ui/dist/font/turboicons.69f1aac.woff ***!
  \**********************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/turboicons.69f1aac.69f1aac.woff";

/***/ }),
/* 1031 */
/*!*********************************************************************!*\
  !*** ./node_modules/@hfe/turbo-ui/dist/font/turboicons.20f40cb.svg ***!
  \*********************************************************************/
/*! no static exports found */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/turboicons.20f40cb.20f40cb.svg";

/***/ })
],[266]);


// WEBPACK FOOTER //
// static/js/client.ff915f6c.js